/* tslint:disable */
/* eslint-disable */
/**
 * Client Tax System API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AccessRequestBusinessDto {
    'id'?: string;
    'businessName'?: string | null;
    'ein'?: string | null;
    'entityType'?: BusinessEntityType;
    'entityTypeDisplay'?: string | null;
}


export interface AccessRequestPageDefaultsDto {
    'pageSize'?: number | null;
    'sortBy'?: string | null;
    'sortOrder'?: string | null;
    'status'?: string | null;
    'officeId'?: string | null;
}

export enum AccessRequestStatus {
    Na = 'na',
    Pending = 'pending',
    Accepted = 'accepted',
    Rejected = 'rejected'
}



export enum AccessRequestType {
    Na = 'na',
    Individual = 'individual',
    Business = 'business',
    Both = 'both'
}


/**
 * Current preference settings for a specific action type.
 */
export interface ActionPreferenceDto {
    'actionType'?: NotificationActionType;
    'displayName'?: string | null;
    'description'?: string | null;
    'category'?: string | null;
    'channels'?: NotificationDeliveryChannel;
    'batchStrategy'?: NotificationBatchStrategy;
    /**
     * Whether this action is using the user\'s default settings.
     */
    'isUsingDefaults'?: boolean;
    'effectiveChannels'?: NotificationDeliveryChannel;
    'effectiveBatchStrategy'?: NotificationBatchStrategy;
    /**
     * Whether this action type supports batching.
     */
    'supportsBatching'?: boolean;
    'actionDefaultChannel'?: NotificationDeliveryChannel;
    'actionDefaultBatchStrategy'?: NotificationBatchStrategy;
}


export interface ActionPreferenceDtoApiResponse {
    'success'?: boolean;
    'data'?: ActionPreferenceDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Response containing all action preferences grouped by category.
 */
export interface ActionPreferencesResponseDto {
    'defaultChannels'?: NotificationDeliveryChannel;
    'defaultBatchStrategy'?: NotificationBatchStrategy;
    /**
     * All action preferences grouped by category.
     */
    'actionsByCategory'?: { [key: string]: Array<ActionPreferenceDto> | null; } | null;
}


export interface ActionPreferencesResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: ActionPreferencesResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Metadata about a notification action type for UI display.
 */
export interface ActionTypeDto {
    'actionType'?: NotificationActionType;
    'actionTypeValue'?: number;
    'displayName'?: string | null;
    'description'?: string | null;
    'category'?: string | null;
    'serviceLine'?: ServiceLine;
    /**
     * Whether this action type supports batching (false for system notifications like password reset).
     */
    'supportsBatching'?: boolean;
    'defaultChannel'?: NotificationDeliveryChannel;
    'defaultBatchStrategy'?: NotificationBatchStrategy;
}


export interface ActionTypeDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ActionTypeDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Request to add a signer to an existing e-signature submission. Field positions are auto-detected from the PDF - no manual placement required.
 */
export interface AddSignerRequestDto {
    /**
     * Full name of the new signer
     */
    'name': string;
    /**
     * Email address for sending the signature request
     */
    'email': string;
    /**
     * Phone number for SMS notifications (optional)
     */
    'phone'?: string | null;
    /**
     * Role of the signer. Must match a role in the document\'s signature fields. Common values: \"Spouse\", \"Joint Filer\", \"Co-Signer\"
     */
    'role': string;
}
/**
 * Response after adding a signer to an e-signature submission
 */
export interface AddSignerResponseDto {
    'success'?: boolean;
    /**
     * Human-readable message describing the result
     */
    'message'?: string | null;
    /**
     * Strategy used: \"voided_and_recreated\" (no one signed yet) or \"addon_from_signed\" (first signer completed)
     */
    'strategy'?: string | null;
    /**
     * New submission ID (DocuSeal submission ID)
     */
    'newSubmissionId'?: string | null;
    /**
     * Original submission ID that was modified or replaced
     */
    'originalSubmissionId'?: string | null;
    /**
     * Number of signature fields detected for the new signer\'s role
     */
    'fieldsDetected'?: number;
    /**
     * List of all signers on the new/updated submission
     */
    'signers'?: Array<AddSignerSignerDto> | null;
}
export interface AddSignerResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: AddSignerResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Signer information returned in AddSignerResponseDto
 */
export interface AddSignerSignerDto {
    'signerId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    'status'?: string | null;
}
/**
 * Complete admin dashboard response with summary stats, per-preparer breakdown, and per-office breakdown
 */
export interface AdminDashboardDto {
    'summary'?: AdminDashboardSummaryDto;
    /**
     * Per-preparer breakdown of binder activity
     */
    'preparerBreakdown'?: Array<PreparerActivityDto> | null;
    /**
     * Per-office breakdown of binder activity
     */
    'officeBreakdown'?: Array<OfficeActivityDto> | null;
    /**
     * Distribution of binders across workflow stages
     */
    'stageDistribution'?: Array<StageDistributionDto> | null;
    /**
     * Average number of days from binder creation to completion (for binders completed in the past month)
     */
    'averageDaysToCompletion'?: number | null;
    /**
     * Number of binders currently overdue (past due date and not yet completed)
     */
    'overdueBinders'?: number;
    /**
     * Total active (non-archived, non-completed) binders firm-wide
     */
    'totalActiveBinders'?: number;
    'workflowTiming'?: WorkflowTimingDto;
    /**
     * Per-preparer workflow timing breakdown
     */
    'preparerTimingBreakdown'?: Array<PreparerWorkflowTimingDto> | null;
    /**
     * Per-partner breakdown of binder activity
     */
    'partnerBreakdown'?: Array<PartnerActivityDto> | null;
    /**
     * Per-office workflow timing breakdown
     */
    'officeTimingBreakdown'?: Array<OfficeWorkflowTimingDto> | null;
    /**
     * Per-partner workflow timing breakdown
     */
    'partnerTimingBreakdown'?: Array<PartnerWorkflowTimingDto> | null;
}
export interface AdminDashboardDtoApiResponse {
    'success'?: boolean;
    'data'?: AdminDashboardDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface AdminDashboardPageDefaultsDto {
    'breakdownView'?: string | null;
}
/**
 * Firm-wide summary with time period breakdowns
 */
export interface AdminDashboardSummaryDto {
    'bindersCreated'?: TimePeriodCountsDto;
    'sentForPreparation'?: TimePeriodCountsDto;
    'completed'?: TimePeriodCountsDto;
    'bindersCreatedPriorYear'?: TimePeriodCountsDto;
    'sentForPreparationPriorYear'?: TimePeriodCountsDto;
    'completedPriorYear'?: TimePeriodCountsDto;
}

export enum AiProcessingStatus {
    NotRequired = 'notRequired',
    Pending = 'pending',
    InProgress = 'inProgress',
    Completed = 'completed',
    Failed = 'failed'
}



export enum AnchorPoint {
    TopLeft = 'topLeft',
    TopRight = 'topRight',
    BottomLeft = 'bottomLeft',
    BottomRight = 'bottomRight',
    Center = 'center',
    TopCenter = 'topCenter',
    BottomCenter = 'bottomCenter',
    LeftCenter = 'leftCenter',
    RightCenter = 'rightCenter'
}


export interface ApiError {
    'code'?: string | null;
    'message'?: string | null;
    'details'?: { [key: string]: any | null; } | null;
}
export interface ApiMeta {
    'requestId'?: string | null;
    'timestamp'?: string;
}
/**
 * Request DTO for archiving or unarchiving an binder. Client Binder Document Management.
 */
export interface ArchiveTaxBinderRequest {
    /**
     * Whether the binder should be archived. Archived binders prevent client uploads but allow viewing of firm-delivered documents.
     */
    'isArchived': boolean;
}
/**
 * DTO for assigning a document to a document request, moving it to a different request, or detaching it from its current request.
 */
export interface AssignDocumentToRequestDto {
    /**
     * The document request to assign the document to. Must belong to the same binder as the document. Set to null to detach the document from its current request (it remains attached to the binder).
     */
    'documentRequestId'?: string | null;
}
export interface AssignUserToClientDto {
    'userId'?: string;
    'clientId'?: string;
    'role'?: ClientUserRole;
    /**
     * When true, promotes this user to main contact for the client. When false, demotes this user and auto-promotes the next best candidate. Omit or pass null to leave the current main contact unchanged.
     */
    'isMainContact'?: boolean | null;
}


/**
 * Response DTO for the attach engagement letter endpoint
 */
export interface AttachEngagementLetterResponseDto {
    /**
     * The ID of the created document
     */
    'documentId'?: string;
    /**
     * The DocuSeal submission ID
     */
    'submissionId'?: string | null;
    /**
     * The URL for signing the engagement letter
     */
    'signingUrl'?: string | null;
    /**
     * The current status of the submission (e.g., \"pending\", \"awaiting\")
     */
    'status'?: string | null;
    /**
     * Whether a signature request notification was queued in the client notification system
     */
    'notificationQueued'?: boolean;
    /**
     * When the submission was created
     */
    'createdAt'?: string;
    /**
     * The ID of the replaced document (null if not replacing)
     */
    'replacedDocumentId'?: string | null;
    /**
     * The DocuSeal submission ID of the replaced submission (null if not replacing)
     */
    'replacedSubmissionId'?: string | null;
}
export interface AttachEngagementLetterResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: AttachEngagementLetterResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Audit binder activity for one preparer, office or partner
 */
export interface AuditActivityBreakdownDto {
    'id'?: string;
    'name'?: string | null;
    'bindersCreated'?: TimePeriodCountsDto;
    'releasedToClient'?: TimePeriodCountsDto;
    'completed'?: TimePeriodCountsDto;
}
/**
 * Admin dashboard for audit binders: firm-wide summary, per-preparer/office/partner breakdowns, stage distribution and workflow timing across all non-archived audit binders. Counts, breakdowns and timing include binders the deletion lifecycle has removed; stage distribution, overdue and active cover only binders that still exist.
 */
export interface AuditAdminDashboardDto {
    'summary'?: AuditAdminDashboardSummaryDto;
    'preparerBreakdown'?: Array<AuditActivityBreakdownDto> | null;
    'officeBreakdown'?: Array<AuditActivityBreakdownDto> | null;
    'partnerBreakdown'?: Array<AuditActivityBreakdownDto> | null;
    /**
     * Distribution of audit binders across workflow stages
     */
    'stageDistribution'?: Array<AuditStageDistributionDto> | null;
    /**
     * Average number of days from binder creation to completion (for binders completed in the past month)
     */
    'averageDaysToCompletion'?: number | null;
    /**
     * Number of audit binders past their due date and not yet complete
     */
    'overdueBinders'?: number;
    /**
     * Total non-archived audit binders that are not complete
     */
    'totalActiveBinders'?: number;
    'workflowTiming'?: AuditWorkflowTimingDto;
    'preparerTimingBreakdown'?: Array<AuditTimingBreakdownDto> | null;
    'officeTimingBreakdown'?: Array<AuditTimingBreakdownDto> | null;
    'partnerTimingBreakdown'?: Array<AuditTimingBreakdownDto> | null;
}
export interface AuditAdminDashboardDtoApiResponse {
    'success'?: boolean;
    'data'?: AuditAdminDashboardDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Firm-wide audit binder counts by time period, with the same windows one year earlier
 */
export interface AuditAdminDashboardSummaryDto {
    'bindersCreated'?: TimePeriodCountsDto;
    'releasedToClient'?: TimePeriodCountsDto;
    'completed'?: TimePeriodCountsDto;
    'bindersCreatedPriorYear'?: TimePeriodCountsDto;
    'releasedToClientPriorYear'?: TimePeriodCountsDto;
    'completedPriorYear'?: TimePeriodCountsDto;
}

export enum AuditBinderActivityEvent {
    BinderCreated = 'binderCreated',
    StageChanged = 'stageChanged',
    ItemRequested = 'itemRequested',
    ItemApproved = 'itemApproved',
    ItemClientResponded = 'itemClientResponded',
    DocumentUploaded = 'documentUploaded',
    DocumentApproved = 'documentApproved',
    DocumentRejected = 'documentRejected',
    CommentPosted = 'commentPosted',
    FinalDocumentUploaded = 'finalDocumentUploaded',
    BinderCompleted = 'binderCompleted',
    DocumentDeleted = 'documentDeleted',
    ItemEdited = 'itemEdited',
    DocumentsExported = 'documentsExported',
    SignatureRequested = 'signatureRequested',
    SignatureCompleted = 'signatureCompleted',
    ItemUnapproved = 'itemUnapproved',
    DocumentDownloaded = 'documentDownloaded',
    BinderSoftDeleted = 'binderSoftDeleted',
    ItemReleased = 'itemReleased',
    SignatureRequestCancelled = 'signatureRequestCancelled',
    DocumentMoved = 'documentMoved',
    RequestsImported = 'requestsImported',
    FinalDeliverableRemoved = 'finalDeliverableRemoved',
    ReminderSent = 'reminderSent'
}



export enum AuditBinderDeletionReason {
    Manual = 'manual',
    Replaced = 'replaced'
}


/**
 * A client user\'s most recent download of a final deliverable.
 */
export interface AuditBinderDeliverableDownloadDto {
    'userId'?: string;
    'name'?: string | null;
    'lastDownloadedAt'?: string;
}
export interface AuditBinderDetailActivityDto {
    'id'?: string;
    'type'?: AuditBinderActivityEvent;
    'actorName'?: string | null;
    'actorRole'?: string | null;
    'createdAt'?: string;
    /**
     * Raw payload JSON as stored on the row; clients render via known keys.
     */
    'payloadJson'?: string | null;
}


export interface AuditBinderDetailCommentDto {
    'id'?: string;
    'content'?: string | null;
    'authorName'?: string | null;
    'authorRole'?: string | null;
    'isInternal'?: boolean;
    'createdAt'?: string;
    /**
     * Derived, NOT a passthrough of the Comment.IsRead column: a comment from the viewer\'s own side (client vs firm) always reads as true, so the same row can report true to staff and false to the client. Matches CommentService.ShouldBeConsideredRead so the flag and the unread counts agree.
     */
    'isReadByViewer'?: boolean;
}
export interface AuditBinderDetailDocumentDto {
    'id'?: string;
    'name'?: string | null;
    'fileSize'?: number;
    'uploadedAt'?: string;
    'uploadedByName'?: string | null;
    'uploadedByRole'?: string | null;
    'isNonClientUpload'?: boolean;
    'isFirmUpload'?: boolean;
    'status'?: string | null;
    'rejectionReason'?: string | null;
    'reviewedAt'?: string | null;
    'reviewedByName'?: string | null;
    'exportedAt'?: string | null;
    'exportedByName'?: string | null;
    'virusScanStatus'?: VirusScanStatus;
}


/**
 * One-shot fetch shape used by the audit binder detail screen. Replaces the N+1 of binder + items + per-item docs + comments + activity. Returned by GET /api/audit-binders/{id}/detail.
 */
export interface AuditBinderDetailDto {
    'binder'?: AuditBinderDetailHeaderDto;
    'items'?: Array<AuditBinderDetailItemDto> | null;
    'otherDocuments'?: Array<AuditBinderDetailDocumentDto> | null;
    /**
     * The binder\'s final deliverables in display order; the first is the primary report. They appear in no other document list. Empty for a client until the binder is Complete.
     */
    'finalDeliverables'?: Array<AuditBinderFinalDeliverableDto> | null;
    /**
     * When a final deliverable was most recently added, or null; withheld from a client until Complete.
     */
    'finalDocumentUploadedAt'?: string | null;
    'binderActivity'?: Array<AuditBinderDetailActivityDto> | null;
    'binderComments'?: Array<AuditBinderDetailCommentDto> | null;
    /**
     * Unread binder-level comments for the calling viewer. Per-request counts live on Op.ClientTaxSystem.Api.DTOs.AuditBinders.AuditBinderDetailItemDto.UnreadCommentCount; the two sum to the binder\'s total unread.
     */
    'unreadBinderCommentCount'?: number;
    /**
     * Binder-level documents sent for e-signature, with per-signer status. Each is a Document with RequiresSignature=true and no request-item link; it does NOT also appear in Op.ClientTaxSystem.Api.DTOs.AuditBinders.AuditBinderDetailDto.OtherDocuments.
     */
    'signatureDocuments'?: Array<AuditBinderSignatureDocumentDto> | null;
    'summary'?: AuditBinderDetailSummaryDto;
}
export interface AuditBinderDetailDtoApiResponse {
    'success'?: boolean;
    'data'?: AuditBinderDetailDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface AuditBinderDetailHeaderDto {
    'id'?: string;
    'name'?: string | null;
    'clientId'?: string;
    'clientName'?: string | null;
    'preparerId'?: string;
    'preparerName'?: string | null;
    'periodStart'?: string;
    'periodEnd'?: string;
    'dueDate'?: string | null;
    'stage'?: AuditBinderStage;
    'description'?: string | null;
    'createdAt'?: string;
    'completedAt'?: string | null;
    /**
     * When the client loses access to this Complete binder. Null unless the binder is Complete.
     */
    'clientAccessEndsAt'?: string | null;
}


export interface AuditBinderDetailItemDto {
    'id'?: string;
    'title'?: string | null;
    'description'?: string | null;
    'priority'?: DocumentRequestPriority;
    'dueDate'?: string | null;
    'status'?: DocumentRequestStatus;
    'derivedStatus'?: AuditBinderItemDerivedStatus;
    'clientResponse'?: ClientResponseType;
    'clientResponseNote'?: string | null;
    'requestType'?: AuditDocumentRequestType;
    'requestTypeDisplayName'?: string | null;
    'isConfidential'?: boolean;
    'confidentialClientUserId'?: string | null;
    'confidentialClientUserName'?: string | null;
    /**
     * True when this request is held for approval before the client can see it.
     */
    'requiresApproval'?: boolean;
    /**
     * When the request was released to the client, or null while still held (or never held).
     */
    'releasedToClientAt'?: string | null;
    /**
     * True when staff manually flagged this request for the client. Drives a Op.ClientTaxSystem.Api.DTOs.AuditBinders.AuditBinderItemDerivedStatus.NeedsAttention derived status that no document rejection produced, so the client-facing copy must explain it from Op.ClientTaxSystem.Api.DTOs.AuditBinders.AuditBinderDetailItemDto.NeedsClientAttentionNote rather than from a rejected document.
     */
    'needsClientAttention'?: boolean;
    'needsClientAttentionAt'?: string | null;
    'needsClientAttentionByName'?: string | null;
    'needsClientAttentionNote'?: string | null;
    /**
     * Staff only: true when the binder is released and the request is waiting on the client, so the \"Send reminder\" action applies. The cooldown is reported separately and the send re-checks everything.
     */
    'canRemindClient'?: boolean;
    /**
     * Staff only: how many reminders have been sent about this request.
     */
    'reminderCount'?: number;
    'lastReminderSentAt'?: string | null;
    'lastReminderSentByName'?: string | null;
    /**
     * Staff only: when the next reminder may be sent, or null when none has been sent.
     */
    'nextReminderAvailableAt'?: string | null;
    /**
     * Client only: when the latest reminder sent to the calling client user was sent, while the request is still waiting on the client and nobody on the client side has acted since. Null for staff and for anyone not reminded.
     */
    'clientReminderAt'?: string | null;
    /**
     * Client only: the preparer\'s message in that reminder, or null when there was none.
     */
    'clientReminderMessage'?: string | null;
    'rejectionReason'?: string | null;
    'requestedByName'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'documents'?: Array<AuditBinderDetailDocumentDto> | null;
    'comments'?: Array<AuditBinderDetailCommentDto> | null;
    'activity'?: Array<AuditBinderDetailActivityDto> | null;
    'commentCount'?: number;
    'unreadCommentCount'?: number;
}


export interface AuditBinderDetailSummaryDto {
    'totalItems'?: number;
    'approvedItems'?: number;
    'pendingReviewItems'?: number;
    'awaitingClientItems'?: number;
    'needsAttentionItems'?: number;
    'naItems'?: number;
    /**
     * Requests held for approval that have not been released to the client yet. Staff-only concept.
     */
    'pendingReleaseItems'?: number;
}
export interface AuditBinderDto {
    'id'?: string;
    'name'?: string | null;
    'clientId'?: string;
    'preparerId'?: string;
    'preparerName'?: string | null;
    'periodStart'?: string;
    'periodEnd'?: string;
    'dueDate'?: string | null;
    'description'?: string | null;
    'stage'?: AuditBinderStage;
    'isArchived'?: boolean;
    'createdAt'?: string;
    'updatedAt'?: string;
    'preReleaseReviewAt'?: string | null;
    'preReleaseReviewById'?: string | null;
    'openAt'?: string | null;
    'openById'?: string | null;
    'inReviewStartedAt'?: string | null;
    'inReviewById'?: string | null;
    'inReviewCompletedAt'?: string | null;
    'completedAt'?: string | null;
    'completedById'?: string | null;
}


export interface AuditBinderDtoApiResponse {
    'success'?: boolean;
    'data'?: AuditBinderDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * One final deliverable on the binder detail screen, in display order.
 */
export interface AuditBinderFinalDeliverableDto {
    'document'?: AuditBinderDetailDocumentDto;
    /**
     * When the document became a final deliverable (UTC); the client\'s \"posted\" date.
     */
    'addedAt'?: string;
    /**
     * Each client user who downloaded this deliverable, with their most recent download. Staff only: null for a client caller. Downloads before multiple deliverables shipped were recorded for the first client download of a document only.
     */
    'clientDownloads'?: Array<AuditBinderDeliverableDownloadDto> | null;
}
/**
 * The binder\'s final deliverable document ids in display order, after a change.
 */
export interface AuditBinderFinalDeliverablesResultDto {
    'documentIds'?: Array<string> | null;
}
export interface AuditBinderFinalDeliverablesResultDtoApiResponse {
    'success'?: boolean;
    'data'?: AuditBinderFinalDeliverablesResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface AuditBinderImportClientUserDto {
    'userId'?: string;
    'name'?: string | null;
}
export interface AuditBinderImportSourceDto {
    'id'?: string;
    'name'?: string | null;
    'periodStart'?: string;
    'periodEnd'?: string;
    'stage'?: AuditBinderStage;
    'requestCount'?: number;
}


export interface AuditBinderImportSourceRequestDto {
    'id'?: string;
    'title'?: string | null;
    'description'?: string | null;
    'requestType'?: AuditDocumentRequestType;
    'requestTypeDisplayName'?: string | null;
    'priority'?: DocumentRequestPriority;
    'sortOrder'?: number;
    'isConfidential'?: boolean;
    'confidentialClientUserId'?: string | null;
    'confidentialClientUserName'?: string | null;
    /**
     * True when the request is confidential and its visible client user no longer has access to the client (or it never had one), so staff must pick a current user before it can be imported.
     */
    'needsVisibleUser'?: boolean;
    'finalStatus'?: AuditBinderItemDerivedStatus;
    /**
     * True when the target binder already has a request with the same title.
     */
    'alreadyInBinder'?: boolean;
    /**
     * Selected unless it was N/A in the source binder or is already in the target binder.
     */
    'selectedByDefault'?: boolean;
}


/**
 * Every request in a source binder, as the request picker lists it.
 */
export interface AuditBinderImportSourceRequestsDto {
    'source'?: AuditBinderImportSourceDto;
    'requests'?: Array<AuditBinderImportSourceRequestDto> | null;
    /**
     * The client\'s current users, who can be made the visible user of a confidential request.
     */
    'clientUsers'?: Array<AuditBinderImportClientUserDto> | null;
}
export interface AuditBinderImportSourceRequestsDtoApiResponse {
    'success'?: boolean;
    'data'?: AuditBinderImportSourceRequestsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * The binders whose requests can be copied into this one: the client\'s active (Open or In Review) binder and its Complete binder, whichever exist. Drafts and deleted binders are never sources.
 */
export interface AuditBinderImportSourcesDto {
    /**
     * Most recent first: the active binder when there is one, then the Complete binder.
     */
    'sources'?: Array<AuditBinderImportSourceDto> | null;
}
export interface AuditBinderImportSourcesDtoApiResponse {
    'success'?: boolean;
    'data'?: AuditBinderImportSourcesDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Derived UI status that rolls up DocumentRequestStatus + per-document review state into the five visible states the detail screen renders.
 */

export enum AuditBinderItemDerivedStatus {
    Awaiting = 'awaiting',
    PendingReview = 'pendingReview',
    NeedsAttention = 'needsAttention',
    Approved = 'approved',
    Na = 'na',
    PendingRelease = 'pendingRelease'
}


export interface AuditBinderLimitBinderDto {
    'id'?: string;
    'name'?: string | null;
    'periodStart'?: string;
    'periodEnd'?: string;
    'stage'?: AuditBinderStage;
}


/**
 * The client\'s other audit binders that the one-active / one-Completed limits weigh against this binder. Drives the disabled Release and Reopen actions and the Complete dialog\'s replacement warning.
 */
export interface AuditBinderLimitsDto {
    'otherActiveBinder'?: AuditBinderLimitBinderDto;
    /**
     * The client\'s other Complete binders, which completing this binder deletes. Normally zero or one; clients over the limit from before it existed can have more, and every one is listed and confirmed.
     */
    'previousCompletedBinders'?: Array<AuditBinderReplacementPreviewDto> | null;
}
export interface AuditBinderLimitsDtoApiResponse {
    'success'?: boolean;
    'data'?: AuditBinderLimitsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * What completing the current binder will remove.
 */
export interface AuditBinderReplacementPreviewDto {
    'id'?: string;
    'name'?: string | null;
    'periodStart'?: string;
    'periodEnd'?: string;
    'stage'?: AuditBinderStage;
    'requestCount'?: number;
    'documentCount'?: number;
    'finalDeliverableNames'?: Array<string> | null;
    /**
     * Every document in the binder, so staff can download it as a ZIP before confirming.
     */
    'documentIds'?: Array<string> | null;
}


/**
 * A document in this binder that has an e-signature request.
 */
export interface AuditBinderSignatureDocumentDto {
    'documentId'?: string;
    'name'?: string | null;
    'fileSize'?: number;
    'uploadedAt'?: string;
    'uploadedByName'?: string | null;
    'docuSealSubmissionId'?: number;
    /**
     * DocuSeal submission status: pending | completed | declined | expired …
     */
    'submissionStatus'?: string | null;
    'completedAt'?: string | null;
    /**
     * DocuSeal builder template id the fields were placed on, when known. Lets the \"edit fields\" action re-open the builder preloaded with the existing placements. Null for submissions created before this was captured.
     */
    'fieldTemplateId'?: string | null;
    /**
     * Server-authoritative hint: true when the fields may still be edited (request open, no signer has signed). A UI convenience only — the edit endpoint re-checks this at request time, so a stale value can never permit an edit.
     */
    'canEditFields'?: boolean;
    /**
     * When the signed PDF was downloaded from DocuSeal and stored over the document\'s file, or null while signing is in progress (or the post-completion download job hasn\'t run yet). While null, downloading the document still returns the unsigned original — gate any \"download signed copy\" action on this.
     */
    'signedPdfStoredAt'?: string | null;
    'signers'?: Array<AuditBinderSignerStatusDto> | null;
}
/**
 * Per-signer status for an audit-binder signature document.
 */
export interface AuditBinderSignerStatusDto {
    /**
     * App user id of the signer (parsed from the DocuSeal submitter ExternalId), if known.
     */
    'clientUserId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    /**
     * pending | opened | completed | declined
     */
    'status'?: string | null;
    'signingOrder'?: number;
    'completedAt'?: string | null;
    /**
     * DocuSeal submitter id — the signer identifier the reminder endpoint targets.
     */
    'signerId'?: number;
    /**
     * When the initial signature request was sent to this signer.
     */
    'sentAt'?: string | null;
    /**
     * When the most recent reminder was sent to this signer, or null if none.
     */
    'lastReminderSentAt'?: string | null;
    /**
     * How many reminders have been sent to this signer.
     */
    'reminderCount'?: number;
}

export enum AuditBinderStage {
    New = 'new',
    PreReleaseReview = 'preReleaseReview',
    Open = 'open',
    InReview = 'inReview',
    Complete = 'complete'
}


/**
 * Row shape for the preparer audit dashboard. Trimmed to exactly the fields the dashboard table renders so we don\'t pay for projection columns the table doesn\'t consume.
 */
export interface AuditDashboardItemDto {
    'id'?: string;
    'name'?: string | null;
    'stage'?: AuditBinderStage;
    'dueDate'?: string | null;
    'daysOverdue'?: number;
    'periodStart'?: string;
    'periodEnd'?: string;
    'preparerId'?: string;
    'preparerName'?: string | null;
    /**
     * When the binder row was created. Used as a sort key on the             client portal\'s \"My Binders\" page.
     */
    'createdAt'?: string;
    'clientId'?: string;
    'clientName'?: string | null;
    'clientNumber'?: string | null;
    'clientEmail'?: string | null;
    'officeId'?: string | null;
    'officeName'?: string | null;
    'documentsTotal'?: number;
    'documentsApproved'?: number;
    'documentCompletionPercentage'?: number;
    'requestsTotal'?: number;
    'requestsCompleted'?: number;
    'completionPercentage'?: number;
    /**
     * Latest !:AuditBinderActivity.CreatedAt for this binder, or `null` when no activity rows exist yet.
     */
    'lastActivityAt'?: string | null;
    /**
     * True when the current user watches this binder\'s client.
     */
    'isWatched'?: boolean;
    /**
     * When the binder was moved to Complete (UTC). Null while not complete.
     */
    'completedAt'?: string | null;
    /**
     * When the client loses access to this Complete binder (UTC). Null while not complete.
     */
    'clientAccessEndsAt'?: string | null;
    /**
     * Id of the primary (first) final deliverable on a Complete binder, or null when there is none. Lets the client portal\'s \"My Binders\" card offer a direct download without opening the binder.
     */
    'finalDocumentId'?: string | null;
    /**
     * Display name of the primary final deliverable; null when Op.ClientTaxSystem.Api.DTOs.AuditDashboard.AuditDashboardItemDto.FinalDocumentId is null.
     */
    'finalDocumentName'?: string | null;
    /**
     * How many final deliverables a Complete binder has; 0 before Complete.
     */
    'finalDeliverableCount'?: number;
}


export interface AuditDashboardItemDtoPaginatedResponse {
    'items'?: Array<AuditDashboardItemDto> | null;
    'pagination'?: PaginationInfo;
}
export interface AuditDashboardItemDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: AuditDashboardItemDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum AuditDocumentRequestType {
    Cash = 'cash',
    Expenses = 'expenses',
    Payroll = 'payroll',
    Revenue = 'revenue',
    AccountsReceivable = 'accountsReceivable',
    AccountsPayable = 'accountsPayable',
    Inventory = 'inventory',
    FixedAssets = 'fixedAssets',
    DebtAndFinancing = 'debtAndFinancing',
    Equity = 'equity',
    Tax = 'tax',
    General = 'general',
    Grants = 'grants',
    Investments = 'investments',
    SingleAudit = 'singleAudit',
    Other = 'other'
}


/**
 * Count of audit binders in a specific workflow stage
 */
export interface AuditStageDistributionDto {
    'stage'?: AuditBinderStage;
    'stageName'?: string | null;
    'count'?: number;
}


/**
 * Audit workflow timing for one preparer, office or partner
 */
export interface AuditTimingBreakdownDto {
    'id'?: string;
    'name'?: string | null;
    'bindersCompleted'?: number;
    'timing'?: AuditWorkflowTimingDto;
}
/**
 * Average days for key audit workflow transitions (null when no qualifying binders exist)
 */
export interface AuditWorkflowTimingDto {
    /**
     * Avg days from binder creation to release to the client
     */
    'avgDaysCreatedToReleased'?: number | null;
    /**
     * Avg days from release to the client to In Review
     */
    'avgDaysReleasedToInReview'?: number | null;
    /**
     * Avg days from In Review to Complete
     */
    'avgDaysInReviewToCompleted'?: number | null;
    /**
     * Avg days from binder creation to Complete
     */
    'avgDaysCreatedToCompleted'?: number | null;
}

export enum BankAccountType {
    Checking = 'checking',
    Savings = 'savings'
}


/**
 * Request to extract structured data from multiple documents in batch.
 */
export interface BatchExtractionRequest {
    /**
     * Binder ID to extract documents from.
     */
    'binderId': string;
    /**
     * Optional list of specific document IDs to extract. If null or empty, all documents in the binder will be processed.
     */
    'documentIds'?: Array<string> | null;
}
/**
 * Response from a batch data extraction operation. Contains summary statistics and per-document results.
 */
export interface BatchExtractionResponse {
    /**
     * Total number of documents attempted.
     */
    'totalDocuments'?: number;
    /**
     * Number of successful extractions.
     */
    'successfulExtractions'?: number;
    /**
     * Number of failed extractions.
     */
    'failedExtractions'?: number;
    /**
     * Number of documents skipped (unsupported form types).
     */
    'skippedDocuments'?: number;
    /**
     * Per-document extraction results.
     */
    'results'?: Array<ExtractionResult> | null;
    /**
     * Total duration of the batch operation.
     */
    'duration'?: string;
}
export interface BatchExtractionResponseApiResponse {
    'success'?: boolean;
    'data'?: BatchExtractionResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Information about a single document created from batch processing.
 */
export interface BatchProcessedDocumentDto {
    /**
     * Document ID in the system.
     */
    'documentId'?: string;
    /**
     * Page numbers from the original PDF that were included in this document.
     */
    'pageNumbers'?: Array<number> | null;
    /**
     * Detected form type (e.g., \"W-2\", \"8879\", \"1040\"). Null if form could not be detected or detection was disabled.
     */
    'detectedFormType'?: string | null;
    /**
     * AI confidence score for the detected form type (0.0 to 1.0). Null if detection was not performed.
     */
    'confidence'?: number | null;
    /**
     * Whether this document was auto-assigned to a required document slot.
     */
    'assignedToRequest'?: boolean;
    /**
     * Required document ID if auto-assigned.
     */
    'requiredDocumentId'?: string | null;
    /**
     * Whether structured data was extracted from this document.
     */
    'dataExtracted'?: boolean;
}
/**
 * Immediate response returned when a batch upload job is queued.
 */
export interface BatchUploadJobResponse {
    /**
     * Unique identifier for tracking this batch upload job.
     */
    'jobId'?: string;
    /**
     * Binder ID that documents are being uploaded to.
     */
    'binderId'?: string;
    /**
     * Current job status (typically \"queued\" on initial response).
     */
    'status'?: string | null;
    /**
     * Estimated duration for processing (based on file size and page count).
     */
    'estimatedDuration'?: string;
    /**
     * Original filename of the uploaded PDF.
     */
    'fileName'?: string | null;
    /**
     * File size in bytes.
     */
    'fileSize'?: number;
    /**
     * When the job was queued.
     */
    'queuedAt'?: string;
    /**
     * Whether auto-split was enabled for this upload.
     */
    'autoSplitEnabled'?: boolean;
    /**
     * Whether auto-split was successfully applied.
     */
    'autoSplitApplied'?: boolean;
    /**
     * Confidence score of the auto-split analysis (0.0-1.0). Only populated if AutoSplitEnabled is true.
     */
    'autoSplitConfidence'?: number | null;
    /**
     * Number of document groups detected by auto-split. Only populated if AutoSplitApplied is true.
     */
    'detectedGroups'?: number | null;
}
export interface BatchUploadJobResponseApiResponse {
    'success'?: boolean;
    'data'?: BatchUploadJobResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Real-time progress information for a batch upload job.
 */
export interface BatchUploadProgress {
    /**
     * Current page being processed.
     */
    'currentPage'?: number;
    /**
     * Total number of pages in the PDF.
     */
    'totalPages'?: number;
    /**
     * Current processing stage.
     */
    'stage'?: string | null;
    /**
     * Human-readable progress message.
     */
    'message'?: string | null;
    /**
     * Overall completion percentage (0-100).
     */
    'percentComplete'?: number;
}
/**
 * Final results of a completed batch upload job.
 */
export interface BatchUploadResult {
    /**
     * Job identifier.
     */
    'jobId'?: string;
    /**
     * Binder ID that documents were uploaded to.
     */
    'binderId'?: string;
    /**
     * Total number of pages processed.
     */
    'totalPages'?: number;
    /**
     * List of documents created from the batch upload.
     */
    'processedDocuments'?: Array<BatchProcessedDocumentDto> | null;
    'summary'?: BatchUploadSummary;
    /**
     * Total processing duration.
     */
    'duration'?: string;
}
export interface BatchUploadResultApiResponse {
    'success'?: boolean;
    'data'?: BatchUploadResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Current status of a batch upload job (for polling).
 */
export interface BatchUploadStatusResponse {
    /**
     * Job identifier.
     */
    'jobId'?: string;
    /**
     * Current job status: \"queued\", \"processing\", \"completed\", \"failed\".
     */
    'status'?: string | null;
    'progress'?: BatchUploadProgress;
    /**
     * When job processing started (null if not yet started).
     */
    'startedAt'?: string | null;
    /**
     * When job completed (null if not yet completed).
     */
    'completedAt'?: string | null;
    /**
     * Estimated completion time (null if cannot be calculated).
     */
    'estimatedCompletion'?: string | null;
    /**
     * Error message if job failed.
     */
    'errorMessage'?: string | null;
}
export interface BatchUploadStatusResponseApiResponse {
    'success'?: boolean;
    'data'?: BatchUploadStatusResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Summary statistics for a batch upload job.
 */
export interface BatchUploadSummary {
    /**
     * Number of documents successfully created.
     */
    'documentsCreated'?: number;
    /**
     * Number of documents auto-assigned to required slots.
     */
    'documentsAutoAssigned'?: number;
    /**
     * Number of forms successfully detected.
     */
    'formsDetected'?: number;
    /**
     * Number of pages where form detection failed or had low confidence.
     */
    'detectionFailures'?: number;
    /**
     * Number of documents with extracted data.
     */
    'dataExtractionCount'?: number;
    /**
     * List of warnings or issues encountered during processing.
     */
    'warnings'?: Array<string> | null;
}
/**
 * Per-action override state for a binder.
 */
export interface BinderActionPreferenceDto {
    'actionType'?: NotificationActionType;
    'actionTypeValue'?: number;
    'displayName'?: string | null;
    'description'?: string | null;
    'category'?: string | null;
    'overrideChannel'?: NotificationDeliveryChannel;
    /**
     * Whether this action is using the user\'s global preference (no binder override set).
     */
    'isUsingDefault'?: boolean;
    'globalEffectiveChannel'?: NotificationDeliveryChannel;
    'effectiveChannel'?: NotificationDeliveryChannel;
}



export enum BinderActivityType {
    None = 'none',
    ClientComment = 'clientComment',
    ClientDocumentUpload = 'clientDocumentUpload',
    ClientSubmitted = 'clientSubmitted',
    PreparerInReview = 'preparerInReview',
    PreparerCompleted = 'preparerCompleted'
}


/**
 * The client a binder belongs to, returned only to a signed-in client user who is linked to that client.
 */
export interface BinderClientDto {
    'clientId'?: string;
    'clientName'?: string | null;
}
export interface BinderClientDtoApiResponse {
    'success'?: boolean;
    'data'?: BinderClientDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Estimated tax payments for a binder\'s tax year, resolved from the prior-year binder\'s return bundle.
 */
export interface BinderEstimatedPaymentsDto {
    /**
     * The binder the estimates were requested for
     */
    'binderId'?: string;
    /**
     * The payment year the vouchers apply to (== the binder\'s tax year)
     */
    'taxYear'?: number;
    /**
     * The prior-year binder the vouchers came from; null when none exists
     */
    'sourceBinderId'?: string | null;
    /**
     * Tax year of the source binder (TaxYear - 1)
     */
    'sourceTaxYear'?: number | null;
    /**
     * The return bundle the vouchers belong to
     */
    'sourceReturnBundleId'?: string | null;
    /**
     * Vouchers grouped by jurisdiction, in jurisdiction sort order
     */
    'jurisdictions'?: Array<EstimatedPaymentJurisdictionDto> | null;
}
export interface BinderEstimatedPaymentsDtoApiResponse {
    'success'?: boolean;
    'data'?: BinderEstimatedPaymentsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Polymorphic list-item DTO returned by GET /api/binders. Discriminated by Op.ClientTaxSystem.Api.DTOs.Binders.BinderListItemDto.BinderType. Tax-only fields are populated for Tax binders; audit-only fields are populated for Audit binders; the other side is null.
 */
export interface BinderListItemDto {
    'id'?: string;
    'name'?: string | null;
    'clientId'?: string;
    'preparerId'?: string;
    'preparerName'?: string | null;
    'binderType'?: BinderType;
    'dueDate'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'isArchived'?: boolean;
    'taxYear'?: number | null;
    'taxStage'?: BinderStage;
    'taxBinderType'?: TaxBinderType;
    'auditStage'?: AuditBinderStage;
    'periodStart'?: string | null;
    'periodEnd'?: string | null;
    /**
     * When the client loses access to a Complete audit binder. Null unless the binder is Complete.
     */
    'clientAccessEndsAt'?: string | null;
}


export interface BinderListItemDtoPaginatedResponse {
    'items'?: Array<BinderListItemDto> | null;
    'pagination'?: PaginationInfo;
}
export interface BinderListItemDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: BinderListItemDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * The current user\'s per-binder audit notification overrides for a single binder.
 */
export interface BinderNotificationPreferenceDto {
    'binderId'?: string;
    /**
     * One entry per preparer-facing audit notification action that can be overridden on this binder.
     */
    'actions'?: Array<BinderActionPreferenceDto> | null;
}
export interface BinderNotificationPreferenceDtoApiResponse {
    'success'?: boolean;
    'data'?: BinderNotificationPreferenceDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BinderPageDefaultsDto {
    'rowsPerPage'?: number | null;
    'sortBy'?: string | null;
    'sortOrder'?: string | null;
    'status'?: string | null;
    'taxYear'?: string | null;
    'stage'?: string | null;
    'hasLateDocuments'?: string | null;
}

export enum BinderStage {
    New = 'new',
    Open = 'open',
    ClientSubmitted = 'clientSubmitted',
    InReview = 'inReview',
    ReadyForScan = 'readyForScan',
    SentForPreparation = 'sentForPreparation',
    FinalClientReview = 'finalClientReview',
    ClientRequestsChanges = 'clientRequestsChanges',
    EfileReady = 'efileReady',
    Complete = 'complete'
}


/**
 * Filter for tax-binder status on clients.
 */

export enum BinderStatusFilter {
    Na = 'na',
    HasOpen = 'hasOpen',
    AllCompleted = 'allCompleted',
    NoBinders = 'noBinders'
}



export enum BinderType {
    Tax = 'tax',
    Audit = 'audit'
}


export interface BooleanApiResponse {
    'success'?: boolean;
    'data'?: boolean;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BulkApproveDocumentRequestsDto {
    'documentRequestIds': Array<string>;
    'reviewNotes'?: string | null;
}
export interface BulkApproveDocumentRequestsResultDto {
    /**
     * IDs of requests that were approved (request + all their documents).
     */
    'approvedRequestIds'?: Array<string> | null;
    /**
     * Requests that were skipped, with the reason why.
     */
    'skipped'?: Array<BulkApproveSkippedItemDto> | null;
    'approvedCount'?: number;
    'skippedCount'?: number;
}
export interface BulkApproveDocumentRequestsResultDtoApiResponse {
    'success'?: boolean;
    'data'?: BulkApproveDocumentRequestsResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BulkApproveSkippedItemDto {
    'documentRequestId'?: string;
    'reason'?: string | null;
}
/**
 * Summary result for the bulk CSV import operation.
 */
export interface BulkCsvImportResult {
    /**
     * Whether the overall operation was successful.
     */
    'success'?: boolean;
    /**
     * Total number of client IDs processed from the CSV.
     */
    'totalProcessed'?: number;
    /**
     * Number of clients found in ExternalClients table.
     */
    'found'?: number;
    /**
     * Number of clients not found in ExternalClients table.
     */
    'notFound'?: number;
    /**
     * Number of clients that were already imported.
     */
    'alreadyImported'?: number;
    /**
     * Number of clients successfully imported in this operation.
     */
    'newlyImported'?: number;
    /**
     * Number of clients that failed to import.
     */
    'failed'?: number;
    /**
     * Number of clients whose contact info (email/phone) was updated.
     */
    'contactInfoUpdated'?: number;
    /**
     * Whether this was a dry run (no actual imports).
     */
    'isDryRun'?: boolean;
    /**
     * Detailed results for each client ID.
     */
    'results'?: Array<BulkCsvImportResultItem> | null;
}
/**
 * Result for a single client in the bulk CSV import operation.
 */
export interface BulkCsvImportResultItem {
    /**
     * The ClientId provided in the CSV (maps to ExternalClient.ExternalId).
     */
    'clientId'?: string | null;
    /**
     * Whether this client was found in the ExternalClients table.
     */
    'found'?: boolean;
    /**
     * Whether the import was successful (only applicable when DryRun=false).
     */
    'imported'?: boolean;
    /**
     * The internal Client.Id if the import was successful or if already imported.
     */
    'importedClientId'?: string | null;
    /**
     * The client name from the ExternalClient record.
     */
    'clientName'?: string | null;
    /**
     * Whether this client was already imported before this operation.
     */
    'wasAlreadyImported'?: boolean;
    /**
     * Whether the client\'s name was updated from CSV data.
     */
    'nameUpdated'?: boolean;
    /**
     * Whether the client\'s TaxId (SSN/EIN) was updated from CSV data.
     */
    'taxIdUpdated'?: boolean;
    /**
     * Whether the client\'s email was updated from CSV data.
     */
    'emailUpdated'?: boolean;
    /**
     * Whether the client\'s phone number was updated from CSV data.
     */
    'phoneUpdated'?: boolean;
    /**
     * Whether the primary user\'s contact info was updated.
     */
    'primaryUserUpdated'?: boolean;
    /**
     * Whether a spouse record was created.
     */
    'spouseCreated'?: boolean;
    /**
     * Whether an existing spouse record was updated.
     */
    'spouseUpdated'?: boolean;
    /**
     * Whether a spouse user account was created.
     */
    'spouseUserCreated'?: boolean;
    /**
     * Status message describing the result.
     */
    'status'?: string | null;
    /**
     * Error message if any error occurred during lookup or import.
     */
    'error'?: string | null;
    /**
     * Validation errors for email/phone fields (non-fatal).
     */
    'validationErrors'?: Array<string> | null;
}
/**
 * Response when a bulk import job is started.
 */
export interface BulkImportJobStartedDto {
    /**
     * Unique identifier for the job.
     */
    'jobId'?: string | null;
    /**
     * Hangfire job ID for reference.
     */
    'hangfireJobId'?: string | null;
    /**
     * Human-readable message.
     */
    'message'?: string | null;
    /**
     * URL to check job status.
     */
    'statusUrl'?: string | null;
    /**
     * Total number of clients to be processed.
     */
    'totalClients'?: number;
}
export interface BulkImportJobStartedDtoApiResponse {
    'success'?: boolean;
    'data'?: BulkImportJobStartedDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * State of a bulk import job stored in Redis.
 */
export interface BulkImportJobState {
    /**
     * Unique identifier for the job.
     */
    'jobId'?: string | null;
    /**
     * Current status: \"pending\", \"processing\", \"completed\", \"failed\".
     */
    'status'?: string | null;
    /**
     * Total number of clients to process.
     */
    'totalClients'?: number;
    /**
     * Number of clients processed so far.
     */
    'processedCount'?: number;
    /**
     * Number of clients found in ExternalClients table.
     */
    'foundCount'?: number;
    /**
     * Number of clients successfully imported.
     */
    'importedCount'?: number;
    /**
     * Number of clients already imported before this operation.
     */
    'alreadyImportedCount'?: number;
    /**
     * Number of clients not found in ExternalClients table.
     */
    'notFoundCount'?: number;
    /**
     * Number of clients that failed to import.
     */
    'failedCount'?: number;
    /**
     * Whether this is a dry run.
     */
    'isDryRun'?: boolean;
    /**
     * Source system for the import (default: \"CCH\").
     */
    'sourceSystem'?: string | null;
    /**
     * Error message if the job failed.
     */
    'errorMessage'?: string | null;
    /**
     * When the job started.
     */
    'startedAt'?: string;
    /**
     * When the job completed (null if still running).
     */
    'completedAt'?: string | null;
    /**
     * Progress percentage (0-100).
     */
    'progressPercent'?: number;
    'result'?: BulkCsvImportResult;
}
export interface BulkImportJobStateApiResponse {
    'success'?: boolean;
    'data'?: BulkImportJobState;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BulkReviewDocumentsDto {
    'documents': Array<DocumentReviewItemDto>;
}

export enum BundleDocumentCategory {
    EFileAuthorization = 'eFileAuthorization',
    EngagementLetter = 'engagementLetter',
    DirectDepositReport = 'directDepositReport',
    FilingInstructions = 'filingInstructions',
    PaymentVoucher = 'paymentVoucher',
    TaxReturn = 'taxReturn',
    AdditionalDocument = 'additionalDocument',
    AuthorizationForm = 'authorizationForm',
    CoverLetter = 'coverLetter',
    SCorpElection = 'sCorpElection'
}


/**
 * DTO representing a logical document within a tax return bundle. Includes extracted PDFs (8879s, engagement letters, DD reports) and page-reference-only documents (filing instructions, vouchers, tax return pages).
 */
export interface BundleDocumentDto {
    'id'?: string;
    'taxReturnBundleId'?: string;
    'taxReturnBundleJurisdictionId'?: string | null;
    'documentId'?: string | null;
    'documentCategory'?: BundleDocumentCategory;
    'displayName'?: string | null;
    'sortOrder'?: number;
    'isExtracted'?: boolean;
    'sourceCopyType'?: ReturnCopyType;
    'sourceStartPage'?: number | null;
    'sourceEndPage'?: number | null;
    'formType'?: string | null;
    'requiresSignature'?: boolean;
    'signatureStatus'?: BundleDocumentSignatureStatus;
    'signedAt'?: string | null;
    'docuSealSubmissionId'?: string | null;
    'isPreparerAdded'?: boolean;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    /**
     * Whether Op.ClientTaxSystem.Api.DTOs.Returns.BundleDocumentDto.DocumentId still resolves to a downloadable document. False once the combiner has retired the extracted file (its signed pages live in the Signed Documents PDF), so the UI can stop offering a download that would 404.
     */
    'isDownloadable'?: boolean;
    'createdAt'?: string;
    'updatedAt'?: string;
}


export interface BundleDocumentDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleDocumentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface BundleDocumentDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<BundleDocumentDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Per-document breakdown within a unified signature response.
 */
export interface BundleDocumentSignatureInfoDto {
    /**
     * BundleDocument ID.
     */
    'bundleDocumentId'?: string;
    /**
     * Display name (e.g., \"Federal Form 8879\", \"Direct Deposit Report\").
     */
    'displayName'?: string | null;
    'documentCategory'?: BundleDocumentCategory;
    /**
     * Jurisdiction code (null for bundle-level documents).
     */
    'jurisdictionCode'?: string | null;
    /**
     * Number of signature fields detected for this document.
     */
    'signatureFieldCount'?: number;
}


/**
 * Response for the unified bundle document signature request. Contains a single DocuSeal submission with all signature-required documents.
 */
export interface BundleDocumentSignatureResponseDto {
    /**
     * The binder ID this signature request belongs to.
     */
    'binderId'?: string;
    /**
     * DocuSeal submission ID for the unified signature session.
     */
    'submissionId'?: string | null;
    /**
     * URL for the signing session (embedded signing). Client signs all documents in one session via this URL.
     */
    'signingUrl'?: string | null;
    /**
     * Total number of signature fields across all documents.
     */
    'totalSignatureFields'?: number;
    /**
     * Documents included in this signing session with field counts.
     */
    'documents'?: Array<BundleDocumentSignatureInfoDto> | null;
    /**
     * List of submitters (signers) for this submission.
     */
    'submitters'?: Array<BundleSignatureSubmitterDto> | null;
    /**
     * Timestamp when the signature request was sent (if SendImmediately was true).
     */
    'sentAt'?: string | null;
    /**
     * Signature-required documents that were EXCLUDED from the DocuSeal submission because no signature fields could be detected on them (no field config matched). They remain Pending and must be re-sent after a field config is added, or signed manually. Empty when every signature-required document was included.
     */
    'droppedDocuments'?: Array<BundleDroppedDocumentDto> | null;
    /**
     * Separate DocuSeal submission ID for the engagement letter (null if no EL in bundle).
     */
    'engagementLetterSubmissionId'?: string | null;
    /**
     * Separate signing URL for the engagement letter submission (null if no EL in bundle).
     */
    'engagementLetterSigningUrl'?: string | null;
}
export interface BundleDocumentSignatureResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleDocumentSignatureResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum BundleDocumentSignatureStatus {
    None = 'none',
    Pending = 'pending',
    AwaitingSignature = 'awaitingSignature',
    Signed = 'signed',
    ManualRequired = 'manualRequired',
    Skipped = 'skipped'
}


/**
 * Per-document signature status within a bundle signature. Includes all signature-required documents: 8879s, DD report, engagement letter, preparer-added.
 */
export interface BundleDocumentSignatureStatusDto {
    /**
     * BundleDocument ID.
     */
    'bundleDocumentId'?: string;
    /**
     * Display name (e.g., \"Federal Form 8879\", \"Direct Deposit Report\").
     */
    'displayName'?: string | null;
    'documentCategory'?: BundleDocumentCategory;
    /**
     * Jurisdiction code (null for bundle-level documents like DD report, engagement letter).
     */
    'jurisdictionCode'?: string | null;
    'signatureStatus'?: BundleDocumentSignatureStatus;
    /**
     * Timestamp when the document was signed (if signed).
     */
    'signedAt'?: string | null;
}


/**
 * A signature-required document that was excluded from the DocuSeal submission because no signature fields could be detected on it (no field configuration matched the form).
 */
export interface BundleDroppedDocumentDto {
    /**
     * BundleDocument ID.
     */
    'bundleDocumentId'?: string;
    /**
     * Display name (e.g., \"Georgia Form 8453P\").
     */
    'displayName'?: string | null;
    /**
     * Form type (e.g., \"8453P\"), when known.
     */
    'formType'?: string | null;
    /**
     * Jurisdiction code (null for bundle-level documents).
     */
    'jurisdictionCode'?: string | null;
}
/**
 * DTO for page references within the bundle PDF for a jurisdiction. Each reference points to a specific section (return pages, 8879, filing instructions, vouchers, etc.) within either the Client Copy or Government Copy PDF.
 */
export interface BundlePageReferenceDto {
    'id'?: string;
    'referenceType'?: BundleReferenceType;
    'copyType'?: ReturnCopyType;
    'startPage'?: number;
    'endPage'?: number;
    'bookmarkTitle'?: string | null;
    'formType'?: string | null;
    'sortOrder'?: number;
}


/**
 * Result of bundle processing job
 */
export interface BundleProcessingResultDto {
    'success'?: boolean;
    'binderId'?: string;
    'returnsCreated'?: number;
    'documentsExtracted'?: number;
    'filingInstructionsExtracted'?: number;
    'vouchersExtracted'?: number;
    'k1PartnersExtracted'?: number;
    'warnings'?: Array<string> | null;
    'errorMessage'?: string | null;
    'processedAt'?: string;
    'returns'?: Array<TaxReturnBundleJurisdictionSummaryDto> | null;
    'clientMismatchWarning'?: ClientMismatchWarningDto;
}
export interface BundleProcessingResultDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleProcessingResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for bundle processing status
 */
export interface BundleProcessingStatusDto {
    'binderId'?: string;
    'isProcessed'?: boolean;
    'processedAt'?: string | null;
    'status'?: ProcessingStatus;
    'errorMessage'?: string | null;
    'returnCount'?: number;
    'returns'?: Array<TaxReturnBundleJurisdictionSummaryDto> | null;
    /**
     * Document id of the current Client Copy bundle PDF (null until a bundle is stored). Authoritative pointer — replaces matching firm documents by file name in the UI.
     */
    'clientCopyDocumentId'?: string | null;
    /**
     * Document id of the current Government Copy bundle PDF (null until a bundle is stored).
     */
    'governmentCopyDocumentId'?: string | null;
}


export interface BundleProcessingStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleProcessingStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum BundleReferenceType {
    JurisdictionReturn = 'jurisdictionReturn',
    Form8879 = 'form8879',
    FilingInstructions = 'filingInstructions',
    PaymentVoucher = 'paymentVoucher',
    MainForm = 'mainForm',
    Schedule = 'schedule',
    StateForm = 'stateForm',
    DirectDepositReport = 'directDepositReport'
}


/**
 * DTO for BundleSignatureRequirement entity
 */
export interface BundleSignatureRequirementDto {
    'id'?: string;
    'taxReturnBundleJurisdictionId'?: string;
    'signerRole'?: SignerRole;
    'detectedName'?: string | null;
    'isDeceased'?: boolean;
    'deceasedDate'?: string | null;
    'userId'?: string | null;
    'userName'?: string | null;
    'userEmail'?: string | null;
    'signingOrder'?: number;
    'requiresManualSign'?: boolean;
    'manualSignReason'?: string | null;
    'status'?: SignatureRequirementStatus;
    'signedAt'?: string | null;
    'hasAssignedUser'?: boolean;
    'canESign'?: boolean;
}


export interface BundleSignatureRequirementDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleSignatureRequirementDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for bundle signature status.
 */
export interface BundleSignatureStatusDto {
    /**
     * The binder ID.
     */
    'binderId'?: string;
    /**
     * Whether a bundle signature request exists.
     */
    'hasBundleSignature'?: boolean;
    /**
     * DocuSeal submission ID (if exists).
     */
    'submissionId'?: string | null;
    /**
     * Overall status of the bundle signature.
     */
    'status'?: string | null;
    /**
     * Status breakdown by jurisdiction.
     */
    'jurisdictions'?: Array<JurisdictionSignatureStatusDto> | null;
    /**
     * Status breakdown by signer.
     */
    'signers'?: Array<BundleSignerStatusDto> | null;
    /**
     * Per-document signature status for all signature-required documents. Includes 8879s, DD report, engagement letter, and preparer-added docs.
     */
    'documents'?: Array<BundleDocumentSignatureStatusDto> | null;
    /**
     * Signing URL for the primary signer (constructed from signer slug). Relative URL like \"/s/{slug}\" — frontend prepends DocuSeal base URL.
     */
    'signingUrl'?: string | null;
    /**
     * Timestamp when signature request was sent.
     */
    'sentAt'?: string | null;
    /**
     * Timestamp when all signatures were completed.
     */
    'completedAt'?: string | null;
    /**
     * Optional custom message from the preparer shown to the client during signing review.
     */
    'preparerMessage'?: string | null;
    /**
     * Separate DocuSeal submission ID for the engagement letter (null if no EL submission).
     */
    'engagementLetterSubmissionId'?: string | null;
    /**
     * Separate signing URL for the engagement letter submission (null if no EL submission).
     */
    'engagementLetterSigningUrl'?: string | null;
}
export interface BundleSignatureStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: BundleSignatureStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Submitter information for bundle signature response.
 */
export interface BundleSignatureSubmitterDto {
    /**
     * Display name of the signer.
     */
    'name'?: string | null;
    /**
     * Email address for notifications.
     */
    'email'?: string | null;
    /**
     * Role (e.g., \"Taxpayer\", \"Spouse\").
     */
    'role'?: string | null;
    /**
     * Signer\'s unique slug for signing URL.
     */
    'slug'?: string | null;
}
/**
 * Signer-level status within bundle signature.
 */
export interface BundleSignerStatusDto {
    /**
     * Signer name.
     */
    'name'?: string | null;
    /**
     * Signer email.
     */
    'email'?: string | null;
    /**
     * Signer role (Taxpayer, Spouse).
     */
    'role'?: string | null;
    /**
     * Current status (pending, opened, completed, etc.).
     */
    'status'?: string | null;
    /**
     * Signer\'s unique slug for constructing signing URL (\"/s/{slug}\").
     */
    'slug'?: string | null;
    /**
     * Timestamp when signer completed (if completed).
     */
    'completedAt'?: string | null;
    /**
     * Timestamp when signer viewed the document.
     */
    'viewedAt'?: string | null;
}

export enum BusinessEntityType {
    Na = 'na',
    SoleProprietorship = 'soleProprietorship',
    Partnership = 'partnership',
    LimitedLiabilityCompany = 'limitedLiabilityCompany',
    SCorporation = 'sCorporation',
    CCorporation = 'cCorporation',
    TrustOrEstate = 'trustOrEstate',
    NonProfit = 'nonProfit',
    Other = 'other'
}


/**
 * Represents a document available in CCH Axcess Document Portal.
 */
export interface CchDocumentDto {
    'documentGuid'?: string | null;
    'fileName'?: string | null;
    'year'?: string | null;
    'className'?: string | null;
    'subClassName'?: string | null;
    'entityName'?: string | null;
    'status'?: string | null;
    'alreadyImported'?: boolean;
    /**
     * Display name of the DocumentType this document would be mapped to on import.
     */
    'mappedDocumentType'?: string | null;
}
export interface CchDocumentDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<CchDocumentDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Status of an individual document import attempt.
 */
export interface CchDocumentImportItemDto {
    'cchDocumentGuid'?: string | null;
    'fileName'?: string | null;
    /**
     * \"Imported\", \"Skipped\" (duplicate), or \"Failed\"
     */
    'status'?: string | null;
    'documentId'?: string;
    'error'?: string | null;
}
/**
 * Request to import selected CCH documents into a binder.
 */
export interface CchDocumentImportRequest {
    'documentGuids'?: Array<string> | null;
    /**
     * When true, documents mapped as TaxReturn will be processed through the return bundle processing workflow to extract individual returns, 8879s, vouchers, etc.
     */
    'processAsReturns'?: boolean;
}
/**
 * Result of a CCH document import operation.
 */
export interface CchDocumentImportResultDto {
    'importedCount'?: number;
    'skippedCount'?: number;
    'failedCount'?: number;
    'items'?: Array<CchDocumentImportItemDto> | null;
    'bundleProcessingResult'?: BundleProcessingResultDto;
    /**
     * Error message if return bundle processing failed. Import results are still valid.
     */
    'bundleProcessingError'?: string | null;
}
export interface CchDocumentImportResultDtoApiResponse {
    'success'?: boolean;
    'data'?: CchDocumentImportResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum CchExportArtifactKind {
    Package = 'package',
    SourceFile = 'sourceFile'
}


/**
 * A CCH document class the firm/client can file under.
 */
export interface CchExportClassDto {
    'code'?: number | null;
    'name'?: string | null;
}
/**
 * The destination a preparer picked. Codes and ids come straight back from Op.ClientTaxSystem.Api.DTOs.CchExportDestinationOptionsDto; the names travel with them so the upload metadata and our audit row record what the preparer actually saw.
 */
export interface CchExportDestinationDto {
    'classCode'?: number | null;
    'className'?: string | null;
    'subClassCode'?: number | null;
    'subClassName'?: string | null;
    'year'?: string | null;
    'yearId'?: number | null;
    'folderGuid': string;
    'folderIntId'?: number | null;
    'folderYearIntId'?: number | null;
    'folderPath'?: string | null;
    /**
     * Name for the merged package, without extension. Defaults to the dialog\'s suggestion but the preparer can change it — CCH rejects a duplicate name in the same folder, and has no delete operation, so renaming is the only way out of a collision.
     */
    'documentName': string;
}
/**
 * Everything the export dialog needs to let a preparer choose where in CCH Axcess Document a binder export should be filed.
 */
export interface CchExportDestinationOptionsDto {
    /**
     * False when the export cannot be pushed to CCH at all — the feature is off, or this client has no usable CCH link. The CCH destination stays selectable so the preparer can see why: choosing it shows Op.ClientTaxSystem.Api.DTOs.CchExportDestinationOptionsDto.UnavailableMessage in place of the filing fields and blocks the export, rather than offering a dead option with no explanation.
     */
    'available'?: boolean;
    /**
     * Why the CCH destination is unavailable: `FEATURE_DISABLED`, `NO_CCH_CLIENT`, `INVALID_CCH_GUID`, `CCH_CLIENT_NOT_FOUND` or `CCH_API_ERROR`. Null when Op.ClientTaxSystem.Api.DTOs.CchExportDestinationOptionsDto.Available is true.
     */
    'unavailableReason'?: string | null;
    /**
     * Human-readable companion to Op.ClientTaxSystem.Api.DTOs.CchExportDestinationOptionsDto.UnavailableReason.
     */
    'unavailableMessage'?: string | null;
    /**
     * Binder\'s tax year, so the dialog can show what it is filing against.
     */
    'taxYear'?: number;
    /**
     * CCH client this would be filed under, for confirmation in the dialog.
     */
    'cchClientName'?: string | null;
    /**
     * Suggested document name for the merged package, without extension — identical to the name the download path would have used.
     */
    'suggestedDocumentName'?: string | null;
    'classes'?: Array<CchExportClassDto> | null;
    'subclasses'?: Array<CchExportSubclassDto> | null;
    'years'?: Array<CchExportYearDto> | null;
    'folders'?: Array<CchExportFolderDto> | null;
    'defaultYear'?: CchExportYearDto;
    'defaultFolder'?: CchExportFolderDto;
    'defaultClass'?: CchExportClassDto;
    'defaultSubclass'?: CchExportSubclassDto;
}
export interface CchExportDestinationOptionsDtoApiResponse {
    'success'?: boolean;
    'data'?: CchExportDestinationOptionsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Result of filing one file into CCH.
 */
export interface CchExportFileResultDto {
    'fileName'?: string | null;
    'kind'?: CchExportArtifactKind;
    'success'?: boolean;
    /**
     * GUID CCH assigned, when the upload succeeded.
     */
    'cchDocumentGuid'?: string | null;
    /**
     * `CCH_DUPLICATE_DOCUMENT_NAME` when CCH already has a document of this name in the             folder, otherwise `CCH_UPLOAD_FAILED`. Null on success.
     */
    'errorCode'?: string | null;
    /**
     * Message safe to show the preparer. Null on success.
     */
    'error'?: string | null;
}


/**
 * A filing location in the client\'s CCH folder tree. Op.ClientTaxSystem.Api.DTOs.CchExportFolderDto.FolderIntId is CCH\'s `EntityFolderDetailIntID` — the value the upload metadata expects, which is not the same as `EntityFolderIntID`.
 */
export interface CchExportFolderDto {
    'folderGuid'?: string | null;
    'folderIntId'?: number | null;
    'folderYearIntId'?: number | null;
    /**
     * The folder\'s own name. In this firm\'s tenant these are tax years (\"2025\"), which is how the default folder is matched to the binder.
     */
    'name'?: string | null;
    /**
     * CCH\'s VirtualFolderPath — what the dialog shows.
     */
    'path'?: string | null;
    'level'?: number | null;
}
/**
 * A CCH document subclass, scoped to its parent class by Op.ClientTaxSystem.Api.DTOs.CchExportSubclassDto.ClassCode.
 */
export interface CchExportSubclassDto {
    'classCode'?: number | null;
    'code'?: number | null;
    'name'?: string | null;
}
/**
 * A CCH document year. CCH stores the year as a string alongside a numeric id.
 */
export interface CchExportYearDto {
    'year'?: string | null;
    'yearId'?: number | null;
}
export interface ChangePasswordDto {
    'currentPassword'?: string | null;
    'newPassword'?: string | null;
    'confirmPassword'?: string | null;
}
/**
 * DTO for client access permission information
 */
export interface ClientAccessPermissionDto {
    'id'?: string;
    'clientId'?: string;
    'userId'?: string;
    'userFirstName'?: string | null;
    'userLastName'?: string | null;
    'userEmail'?: string | null;
    'userRole'?: UserRole;
    'grantedBy'?: string;
    'grantedByFirstName'?: string | null;
    'grantedByLastName'?: string | null;
    'grantedAt'?: string;
}


export interface ClientAccessPermissionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientAccessPermissionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Complete summary of all users who have access to a client, including both direct (ClientUserDetail) and indirect (multi-contact pattern) access.
 */
export interface ClientAccessSummaryDto {
    'clientId'?: string;
    'clientName'?: string | null;
    /**
     * Users with explicit ClientUserDetail records for this client.
     */
    'directAccess'?: Array<DirectClientAccessDto> | null;
    /**
     * Users who have access via the multi-contact pattern (shared email/phone with direct users).
     */
    'indirectAccess'?: Array<IndirectClientAccessDto> | null;
    /**
     * Total count of unique users with access (direct + indirect).
     */
    'totalUsersWithAccess'?: number;
}
export interface ClientAccessSummaryDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientAccessSummaryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Represents a single audit entry for a client with human-readable information
 */
export interface ClientAuditEntryDto {
    /**
     * Unique identifier for the audit entry
     */
    'id'?: number;
    /**
     * When the change occurred
     */
    'timestampUtc'?: string;
    /**
     * Type of action (Created, Updated, etc.)
     */
    'action'?: string | null;
    /**
     * What the row is about, as recorded — the aggregation walks several entity types, so a row\'s subject is not implied by the endpoint it came from. Drives naming and linking on the client.
     */
    'entityType'?: string | null;
    /**
     * Identifier of the audited record, for resolving where a row\'s link should point.
     */
    'entityId'?: string | null;
    /**
     * Human-readable description of what changed
     */
    'description'?: string | null;
    /**
     * User who made the change
     */
    'userName'?: string | null;
    /**
     * ID of the user who made the change
     */
    'userId'?: string | null;
    /**
     * Specific field changes (if applicable)
     */
    'fieldChanges'?: Array<FieldChangeDto> | null;
    /**
     * IP address of the user (if available)
     */
    'ipAddress'?: string | null;
}
/**
 * Represents the audit history for a client with human-readable change descriptions
 */
export interface ClientAuditHistoryDto {
    /**
     * The client ID this history belongs to
     */
    'clientId'?: string;
    /**
     * The name of the client for context
     */
    'clientName'?: string | null;
    /**
     * List of audit entries in chronological order (newest first)
     */
    'auditEntries'?: Array<ClientAuditEntryDto> | null;
    /**
     * Total number of audit entries
     */
    'totalEntries'?: number;
    /**
     * 1-based page of entries returned. TotalEntries counts the whole filtered set, not this page.
     */
    'page'?: number;
    /**
     * Maximum entries per page.
     */
    'pageSize'?: number;
}
export interface ClientAuditHistoryDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientAuditHistoryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for bank account information used in questionnaire pre-fill. SECURITY: Contains sensitive financial data. - AccountNumber: Full account number (sensitive - should only be exposed to authorized callers). - AccountNumberLast4: Last 4 digits for display and masking purposes. Access to this DTO should be restricted to authenticated, authorized users only.
 */
export interface ClientBankAccountDto {
    'id'?: string;
    'accountType'?: BankAccountType;
    'accountTypeDisplay'?: string | null;
    'bankName'?: string | null;
    /**
     * Full bank account number (4-17 digits). SECURITY: Sensitive financial data - do not log or expose unnecessarily.
     */
    'accountNumber'?: string | null;
    /**
     * Last 4 digits of bank account number (for display/masking purposes).
     */
    'accountNumberLast4'?: string | null;
    'routingNumber'?: string | null;
    'isPreferredForRefund'?: boolean;
    'isPreferredForPayment'?: boolean;
    'notes'?: string | null;
}


export interface ClientBankAccountDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientBankAccountDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * The client copy a signer must review, plus whether the calling user has already accepted it.
 */
export interface ClientCopyReviewDto {
    /**
     * Document holding the client copy PDF, fetched via the standard document download endpoint
     */
    'documentId'?: string;
    /**
     * Display name of the client copy document
     */
    'documentName'?: string | null;
    /**
     * When the calling user accepted the client copy, null if they have not
     */
    'acknowledgedAt'?: string | null;
    /**
     * Whether the calling user has accepted the client copy
     */
    'acknowledgedByCurrentUser'?: boolean;
}
export interface ClientCopyReviewDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientCopyReviewDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for dependent information used in questionnaire pre-fill.
 */
export interface ClientDependentDto {
    'id'?: string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'ssn'?: string | null;
    'dateOfBirth'?: string | null;
    'age'?: number | null;
    'relationship'?: DependentRelationship;
    'relationshipDisplay'?: string | null;
    'monthsLivedInHome'?: number | null;
    'isStudent'?: boolean;
    'isDisabled'?: boolean;
    'notes'?: string | null;
}


export interface ClientDependentDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientDependentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientDetailsDto {
    'id'?: string;
    'clientNumber'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'address1'?: string | null;
    'address2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'taxId'?: string | null;
    'maskedTaxId'?: string | null;
    'spouseTaxId'?: string | null;
    'maskedSpouseTaxId'?: string | null;
    'fullAddress'?: string | null;
    'type'?: ClientType;
    'typeDisplay'?: string | null;
    'notes'?: string | null;
    /**
     * Service lines (Tax, Audit, CAS) enabled for this client. Drives which binder areas/tabs are visible on the preparer side and in the client portal.
     */
    'serviceLines'?: Array<ServiceLine> | null;
    'tags'?: Array<string> | null;
    'documentCount'?: number;
    /**
     * Number of Tax binders for this client (excludes audit binders). \"Organizer\" is legacy naming; the frontend surfaces this as \"Tax Binders\".
     */
    'organizerCount'?: number;
    /**
     * Number of Audit binders for this client. Surfaced alongside the tax binder count so clients enrolled in the Audit service line see both.
     */
    'auditBinderCount'?: number;
    'dependentsCount'?: number;
    'maritalStatus'?: MaritalStatus;
    'maritalStatusDisplay'?: string | null;
    'office'?: OfficeDto;
    'lastActivityAt'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'practiceManagementId'?: string | null;
    'practiceManagementSource'?: string | null;
    'isConfidential'?: boolean;
    'confidentialMarkedAt'?: string | null;
    'confidentialMarkedBy'?: string | null;
    'confidentialMarkedByName'?: string | null;
    'authorizedUserIds'?: Array<string> | null;
    'myRole'?: ClientUserRole;
    /**
     * Whether clients can upload a physically signed engagement letter instead of e-signing.
     */
    'allowPhysicalSignature'?: boolean;
    /**
     * Whether an engagement letter is required for this client\'s binders.
     */
    'engagementLetterRequired'?: boolean;
    'partnerId'?: string | null;
    'partnerName'?: string | null;
    'partnerEmail'?: string | null;
    /**
     * Default client users suggested during CCH import preview Only populated for CCH preview responses
     */
    'defaultClientUsers'?: Array<ImportClientUserDto> | null;
    /**
     * Validation warnings encountered during CCH import (e.g., invalid email format skipped) Only populated for CCH import responses
     */
    'validationWarnings'?: Array<string> | null;
    'users'?: Array<ClientUserDto> | null;
    'recentDocuments'?: Array<DocumentDto> | null;
    'recentBinders'?: Array<TaxBinderDto> | null;
    'statistics'?: ClientStatisticsDto;
}


export interface ClientDetailsDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientDetailsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientDto {
    'id'?: string;
    'clientNumber'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'address1'?: string | null;
    'address2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'taxId'?: string | null;
    'maskedTaxId'?: string | null;
    'spouseTaxId'?: string | null;
    'maskedSpouseTaxId'?: string | null;
    'fullAddress'?: string | null;
    'type'?: ClientType;
    'typeDisplay'?: string | null;
    'notes'?: string | null;
    /**
     * Service lines (Tax, Audit, CAS) enabled for this client. Drives which binder areas/tabs are visible on the preparer side and in the client portal.
     */
    'serviceLines'?: Array<ServiceLine> | null;
    'tags'?: Array<string> | null;
    'documentCount'?: number;
    /**
     * Number of Tax binders for this client (excludes audit binders). \"Organizer\" is legacy naming; the frontend surfaces this as \"Tax Binders\".
     */
    'organizerCount'?: number;
    /**
     * Number of Audit binders for this client. Surfaced alongside the tax binder count so clients enrolled in the Audit service line see both.
     */
    'auditBinderCount'?: number;
    'dependentsCount'?: number;
    'maritalStatus'?: MaritalStatus;
    'maritalStatusDisplay'?: string | null;
    'office'?: OfficeDto;
    'lastActivityAt'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'practiceManagementId'?: string | null;
    'practiceManagementSource'?: string | null;
    'isConfidential'?: boolean;
    'confidentialMarkedAt'?: string | null;
    'confidentialMarkedBy'?: string | null;
    'confidentialMarkedByName'?: string | null;
    'authorizedUserIds'?: Array<string> | null;
    'myRole'?: ClientUserRole;
    /**
     * Whether clients can upload a physically signed engagement letter instead of e-signing.
     */
    'allowPhysicalSignature'?: boolean;
    /**
     * Whether an engagement letter is required for this client\'s binders.
     */
    'engagementLetterRequired'?: boolean;
    'partnerId'?: string | null;
    'partnerName'?: string | null;
    'partnerEmail'?: string | null;
    /**
     * Default client users suggested during CCH import preview Only populated for CCH preview responses
     */
    'defaultClientUsers'?: Array<ImportClientUserDto> | null;
    /**
     * Validation warnings encountered during CCH import (e.g., invalid email format skipped) Only populated for CCH import responses
     */
    'validationWarnings'?: Array<string> | null;
}


export interface ClientDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientDtoPaginatedResponse {
    'items'?: Array<ClientDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ClientDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ClientDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientLoginDto {
    'emailOrPhone': string;
    'taxIdLast4': string;
}
/**
 * Warning returned when the CCH client number in the uploaded tax return PDF footer does not match the client the binder belongs to.
 */
export interface ClientMismatchWarningDto {
    'detectedClientNumber'?: string | null;
    'detectedClientName'?: string | null;
    'expectedClientNumber'?: string | null;
    'expectedClientName'?: string | null;
}
export interface ClientNoteDto {
    'id'?: string;
    'clientId'?: string;
    'serviceLine'?: ServiceLine;
    'content'?: string | null;
    'createdById'?: string;
    'createdByName'?: string | null;
    'createdAt'?: string;
    'updatedById'?: string | null;
    'updatedByName'?: string | null;
    'updatedAt'?: string;
}


export interface ClientNoteDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientNoteDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientNoteDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientNoteDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Client notification preference settings.
 */
export interface ClientNotificationPreferenceDto {
    'id'?: string;
    'clientId'?: string;
    'preferredChannel'?: NotificationChannel;
    'isEnabled'?: boolean;
    'batchIntervalMinutes'?: number;
    'enableDocumentRequests'?: boolean;
    'enableDocumentApprovals'?: boolean;
    'enableDocumentRejections'?: boolean;
    'enableDocumentComments'?: boolean;
    'enableBinderStageChanges'?: boolean;
    'enableBinderCreated'?: boolean;
    'enableSignatureRequests'?: boolean;
    'enableTaxReturnReleased'?: boolean;
    'enableEstimatedPaymentReminders'?: boolean;
    'enableAuditBinderStageChanges'?: boolean;
    'enableAuditBinderComments'?: boolean;
    'enableAuditBinderDocumentApprovals'?: boolean;
    'enableAuditBinderDocumentRejections'?: boolean;
    'enableAuditBinderDocumentRequests'?: boolean;
    'enableAuditBinderDocumentRequestOutcomes'?: boolean;
    'enableAuditBinderFirmDocumentsAdded'?: boolean;
    'notifyPrimaryUser'?: boolean;
    'notifySpouse'?: boolean;
    'notifyDependents'?: boolean;
    'notifyAuthorized'?: boolean;
    'notifyAccountant'?: boolean;
}


export interface ClientNotificationPreferenceDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientNotificationPreferenceDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientPageDefaultsDto {
    'rowsPerPage'?: number | null;
    'sortBy'?: string | null;
    'sortOrder'?: string | null;
    'myClientsOnly'?: string | null;
    'binderStatus'?: string | null;
    'type'?: string | null;
    'state'?: string | null;
    'officeIds'?: Array<string> | null;
    'partnerId'?: string | null;
    'confidentialFilter'?: string | null;
    'tags'?: Array<string> | null;
    'dateRangeStart'?: string | null;
    'dateRangeEnd'?: string | null;
}
export interface ClientPortalAccessRequestDto {
    'id'?: string;
    'requestType'?: AccessRequestType;
    /**
     * Display name for Op.ClientTaxSystem.Api.DTOs.Auth.ClientPortalAccessRequestDto.RequestType, so the review UI does not map the enum itself.
     */
    'requestTypeDisplay'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'zipCode'?: string | null;
    'last4TaxId'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'isMarried'?: boolean;
    'spouseFirstName'?: string | null;
    'spouseLastName'?: string | null;
    'spouseEmail'?: string | null;
    'spousePhoneNumber'?: string | null;
    'spouseLast4TaxId'?: string | null;
    'businesses'?: Array<AccessRequestBusinessDto> | null;
    'connectedTaxEntities'?: string | null;
    'comments'?: string | null;
    'status'?: AccessRequestStatus;
    'createdAt'?: string;
    'updatedAt'?: string;
    'reviewedAt'?: string | null;
    'reviewedByUserId'?: string | null;
    'reviewedByUserName'?: string | null;
    'reviewerNotes'?: string | null;
    /**
     * If set, indicates an existing client was found matching this access request (by email or phone). Helps preparers identify if the requester is already in the system.
     */
    'matchedClientId'?: string | null;
    /**
     * Name of the matched client, if found.
     */
    'matchedClientName'?: string | null;
    /**
     * The ID of the office this access request is assigned to.
     */
    'officeId'?: string | null;
    /**
     * The name of the office this access request is assigned to.
     */
    'officeName'?: string | null;
}


export interface ClientPortalAccessRequestDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientPortalAccessRequestDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientPortalAccessRequestDtoPaginatedResponse {
    'items'?: Array<ClientPortalAccessRequestDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ClientPortalAccessRequestDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ClientPortalAccessRequestDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for client response to a document request when they cannot provide or the request is not applicable
 */
export interface ClientResponseDto {
    'responseType': ClientResponseType;
    /**
     * Optional explanation note from the client
     */
    'note'?: string | null;
}



export enum ClientResponseType {
    CannotProvide = 'cannotProvide',
    NotApplicable = 'notApplicable',
    WillProvideDocument = 'willProvideDocument',
    FirmHasThisItem = 'firmHasThisItem',
    IncludedInOtherRequest = 'includedInOtherRequest'
}


/**
 * Search query DTO for client hybrid search
 */
export interface ClientSearchQueryDto {
    /**
     * Search term for name, client number, email, or phone. Optional - if empty, returns all clients matching filters. When provided, must be at least 2 characters.
     */
    'searchTerm'?: string | null;
    'type'?: ClientType;
    /**
     * Filter by office ID (single office - deprecated, use OfficeIds for multiple)
     */
    'officeId'?: string | null;
    /**
     * Filter by multiple office IDs (OR logic - returns clients in any of these offices)
     */
    'officeIds'?: Array<string> | null;
    /**
     * Filter by state
     */
    'state'?: string | null;
    /**
     * Enable semantic search (default: uses configuration setting)
     */
    'enableSemanticSearch'?: boolean | null;
    /**
     * Filter to only return clients the current user is watching/following. When true, results are limited to clients in the user\'s watch list.
     */
    'watchedClientsOnly'?: boolean | null;
    'binderStatus'?: BinderStatusFilter;
    'dateRange'?: DateRangeDto;
    'confidentialFilter'?: ConfidentialFilter;
    /**
     * Filter by assigned partner (User ID). Only applies to Preparer/Admin users.
     */
    'partnerId'?: string | null;
    /**
     * Page number (1-based)
     */
    'page'?: number;
    /**
     * Page size (default: 25, max: 100)
     */
    'pageSize'?: number;
    /**
     * Field to sort by (e.g., \"name\", \"email\", \"clientNumber\", \"status\", \"type\", \"lastActivityAt\")
     */
    'sortBy'?: string | null;
    /**
     * Sort order: \"asc\" or \"desc\" (default: \"asc\")
     */
    'sortOrder'?: string | null;
}


/**
 * Search result DTO with relevance scoring for client search
 */
export interface ClientSearchResultDto {
    'client'?: ClientDto;
    /**
     * Combined relevance score (0.0 - 1.0)
     */
    'score'?: number;
    /**
     * Exact match score component
     */
    'exactScore'?: number;
    /**
     * Fuzzy (trigram) match score component
     */
    'fuzzyScore'?: number;
    /**
     * Semantic (vector) similarity score component
     */
    'semanticScore'?: number;
    /**
     * Indicates which search method found this result
     */
    'matchType'?: string | null;
    /**
     * Highlighted text showing where the match occurred
     */
    'highlightedName'?: string | null;
}
export interface ClientSearchResultDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientSearchResultDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientSearchResultDtoPaginatedResponse {
    'items'?: Array<ClientSearchResultDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ClientSearchResultDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ClientSearchResultDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Search suggestion for autocomplete
 */
export interface ClientSearchSuggestionDto {
    /**
     * Unique identifier for the client.
     */
    'id'?: string;
    /**
     * Display name of the client.
     */
    'name'?: string | null;
    /**
     * Client number/code.
     */
    'clientNumber'?: string | null;
    /**
     * Client email.
     */
    'email'?: string | null;
    'clientType'?: ClientType;
    /**
     * Client type display name.
     */
    'clientTypeDisplay'?: string | null;
    /**
     * Client status display name.
     */
    'statusDisplay'?: string | null;
    /**
     * Relevance score for ranking suggestions (0.0 - 1.0).
     */
    'score'?: number;
}


export interface ClientSearchSuggestionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientSearchSuggestionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for spouse information used in questionnaire pre-fill.
 */
export interface ClientSpouseDto {
    'id'?: string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'ssn'?: string | null;
    'dateOfBirth'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
}
export interface ClientSpouseDtoApiResponse {
    'success'?: boolean;
    'data'?: ClientSpouseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ClientStatisticsDto {
    'totalDocuments'?: number;
    'totalBinders'?: number;
    'totalComments'?: number;
    'documentsByYear'?: { [key: string]: number; } | null;
    'documentsByType'?: ClientStatisticsDtoDocumentsByType | null;
    'lastDocumentUpload'?: string | null;
    'lastOrganizerUpdate'?: string | null;
}
export interface ClientStatisticsDtoDocumentsByType {
    'incomeDocument'?: number;
    'deductionDocument'?: number;
    'supportingDocument'?: number;
    'identificationDocument'?: number;
    'otherClientDocument'?: number;
    'taxReturn'?: number;
    'eFileAuthorization'?: number;
    'taxBinder'?: number;
    'engagementLetter'?: number;
    'estimatedPaymentVoucher'?: number;
    'directDepositReport'?: number;
    'otherPreparerDocument'?: number;
    'powerOfAttorney'?: number;
    'taxInformationAuthorization'?: number;
    'paymentAuthorization'?: number;
    'extensionRequest'?: number;
    'otherAuthorization'?: number;
}

export enum ClientType {
    Corporation = 'corporation',
    EmployeePlan = 'employeePlan',
    Fiduciary = 'fiduciary',
    Individual = 'individual',
    NonProfit = 'nonProfit',
    Partnership = 'partnership',
    SoleProprietorship = 'soleProprietorship',
    Other = 'other',
    Staff = 'staff',
    Project = 'project',
    Audit = 'audit'
}


export interface ClientUserDto {
    'id'?: string;
    'userId'?: string;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'role'?: ClientUserRole;
    'roleDisplay'?: string | null;
    'isMainContact'?: boolean;
    'createdAt'?: string;
    'otherConnectedClientsCount'?: number;
    'otherConnectedClients'?: Array<ConnectedClientInfo> | null;
}


export interface ClientUserDtoPaginatedResponse {
    'items'?: Array<ClientUserDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ClientUserDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ClientUserDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum ClientUserRole {
    Primary = 'primary',
    Spouse = 'spouse',
    Dependent = 'dependent',
    Authorized = 'authorized',
    Accountant = 'accountant',
    K1Recipient = 'k1Recipient'
}


/**
 * Detailed information about a client watcher
 */
export interface ClientWatcherInfo {
    'userId'?: string;
    'userName'?: string | null;
    'userEmail'?: string | null;
    'watchedAt'?: string;
    'isAutoAdded'?: boolean;
}
export interface ClientWatcherInfoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ClientWatcherInfo> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface CommentDto {
    'id'?: string;
    'content'?: string | null;
    'documentId'?: string | null;
    'binderId'?: string | null;
    'documentRequestId'?: string | null;
    'isInternal'?: boolean;
    'parentCommentId'?: string | null;
    'priority'?: string | null;
    'status'?: string | null;
    'replies'?: Array<CommentDto> | null;
    'createdById'?: string;
    'createdByName'?: string | null;
    'createdByRole'?: string | null;
    'createdAt'?: string;
    'updatedById'?: string | null;
    'updatedByName'?: string | null;
    'updatedAt'?: string;
    'isRead'?: boolean;
    'readAt'?: string | null;
    'readById'?: string | null;
    'readByName'?: string | null;
}
export interface CommentDtoApiResponse {
    'success'?: boolean;
    'data'?: CommentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface CommentDtoPaginatedResponse {
    'items'?: Array<CommentDto> | null;
    'pagination'?: PaginationInfo;
}
export interface CommentDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: CommentDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Common specific form type for autocomplete
 */
export interface CommonFormTypeDto {
    /**
     * Form code (e.g., \"8879\", \"W-2\", \"KY-740\")
     */
    'code'?: string | null;
    /**
     * User-friendly display name
     */
    'displayName'?: string | null;
    /**
     * Category for grouping in UI (e.g., \"Federal\", \"Income\", \"Schedule\", \"State-KY\")
     */
    'category'?: string | null;
}
/**
 * Request model for marking a binder\'s questionnaire as complete with answers
 */
export interface CompleteQuestionnaireRequest {
    /**
     * JSON object containing the questionnaire answers
     */
    'answers': any;
}
/**
 * Filter options for confidential client visibility
 */

export enum ConfidentialFilter {
    All = 'all',
    PublicOnly = 'publicOnly',
    MyViewableClients = 'myViewableClients',
    Restricted = 'restricted',
    AllConfidential = 'allConfidential'
}


export interface ConnectedClientInfo {
    'clientId'?: string;
    'clientName'?: string | null;
}
/**
 * DTO for converting a return to paper copy signing. Cancels any active DocuSeal e-signature session and switches to wet-ink paper workflow.
 */
export interface ConvertToPaperDto {
    /**
     * Optional reason for converting to paper copy. Defaults to \"Paper copy requested\" if not provided.
     */
    'reason'?: string | null;
}

export enum CoordinateSystem {
    PdfPoints = 'pdfPoints',
    Percentage = 'percentage',
    Pixels = 'pixels',
    Millimeters = 'millimeters'
}


export interface CreateAccessRequestBusinessDto {
    'businessName': string;
    /**
     * Full 9-digit EIN. Accepted with or without the XX-XXXXXXX dash; stored digits only.
     */
    'ein': string;
    'entityType'?: BusinessEntityType;
}


export interface CreateAuditBinderDto {
    'clientId': string;
    'name': string;
    'periodStart': string;
    'periodEnd': string;
    'dueDate': string;
    'description'?: string | null;
}
/**
 * Result of creating a binder with bundle upload. Contains both the created binder information and the bundle processing results.
 */
export interface CreateBinderWithBundleResultDto {
    'binder'?: TaxBinderDto;
    /**
     * Number of returns created from the bundle
     */
    'returnsCreated'?: number;
    /**
     * Number of documents stored (client copy, government copy, optional K-1)
     */
    'documentsExtracted'?: number;
    /**
     * Number of filing instructions extracted
     */
    'filingInstructionsExtracted'?: number;
    /**
     * Number of payment vouchers extracted
     */
    'vouchersExtracted'?: number;
    /**
     * Number of K-1 partners extracted from the K-1 bundle PDF
     */
    'k1PartnersExtracted'?: number;
    /**
     * Any warnings during processing
     */
    'warnings'?: Array<string> | null;
    'clientMismatchWarning'?: ClientMismatchWarningDto;
    /**
     * Timestamp when processing completed
     */
    'processedAt'?: string;
}
export interface CreateBinderWithBundleResultDtoApiResponse {
    'success'?: boolean;
    'data'?: CreateBinderWithBundleResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface CreateClientNoteDto {
    'clientId': string;
    'serviceLine': ServiceLine;
    'content': string;
}


export interface CreateClientPortalAccessRequestDto {
    'requestType': AccessRequestType;
    'firstName': string;
    'lastName': string;
    'zipCode': string;
    /**
     * Required on an Individual or Both request; unused on a Business request, which is identified by its EINs instead.
     */
    'last4TaxId'?: string | null;
    'email': string;
    'phoneNumber': string;
    /**
     * Nullable so an omitted field is rejected rather than binding to false, which would let a direct caller skip the married question and every spouse requirement behind it.
     */
    'isMarried'?: boolean | null;
    'spouseFirstName'?: string | null;
    'spouseLastName'?: string | null;
    'spouseEmail'?: string | null;
    'spousePhoneNumber'?: string | null;
    /**
     * Optional even on a married request.
     */
    'spouseLast4TaxId'?: string | null;
    /**
     * At least one entry on a Business or Both request.
     */
    'businesses'?: Array<CreateAccessRequestBusinessDto> | null;
    'connectedTaxEntities'?: string | null;
    'comments'?: string | null;
    'officeId'?: string | null;
}


export interface CreateCommentDto {
    'content': string;
    'documentId'?: string | null;
    'binderId'?: string | null;
    'documentRequestId'?: string | null;
    'isInternal'?: boolean;
    'parentCommentId'?: string | null;
    'priority'?: string | null;
    'status'?: string | null;
}
export interface CreateDocumentRequestDto {
    'title': string;
    'description'?: string | null;
    'clientId': string;
    'binderId'?: string | null;
    'priority'?: DocumentRequestPriority;
    'dueDate'?: string | null;
    'notes'?: string | null;
    'taxYear': number;
    'sortOrder'?: number;
    'requestType'?: AuditDocumentRequestType;
    'isConfidential'?: boolean | null;
    'confidentialClientUserId'?: string | null;
    /**
     * When true, hold this request for approval: no client user sees it and no client notification is sent until a Preparer/Admin releases it. Audit-binder requests only; staff only.
     */
    'requiresApproval'?: boolean | null;
}


export interface CreateK1RecipientAssignmentDto {
    'k1DocumentId': string;
    'partnerName': string;
    'bookmarkName': string;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
}
/**
 * DTO for manually creating a payment voucher
 */
export interface CreatePaymentVoucherDto {
    'quarter': VoucherQuarter;
    'taxYear': number;
    'formNumber': string;
    'dueDate': string;
    'amount': number;
    'mailingAddress1'?: string | null;
    'mailingAddress2'?: string | null;
    'mailingCity'?: string | null;
    'mailingState'?: string | null;
    'mailingZip'?: string | null;
    'payableTo'?: string | null;
}


/**
 * DTO for creating a primary user when a spouse logs in and no primary exists. Used by the spouse verification flow to create the primary taxpayer account.
 */
export interface CreatePrimaryUserDto {
    /**
     * Primary taxpayer\'s first name.
     */
    'firstName': string;
    /**
     * Primary taxpayer\'s last name.
     */
    'lastName': string;
    /**
     * Primary taxpayer\'s email address.
     */
    'email': string;
    /**
     * Primary taxpayer\'s phone number. Should be a mobile phone for SMS verification. Frontend should validate via Twilio Lookup before submission.
     */
    'phoneNumber': string;
}
export interface CreateQuestionnaireDto {
    'title': string;
    'description'?: string | null;
    'taxYear': number;
    'isActive'?: boolean;
    'isRequired'?: boolean;
    'questions'?: Array<CreateQuestionnaireQuestionDto> | null;
}
export interface CreateQuestionnaireQuestionDto {
    'question': string;
    'description'?: string | null;
    'questionType': QuestionType;
    'options'?: Array<string> | null;
    'isRequired'?: boolean;
    'validationRules'?: { [key: string]: any | null; } | null;
}


/**
 * DTO for creating a new questionnaire response
 */
export interface CreateQuestionnaireResponseDto {
    'binderId': string;
    'responseData': string;
}
/**
 * Generic \"send a document for e-signature\" request. Unlike the tax-binder taxpayer/spouse flow, this supports an arbitrary set of signers, each assigned to one or more placed fields by a shared Op.ClientTaxSystem.Api.DTOs.Signatures.SignerAssignmentDto.Role string. The document must already be uploaded and attached to the binder.
 */
export interface CreateSignatureRequestDto {
    /**
     * The already-uploaded document (PDF) to send for signature.
     */
    'documentId': string;
    /**
     * Optional submission title shown in DocuSeal / audit trail.
     */
    'name'?: string | null;
    /**
     * One entry per signer. Role maps placed fields to this signer.
     */
    'signers': Array<SignerAssignmentDto>;
    /**
     * Placed fields with relative coordinates and a role tying each to a signer.
     */
    'fields': Array<SignatureFieldPlacementDto>;
    /**
     * Optional DocuSeal builder template id the fields were placed on. Stored on the submission so a later \"edit fields\" can re-open the builder preloaded with the existing placements. Not used to create the submission itself (that is built inline from the PDF + Op.ClientTaxSystem.Api.DTOs.Signatures.CreateSignatureRequestDto.Fields).
     */
    'fieldTemplateId'?: string | null;
}
export interface CreateSignatureTemplateDto {
    'documentType': DocumentType;
    /**
     * Optional specific form type (e.g., \"8879\", \"KY-740\") If null, template applies to all documents of the DocumentType category
     */
    'specificFormType'?: string | null;
    'templateName': string;
    'requiresSignature'?: boolean;
    /**
     * If true, template will be permanently deleted from DocuSeal after first use. Use for sensitive documents like specific engagement letters.
     */
    'isOneTimeUse'?: boolean;
    'fields': Array<TemplateSignatureFieldDto>;
}


export interface CreateSubmissionFromPdfDto {
    /**
     * Name of the document submission
     */
    'name'?: string | null;
    /**
     * Set false to disable signature request emails sending
     */
    'send_email'?: boolean;
    /**
     * Set true to send signature request via phone number and SMS
     */
    'send_sms'?: boolean;
    /**
     * Pass \'random\' to send signature request emails to all parties right away
     */
    'order'?: string | null;
    /**
     * Specify URL to redirect to after the submission completion. Null to omit from request.
     */
    'completed_redirect_url'?: string | null;
    /**
     * Specify BCC address to send signed documents to after the completion. Null to omit from request.
     */
    'bcc_completed'?: string | null;
    /**
     * Specify Reply-To address to use in the notification emails. Null to omit from request.
     */
    'reply_to'?: string | null;
    /**
     * Specify the expiration date and time after which the submission becomes unavailable for signature. Null to omit from request.
     */
    'expire_at'?: string | null;
    /**
     * Remove PDF form fields from the documents
     */
    'flatten'?: boolean;
    /**
     * Set true to merge the documents into a single PDF file
     */
    'merge_documents'?: boolean;
    /**
     * Pass false to disable the removal of {{text}} tags from the PDF
     */
    'remove_tags'?: boolean;
    /**
     * Set true to use embedded signing mode (signing URLs returned instead of emails sent)
     */
    'embedded'?: boolean;
    /**
     * List of documents to be signed
     */
    'documents': Array<DocuSealDocumentDto>;
    /**
     * List of submitters/signers
     */
    'submitters': Array<SubmitterDto>;
}
export interface CreateTemplateFromDocumentDto {
    /**
     * ID of the existing document to convert to a template
     */
    'documentId': string;
    /**
     * Optional name for the template (defaults to document name)
     */
    'templateName'?: string | null;
    'documentType'?: DocumentType;
    /**
     * Whether template requires signatures (default: true)
     */
    'requiresSignature'?: boolean;
    /**
     * If true, template will be permanently deleted from DocuSeal after first use
     */
    'isOneTimeUse'?: boolean;
    /**
     * If true and TemplateName is null/empty, use AI to generate an intelligent template name. Uses Azure Document Intelligence + Claude vision to create professional names for tax preparers. Default: true (opt-out behavior for backward compatibility)
     */
    'autoGenerateName'?: boolean | null;
}


export interface CreateUploadLinkDto {
    'label': string;
    'message'?: string | null;
    'recipientEmails'?: Array<string> | null;
    'expiresAt'?: string | null;
}
/**
 * DTO for creating a new user account with immediate client association
 */
export interface CreateUserWithClientDto {
    'email': string;
    'firstName': string;
    'lastName': string;
    'phoneNumber'?: string | null;
    'clientId': string;
    'clientUserRole': ClientUserRole;
    /**
     * When true, promotes this user to main contact for the client. When false, demotes this user and auto-promotes the next best candidate. Omit or pass null to leave the current main contact unchanged.
     */
    'isMainContact'?: boolean | null;
}


export interface DashboardDto {
    'stats'?: DashboardStatsDto;
    'metrics'?: DashboardMetricsDto;
    'recentActivities'?: Array<RecentActivityDto> | null;
    'recentClients'?: Array<RecentClientDto> | null;
}
export interface DashboardDtoApiResponse {
    'success'?: boolean;
    'data'?: DashboardDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DashboardMetricsDto {
    'documentsAwaitingReview'?: number;
    'pendingSignatures'?: number;
    'questionnairesInProgress'?: number;
    'clientResponseRate'?: number;
}
export interface DashboardMetricsDtoApiResponse {
    'success'?: boolean;
    'data'?: DashboardMetricsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DashboardPageDefaultsDto {
    'myClientsOnly'?: string | null;
    'assignedToMe'?: string | null;
    'officeId'?: string | null;
    'partnerId'?: string | null;
    'activeCardFilter'?: string | null;
    'sortField'?: string | null;
    'sortOrder'?: string | null;
    'taxYear'?: string | null;
    'taxType'?: string | null;
    'stage'?: string | null;
    'isClientSubmitted'?: string | null;
}
export interface DashboardStatsDto {
    /**
     * Number of documents pending preparer review (ReadyForReview, UnderReview, or PendingApproval status)
     */
    'documentsToReviewCount'?: number;
    /**
     * Number of binders where client has submitted (ClientSubmittedAt is set) but preparer hasn\'t started review
     */
    'clientSubmissionsCount'?: number;
    /**
     * Number of binders currently in InReview stage (preparer actively working on them)
     */
    'returnsInProcessCount'?: number;
    /**
     * Number of comments pending preparer review (unread comments)
     */
    'commentsToReviewCount'?: number;
    /**
     * Number of binders with late documents (documents uploaded after SentForPreparation stage)
     */
    'lateDocumentsCount'?: number;
}
export interface DashboardStatsDtoApiResponse {
    'success'?: boolean;
    'data'?: DashboardStatsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Date range DTO for filtering
 */
export interface DateRangeDto {
    /**
     * Start date (inclusive)
     */
    'startDate'?: string | null;
    /**
     * End date (inclusive)
     */
    'endDate'?: string | null;
}
/**
 * DTO for providing a reason when deleting a return.
 */
export interface DeleteReturnDto {
    /**
     * Optional reason for deletion. Defaults to \"Return deleted\" if not provided.
     */
    'reason'?: string | null;
}
export interface DeletedAuditBinderDto {
    'id'?: string;
    'clientId'?: string;
    'clientName'?: string | null;
    'clientNumber'?: string | null;
    'name'?: string | null;
    'periodStart'?: string;
    'periodEnd'?: string;
    'stage'?: AuditBinderStage;
    'deletedAt'?: string;
    'deletedByName'?: string | null;
    'deletionReason'?: AuditBinderDeletionReason;
    'replacedByBinderName'?: string | null;
    /**
     * When the purge removes it; null when it is never purged (retired schedule).
     */
    'purgeScheduledAt'?: string | null;
    /**
     * Whether the next purge run removes it.
     */
    'purgeDue'?: boolean;
    'requestCount'?: number;
    'documentCount'?: number;
    'fileCount'?: number;
    'storedObjectCount'?: number;
    'totalFileBytes'?: number;
}


/**
 * The Admin-only \"Recently deleted audit binders\" list, which doubles as the purge\'s dry-run report: it shows what the next run would remove. View only; nothing here restores or purges.
 */
export interface DeletedAuditBindersDto {
    /**
     * Days a deleted binder is kept before it is purged.
     */
    'retentionDays'?: number;
    /**
     * Whether the daily purge job runs in this environment.
     */
    'purgeEnabled'?: boolean;
    /**
     * Whether the purge only logs what it would remove.
     */
    'purgeDryRun'?: boolean;
    /**
     * Every deleted audit binder, most recently deleted first.
     */
    'items'?: Array<DeletedAuditBinderDto> | null;
    /**
     * Binders the next run would purge.
     */
    'dueBinderCount'?: number;
    /**
     * Stored files the next run would remove.
     */
    'dueStoredObjectCount'?: number;
    /**
     * Size of the document files the next run would remove, in bytes.
     */
    'dueTotalFileBytes'?: number;
    /**
     * Stored files of already purged binders still waiting to be removed.
     */
    'pendingFileDeletionCount'?: number;
    /**
     * Of those, how many have failed at least once.
     */
    'failedFileDeletionCount'?: number;
}
export interface DeletedAuditBindersDtoApiResponse {
    'success'?: boolean;
    'data'?: DeletedAuditBindersDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum DependentRelationship {
    Child = 'child',
    Stepchild = 'stepchild',
    FosterChild = 'fosterChild',
    AdoptedChild = 'adoptedChild',
    Grandchild = 'grandchild',
    Parent = 'parent',
    Sibling = 'sibling',
    OtherRelative = 'otherRelative'
}


/**
 * Development-only DTO for bypassing client verification code flow. This endpoint is ONLY available in Development environment.
 */
export interface DevClientLoginDto {
    'clientId': string;
    'emailOrPhone': string;
}
/**
 * Request DTO for the dev-only SSO mock endpoint. Used by E2E tests to bypass the real Azure AD redirect flow. Available only when ASPNETCORE_ENVIRONMENT=Development AND AzureAd:SsoMockMode=true.
 */
export interface DevSsoLoginDto {
    /**
     * Target preparer email — must match a seeded preparer in the test database (e.g., admin@test.com, prep1@test.com, partner@test.com).
     */
    'email': string;
}
/**
 * A user with direct access to a client via ClientUserDetail.
 */
export interface DirectClientAccessDto {
    'userId'?: string;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'clientRole'?: ClientUserRole;
    'clientRoleDisplay'?: string | null;
    'systemRole'?: UserRole;
    'systemRoleDisplay'?: string | null;
    /**
     * When this user was associated with the client.
     */
    'associatedAt'?: string;
}


export interface DocuSealDocumentDto {
    /**
     * Name of the document
     */
    'name': string;
    /**
     * Base64-encoded content of the PDF or DOCX file or downloadable file URL
     */
    'file': string;
    /**
     * Fields are optional if you use {{...}} text tags to define fields in the document
     */
    'fields'?: Array<DocuSealDocumentFieldDto> | null;
}
export interface DocuSealDocumentFieldDto {
    /**
     * Name of the field
     */
    'name': string;
    /**
     * Display title shown to the submitter (e.g., signer\'s name instead of field identifier). When null, DocuSeal defaults to showing the Name.
     */
    'title'?: string | null;
    /**
     * Type of the field (e.g., text, signature, date, initials)
     */
    'type'?: string | null;
    /**
     * Role assigned to this field
     */
    'role'?: string | null;
    /**
     * Whether this field is required
     */
    'required'?: boolean;
    /**
     * Format for date fields (e.g., \"MM/DD/YYYY\"). Null to omit from request.
     */
    'format'?: string | null;
    /**
     * Areas where the field is positioned in the document. Coordinates are relative (0.0-1.0) as percentages of page dimensions.
     */
    'areas'?: Array<DocuSealFieldAreaDto> | null;
}
export interface DocuSealFieldAreaDto {
    /**
     * X coordinate (0.0-1.0, relative to page width)
     */
    'x'?: number;
    /**
     * Y coordinate (0.0-1.0, relative to page height)
     */
    'y'?: number;
    /**
     * Width (0.0-1.0, relative to page width)
     */
    'w'?: number;
    /**
     * Height (0.0-1.0, relative to page height)
     */
    'h'?: number;
    /**
     * Page number (1-based)
     */
    'page'?: number;
}
export interface DocuSealWebhookData {
    'status'?: string | null;
    'email'?: string | null;
    'name'?: string | null;
    'declineReason'?: string | null;
    'documents'?: Array<DocuSealWebhookDocument> | null;
}
export interface DocuSealWebhookDocument {
    'documentId'?: string | null;
    'fileName'?: string | null;
    'downloadUrl'?: string | null;
    'signedAt'?: string | null;
}
export interface DocuSealWebhookDto {
    'eventType'?: string | null;
    'submissionId'?: string | null;
    'timestamp'?: string;
    'data'?: DocuSealWebhookData;
    'signature'?: string | null;
}
/**
 * Result of AI-powered document classification analysis
 */
export interface DocumentClassificationResult {
    'suggestedDocumentType'?: DocumentType;
    /**
     * Confidence score for the suggestion (0.0 to 1.0)
     */
    'confidence'?: number;
    /**
     * Suggested tags for document organization (e.g., \"income\", \"federal\", \"w2\")
     */
    'suggestedTags'?: Array<string> | null;
    /**
     * ID of the matching required document slot, if applicable
     */
    'suggestedRequiredDocumentSlotId'?: string | null;
    /**
     * Human-readable explanation for the classification suggestions
     */
    'reasoning'?: string | null;
    /**
     * Whether suggestions were automatically applied (only if confidence >= 0.80)
     */
    'autoApplied'?: boolean;
    /**
     * Detected form type from the document (e.g., \"W-2\", \"8879\")
     */
    'detectedFormType'?: string | null;
}


export interface DocumentClassificationResultApiResponse {
    'success'?: boolean;
    'data'?: DocumentClassificationResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentCompletionStatus {
    'totalDocuments'?: number;
    'uploadedDocuments'?: number;
    'pendingDocuments'?: number;
    'completionPercentage'?: number;
    'documentStatuses'?: DocumentCompletionStatusDocumentStatuses | null;
}
export interface DocumentCompletionStatusDocumentStatuses {
    'incomeDocument'?: DocumentStatus;
    'deductionDocument'?: DocumentStatus;
    'supportingDocument'?: DocumentStatus;
    'identificationDocument'?: DocumentStatus;
    'otherClientDocument'?: DocumentStatus;
    'taxReturn'?: DocumentStatus;
    'eFileAuthorization'?: DocumentStatus;
    'taxBinder'?: DocumentStatus;
    'engagementLetter'?: DocumentStatus;
    'estimatedPaymentVoucher'?: DocumentStatus;
    'directDepositReport'?: DocumentStatus;
    'otherPreparerDocument'?: DocumentStatus;
    'powerOfAttorney'?: DocumentStatus;
    'taxInformationAuthorization'?: DocumentStatus;
    'paymentAuthorization'?: DocumentStatus;
    'extensionRequest'?: DocumentStatus;
    'otherAuthorization'?: DocumentStatus;
}



export enum DocumentDirection {
    ReceivedFromClient = 'receivedFromClient',
    SentToClient = 'sentToClient'
}


/**
 * DTO for document download URL response with presigned URL and metadata
 */
export interface DocumentDownloadUrlDto {
    /**
     * Presigned URL for downloading the document with time-limited access
     */
    'downloadUrl'?: string | null;
    /**
     * When the presigned URL will expire (UTC)
     */
    'expiresAt'?: string;
    /**
     * Document file name for download attribution
     */
    'fileName'?: string | null;
    /**
     * MIME type of the document
     */
    'contentType'?: string | null;
    /**
     * File size in bytes
     */
    'fileSize'?: number | null;
}
export interface DocumentDownloadUrlDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentDownloadUrlDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentDto {
    'id'?: string;
    'type'?: DocumentType;
    'status'?: DocumentStatus;
    'direction'?: DocumentDirection;
    'binderId'?: string;
    'createdAt'?: string;
    'updatedAt'?: string;
    'updatedById'?: string | null;
    'detectedFormType'?: string | null;
    'detectionConfidence'?: number | null;
    'userOverrideFormType'?: string | null;
    'effectiveFormType'?: string | null;
    'suggestedDocumentType'?: DocumentType;
    'classificationConfidence'?: number | null;
    'classificationTimestamp'?: string | null;
    'dataExtractedAt'?: string | null;
    'dataExtractionConfidence'?: number | null;
    'dataExtractionSource'?: string | null;
    'extractedDataJson'?: string | null;
    'aiProcessingStatus'?: AiProcessingStatus;
    /**
     * Timestamp when AI processing job was queued.
     */
    'aiProcessingQueuedAt'?: string | null;
    /**
     * Timestamp when AI processing completed (successfully or with error).
     */
    'aiProcessingCompletedAt'?: string | null;
    /**
     * Error message if AI processing failed.
     */
    'aiProcessingError'?: string | null;
    /**
     * True if AI processing is still pending or in progress. Frontend can use this to show a loading indicator.
     */
    'isAiProcessing'?: boolean;
    'createdById'?: string | null;
    'uploadedByName'?: string | null;
    'uploadedByRole'?: UserRole;
    'exportedAt'?: string | null;
    'exportedById'?: string | null;
    'exportedByName'?: string | null;
    'signatureStatus'?: SignatureStatus;
    'signatureSubmissionId'?: string | null;
    'signatureTemplateId'?: string | null;
    'requiresSignature'?: boolean;
    'signatureSentAt'?: string | null;
    'signatureCompletedAt'?: string | null;
    'signedPdfStoredAt'?: string | null;
    'requiresESignature'?: boolean;
    'reviewedAt'?: string | null;
    'reviewedById'?: string | null;
    'reviewedByName'?: string | null;
    'reviewNotes'?: string | null;
    'rejectionReason'?: string | null;
    'documentRequestId'?: string | null;
    'documentRequestName'?: string | null;
    'category'?: string | null;
    'description'?: string | null;
    'comment'?: string | null;
    'reviewComment'?: string | null;
    /**
     * Result of virus scanning. Null = not scanned, true = passed, false = virus detected.
     */
    'virusScanPassed'?: boolean | null;
    /**
     * Timestamp when virus scan was performed.
     */
    'virusScanAt'?: string | null;
    /**
     * Name of the virus scanning provider/service used.
     */
    'virusScanProvider'?: string | null;
    'virusScanStatus'?: VirusScanStatus;
    /**
     * Indicates if this document was uploaded \"late\" (after binder reached SentForPreparation stage). Late documents require preparer attention and trigger email notifications.
     */
    'isLate'?: boolean;
    /**
     * URL for accessing the document thumbnail (if available). Thumbnails are 200x200px JPEG images with preserved aspect ratio. Null if no thumbnail exists (e.g., for PDFs or if generation failed).
     */
    'thumbnailUrl'?: string | null;
    'documentFiles'?: Array<DocumentFileDto> | null;
}


export interface DocumentDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<DocumentDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentDtoPaginatedResponse {
    'items'?: Array<DocumentDto> | null;
    'pagination'?: PaginationInfo;
}
export interface DocumentDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: DocumentDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentFileDto {
    'id'?: string;
    'documentId'?: string;
    'fileName'?: string | null;
    'fileSize'?: number;
    'mimeType'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'createdById'?: string | null;
    'updatedById'?: string | null;
    /**
     * Pre-computed SHA256 hash of the file content for fast duplicate detection. 64 characters (hex representation of 256-bit hash).
     */
    'shA256Hash'?: string | null;
    /**
     * Timestamp when the hash was computed. Null for legacy files uploaded before hash computation was implemented.
     */
    'hashComputedAt'?: string | null;
}
/**
 * Enum for filtering documents to include in the export package.
 */

export enum DocumentFilter {
    ApprovedOnly = 'approvedOnly',
    All = 'all',
    Selected = 'selected'
}


export interface DocumentGroupDto {
    'groupId'?: string | null;
    'name'?: string | null;
    'startPage'?: number;
    'endPage'?: number;
    'pageCount'?: number;
    'pages'?: Array<DocumentPageDto> | null;
    'bookmarkName'?: string | null;
    'hasBookmark'?: boolean;
    'documentType'?: DocumentType;
}


export interface DocumentGroupSelectionDto {
    'groupId': string;
    'documentType': DocumentType;
    'selectedPageIds': Array<string>;
    'signatureTemplateId'?: string | null;
}


export interface DocumentPageDto {
    'pageId'?: string | null;
    'pageNumber'?: number;
    'previewImageBase64'?: string | null;
    'previewImageUrl'?: string | null;
    'originalWidth'?: number;
    'originalHeight'?: number;
    'thumbnailWidth'?: number;
    'thumbnailHeight'?: number;
    'isSelected'?: boolean;
}
export interface DocumentPreprocessingDto {
    'id'?: string;
    'binderId'?: string;
    'originalFileName'?: string | null;
    'status'?: ProcessingStatus;
    'errorMessage'?: string | null;
    'totalPages'?: number;
    'createdAt'?: string;
    'completedAt'?: string | null;
    'documents'?: Array<PreprocessedDocumentDto> | null;
}


export interface DocumentPreprocessingDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentPreprocessingDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentPreviewResponseDto {
    'previewId'?: string | null;
    'fileName'?: string | null;
    'totalPages'?: number;
    'groups'?: Array<DocumentGroupDto> | null;
    'createdAt'?: string;
    'fileSizeBytes'?: number;
}
export interface DocumentPreviewResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentPreviewResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Represents a single audit entry for a document request with human-readable information
 */
export interface DocumentRequestAuditEntryDto {
    /**
     * Unique identifier for the audit entry
     */
    'id'?: number;
    /**
     * When the change occurred
     */
    'timestampUtc'?: string;
    /**
     * Type of action (Created, Updated, StatusChanged, etc.)
     */
    'action'?: string | null;
    /**
     * Human-readable description of what changed
     */
    'description'?: string | null;
    /**
     * User who made the change
     */
    'userName'?: string | null;
    /**
     * ID of the user who made the change
     */
    'userId'?: string | null;
    /**
     * Specific field changes (if applicable)
     */
    'fieldChanges'?: Array<FieldChangeDto> | null;
    /**
     * IP address of the user (if available)
     */
    'ipAddress'?: string | null;
}
/**
 * Represents the audit history for a document request with human-readable change descriptions
 */
export interface DocumentRequestAuditHistoryDto {
    /**
     * The document request ID this history belongs to
     */
    'documentRequestId'?: string;
    /**
     * The title of the document request for context
     */
    'documentRequestTitle'?: string | null;
    'currentStatus'?: DocumentRequestStatus;
    /**
     * List of audit entries in chronological order (newest first)
     */
    'auditEntries'?: Array<DocumentRequestAuditEntryDto> | null;
    /**
     * Total number of audit entries
     */
    'totalEntries'?: number;
}


export interface DocumentRequestAuditHistoryDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentRequestAuditHistoryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentRequestDocumentDto {
    'id'?: string;
    'documentId'?: string;
    'name'?: string | null;
    'type'?: DocumentType;
    'status'?: DocumentStatus;
    'fileSize'?: number | null;
    'contentType'?: string | null;
    'createdAt'?: string;
    'uploadedAt'?: string;
    'uploadedByName'?: string | null;
}


export interface DocumentRequestDto {
    'id'?: string;
    'title'?: string | null;
    'description'?: string | null;
    'clientId'?: string;
    'clientName'?: string | null;
    'binderId'?: string | null;
    'binderName'?: string | null;
    'requestedById'?: string;
    'requestedByName'?: string | null;
    'status'?: DocumentRequestStatus;
    'statusDisplayName'?: string | null;
    'priority'?: DocumentRequestPriority;
    'priorityDisplayName'?: string | null;
    'dueDate'?: string | null;
    'completedDate'?: string | null;
    'completedById'?: string | null;
    'completedByName'?: string | null;
    'notes'?: string | null;
    'sortOrder'?: number;
    'taxYear'?: number;
    'createdAt'?: string;
    'updatedAt'?: string;
    'documents'?: Array<DocumentRequestDocumentDto> | null;
    'commentCount'?: number;
    'unreadCommentCount'?: number;
    'isOverdue'?: boolean;
    'submittedAt'?: string | null;
    'submittedById'?: string | null;
    'submittedByName'?: string | null;
    'reviewedAt'?: string | null;
    'reviewedById'?: string | null;
    'reviewedByName'?: string | null;
    'reviewNotes'?: string | null;
    'rejectionReason'?: string | null;
    'requiresResubmission'?: boolean;
    'requestType'?: AuditDocumentRequestType;
    'requestTypeDisplayName'?: string | null;
    'isConfidential'?: boolean;
    'confidentialClientUserId'?: string | null;
    'confidentialClientUserName'?: string | null;
    'requiresApproval'?: boolean;
    'releasedToClientAt'?: string | null;
    'releasedToClientById'?: string | null;
    'needsClientAttentionAt'?: string | null;
    'needsClientAttentionById'?: string | null;
    'needsClientAttentionByName'?: string | null;
    'needsClientAttentionNote'?: string | null;
    /**
     * True when a Preparer/Admin has manually flagged this request for the client.
     */
    'needsClientAttention'?: boolean;
    'clientResponse'?: ClientResponseType;
    'clientResponseNote'?: string | null;
    'clientRespondedAt'?: string | null;
    /**
     * Gets or sets the display name for the client response. This is a human-readable string derived from the Op.ClientTaxSystem.Api.DTOs.DocumentRequests.DocumentRequestDto.ClientResponse enum value, typically set by a mapping profile or service layer to provide a user-friendly label.
     */
    'clientResponseDisplayName'?: string | null;
    'totalDocuments'?: number;
    'uploadedDocuments'?: number;
    'approvedDocuments'?: number;
    'rejectedDocuments'?: number;
    'pendingDocuments'?: number;
    'requiresChangesDocuments'?: number;
    /**
     * True when status is Submitted and preparer can review
     */
    'canBeReviewed'?: boolean;
    /**
     * True when status is Rejected and client can upload new documents
     */
    'canResubmit'?: boolean;
    /**
     * True when some documents are approved but others still need review
     */
    'hasPartialReview'?: boolean;
    /**
     * Document-level completion percentage based on approved documents
     */
    'completionPercentage'?: number;
}


export interface DocumentRequestDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentRequestDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentRequestDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<DocumentRequestDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentRequestDtoPaginatedResponse {
    'items'?: Array<DocumentRequestDto> | null;
    'pagination'?: PaginationInfo;
}
export interface DocumentRequestDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: DocumentRequestDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum DocumentRequestPriority {
    Low = 'low',
    Medium = 'medium',
    High = 'high',
    Critical = 'critical'
}


/**
 * What the staff \"Send reminder\" dialog shows before sending: who would receive it, why anyone would not, what the client will read, and the request\'s reminder history.
 */
export interface DocumentRequestReminderPreviewDto {
    /**
     * True when a reminder can be sent right now.
     */
    'canSend'?: boolean;
    /**
     * Why a reminder can\'t be sent right now, as an error code. Null when Op.ClientTaxSystem.Api.DTOs.DocumentRequests.DocumentRequestReminderPreviewDto.CanSend is true.
     */
    'blockedCode'?: string | null;
    /**
     * Why a reminder can\'t be sent right now, in words for the staff member.
     */
    'blockedMessage'?: string | null;
    /**
     * Client users who will receive the reminder, with the channels it reaches them on.
     */
    'recipients'?: Array<DocumentRequestReminderRecipientDto> | null;
    /**
     * Client users who can see the request but will not receive the reminder, each with the reason.
     */
    'notReceiving'?: Array<DocumentRequestReminderRecipientDto> | null;
    'reminderCount'?: number;
    'lastReminderSentAt'?: string | null;
    'lastReminderSentByName'?: string | null;
    /**
     * When the cooldown ends. Null when no reminder has been sent.
     */
    'nextReminderAvailableAt'?: string | null;
    /**
     * What the client reads, before any optional message from staff.
     */
    'previewMessage'?: string | null;
    'dueDate'?: string | null;
    'isOverdue'?: boolean;
    /**
     * The link in the reminder, which opens this request in the client portal.
     */
    'requestUrl'?: string | null;
}
export interface DocumentRequestReminderPreviewDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentRequestReminderPreviewDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentRequestReminderRecipientDto {
    'userId'?: string;
    'name'?: string | null;
    /**
     * The user\'s role on the client, e.g. \"Primary\" or \"Spouse\".
     */
    'roleDisplay'?: string | null;
    /**
     * The channels the reminder reaches this user on: \"Email\" (in the next digest) and/or \"Text\".
     */
    'channels'?: Array<string> | null;
    /**
     * Why this user will not receive the reminder. Null for a recipient.
     */
    'reason'?: string | null;
}
export interface DocumentRequestReminderResultDto {
    'sentAt'?: string;
    'recipientNames'?: Array<string> | null;
    'reminderCount'?: number;
    'nextReminderAvailableAt'?: string;
}
export interface DocumentRequestReminderResultDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentRequestReminderResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum DocumentRequestReviewAction {
    Approve = 'approve',
    Reject = 'reject',
    RequestChanges = 'requestChanges',
    Unapprove = 'unapprove'
}



export enum DocumentRequestStatus {
    Pending = 'pending',
    Submitted = 'submitted',
    Completed = 'completed',
    Rejected = 'rejected',
    Cancelled = 'cancelled'
}



export enum DocumentReviewAction {
    Approve = 'approve',
    Reject = 'reject',
    RequireChanges = 'requireChanges'
}


export interface DocumentReviewItemDto {
    'documentId': string;
    'action': DocumentReviewAction;
    'reviewNotes'?: string | null;
    'rejectionReason'?: string | null;
}


/**
 * Response DTO containing document review result details Client Binder Document Management
 */
export interface DocumentReviewResultDto {
    /**
     * Document unique identifier
     */
    'id'?: string;
    'status'?: DocumentStatus;
    /**
     * Timestamp when document was reviewed
     */
    'reviewedAt'?: string | null;
    /**
     * Full name of the reviewer
     */
    'reviewedBy'?: string | null;
    /**
     * Review comment from preparer
     */
    'reviewComment'?: string | null;
}


export interface DocumentReviewResultDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentReviewResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Result for individual document signature preparation
 */
export interface DocumentSignatureResultDto {
    'documentId'?: string;
    'documentName'?: string | null;
    'success'?: boolean;
    'submissionId'?: string | null;
    'signingUrl'?: string | null;
    'error'?: string | null;
    'existingSubmissionId'?: string | null;
}

export enum DocumentSplitOption {
    KeepTogether = 'keepTogether',
    SplitByGroups = 'splitByGroups'
}


export interface DocumentStagingDto {
    'binderId'?: string;
    'stage'?: BinderStage;
    'preprocessing'?: DocumentPreprocessingDto;
    'documents'?: Array<PreprocessedDocumentDto> | null;
    'canFinalize'?: boolean;
    'totalDocuments'?: number;
    'documentsRequiringSignature'?: number;
}


export interface DocumentStagingDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentStagingDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum DocumentStatus {
    Na = 'na',
    NotUploaded = 'notUploaded',
    RequiresChanges = 'requiresChanges',
    Staged = 'staged',
    ReadyForReview = 'readyForReview',
    UnderReview = 'underReview',
    PendingApproval = 'pendingApproval',
    Processing = 'processing',
    Validating = 'validating',
    Uploading = 'uploading',
    Uploaded = 'uploaded',
    UploadFailed = 'uploadFailed',
    Accepted = 'accepted',
    Approved = 'approved',
    Rejected = 'rejected',
    Completed = 'completed',
    Archived = 'archived',
    Deleted = 'deleted'
}



export enum DocumentType {
    IncomeDocument = 'incomeDocument',
    DeductionDocument = 'deductionDocument',
    SupportingDocument = 'supportingDocument',
    IdentificationDocument = 'identificationDocument',
    OtherClientDocument = 'otherClientDocument',
    TaxReturn = 'taxReturn',
    EFileAuthorization = 'eFileAuthorization',
    TaxBinder = 'taxBinder',
    EngagementLetter = 'engagementLetter',
    EstimatedPaymentVoucher = 'estimatedPaymentVoucher',
    DirectDepositReport = 'directDepositReport',
    OtherPreparerDocument = 'otherPreparerDocument',
    PowerOfAttorney = 'powerOfAttorney',
    TaxInformationAuthorization = 'taxInformationAuthorization',
    PaymentAuthorization = 'paymentAuthorization',
    ExtensionRequest = 'extensionRequest',
    OtherAuthorization = 'otherAuthorization'
}


/**
 * Document type category from enum
 */
export interface DocumentTypeCategoryDto {
    'value'?: DocumentType;
    /**
     * Enum name (e.g., \"TaxReturn\", \"Form8879\")
     */
    'name'?: string | null;
    /**
     * User-friendly display name (e.g., \"Federal Tax Return\", \"IRS e-file Authorization (Form 8879)\")
     */
    'displayName'?: string | null;
    /**
     * Whether this type typically requires signatures
     */
    'requiresSignature'?: boolean;
    /**
     * Grouping: ClientUploaded, PreparerGenerated, or SignatureRequired
     */
    'group'?: string | null;
}


/**
 * Data transfer object for frontend document type metadata.
 */
export interface DocumentTypeDto {
    /**
     * Frontend type value (e.g., \"w2\", \"1099\", \"receipt\").
     */
    'value'?: string | null;
    /**
     * Human-readable label for display (e.g., \"W-2\", \"1099 Forms\").
     */
    'label'?: string | null;
    /**
     * Description of the document type (e.g., \"Wage and tax statement\").
     */
    'description'?: string | null;
    /**
     * High-level category name (e.g., \"Income Document\").
     */
    'category'?: string | null;
}
export interface DocumentTypeDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<DocumentTypeDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Document type options for frontend selection
 */
export interface DocumentTypeOptionsDto {
    /**
     * High-level document type categories from the enum
     */
    'categories'?: Array<DocumentTypeCategoryDto> | null;
    /**
     * Common specific form types for autocomplete/quick selection
     */
    'commonFormTypes'?: Array<CommonFormTypeDto> | null;
}
export interface DocumentTypeOptionsDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentTypeOptionsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentUploadResponseDto {
    /**
     * Primary document ID (first document when multiple files are uploaded). For backward compatibility - use DocumentIds for multi-file uploads.
     */
    'documentId'?: string;
    /**
     * All file IDs created during upload.
     */
    'fileIds'?: Array<string> | null;
    /**
     * All document IDs created during upload. Each file creates a separate document when multiple files are uploaded.
     */
    'documentIds'?: Array<string> | null;
}
export interface DocumentUploadResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentUploadResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface DocumentUploadResult {
    'documentId'?: string;
    'documentName'?: string | null;
    'documentType'?: DocumentType;
    'fileIds'?: Array<string> | null;
    'includedPageNumbers'?: Array<number> | null;
    'groupName'?: string | null;
    'uploaderRole'?: UploaderRole;
    'signatureTemplateId'?: string | null;
    'eSignatureStatus'?: ESignatureStatus;
    'eSignatureSubmissionId'?: string | null;
}


export interface DocumentUploadWithPagesDto {
    'previewId': string;
    'selectedGroups': Array<DocumentGroupSelectionDto>;
    'binderId': string;
    'folderName'?: string | null;
    'splitOption': DocumentSplitOption;
    'sendESignatureOnUpload'?: boolean;
    'direction'?: DocumentDirection;
    /**
     * Whether to generate AI-powered descriptions for uploaded documents (default: true). If true, generates descriptions from Azure Document Intelligence extracted data or falls back to Claude vision API. Descriptions include page ranges and key document information for each page group.
     */
    'generateAiDescription'?: boolean;
}


export interface DocumentUploadWithPagesResponseDto {
    'createdDocuments'?: Array<DocumentUploadResult> | null;
    'previewId'?: string | null;
    'totalPagesProcessed'?: number;
    'splitOption'?: DocumentSplitOption;
}


export interface DocumentUploadWithPagesResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: DocumentUploadWithPagesResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Represents a client association for a duplicate user (simplified version)
 */
export interface DuplicateClientAssociationDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'clientNumber'?: string | null;
    'clientType'?: ClientType;
    'clientTypeDisplay'?: string | null;
    'role'?: ClientUserRole;
    'roleDisplay'?: string | null;
}


/**
 * Result of duplicate detection analysis
 */
export interface DuplicateDetectionResult {
    /**
     * Whether potential duplicates were found (similarity >= 0.70)
     */
    'isPotentialDuplicate'?: boolean;
    /**
     * List of potential duplicate matches
     */
    'matches'?: Array<DuplicateMatch> | null;
    /**
     * Highest similarity score among all matches
     */
    'highestSimilarityScore'?: number;
}
export interface DuplicateDetectionResultApiResponse {
    'success'?: boolean;
    'data'?: DuplicateDetectionResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Information about a potential duplicate document
 */
export interface DuplicateMatch {
    /**
     * ID of the existing document that matches
     */
    'existingDocumentId'?: string;
    /**
     * Filename of the existing document
     */
    'existingDocumentName'?: string | null;
    /**
     * Similarity score (0.0 to 1.0)
     */
    'similarityScore'?: number;
    /**
     * Explanation of why this is considered a potential duplicate
     */
    'matchReason'?: string | null;
    /**
     * Upload timestamp of the existing document
     */
    'uploadedAt'?: string;
}

export enum EFileSigningMethod {
    NotSigned = 'notSigned',
    ESignature = 'eSignature',
    PaperCopy = 'paperCopy'
}



export enum ESignatureAuditAction {
    DocumentUploaded = 'documentUploaded',
    SignatureRequested = 'signatureRequested',
    DocumentViewed = 'documentViewed',
    SigningStarted = 'signingStarted',
    DocumentSigned = 'documentSigned',
    DocumentDeclined = 'documentDeclined',
    SubmissionCompleted = 'submissionCompleted',
    SubmissionExpired = 'submissionExpired',
    SubmissionCancelled = 'submissionCancelled',
    ReminderSent = 'reminderSent',
    SignerReplaced = 'signerReplaced',
    DocumentReplaced = 'documentReplaced',
    IdentityVerified = 'identityVerified',
    IdentityVerificationFailed = 'identityVerificationFailed',
    SignerAdded = 'signerAdded',
    SubmissionVoided = 'submissionVoided',
    AddonCreated = 'addonCreated'
}


/**
 * Individual audit entry for e-signature events (IRS compliant)
 */
export interface ESignatureAuditEntryDto {
    'id'?: number;
    'action'?: ESignatureAuditAction;
    'description'?: string | null;
    'documentType'?: DocumentType;
    'documentName'?: string | null;
    /**
     * Type of actor: \"signer\", \"preparer\", \"system\", \"webhook\"
     */
    'actorType'?: string | null;
    'actorName'?: string | null;
    'actorEmail'?: string | null;
    'signerName'?: string | null;
    'signerEmail'?: string | null;
    'signerRole'?: SignerRole;
    'timestampUtc'?: string;
    'ipAddress'?: string | null;
    'signatureMethod'?: string | null;
    'identityVerificationMethod'?: string | null;
    'declineReason'?: string | null;
    'metadata'?: { [key: string]: any | null; } | null;
}


/**
 * Response wrapper for e-signature audit history
 */
export interface ESignatureAuditHistoryDto {
    'entries'?: Array<ESignatureAuditEntryDto> | null;
    'totalCount'?: number;
}
export interface ESignatureAuditHistoryDtoApiResponse {
    'success'?: boolean;
    'data'?: ESignatureAuditHistoryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * E-signature document details for the E-Signatures tab
 */
export interface ESignatureDocumentDto {
    'id'?: string;
    'documentType'?: DocumentType;
    'fileName'?: string | null;
    'uploadedAt'?: string;
    'uploadedByUserId'?: string;
    'uploadedByUserName'?: string | null;
    'submission'?: ESignatureSubmissionDto;
    /**
     * True when the document belongs to a return round earlier than the binder\'s current one and its tax-return signature request was never completed, so no signature is expected
     */
    'isSuperseded'?: boolean;
}


/**
 * Response wrapper for e-signature documents in a binder
 */
export interface ESignatureDocumentListDto {
    'documents'?: Array<ESignatureDocumentDto> | null;
    'summary'?: ESignatureSummaryDto;
}
export interface ESignatureDocumentListDtoApiResponse {
    'success'?: boolean;
    'data'?: ESignatureDocumentListDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum ESignatureStatus {
    NotRequested = 'notRequested',
    Pending = 'pending',
    Completed = 'completed',
    Failed = 'failed'
}


/**
 * Generic e-signature status DTO for tracking signature status on any document type. Used in TaxBinderDto for engagement letter, e-file authorization, and future e-signature documents.
 */
export interface ESignatureStatusDto {
    /**
     * ID of the document that requires signature
     */
    'documentId'?: string | null;
    /**
     * Whether a document exists for this e-signature type
     */
    'hasDocument'?: boolean;
    /**
     * When all required signatures were completed (null if not fully signed)
     */
    'signedAt'?: string | null;
    /**
     * Whether all required signatures have been collected
     */
    'isSigned'?: boolean;
    /**
     * DocuSeal submission ID (if sent for signature)
     */
    'submissionId'?: string | null;
    /**
     * Public signing URL for the DocuSeal submission
     */
    'signingUrl'?: string | null;
    /**
     * Current status of the submission (pending, completed, etc.)
     */
    'submissionStatus'?: string | null;
    /**
     * Whether a DocuSeal submission exists for this document
     */
    'hasSubmission'?: boolean;
    /**
     * Human-readable sequential signing status: \"Awaiting First Party\", \"Awaiting Second Party\", \"Completed\"
     */
    'sequentialStatus'?: string | null;
    /**
     * Whether the current logged-in user can sign this document. For sequential signing, this will be false if the user must wait for a previous signer.
     */
    'currentUserCanSign'?: boolean;
    /**
     * The signing URL specific to the current user. Each signer has a unique URL; this is the URL for the logged-in user.
     */
    'currentUserSigningUrl'?: string | null;
    /**
     * Whether the current user is waiting for a previous signer to complete before they can sign.
     */
    'currentUserWaitingForPreviousSigner'?: boolean;
    /**
     * Whether the current user has already signed this document.
     */
    'currentUserSigned'?: boolean;
    /**
     * Name of the signer the submission is currently waiting for (null if not waiting or completed)
     */
    'waitingForSignerName'?: string | null;
    'signatureMethod'?: EngagementLetterSignatureMethod;
    /**
     * Whether physical signature upload is allowed for this client.
     */
    'physicalSignatureAllowed'?: boolean;
    /**
     * Whether an engagement letter is required for this binder\'s client.
     */
    'engagementLetterRequired'?: boolean;
}


/**
 * DocuSeal submission tracking details
 */
export interface ESignatureSubmissionDto {
    'submissionId'?: string | null;
    'status'?: SignatureStatus;
    'createdAt'?: string;
    'completedAt'?: string | null;
    'expiresAt'?: string | null;
    'signers'?: Array<SignerStatusDto> | null;
    'signersCompleted'?: number;
    'signersTotal'?: number;
    /**
     * Human-readable sequential signing status: \"Awaiting First Party\", \"Awaiting Second Party\", \"Completed\"
     */
    'sequentialStatus'?: string | null;
    'nextSigner'?: SignerStatusDto;
}


/**
 * Summary statistics for e-signature documents in a binder
 */
export interface ESignatureSummaryDto {
    'total'?: number;
    'completed'?: number;
    'pending'?: number;
    'notStarted'?: number;
}
/**
 * Individual eligible signer information
 */
export interface EligibleSignerDto {
    'userId'?: string;
    'name'?: string | null;
    'email'?: string | null;
    /**
     * Relationship to the client: \"primary\", \"spouse\", \"authorized_user\", \"preparer\"
     */
    'relationship'?: string | null;
}
/**
 * Response containing users eligible to sign documents for a client
 */
export interface EligibleSignersDto {
    'users'?: Array<EligibleSignerDto> | null;
}
export interface EligibleSignersDtoApiResponse {
    'success'?: boolean;
    'data'?: EligibleSignersDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Response DTO for email verification operations
 */
export interface EmailVerificationResponseDto {
    /**
     * Whether the operation was successful
     */
    'success'?: boolean;
    /**
     * Human-readable message describing the result
     */
    'message'?: string | null;
    /**
     * The email address that was verified (masked for security)
     */
    'email'?: string | null;
    /**
     * Whether the email is now verified
     */
    'emailVerified'?: boolean;
}
export interface EmailVerificationResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: EmailVerificationResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum EngagementLetterSignatureMethod {
    NotSigned = 'notSigned',
    ESignature = 'eSignature',
    PhysicalUpload = 'physicalUpload'
}


export interface EntityAuditTrailDto {
    'entityType'?: string | null;
    'entityId'?: string | null;
    'auditEntries'?: Array<StructuredAuditDto> | null;
    'totalEntries'?: number;
}
export interface EntityAuditTrailDtoApiResponse {
    'success'?: boolean;
    'data'?: EntityAuditTrailDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * A group of comments belonging to a single entity (document or document request)
 */
export interface EntityCommentGroupDto {
    /**
     * The ID of the entity (document or document request)
     */
    'entityId'?: string;
    /**
     * The type of entity: \"document\" or \"documentRequest\"
     */
    'entityType'?: string | null;
    /**
     * The display name of the entity (document name or request title)
     */
    'entityName'?: string | null;
    /**
     * Optional description or additional context (e.g., document type)
     */
    'entityDescription'?: string | null;
    /**
     * Comments in this group, ordered by creation time
     */
    'comments'?: Array<CommentDto> | null;
    /**
     * Total number of comments in this group
     */
    'totalCount'?: number;
    /**
     * Number of unread comments in this group
     */
    'unreadCount'?: number;
    /**
     * Timestamp of the most recent comment in this group
     */
    'latestCommentAt'?: string | null;
}
/**
 * DTO for enum values with metadata for UI dropdowns/selects. Provides enum name, numeric value, and display name for frontend integration.
 */
export interface EnumOptionDto {
    /**
     * The enum value name (e.g., \"IncomeDocument\"). Use for API serialization and deserialization.
     */
    'value'?: string | null;
    /**
     * The numeric value of the enum (e.g., 0 for DocumentType.IncomeDocument). Use for database storage or numeric comparisons.
     */
    'numericValue'?: number;
    /**
     * The human-readable display name from [Display(Name = \"...\")] attribute. Use for UI labels, dropdowns, and user-facing text.
     */
    'displayName'?: string | null;
    /**
     * Optional display order for custom sorting. Defaults to enum declaration order (0, 1, 2, ...).
     */
    'order'?: number | null;
}
export interface EnumOptionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<EnumOptionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * A jurisdiction\'s estimated payment vouchers within a BinderEstimatedPaymentsDto
 */
export interface EstimatedPaymentJurisdictionDto {
    /**
     * Jurisdiction id — the {returnId} segment for the voucher mark-paid/opt-in routes
     */
    'returnId'?: string;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'vouchers'?: Array<TaxReturnBundlePaymentVoucherDto> | null;
}
/**
 * A prior-year payment voucher flattened for questionnaire prefill.
 */
export interface EstimatedPaymentPreFillDto {
    'voucherId'?: string;
    'quarter'?: VoucherQuarter;
    /**
     * The payment year the voucher applies to (== the binder\'s tax year)
     */
    'taxYear'?: number;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'formNumber'?: string | null;
    /**
     * Scheduled amount from the prior-year return
     */
    'amount'?: number;
    'dueDate'?: string;
    'isPaid'?: boolean;
    'paidAt'?: string | null;
    /**
     * Client-entered amount actually paid, when it differs from Amount. Null = scheduled amount. The estimates step should prefill with PaidAmount ?? Amount for paid vouchers.
     */
    'paidAmount'?: number | null;
}


/**
 * Request body for bundling selected documents from an audit binder into a downloadable zip archive. All ids must belong to the target binder; if any do not, the service throws a BusinessLogicException.
 */
export interface ExportAuditBinderDocumentsDto {
    'documentIds': Array<string>;
}

export enum ExportFormat {
    Auto = 'auto',
    SinglePdf = 'singlePdf',
    Zip = 'zip',
    Direct = 'direct'
}



export enum ExportType {
    SinglePdf = 'singlePdf',
    ZipArchive = 'zipArchive',
    CchUpload = 'cchUpload'
}


/**
 * External client response DTO representing a client from an external system (e.g., CCH Axcess).
 */
export interface ExternalClientDto {
    /**
     * Unique identifier for the external client record in our system.
     */
    'id'?: string;
    /**
     * The external system this client was imported from (e.g., \"CCH\").
     */
    'sourceSystem'?: string | null;
    /**
     * The client\'s unique identifier in the external source system.
     */
    'externalId'?: string | null;
    /**
     * The client\'s GUID in the external source system, if available.
     */
    'externalGuid'?: string | null;
    /**
     * The client number/code used in the external system.
     */
    'clientNumber'?: string | null;
    /**
     * The client\'s display name or sort name from the external system.
     */
    'name'?: string | null;
    /**
     * Primary email address for the client.
     */
    'email'?: string | null;
    /**
     * Primary phone number for the client (normalized to digits only).
     */
    'phone'?: string | null;
    /**
     * The office GUID this client belongs to in the external system.
     */
    'officeId'?: string | null;
    /**
     * The name of the office this client belongs to.
     */
    'officeName'?: string | null;
    /**
     * Client type code from the external system (e.g., \"Individual\", \"Corporation\").
     */
    'clientType'?: string | null;
    /**
     * Human-readable display name for the client type.
     */
    'clientTypeDisplay'?: string | null;
    /**
     * Client status from the external system (e.g., \"Active\", \"Inactive\").
     */
    'status'?: string | null;
    /**
     * Whether the client is currently active in the external system.
     */
    'isActive'?: boolean;
    /**
     * Last activity or modification timestamp from the external system.
     */
    'lastActivityAt'?: string | null;
    /**
     * When this client was last synchronized from the external system.
     */
    'lastSyncedAt'?: string;
    /**
     * Whether a vector embedding has been generated for semantic search.
     */
    'hasEmbedding'?: boolean;
    /**
     * When the semantic search embedding was generated.
     */
    'embeddingGeneratedAt'?: string | null;
    /**
     * The ID of the local Client record if this external client has been imported.
     */
    'importedClientId'?: string | null;
    /**
     * Whether this external client has been imported as a local Client.
     */
    'isImported'?: boolean;
    /**
     * Primary Partner Staff GUID from CCH (Responsible Staff assignment).
     */
    'primaryPartnerStaffGuid'?: string | null;
    /**
     * Primary Partner name from CCH.
     */
    'primaryPartnerName'?: string | null;
    /**
     * Primary Partner email from CCH.
     */
    'primaryPartnerEmail'?: string | null;
    /**
     * When this external client record was created in our system.
     */
    'createdAt'?: string;
    /**
     * When this external client record was last updated in our system.
     */
    'updatedAt'?: string;
}
export interface ExternalClientDtoApiResponse {
    'success'?: boolean;
    'data'?: ExternalClientDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalClientDtoPaginatedResponse {
    'items'?: Array<ExternalClientDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ExternalClientDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ExternalClientDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Search result DTO with relevance scoring
 */
export interface ExternalClientSearchResultDto {
    'client'?: ExternalClientDto;
    /**
     * Combined relevance score (0.0 - 1.0)
     */
    'score'?: number;
    /**
     * Exact match score component
     */
    'exactScore'?: number;
    /**
     * Fuzzy (trigram) match score component
     */
    'fuzzyScore'?: number;
    /**
     * Semantic (vector) similarity score component
     */
    'semanticScore'?: number;
    /**
     * Indicates which search method found this result
     */
    'matchType'?: string | null;
    /**
     * Highlighted text showing where the match occurred
     */
    'highlightedName'?: string | null;
}
export interface ExternalClientSearchResultDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ExternalClientSearchResultDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalClientSearchResultDtoPaginatedResponse {
    'items'?: Array<ExternalClientSearchResultDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ExternalClientSearchResultDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ExternalClientSearchResultDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Search suggestion for autocomplete
 */
export interface ExternalClientSearchSuggestionDto {
    /**
     * Unique identifier for the external client.
     */
    'id'?: string;
    /**
     * Display name of the client.
     */
    'name'?: string | null;
    /**
     * Client number/code from the external system.
     */
    'clientNumber'?: string | null;
    /**
     * Source system identifier (e.g., \"CCH\").
     */
    'sourceSystem'?: string | null;
    /**
     * Relevance score for ranking suggestions (0.0 - 1.0).
     */
    'score'?: number;
}
export interface ExternalClientSearchSuggestionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<ExternalClientSearchSuggestionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Manual sync request DTO
 */
export interface ExternalClientSyncRequestDto {
    /**
     * Source system to sync (leave empty for all)
     */
    'sourceSystem'?: string | null;
    /**
     * Only sync clients modified since this date
     */
    'modifiedSince'?: string | null;
    /**
     * Force regenerate embeddings for all synced clients
     */
    'regenerateEmbeddings'?: boolean;
}
/**
 * Sync operation result DTO
 */
export interface ExternalClientSyncResultDto {
    'sourceSystem'?: string | null;
    'syncStartedAt'?: string;
    'syncCompletedAt'?: string | null;
    'duration'?: string | null;
    'success'?: boolean;
    'errorMessage'?: string | null;
    /**
     * Total clients fetched from source
     */
    'totalFetched'?: number;
    /**
     * New clients inserted
     */
    'inserted'?: number;
    /**
     * Existing clients updated
     */
    'updated'?: number;
    /**
     * Clients marked inactive (not in source)
     */
    'markedInactive'?: number;
    /**
     * Clients with errors during processing
     */
    'errors'?: number;
    /**
     * Embeddings generated during sync
     */
    'embeddingsGenerated'?: number;
}
/**
 * Sync status DTO
 */
export interface ExternalClientSyncStatusDto {
    'isRunning'?: boolean;
    'lastSyncAt'?: string | null;
    'nextScheduledSync'?: string | null;
    'syncCronSchedule'?: string | null;
    /**
     * Total external clients in repository
     */
    'totalClients'?: number;
    /**
     * Active external clients
     */
    'activeClients'?: number;
    /**
     * Clients with embeddings
     */
    'clientsWithEmbeddings'?: number;
    /**
     * Clients linked to imported local clients
     */
    'importedClients'?: number;
    /**
     * Stats per source system
     */
    'sourceSystems'?: Array<SourceSystemStatsDto> | null;
    /**
     * Last sync results per source
     */
    'lastSyncResults'?: Array<ExternalClientSyncResultDto> | null;
}
export interface ExternalClientSyncStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: ExternalClientSyncStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * A document share owned by the current preparer/admin, as shown in the \"Send Documents\" table.
 */
export interface ExternalDocumentShareDto {
    'id'?: string;
    /**
     * Name of the zip bundle that was sent (e.g. \"Documents-2026-07-16.zip\").
     */
    'fileName'?: string | null;
    'mimeType'?: string | null;
    /**
     * Size of the zip bundle in bytes.
     */
    'fileSize'?: number;
    /**
     * How many individual documents are inside the zip bundle.
     */
    'fileCount'?: number;
    /**
     * The external recipients this bundle was sent to.
     */
    'recipientEmails'?: Array<string> | null;
    /**
     * Per-recipient download detail (who downloaded and when). Powers the \"Downloaded\" column\'s inline per-recipient list in the \"Sent Documents\" table.
     */
    'recipients'?: Array<ExternalDocumentShareRecipientDto> | null;
    'message'?: string | null;
    /**
     * The public landing-page URL the recipient was emailed (for \"copy link\").
     */
    'shareUrl'?: string | null;
    'status'?: ExternalDocumentShareStatus;
    'createdAt'?: string;
    'expiresAt'?: string;
    'downloadedAt'?: string | null;
    'downloadCount'?: number;
    /**
     * True when the link is configured to expire after the first download.
     */
    'expireOnDownload'?: boolean;
}


export interface ExternalDocumentShareDtoApiResponse {
    'success'?: boolean;
    'data'?: ExternalDocumentShareDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ExternalDocumentShareDtoPaginatedResponse {
    'items'?: Array<ExternalDocumentShareDto> | null;
    'pagination'?: PaginationInfo;
}
export interface ExternalDocumentShareDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: ExternalDocumentShareDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * One recipient of an external document share, with their individual download state. Download attribution is best-effort (derived from the `email` query parameter on the recipient\'s link), so Op.ClientTaxSystem.Api.DTOs.ExternalDocumentShares.ExternalDocumentShareRecipientDto.DownloadedAt may be null even if the aggregate share was downloaded.
 */
export interface ExternalDocumentShareRecipientDto {
    'email'?: string | null;
    /**
     * When this recipient first downloaded (UTC), or null if they have not.
     */
    'downloadedAt'?: string | null;
    /**
     * Number of downloads attributed to this recipient.
     */
    'downloadCount'?: number;
}
/**
 * Lifecycle status of an external document share, computed from expiry + download state.
 */

export enum ExternalDocumentShareStatus {
    Sent = 'sent',
    Downloaded = 'downloaded',
    Expired = 'expired'
}


export interface ExternalUploadViewDto {
    'label'?: string | null;
    'uploads'?: Array<UploadedFileDto> | null;
}
export interface ExternalUploadViewDtoApiResponse {
    'success'?: boolean;
    'data'?: ExternalUploadViewDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Result of structured data extraction from a tax form. Contains the extracted fields as JSON plus metadata about the extraction.
 */
export interface ExtractedDataResult {
    /**
     * Form type that was processed (e.g., \"W-2\", \"1099-DIV\", \"1098\").
     */
    'formType'?: string | null;
    /**
     * Serialized JSON containing the extracted structured data. The structure varies by form type (W2Data, Form1099DivData, etc.).
     */
    'jsonData'?: string | null;
    /**
     * Overall confidence score for the extraction (0.0 to 1.0). Represents the average confidence across all extracted fields.
     */
    'confidence'?: number;
    /**
     * Name of the AI service or model used for extraction. Example: \"Azure-Document-Intelligence-W2\"
     */
    'source'?: string | null;
    /**
     * Number of fields successfully extracted from the document.
     */
    'fieldCount'?: number;
    /**
     * Timestamp when the extraction was performed.
     */
    'extractedAt'?: string;
    /**
     * Dictionary of field names to their extracted values. Useful for debugging and validation without parsing JSON.
     */
    'rawFields'?: { [key: string]: any | null; } | null;
    /**
     * Error message if extraction failed. Null if successful.
     */
    'errorMessage'?: string | null;
    /**
     * Whether the extraction was successful.
     */
    'success'?: boolean;
    /**
     * Form type detected from content analysis (e.g., \"W-2\", \"1099-DIV\"). This is determined by analyzing the extracted text content.
     */
    'detectedFormType'?: string | null;
    /**
     * Confidence score for the detected form type (0.0 to 1.0).
     */
    'detectionConfidence'?: number;
    /**
     * Whether the detected form type is a recognized tax form.
     */
    'isRecognizedTaxForm'?: boolean;
}
export interface ExtractedDataResultApiResponse {
    'success'?: boolean;
    'data'?: ExtractedDataResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Individual document extraction result within a batch operation.
 */
export interface ExtractionResult {
    /**
     * Document ID that was processed.
     */
    'documentId'?: string;
    /**
     * Whether extraction succeeded for this document.
     */
    'success'?: boolean;
    /**
     * Detected form type (e.g., \"W-2\", \"1099-DIV\").
     */
    'formType'?: string | null;
    /**
     * Confidence score of the extraction (0.0 to 1.0).
     */
    'confidence'?: number | null;
    /**
     * Number of fields extracted from the document.
     */
    'fieldCount'?: number | null;
    /**
     * Error message if extraction failed. Null if successful.
     */
    'errorMessage'?: string | null;
    /**
     * Whether the document was skipped due to unsupported form type.
     */
    'skipped'?: boolean;
}
/**
 * Represents a specific field change in an audit entry
 */
export interface FieldChangeDto {
    /**
     * Name of the field that changed
     */
    'fieldName'?: string | null;
    /**
     * Human-readable field display name
     */
    'displayName'?: string | null;
    /**
     * Previous value (formatted for display)
     */
    'oldValue'?: string | null;
    /**
     * New value (formatted for display)
     */
    'newValue'?: string | null;
}
export interface FieldDetail {
    'name'?: string | null;
    'type'?: string | null;
    'role'?: string | null;
    'page'?: number;
    'x'?: number;
    'y'?: number;
    'width'?: number;
    'height'?: number;
    'confidence'?: number;
}
export interface FieldDimensionsDto {
    'width': number;
    'height': number;
    'maintainAspectRatio'?: boolean;
}
export interface FieldPositionDto {
    'x': number;
    'y': number;
    'system'?: CoordinateSystem;
    'anchor'?: AnchorPoint;
}


export interface FieldPreferencesDto {
    'fontSize'?: number | null;
    'fontType'?: string | null;
    'font'?: string | null;
    'color'?: string | null;
    'align'?: string | null;
    'vAlign'?: string | null;
    'format'?: string | null;
    'price'?: number | null;
    'currency'?: string | null;
    'mask'?: boolean | null;
}
export interface FilePreviewDto {
    'fileId'?: string;
    'documentId'?: string;
    'fileName'?: string | null;
    'mimeType'?: string | null;
    'fileSize'?: number;
    'documentType'?: DocumentType;
}



export enum FilingInstructionType {
    TaxReturn = 'taxReturn',
    EstimatedTax = 'estimatedTax'
}



export enum FilingMethod {
    EFile = 'eFile',
    Mail = 'mail'
}


export interface FinalizeStagingDto {
    'sendNotification'?: boolean;
    'createSignatureSubmissions'?: boolean;
}
export interface FinalizeStagingResultDto {
    'binderId'?: string;
    'success'?: boolean;
    'totalDocumentsProcessed'?: number;
    'documentsFinalized'?: number;
    'signatureSubmissionsCreated'?: number;
    'notificationSent'?: boolean;
    'processedDocuments'?: Array<ProcessedDocumentDto> | null;
    'warnings'?: Array<string> | null;
    'errors'?: Array<string> | null;
    'processedAt'?: string;
}
export interface FinalizeStagingResultDtoApiResponse {
    'success'?: boolean;
    'data'?: FinalizeStagingResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface Form8879DiagnosticReport {
    'totalForms'?: number;
    'formsWithFields'?: number;
    'formsWithoutFields'?: number;
    'formsWithErrors'?: number;
    'formsWithVariantDetected'?: number;
    'formsDirectory'?: string | null;
    'results'?: Array<FormDetectionResult> | null;
}
export interface Form8879DiagnosticReportApiResponse {
    'success'?: boolean;
    'data'?: Form8879DiagnosticReport;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface FormBuilderAreaDto {
    'x'?: number;
    'y'?: number;
    'w'?: number;
    'h'?: number;
    'attachment_uuid'?: string | null;
    'page'?: number;
}
export interface FormBuilderConfigDto {
    'jwtToken': string;
    'builderOptions'?: { [key: string]: any | null; } | null;
    'callbackUrl'?: string | null;
    'testMode'?: boolean;
}
export interface FormBuilderConfigDtoApiResponse {
    'success'?: boolean;
    'data'?: FormBuilderConfigDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface FormBuilderDocumentDto {
    'id'?: number | null;
    'name'?: string | null;
    'uuid'?: string | null;
    'record_type'?: string | null;
    'record_id'?: number | null;
    'blob_id'?: number | null;
    'created_at'?: string | null;
    'signed_uuid'?: string | null;
    'filename'?: string | null;
    'metadata'?: { [key: string]: any | null; } | null;
    'preview_images'?: Array<FormBuilderPreviewImageDto> | null;
}
export interface FormBuilderFieldDto {
    'uuid'?: string | null;
    'submitter_uuid'?: string | null;
    'name'?: string | null;
    'type'?: string | null;
    'required'?: boolean;
    'preferences'?: FormBuilderFieldPreferencesDto;
    'areas'?: Array<FormBuilderAreaDto> | null;
}
export interface FormBuilderFieldPreferencesDto {
    'fontSize'?: number | null;
    'fontType'?: string | null;
    'font'?: string | null;
    'color'?: string | null;
    'align'?: string | null;
    'vAlign'?: string | null;
    'format'?: string | null;
    'price'?: number | null;
    'currency'?: string | null;
    'mask'?: boolean | null;
}
export interface FormBuilderPreviewImageDto {
    'id'?: number | null;
    'name'?: string | null;
    'uuid'?: string | null;
    'record_type'?: string | null;
    'record_id'?: number | null;
    'blob_id'?: number | null;
    'created_at'?: string | null;
    'url'?: string | null;
    'filename'?: string | null;
    'metadata'?: { [key: string]: any | null; } | null;
}
export interface FormBuilderSaveDto {
    'id': number;
    'slug'?: string | null;
    'name': string;
    'external_id'?: string | null;
    'folder_id'?: number | null;
    'shared_link'?: boolean;
    'created_at'?: string;
    'updated_at'?: string;
    'author_id'?: number | null;
    'account_id'?: number | null;
    'archived_at'?: string | null;
    'source'?: string | null;
    'application_key'?: string | null;
    'preferences'?: { [key: string]: any | null; } | null;
    'variables_schema'?: { [key: string]: any | null; } | null;
    'schema'?: Array<FormBuilderSchemaDto> | null;
    'documents'?: Array<FormBuilderDocumentDto> | null;
    'submitters'?: Array<FormBuilderSubmitterDto> | null;
    'fields'?: Array<FormBuilderFieldDto> | null;
}
export interface FormBuilderSchemaDto {
    'attachment_uuid'?: string | null;
    'name'?: string | null;
}
export interface FormBuilderSubmitterDto {
    'uuid'?: string | null;
    'name'?: string | null;
}
export interface FormBuilderTokenRequestDto {
    'integrationEmail'?: string | null;
    'externalId'?: string | null;
    'name'?: string | null;
    'templateId'?: string | null;
    'documentUrls'?: Array<string> | null;
}
export interface FormDetectionResult {
    'fileName'?: string | null;
    'success'?: boolean;
    'error'?: string | null;
    'catalogStateFed'?: string | null;
    'catalogFormName'?: string | null;
    'catalogFullTitle'?: string | null;
    'detectedVariant'?: string | null;
    'hasSignatureFields'?: boolean;
    'signatureFieldCount'?: number;
    'fields'?: Array<FieldDetail> | null;
    'signerInfoCount'?: number;
    'signers'?: Array<SignerDetail> | null;
}
/**
 * Request model for granting access to a client
 */
export interface GrantAccessRequest {
    'userId'?: string;
}
/**
 * DTO for granting SMS consent (A2P 10DLC opt-in)
 */
export interface GrantSmsConsentDto {
    /**
     * How the consent is being given (e.g., \"AccountSettings\", \"Registration\", \"WebForm\")
     */
    'consentMethod': string;
    /**
     * User must acknowledge they agree to receive SMS messages. Set to true to confirm consent.
     */
    'acknowledgeSmsTerms': boolean;
}
/**
 * Response DTO for grouped comments endpoint - returns comments organized by their parent entity
 */
export interface GroupedCommentsDto {
    /**
     * Comments attached directly to the binder (not to a specific document or request)
     */
    'binderComments'?: Array<CommentDto> | null;
    /**
     * Comments grouped by document
     */
    'documentGroups'?: Array<EntityCommentGroupDto> | null;
    /**
     * Comments grouped by document request
     */
    'documentRequestGroups'?: Array<EntityCommentGroupDto> | null;
    /**
     * Total number of comments across all groups
     */
    'totalComments'?: number;
    /**
     * Total number of unread comments across all groups
     */
    'unreadComments'?: number;
}
export interface GroupedCommentsDtoApiResponse {
    'success'?: boolean;
    'data'?: GroupedCommentsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface GuidListApiResponse {
    'success'?: boolean;
    'data'?: Array<string> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Request DTO for client impersonation by Preparers/Admins. Allows staff to view the system as a specific user for support and testing purposes.
 */
export interface ImpersonateClientDto {
    'clientId': string;
    'userId': string;
}
/**
 * Response DTO for successful client impersonation. Contains limited-scope access token (30 min) and metadata about the impersonation session.
 */
export interface ImpersonateClientResponseDto {
    /**
     * JWT access token with client claims and impersonation metadata
     */
    'accessToken'?: string | null;
    /**
     * Token expiration time in seconds (1800 = 30 minutes)
     */
    'expiresIn'?: number;
    /**
     * Always true for impersonation sessions to indicate special token type
     */
    'isImpersonated'?: boolean;
    /**
     * ID of the preparer/admin who initiated the impersonation
     */
    'originalUserId'?: string;
    /**
     * Email of the preparer/admin who initiated the impersonation
     */
    'originalUserEmail'?: string | null;
    /**
     * ID of the client being impersonated
     */
    'impersonatedClientId'?: string;
    /**
     * ID of the user being impersonated within the client
     */
    'impersonatedUserId'?: string;
    'originalUserRole'?: UserRole;
}


export interface ImpersonateClientResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: ImpersonateClientResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum ImportAction {
    Created = 'created',
    Updated = 'updated',
    Skipped = 'skipped',
    Failed = 'failed'
}


export interface ImportClientDto {
    'clientId': string;
    'updateExisting'?: boolean;
    /**
     * Optional TaxId (SSN/EIN) to set on the client. If provided, overrides the value from CCH. Format: 9 digits (123456789) or with dashes (123-45-6789 for SSN, 12-3456789 for EIN)
     */
    'taxId'?: string | null;
    /**
     * Optional Spouse TaxId (SSN) to set on the client. If provided, overrides the value from CCH. Format: 9 digits (123456789) or with dashes (123-45-6789)
     */
    'spouseTaxId'?: string | null;
    /**
     * Array of client users to be added to this client during import
     */
    'clientUsers'?: Array<ImportClientUserDto> | null;
    /**
     * The full set of service lines (Tax, Audit, CAS) to enable for this client on import. When null (or omitted from the payload), service lines are left unchanged. When provided, the client\'s service lines are reconciled to exactly this set (an empty list removes all). CAS is accepted but not yet surfaced in the UI.
     */
    'serviceLines'?: Array<ServiceLine> | null;
}
export interface ImportClientResultDto {
    /**
     * Internal system client ID (GUID). Use this for navigation/API calls. Only populated on successful import (Created/Updated actions).
     */
    'id'?: string | null;
    /**
     * External CCH Axcess client identifier (e.g., \"76404\").
     */
    'cchClientId'?: string | null;
    /**
     * Client number stored in our system (same as CchClientId for CCH-imported clients).
     */
    'clientNumber'?: string | null;
    'clientName'?: string | null;
    'success'?: boolean;
    'error'?: string | null;
    'action'?: ImportAction;
    'validationWarnings'?: Array<string> | null;
}


export interface ImportClientResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ImportClientResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ImportClientUserDto {
    /**
     * Optional: Existing user ID to link to this client. If provided, the user will be linked instead of creating a new user. When UserId is provided, Name is ignored; Email and Phone (if supplied) may be used to update the linked user\'s contact details.
     */
    'userId'?: string | null;
    /**
     * Email address for the user (required when creating a new user)
     */
    'email'?: string | null;
    /**
     * Phone number for the user
     */
    'phone'?: string | null;
    'role': ClientUserRole;
    /**
     * Full name of the user (can be derived from SortName in CCH) Required when creating a new user, ignored when linking existing user.
     */
    'name'?: string | null;
    'spouseData'?: SpouseData;
    /**
     * When true, promotes as main contact. When null, auto-promotes if first user.
     */
    'isMainContact'?: boolean | null;
}


export interface ImportDocumentRequestRowError {
    'rowNumber'?: number;
    'descriptionPreview'?: string | null;
    'reason'?: string | null;
}
export interface ImportDocumentRequestsResultDto {
    'importedCount'?: number;
    'skippedCount'?: number;
    'errors'?: Array<ImportDocumentRequestRowError> | null;
}
export interface ImportDocumentRequestsResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ImportDocumentRequestsResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ImportMultipleClientsDto {
    'clientIds': Array<string>;
    'updateExisting'?: boolean;
    'continueOnError'?: boolean;
}
export interface ImportRequestFromBinderItemDto {
    'documentRequestId': string;
    /**
     * The client user who will see a confidential request. Required when the source request\'s user lost access; otherwise optional and replaces the source request\'s user. Ignored for requests that are not confidential.
     */
    'confidentialClientUserId'?: string | null;
}
export interface ImportRequestsFromBinderDto {
    'sourceBinderId': string;
    'items': Array<ImportRequestFromBinderItemDto>;
}
export interface ImportRequestsFromBinderResultDto {
    'importedCount'?: number;
}
export interface ImportRequestsFromBinderResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ImportRequestsFromBinderResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ImportResultDto {
    'totalClients'?: number;
    'importedCount'?: number;
    'updatedCount'?: number;
    'failedCount'?: number;
    'skippedCount'?: number;
    'results'?: Array<ImportClientResultDto> | null;
    'processingTime'?: string;
}
export interface ImportResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ImportResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Returned by the enqueue endpoint so the client can correlate SignalR events.
 */
export interface ImportZipQueuedDto {
    'operationId'?: string | null;
}
export interface ImportZipQueuedDtoApiResponse {
    'success'?: boolean;
    'data'?: ImportZipQueuedDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * A user with indirect access to a client via the multi-contact pattern. These users share an email or phone number with a user who has direct access.
 */
export interface IndirectClientAccessDto {
    'userId'?: string;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'systemRole'?: UserRole;
    'systemRoleDisplay'?: string | null;
    /**
     * Human-readable explanation of why this user has access. Example: \"Shares email (john@example.com) with John Doe\"
     */
    'accessReason'?: string | null;
    /**
     * The direct user whose contact info matched.
     */
    'matchedWithUserId'?: string;
    'matchedWithUserName'?: string | null;
    /**
     * The type of contact info that matched (Email, Phone, or Both).
     */
    'matchType'?: string | null;
    /**
     * The specific value that matched (the shared email or phone).
     */
    'matchedValue'?: string | null;
}


export interface Int32ApiResponse {
    'success'?: boolean;
    'data'?: number;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for job history information displayed on admin dashboard
 */
export interface JobHistoryDto {
    /**
     * Unique identifier for the job history record
     */
    'id'?: string;
    /**
     * Job name/identifier (e.g., \"external-client-sync\")
     */
    'jobName'?: string | null;
    /**
     * When the job last started
     */
    'lastStartedAt'?: string | null;
    /**
     * When the job last completed
     */
    'lastCompletedAt'?: string | null;
    /**
     * Current status: \"Success\", \"Failed\", \"InProgress\", \"Cancelled\", \"Never Run\"
     */
    'lastStatus'?: string | null;
    /**
     * Error message if the last run failed
     */
    'lastError'?: string | null;
    /**
     * Duration of last run in milliseconds
     */
    'lastDurationMs'?: number | null;
    /**
     * Human-readable duration
     */
    'lastDurationFormatted'?: string | null;
    /**
     * Metadata from last run (parsed from JSON)
     */
    'metadata'?: any | null;
    /**
     * When this job history record was created
     */
    'createdAt'?: string;
    /**
     * When this job history record was last updated
     */
    'updatedAt'?: string;
}
/**
 * Summary of all job statuses
 */
export interface JobStatusSummaryDto {
    /**
     * Total number of tracked jobs
     */
    'totalJobs'?: number;
    /**
     * Number of jobs currently running
     */
    'runningJobs'?: number;
    /**
     * Number of jobs that completed successfully
     */
    'successfulJobs'?: number;
    /**
     * Number of jobs that failed
     */
    'failedJobs'?: number;
    /**
     * List of all job history records
     */
    'jobs'?: Array<JobHistoryDto> | null;
}
export interface JobStatusSummaryDtoApiResponse {
    'success'?: boolean;
    'data'?: JobStatusSummaryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Jurisdiction-level signature status.
 */
export interface JurisdictionSignatureStatusDto {
    /**
     * Jurisdiction code.
     */
    'jurisdictionCode'?: string | null;
    /**
     * Jurisdiction name for display.
     */
    'jurisdictionName'?: string | null;
    /**
     * Whether all signatures for this jurisdiction are complete.
     */
    'isComplete'?: boolean;
    'status'?: ReturnStatus;
}



export enum JurisdictionType {
    Federal = 'federal',
    State = 'state',
    City = 'city',
    County = 'county',
    Miscellaneous = 'miscellaneous'
}


export interface K1ActivePushDto {
    'pushId'?: string;
    /**
     * Empty, with no copy id, client name or year, when the caller cannot open the destination client.
     */
    'destinationBinderId'?: string;
    /**
     * The destination binder\'s client, so a client viewer can switch to it before opening the binder. Null when hidden.
     */
    'destinationClientId'?: string | null;
    'destinationDocumentId'?: string | null;
    'destinationClientName'?: string | null;
    'destinationTaxYear'?: number;
    /**
     * The person the copy was pushed for, who may no longer hold the K-1.
     */
    'recipientName'?: string | null;
    'pushedByName'?: string | null;
    'pushedByRole'?: UserRole;
    'pushedAt'?: string;
    /**
     * \"Pushed to {client} {year} by {who}\".
     */
    'summary'?: string | null;
}


export interface K1ExtractedPartnerDto {
    'bookmarkName'?: string | null;
    'partnerName'?: string | null;
    'documentId'?: string;
    'startPage'?: number;
    'endPage'?: number;
}
export interface K1ExtractedPartnerDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<K1ExtractedPartnerDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface K1PushDestinationDto {
    'binderId'?: string;
    'binderName'?: string | null;
    'clientName'?: string | null;
    'taxYear'?: number;
    'stage'?: BinderStage;
    'recipientRole'?: ClientUserRole;
}


export interface K1PushDestinationsDto {
    'state'?: K1PushStateDto;
    'destinations'?: Array<K1PushDestinationDto> | null;
    /**
     * Explains an empty destination list, or null when there is at least one destination.
     */
    'emptyReason'?: string | null;
}
export interface K1PushDestinationsDtoApiResponse {
    'success'?: boolean;
    'data'?: K1PushDestinationsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface K1PushResultDto {
    'pushId'?: string;
    'destinationBinderId'?: string;
    'destinationDocumentId'?: string;
    /**
     * The open K-1 document request the copy was placed into, or null when it landed as a general upload.
     */
    'documentRequestId'?: string | null;
    'state'?: K1PushStateDto;
}
export interface K1PushResultDtoApiResponse {
    'success'?: boolean;
    'data'?: K1PushResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Whether an assigned K-1 can be pushed into the recipient\'s own binder, and where its live copy is if it already was.
 */
export interface K1PushStateDto {
    'assignmentId'?: string;
    'k1DocumentId'?: string;
    'recipientUserId'?: string;
    'partnerName'?: string | null;
    /**
     * \"Schedule K-1\", or \"Amended K-1 (round N)\" for a K-1 released in an amendment round.
     */
    'label'?: string | null;
    'amendmentRound'?: number;
    /**
     * True when the source binder is Complete and no live copy exists.
     */
    'canPush'?: boolean;
    /**
     * Why the push action is unavailable, or null when Op.ClientTaxSystem.Api.DTOs.K1.K1PushStateDto.CanPush is true.
     */
    'cannotPushReason'?: string | null;
    'activePush'?: K1ActivePushDto;
}
export interface K1PushStateDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<K1PushStateDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * The fate of a K-1\'s live pushed copy when its recipient changes. Either way the K-1 is freed for the new recipient.
 */

export enum K1PushedCopyAction {
    Keep = 'keep',
    Remove = 'remove'
}


export interface K1RecipientAssignmentDto {
    'id'?: string;
    'binderId'?: string;
    'k1DocumentId'?: string;
    'userId'?: string;
    'partnerName'?: string | null;
    'bookmarkName'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'createdAt'?: string;
    /**
     * Suggested download filename (e.g. \"ClientName_2025_K1_JohnDoe.pdf\"). Derived from the K1 document\'s DocumentName.
     */
    'suggestedFileName'?: string | null;
    /**
     * True when the system carried this assignment over from the prior year and nobody has edited it since.
     */
    'isCarriedOver'?: boolean;
    /**
     * The tax year this assignment was carried over from; null unless IsCarriedOver.
     */
    'carriedOverFromTaxYear'?: number | null;
    /**
     * Why the prior-year partner was judged the same partner.
     */
    'carryOverReason'?: string | null;
    /**
     * True while this K-1 has a copy in a recipient\'s tax binder or a push in progress; the destination is not disclosed here.
     */
    'hasLivePush'?: boolean;
}
export interface K1RecipientAssignmentDtoApiResponse {
    'success'?: boolean;
    'data'?: K1RecipientAssignmentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface K1RecipientAssignmentDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<K1RecipientAssignmentDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface K1StatusDocumentDto {
    'documentId'?: string;
    /**
     * The partner/entity slot this K-1 corresponds to (for labeling in the UI).
     */
    'partnerName'?: string | null;
    /**
     * Suggested download filename for this K-1 document. Format: {ClientName}_{TaxYear}_K1_{FirstName}{LastName}_{PartnerName}.pdf
     */
    'suggestedFileName'?: string | null;
}
export interface K1StatusDto {
    'isComplete'?: boolean;
    /**
     * True if this binder has any extracted K1 partner documents, regardless of whether the current user is a K1 recipient.
     */
    'hasK1Documents'?: boolean;
    /**
     * True when the current user holds no K-1 on this binder now but held one that was removed. Describes only the caller\'s own assignments.
     */
    'hasRemovedAssignment'?: boolean;
    /**
     * The current user\'s K-1 documents for this binder. A recipient may be assigned to more than one K-1 in the same binder. Populated only when the binder is complete; empty otherwise (and for non-recipient viewers such as the primary client or staff).
     */
    'documents'?: Array<K1StatusDocumentDto> | null;
}
export interface K1StatusDtoApiResponse {
    'success'?: boolean;
    'data'?: K1StatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface LeftoverAuditBinderFilesDto {
    'binderId'?: string;
    /**
     * The binder\'s client, from the file\'s path or the audit trail; null when neither recorded it.
     */
    'clientId'?: string | null;
    'clientName'?: string | null;
    /**
     * The binder\'s name from the audit trail, where it was recorded.
     */
    'binderName'?: string | null;
    /**
     * When the binder was deleted, from the audit trail, where it was recorded.
     */
    'deletedAt'?: string | null;
    'fileCount'?: number;
    'totalBytes'?: number;
}
/**
 * Read-only report of stored files left behind by audit binders deleted before deletes were soft. A file is listed only when nothing references it and its binder (from its storage path, or for a flat key from the audit trail\'s record of the file and its document) no longer exists and is recorded as an audit binder. Nothing is deleted.
 */
export interface LeftoverAuditBinderFilesReportDto {
    'generatedAt'?: string;
    'scannedFileCount'?: number;
    'leftoverFileCount'?: number;
    'leftoverTotalBytes'?: number;
    /**
     * The deleted audit binders the leftover files came from.
     */
    'binders'?: Array<LeftoverAuditBinderFilesDto> | null;
    'excluded'?: LeftoverExclusionCountsDto;
}
export interface LeftoverAuditBinderFilesReportDtoApiResponse {
    'success'?: boolean;
    'data'?: LeftoverAuditBinderFilesReportDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface LeftoverExclusionCountsDto {
    /**
     * Neither the path nor the audit trail tells which binder the file came from.
     */
    'unattributable'?: number;
    /**
     * The binder still exists (live, or deleted and restorable).
     */
    'binderExists'?: number;
    /**
     * Nothing records the binder as an audit binder.
     */
    'notAnAuditBinder'?: number;
    /**
     * A document, file, preprocessing row or share still references the file.
     */
    'referenced'?: number;
    /**
     * The purge has queued the file for deletion already.
     */
    'queuedByPurge'?: number;
}
/**
 * Link external client to imported client request
 */
export interface LinkExternalClientDto {
    'importedClientId': string;
}
/**
 * Response for list submissions API
 */
export interface ListSubmissionsResponseDto {
    /**
     * List of submissions
     */
    'data'?: Array<SubmissionSummaryDto> | null;
    'pagination'?: PaginationDto;
}
export interface ListSubmissionsResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: ListSubmissionsResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface LoginDto {
    'email': string;
    'password': string;
    'rememberMe'?: boolean;
}
export interface LoginResponseDto {
    'success'?: boolean;
    'message'?: string | null;
    'errorCode'?: string | null;
    'user'?: UserDto;
    'token'?: string | null;
    'refreshToken'?: string | null;
    'expiresAt'?: string;
    'requiresVerification'?: boolean;
    'verificationMethod'?: string | null;
    'clientId'?: string | null;
    'isFirstLogin'?: boolean;
}
export interface LoginResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: LoginResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum MaritalStatus {
    Single = 'single',
    MarriedFilingJointly = 'marriedFilingJointly',
    MarriedFilingSeparately = 'marriedFilingSeparately',
    HeadOfHousehold = 'headOfHousehold',
    QualifyingWidow = 'qualifyingWidow'
}


/**
 * Existing binder documents to mark as final deliverables, appended in this order.
 */
export interface MarkAuditBinderFinalDeliverablesDto {
    'documentIds': Array<string>;
}
/**
 * DTO for marking multiple notifications as read.
 */
export interface MarkNotificationsReadDto {
    'notificationIds': Array<string>;
}
/**
 * DTO for marking a voucher as paid (or un-marking with IsPaid = false)
 */
export interface MarkPaymentVoucherPaidDto {
    /**
     * True (default) marks the voucher paid; false clears the payment.
     */
    'isPaid'?: boolean;
    /**
     * When the payment was made. Only stamped on first mark (defaults to now) or when supplied; re-marking / editing an already-paid voucher keeps the original date unless this is set.
     */
    'paidAt'?: string | null;
    /**
     * Amount actually paid, if different from the scheduled amount. Null leaves the stored value unchanged; ignored (and cleared) when IsPaid is false.
     */
    'paidAmount'?: number | null;
    'paymentNotes'?: string | null;
}
export interface MarkSubmittedDto {
    'submissionNotes'?: string | null;
}
/**
 * DTO for marking a return as filed
 */
export interface MarkTaxReturnFiledDto {
    'filedAt'?: string | null;
    'eFileConfirmationNumber'?: string | null;
}
/**
 * DTO for marking a return as rejected
 */
export interface MarkTaxReturnRejectedDto {
    'rejectionReason'?: string | null;
}
/**
 * Represents a conflict where both users are assigned to the same client
 */
export interface MergeConflictDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'clientNumber'?: string | null;
    'survivingUserRole'?: ClientUserRole;
    'survivingUserRoleDisplay'?: string | null;
    'mergedUserRole'?: ClientUserRole;
    'mergedUserRoleDisplay'?: string | null;
    'resolvedRole'?: ClientUserRole;
    'resolvedRoleDisplay'?: string | null;
}


/**
 * Preview of what will happen when two users are merged
 */
export interface MergePreviewDto {
    'survivingUser'?: UserDto;
    'mergedUser'?: UserDto;
    /**
     * List of client conflicts where both users are assigned to the same client
     */
    'clientConflicts'?: Array<MergeConflictDto> | null;
    'statistics'?: MergeStatisticsDto;
}
export interface MergePreviewDtoApiResponse {
    'success'?: boolean;
    'data'?: MergePreviewDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Result of a completed merge operation
 */
export interface MergeResultDto {
    /**
     * Whether the merge was successful
     */
    'success'?: boolean;
    /**
     * The ID of the surviving user
     */
    'survivingUserId'?: string;
    /**
     * The ID of the user that was merged (now deactivated)
     */
    'mergedUserId'?: string;
    'statistics'?: MergeStatisticsDto;
    /**
     * The ID of the audit log entry created for this merge
     */
    'auditLogId'?: number;
    /**
     * Error message if the merge failed
     */
    'errorMessage'?: string | null;
}
export interface MergeResultDtoApiResponse {
    'success'?: boolean;
    'data'?: MergeResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Statistics about the merge operation
 */
export interface MergeStatisticsDto {
    /**
     * Number of client associations that will be transferred to the surviving user
     */
    'clientAssociationsToMerge'?: number;
    /**
     * Number of client associations where both users are linked (conflicts)
     */
    'clientConflicts'?: number;
    /**
     * Number of refresh tokens that will be deleted
     */
    'refreshTokensToDelete'?: number;
}
/**
 * Request DTO for merging two user accounts
 */
export interface MergeUsersDto {
    /**
     * The user ID that will survive the merge (keep this account)
     */
    'survivingUserId': string;
    /**
     * The user ID that will be merged into the surviving user (this account will be deactivated)
     */
    'mergedUserId': string;
}
/**
 * New signer information including signing URL
 */
export interface NewSignerInfoDto {
    'signerId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'signingUrl'?: string | null;
}

export enum NotificationActionType {
    DocumentUploaded = 'documentUploaded',
    DocumentApproved = 'documentApproved',
    DocumentRejected = 'documentRejected',
    DocumentRequested = 'documentRequested',
    LateDocumentUploaded = 'lateDocumentUploaded',
    DocumentAiProcessingCompleted = 'documentAiProcessingCompleted',
    DocumentFailedSecurityCheck = 'documentFailedSecurityCheck',
    CommentCreated = 'commentCreated',
    BinderCreated = 'binderCreated',
    BinderStageChanged = 'binderStageChanged',
    AuditBinderDeletionWarning = 'auditBinderDeletionWarning',
    BinderArchived = 'binderArchived',
    AuditBinderReleasedToClient = 'auditBinderReleasedToClient',
    AuditBinderStageChanged = 'auditBinderStageChanged',
    AuditBinderCommentReceived = 'auditBinderCommentReceived',
    AuditBinderDocumentApproved = 'auditBinderDocumentApproved',
    AuditBinderDocumentRejected = 'auditBinderDocumentRejected',
    AuditBinderDocumentRequested = 'auditBinderDocumentRequested',
    AuditBinderDocumentRequestOutcome = 'auditBinderDocumentRequestOutcome',
    AuditBinderFirmDocumentUploaded = 'auditBinderFirmDocumentUploaded',
    AuditBinderDocumentRequestNeedsAttention = 'auditBinderDocumentRequestNeedsAttention',
    AuditBinderDocumentFailedSecurityCheck = 'auditBinderDocumentFailedSecurityCheck',
    AuditBinderDocumentRequestReminder = 'auditBinderDocumentRequestReminder',
    AuditBinderClientCommented = 'auditBinderClientCommented',
    AuditBinderClientDocumentUploaded = 'auditBinderClientDocumentUploaded',
    AuditBinderRequestAwaitingRelease = 'auditBinderRequestAwaitingRelease',
    ClientSubmitted = 'clientSubmitted',
    ClientRequestedChanges = 'clientRequestedChanges',
    QuestionnaireCompleted = 'questionnaireCompleted',
    SignatureRequested = 'signatureRequested',
    SignatureCompleted = 'signatureCompleted',
    SignatureDeclined = 'signatureDeclined',
    SignatureReminder = 'signatureReminder',
    SignatureExpired = 'signatureExpired',
    CoSignerTurnToSign = 'coSignerTurnToSign',
    AllSignaturesCompleted = 'allSignaturesCompleted',
    TaxReturnReleased = 'taxReturnReleased',
    AmendedTaxReturnReleased = 'amendedTaxReturnReleased',
    TaxReturnRecalled = 'taxReturnRecalled',
    SignatureRequestCancelled = 'signatureRequestCancelled',
    EstimatedPaymentReminder = 'estimatedPaymentReminder',
    K1Ready = 'k1Ready',
    K1RecipientsCarriedOver = 'k1RecipientsCarriedOver',
    K1PushedToBinder = 'k1PushedToBinder',
    WelcomeEmail = 'welcomeEmail',
    PasswordReset = 'passwordReset',
    SecurityAlert = 'securityAlert',
    BinderLinkSent = 'binderLinkSent'
}



export enum NotificationAudience {
    Client = 'client',
    Preparer = 'preparer',
    System = 'system',
    Admin = 'admin'
}



export enum NotificationBatchStrategy {
    Immediate = 'immediate',
    Batched = 'batched',
    Scheduled = 'scheduled'
}



export enum NotificationChannel {
    Email = 'email',
    Sms = 'sms',
    Both = 'both'
}


/**
 * Summary of notification counts for dashboard display.
 */
export interface NotificationCountSummaryDto {
    'totalUnread'?: number;
    'highPriority'?: number;
    'byActionType'?: { [key: string]: number; } | null;
}
export interface NotificationCountSummaryDtoApiResponse {
    'success'?: boolean;
    'data'?: NotificationCountSummaryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum NotificationDeliveryChannel {
    None = 'none',
    Email = 'email',
    Sms = 'sms',
    EmailAndSms = 'emailAndSms',
    Realtime = 'realtime',
    EmailAndRealtime = 'emailAndRealtime',
    SmsAndRealtime = 'smsAndRealtime',
    All = 'all'
}



export enum NotificationEntityType {
    None = 'none',
    Document = 'document',
    DocumentRequest = 'documentRequest',
    Comment = 'comment',
    Binder = 'binder',
    Questionnaire = 'questionnaire',
    QuestionnaireResponse = 'questionnaireResponse',
    Signature = 'signature',
    ESignatureSubmission = 'eSignatureSubmission',
    User = 'user',
    Client = 'client'
}



export enum NotificationPriority {
    Low = 'low',
    Normal = 'normal',
    High = 'high',
    Critical = 'critical'
}


export interface ObjectApiResponse {
    'success'?: boolean;
    'data'?: any | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Activity stats for a single office
 */
export interface OfficeActivityDto {
    'officeId'?: string;
    'officeName'?: string | null;
    'bindersCreated'?: TimePeriodCountsDto;
    'sentForPreparation'?: TimePeriodCountsDto;
    'completed'?: TimePeriodCountsDto;
}
export interface OfficeDto {
    'id'?: string;
    'name'?: string | null;
    'clientCount'?: number;
    'createdAt'?: string;
    'updatedAt'?: string;
}
/**
 * Workflow timing stats for a single office
 */
export interface OfficeWorkflowTimingDto {
    'officeId'?: string;
    'officeName'?: string | null;
    'bindersCompleted'?: number;
    'timing'?: WorkflowTimingDto;
}
/**
 * Generic DTO for dropdown/filter options with ID and display name. Reusable across the system for offices, users, clients, etc.
 */
export interface OptionDto {
    /**
     * Unique identifier for the option
     */
    'id'?: string;
    /**
     * Display name for the option
     */
    'name'?: string | null;
    /**
     * Optional display order for custom sorting. When null, options are sorted alphabetically by Name. Lower values appear first (e.g., 0 before 10). Use case: Show \"Primary Office\" first regardless of alphabetical order.
     */
    'displayOrder'?: number | null;
    /**
     * Indicates if this option is active and should be shown in filters. Inactive options can be hidden from dropdowns without deleting database records. Defaults to true.
     */
    'isActive'?: boolean;
}
export interface OptionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<OptionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Result of analyzing an organizer PDF against an existing binder.
 */
export interface OrganizerAnalysisResultDto {
    'documentRequestsCreated'?: number;
    'documentRequestsSkippedDuplicate'?: number;
    'documentRequestsFailed'?: number;
    'engagementLetterExtracted'?: boolean;
    'engagementLetterAlreadyPresent'?: boolean;
    'engagementLetterDocumentId'?: string | null;
    'operationId'?: string | null;
}
export interface OrganizerAnalysisResultDtoApiResponse {
    'success'?: boolean;
    'data'?: OrganizerAnalysisResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Storage metrics for an individual binder
 */
export interface OrganizerStorageDto {
    /**
     * Unique identifier of the binder
     */
    'binderId'?: string;
    /**
     * Number of unique documents in this binder
     */
    'documentCount'?: number;
    /**
     * Total number of files across all documents
     */
    'fileCount'?: number;
    /**
     * Total size of all files in this binder (bytes)
     */
    'totalSizeBytes'?: number;
}
/**
 * Result of orphan file cleanup operation with detailed statistics
 */
export interface OrphanFileCleanupResult {
    /**
     * Timestamp when the cleanup operation started
     */
    'startedAt'?: string;
    /**
     * Timestamp when the cleanup operation completed
     */
    'completedAt'?: string;
    /**
     * Duration of the cleanup operation
     */
    'duration'?: string;
    /**
     * Whether the cleanup was run in dry-run mode (no actual deletions)
     */
    'isDryRun'?: boolean;
    /**
     * Total number of files scanned
     */
    'filesScanned'?: number;
    /**
     * Number of orphaned files detected
     */
    'orphansDetected'?: number;
    /**
     * Number of files successfully deleted (0 in dry-run mode)
     */
    'filesDeleted'?: number;
    /**
     * Number of deletion failures
     */
    'deletionFailures'?: number;
    /**
     * Number of metadata sidecar files deleted
     */
    'metadataFilesDeleted'?: number;
    /**
     * Total size of deleted files in bytes
     */
    'bytesFreed'?: number;
    /**
     * List of orphaned file paths detected
     */
    'orphanedFiles'?: Array<string> | null;
    /**
     * Errors encountered during cleanup
     */
    'errors'?: Array<string> | null;
    /**
     * Whether the operation completed successfully
     */
    'success'?: boolean;
}
export interface OrphanFileCleanupResultApiResponse {
    'success'?: boolean;
    'data'?: OrphanFileCleanupResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Represents an orphaned file with metadata for cleanup decision
 */
export interface OrphanedFileInfo {
    /**
     * Storage key or file path
     */
    'storageKey'?: string | null;
    /**
     * Full file path (for local storage)
     */
    'filePath'?: string | null;
    /**
     * File size in bytes
     */
    'sizeBytes'?: number;
    /**
     * File creation date
     */
    'createdAt'?: string;
    /**
     * File last modified date
     */
    'lastModifiedAt'?: string;
    /**
     * Age of the file in days
     */
    'ageInDays'?: number;
    /**
     * Whether this is a metadata sidecar file (.json)
     */
    'isMetadataFile'?: boolean;
    /**
     * Reason why this file is considered orphaned
     */
    'orphanReason'?: string | null;
}
export interface OrphanedFileInfoListApiResponse {
    'success'?: boolean;
    'data'?: Array<OrphanedFileInfo> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Represents a detected boundary between documents in a multi-page PDF. A boundary is where the form type changes from one page to the next.
 */
export interface PageBoundaryDto {
    /**
     * Page number where the boundary occurs (1-indexed) This is the first page of the new document.
     */
    'pageNumber'?: number;
    /**
     * Form type detected on the previous page
     */
    'previousFormType'?: string | null;
    /**
     * Form type detected on this page (new document starts here)
     */
    'newFormType'?: string | null;
    /**
     * Confidence in this boundary detection (0.0 to 1.0)
     */
    'confidence'?: number;
    /**
     * Reason for the boundary detection Examples: - \"Form type changed from W-2 to 1099-DIV\" - \"New document detected (high confidence)\" - \"Page count exceeds expected for Schedule-C\"
     */
    'reason'?: string | null;
    /**
     * Whether this boundary is recommended for splitting False if forms are known multi-page and within expected count
     */
    'recommendSplit'?: boolean;
}
/**
 * Container for all per-page default configurations.
 */
export interface PageDefaultsDto {
    'dashboard'?: DashboardPageDefaultsDto;
    'clients'?: ClientPageDefaultsDto;
    'binders'?: BinderPageDefaultsDto;
    'adminDashboard'?: AdminDashboardPageDefaultsDto;
    'auditAdminDashboard'?: AdminDashboardPageDefaultsDto;
    'users'?: UserPageDefaultsDto;
    'accessRequests'?: AccessRequestPageDefaultsDto;
}
/**
 * Suggestion for a group of pages that should be saved as a single document. Based on detected form type and page boundaries.
 */
export interface PageGroupSuggestionDto {
    /**
     * Starting page number (1-indexed)
     */
    'startPage'?: number;
    /**
     * Ending page number (1-indexed, inclusive)
     */
    'endPage'?: number;
    /**
     * Number of pages in this group
     */
    'pageCount'?: number;
    /**
     * Detected form type for this group (e.g., \"W-2\", \"8879\", \"KY-740\")
     */
    'formType'?: string | null;
    /**
     * AI confidence in the form type detection (0.0 to 1.0)
     */
    'confidence'?: number;
    /**
     * Suggested document name for this group Example: \"Pages 1-2: 2024 W-2 from ABC Corp\"
     */
    'suggestedDocumentName'?: string | null;
    'suggestedDocumentType'?: DocumentType;
    /**
     * Whether this is a known multi-page form (true) or a single-page form (false)
     */
    'isKnownMultiPageForm'?: boolean;
    /**
     * Expected page count for this form type (null if unknown)
     */
    'expectedPageCount'?: number | null;
    /**
     * Whether the detected page count matches the expected count
     */
    'pageCountMatchesExpected'?: boolean;
    /**
     * Additional metadata about the detected form
     */
    'metadata'?: { [key: string]: string | null; } | null;
}


/**
 * Result of analyzing a PDF for intelligent page splitting. Contains suggested page groupings based on form type detection.
 */
export interface PageSplittingResultDto {
    /**
     * Total number of pages in the PDF
     */
    'totalPages'?: number;
    /**
     * Suggested page groupings for separate documents
     */
    'suggestedGroups'?: Array<PageGroupSuggestionDto> | null;
    /**
     * Form type detected on each page (page number -> form type)
     */
    'pageFormTypes'?: { [key: string]: string | null; } | null;
    /**
     * Detected boundaries where form type changes
     */
    'detectedBoundaries'?: Array<PageBoundaryDto> | null;
    /**
     * Overall confidence in the splitting suggestions (0.0 to 1.0)
     */
    'overallConfidence'?: number;
    /**
     * Whether automatic splitting is recommended based on confidence
     */
    'recommendAutoSplit'?: boolean;
    /**
     * Time taken to analyze the PDF (milliseconds)
     */
    'analysisTimeMs'?: number;
    /**
     * Any warnings or notes about the analysis
     */
    'warnings'?: Array<string> | null;
}
export interface PageSplittingResultDtoApiResponse {
    'success'?: boolean;
    'data'?: PageSplittingResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Pagination information for API responses
 */
export interface PaginationDto {
    /**
     * Total number of items
     */
    'count'?: number;
    /**
     * Next pagination cursor
     */
    'next'?: number | null;
    /**
     * Previous pagination cursor
     */
    'prev'?: number | null;
}
export interface PaginationInfo {
    'page'?: number;
    'pageSize'?: number;
    'totalCount'?: number;
    'totalPages'?: number;
    'hasNextPage'?: boolean;
    'hasPreviousPage'?: boolean;
}
/**
 * Activity stats for a single partner
 */
export interface PartnerActivityDto {
    'partnerId'?: string;
    'partnerName'?: string | null;
    'bindersCreated'?: TimePeriodCountsDto;
    'sentForPreparation'?: TimePeriodCountsDto;
    'completed'?: TimePeriodCountsDto;
}
/**
 * Workflow timing stats for a single partner
 */
export interface PartnerWorkflowTimingDto {
    'partnerId'?: string;
    'partnerName'?: string | null;
    'bindersCompleted'?: number;
    'timing'?: WorkflowTimingDto;
}
/**
 * DTO for enabling reminder on a voucher
 */
export interface PaymentVoucherReminderOptInDto {
    'reminderEnabled'?: boolean;
    'reminderDaysPrior'?: number;
}
/**
 * PDF conversion configuration settings for admin inspection
 */
export interface PdfConversionConfigDto {
    /**
     * Current environment name (Development, Production, etc.)
     */
    'environment'?: string | null;
    /**
     * Whether PDF to image optimization is enabled for Claude API
     */
    'useImageOptimization'?: boolean;
    /**
     * DPI resolution for PDF rendering (higher = better quality, larger file size)
     */
    'imageDpi'?: number;
    /**
     * JPEG compression quality (1-100, higher = better quality, larger file size)
     */
    'imageQuality'?: number;
    /**
     * Maximum PDF file size in bytes for image conversion
     */
    'maxPdfSizeBytes'?: number;
    /**
     * Maximum number of pages to convert per PDF
     */
    'maxPages'?: number;
    /**
     * Maximum number of concurrent page conversions when processing multi-page PDFs
     */
    'maxConcurrentConversions'?: number;
    /**
     * Timeout for individual page conversion in seconds
     */
    'pageConversionTimeoutSeconds'?: number;
}
export interface PdfConversionConfigDtoApiResponse {
    'success'?: boolean;
    'data'?: PdfConversionConfigDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Result of a phone number lookup operation, including line type and carrier information. Used to determine if a phone number is mobile, landline, or VoIP for SMS delivery optimization.
 */
export interface PhoneLookupResult {
    /**
     * Indicates whether the phone lookup was successful.
     */
    'success'?: boolean;
    /**
     * The phone number that was looked up, in E.164 format (e.g., +15551234567).
     */
    'phoneNumber'?: string | null;
    /**
     * The type of phone line for the number. Common values: \"mobile\", \"landline\", \"fixedVoip\", \"nonFixedVoip\", \"tollFree\", \"unknown\".
     */
    'lineType'?: string | null;
    /**
     * The name of the carrier or service provider for the phone number. May be null if carrier information is unavailable.
     */
    'carrierName'?: string | null;
    /**
     * Error message if the lookup failed. Null if successful.
     */
    'errorMessage'?: string | null;
    /**
     * Computed property that returns true if the line type indicates a mobile phone. This is the primary indicator for whether SMS delivery is likely to succeed.
     */
    'isMobile'?: boolean;
}
export interface PhoneLookupResultApiResponse {
    'success'?: boolean;
    'data'?: PhoneLookupResult;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Response DTO for phone verification operations
 */
export interface PhoneVerificationResponseDto {
    /**
     * Whether the operation was successful
     */
    'success'?: boolean;
    /**
     * Human-readable message describing the result
     */
    'message'?: string | null;
    /**
     * The phone number that was verified (masked for security)
     */
    'phoneNumber'?: string | null;
    /**
     * Whether the phone number is now verified
     */
    'phoneNumberVerified'?: boolean;
}
export interface PhoneVerificationResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: PhoneVerificationResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Represents a possible duplicate user account found by matching email or phone number
 */
export interface PossibleDuplicateDto {
    'id'?: string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'role'?: UserRole;
    'roleDisplay'?: string | null;
    'isActive'?: boolean;
    'createdAt'?: string;
    'lastLoginAt'?: string | null;
    /**
     * Indicates why this user was flagged as a duplicate: \"Email\", \"Phone\", or \"Both\"
     */
    'matchReason'?: string | null;
    /**
     * Total number of clients this user is assigned to
     */
    'clientCount'?: number;
    /**
     * List of client associations for this duplicate user
     */
    'clientAssociations'?: Array<DuplicateClientAssociationDto> | null;
}


export interface PossibleDuplicateDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<PossibleDuplicateDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for preparing multiple documents for signature
 */
export interface PrepareForSignatureDto {
    'documentIds': Array<string>;
    'clientName': string;
    'clientEmail': string;
    'signerName': string;
    'signerEmail': string;
    'overrideExisting'?: boolean;
    'spouseName'?: string | null;
    'spouseEmail'?: string | null;
    'sendEmail'?: boolean;
    'sendSms'?: boolean;
    'clientPhone'?: string | null;
}
/**
 * Result of bulk prepare-for-signature operation
 */
export interface PrepareForSignatureResultDto {
    'totalRequested'?: number;
    'successful'?: number;
    'failed'?: number;
    'results'?: Array<DocumentSignatureResultDto> | null;
}
export interface PrepareForSignatureResultDtoApiResponse {
    'success'?: boolean;
    'data'?: PrepareForSignatureResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Activity stats for a single preparer
 */
export interface PreparerActivityDto {
    'preparerId'?: string;
    'preparerName'?: string | null;
    'bindersCreated'?: TimePeriodCountsDto;
    'sentForPreparation'?: TimePeriodCountsDto;
    'completed'?: TimePeriodCountsDto;
}
/**
 * Workflow timing stats for a single preparer
 */
export interface PreparerWorkflowTimingDto {
    'preparerId'?: string;
    'preparerName'?: string | null;
    'bindersCompleted'?: number;
    'timing'?: WorkflowTimingDto;
}
export interface PreprocessedDocumentDto {
    'id'?: string;
    'documentName'?: string | null;
    'startPage'?: number;
    'endPage'?: number;
    'pageCount'?: number;
    'requiresSignature'?: boolean;
    'type'?: DocumentType;
    'isIncluded'?: boolean;
    'bookmarkName'?: string | null;
    'thumbnailUrl'?: string | null;
    'signatureTemplateId'?: string | null;
    'suggestedFields'?: Array<SuggestedSignatureFieldDto> | null;
}


export interface PreprocessedDocumentDtoApiResponse {
    'success'?: boolean;
    'data'?: PreprocessedDocumentDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface PreviewRequestDto {
    'pdfBase64': string;
}
export interface ProblemDetails {
    [key: string]: any;

    'type'?: string | null;
    'title'?: string | null;
    'status'?: number | null;
    'detail'?: string | null;
    'instance'?: string | null;
}
export interface ProcessedDocumentDto {
    'documentId'?: string;
    'documentName'?: string | null;
    'wasFinalized'?: boolean;
    'signatureSubmissionCreated'?: boolean;
    'signatureSubmissionId'?: string | null;
    'signingUrl'?: string | null;
    'error'?: string | null;
}

export enum ProcessingStatus {
    InProgress = 'inProgress',
    Completed = 'completed',
    Failed = 'failed',
    Cancelled = 'cancelled'
}


/**
 * Metadata shown on the public (unauthenticated) shared-document landing page. Deliberately omits the storage key and any sender PII beyond a display name.
 */
export interface PublicExternalDocumentShareDto {
    /**
     * Name of the zip bundle the recipient will download.
     */
    'fileName'?: string | null;
    'fileSize'?: number;
    /**
     * How many individual documents are inside the zip bundle.
     */
    'fileCount'?: number;
    /**
     * Display name of the staff member who sent the document (e.g. \"Jane Smith\").
     */
    'senderName'?: string | null;
    /**
     * Optional message the sender included for the recipient.
     */
    'message'?: string | null;
    'expiresAt'?: string;
    'status'?: ExternalDocumentShareStatus;
    /**
     * True when the link has expired (recipient can no longer download).
     */
    'isExpired'?: boolean;
}


export interface PublicExternalDocumentShareDtoApiResponse {
    'success'?: boolean;
    'data'?: PublicExternalDocumentShareDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface PushK1Request {
    'destinationBinderId': string;
}

export enum QuestionType {
    Text = 'text',
    LongText = 'longText',
    Number = 'number',
    Date = 'date',
    Boolean = 'boolean',
    SingleChoice = 'singleChoice',
    MultipleChoice = 'multipleChoice',
    Dropdown = 'dropdown',
    Email = 'email',
    Phone = 'phone',
    Currency = 'currency'
}


export interface QuestionnaireDto {
    'id'?: string;
    'title'?: string | null;
    'description'?: string | null;
    'taxYear'?: number;
    'isActive'?: boolean;
    'isRequired'?: boolean;
    'sortOrder'?: number;
    'createdById'?: string;
    'createdByName'?: string | null;
    'publishedDate'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'questions'?: Array<QuestionnaireQuestionDto> | null;
    'responseCount'?: number;
    'completedResponseCount'?: number;
}
export interface QuestionnaireDtoApiResponse {
    'success'?: boolean;
    'data'?: QuestionnaireDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface QuestionnaireDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<QuestionnaireDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface QuestionnaireDtoPaginatedResponse {
    'items'?: Array<QuestionnaireDto> | null;
    'pagination'?: PaginationInfo;
}
export interface QuestionnaireDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: QuestionnaireDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Pre-fill data for tax questionnaires aggregated from client profile. Combines basic client information with spouse, dependents, and banking details.
 */
export interface QuestionnairePreFillDataDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'address1'?: string | null;
    'address2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'maritalStatus'?: MaritalStatus;
    'maritalStatusDisplay'?: string | null;
    'dateOfBirth'?: string | null;
    'ssn'?: string | null;
    'spouse'?: ClientSpouseDto;
    'dependents'?: Array<ClientDependentDto> | null;
    'preferredRefundAccount'?: ClientBankAccountDto;
    'preferredPaymentAccount'?: ClientBankAccountDto;
    'priorYearEstimatedPayments'?: Array<EstimatedPaymentPreFillDto> | null;
    'taxYear'?: number | null;
    'lastUpdated'?: string | null;
}


export interface QuestionnairePreFillDataDtoApiResponse {
    'success'?: boolean;
    'data'?: QuestionnairePreFillDataDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface QuestionnaireQuestionDto {
    'id'?: string;
    'questionnaireId'?: string;
    'question'?: string | null;
    'description'?: string | null;
    'questionType'?: QuestionType;
    'questionTypeDisplayName'?: string | null;
    'options'?: Array<string> | null;
    'isRequired'?: boolean;
    'sortOrder'?: number;
    'validationRules'?: { [key: string]: any | null; } | null;
}


/**
 * DTO for questionnaire response details (GET responses)
 */
export interface QuestionnaireResponseDto {
    'id'?: string;
    'binderId'?: string;
    'binderName'?: string | null;
    'responseData'?: string | null;
    'status'?: QuestionnaireStatus;
    'statusDisplayName'?: string | null;
    'submittedAt'?: string | null;
    'reviewedByUserId'?: string | null;
    'reviewedByName'?: string | null;
    'reviewedAt'?: string | null;
    'reviewComment'?: string | null;
    'version'?: number;
    'createdAt'?: string;
    'createdById'?: string;
    'createdByName'?: string | null;
}


export interface QuestionnaireResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: QuestionnaireResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface QuestionnaireResponseDtoPaginatedResponse {
    'items'?: Array<QuestionnaireResponseDto> | null;
    'pagination'?: PaginationInfo;
}
export interface QuestionnaireResponseDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: QuestionnaireResponseDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum QuestionnaireStatus {
    Draft = 'draft',
    Submitted = 'submitted'
}


/**
 * Request DTO for recalling a released tax return.
 */
export interface RecallReturnDto {
    /**
     * Reason for recalling the tax return (required for audit trail)
     */
    'reason': string;
}
/**
 * Result of recalling a released tax return.
 */
export interface RecallReturnResultDto {
    /**
     * The binder ID that was recalled
     */
    'binderId'?: string;
    /**
     * Timestamp when the recall occurred
     */
    'recalledAt'?: string;
    /**
     * New binder stage after recall
     */
    'newStage'?: string | null;
    /**
     * Number of bundle documents that were soft-deleted
     */
    'documentsDeleted'?: number;
    /**
     * Whether the DocuSeal signature submission was archived
     */
    'submissionArchived'?: boolean;
    /**
     * List of jurisdiction codes affected by the recall
     */
    'jurisdictionsAffected'?: Array<string> | null;
    /**
     * Whether any signatures had already been completed before recall
     */
    'hadSignatures'?: boolean;
    /**
     * Warning message if signatures were already completed
     */
    'warningMessage'?: string | null;
}
export interface RecallReturnResultDtoApiResponse {
    'success'?: boolean;
    'data'?: RecallReturnResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface RecentActivityDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'activityType'?: string | null;
    'activityDescription'?: string | null;
    'activityIcon'?: string | null;
    'activityDate'?: string;
    'timeAgo'?: string | null;
}
export interface RecentActivityDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<RecentActivityDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface RecentClientDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'companyName'?: string | null;
    'initials'?: string | null;
    'lastInteraction'?: string;
    'timeAgo'?: string | null;
    'status'?: string | null;
    'statusColor'?: string | null;
}
export interface RecentClientDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<RecentClientDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface RefreshTokenDto {
    'refreshToken': string;
}
export interface ReleaseDocumentRequestsDto {
    'documentRequestIds': Array<string>;
}
export interface ReleaseDocumentRequestsResultDto {
    /**
     * IDs of requests that were released to the client (and notified).
     */
    'releasedRequestIds'?: Array<string> | null;
    /**
     * Requests that were skipped, with the reason why.
     */
    'skipped'?: Array<ReleaseSkippedItemDto> | null;
    'releasedCount'?: number;
    'skippedCount'?: number;
}
export interface ReleaseDocumentRequestsResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ReleaseDocumentRequestsResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface ReleaseSkippedItemDto {
    'documentRequestId'?: string;
    'reason'?: string | null;
}
/**
 * Status of a released binder
 */
export interface ReleaseStatusDto {
    /**
     * The binder ID
     */
    'binderId'?: string;
    /**
     * Whether the binder has been released to client
     */
    'isReleased'?: boolean;
    /**
     * When the binder was released
     */
    'releasedAt'?: string | null;
    /**
     * Name of user who released the binder
     */
    'releasedBy'?: string | null;
    /**
     * Current signing status
     */
    'signingStatus'?: string | null;
    /**
     * Number of signatures completed
     */
    'signaturesCompleted'?: number;
    /**
     * Total signatures required
     */
    'signaturesRequired'?: number;
}
export interface ReleaseStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: ReleaseStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Request DTO for releasing returns to client. Triggers signature requests for all 8879 forms and Direct Deposit Report.
 */
export interface ReleaseToClientDto {
    /**
     * Optional custom message to include in client notification
     */
    'customMessage'?: string | null;
}
/**
 * Result of releasing returns to client.
 */
export interface ReleaseToClientResultDto {
    /**
     * The binder ID that was released
     */
    'binderId'?: string;
    /**
     * Timestamp when released
     */
    'releasedAt'?: string;
    /**
     * DocuSeal submission ID for the bundle signature (all 8879s)
     */
    'bundleSignatureSubmissionId'?: string | null;
    /**
     * DocuSeal submission ID for Direct Deposit Report (null if not present)
     */
    'directDepositSignatureSubmissionId'?: string | null;
    /**
     * List of jurisdiction codes included in the release
     */
    'jurisdictionsIncluded'?: Array<string> | null;
    /**
     * Primary signing URL for the client
     */
    'signingUrl'?: string | null;
    /**
     * Separate DocuSeal submission ID for the engagement letter (null if no EL in bundle)
     */
    'engagementLetterSignatureSubmissionId'?: string | null;
    /**
     * Separate signing URL for the engagement letter (null if no EL in bundle)
     */
    'engagementLetterSigningUrl'?: string | null;
    /**
     * Number of notifications sent to client
     */
    'notificationsSent'?: number;
    /**
     * New binder stage after release
     */
    'newStage'?: string | null;
    /**
     * Signature-required documents that were EXCLUDED from the DocuSeal submission because no signature fields could be detected (no field config matched). They remain Pending — the binder cannot reach EfileReady until they are re-sent (after a field config is added) or handled manually.
     */
    'droppedDocuments'?: Array<BundleDroppedDocumentDto> | null;
}
export interface ReleaseToClientResultDtoApiResponse {
    'success'?: boolean;
    'data'?: ReleaseToClientResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Outcome of a signature-request removal.
 */
export interface RemoveSignatureRequestResultDto {
    /**
     * The document the request belonged to.
     */
    'documentId'?: string;
    /**
     * Name of that document, for the confirmation message.
     */
    'documentName'?: string | null;
    /**
     * True when the document was soft-deleted rather than kept unsigned.
     */
    'documentRemoved'?: boolean;
    /**
     * False when the provider didn\'t confirm. Our own surface is closed either way, but a saved signing URL may still work, so don\'t report a clean success.
     */
    'providerCancellationConfirmed'?: boolean;
    /**
     * Whether a cancellation notice was actually sent to the signers.
     */
    'signersNotified'?: boolean;
}
export interface RemoveSignatureRequestResultDtoApiResponse {
    'success'?: boolean;
    'data'?: RemoveSignatureRequestResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Every current final deliverable of the binder, in the new display order.
 */
export interface ReorderAuditBinderFinalDeliverablesDto {
    'documentIds': Array<string>;
}
/**
 * Response after replacing a document in an e-signature workflow
 */
export interface ReplaceDocumentResponseDto {
    'success'?: boolean;
    'newDocumentId'?: string;
    'newSubmissionId'?: string | null;
    'replacedDocumentId'?: string;
    'notificationsSent'?: boolean;
    'signersNotified'?: number;
}
export interface ReplaceDocumentResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: ReplaceDocumentResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Request to replace a signer in an active submission
 */
export interface ReplaceSignerDto {
    /**
     * User ID of the new signer (must have access to the client)
     */
    'newSignerUserId'?: string;
    /**
     * Reason for replacing the signer (required for audit trail)
     */
    'reason'?: string | null;
    /**
     * Whether to send a notification to the new signer
     */
    'sendNotification'?: boolean;
}
/**
 * Response after replacing a signer
 */
export interface ReplaceSignerResponseDto {
    'success'?: boolean;
    'previousSigner'?: SignerInfoDto;
    'newSigner'?: NewSignerInfoDto;
    'notificationSent'?: boolean;
}
export interface ReplaceSignerResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: ReplaceSignerResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for requesting signature on bundle-level 8879 forms. Supports signing all 8879 forms in the bundle with a single DocuSeal submission.
 */
export interface RequestBundleSignatureDto {
    /**
     * Whether to send the signature request immediately. If false, just prepares the document but doesn\'t send.
     */
    'sendImmediately'?: boolean;
    /**
     * Optional custom message for the signature request email.
     */
    'customMessage'?: string | null;
    /**
     * Optional list of jurisdiction codes to include. If empty or null, includes all jurisdictions with 8879 forms.
     */
    'jurisdictionCodes'?: Array<string> | null;
}
/**
 * Request DTO for when a client requests changes to their tax return during FinalClientReview. This action transitions the binder to ClientRequestsChanges stage.
 */
export interface RequestChangesDto {
    /**
     * Required reason for requesting changes. This will be saved as a comment on the binder and used to notify the preparer.
     */
    'reason': string;
}
export interface RequestPasswordResetDto {
    'email': string;
}
export interface ResetPasswordDto {
    'email'?: string | null;
    'token'?: string | null;
    'newPassword'?: string | null;
    'confirmPassword'?: string | null;
}
/**
 * DTO for resetting page defaults. If PageKey is provided, only that page\'s defaults are cleared. If omitted, all page defaults are reset.
 */
export interface ResetUserSettingDto {
    /**
     * Optional page key to reset: \"dashboard\", \"clients\", \"binders\", \"adminDashboard\", \"auditAdminDashboard\", \"users\", \"accessRequests\". If null/empty, all page defaults are reset.
     */
    'pageKey'?: string | null;
}

export enum ReturnCopyType {
    ClientCopy = 'clientCopy',
    GovernmentCopy = 'governmentCopy',
    K1 = 'k1'
}


/**
 * Every return round recorded against a binder, oldest first. Drives both the preparer\'s original-return history and the client\'s permanent download list.
 */
export interface ReturnHistoryDto {
    'binderId'?: string;
    /**
     * Whether the binder has more than one round, so rounds need Original/Amended labels
     */
    'hasAmendmentHistory'?: boolean;
    'rounds'?: Array<ReturnHistoryRoundDto> | null;
}
export interface ReturnHistoryDtoApiResponse {
    'success'?: boolean;
    'data'?: ReturnHistoryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * One jurisdiction within a return round.
 */
export interface ReturnHistoryJurisdictionDto {
    'id'?: string;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'status'?: ReturnStatus;
    'isAmended'?: boolean;
    /**
     * The jurisdiction in the prior round this one amends
     */
    'originalReturnId'?: string | null;
    'allSignaturesComplete'?: boolean;
    'filedAt'?: string | null;
    'acceptedAt'?: string | null;
}


/**
 * One return round: a bundle, its downloadable copies, and its jurisdictions.
 */
export interface ReturnHistoryRoundDto {
    /**
     * The round\'s bundle. Only the active round has one; earlier rounds are identified by sequence
     */
    'bundleId'?: string | null;
    /**
     * Amendment round (0 for the binder\'s original return)
     */
    'amendmentSequence'?: number;
    'isAmended'?: boolean;
    /**
     * Whether this is the round the binder\'s workflow currently acts on
     */
    'isActive'?: boolean;
    'isProcessed'?: boolean;
    'processedAt'?: string | null;
    /**
     * Document holding this round\'s client copy PDF
     */
    'clientCopyDocumentId'?: string | null;
    /**
     * Size in bytes of the client copy, so a round describes its own download without a document list
     */
    'clientCopySizeBytes'?: number | null;
    /**
     * When the client copy was created
     */
    'clientCopyCreatedAt'?: string | null;
    /**
     * Document holding this round\'s government copy PDF
     */
    'governmentCopyDocumentId'?: string | null;
    /**
     * Document holding this round\'s combined signed package, once signing completed
     */
    'signedDocumentsDocumentId'?: string | null;
    'jurisdictions'?: Array<ReturnHistoryJurisdictionDto> | null;
}

export enum ReturnStatus {
    Pending = 'pending',
    ReadyForReview = 'readyForReview',
    AwaitingSignature = 'awaitingSignature',
    Signed = 'signed',
    Filed = 'filed',
    Accepted = 'accepted',
    Rejected = 'rejected'
}


export interface ReviewAccessRequestDto {
    'status': AccessRequestStatus;
    'reviewerNotes'?: string | null;
}


export interface ReviewDocumentDto {
    'action': DocumentReviewAction;
    'reviewNotes'?: string | null;
    'rejectionReason'?: string | null;
}


/**
 * Request DTO for reviewing a document with approval or rejection Client Binder Document Management
 */
export interface ReviewDocumentRequest {
    /**
     * Review status: \"approved\" or \"rejected\"
     */
    'status': string;
    /**
     * Review comment from preparer (required if status is \"rejected\")
     */
    'comment'?: string | null;
}
export interface ReviewDocumentRequestDto {
    'action': DocumentRequestReviewAction;
    'reviewNotes'?: string | null;
    'rejectionReason'?: string | null;
    'requiresResubmission'?: boolean;
}


/**
 * DTO for revoking SMS consent (A2P 10DLC opt-out)
 */
export interface RevokeSmsConsentDto {
    /**
     * Optional reason for opting out
     */
    'reason'?: string | null;
}
/**
 * Request DTO for sending a binder back to the client from ClientSubmitted or InReview stage. This action transitions the binder back to Open stage and notifies the client.
 */
export interface SendBackToClientDto {
    /**
     * Required reason for sending the binder back to the client. This will be included in the email notification and saved as a comment on the binder.
     */
    'reason': string;
}
/**
 * Request to send reminders to all pending signers
 */
export interface SendBulkReminderDto {
    /**
     * Optional custom message to include in the reminders
     */
    'message'?: string | null;
    /**
     * Whether to skip signers who were recently reminded (within cooldown period)
     */
    'skipRecentlyReminded'?: boolean;
}
/**
 * Response after sending bulk reminders
 */
export interface SendBulkReminderResponseDto {
    'success'?: boolean;
    'remindersAttempted'?: number;
    'remindersSent'?: number;
    'remindersSkipped'?: number;
    'results'?: Array<SignerReminderResultDto> | null;
}
export interface SendBulkReminderResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SendBulkReminderResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SendDocumentRequestReminderDto {
    /**
     * Optional note from staff, included in the reminder as written.
     */
    'message'?: string | null;
}
/**
 * DTO for requesting email verification code
 */
export interface SendEmailVerificationDto {
    /**
     * Optional email address to verify. If not provided, uses the user\'s current email.
     */
    'email'?: string | null;
}
/**
 * DTO for requesting phone verification code
 */
export interface SendPhoneVerificationDto {
    /**
     * Optional phone number to verify. If not provided, uses the user\'s current phone number.
     */
    'phoneNumber'?: string | null;
}
/**
 * Response after sending a reminder to a signer
 */
export interface SendReminderResponseDto {
    'success'?: boolean;
    'message'?: string | null;
    'reminderSentAt'?: string;
    'channelsUsed'?: Array<string> | null;
    'nextReminderAvailableAt'?: string;
}
export interface SendReminderResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SendReminderResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Request to send a reminder to a single signer
 */
export interface SendSignerReminderDto {
    /**
     * Optional custom message to include in the reminder
     */
    'message'?: string | null;
}
export interface SendVerificationCodeDto {
    'email'?: string | null;
    'method'?: string | null;
}

export enum ServiceLine {
    Tax = 'tax',
    Audit = 'audit',
    Cas = 'cas'
}


export interface SetConfidentialDto {
    'isConfidential': boolean;
    /**
     * The client user who should have exclusive access. Required when IsConfidential = true and caller is staff. Ignored when caller is a client (they are automatically assigned).
     */
    'confidentialClientUserId'?: string | null;
}
export interface SetNeedsAttentionDto {
    /**
     * True to flag, false to clear. Nullable so a body that omits it fails validation — on a non-nullable bool a missing field binds to false and silently clears the flag.
     */
    'needsAttention': boolean;
    /**
     * Why the client needs to act, shown to them verbatim. Required when Op.ClientTaxSystem.Api.DTOs.DocumentRequests.SetNeedsAttentionDto.NeedsAttention is true; ignored when clearing the flag.
     */
    'note'?: string | null;
}
export interface SignatureDocumentDto {
    'documentId'?: string | null;
    'fileName'?: string | null;
    'status'?: string | null;
    'signedAt'?: string | null;
    'downloadUrl'?: string | null;
}
export interface SignatureDocumentItemDto {
    'documentId'?: string;
    'name'?: string | null;
    'uploadedAt'?: string;
    'uploadedByName'?: string | null;
    'docuSealSubmissionId'?: number;
    /**
     * Overall submission status: pending | completed | declined | expired.
     */
    'submissionStatus'?: string | null;
    'completedAt'?: string | null;
    'signers'?: Array<SignatureDocumentSignerDto> | null;
}
/**
 * Signature documents attached to a binder (audit or tax), with per-signer status. Powers both the preparer management view and the client \"documents to sign\" surface. Binder-type agnostic.
 */
export interface SignatureDocumentListDto {
    'documents'?: Array<SignatureDocumentItemDto> | null;
}
export interface SignatureDocumentListDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureDocumentListDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SignatureDocumentSignerDto {
    /**
     * The signer\'s app user id, when the submitter maps to a client user.
     */
    'clientUserId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    /**
     * Per-signer status: pending | opened | completed | declined.
     */
    'status'?: string | null;
    'signingOrder'?: number;
    'completedAt'?: string | null;
    /**
     * DocuSeal submitter id — the signer identifier the reminder endpoint targets.
     */
    'signerId'?: number;
    /**
     * When the initial signature request was sent to this signer.
     */
    'sentAt'?: string | null;
    /**
     * When the most recent reminder was sent to this signer, or null if none.
     */
    'lastReminderSentAt'?: string | null;
    /**
     * How many reminders have been sent to this signer.
     */
    'reminderCount'?: number;
}
export interface SignatureFieldDto {
    'name': string;
    'type': string;
    'role': string;
    'required'?: boolean;
    'page'?: number | null;
    'x'?: number | null;
    'y'?: number | null;
    'width'?: number | null;
    'height'?: number | null;
    'label'?: string | null;
    'placeholder'?: string | null;
}
/**
 * A single placed field. Coordinates are relative (0.0-1.0) as fractions of page dimensions; Page is 1-based. Mirrors DocuSeal\'s field/area shape.
 */
export interface SignatureFieldPlacementDto {
    /**
     * Role this field belongs to (matches a Op.ClientTaxSystem.Api.DTOs.Signatures.SignerAssignmentDto.Role).
     */
    'role': string;
    /**
     * Field type: signature, initials, date, text, checkbox.
     */
    'type': string;
    'page'?: number;
    'x'?: number;
    'y'?: number;
    'w'?: number;
    'h'?: number;
    'required'?: boolean;
    /**
     * Optional display title shown to the signer.
     */
    'title'?: string | null;
}

export enum SignatureFieldType {
    Signature = 'signature',
    Date = 'date',
    InitialsOnly = 'initialsOnly',
    FullName = 'fullName',
    Pin = 'pin',
    Checkbox = 'checkbox',
    SsnLastFour = 'ssnLastFour',
    PhoneNumber = 'phoneNumber',
    Email = 'email',
    Text = 'text'
}


/**
 * Result of creating + sending a signature request.
 */
export interface SignatureRequestResultDto {
    'documentId'?: string;
    'docuSealSubmissionId'?: number;
    'submissionStatus'?: string | null;
    'signers'?: Array<SignerStatusItemDto> | null;
}
export interface SignatureRequestResultDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureRequestResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum SignatureRequirementStatus {
    Pending = 'pending',
    AwaitingSignature = 'awaitingSignature',
    Signed = 'signed',
    Skipped = 'skipped',
    ManualSignRequired = 'manualSignRequired'
}


/**
 * Embedded-signing session for the current user on a specific signature document. The frontend feeds Op.ClientTaxSystem.Api.DTOs.Signatures.SignatureSigningSessionDto.Slug into the embedded DocuSeal form component.
 */
export interface SignatureSigningSessionDto {
    'documentId'?: string;
    'docuSealSubmissionId'?: number;
    'slug'?: string | null;
    'email'?: string | null;
    'status'?: string | null;
}
export interface SignatureSigningSessionDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureSigningSessionDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum SignatureStatus {
    NotRequired = 'notRequired',
    Pending = 'pending',
    Sent = 'sent',
    Viewed = 'viewed',
    Signed = 'signed',
    Declined = 'declined',
    Expired = 'expired',
    Completed = 'completed',
    Cancelled = 'cancelled'
}


export interface SignatureStatusDto {
    'submissionId'?: string | null;
    'status'?: SignatureStatus;
    'viewedAt'?: string | null;
    'signedAt'?: string | null;
    'declinedAt'?: string | null;
    'expiredAt'?: string | null;
    'declineReason'?: string | null;
    'documentsSigned'?: number;
    'totalDocuments'?: number;
}


export interface SignatureStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SignatureSubmissionDto {
    'submissionId'?: string | null;
    'status'?: string | null;
    'signingUrl'?: string | null;
    'createdAt'?: string;
    'completedAt'?: string | null;
    'documents'?: Array<SignatureDocumentDto> | null;
    /**
     * Submitters (signers) returned from DocuSeal when submission is created. Used to populate DocuSealSubmitters table at submission creation time.
     */
    'submitters'?: Array<SubmissionSubmitterDto> | null;
}
export interface SignatureSubmissionDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureSubmissionDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SignatureTemplateDto {
    'id'?: string;
    'documentType'?: DocumentType;
    'documentTypeDescription'?: string | null;
    /**
     * Specific form type for granular matching (e.g., \"8879\", \"KY-740\") If null, template applies to all documents of the DocumentType category
     */
    'specificFormType'?: string | null;
    'templateName'?: string | null;
    'requiresSignature'?: boolean;
    'fields'?: Array<TemplateSignatureFieldDto> | null;
    'isActive'?: boolean;
    'createdAt'?: string;
    'updatedAt'?: string;
    'createdByName'?: string | null;
    'docuSealTemplateId'?: string | null;
    'docuSealSlug'?: string | null;
    'isOneTimeUse'?: boolean;
    'usedAt'?: string | null;
    'docuSealSubmissionId'?: string | null;
}


export interface SignatureTemplateDtoApiResponse {
    'success'?: boolean;
    'data'?: SignatureTemplateDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SignatureTemplateDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<SignatureTemplateDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Assigns a client user to a DocuSeal role used by placed fields.
 */
export interface SignerAssignmentDto {
    /**
     * Role identifier shared with the placed fields (e.g. \"Signer-1\").
     */
    'role': string;
    /**
     * The client user assigned to sign this role\'s fields.
     */
    'clientUserId': string;
    /**
     * 0-based signing order. Lower signs first when order is preserved.
     */
    'signingOrder'?: number;
}
export interface SignerDetail {
    'name'?: string | null;
    'role'?: string | null;
    'isDeceased'?: boolean;
}
/**
 * Basic signer information
 */
export interface SignerInfoDto {
    'signerId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
}
/**
 * Result of attempting to send a reminder to a single signer
 */
export interface SignerReminderResultDto {
    'signerId'?: string | null;
    'signerName'?: string | null;
    'sent'?: boolean;
    /**
     * Reason for result: \"sent\", \"already_signed\", \"cooldown\", \"no_contact\", \"error\"
     */
    'reason'?: string | null;
}

export enum SignerRole {
    PrimaryTaxpayer = 'primaryTaxpayer',
    Spouse = 'spouse',
    Partner = 'partner',
    Preparer = 'preparer',
    Other = 'other'
}


/**
 * Individual signer status within a submission
 */
export interface SignerStatusDto {
    'signerId'?: string | null;
    'role'?: SignerRole;
    'name'?: string | null;
    'email'?: string | null;
    'status'?: SignatureStatus;
    'sentAt'?: string | null;
    'viewedAt'?: string | null;
    'signedAt'?: string | null;
    'declinedAt'?: string | null;
    'declineReason'?: string | null;
    'lastReminderSentAt'?: string | null;
    'reminderCount'?: number;
    /**
     * Whether a reminder can be sent (based on cooldown and signer status)
     */
    'canSendReminder'?: boolean;
    /**
     * Signing order (0-based). Lower numbers sign first.
     */
    'signingOrder'?: number;
    /**
     * Whether this signer can currently sign (not blocked by sequential order)
     */
    'canSign'?: boolean;
    /**
     * Whether this signer is waiting for a previous signer to complete
     */
    'isWaitingForPreviousSigner'?: boolean;
}


/**
 * Per-signer status snapshot.
 */
export interface SignerStatusItemDto {
    'clientUserId'?: string | null;
    'name'?: string | null;
    'email'?: string | null;
    'role'?: string | null;
    'status'?: string | null;
    'signingOrder'?: number;
}
/**
 * Configuration response for signing form integration
 */
export interface SigningFormConfigDto {
    /**
     * Base URL for DocuSeal signing forms
     */
    'baseUrl'?: string | null;
    /**
     * JavaScript library URL for embedding
     */
    'scriptUrl'?: string | null;
    /**
     * Whether preview mode is enabled
     */
    'isPreviewMode'?: boolean;
    /**
     * Custom CSS for styling (optional)
     */
    'customCss'?: string | null;
    /**
     * Set to false to disable DocuSeal\'s automatic email with signed documents to signers. When false, the frontend should add data-send-copy-email=\"false\" to the docuseal-form element. Default is false to ensure all communication goes through the portal.
     */
    'sendCopyEmail'?: boolean;
}
export interface SigningFormConfigDtoApiResponse {
    'success'?: boolean;
    'data'?: SigningFormConfigDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for preparing a single document for signature
 */
export interface SingleDocumentSignatureDto {
    'clientName': string;
    'clientEmail': string;
    'spouseName'?: string | null;
    'spouseEmail'?: string | null;
    'sendEmail'?: boolean;
    'sendSms'?: boolean;
    'clientPhone'?: string | null;
    'fields'?: Array<SignatureFieldDto> | null;
}
/**
 * DTO for viewing SMS consent status
 */
export interface SmsConsentStatusDto {
    /**
     * Whether the user has given consent to receive SMS messages
     */
    'smsConsentGiven'?: boolean;
    /**
     * When the user gave consent (null if never consented)
     */
    'smsConsentTimestamp'?: string | null;
    /**
     * How the consent was given (e.g., \"AccountSettings\", \"Registration\", \"WebForm\")
     */
    'smsConsentMethod'?: string | null;
    /**
     * When the user opted out (null if still opted in)
     */
    'smsOptOutTimestamp'?: string | null;
    /**
     * The phone number that will receive SMS messages (null if not set or not verified)
     */
    'phoneNumber'?: string | null;
    /**
     * Whether the phone number has been verified
     */
    'phoneNumberVerified'?: boolean;
    /**
     * Returns true if the user has active SMS consent (consented and not opted out)
     */
    'hasActiveSmsConsent'?: boolean;
    /**
     * Returns true if SMS notifications can be sent (has consent and verified phone)
     */
    'canReceiveSms'?: boolean;
}
export interface SmsConsentStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: SmsConsentStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Statistics for a specific source system in the external client repository.
 */
export interface SourceSystemStatsDto {
    /**
     * Source system identifier (e.g., \"CCH\").
     */
    'sourceSystem'?: string | null;
    /**
     * Total number of clients from this source system.
     */
    'totalClients'?: number;
    /**
     * Number of active clients from this source system.
     */
    'activeClients'?: number;
    /**
     * Number of clients with generated embeddings for semantic search.
     */
    'clientsWithEmbeddings'?: number;
    /**
     * When clients from this source system were last synchronized.
     */
    'lastSyncedAt'?: string | null;
}
/**
 * Represents spouse data extracted from CCH API.
 */
export interface SpouseData {
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'taxId'?: string | null;
    'dateOfBirth'?: string | null;
    'occupation'?: string | null;
    'isDeceased'?: boolean;
}
/**
 * Response DTO for SSO login initiation. Contains the redirect URL to Azure AD for authentication.
 */
export interface SsoLoginInitiateDto {
    /**
     * The URL to redirect the user to for Azure AD authentication.
     */
    'redirectUrl'?: string | null;
    /**
     * State parameter for CSRF protection. Should be included in the callback verification.
     */
    'state'?: string | null;
}
export interface SsoLoginInitiateDtoApiResponse {
    'success'?: boolean;
    'data'?: SsoLoginInitiateDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Response DTO for successful SSO authentication callback. Contains the application JWT tokens after SSO validation.
 */
export interface SsoLoginResponseDto {
    /**
     * Indicates whether the SSO authentication was successful.
     */
    'success'?: boolean;
    /**
     * Human-readable message describing the authentication result.
     */
    'message'?: string | null;
    'user'?: UserDto;
    /**
     * The application JWT access token. This is the same token format used by regular login.
     */
    'token'?: string | null;
    /**
     * The application refresh token for obtaining new access tokens.
     */
    'refreshToken'?: string | null;
    /**
     * When the access token expires.
     */
    'expiresAt'?: string;
    /**
     * Indicates if this was the user\'s first SSO login (account was created).
     */
    'isNewUser'?: boolean;
    /**
     * Indicates if an existing local account was linked to the SSO account.
     */
    'wasLinked'?: boolean;
}
export interface SsoLoginResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SsoLoginResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Response DTO for SSO configuration status. Indicates whether SSO is available and configured.
 */
export interface SsoStatusDto {
    /**
     * Whether Azure AD SSO is enabled in the application configuration.
     */
    'enabled'?: boolean;
    /**
     * The display name for the SSO provider (e.g., \"Microsoft Entra ID\").
     */
    'providerName'?: string | null;
    /**
     * The Azure AD Tenant ID configured for SSO. Only first/last characters shown for security.
     */
    'tenantIdMasked'?: string | null;
    /**
     * The login initiation URL for SSO.
     */
    'loginUrl'?: string | null;
    /**
     * Human-readable status message.
     */
    'statusMessage'?: string | null;
}
export interface SsoStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: SsoStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Count of binders in a specific workflow stage
 */
export interface StageDistributionDto {
    'stage'?: BinderStage;
    'stageName'?: string | null;
    'count'?: number;
}


/**
 * Result of starting an amended return on a completed binder.
 */
export interface StartAmendmentResultDto {
    /**
     * The binder the amendment was started on
     */
    'binderId'?: string;
    /**
     * The round this amendment opened (1 for the first amendment)
     */
    'amendmentSequence'?: number;
    /**
     * Binder stage after the amendment was started
     */
    'newStage'?: string | null;
    /**
     * Timestamp when the amendment was started
     */
    'amendmentStartedAt'?: string;
}
export interface StartAmendmentResultDtoApiResponse {
    'success'?: boolean;
    'data'?: StartAmendmentResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Storage usage metrics and statistics for admin monitoring
 */
export interface StorageMetricsDto {
    /**
     * Total size of all files in storage (bytes)
     */
    'totalFileSizeBytes'?: number;
    /**
     * Total number of files in storage
     */
    'totalFileCount'?: number;
    /**
     * Number of unique binders with files
     */
    'organizerCount'?: number;
    /**
     * Number of unique documents with files
     */
    'documentCount'?: number;
    /**
     * Average file size in bytes
     */
    'avgFileSizeBytes'?: number;
    /**
     * Timestamp when metrics were scanned
     */
    'scannedAt'?: string;
    /**
     * Top 10 binders by storage usage
     */
    'topBindersBySize'?: Array<OrganizerStorageDto> | null;
}
export interface StorageMetricsDtoApiResponse {
    'success'?: boolean;
    'data'?: StorageMetricsDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StringApiResponse {
    'success'?: boolean;
    'data'?: string | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StringInt32DictionaryApiResponse {
    'success'?: boolean;
    'data'?: { [key: string]: number; } | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StringListApiResponse {
    'success'?: boolean;
    'data'?: Array<string> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StringObjectDictionaryApiResponse {
    'success'?: boolean;
    'data'?: { [key: string]: any | null; } | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StructuredAuditDto {
    'id'?: number;
    'timestampUtc'?: string;
    'entityType'?: string | null;
    'tableName'?: string | null;
    'action'?: string | null;
    'entityId'?: string | null;
    'parentEntityType'?: string | null;
    'parentEntityId'?: string | null;
    'userId'?: string | null;
    'userName'?: string | null;
    'ipAddress'?: string | null;
    'userAgent'?: string | null;
    'correlationId'?: string | null;
    'changes'?: { [key: string]: any | null; } | null;
}
export interface StructuredAuditDtoApiResponse {
    'success'?: boolean;
    'data'?: StructuredAuditDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StructuredAuditDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<StructuredAuditDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface StructuredAuditDtoPaginatedResponse {
    'items'?: Array<StructuredAuditDto> | null;
    'pagination'?: PaginationInfo;
}
export interface StructuredAuditDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: StructuredAuditDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Detailed document information with download URLs
 */
export interface SubmissionDocumentDetailsDto {
    /**
     * Document name
     */
    'name'?: string | null;
    /**
     * Unique identifier of attached document
     */
    'attachment_uuid'?: string | null;
    /**
     * URL to download the document
     */
    'url'?: string | null;
    /**
     * File size in bytes
     */
    'size'?: number | null;
    /**
     * Content type of the document
     */
    'content_type'?: string | null;
    /**
     * Number of pages in the document (for PDFs)
     */
    'pages'?: number | null;
    /**
     * Document metadata
     */
    'metadata'?: { [key: string]: any | null; } | null;
    /**
     * Date when the document was created/uploaded
     */
    'created_at'?: string | null;
    /**
     * Date when the document was last updated
     */
    'updated_at'?: string | null;
}
export interface SubmissionDocumentDto {
    /**
     * Unique identifier of attached document
     */
    'attachment_uuid'?: string | null;
    /**
     * Name of the attached document
     */
    'name'?: string | null;
}
/**
 * Response for get submission documents API
 */
export interface SubmissionDocumentsResponseDto {
    /**
     * Submission ID
     */
    'id'?: number;
    /**
     * List of documents in the submission
     */
    'documents'?: Array<SubmissionDocumentDetailsDto> | null;
}
export interface SubmissionDocumentsResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SubmissionDocumentsResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface SubmissionResponseDto {
    /**
     * Submission unique ID number
     */
    'id'?: number;
    /**
     * Submission name
     */
    'name'?: string | null;
    /**
     * The source of the submission
     */
    'source'?: string | null;
    /**
     * The order of submitters
     */
    'submitters_order'?: string | null;
    /**
     * The status of the submission
     */
    'status'?: string | null;
    /**
     * List of documents attached to the submission
     */
    'documents'?: Array<SubmissionDocumentDto> | null;
    /**
     * List of submitters
     */
    'submitters'?: Array<SubmissionSubmitterDto> | null;
    /**
     * Expiration date and time
     */
    'expire_at'?: string | null;
    /**
     * Date and time when the submission was created
     */
    'created_at'?: string | null;
    /**
     * Date and time when the submission was completed
     */
    'completed_at'?: string | null;
    /**
     * Audit log file URL (available for completed submissions)
     */
    'audit_log_url'?: string | null;
    /**
     * Combined PDF file URL with documents and Audit Log
     */
    'combined_document_url'?: string | null;
}
export interface SubmissionResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: SubmissionResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Submission status enumeration
 */

export enum SubmissionStatus {
    Pending = 'pending',
    Completed = 'completed',
    Declined = 'declined',
    Expired = 'expired'
}


export interface SubmissionSubmitterDto {
    /**
     * Submitter ID
     */
    'id'?: number;
    /**
     * Submission ID
     */
    'submission_id'?: number;
    /**
     * Unique identifier of the submitter
     */
    'uuid'?: string | null;
    /**
     * Email address of the submitter
     */
    'email'?: string | null;
    /**
     * Unique slug of the submitter
     */
    'slug'?: string | null;
    /**
     * Date and time when the signature request was sent
     */
    'sent_at'?: string | null;
    /**
     * Date and time when the signature request was opened
     */
    'opened_at'?: string | null;
    /**
     * Date and time when the submission was completed
     */
    'completed_at'?: string | null;
    /**
     * Date and time when the submission was declined
     */
    'declined_at'?: string | null;
    /**
     * Date and time when the submitter was created
     */
    'created_at'?: string | null;
    /**
     * Date and time when the submitter was last updated
     */
    'updated_at'?: string | null;
    /**
     * Name of the submitter
     */
    'name'?: string | null;
    /**
     * Phone number of the submitter
     */
    'phone'?: string | null;
    /**
     * Role of the submitter
     */
    'role'?: string | null;
    /**
     * Current status of the submitter
     */
    'status'?: string | null;
    /**
     * External ID for the submitter (contains User ID for audit trail)
     */
    'external_id'?: string | null;
}
/**
 * Submitter summary information
 */
export interface SubmissionSubmitterSummaryDto {
    /**
     * Submitter ID
     */
    'id'?: number;
    /**
     * Submitter name
     */
    'name'?: string | null;
    /**
     * Email address of the submitter
     */
    'email'?: string | null;
    /**
     * Phone number of the submitter
     */
    'phone'?: string | null;
    /**
     * Role of the submitter
     */
    'role'?: string | null;
    /**
     * Submitter status
     */
    'status'?: string | null;
    /**
     * External ID if provided for the submitter
     */
    'external_id'?: string | null;
}
/**
 * Summary information for a submission in list results
 */
export interface SubmissionSummaryDto {
    /**
     * Submission unique ID number
     */
    'id'?: number;
    /**
     * Submission name
     */
    'name'?: string | null;
    /**
     * The source of the submission
     */
    'source'?: string | null;
    /**
     * The status of the submission
     */
    'status'?: string | null;
    /**
     * Unique slug identifier for the submission
     */
    'slug'?: string | null;
    /**
     * External ID if provided during submission creation
     */
    'external_id'?: string | null;
    'template'?: SubmissionTemplateDto;
    /**
     * List of submitters/signers
     */
    'submitters'?: Array<SubmissionSubmitterSummaryDto> | null;
    /**
     * Date and time when the submission was created
     */
    'created_at'?: string | null;
    /**
     * Date and time when the submission was last updated
     */
    'updated_at'?: string | null;
    /**
     * Date and time when the submission was completed
     */
    'completed_at'?: string | null;
    /**
     * Expiration date and time
     */
    'expire_at'?: string | null;
    /**
     * Date and time when the submission was archived
     */
    'archived_at'?: string | null;
}
/**
 * Template information in submission summary
 */
export interface SubmissionTemplateDto {
    /**
     * Template unique ID number
     */
    'id'?: number;
    /**
     * Template name
     */
    'name'?: string | null;
    /**
     * External ID if provided during template creation
     */
    'external_id'?: string | null;
    /**
     * Template folder name
     */
    'folder'?: string | null;
}
/**
 * Request DTO for submitting a binder for preparer review (Ready to Proceed)
 */
export interface SubmitTaxBinderRequest {
    /**
     * Optional message to the preparer (will be saved as a Comment on the binder)
     */
    'note'?: string | null;
}
/**
 * Submitter/signer information for creating submissions
 */
export interface SubmitterDto {
    /**
     * Name of the submitter/signer
     */
    'name': string;
    /**
     * Email address of the submitter/signer. Can be null/empty when send_email is false (email will be updated later).
     */
    'email'?: string | null;
    /**
     * Phone number of the submitter/signer, formatted according to the E.164 standard. Null to omit from request.
     */
    'phone'?: string | null;
    /**
     * Role of the submitter (e.g., \"Taxpayer\", \"Spouse\", \"Officer\")
     */
    'role'?: string | null;
    /**
     * Signing order (0-based). Lower numbers sign first when submission order is \"preserved\".
     */
    'order'?: number;
    /**
     * Override send_email for this specific submitter. Null to omit from request.
     */
    'send_email'?: boolean | null;
    /**
     * Your application-specific unique string key to identify the submitter. Null to omit from request.
     */
    'external_id'?: string | null;
    /**
     * Pre-filled values for the submission. Use field names for keys of the object. Null to omit from request.
     */
    'values'?: { [key: string]: any | null; } | null;
    /**
     * Pre-filled field configurations for this submitter (name, default_value, readonly). Null to omit from request.
     */
    'fields'?: Array<SubmitterFieldDto> | null;
    'message'?: SubmitterMessageDto;
    /**
     * Application preferences. Null to omit from request.
     */
    'preferences'?: { [key: string]: any | null; } | null;
}
/**
 * Pre-filled field value configuration for a submitter
 */
export interface SubmitterFieldDto {
    'name'?: string | null;
    'default_value'?: string | null;
    'readonly'?: boolean | null;
}
/**
 * Custom message configuration for submitters
 */
export interface SubmitterMessageDto {
    /**
     * Subject line for the signature request email
     */
    'subject'?: string | null;
    /**
     * Custom message body for the signature request email
     */
    'body'?: string | null;
}
export interface SuggestedSignatureFieldDto {
    'id'?: string;
    'name'?: string | null;
    'type'?: SignatureFieldType;
    'role'?: string | null;
    'page'?: number;
    'x'?: number;
    'y'?: number;
    'width'?: number;
    'height'?: number;
    'isRequired'?: boolean;
    'description'?: string | null;
    'defaultValue'?: string | null;
}


export interface SyncAllClientsDto {
    'lastSyncedAfter'?: string | null;
    'updateExisting'?: boolean;
    'batchSize'?: number | null;
}
/**
 * Represents a single audit entry for a tax binder with human-readable information
 */
export interface TaxBinderAuditEntryDto {
    /**
     * Unique identifier for the audit entry
     */
    'id'?: number;
    /**
     * When the change occurred
     */
    'timestampUtc'?: string;
    /**
     * Type of action (Created, Updated, StatusChanged, etc.)
     */
    'action'?: string | null;
    /**
     * What the row is about, as recorded — the aggregation walks several entity types, so a row\'s subject is not implied by the endpoint it came from. Drives naming and linking on the client.
     */
    'entityType'?: string | null;
    /**
     * Identifier of the audited record, for resolving where a row\'s link should point.
     */
    'entityId'?: string | null;
    /**
     * Human-readable description of what changed
     */
    'description'?: string | null;
    /**
     * User who made the change
     */
    'userName'?: string | null;
    /**
     * ID of the user who made the change
     */
    'userId'?: string | null;
    /**
     * Specific field changes (if applicable)
     */
    'fieldChanges'?: Array<FieldChangeDto> | null;
    /**
     * IP address of the user (if available)
     */
    'ipAddress'?: string | null;
}
/**
 * Represents the audit history for a tax binder with human-readable change descriptions
 */
export interface TaxBinderAuditHistoryDto {
    /**
     * The binder ID this history belongs to
     */
    'binderId'?: string;
    /**
     * The tax year of the binder for context
     */
    'taxYear'?: number;
    /**
     * The client name associated with this binder
     */
    'clientName'?: string | null;
    'currentStage'?: BinderStage;
    /**
     * List of audit entries in chronological order (newest first)
     */
    'auditEntries'?: Array<TaxBinderAuditEntryDto> | null;
    /**
     * Total number of audit entries
     */
    'totalEntries'?: number;
    /**
     * 1-based page of entries returned. TotalEntries counts the whole filtered set, not this page.
     */
    'page'?: number;
    /**
     * Maximum entries per page.
     */
    'pageSize'?: number;
}


export interface TaxBinderAuditHistoryDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderAuditHistoryDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Request to build a binder export package and file it into CCH Axcess Document.
 */
export interface TaxBinderCchExportRequestDto {
    'exportOptions': TaxBinderPackageExportDto;
    'destination': CchExportDestinationDto;
}
/**
 * Outcome of filing a binder export into CCH Axcess Document.
 */
export interface TaxBinderCchExportResultDto {
    'binderId'?: string;
    'uploadedCount'?: number;
    'failedCount'?: number;
    /**
     * One entry per file we attempted to file, in upload order.
     */
    'files'?: Array<CchExportFileResultDto> | null;
    /**
     * Portal files that could not be read or converted while building the package — the same list the download export returns in its `X-Export-Failures` header.
     */
    'failedFiles'?: Array<string> | null;
}
export interface TaxBinderCchExportResultDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderCchExportResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxBinderDto {
    'id'?: string;
    'name'?: string | null;
    'taxYear'?: number;
    /**
     * Tax type for this binder (e.g., \"individual\", \"business\", \"partnership\")
     */
    'taxType'?: string | null;
    'clientType'?: ClientType;
    'stage'?: BinderStage;
    'type'?: TaxBinderType;
    'clientId'?: string;
    'clientName'?: string | null;
    /**
     * Client number/identifier for display purposes
     */
    'clientNumber'?: string | null;
    /**
     * Client email address for contact and search functionality
     */
    'clientEmail'?: string | null;
    /**
     * Client phone number for contact and search functionality
     */
    'clientPhone'?: string | null;
    /**
     * Office ID associated with the client (nullable if client has no office assigned)
     */
    'officeId'?: string | null;
    /**
     * Office name associated with the client (nullable if client has no office assigned)
     */
    'officeName'?: string | null;
    /**
     * Partner ID assigned to the client (nullable if no partner assigned)
     */
    'partnerId'?: string | null;
    /**
     * Partner name assigned to the client (nullable if no partner assigned)
     */
    'partnerName'?: string | null;
    'preparerId'?: string;
    'preparerName'?: string | null;
    /**
     * Assigned preparer name (alias for PreparerName for frontend compatibility)
     */
    'assignedPreparer'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'dueDate'?: string | null;
    'notificationDaysPrior'?: number;
    'isExtended'?: boolean;
    'engagementLetter'?: ESignatureStatusDto;
    'directDepositReport'?: ESignatureStatusDto;
    'organizerDocumentId'?: string | null;
    'hasOrganizer'?: boolean;
    /**
     * ID of the associated TaxReturnBundle (null if no bundle uploaded)
     */
    'taxReturnBundleId'?: string | null;
    /**
     * Whether this binder has a tax return bundle
     */
    'hasTaxReturnBundle'?: boolean;
    /**
     * Amendment round of the active bundle (0 for the binder\'s original return)
     */
    'amendmentSequence'?: number;
    /**
     * Whether an amended return is being prepared, reviewed or signed right now
     */
    'isAmendmentInProgress'?: boolean;
    /**
     * Whether the binder has at least one superseded return round
     */
    'hasAmendmentHistory'?: boolean;
    /**
     * Timestamp when the most recent amendment was started
     */
    'amendmentStartedAt'?: string | null;
    /**
     * Name of the staff member who started the most recent amendment
     */
    'amendmentStartedBy'?: string | null;
    'bundleSignature'?: ESignatureStatusDto;
    'completionStatus'?: DocumentCompletionStatus;
    /**
     * Total number of documents associated with this binder
     */
    'documentsTotal'?: number;
    /**
     * Number of documents approved by preparer
     */
    'documentsApproved'?: number;
    /**
     * Number of documents rejected by preparer
     */
    'documentsRejected'?: number;
    /**
     * Document completion percentage (approved / total * 100)
     */
    'documentCompletionPercentage'?: number;
    /**
     * Number of questionnaire questions required for this binder (placeholder - always 0 until questionnaires implemented)
     */
    'questionnaireRequired'?: number;
    /**
     * Number of questionnaire questions completed (placeholder - always 0 until questionnaires implemented)
     */
    'questionnaireCompleted'?: number;
    /**
     * Questionnaire completion percentage (placeholder - always 0 until questionnaires implemented)
     */
    'questionnaireCompletionPercentage'?: number;
    /**
     * Timestamp when questionnaire was completed (null = incomplete)
     */
    'questionnaireCompletedAt'?: string | null;
    /**
     * Whether the questionnaire has been completed
     */
    'isQuestionnaireComplete'?: boolean;
    /**
     * JSON string containing questionnaire answers (for viewing purposes)
     */
    'questionnaireAnswers'?: string | null;
    /**
     * Priority level: \"urgent\" (overdue or due within 7 days), \"high\" (due within 30 days), \"medium\" (due within 90 days), \"low\" (due beyond 90 days or no due date)
     */
    'priority'?: string | null;
    /**
     * Number of days overdue (null if not overdue, positive integer if overdue)
     */
    'daysOverdue'?: number | null;
    /**
     * Overall completion percentage based on required documents (0-100)
     */
    'completionPercentage'?: number;
    /**
     * URL link to the invoice for this binder
     */
    'invoiceLink'?: string | null;
    /**
     * Whether this binder is archived (completed, locked from changes)
     */
    'isArchived'?: boolean;
    /**
     * Tax filing deadline for this binder
     */
    'filingDeadline'?: string | null;
    /**
     * User-friendly description of this binder
     */
    'description'?: string | null;
    /**
     * Timestamp when the client indicated they have finished uploading documents and are ready for preparer to proceed
     */
    'clientSubmittedAt'?: string | null;
    /**
     * Name of the client user who submitted the binder (mapped from User.FullName)
     */
    'clientSubmittedBy'?: string | null;
    /**
     * Whether the client has submitted this binder for preparer review
     */
    'isClientSubmitted'?: boolean;
    /**
     * Timestamp when a preparer started reviewing this binder (moved to InReview stage)
     */
    'inReviewStartedAt'?: string | null;
    /**
     * Name of the preparer who is currently reviewing this binder
     */
    'inReviewBy'?: string | null;
    /**
     * Whether a preparer is currently reviewing this binder
     */
    'isInReview'?: boolean;
    /**
     * Timestamp when the InReview stage was completed
     */
    'inReviewCompletedAt'?: string | null;
    /**
     * Timestamp when the binder was moved to ReadyForScan stage
     */
    'readyForScanAt'?: string | null;
    /**
     * Name of the user who moved the binder to ReadyForScan stage
     */
    'readyForScanBy'?: string | null;
    /**
     * Timestamp when the binder was sent for preparation
     */
    'sentForPreparationAt'?: string | null;
    /**
     * Name of the user who sent the binder for preparation
     */
    'sentForPreparationBy'?: string | null;
    /**
     * Timestamp when the binder was sent to client for final review
     */
    'finalClientReviewAt'?: string | null;
    /**
     * Name of the user who sent the binder for final client review
     */
    'finalClientReviewBy'?: string | null;
    /**
     * Timestamp when the binder was marked as complete
     */
    'completedAt'?: string | null;
    /**
     * Name of the user who marked the binder as complete
     */
    'completedBy'?: string | null;
    /**
     * Timestamp when the client requested changes during final review
     */
    'clientRequestsChangesAt'?: string | null;
    /**
     * Name of the user who triggered the client requests changes stage
     */
    'clientRequestsChangesBy'?: string | null;
    /**
     * Timestamp when the binder was marked as e-file ready (client signed, ready to file)
     */
    'efileReadyAt'?: string | null;
    /**
     * Name of the user who marked the binder as e-file ready
     */
    'efileReadyBy'?: string | null;
    /**
     * Timestamp when the binder was released to client for final review and signing
     */
    'releasedToClientAt'?: string | null;
    /**
     * Name of the user who released the binder to client
     */
    'releasedToClientBy'?: string | null;
    /**
     * Whether the binder has been released to client
     */
    'isReleasedToClient'?: boolean;
    /**
     * Timestamp when the binder was recalled from client
     */
    'recalledAt'?: string | null;
    /**
     * Name of the user who recalled the binder
     */
    'recalledBy'?: string | null;
    /**
     * Reason provided for recalling the tax return
     */
    'recallReason'?: string | null;
    /**
     * List of stages this binder can transition to from its current stage. This is populated based on the workflow rules and current stage.
     */
    'allowedTransitions'?: Array<BinderStage> | null;
    /**
     * Whether this binder has documents pending preparer review (ReadyForReview, UnderReview, or PendingApproval status)
     */
    'hasUnreviewedDocuments'?: boolean;
    /**
     * Count of documents pending preparer review
     */
    'unreviewedDocumentsCount'?: number;
    /**
     * Whether this binder has comments that have not been read
     */
    'hasUnreviewedComments'?: boolean;
    /**
     * Count of comments that have not been read
     */
    'unreviewedCommentsCount'?: number;
    'lastActivityType'?: BinderActivityType;
    /**
     * Timestamp of the most recent activity on this binder
     */
    'lastActivityAt'?: string | null;
    /**
     * Timestamp when the first late document was uploaded (null = no late documents). A late document is one uploaded when the binder stage is >= SentForPreparation.
     */
    'lateDocumentsUploadedAt'?: string | null;
    /**
     * Count of late documents uploaded to this binder
     */
    'lateDocumentsCount'?: number;
}


export interface TaxBinderDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxBinderDtoPaginatedResponse {
    'items'?: Array<TaxBinderDto> | null;
    'pagination'?: PaginationInfo;
}
export interface TaxBinderDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxBinderExportPreviewDto {
    'totalFiles'?: number;
    'pdfFiles'?: number;
    'imageFiles'?: number;
    'otherFiles'?: number;
    'recommendedFormat'?: ExportType;
    'estimatedSize'?: number;
    'files'?: Array<FilePreviewDto> | null;
}


export interface TaxBinderExportPreviewDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderExportPreviewDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxBinderExportSelectionDto {
    'documentIds': Array<string>;
    'specificFileIds'?: Array<string> | null;
    'preferredFormat': ExportFormat;
}


/**
 * DTO for configuring binder package export options.
 */
export interface TaxBinderPackageExportDto {
    /**
     * Include basic client information in the package.
     */
    'includeClientInfo'?: boolean;
    /**
     * Include spouse information in the package (if exists).
     */
    'includeSpouseInfo'?: boolean;
    /**
     * Include dependents table in the package (if any exist).
     */
    'includeDependents'?: boolean;
    /**
     * Include bank accounts table in the package (if any exist). When true, full account numbers are extracted from questionnaire responses if available.
     */
    'includeBankAccounts'?: boolean;
    /**
     * Include questionnaire responses in the package (if completed). When included, the questionnaire appears as the first section of the export.
     */
    'includeQuestionnaire'?: boolean;
    /**
     * Include comments summary in the package. When included, comments are grouped by binder-level and document request. Appears at the beginning of the export, after questionnaire if included.
     */
    'includeComments'?: boolean;
    /**
     * Include extracted text as a second page for image documents. When true and extracted text is available with high confidence (≥80%), the exported PDF will have the original image as page 1 and the extracted text (with original filename reference) as page 2.
     */
    'includeExtractedText'?: boolean;
    /**
     * Include separator pages between sections in the exported PDF. When true, a \"Multi-Page\" or \"SinglePage\" separator is inserted before each section based on the actual page count of that section\'s PDF content.
     */
    'includeSeparatorPages'?: boolean;
    'documentFilter': DocumentFilter;
    /**
     * List of specific document IDs to include (only used when DocumentFilter is Selected).
     */
    'selectedDocumentIds'?: Array<string> | null;
}



export enum TaxBinderType {
    Normal = 'normal',
    GiftTax = 'giftTax'
}


/**
 * DTO for binder verification status, used to determine what verification steps the current user needs to complete before accessing the binder\'s questionnaire.
 */
export interface TaxBinderVerificationStatusDto {
    'userRole'?: ClientUserRole;
    /**
     * Whether spouse info has been verified for this binder.
     */
    'isSpouseInfoVerified'?: boolean;
    /**
     * True when a released signature bundle exists but a spouse signature requirement has no linked user or no email (placeholder release, or phone-only spouse). The primary must complete spouse verification before signing can proceed, even if spouse info was verified earlier.
     */
    'requiresSpouseContactInfo'?: boolean;
    /**
     * When spouse info was verified for this binder.
     */
    'spouseInfoVerifiedAt'?: string | null;
    /**
     * Whether the engagement-letter upload warning has been acknowledged for this binder. Shown once per binder before the client uploads documents while no engagement letter exists yet.
     */
    'hasAcknowledgedEngagementLetterWarning'?: boolean;
    /**
     * When the engagement-letter upload warning was acknowledged for this binder.
     */
    'engagementLetterWarningAcknowledgedAt'?: string | null;
    /**
     * Whether the current user can modify marital status. False for Spouse role users - they can only view and acknowledge.
     */
    'canModifyMaritalStatus'?: boolean;
    'maritalStatus'?: MaritalStatus;
    'spouseInfo'?: ClientSpouseDto;
    /**
     * True if we have spouse SSN but missing contact info (email/phone). Primary user needs to enter the missing contact info for engagement letter signing.
     */
    'hasSpouseSsnOnly'?: boolean;
    /**
     * Whether a Primary user exists for this client. False if the current user is a Spouse and needs to create the Primary user.
     */
    'hasPrimaryUser'?: boolean;
    /**
     * Primary user\'s full name (for Spouse users to display).
     */
    'primaryUserName'?: string | null;
    /**
     * Primary user\'s email (for Spouse users to display).
     */
    'primaryUserEmail'?: string | null;
    /**
     * Primary user\'s phone number (for Spouse users to display).
     */
    'primaryUserPhone'?: string | null;
}


export interface TaxBinderVerificationStatusDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxBinderVerificationStatusDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for TaxReturnBundleFilingInstruction entity
 */
export interface TaxReturnBundleFilingInstructionDto {
    'id'?: string;
    'taxReturnBundleJurisdictionId'?: string;
    'documentId'?: string | null;
    'taxYear'?: number;
    'instructionType'?: FilingInstructionType;
    'dueDate'?: string | null;
    'taxLiability'?: number | null;
    'amountPaid'?: number | null;
    'balanceDue'?: number | null;
    'refundAmount'?: number | null;
    'isDirectDeposit'?: boolean;
    'mailingAddress1'?: string | null;
    'mailingAddress2'?: string | null;
    'mailingCity'?: string | null;
    'mailingState'?: string | null;
    'mailingZip'?: string | null;
    'payableTo'?: string | null;
    'specialInstructions'?: string | null;
    'extractionSource'?: string | null;
    'extractionConfidence'?: number | null;
    'extractedAt'?: string | null;
    'hasBalanceDue'?: boolean;
    'hasRefund'?: boolean;
    /**
     * Full formatted mailing address
     */
    'formattedMailingAddress'?: string | null;
}


export interface TaxReturnBundleFilingInstructionDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxReturnBundleFilingInstructionDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for TaxReturnBundleJurisdiction entity
 */
export interface TaxReturnBundleJurisdictionDto {
    'id'?: string;
    'taxReturnBundleId'?: string;
    'jurisdictionType'?: JurisdictionType;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'status'?: ReturnStatus;
    'filingMethod'?: FilingMethod;
    'sortOrder'?: number;
    'eFileAuthorizationDocumentId'?: string | null;
    'eFileAuthorizationFormType'?: string | null;
    'eFileAuthorizationSignedAt'?: string | null;
    'eFileAuthorizationSentById'?: string | null;
    'eFileAuthorizationSentByName'?: string | null;
    'eFileAuthorizationSentAt'?: string | null;
    'eFileSigningMethod'?: EFileSigningMethod;
    'paperConvertedAt'?: string | null;
    'filedAt'?: string | null;
    'filedById'?: string | null;
    'filedByName'?: string | null;
    'eFileConfirmationNumber'?: string | null;
    'acceptedAt'?: string | null;
    'rejectedAt'?: string | null;
    'rejectionReason'?: string | null;
    'isAmended'?: boolean;
    'originalReturnId'?: string | null;
    'notes'?: string | null;
    'createdAt'?: string;
    'updatedAt'?: string;
    'hasEFileAuthorization'?: boolean;
    'isSigned'?: boolean;
    'isFiled'?: boolean;
    'isAccepted'?: boolean;
    'isRejected'?: boolean;
    'filingInstruction'?: TaxReturnBundleFilingInstructionDto;
    'estimatedTaxFilingInstruction'?: TaxReturnBundleFilingInstructionDto;
    'filingInstructions'?: Array<TaxReturnBundleFilingInstructionDto> | null;
    'paymentVouchers'?: Array<TaxReturnBundlePaymentVoucherDto> | null;
    'pageReferences'?: Array<BundlePageReferenceDto> | null;
    'signatureRequirements'?: Array<BundleSignatureRequirementDto> | null;
    'bundleDocuments'?: Array<BundleDocumentDto> | null;
    'documentCount'?: number;
}


export interface TaxReturnBundleJurisdictionDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxReturnBundleJurisdictionDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxReturnBundleJurisdictionDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<TaxReturnBundleJurisdictionDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Summary DTO for listing returns without full details
 */
export interface TaxReturnBundleJurisdictionSummaryDto {
    'id'?: string;
    'jurisdictionType'?: JurisdictionType;
    'jurisdictionCode'?: string | null;
    'jurisdictionName'?: string | null;
    'status'?: ReturnStatus;
    'filingMethod'?: FilingMethod;
    'sortOrder'?: number;
    'isSigned'?: boolean;
    'isFiled'?: boolean;
    'dueDate'?: string | null;
    'balanceDue'?: number | null;
    'refundAmount'?: number | null;
}


/**
 * DTO for TaxReturnBundlePaymentVoucher entity
 */
export interface TaxReturnBundlePaymentVoucherDto {
    'id'?: string;
    'taxReturnBundleJurisdictionId'?: string;
    'documentId'?: string | null;
    'quarter'?: VoucherQuarter;
    'taxYear'?: number;
    'formNumber'?: string | null;
    'dueDate'?: string;
    'amount'?: number;
    'reminderEnabled'?: boolean;
    'reminderDaysPrior'?: number;
    'reminderSentAt'?: string | null;
    'paidAt'?: string | null;
    /**
     * Client-entered amount actually paid, when it differs from the scheduled Amount. Null = scheduled amount.
     */
    'paidAmount'?: number | null;
    'paymentNotes'?: string | null;
    'mailingAddress1'?: string | null;
    'mailingAddress2'?: string | null;
    'mailingCity'?: string | null;
    'mailingState'?: string | null;
    'mailingZip'?: string | null;
    'payableTo'?: string | null;
    'isPaid'?: boolean;
    /**
     * The amount to treat as paid: the client-entered PaidAmount, else the scheduled Amount. Null while unpaid. Single definition for the checklist, preparer panel, and prefill.
     */
    'effectivePaidAmount'?: number | null;
    'isOverdue'?: boolean;
    'daysUntilDue'?: number;
    /**
     * Quarter display name (e.g., \"Q1 2024\")
     */
    'quarterDisplay'?: string | null;
    /**
     * Full formatted mailing address
     */
    'formattedMailingAddress'?: string | null;
}


export interface TaxReturnBundlePaymentVoucherDtoApiResponse {
    'success'?: boolean;
    'data'?: TaxReturnBundlePaymentVoucherDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TaxReturnBundlePaymentVoucherDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<TaxReturnBundlePaymentVoucherDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Represents a tax type option for filtering binders
 */
export interface TaxTypeOption {
    /**
     * The numeric value of the tax type enum
     */
    'value'?: number;
    /**
     * The enum name (e.g., \"Individual\", \"Corporation\")
     */
    'name'?: string | null;
    /**
     * The display name from the Display attribute (e.g., \"Individual\", \"Corporation\")
     */
    'displayName'?: string | null;
}
export interface TaxTypeOptionListApiResponse {
    'success'?: boolean;
    'data'?: Array<TaxTypeOption> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface TemplateSignatureFieldDto {
    'fieldId': string;
    'label': string;
    'role'?: string | null;
    'type': SignatureFieldType;
    'page'?: number;
    'position': FieldPositionDto;
    'dimensions': FieldDimensionsDto;
    'isRequired'?: boolean;
    'tabOrder'?: number;
    'fieldUuid'?: string | null;
    'submitterUuid'?: string | null;
    'attachmentUuid'?: string | null;
    'preferences'?: FieldPreferencesDto;
}


/**
 * Counts broken down by day, week, and month
 */
export interface TimePeriodCountsDto {
    'pastDay'?: number;
    'pastWeek'?: number;
    'pastMonth'?: number;
    'past90Days'?: number;
    'past120Days'?: number;
    'thisYear'?: number;
}
/**
 * Move an audit binder forward (or back) in its stage workflow. Validated server-side — gate conditions live in AuditBinderService.
 */
export interface TransitionAuditBinderDto {
    'toStage': AuditBinderStage;
    /**
     * Completing a binder deletes the client\'s previous Complete binders. The caller confirms by echoing their ids from the limits endpoint; a missing or stale set is refused, so nothing is deleted unseen.
     */
    'confirmDeletePreviousBinderIds'?: Array<string> | null;
    /**
     * Completing only: false sends no \"Audit Complete\" notification. Defaults to true, so callers that predate the Complete dialog\'s \"Notify the client\" checkbox keep notifying.
     */
    'notifyClient'?: boolean;
}


/**
 * DTO for a unified notification response.
 */
export interface UnifiedNotificationDto {
    'id'?: string;
    'actionType'?: NotificationActionType;
    'actionTypeDisplay'?: string | null;
    'targetAudience'?: NotificationAudience;
    'title'?: string | null;
    'message'?: string | null;
    'priority'?: NotificationPriority;
    'clientId'?: string | null;
    'clientName'?: string | null;
    'binderId'?: string | null;
    'binderName'?: string | null;
    'documentId'?: string | null;
    'documentName'?: string | null;
    'documentRequestId'?: string | null;
    'entityType'?: NotificationEntityType;
    'entityId'?: string | null;
    'entityName'?: string | null;
    'triggeredByUserId'?: string | null;
    'triggeredByUserName'?: string | null;
    'triggeredByUserRole'?: UserRole;
    'isRead'?: boolean;
    'readAt'?: string | null;
    'isDismissed'?: boolean;
    'dismissedAt'?: string | null;
    /**
     * The user who received this notification (only populated when viewing client\'s inbox).
     */
    'recipientUserId'?: string | null;
    /**
     * Display name of the recipient (only populated when viewing client\'s inbox).
     */
    'recipientUserName'?: string | null;
    'deliveryChannels'?: NotificationDeliveryChannel;
    /**
     * Whether the notification has been sent (only populated when viewing client\'s inbox).
     */
    'isSent'?: boolean | null;
    /**
     * When the notification was sent (only populated when viewing client\'s inbox).
     */
    'sentAt'?: string | null;
    /**
     * Error message if delivery failed (only populated when viewing client\'s inbox).
     */
    'deliveryError'?: string | null;
    'createdAt'?: string;
    /**
     * Action-specific metadata as a dictionary. For SignatureCompleted, includes: signerName, documentType, totalSigners, completedSigners, remainingSigners.
     */
    'metadata'?: { [key: string]: any | null; } | null;
}


export interface UnifiedNotificationDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<UnifiedNotificationDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UnifiedNotificationDtoPaginatedResponse {
    'items'?: Array<UnifiedNotificationDto> | null;
    'pagination'?: PaginationInfo;
}
export interface UnifiedNotificationDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: UnifiedNotificationDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for updating preferences for a specific action type.
 */
export interface UpdateActionPreferenceDto {
    'channels'?: NotificationDeliveryChannel;
    'batchStrategy'?: NotificationBatchStrategy;
}


export interface UpdateAuditBinderDto {
    'name'?: string | null;
    'periodStart'?: string | null;
    'periodEnd'?: string | null;
    'dueDate'?: string | null;
    'description'?: string | null;
}
/**
 * DTO for setting or clearing a binder-level override for a single action.
 */
export interface UpdateBinderActionPreferenceDto {
    'channel'?: NotificationDeliveryChannel;
}


/**
 * DTO for updating a signature requirement (preparer reassignment)
 */
export interface UpdateBundleSignatureRequirementDto {
    'userId'?: string | null;
    'requiresManualSign'?: boolean | null;
    'manualSignReason'?: string | null;
}
export interface UpdateClientDto {
    'name'?: string | null;
    'email'?: string | null;
    'phoneNumber'?: string | null;
    'address1'?: string | null;
    'address2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'type'?: ClientType;
    'maritalStatus'?: MaritalStatus;
    /**
     * Primary taxpayer SSN or EIN. Formats: SSN (123-45-6789 or 123456789), EIN (12-3456789 or 123456789)
     */
    'taxId'?: string | null;
    /**
     * Spouse SSN (for Individual clients only). Format: 123-45-6789 or 123456789
     */
    'spouseTaxId'?: string | null;
    'notes'?: string | null;
    'tags'?: Array<string> | null;
    /**
     * Whether clients can upload a physically signed engagement letter instead of e-signing.
     */
    'allowPhysicalSignature'?: boolean | null;
    /**
     * Whether an engagement letter is required for this client\'s binders.
     */
    'engagementLetterRequired'?: boolean | null;
    /**
     * Whether this client should be marked as confidential. Only preparers/admins can mark as confidential; only admins can unmark. When null, confidential status is not changed.
     */
    'isConfidential'?: boolean | null;
    /**
     * The full set of service lines (Tax, Audit, CAS) that should be enabled for this client. When null, service lines are left unchanged. When provided, the client\'s service lines are reconciled to exactly this set (an empty list removes all). CAS is accepted but is not yet surfaced in the UI.
     */
    'serviceLines'?: Array<ServiceLine> | null;
}


export interface UpdateClientNoteDto {
    'content': string;
}
/**
 * DTO for updating client notification preferences. All fields are nullable — only provided fields are updated (null = no change).
 */
export interface UpdateClientNotificationPreferenceDto {
    'preferredChannel'?: NotificationChannel;
    'isEnabled'?: boolean | null;
    'batchIntervalMinutes'?: number | null;
    'enableDocumentRequests'?: boolean | null;
    'enableDocumentApprovals'?: boolean | null;
    'enableDocumentRejections'?: boolean | null;
    'enableDocumentComments'?: boolean | null;
    'enableBinderStageChanges'?: boolean | null;
    'enableBinderCreated'?: boolean | null;
    'enableSignatureRequests'?: boolean | null;
    'enableTaxReturnReleased'?: boolean | null;
    'enableEstimatedPaymentReminders'?: boolean | null;
    'enableAuditBinderStageChanges'?: boolean | null;
    'enableAuditBinderComments'?: boolean | null;
    'enableAuditBinderDocumentApprovals'?: boolean | null;
    'enableAuditBinderDocumentRejections'?: boolean | null;
    'enableAuditBinderDocumentRequests'?: boolean | null;
    'enableAuditBinderDocumentRequestOutcomes'?: boolean | null;
    'enableAuditBinderFirmDocumentsAdded'?: boolean | null;
    'notifyPrimaryUser'?: boolean | null;
    'notifySpouse'?: boolean | null;
    'notifyDependents'?: boolean | null;
    'notifyAuthorized'?: boolean | null;
    'notifyAccountant'?: boolean | null;
}


export interface UpdateClientUserRoleDto {
    'userId': string;
    'clientId': string;
    'role': ClientUserRole;
    /**
     * When true, promotes this user to main contact for the client. When false, demotes this user and auto-promotes the next best candidate. Omit or pass null to leave the current main contact unchanged.
     */
    'isMainContact'?: boolean | null;
}


export interface UpdateCommentDto {
    'content': string;
    'priority'?: string | null;
    'status'?: string | null;
}
export interface UpdateContactInfoDto {
    'email'?: string | null;
    'phoneNumber'?: string | null;
}
/**
 * DTO for updating document properties including hybrid type system fields
 */
export interface UpdateDocumentDto {
    'type'?: DocumentType;
    'status'?: DocumentStatus;
    /**
     * User override for AI-detected form type. Set to specific form type (e.g., \"W-2\", \"8879\") to override AI detection. Set to empty string or null to clear the override and use AI-detected value.
     */
    'userOverrideFormType'?: string | null;
}


export interface UpdateDocumentRequestDto {
    'title'?: string | null;
    'description'?: string | null;
    'binderId'?: string | null;
    'status'?: DocumentRequestStatus;
    'priority'?: DocumentRequestPriority;
    'dueDate'?: string | null;
    'notes'?: string | null;
    'requestType'?: AuditDocumentRequestType;
    'isConfidential'?: boolean | null;
    'confidentialClientUserId'?: string | null;
}


/**
 * DTO for updating filing instructions. All fields are optional - only provided fields will be updated.
 */
export interface UpdateFilingInstructionDto {
    /**
     * Due date for the return filing
     */
    'dueDate'?: string | null;
    /**
     * Total tax liability from the return
     */
    'taxLiability'?: number | null;
    /**
     * Amount already paid (withholding, estimated payments)
     */
    'amountPaid'?: number | null;
    /**
     * Balance due with the return
     */
    'balanceDue'?: number | null;
    /**
     * Refund amount (if applicable)
     */
    'refundAmount'?: number | null;
    /**
     * Whether refund will be direct deposited
     */
    'isDirectDeposit'?: boolean | null;
    /**
     * Mailing address line 1 (street or PO Box)
     */
    'mailingAddress1'?: string | null;
    /**
     * Mailing address line 2
     */
    'mailingAddress2'?: string | null;
    /**
     * City for mailing address
     */
    'mailingCity'?: string | null;
    /**
     * State for mailing address
     */
    'mailingState'?: string | null;
    /**
     * ZIP code for mailing address
     */
    'mailingZip'?: string | null;
    /**
     * Entity to make check payable to
     */
    'payableTo'?: string | null;
    /**
     * Special instructions for the return
     */
    'specialInstructions'?: string | null;
}
/**
 * DTO for updating return status and notes
 */
export interface UpdateJurisdictionDto {
    'status'?: ReturnStatus;
    'notes'?: string | null;
    'eFileConfirmationNumber'?: string | null;
    'rejectionReason'?: string | null;
}


export interface UpdateK1RecipientAssignmentDto {
    'email': string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'pushedCopyAction'?: K1PushedCopyAction;
}


/**
 * DTO for updating an existing payment voucher (partial update — all fields optional)
 */
export interface UpdatePaymentVoucherDto {
    'quarter'?: VoucherQuarter;
    'taxYear'?: number | null;
    'formNumber'?: string | null;
    'dueDate'?: string | null;
    'amount'?: number | null;
    'mailingAddress1'?: string | null;
    'mailingAddress2'?: string | null;
    'mailingCity'?: string | null;
    'mailingState'?: string | null;
    'mailingZip'?: string | null;
    'payableTo'?: string | null;
}


/**
 * DTO for updating a preparer-added document\'s metadata. All fields are optional; only provided fields are applied. Cannot update documents that are already awaiting signature or signed.
 */
export interface UpdatePreparerDocumentDto {
    'displayName'?: string | null;
    'category'?: BundleDocumentCategory;
    'jurisdictionId'?: string | null;
    'requiresSignature'?: boolean | null;
    'signatureFieldPlacementsJson'?: string | null;
}


export interface UpdatePreprocessedDocumentDto {
    'documentName'?: string | null;
    'isIncluded'?: boolean | null;
    'requiresSignature'?: boolean | null;
    'documentType'?: DocumentType;
}


export interface UpdateQuestionnaireDto {
    'title'?: string | null;
    'description'?: string | null;
    'isActive'?: boolean | null;
    'isRequired'?: boolean | null;
}
/**
 * DTO for updating an existing questionnaire response
 */
export interface UpdateQuestionnaireResponseDto {
    'responseData': string;
}
export interface UpdateSignatureTemplateDto {
    'specificFormType'?: string | null;
    'templateName'?: string | null;
    'requiresSignature'?: boolean;
    'fields'?: Array<TemplateSignatureFieldDto> | null;
    'isActive'?: boolean;
}
export interface UpdateTaxBinderDto {
    'name'?: string | null;
    'preparerId'?: string | null;
    'dueDate'?: string | null;
    'notificationDaysPrior'?: number | null;
    'isExtended'?: boolean | null;
    /**
     * URL link to the invoice for this binder
     */
    'invoiceLink'?: string | null;
    /**
     * Sets or updates the engagement letter document for this binder. When set, automatically creates a DocuSeal submission for e-signature (without sending notifications).
     */
    'engagementLetterDocumentId'?: string | null;
}
/**
 * DTO for updating binder processing stage
 */
export interface UpdateTaxBinderStageDto {
    'stage': BinderStage;
}


export interface UpdateUserDto {
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'phoneNumber'?: string | null;
    'company'?: string | null;
}
/**
 * DTO for updating user notification preferences.
 */
export interface UpdateUserNotificationPreferenceDto {
    'isEnabled'?: boolean | null;
    'defaultChannels'?: NotificationDeliveryChannel;
    'defaultBatchStrategy'?: NotificationBatchStrategy;
    'batchIntervalMinutes'?: number | null;
    /**
     * Per-action channel preferences. Key is action type (int), value is delivery channel (int).
     */
    'actionChannelPreferences'?: { [key: string]: number; } | null;
    /**
     * Per-action batch preferences. Key is action type (int), value is batch strategy (int).
     */
    'actionBatchPreferences'?: { [key: string]: number; } | null;
    'notifyPrimaryUser'?: boolean | null;
    'notifySpouse'?: boolean | null;
    'notifyDependents'?: boolean | null;
    'notifyAuthorized'?: boolean | null;
    'notifyAccountant'?: boolean | null;
}


/**
 * DTO for updating user settings. Only provided fields are merged into existing settings. Collection fields (e.g., OfficeIds, Tags) use replace semantics — a non-null list replaces the stored list entirely.
 */
export interface UpdateUserSettingDto {
    'pageDefaults'?: PageDefaultsDto;
}
export interface UploadLinkDetailDto {
    'id'?: string;
    'label'?: string | null;
    'expiresAt'?: string | null;
    'isActive'?: boolean;
    'revokedAt'?: string | null;
    'uploadCount'?: number;
    'recipientCount'?: number;
    'createdAt'?: string;
    'uploadUrl'?: string | null;
    'message'?: string | null;
    'recipientEmails'?: Array<string> | null;
    'documents'?: Array<UploadLinkDocumentDto> | null;
}
export interface UploadLinkDetailDtoApiResponse {
    'success'?: boolean;
    'data'?: UploadLinkDetailDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UploadLinkDocumentDto {
    'id'?: string;
    'name'?: string | null;
    'fileSize'?: number;
    'uploadedAt'?: string;
    'virusScanStatus'?: VirusScanStatus;
}


export interface UploadLinkDto {
    'id'?: string;
    'label'?: string | null;
    'expiresAt'?: string | null;
    'isActive'?: boolean;
    'revokedAt'?: string | null;
    'uploadCount'?: number;
    'recipientCount'?: number;
    'createdAt'?: string;
}
export interface UploadLinkDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<UploadLinkDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Response DTO for the upload signed engagement letter endpoint
 */
export interface UploadSignedEngagementLetterResponseDto {
    /**
     * The ID of the binder
     */
    'binderId'?: string;
    /**
     * The ID of the uploaded signed document
     */
    'documentId'?: string;
    /**
     * When the engagement letter was marked as signed
     */
    'signedAt'?: string;
    'signatureMethod'?: EngagementLetterSignatureMethod;
    /**
     * The ID of the original engagement letter document that was archived (if any)
     */
    'archivedDocumentId'?: string | null;
}


export interface UploadSignedEngagementLetterResponseDtoApiResponse {
    'success'?: boolean;
    'data'?: UploadSignedEngagementLetterResponseDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UploadedFileDto {
    'fileName'?: string | null;
    'uploadedAt'?: string;
}
export interface UploadedFileDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<UploadedFileDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}

export enum UploaderRole {
    Client = 'client',
    Preparer = 'preparer'
}


/**
 * Query parameters for admin user search with advanced filtering
 */
export interface UserAdminSearchQueryDto {
    /**
     * Search term to match against name, email, or phone number
     */
    'search'?: string | null;
    'role'?: UserRole;
    /**
     * Filter by active status
     */
    'isActive'?: boolean | null;
    /**
     * Filter by creation date - start of range
     */
    'createdAfter'?: string | null;
    /**
     * Filter by creation date - end of range
     */
    'createdBefore'?: string | null;
    /**
     * Filter by last login date - start of range
     */
    'lastLoginAfter'?: string | null;
    /**
     * Filter by last login date - end of range
     */
    'lastLoginBefore'?: string | null;
    /**
     * Field to sort by (name, email, role, lastLoginAt, createdAt, clientCount)
     */
    'sortBy'?: string | null;
    /**
     * Sort order (asc or desc)
     */
    'sortOrder'?: string | null;
    /**
     * Page number (1-based)
     */
    'page'?: number;
    /**
     * Number of items per page
     */
    'pageSize'?: number;
}


/**
 * User search result for admin pages, includes client assignment summary
 */
export interface UserAdminSearchResultDto {
    'id'?: string;
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'phoneNumber'?: string | null;
    'company'?: string | null;
    'role'?: UserRole;
    'roleDisplay'?: string | null;
    'isActive'?: boolean;
    'lastLoginAt'?: string | null;
    'createdAt'?: string;
    /**
     * Total number of clients this user is assigned to
     */
    'clientCount'?: number;
    /**
     * Number of possible duplicate users based on matching email or phone
     */
    'possibleDuplicateCount'?: number;
    /**
     * List of client assignments for this user (limited to first 10 for performance)
     */
    'clientAssignments'?: Array<UserClientAssignmentDto> | null;
}


export interface UserAdminSearchResultDtoPaginatedResponse {
    'items'?: Array<UserAdminSearchResultDto> | null;
    'pagination'?: PaginationInfo;
}
export interface UserAdminSearchResultDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: UserAdminSearchResultDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Represents a user\'s assignment to a client
 */
export interface UserClientAssignmentDto {
    'clientId'?: string;
    'clientName'?: string | null;
    'clientNumber'?: string | null;
    'clientType'?: ClientType;
    'clientTypeDisplay'?: string | null;
    'clientUserRole'?: ClientUserRole;
    'clientUserRoleDisplay'?: string | null;
    /**
     * Whether the client is marked as confidential
     */
    'isConfidential'?: boolean;
    /**
     * List of user IDs authorized to access this confidential client
     */
    'authorizedUserIds'?: Array<string> | null;
    /**
     * Name of the user who marked this client as confidential
     */
    'confidentialMarkedByName'?: string | null;
}


export interface UserDto {
    'id'?: string;
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'phoneNumber'?: string | null;
    'company'?: string | null;
    'role'?: UserRole;
    'roleDisplay'?: string | null;
    'isActive'?: boolean;
    'isPartner'?: boolean;
    'emailConfirmed'?: boolean;
    'twoFactorEnabled'?: boolean;
    'lastLoginAt'?: string;
    'createdAt'?: string;
    'updatedAt'?: string;
    'smsConsentGiven'?: boolean;
    'smsConsentTimestamp'?: string | null;
    'smsConsentMethod'?: string | null;
    'smsOptOutTimestamp'?: string | null;
    /**
     * Returns true if the user has active SMS consent (consented and not opted out)
     */
    'hasActiveSmsConsent'?: boolean;
    /**
     * Total number of clients this user is assigned to
     */
    'clientCount'?: number;
    /**
     * List of client assignments for this user
     */
    'clientAssignments'?: Array<UserClientAssignmentDto> | null;
}


export interface UserDtoApiResponse {
    'success'?: boolean;
    'data'?: UserDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UserListDto {
    'id'?: string;
    'email'?: string | null;
    'fullName'?: string | null;
    'phoneNumber'?: string | null;
    'company'?: string | null;
    'role'?: UserRole;
    'roleDisplay'?: string | null;
    'isActive'?: boolean;
    'isPartner'?: boolean;
    'lastLoginAt'?: string;
}


export interface UserListDtoPaginatedResponse {
    'items'?: Array<UserListDto> | null;
    'pagination'?: PaginationInfo;
}
export interface UserListDtoPaginatedResponseApiResponse {
    'success'?: boolean;
    'data'?: UserListDtoPaginatedResponse;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * DTO for user notification preferences.
 */
export interface UserNotificationPreferenceDto {
    'id'?: string;
    'userId'?: string;
    'isEnabled'?: boolean;
    'defaultChannels'?: NotificationDeliveryChannel;
    'defaultBatchStrategy'?: NotificationBatchStrategy;
    'batchIntervalMinutes'?: number;
    /**
     * Per-action channel preferences. Key is action type (int), value is delivery channel (int).
     */
    'actionChannelPreferences'?: { [key: string]: number; } | null;
    /**
     * Per-action batch preferences. Key is action type (int), value is batch strategy (int).
     */
    'actionBatchPreferences'?: { [key: string]: number; } | null;
    'notifyPrimaryUser'?: boolean;
    'notifySpouse'?: boolean;
    'notifyDependents'?: boolean;
    'notifyAuthorized'?: boolean;
    'notifyAccountant'?: boolean;
    'createdAt'?: string;
    'updatedAt'?: string;
}


export interface UserNotificationPreferenceDtoApiResponse {
    'success'?: boolean;
    'data'?: UserNotificationPreferenceDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UserPageDefaultsDto {
    'rowsPerPage'?: number | null;
    'sortBy'?: string | null;
    'sortOrder'?: string | null;
    'role'?: string | null;
    'isActive'?: string | null;
    'createdAfter'?: string | null;
    'createdBefore'?: string | null;
    'lastLoginAfter'?: string | null;
    'lastLoginBefore'?: string | null;
}

export enum UserRole {
    Client = 'client',
    Preparer = 'preparer',
    Admin = 'admin'
}


/**
 * DTO for user search results
 */
export interface UserSearchResultDto {
    'id'?: string;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'email'?: string | null;
    'role'?: UserRole;
}


export interface UserSearchResultDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<UserSearchResultDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Full user settings response including all page defaults.
 */
export interface UserSettingDto {
    'id'?: string;
    'userId'?: string;
    'pageDefaults'?: PageDefaultsDto;
    'createdAt'?: string;
    'updatedAt'?: string;
}
export interface UserSettingDtoApiResponse {
    'success'?: boolean;
    'data'?: UserSettingDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
/**
 * Search result for finding users by name, phone, or email with their client associations
 */
export interface UserWithClientsSearchResultDto {
    'id'?: string;
    'email'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
    'fullName'?: string | null;
    'phoneNumber'?: string | null;
    'role'?: UserRole;
    'roleDisplay'?: string | null;
    /**
     * List of clients this user is currently assigned to
     */
    'clientAssignments'?: Array<UserClientAssignmentDto> | null;
}


export interface UserWithClientsSearchResultDtoApiResponse {
    'success'?: boolean;
    'data'?: UserWithClientsSearchResultDto;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface UserWithClientsSearchResultDtoListApiResponse {
    'success'?: boolean;
    'data'?: Array<UserWithClientsSearchResultDto> | null;
    'error'?: ApiError;
    'meta'?: ApiMeta;
}
export interface VerifyCodeDto {
    'emailOrPhone': string;
    'clientId': string;
    'code': string;
    'rememberMe'?: boolean;
}
/**
 * DTO for verifying email with code
 */
export interface VerifyEmailDto {
    /**
     * The 6-digit verification code sent to the email
     */
    'code': string;
}
/**
 * DTO for verifying phone number with code
 */
export interface VerifyPhoneDto {
    /**
     * The 6-digit verification code sent to the phone
     */
    'code': string;
}
/**
 * DTO for verifying spouse information on a binder. Primary users can provide updates to marital status and spouse contact info. Spouse users can only acknowledge (no updates allowed).
 */
export interface VerifySpouseInfoDto {
    /**
     * Client\'s email address. Used to update the client\'s contact info.
     */
    'email'?: string | null;
    /**
     * Client\'s phone number. Used to update the client\'s contact info.
     */
    'phoneNumber'?: string | null;
    'maritalStatus'?: MaritalStatus;
    /**
     * Spouse\'s email address. Only Primary users can modify this.
     */
    'spouseEmail'?: string | null;
    /**
     * Spouse\'s phone number. Only Primary users can modify this.
     */
    'spousePhone'?: string | null;
    /**
     * Spouse\'s first name. Only Primary users can modify this. Used when creating/updating spouse information.
     */
    'spouseFirstName'?: string | null;
    /**
     * Spouse\'s last name. Only Primary users can modify this. Used when creating/updating spouse information.
     */
    'spouseLastName'?: string | null;
    /**
     * Spouse\'s Social Security Number (Tax ID). Required when creating a new spouse. Format: 9 digits (no dashes).
     */
    'spouseSsn'?: string | null;
    /**
     * Spouse\'s date of birth.
     */
    'spouseDateOfBirth'?: string | null;
    /**
     * Date of marriage. Used when adding a new spouse.
     */
    'marriageDate'?: string | null;
    /**
     * Indicates this is a new spouse (remarried scenario). When true, a new spouse user will be created and the old spouse link removed.
     */
    'isNewSpouse'?: boolean;
    /**
     * Indicates the previous spouse relationship has ended (divorced or deceased). When true, the existing spouse user link will be removed.
     */
    'removeSpouse'?: boolean;
}



export enum VirusScanStatus {
    Pending = 'pending',
    Clean = 'clean',
    Infected = 'infected',
    ScanFailed = 'scanFailed'
}



export enum VoucherQuarter {
    Q1 = 'q1',
    Q2 = 'q2',
    Q3 = 'q3',
    Q4 = 'q4'
}


/**
 * Average days for key workflow transitions (null when no qualifying binders exist)
 */
export interface WorkflowTimingDto {
    /**
     * Avg days from binder creation (Open) to Sent for Preparation. Excludes tax-return-only binders that skip directly to SentForPreparation.
     */
    'avgDaysOpenToSentForPrep'?: number | null;
    /**
     * Avg days from Client Submitted to In Review
     */
    'avgDaysClientSubmittedToInReview'?: number | null;
    /**
     * Avg days from Efile Ready to Completed
     */
    'avgDaysEfileReadyToCompleted'?: number | null;
    /**
     * Avg days from binder creation (Open) to Completed
     */
    'avgDaysOpenToCompleted'?: number | null;
}

/**
 * AdminApi - axios parameter creator
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Triggers the one-time ReclassifyFilingInstructionsJob to fix misclassified estimated tax filing instructions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminJobsReclassifyFilingInstructionsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Admin/jobs/reclassify-filing-instructions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Runs orphan file cleanup with optional dry-run mode
         * @param {boolean} [dryRun] If true, only detects orphans without deleting (default: true)
         * @param {number} [maxFiles] Maximum number of files to process (safety limit)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesCleanupPost: async (dryRun?: boolean, maxFiles?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Admin/orphan-files/cleanup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }

            if (maxFiles !== undefined) {
                localVarQueryParameter['maxFiles'] = maxFiles;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detects orphaned files in storage without deleting them (dry-run scan)
         * @param {number} [minimumAgeInDays] Minimum age in days for files to be considered (default: 7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesDetectGet: async (minimumAgeInDays?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Admin/orphan-files/detect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (minimumAgeInDays !== undefined) {
                localVarQueryParameter['minimumAgeInDays'] = minimumAgeInDays;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a specific orphaned file by storage key (admin manual cleanup)
         * @param {string} storageKey Storage key of the file to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesStorageKeyDelete: async (storageKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storageKey' is not null or undefined
            assertParamExists('apiAdminOrphanFilesStorageKeyDelete', 'storageKey', storageKey)
            const localVarPath = `/api/Admin/orphan-files/{storageKey}`
                .replace(`{${"storageKey"}}`, encodeURIComponent(String(storageKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the current PDF conversion configuration settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminPdfConversionConfigGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Admin/pdf-conversion-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets storage usage metrics and statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminStorageMetricsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Admin/storage/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Triggers the one-time ReclassifyFilingInstructionsJob to fix misclassified estimated tax filing instructions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminJobsReclassifyFilingInstructionsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminJobsReclassifyFilingInstructionsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminJobsReclassifyFilingInstructionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Runs orphan file cleanup with optional dry-run mode
         * @param {boolean} [dryRun] If true, only detects orphans without deleting (default: true)
         * @param {number} [maxFiles] Maximum number of files to process (safety limit)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminOrphanFilesCleanupPost(dryRun?: boolean, maxFiles?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrphanFileCleanupResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminOrphanFilesCleanupPost(dryRun, maxFiles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminOrphanFilesCleanupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detects orphaned files in storage without deleting them (dry-run scan)
         * @param {number} [minimumAgeInDays] Minimum age in days for files to be considered (default: 7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminOrphanFilesDetectGet(minimumAgeInDays?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrphanedFileInfoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminOrphanFilesDetectGet(minimumAgeInDays, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminOrphanFilesDetectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a specific orphaned file by storage key (admin manual cleanup)
         * @param {string} storageKey Storage key of the file to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminOrphanFilesStorageKeyDelete(storageKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminOrphanFilesStorageKeyDelete(storageKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminOrphanFilesStorageKeyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the current PDF conversion configuration settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminPdfConversionConfigGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfConversionConfigDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminPdfConversionConfigGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminPdfConversionConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets storage usage metrics and statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminStorageMetricsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageMetricsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminStorageMetricsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminStorageMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Triggers the one-time ReclassifyFilingInstructionsJob to fix misclassified estimated tax filing instructions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminJobsReclassifyFilingInstructionsPost(options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiAdminJobsReclassifyFilingInstructionsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Runs orphan file cleanup with optional dry-run mode
         * @param {AdminApiApiAdminOrphanFilesCleanupPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesCleanupPost(requestParameters: AdminApiApiAdminOrphanFilesCleanupPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrphanFileCleanupResultApiResponse> {
            return localVarFp.apiAdminOrphanFilesCleanupPost(requestParameters.dryRun, requestParameters.maxFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detects orphaned files in storage without deleting them (dry-run scan)
         * @param {AdminApiApiAdminOrphanFilesDetectGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesDetectGet(requestParameters: AdminApiApiAdminOrphanFilesDetectGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrphanedFileInfoListApiResponse> {
            return localVarFp.apiAdminOrphanFilesDetectGet(requestParameters.minimumAgeInDays, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a specific orphaned file by storage key (admin manual cleanup)
         * @param {AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOrphanFilesStorageKeyDelete(requestParameters: AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiAdminOrphanFilesStorageKeyDelete(requestParameters.storageKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the current PDF conversion configuration settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminPdfConversionConfigGet(options?: RawAxiosRequestConfig): AxiosPromise<PdfConversionConfigDtoApiResponse> {
            return localVarFp.apiAdminPdfConversionConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets storage usage metrics and statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminStorageMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<StorageMetricsDtoApiResponse> {
            return localVarFp.apiAdminStorageMetricsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - interface
 */
export interface AdminApiInterface {
    /**
     * 
     * @summary Triggers the one-time ReclassifyFilingInstructionsJob to fix misclassified estimated tax filing instructions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminJobsReclassifyFilingInstructionsPost(options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary Runs orphan file cleanup with optional dry-run mode
     * @param {AdminApiApiAdminOrphanFilesCleanupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminOrphanFilesCleanupPost(requestParameters?: AdminApiApiAdminOrphanFilesCleanupPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrphanFileCleanupResultApiResponse>;

    /**
     * 
     * @summary Detects orphaned files in storage without deleting them (dry-run scan)
     * @param {AdminApiApiAdminOrphanFilesDetectGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminOrphanFilesDetectGet(requestParameters?: AdminApiApiAdminOrphanFilesDetectGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrphanedFileInfoListApiResponse>;

    /**
     * 
     * @summary Deletes a specific orphaned file by storage key (admin manual cleanup)
     * @param {AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminOrphanFilesStorageKeyDelete(requestParameters: AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary Gets the current PDF conversion configuration settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminPdfConversionConfigGet(options?: RawAxiosRequestConfig): AxiosPromise<PdfConversionConfigDtoApiResponse>;

    /**
     * 
     * @summary Gets storage usage metrics and statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminStorageMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<StorageMetricsDtoApiResponse>;

}

/**
 * Request parameters for apiAdminOrphanFilesCleanupPost operation in AdminApi.
 */
export interface AdminApiApiAdminOrphanFilesCleanupPostRequest {
    /**
     * If true, only detects orphans without deleting (default: true)
     */
    readonly dryRun?: boolean

    /**
     * Maximum number of files to process (safety limit)
     */
    readonly maxFiles?: number
}

/**
 * Request parameters for apiAdminOrphanFilesDetectGet operation in AdminApi.
 */
export interface AdminApiApiAdminOrphanFilesDetectGetRequest {
    /**
     * Minimum age in days for files to be considered (default: 7)
     */
    readonly minimumAgeInDays?: number
}

/**
 * Request parameters for apiAdminOrphanFilesStorageKeyDelete operation in AdminApi.
 */
export interface AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest {
    /**
     * Storage key of the file to delete
     */
    readonly storageKey: string
}

/**
 * AdminApi - object-oriented interface
 */
export class AdminApi extends BaseAPI implements AdminApiInterface {
    /**
     * 
     * @summary Triggers the one-time ReclassifyFilingInstructionsJob to fix misclassified estimated tax filing instructions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminJobsReclassifyFilingInstructionsPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminJobsReclassifyFilingInstructionsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Runs orphan file cleanup with optional dry-run mode
     * @param {AdminApiApiAdminOrphanFilesCleanupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminOrphanFilesCleanupPost(requestParameters: AdminApiApiAdminOrphanFilesCleanupPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminOrphanFilesCleanupPost(requestParameters.dryRun, requestParameters.maxFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detects orphaned files in storage without deleting them (dry-run scan)
     * @param {AdminApiApiAdminOrphanFilesDetectGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminOrphanFilesDetectGet(requestParameters: AdminApiApiAdminOrphanFilesDetectGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminOrphanFilesDetectGet(requestParameters.minimumAgeInDays, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a specific orphaned file by storage key (admin manual cleanup)
     * @param {AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminOrphanFilesStorageKeyDelete(requestParameters: AdminApiApiAdminOrphanFilesStorageKeyDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminOrphanFilesStorageKeyDelete(requestParameters.storageKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the current PDF conversion configuration settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminPdfConversionConfigGet(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminPdfConversionConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets storage usage metrics and statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminStorageMetricsGet(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminStorageMetricsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminDashboardApi - axios parameter creator
 */
export const AdminDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves the audit admin dashboard: firm-wide audit binder summary stats, per-preparer, per-office and per-partner breakdowns, stage distribution, and workflow timing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDashboardAuditGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin-dashboard/audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves comprehensive admin dashboard data including firm-wide summary stats, per-preparer breakdown, per-office breakdown, stage distribution, and additional metrics.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDashboardGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin-dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDashboardApi - functional programming interface
 */
export const AdminDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves the audit admin dashboard: firm-wide audit binder summary stats, per-preparer, per-office and per-partner breakdowns, stage distribution, and workflow timing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminDashboardAuditGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditAdminDashboardDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminDashboardAuditGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDashboardApi.apiAdminDashboardAuditGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves comprehensive admin dashboard data including firm-wide summary stats, per-preparer breakdown, per-office breakdown, stage distribution, and additional metrics.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminDashboardGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDashboardDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminDashboardGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDashboardApi.apiAdminDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDashboardApi - factory interface
 */
export const AdminDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves the audit admin dashboard: firm-wide audit binder summary stats, per-preparer, per-office and per-partner breakdowns, stage distribution, and workflow timing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDashboardAuditGet(options?: RawAxiosRequestConfig): AxiosPromise<AuditAdminDashboardDtoApiResponse> {
            return localVarFp.apiAdminDashboardAuditGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves comprehensive admin dashboard data including firm-wide summary stats, per-preparer breakdown, per-office breakdown, stage distribution, and additional metrics.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<AdminDashboardDtoApiResponse> {
            return localVarFp.apiAdminDashboardGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDashboardApi - interface
 */
export interface AdminDashboardApiInterface {
    /**
     * 
     * @summary Retrieves the audit admin dashboard: firm-wide audit binder summary stats, per-preparer, per-office and per-partner breakdowns, stage distribution, and workflow timing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminDashboardAuditGet(options?: RawAxiosRequestConfig): AxiosPromise<AuditAdminDashboardDtoApiResponse>;

    /**
     * 
     * @summary Retrieves comprehensive admin dashboard data including firm-wide summary stats, per-preparer breakdown, per-office breakdown, stage distribution, and additional metrics.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<AdminDashboardDtoApiResponse>;

}

/**
 * AdminDashboardApi - object-oriented interface
 */
export class AdminDashboardApi extends BaseAPI implements AdminDashboardApiInterface {
    /**
     * 
     * @summary Retrieves the audit admin dashboard: firm-wide audit binder summary stats, per-preparer, per-office and per-partner breakdowns, stage distribution, and workflow timing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminDashboardAuditGet(options?: RawAxiosRequestConfig) {
        return AdminDashboardApiFp(this.configuration).apiAdminDashboardAuditGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves comprehensive admin dashboard data including firm-wide summary stats, per-preparer breakdown, per-office breakdown, stage distribution, and additional metrics.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminDashboardGet(options?: RawAxiosRequestConfig) {
        return AdminDashboardApiFp(this.configuration).apiAdminDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditBindersApi - axios parameter creator
 */
export const AuditBindersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all upload links for this audit binder. Staff only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksGet', 'binderId', binderId)
            const localVarPath = `/api/audit-binders/{binderId}/upload-links`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the full detail of an upload link (message, recipients, uploaded files). Staff only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksLinkIdGet: async (binderId: string, linkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksLinkIdGet', 'binderId', binderId)
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksLinkIdGet', 'linkId', linkId)
            const localVarPath = `/api/audit-binders/{binderId}/upload-links/{linkId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"linkId"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke an active upload link on this audit binder. Staff only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksLinkIdRevokePost: async (binderId: string, linkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksLinkIdRevokePost', 'binderId', binderId)
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksLinkIdRevokePost', 'linkId', linkId)
            const localVarPath = `/api/audit-binders/{binderId}/upload-links/{linkId}/revoke`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"linkId"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new external upload link for this audit binder. Staff only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {CreateUploadLinkDto} [createUploadLinkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksPost: async (binderId: string, createUploadLinkDto?: CreateUploadLinkDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdUploadLinksPost', 'binderId', binderId)
            const localVarPath = `/api/audit-binders/{binderId}/upload-links`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUploadLinkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin-only \"Recently deleted audit binders\": every deleted binder with who deleted it, why and when it is purged, plus what the next purge run would remove (the purge\'s dry-run report). View only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersDeletedGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit-binders/deleted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin-only, read-only report of stored files that audit binder deletes from before soft deletes left behind: unreferenced files of binders that no longer exist and were audit binders. Scans the whole storage container; deletes nothing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersDeletedLeftoverFilesReportGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit-binders/deleted/leftover-files-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paginated list of audit binders for the preparer management view. Supports search (binder name, client name, client number), audit period overlap, due date range, stage multi-select, and office filtering.
         * @param {string} [clientId] Use an existing client ID
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {Array<AuditBinderStage>} [stages] Multi-select stage filter for the preparer audit dashboard. When null or empty, the service excludes Op.ClientTaxSystem.Data.Models.AuditBinderStage.Complete by default (dashboard \&quot;all open work\&quot; default).
         * @param {string} [dueDateStart] Filter by due date range (inclusive). UTC dates.
         * @param {string} [dueDateEnd] 
         * @param {string} [periodStart] Filter by audit period overlap. Matches binders where PeriodStart &lt;&#x3D; PeriodEnd and PeriodEnd &gt;&#x3D; PeriodStart (i.e., the ranges intersect). UTC dates.
         * @param {string} [periodEnd] 
         * @param {boolean} [watchedClientsOnly] Restrict results to clients the current user watches. Applies to any role.
         * @param {boolean} [assignedToMe] Restrict results to binders where the current user is the assigned preparer. Ignored when PreparerId is also set.
         * @param {boolean} [isArchived] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {AuditDocumentRequestType} [requestType] When set, the Documents and Progress columns are scoped to document requests of this type only (counts of total/approved documents and total/completed requests are limited to the matching request type).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersGet: async (clientId?: string, preparerId?: string, officeId?: string, stages?: Array<AuditBinderStage>, dueDateStart?: string, dueDateEnd?: string, periodStart?: string, periodEnd?: string, watchedClientsOnly?: boolean, assignedToMe?: boolean, isArchived?: boolean, search?: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, requestType?: AuditDocumentRequestType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit-binders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (preparerId !== undefined) {
                localVarQueryParameter['PreparerId'] = preparerId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            if (stages) {
                localVarQueryParameter['Stages'] = stages;
            }

            if (dueDateStart !== undefined) {
                localVarQueryParameter['DueDateStart'] = (dueDateStart as any instanceof Date) ?
                    (dueDateStart as any).toISOString() :
                    dueDateStart;
            }

            if (dueDateEnd !== undefined) {
                localVarQueryParameter['DueDateEnd'] = (dueDateEnd as any instanceof Date) ?
                    (dueDateEnd as any).toISOString() :
                    dueDateEnd;
            }

            if (periodStart !== undefined) {
                localVarQueryParameter['PeriodStart'] = (periodStart as any instanceof Date) ?
                    (periodStart as any).toISOString() :
                    periodStart;
            }

            if (periodEnd !== undefined) {
                localVarQueryParameter['PeriodEnd'] = (periodEnd as any instanceof Date) ?
                    (periodEnd as any).toISOString() :
                    periodEnd;
            }

            if (watchedClientsOnly !== undefined) {
                localVarQueryParameter['WatchedClientsOnly'] = watchedClientsOnly;
            }

            if (assignedToMe !== undefined) {
                localVarQueryParameter['AssignedToMe'] = assignedToMe;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['IsArchived'] = isArchived;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (requestType !== undefined) {
                localVarQueryParameter['RequestType'] = requestType;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdDelete', 'id', id)
            const localVarPath = `/api/audit-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary One-shot fetch for the audit binder detail screen. Returns binder + items + per-item docs/comments/activity + binder-level docs/comments/activity + summary counts. Clients are scoped to their active client via the X-Active-Client-Id header; preparers/admins see any binder.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDetailGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdDetailGet', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload one or more documents to this audit binder. Separate from the shared /api/documents/upload endpoint — audit uploads skip tax-form classification, AI form detection, and signature templates. Optionally scoped to a request item via `DocumentRequestId`.
         * @param {string} id 
         * @param {Array<File>} files 
         * @param {string} [documentRequestId] Optional — tie these uploads to a specific request item on this binder.
         * @param {string} [comment] Optional comment recorded on the Document row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDocumentsPost: async (id: string, files: Array<File>, documentRequestId?: string, comment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdDocumentsPost', 'id', id)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('apiAuditBindersIdDocumentsPost', 'files', files)
            const localVarPath = `/api/audit-binders/{id}/documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element as any);
                })
            }


            if (documentRequestId !== undefined) { 
                localVarFormParams.append('DocumentRequestId', documentRequestId as any);
            }

            if (comment !== undefined) { 
                localVarFormParams.append('Comment', comment as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bundle the specified binder documents into a zip archive and stream it back as an attachment. Staff-only — clients don\'t need bulk export.
         * @param {string} id 
         * @param {ExportAuditBinderDocumentsDto} [exportAuditBinderDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDocumentsZipPost: async (id: string, exportAuditBinderDocumentsDto?: ExportAuditBinderDocumentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdDocumentsZipPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/documents/zip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportAuditBinderDocumentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Turn a final deliverable back into an ordinary document. It is not deleted, and the client access window is unchanged.
         * @param {string} id 
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDeliverablesDocumentIdDelete: async (id: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdFinalDeliverablesDocumentIdDelete', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiAuditBindersIdFinalDeliverablesDocumentIdDelete', 'documentId', documentId)
            const localVarPath = `/api/audit-binders/{id}/final-deliverables/{documentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark existing firm-uploaded binder documents as final deliverables, appended in the given order. Same window and notification rules as an upload.
         * @param {string} id 
         * @param {MarkAuditBinderFinalDeliverablesDto} [markAuditBinderFinalDeliverablesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDeliverablesMarkPost: async (id: string, markAuditBinderFinalDeliverablesDto?: MarkAuditBinderFinalDeliverablesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdFinalDeliverablesMarkPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/final-deliverables/mark`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markAuditBinderFinalDeliverablesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the display order of the final deliverables; the first is the primary report.
         * @param {string} id 
         * @param {ReorderAuditBinderFinalDeliverablesDto} [reorderAuditBinderFinalDeliverablesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDeliverablesOrderPut: async (id: string, reorderAuditBinderFinalDeliverablesDto?: ReorderAuditBinderFinalDeliverablesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdFinalDeliverablesOrderPut', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/final-deliverables/order`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderAuditBinderFinalDeliverablesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload one or more files, each becoming a final deliverable appended after the existing ones. Restarts the client access window; on a Complete binder the client gets one \"new final deliverable\" notice.
         * @param {string} id 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDeliverablesPost: async (id: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdFinalDeliverablesPost', 'id', id)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('apiAuditBindersIdFinalDeliverablesPost', 'files', files)
            const localVarPath = `/api/audit-binders/{id}/final-deliverables`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Every final deliverable in one ZIP, recorded as a download of each file. Clients get it only once the binder is Complete and while their access window lasts.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDeliverablesZipGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdFinalDeliverablesZipGet', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/final-deliverables/zip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdGet', 'id', id)
            const localVarPath = `/api/audit-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import document requests from an .xlsx file. Columns used: D = Due Date, E = Description (→ Title), F = Category (→ RequestType). Only permitted when the binder is in New or PreReleaseReview stage.
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportDocumentRequestsPost: async (id: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdImportDocumentRequestsPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/import-document-requests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a .zip; a background job creates a DocumentRequest per folder/subfolder and attaches the files, streaming progress over SignalR. Returns 202 with an operationId. Only permitted while the binder is in New or PreReleaseReview stage.
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportDocumentsFromZipPost: async (id: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdImportDocumentsFromZipPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/import-documents-from-zip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Copy the chosen requests from the client\'s previous binder into this one. All or nothing; only while this binder is in New or Pre-Release Review. The client is not notified.
         * @param {string} id 
         * @param {ImportRequestsFromBinderDto} [importRequestsFromBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportFromBinderPost: async (id: string, importRequestsFromBinderDto?: ImportRequestsFromBinderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdImportFromBinderPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/import-from-binder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importRequestsFromBinderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The binders this one can copy requests from: the client\'s active binder and its Complete binder, whichever exist, most recent first.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportSourcesGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdImportSourcesGet', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/import-sources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Every request in a source binder, flagged for the picker: already in this binder, N/A in the source, or confidential with a visible user who no longer has access to the client.
         * @param {string} id 
         * @param {string} sourceBinderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet: async (id: string, sourceBinderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet', 'id', id)
            // verify required parameter 'sourceBinderId' is not null or undefined
            assertParamExists('apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet', 'sourceBinderId', sourceBinderId)
            const localVarPath = `/api/audit-binders/{id}/import-sources/{sourceBinderId}/requests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"sourceBinderId"}}`, encodeURIComponent(String(sourceBinderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The client\'s other audit binders that the one-active / one-Completed limits weigh against this one: the active binder that blocks Release and Reopen, and the Complete binders that completing deletes.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdLimitsGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdLimitsGet', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/limits`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAuditBinderDto} [updateAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdPut: async (id: string, updateAuditBinderDto?: UpdateAuditBinderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdPut', 'id', id)
            const localVarPath = `/api/audit-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAuditBinderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Take a signature request off the binder. Permitted at any signing stage, since a signed document can still be the wrong document.
         * @param {string} id 
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {boolean} [confirmCancellation] 
         * @param {boolean} [removeDocument] 
         * @param {boolean} [notifySigners] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsDocumentIdDelete: async (id: string, documentId: string, confirmCancellation?: boolean, removeDocument?: boolean, notifySigners?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsDocumentIdDelete', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsDocumentIdDelete', 'documentId', documentId)
            const localVarPath = `/api/audit-binders/{id}/signature-documents/{documentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (confirmCancellation !== undefined) {
                localVarQueryParameter['confirmCancellation'] = confirmCancellation;
            }

            if (removeDocument !== undefined) {
                localVarQueryParameter['removeDocument'] = removeDocument;
            }

            if (notifySigners !== undefined) {
                localVarQueryParameter['notifySigners'] = notifySigners;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Re-send a signature document with corrected fields/signers. Allowed only while no signer has signed — voids the current submission and creates a fresh one for the same document. The document id comes from the route.
         * @param {string} id 
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsDocumentIdPut: async (id: string, documentId: string, createSignatureRequestDto?: CreateSignatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsDocumentIdPut', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsDocumentIdPut', 'documentId', documentId)
            const localVarPath = `/api/audit-binders/{id}/signature-documents/{documentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSignatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Embedded signing session (DocuSeal slug) for the current user on a signature document. Returns 403-style error if the caller isn\'t an assigned signer. Clients are scoped to their active client.
         * @param {string} id 
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet: async (id: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet', 'documentId', documentId)
            const localVarPath = `/api/audit-binders/{id}/signature-documents/{documentId}/signing-session`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Client users eligible to be assigned as signers on a signature document for this binder\'s client. Includes all client-user relationships on the account.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsEligibleSignersGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsEligibleSignersGet', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/signature-documents/eligible-signers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a previously-uploaded binder document for e-signature. Placed fields are assigned to client-user signers by role. Creates a DocuSeal submission in embedded mode (signers sign in-app); notifications are driven by our system.
         * @param {string} id 
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsPost: async (id: string, createSignatureRequestDto?: CreateSignatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdSignatureDocumentsPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/signature-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSignatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move the binder to a new stage. Preparers/admins only.
         * @param {string} id 
         * @param {TransitionAuditBinderDto} [transitionAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdTransitionPost: async (id: string, transitionAuditBinderDto?: TransitionAuditBinderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuditBindersIdTransitionPost', 'id', id)
            const localVarPath = `/api/audit-binders/{id}/transition`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transitionAuditBinderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAuditBinderDto} [createAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersPost: async (createAuditBinderDto?: CreateAuditBinderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit-binders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAuditBinderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditBindersApi - functional programming interface
 */
export const AuditBindersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditBindersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all upload links for this audit binder. Staff only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdUploadLinksGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLinkDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdUploadLinksGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersBinderIdUploadLinksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the full detail of an upload link (message, recipients, uploaded files). Staff only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdUploadLinksLinkIdGet(binderId: string, linkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLinkDetailDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdUploadLinksLinkIdGet(binderId, linkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersBinderIdUploadLinksLinkIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke an active upload link on this audit binder. Staff only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(binderId: string, linkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(binderId, linkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersBinderIdUploadLinksLinkIdRevokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new external upload link for this audit binder. Staff only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {CreateUploadLinkDto} [createUploadLinkDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdUploadLinksPost(binderId: string, createUploadLinkDto?: CreateUploadLinkDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLinkDetailDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdUploadLinksPost(binderId, createUploadLinkDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersBinderIdUploadLinksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin-only \"Recently deleted audit binders\": every deleted binder with who deleted it, why and when it is purged, plus what the next purge run would remove (the purge\'s dry-run report). View only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersDeletedGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeletedAuditBindersDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersDeletedGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersDeletedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin-only, read-only report of stored files that audit binder deletes from before soft deletes left behind: unreferenced files of binders that no longer exist and were audit binders. Scans the whole storage container; deletes nothing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersDeletedLeftoverFilesReportGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeftoverAuditBinderFilesReportDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersDeletedLeftoverFilesReportGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersDeletedLeftoverFilesReportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Paginated list of audit binders for the preparer management view. Supports search (binder name, client name, client number), audit period overlap, due date range, stage multi-select, and office filtering.
         * @param {string} [clientId] Use an existing client ID
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {Array<AuditBinderStage>} [stages] Multi-select stage filter for the preparer audit dashboard. When null or empty, the service excludes Op.ClientTaxSystem.Data.Models.AuditBinderStage.Complete by default (dashboard \&quot;all open work\&quot; default).
         * @param {string} [dueDateStart] Filter by due date range (inclusive). UTC dates.
         * @param {string} [dueDateEnd] 
         * @param {string} [periodStart] Filter by audit period overlap. Matches binders where PeriodStart &lt;&#x3D; PeriodEnd and PeriodEnd &gt;&#x3D; PeriodStart (i.e., the ranges intersect). UTC dates.
         * @param {string} [periodEnd] 
         * @param {boolean} [watchedClientsOnly] Restrict results to clients the current user watches. Applies to any role.
         * @param {boolean} [assignedToMe] Restrict results to binders where the current user is the assigned preparer. Ignored when PreparerId is also set.
         * @param {boolean} [isArchived] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {AuditDocumentRequestType} [requestType] When set, the Documents and Progress columns are scoped to document requests of this type only (counts of total/approved documents and total/completed requests are limited to the matching request type).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersGet(clientId?: string, preparerId?: string, officeId?: string, stages?: Array<AuditBinderStage>, dueDateStart?: string, dueDateEnd?: string, periodStart?: string, periodEnd?: string, watchedClientsOnly?: boolean, assignedToMe?: boolean, isArchived?: boolean, search?: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, requestType?: AuditDocumentRequestType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersGet(clientId, preparerId, officeId, stages, dueDateStart, dueDateEnd, periodStart, periodEnd, watchedClientsOnly, assignedToMe, isArchived, search, page, limit, sortBy, sortOrder, requestType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary One-shot fetch for the audit binder detail screen. Returns binder + items + per-item docs/comments/activity + binder-level docs/comments/activity + summary counts. Clients are scoped to their active client via the X-Active-Client-Id header; preparers/admins see any binder.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdDetailGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDetailDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdDetailGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdDetailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload one or more documents to this audit binder. Separate from the shared /api/documents/upload endpoint — audit uploads skip tax-form classification, AI form detection, and signature templates. Optionally scoped to a request item via `DocumentRequestId`.
         * @param {string} id 
         * @param {Array<File>} files 
         * @param {string} [documentRequestId] Optional — tie these uploads to a specific request item on this binder.
         * @param {string} [comment] Optional comment recorded on the Document row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdDocumentsPost(id: string, files: Array<File>, documentRequestId?: string, comment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdDocumentsPost(id, files, documentRequestId, comment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bundle the specified binder documents into a zip archive and stream it back as an attachment. Staff-only — clients don\'t need bulk export.
         * @param {string} id 
         * @param {ExportAuditBinderDocumentsDto} [exportAuditBinderDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdDocumentsZipPost(id: string, exportAuditBinderDocumentsDto?: ExportAuditBinderDocumentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdDocumentsZipPost(id, exportAuditBinderDocumentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdDocumentsZipPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Turn a final deliverable back into an ordinary document. It is not deleted, and the client access window is unchanged.
         * @param {string} id 
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdFinalDeliverablesDocumentIdDelete(id: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdFinalDeliverablesDocumentIdDelete(id, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdFinalDeliverablesDocumentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark existing firm-uploaded binder documents as final deliverables, appended in the given order. Same window and notification rules as an upload.
         * @param {string} id 
         * @param {MarkAuditBinderFinalDeliverablesDto} [markAuditBinderFinalDeliverablesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdFinalDeliverablesMarkPost(id: string, markAuditBinderFinalDeliverablesDto?: MarkAuditBinderFinalDeliverablesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdFinalDeliverablesMarkPost(id, markAuditBinderFinalDeliverablesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdFinalDeliverablesMarkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set the display order of the final deliverables; the first is the primary report.
         * @param {string} id 
         * @param {ReorderAuditBinderFinalDeliverablesDto} [reorderAuditBinderFinalDeliverablesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdFinalDeliverablesOrderPut(id: string, reorderAuditBinderFinalDeliverablesDto?: ReorderAuditBinderFinalDeliverablesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdFinalDeliverablesOrderPut(id, reorderAuditBinderFinalDeliverablesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdFinalDeliverablesOrderPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload one or more files, each becoming a final deliverable appended after the existing ones. Restarts the client access window; on a Complete binder the client gets one \"new final deliverable\" notice.
         * @param {string} id 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdFinalDeliverablesPost(id: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdFinalDeliverablesPost(id, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdFinalDeliverablesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Every final deliverable in one ZIP, recorded as a download of each file. Clients get it only once the binder is Complete and while their access window lasts.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdFinalDeliverablesZipGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdFinalDeliverablesZipGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdFinalDeliverablesZipGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import document requests from an .xlsx file. Columns used: D = Due Date, E = Description (→ Title), F = Category (→ RequestType). Only permitted when the binder is in New or PreReleaseReview stage.
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdImportDocumentRequestsPost(id: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportDocumentRequestsResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdImportDocumentRequestsPost(id, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdImportDocumentRequestsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a .zip; a background job creates a DocumentRequest per folder/subfolder and attaches the files, streaming progress over SignalR. Returns 202 with an operationId. Only permitted while the binder is in New or PreReleaseReview stage.
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdImportDocumentsFromZipPost(id: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportZipQueuedDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdImportDocumentsFromZipPost(id, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdImportDocumentsFromZipPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Copy the chosen requests from the client\'s previous binder into this one. All or nothing; only while this binder is in New or Pre-Release Review. The client is not notified.
         * @param {string} id 
         * @param {ImportRequestsFromBinderDto} [importRequestsFromBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdImportFromBinderPost(id: string, importRequestsFromBinderDto?: ImportRequestsFromBinderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportRequestsFromBinderResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdImportFromBinderPost(id, importRequestsFromBinderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdImportFromBinderPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary The binders this one can copy requests from: the client\'s active binder and its Complete binder, whichever exist, most recent first.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdImportSourcesGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderImportSourcesDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdImportSourcesGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdImportSourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Every request in a source binder, flagged for the picker: already in this binder, N/A in the source, or confidential with a visible user who no longer has access to the client.
         * @param {string} id 
         * @param {string} sourceBinderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet(id: string, sourceBinderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderImportSourceRequestsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet(id, sourceBinderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary The client\'s other audit binders that the one-active / one-Completed limits weigh against this one: the active binder that blocks Release and Reopen, and the Complete binders that completing deletes.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdLimitsGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderLimitsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdLimitsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdLimitsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAuditBinderDto} [updateAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdPut(id: string, updateAuditBinderDto?: UpdateAuditBinderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdPut(id, updateAuditBinderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Take a signature request off the binder. Permitted at any signing stage, since a signed document can still be the wrong document.
         * @param {string} id 
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {boolean} [confirmCancellation] 
         * @param {boolean} [removeDocument] 
         * @param {boolean} [notifySigners] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdSignatureDocumentsDocumentIdDelete(id: string, documentId: string, confirmCancellation?: boolean, removeDocument?: boolean, notifySigners?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveSignatureRequestResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdSignatureDocumentsDocumentIdDelete(id, documentId, confirmCancellation, removeDocument, notifySigners, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdSignatureDocumentsDocumentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Re-send a signature document with corrected fields/signers. Allowed only while no signer has signed — voids the current submission and creates a fresh one for the same document. The document id comes from the route.
         * @param {string} id 
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdSignatureDocumentsDocumentIdPut(id: string, documentId: string, createSignatureRequestDto?: CreateSignatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureRequestResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdSignatureDocumentsDocumentIdPut(id, documentId, createSignatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdSignatureDocumentsDocumentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Embedded signing session (DocuSeal slug) for the current user on a signature document. Returns 403-style error if the caller isn\'t an assigned signer. Clients are scoped to their active client.
         * @param {string} id 
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(id: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureSigningSessionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(id, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Client users eligible to be assigned as signers on a signature document for this binder\'s client. Includes all client-user relationships on the account.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdSignatureDocumentsEligibleSignersGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibleSignersDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdSignatureDocumentsEligibleSignersGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdSignatureDocumentsEligibleSignersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send a previously-uploaded binder document for e-signature. Placed fields are assigned to client-user signers by role. Creates a DocuSeal submission in embedded mode (signers sign in-app); notifications are driven by our system.
         * @param {string} id 
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdSignatureDocumentsPost(id: string, createSignatureRequestDto?: CreateSignatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureRequestResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdSignatureDocumentsPost(id, createSignatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdSignatureDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Move the binder to a new stage. Preparers/admins only.
         * @param {string} id 
         * @param {TransitionAuditBinderDto} [transitionAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersIdTransitionPost(id: string, transitionAuditBinderDto?: TransitionAuditBinderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersIdTransitionPost(id, transitionAuditBinderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersIdTransitionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateAuditBinderDto} [createAuditBinderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersPost(createAuditBinderDto?: CreateAuditBinderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersPost(createAuditBinderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditBindersApi.apiAuditBindersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditBindersApi - factory interface
 */
export const AuditBindersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditBindersApiFp(configuration)
    return {
        /**
         * 
         * @summary List all upload links for this audit binder. Staff only.
         * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDtoListApiResponse> {
            return localVarFp.apiAuditBindersBinderIdUploadLinksGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the full detail of an upload link (message, recipients, uploaded files). Staff only.
         * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksLinkIdGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDetailDtoApiResponse> {
            return localVarFp.apiAuditBindersBinderIdUploadLinksLinkIdGet(requestParameters.binderId, requestParameters.linkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke an active upload link on this audit binder. Staff only.
         * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(requestParameters.binderId, requestParameters.linkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new external upload link for this audit binder. Staff only.
         * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdUploadLinksPost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDetailDtoApiResponse> {
            return localVarFp.apiAuditBindersBinderIdUploadLinksPost(requestParameters.binderId, requestParameters.createUploadLinkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin-only \"Recently deleted audit binders\": every deleted binder with who deleted it, why and when it is purged, plus what the next purge run would remove (the purge\'s dry-run report). View only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersDeletedGet(options?: RawAxiosRequestConfig): AxiosPromise<DeletedAuditBindersDtoApiResponse> {
            return localVarFp.apiAuditBindersDeletedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin-only, read-only report of stored files that audit binder deletes from before soft deletes left behind: unreferenced files of binders that no longer exist and were audit binders. Scans the whole storage container; deletes nothing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersDeletedLeftoverFilesReportGet(options?: RawAxiosRequestConfig): AxiosPromise<LeftoverAuditBinderFilesReportDtoApiResponse> {
            return localVarFp.apiAuditBindersDeletedLeftoverFilesReportGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Paginated list of audit binders for the preparer management view. Supports search (binder name, client name, client number), audit period overlap, due date range, stage multi-select, and office filtering.
         * @param {AuditBindersApiApiAuditBindersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersGet(requestParameters: AuditBindersApiApiAuditBindersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse> {
            return localVarFp.apiAuditBindersGet(requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.stages, requestParameters.dueDateStart, requestParameters.dueDateEnd, requestParameters.periodStart, requestParameters.periodEnd, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.isArchived, requestParameters.search, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.requestType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiAuditBindersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary One-shot fetch for the audit binder detail screen. Returns binder + items + per-item docs/comments/activity + binder-level docs/comments/activity + summary counts. Clients are scoped to their active client via the X-Active-Client-Id header; preparers/admins see any binder.
         * @param {AuditBindersApiApiAuditBindersIdDetailGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDetailGet(requestParameters: AuditBindersApiApiAuditBindersIdDetailGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDetailDtoApiResponse> {
            return localVarFp.apiAuditBindersIdDetailGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload one or more documents to this audit binder. Separate from the shared /api/documents/upload endpoint — audit uploads skip tax-form classification, AI form detection, and signature templates. Optionally scoped to a request item via `DocumentRequestId`.
         * @param {AuditBindersApiApiAuditBindersIdDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse> {
            return localVarFp.apiAuditBindersIdDocumentsPost(requestParameters.id, requestParameters.files, requestParameters.documentRequestId, requestParameters.comment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bundle the specified binder documents into a zip archive and stream it back as an attachment. Staff-only — clients don\'t need bulk export.
         * @param {AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdDocumentsZipPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiAuditBindersIdDocumentsZipPost(requestParameters.id, requestParameters.exportAuditBinderDocumentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Turn a final deliverable back into an ordinary document. It is not deleted, and the client access window is unchanged.
         * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesDocumentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDeliverablesDocumentIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdFinalDeliverablesDocumentIdDelete(requestParameters.id, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark existing firm-uploaded binder documents as final deliverables, appended in the given order. Same window and notification rules as an upload.
         * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesMarkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDeliverablesMarkPost(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesMarkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdFinalDeliverablesMarkPost(requestParameters.id, requestParameters.markAuditBinderFinalDeliverablesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the display order of the final deliverables; the first is the primary report.
         * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesOrderPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDeliverablesOrderPut(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesOrderPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdFinalDeliverablesOrderPut(requestParameters.id, requestParameters.reorderAuditBinderFinalDeliverablesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload one or more files, each becoming a final deliverable appended after the existing ones. Restarts the client access window; on a Complete binder the client gets one \"new final deliverable\" notice.
         * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDeliverablesPost(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdFinalDeliverablesPost(requestParameters.id, requestParameters.files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Every final deliverable in one ZIP, recorded as a download of each file. Clients get it only once the binder is Complete and while their access window lasts.
         * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesZipGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdFinalDeliverablesZipGet(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesZipGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiAuditBindersIdFinalDeliverablesZipGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdGet(requestParameters: AuditBindersApiApiAuditBindersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse> {
            return localVarFp.apiAuditBindersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import document requests from an .xlsx file. Columns used: D = Due Date, E = Description (→ Title), F = Category (→ RequestType). Only permitted when the binder is in New or PreReleaseReview stage.
         * @param {AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportDocumentRequestsPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportDocumentRequestsResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdImportDocumentRequestsPost(requestParameters.id, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a .zip; a background job creates a DocumentRequest per folder/subfolder and attaches the files, streaming progress over SignalR. Returns 202 with an operationId. Only permitted while the binder is in New or PreReleaseReview stage.
         * @param {AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportDocumentsFromZipPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportZipQueuedDtoApiResponse> {
            return localVarFp.apiAuditBindersIdImportDocumentsFromZipPost(requestParameters.id, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Copy the chosen requests from the client\'s previous binder into this one. All or nothing; only while this binder is in New or Pre-Release Review. The client is not notified.
         * @param {AuditBindersApiApiAuditBindersIdImportFromBinderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportFromBinderPost(requestParameters: AuditBindersApiApiAuditBindersIdImportFromBinderPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportRequestsFromBinderResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdImportFromBinderPost(requestParameters.id, requestParameters.importRequestsFromBinderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The binders this one can copy requests from: the client\'s active binder and its Complete binder, whichever exist, most recent first.
         * @param {AuditBindersApiApiAuditBindersIdImportSourcesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportSourcesGet(requestParameters: AuditBindersApiApiAuditBindersIdImportSourcesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderImportSourcesDtoApiResponse> {
            return localVarFp.apiAuditBindersIdImportSourcesGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Every request in a source binder, flagged for the picker: already in this binder, N/A in the source, or confidential with a visible user who no longer has access to the client.
         * @param {AuditBindersApiApiAuditBindersIdImportSourcesSourceBinderIdRequestsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet(requestParameters: AuditBindersApiApiAuditBindersIdImportSourcesSourceBinderIdRequestsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderImportSourceRequestsDtoApiResponse> {
            return localVarFp.apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet(requestParameters.id, requestParameters.sourceBinderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The client\'s other audit binders that the one-active / one-Completed limits weigh against this one: the active binder that blocks Release and Reopen, and the Complete binders that completing deletes.
         * @param {AuditBindersApiApiAuditBindersIdLimitsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdLimitsGet(requestParameters: AuditBindersApiApiAuditBindersIdLimitsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderLimitsDtoApiResponse> {
            return localVarFp.apiAuditBindersIdLimitsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdPut(requestParameters: AuditBindersApiApiAuditBindersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse> {
            return localVarFp.apiAuditBindersIdPut(requestParameters.id, requestParameters.updateAuditBinderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Take a signature request off the binder. Permitted at any signing stage, since a signed document can still be the wrong document.
         * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsDocumentIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<RemoveSignatureRequestResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdSignatureDocumentsDocumentIdDelete(requestParameters.id, requestParameters.documentId, requestParameters.confirmCancellation, requestParameters.removeDocument, requestParameters.notifySigners, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Re-send a signature document with corrected fields/signers. Allowed only while no signer has signed — voids the current submission and creates a fresh one for the same document. The document id comes from the route.
         * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsDocumentIdPut(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdSignatureDocumentsDocumentIdPut(requestParameters.id, requestParameters.documentId, requestParameters.createSignatureRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Embedded signing session (DocuSeal slug) for the current user on a signature document. Returns 403-style error if the caller isn\'t an assigned signer. Clients are scoped to their active client.
         * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSigningSessionDtoApiResponse> {
            return localVarFp.apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters.id, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Client users eligible to be assigned as signers on a signature document for this binder\'s client. Includes all client-user relationships on the account.
         * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse> {
            return localVarFp.apiAuditBindersIdSignatureDocumentsEligibleSignersGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a previously-uploaded binder document for e-signature. Placed fields are assigned to client-user signers by role. Creates a DocuSeal submission in embedded mode (signers sign in-app); notifications are driven by our system.
         * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdSignatureDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse> {
            return localVarFp.apiAuditBindersIdSignatureDocumentsPost(requestParameters.id, requestParameters.createSignatureRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move the binder to a new stage. Preparers/admins only.
         * @param {AuditBindersApiApiAuditBindersIdTransitionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersIdTransitionPost(requestParameters: AuditBindersApiApiAuditBindersIdTransitionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse> {
            return localVarFp.apiAuditBindersIdTransitionPost(requestParameters.id, requestParameters.transitionAuditBinderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditBindersApiApiAuditBindersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersPost(requestParameters: AuditBindersApiApiAuditBindersPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse> {
            return localVarFp.apiAuditBindersPost(requestParameters.createAuditBinderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditBindersApi - interface
 */
export interface AuditBindersApiInterface {
    /**
     * 
     * @summary List all upload links for this audit binder. Staff only.
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdUploadLinksGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDtoListApiResponse>;

    /**
     * 
     * @summary Get the full detail of an upload link (message, recipients, uploaded files). Staff only.
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdUploadLinksLinkIdGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDetailDtoApiResponse>;

    /**
     * 
     * @summary Revoke an active upload link on this audit binder. Staff only.
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Create a new external upload link for this audit binder. Staff only.
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdUploadLinksPost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLinkDetailDtoApiResponse>;

    /**
     * 
     * @summary Admin-only \"Recently deleted audit binders\": every deleted binder with who deleted it, why and when it is purged, plus what the next purge run would remove (the purge\'s dry-run report). View only.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersDeletedGet(options?: RawAxiosRequestConfig): AxiosPromise<DeletedAuditBindersDtoApiResponse>;

    /**
     * 
     * @summary Admin-only, read-only report of stored files that audit binder deletes from before soft deletes left behind: unreferenced files of binders that no longer exist and were audit binders. Scans the whole storage container; deletes nothing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersDeletedLeftoverFilesReportGet(options?: RawAxiosRequestConfig): AxiosPromise<LeftoverAuditBinderFilesReportDtoApiResponse>;

    /**
     * 
     * @summary Paginated list of audit binders for the preparer management view. Supports search (binder name, client name, client number), audit period overlap, due date range, stage multi-select, and office filtering.
     * @param {AuditBindersApiApiAuditBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersGet(requestParameters?: AuditBindersApiApiAuditBindersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary One-shot fetch for the audit binder detail screen. Returns binder + items + per-item docs/comments/activity + binder-level docs/comments/activity + summary counts. Clients are scoped to their active client via the X-Active-Client-Id header; preparers/admins see any binder.
     * @param {AuditBindersApiApiAuditBindersIdDetailGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdDetailGet(requestParameters: AuditBindersApiApiAuditBindersIdDetailGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDetailDtoApiResponse>;

    /**
     * 
     * @summary Upload one or more documents to this audit binder. Separate from the shared /api/documents/upload endpoint — audit uploads skip tax-form classification, AI form detection, and signature templates. Optionally scoped to a request item via `DocumentRequestId`.
     * @param {AuditBindersApiApiAuditBindersIdDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse>;

    /**
     * 
     * @summary Bundle the specified binder documents into a zip archive and stream it back as an attachment. Staff-only — clients don\'t need bulk export.
     * @param {AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdDocumentsZipPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Turn a final deliverable back into an ordinary document. It is not deleted, and the client access window is unchanged.
     * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdFinalDeliverablesDocumentIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse>;

    /**
     * 
     * @summary Mark existing firm-uploaded binder documents as final deliverables, appended in the given order. Same window and notification rules as an upload.
     * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesMarkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdFinalDeliverablesMarkPost(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesMarkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse>;

    /**
     * 
     * @summary Set the display order of the final deliverables; the first is the primary report.
     * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesOrderPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdFinalDeliverablesOrderPut(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesOrderPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse>;

    /**
     * 
     * @summary Upload one or more files, each becoming a final deliverable appended after the existing ones. Restarts the client access window; on a Complete binder the client gets one \"new final deliverable\" notice.
     * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdFinalDeliverablesPost(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderFinalDeliverablesResultDtoApiResponse>;

    /**
     * 
     * @summary Every final deliverable in one ZIP, recorded as a download of each file. Clients get it only once the binder is Complete and while their access window lasts.
     * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesZipGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdFinalDeliverablesZipGet(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesZipGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdGet(requestParameters: AuditBindersApiApiAuditBindersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse>;

    /**
     * 
     * @summary Import document requests from an .xlsx file. Columns used: D = Due Date, E = Description (→ Title), F = Category (→ RequestType). Only permitted when the binder is in New or PreReleaseReview stage.
     * @param {AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdImportDocumentRequestsPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportDocumentRequestsResultDtoApiResponse>;

    /**
     * 
     * @summary Upload a .zip; a background job creates a DocumentRequest per folder/subfolder and attaches the files, streaming progress over SignalR. Returns 202 with an operationId. Only permitted while the binder is in New or PreReleaseReview stage.
     * @param {AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdImportDocumentsFromZipPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportZipQueuedDtoApiResponse>;

    /**
     * 
     * @summary Copy the chosen requests from the client\'s previous binder into this one. All or nothing; only while this binder is in New or Pre-Release Review. The client is not notified.
     * @param {AuditBindersApiApiAuditBindersIdImportFromBinderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdImportFromBinderPost(requestParameters: AuditBindersApiApiAuditBindersIdImportFromBinderPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportRequestsFromBinderResultDtoApiResponse>;

    /**
     * 
     * @summary The binders this one can copy requests from: the client\'s active binder and its Complete binder, whichever exist, most recent first.
     * @param {AuditBindersApiApiAuditBindersIdImportSourcesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdImportSourcesGet(requestParameters: AuditBindersApiApiAuditBindersIdImportSourcesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderImportSourcesDtoApiResponse>;

    /**
     * 
     * @summary Every request in a source binder, flagged for the picker: already in this binder, N/A in the source, or confidential with a visible user who no longer has access to the client.
     * @param {AuditBindersApiApiAuditBindersIdImportSourcesSourceBinderIdRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet(requestParameters: AuditBindersApiApiAuditBindersIdImportSourcesSourceBinderIdRequestsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderImportSourceRequestsDtoApiResponse>;

    /**
     * 
     * @summary The client\'s other audit binders that the one-active / one-Completed limits weigh against this one: the active binder that blocks Release and Reopen, and the Complete binders that completing deletes.
     * @param {AuditBindersApiApiAuditBindersIdLimitsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdLimitsGet(requestParameters: AuditBindersApiApiAuditBindersIdLimitsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderLimitsDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdPut(requestParameters: AuditBindersApiApiAuditBindersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse>;

    /**
     * 
     * @summary Take a signature request off the binder. Permitted at any signing stage, since a signed document can still be the wrong document.
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdSignatureDocumentsDocumentIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<RemoveSignatureRequestResultDtoApiResponse>;

    /**
     * 
     * @summary Re-send a signature document with corrected fields/signers. Allowed only while no signer has signed — voids the current submission and creates a fresh one for the same document. The document id comes from the route.
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdSignatureDocumentsDocumentIdPut(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse>;

    /**
     * 
     * @summary Embedded signing session (DocuSeal slug) for the current user on a signature document. Returns 403-style error if the caller isn\'t an assigned signer. Clients are scoped to their active client.
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSigningSessionDtoApiResponse>;

    /**
     * 
     * @summary Client users eligible to be assigned as signers on a signature document for this binder\'s client. Includes all client-user relationships on the account.
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse>;

    /**
     * 
     * @summary Send a previously-uploaded binder document for e-signature. Placed fields are assigned to client-user signers by role. Creates a DocuSeal submission in embedded mode (signers sign in-app); notifications are driven by our system.
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdSignatureDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse>;

    /**
     * 
     * @summary Move the binder to a new stage. Preparers/admins only.
     * @param {AuditBindersApiApiAuditBindersIdTransitionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersIdTransitionPost(requestParameters: AuditBindersApiApiAuditBindersIdTransitionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse>;

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersPost(requestParameters?: AuditBindersApiApiAuditBindersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditBinderDtoApiResponse>;

}

/**
 * Request parameters for apiAuditBindersBinderIdUploadLinksGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiAuditBindersBinderIdUploadLinksLinkIdGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly linkId: string
}

/**
 * Request parameters for apiAuditBindersBinderIdUploadLinksLinkIdRevokePost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly linkId: string
}

/**
 * Request parameters for apiAuditBindersBinderIdUploadLinksPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly createUploadLinkDto?: CreateUploadLinkDto
}

/**
 * Request parameters for apiAuditBindersGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersGetRequest {
    /**
     * Use an existing client ID
     */
    readonly clientId?: string

    readonly preparerId?: string

    readonly officeId?: string

    /**
     * Multi-select stage filter for the preparer audit dashboard. When null or empty, the service excludes Op.ClientTaxSystem.Data.Models.AuditBinderStage.Complete by default (dashboard \&quot;all open work\&quot; default).
     */
    readonly stages?: Array<AuditBinderStage>

    /**
     * Filter by due date range (inclusive). UTC dates.
     */
    readonly dueDateStart?: string

    readonly dueDateEnd?: string

    /**
     * Filter by audit period overlap. Matches binders where PeriodStart &lt;&#x3D; PeriodEnd and PeriodEnd &gt;&#x3D; PeriodStart (i.e., the ranges intersect). UTC dates.
     */
    readonly periodStart?: string

    readonly periodEnd?: string

    /**
     * Restrict results to clients the current user watches. Applies to any role.
     */
    readonly watchedClientsOnly?: boolean

    /**
     * Restrict results to binders where the current user is the assigned preparer. Ignored when PreparerId is also set.
     */
    readonly assignedToMe?: boolean

    readonly isArchived?: boolean

    readonly search?: string

    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    /**
     * When set, the Documents and Progress columns are scoped to document requests of this type only (counts of total/approved documents and total/completed requests are limited to the matching request type).
     */
    readonly requestType?: AuditDocumentRequestType
}

/**
 * Request parameters for apiAuditBindersIdDelete operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdDetailGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdDetailGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdDocumentsPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdDocumentsPostRequest {
    readonly id: string

    readonly files: Array<File>

    /**
     * Optional — tie these uploads to a specific request item on this binder.
     */
    readonly documentRequestId?: string

    /**
     * Optional comment recorded on the Document row.
     */
    readonly comment?: string
}

/**
 * Request parameters for apiAuditBindersIdDocumentsZipPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest {
    readonly id: string

    readonly exportAuditBinderDocumentsDto?: ExportAuditBinderDocumentsDto
}

/**
 * Request parameters for apiAuditBindersIdFinalDeliverablesDocumentIdDelete operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdFinalDeliverablesDocumentIdDeleteRequest {
    readonly id: string

    /**
     * Copy this from the Staging Data response or Preprocessing results
     */
    readonly documentId: string
}

/**
 * Request parameters for apiAuditBindersIdFinalDeliverablesMarkPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdFinalDeliverablesMarkPostRequest {
    readonly id: string

    readonly markAuditBinderFinalDeliverablesDto?: MarkAuditBinderFinalDeliverablesDto
}

/**
 * Request parameters for apiAuditBindersIdFinalDeliverablesOrderPut operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdFinalDeliverablesOrderPutRequest {
    readonly id: string

    readonly reorderAuditBinderFinalDeliverablesDto?: ReorderAuditBinderFinalDeliverablesDto
}

/**
 * Request parameters for apiAuditBindersIdFinalDeliverablesPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdFinalDeliverablesPostRequest {
    readonly id: string

    readonly files: Array<File>
}

/**
 * Request parameters for apiAuditBindersIdFinalDeliverablesZipGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdFinalDeliverablesZipGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdImportDocumentRequestsPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest {
    readonly id: string

    readonly file?: File
}

/**
 * Request parameters for apiAuditBindersIdImportDocumentsFromZipPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest {
    readonly id: string

    readonly file?: File
}

/**
 * Request parameters for apiAuditBindersIdImportFromBinderPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdImportFromBinderPostRequest {
    readonly id: string

    readonly importRequestsFromBinderDto?: ImportRequestsFromBinderDto
}

/**
 * Request parameters for apiAuditBindersIdImportSourcesGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdImportSourcesGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdImportSourcesSourceBinderIdRequestsGetRequest {
    readonly id: string

    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly sourceBinderId: string
}

/**
 * Request parameters for apiAuditBindersIdLimitsGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdLimitsGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdPut operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdPutRequest {
    readonly id: string

    readonly updateAuditBinderDto?: UpdateAuditBinderDto
}

/**
 * Request parameters for apiAuditBindersIdSignatureDocumentsDocumentIdDelete operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdDeleteRequest {
    readonly id: string

    /**
     * Copy this from the Staging Data response or Preprocessing results
     */
    readonly documentId: string

    readonly confirmCancellation?: boolean

    readonly removeDocument?: boolean

    readonly notifySigners?: boolean
}

/**
 * Request parameters for apiAuditBindersIdSignatureDocumentsDocumentIdPut operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest {
    readonly id: string

    /**
     * Copy this from the Staging Data response or Preprocessing results
     */
    readonly documentId: string

    readonly createSignatureRequestDto?: CreateSignatureRequestDto
}

/**
 * Request parameters for apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest {
    readonly id: string

    /**
     * Copy this from the Staging Data response or Preprocessing results
     */
    readonly documentId: string
}

/**
 * Request parameters for apiAuditBindersIdSignatureDocumentsEligibleSignersGet operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiAuditBindersIdSignatureDocumentsPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest {
    readonly id: string

    readonly createSignatureRequestDto?: CreateSignatureRequestDto
}

/**
 * Request parameters for apiAuditBindersIdTransitionPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersIdTransitionPostRequest {
    readonly id: string

    readonly transitionAuditBinderDto?: TransitionAuditBinderDto
}

/**
 * Request parameters for apiAuditBindersPost operation in AuditBindersApi.
 */
export interface AuditBindersApiApiAuditBindersPostRequest {
    readonly createAuditBinderDto?: CreateAuditBinderDto
}

/**
 * AuditBindersApi - object-oriented interface
 */
export class AuditBindersApi extends BaseAPI implements AuditBindersApiInterface {
    /**
     * 
     * @summary List all upload links for this audit binder. Staff only.
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdUploadLinksGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersBinderIdUploadLinksGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the full detail of an upload link (message, recipients, uploaded files). Staff only.
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdUploadLinksLinkIdGet(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersBinderIdUploadLinksLinkIdGet(requestParameters.binderId, requestParameters.linkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke an active upload link on this audit binder. Staff only.
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksLinkIdRevokePostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersBinderIdUploadLinksLinkIdRevokePost(requestParameters.binderId, requestParameters.linkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new external upload link for this audit binder. Staff only.
     * @param {AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdUploadLinksPost(requestParameters: AuditBindersApiApiAuditBindersBinderIdUploadLinksPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersBinderIdUploadLinksPost(requestParameters.binderId, requestParameters.createUploadLinkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin-only \"Recently deleted audit binders\": every deleted binder with who deleted it, why and when it is purged, plus what the next purge run would remove (the purge\'s dry-run report). View only.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersDeletedGet(options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersDeletedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin-only, read-only report of stored files that audit binder deletes from before soft deletes left behind: unreferenced files of binders that no longer exist and were audit binders. Scans the whole storage container; deletes nothing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersDeletedLeftoverFilesReportGet(options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersDeletedLeftoverFilesReportGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Paginated list of audit binders for the preparer management view. Supports search (binder name, client name, client number), audit period overlap, due date range, stage multi-select, and office filtering.
     * @param {AuditBindersApiApiAuditBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersGet(requestParameters: AuditBindersApiApiAuditBindersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersGet(requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.stages, requestParameters.dueDateStart, requestParameters.dueDateEnd, requestParameters.periodStart, requestParameters.periodEnd, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.isArchived, requestParameters.search, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.requestType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary One-shot fetch for the audit binder detail screen. Returns binder + items + per-item docs/comments/activity + binder-level docs/comments/activity + summary counts. Clients are scoped to their active client via the X-Active-Client-Id header; preparers/admins see any binder.
     * @param {AuditBindersApiApiAuditBindersIdDetailGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdDetailGet(requestParameters: AuditBindersApiApiAuditBindersIdDetailGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdDetailGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload one or more documents to this audit binder. Separate from the shared /api/documents/upload endpoint — audit uploads skip tax-form classification, AI form detection, and signature templates. Optionally scoped to a request item via `DocumentRequestId`.
     * @param {AuditBindersApiApiAuditBindersIdDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdDocumentsPost(requestParameters.id, requestParameters.files, requestParameters.documentRequestId, requestParameters.comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bundle the specified binder documents into a zip archive and stream it back as an attachment. Staff-only — clients don\'t need bulk export.
     * @param {AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdDocumentsZipPost(requestParameters: AuditBindersApiApiAuditBindersIdDocumentsZipPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdDocumentsZipPost(requestParameters.id, requestParameters.exportAuditBinderDocumentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Turn a final deliverable back into an ordinary document. It is not deleted, and the client access window is unchanged.
     * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdFinalDeliverablesDocumentIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesDocumentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdFinalDeliverablesDocumentIdDelete(requestParameters.id, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark existing firm-uploaded binder documents as final deliverables, appended in the given order. Same window and notification rules as an upload.
     * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesMarkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdFinalDeliverablesMarkPost(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesMarkPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdFinalDeliverablesMarkPost(requestParameters.id, requestParameters.markAuditBinderFinalDeliverablesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the display order of the final deliverables; the first is the primary report.
     * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesOrderPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdFinalDeliverablesOrderPut(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesOrderPutRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdFinalDeliverablesOrderPut(requestParameters.id, requestParameters.reorderAuditBinderFinalDeliverablesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload one or more files, each becoming a final deliverable appended after the existing ones. Restarts the client access window; on a Complete binder the client gets one \"new final deliverable\" notice.
     * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdFinalDeliverablesPost(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdFinalDeliverablesPost(requestParameters.id, requestParameters.files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Every final deliverable in one ZIP, recorded as a download of each file. Clients get it only once the binder is Complete and while their access window lasts.
     * @param {AuditBindersApiApiAuditBindersIdFinalDeliverablesZipGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdFinalDeliverablesZipGet(requestParameters: AuditBindersApiApiAuditBindersIdFinalDeliverablesZipGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdFinalDeliverablesZipGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdGet(requestParameters: AuditBindersApiApiAuditBindersIdGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import document requests from an .xlsx file. Columns used: D = Due Date, E = Description (→ Title), F = Category (→ RequestType). Only permitted when the binder is in New or PreReleaseReview stage.
     * @param {AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdImportDocumentRequestsPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentRequestsPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdImportDocumentRequestsPost(requestParameters.id, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a .zip; a background job creates a DocumentRequest per folder/subfolder and attaches the files, streaming progress over SignalR. Returns 202 with an operationId. Only permitted while the binder is in New or PreReleaseReview stage.
     * @param {AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdImportDocumentsFromZipPost(requestParameters: AuditBindersApiApiAuditBindersIdImportDocumentsFromZipPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdImportDocumentsFromZipPost(requestParameters.id, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Copy the chosen requests from the client\'s previous binder into this one. All or nothing; only while this binder is in New or Pre-Release Review. The client is not notified.
     * @param {AuditBindersApiApiAuditBindersIdImportFromBinderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdImportFromBinderPost(requestParameters: AuditBindersApiApiAuditBindersIdImportFromBinderPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdImportFromBinderPost(requestParameters.id, requestParameters.importRequestsFromBinderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The binders this one can copy requests from: the client\'s active binder and its Complete binder, whichever exist, most recent first.
     * @param {AuditBindersApiApiAuditBindersIdImportSourcesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdImportSourcesGet(requestParameters: AuditBindersApiApiAuditBindersIdImportSourcesGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdImportSourcesGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Every request in a source binder, flagged for the picker: already in this binder, N/A in the source, or confidential with a visible user who no longer has access to the client.
     * @param {AuditBindersApiApiAuditBindersIdImportSourcesSourceBinderIdRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet(requestParameters: AuditBindersApiApiAuditBindersIdImportSourcesSourceBinderIdRequestsGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdImportSourcesSourceBinderIdRequestsGet(requestParameters.id, requestParameters.sourceBinderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The client\'s other audit binders that the one-active / one-Completed limits weigh against this one: the active binder that blocks Release and Reopen, and the Complete binders that completing deletes.
     * @param {AuditBindersApiApiAuditBindersIdLimitsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdLimitsGet(requestParameters: AuditBindersApiApiAuditBindersIdLimitsGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdLimitsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdPut(requestParameters: AuditBindersApiApiAuditBindersIdPutRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdPut(requestParameters.id, requestParameters.updateAuditBinderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Take a signature request off the binder. Permitted at any signing stage, since a signed document can still be the wrong document.
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdSignatureDocumentsDocumentIdDelete(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdSignatureDocumentsDocumentIdDelete(requestParameters.id, requestParameters.documentId, requestParameters.confirmCancellation, requestParameters.removeDocument, requestParameters.notifySigners, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Re-send a signature document with corrected fields/signers. Allowed only while no signer has signed — voids the current submission and creates a fresh one for the same document. The document id comes from the route.
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdSignatureDocumentsDocumentIdPut(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdSignatureDocumentsDocumentIdPut(requestParameters.id, requestParameters.documentId, requestParameters.createSignatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Embedded signing session (DocuSeal slug) for the current user on a signature document. Returns 403-style error if the caller isn\'t an assigned signer. Clients are scoped to their active client.
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters.id, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Client users eligible to be assigned as signers on a signature document for this binder\'s client. Includes all client-user relationships on the account.
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdSignatureDocumentsEligibleSignersGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a previously-uploaded binder document for e-signature. Placed fields are assigned to client-user signers by role. Creates a DocuSeal submission in embedded mode (signers sign in-app); notifications are driven by our system.
     * @param {AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdSignatureDocumentsPost(requestParameters: AuditBindersApiApiAuditBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdSignatureDocumentsPost(requestParameters.id, requestParameters.createSignatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move the binder to a new stage. Preparers/admins only.
     * @param {AuditBindersApiApiAuditBindersIdTransitionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersIdTransitionPost(requestParameters: AuditBindersApiApiAuditBindersIdTransitionPostRequest, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersIdTransitionPost(requestParameters.id, requestParameters.transitionAuditBinderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditBindersApiApiAuditBindersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersPost(requestParameters: AuditBindersApiApiAuditBindersPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditBindersApiFp(this.configuration).apiAuditBindersPost(requestParameters.createAuditBinderDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditDashboardApi - axios parameter creator
 */
export const AuditDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Paginated rows for the preparer audit dashboard. Clients are scoped to their active client via the X-Active-Client-Id header; preparers/admins may pass it optionally to filter to a single client. When Op.ClientTaxSystem.Api.DTOs.AuditDashboard.AuditDashboardQueryDto.Stages is empty/null, results exclude binders in the Complete stage by default.
         * @param {string} [clientId] Use an existing client ID
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {Array<AuditBinderStage>} [stages] Multi-select stage filter for the preparer audit dashboard. When null or empty, the service excludes Op.ClientTaxSystem.Data.Models.AuditBinderStage.Complete by default (dashboard \&quot;all open work\&quot; default).
         * @param {string} [dueDateStart] Filter by due date range (inclusive). UTC dates.
         * @param {string} [dueDateEnd] 
         * @param {string} [periodStart] Filter by audit period overlap. Matches binders where PeriodStart &lt;&#x3D; PeriodEnd and PeriodEnd &gt;&#x3D; PeriodStart (i.e., the ranges intersect). UTC dates.
         * @param {string} [periodEnd] 
         * @param {boolean} [watchedClientsOnly] Restrict results to clients the current user watches. Applies to any role.
         * @param {boolean} [assignedToMe] Restrict results to binders where the current user is the assigned preparer. Ignored when PreparerId is also set.
         * @param {boolean} [isArchived] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {AuditDocumentRequestType} [requestType] When set, the Documents and Progress columns are scoped to document requests of this type only (counts of total/approved documents and total/completed requests are limited to the matching request type).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditDashboardGet: async (clientId?: string, preparerId?: string, officeId?: string, stages?: Array<AuditBinderStage>, dueDateStart?: string, dueDateEnd?: string, periodStart?: string, periodEnd?: string, watchedClientsOnly?: boolean, assignedToMe?: boolean, isArchived?: boolean, search?: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, requestType?: AuditDocumentRequestType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/audit-dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (preparerId !== undefined) {
                localVarQueryParameter['PreparerId'] = preparerId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            if (stages) {
                localVarQueryParameter['Stages'] = stages;
            }

            if (dueDateStart !== undefined) {
                localVarQueryParameter['DueDateStart'] = (dueDateStart as any instanceof Date) ?
                    (dueDateStart as any).toISOString() :
                    dueDateStart;
            }

            if (dueDateEnd !== undefined) {
                localVarQueryParameter['DueDateEnd'] = (dueDateEnd as any instanceof Date) ?
                    (dueDateEnd as any).toISOString() :
                    dueDateEnd;
            }

            if (periodStart !== undefined) {
                localVarQueryParameter['PeriodStart'] = (periodStart as any instanceof Date) ?
                    (periodStart as any).toISOString() :
                    periodStart;
            }

            if (periodEnd !== undefined) {
                localVarQueryParameter['PeriodEnd'] = (periodEnd as any instanceof Date) ?
                    (periodEnd as any).toISOString() :
                    periodEnd;
            }

            if (watchedClientsOnly !== undefined) {
                localVarQueryParameter['WatchedClientsOnly'] = watchedClientsOnly;
            }

            if (assignedToMe !== undefined) {
                localVarQueryParameter['AssignedToMe'] = assignedToMe;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['IsArchived'] = isArchived;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (requestType !== undefined) {
                localVarQueryParameter['RequestType'] = requestType;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditDashboardApi - functional programming interface
 */
export const AuditDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Paginated rows for the preparer audit dashboard. Clients are scoped to their active client via the X-Active-Client-Id header; preparers/admins may pass it optionally to filter to a single client. When Op.ClientTaxSystem.Api.DTOs.AuditDashboard.AuditDashboardQueryDto.Stages is empty/null, results exclude binders in the Complete stage by default.
         * @param {string} [clientId] Use an existing client ID
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {Array<AuditBinderStage>} [stages] Multi-select stage filter for the preparer audit dashboard. When null or empty, the service excludes Op.ClientTaxSystem.Data.Models.AuditBinderStage.Complete by default (dashboard \&quot;all open work\&quot; default).
         * @param {string} [dueDateStart] Filter by due date range (inclusive). UTC dates.
         * @param {string} [dueDateEnd] 
         * @param {string} [periodStart] Filter by audit period overlap. Matches binders where PeriodStart &lt;&#x3D; PeriodEnd and PeriodEnd &gt;&#x3D; PeriodStart (i.e., the ranges intersect). UTC dates.
         * @param {string} [periodEnd] 
         * @param {boolean} [watchedClientsOnly] Restrict results to clients the current user watches. Applies to any role.
         * @param {boolean} [assignedToMe] Restrict results to binders where the current user is the assigned preparer. Ignored when PreparerId is also set.
         * @param {boolean} [isArchived] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {AuditDocumentRequestType} [requestType] When set, the Documents and Progress columns are scoped to document requests of this type only (counts of total/approved documents and total/completed requests are limited to the matching request type).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditDashboardGet(clientId?: string, preparerId?: string, officeId?: string, stages?: Array<AuditBinderStage>, dueDateStart?: string, dueDateEnd?: string, periodStart?: string, periodEnd?: string, watchedClientsOnly?: boolean, assignedToMe?: boolean, isArchived?: boolean, search?: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, requestType?: AuditDocumentRequestType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditDashboardGet(clientId, preparerId, officeId, stages, dueDateStart, dueDateEnd, periodStart, periodEnd, watchedClientsOnly, assignedToMe, isArchived, search, page, limit, sortBy, sortOrder, requestType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditDashboardApi.apiAuditDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditDashboardApi - factory interface
 */
export const AuditDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditDashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary Paginated rows for the preparer audit dashboard. Clients are scoped to their active client via the X-Active-Client-Id header; preparers/admins may pass it optionally to filter to a single client. When Op.ClientTaxSystem.Api.DTOs.AuditDashboard.AuditDashboardQueryDto.Stages is empty/null, results exclude binders in the Complete stage by default.
         * @param {AuditDashboardApiApiAuditDashboardGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditDashboardGet(requestParameters: AuditDashboardApiApiAuditDashboardGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse> {
            return localVarFp.apiAuditDashboardGet(requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.stages, requestParameters.dueDateStart, requestParameters.dueDateEnd, requestParameters.periodStart, requestParameters.periodEnd, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.isArchived, requestParameters.search, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.requestType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditDashboardApi - interface
 */
export interface AuditDashboardApiInterface {
    /**
     * 
     * @summary Paginated rows for the preparer audit dashboard. Clients are scoped to their active client via the X-Active-Client-Id header; preparers/admins may pass it optionally to filter to a single client. When Op.ClientTaxSystem.Api.DTOs.AuditDashboard.AuditDashboardQueryDto.Stages is empty/null, results exclude binders in the Complete stage by default.
     * @param {AuditDashboardApiApiAuditDashboardGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditDashboardGet(requestParameters?: AuditDashboardApiApiAuditDashboardGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditDashboardItemDtoPaginatedResponseApiResponse>;

}

/**
 * Request parameters for apiAuditDashboardGet operation in AuditDashboardApi.
 */
export interface AuditDashboardApiApiAuditDashboardGetRequest {
    /**
     * Use an existing client ID
     */
    readonly clientId?: string

    readonly preparerId?: string

    readonly officeId?: string

    /**
     * Multi-select stage filter for the preparer audit dashboard. When null or empty, the service excludes Op.ClientTaxSystem.Data.Models.AuditBinderStage.Complete by default (dashboard \&quot;all open work\&quot; default).
     */
    readonly stages?: Array<AuditBinderStage>

    /**
     * Filter by due date range (inclusive). UTC dates.
     */
    readonly dueDateStart?: string

    readonly dueDateEnd?: string

    /**
     * Filter by audit period overlap. Matches binders where PeriodStart &lt;&#x3D; PeriodEnd and PeriodEnd &gt;&#x3D; PeriodStart (i.e., the ranges intersect). UTC dates.
     */
    readonly periodStart?: string

    readonly periodEnd?: string

    /**
     * Restrict results to clients the current user watches. Applies to any role.
     */
    readonly watchedClientsOnly?: boolean

    /**
     * Restrict results to binders where the current user is the assigned preparer. Ignored when PreparerId is also set.
     */
    readonly assignedToMe?: boolean

    readonly isArchived?: boolean

    readonly search?: string

    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    /**
     * When set, the Documents and Progress columns are scoped to document requests of this type only (counts of total/approved documents and total/completed requests are limited to the matching request type).
     */
    readonly requestType?: AuditDocumentRequestType
}

/**
 * AuditDashboardApi - object-oriented interface
 */
export class AuditDashboardApi extends BaseAPI implements AuditDashboardApiInterface {
    /**
     * 
     * @summary Paginated rows for the preparer audit dashboard. Clients are scoped to their active client via the X-Active-Client-Id header; preparers/admins may pass it optionally to filter to a single client. When Op.ClientTaxSystem.Api.DTOs.AuditDashboard.AuditDashboardQueryDto.Stages is empty/null, results exclude binders in the Complete stage by default.
     * @param {AuditDashboardApiApiAuditDashboardGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditDashboardGet(requestParameters: AuditDashboardApiApiAuditDashboardGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditDashboardApiFp(this.configuration).apiAuditDashboardGet(requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.stages, requestParameters.dueDateStart, requestParameters.dueDateEnd, requestParameters.periodStart, requestParameters.periodEnd, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.isArchived, requestParameters.search, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.requestType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates a new client portal access request.
         * @param {CreateClientPortalAccessRequestDto} [createClientPortalAccessRequestDto] Access request details including personal information and tax identification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestPost: async (createClientPortalAccessRequestDto?: CreateClientPortalAccessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/access-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientPortalAccessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a paginated list of client portal access requests.
         * @param {number} [page] Page number (default: 1).
         * @param {number} [pageSize] Number of items per page (default: 50, max: 200).
         * @param {string} [status] Optional filter by status (Pending, Accepted, Rejected).
         * @param {string} [officeId] 
         * @param {string} [search] Optional search term to filter by name, email, phone, zip code, tax ID, or connected entities.
         * @param {string} [sortBy] Optional field to sort by (name, email, phone, zipcode, taxid, status, submitted).
         * @param {string} [sortOrder] Optional sort order (asc or desc, default: asc).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsGet: async (page?: number, pageSize?: number, status?: string, officeId?: string, search?: string, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/access-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['officeId'] = officeId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a specific client portal access request by ID.
         * @param {string} id The unique identifier of the access request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuthAccessRequestsIdGet', 'id', id)
            const localVarPath = `/api/Auth/access-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reviews and updates the status of a client portal access request.
         * @param {string} id The unique identifier of the access request.
         * @param {ReviewAccessRequestDto} [reviewAccessRequestDto] Review details including status and notes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsIdReviewPut: async (id: string, reviewAccessRequestDto?: ReviewAccessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuthAccessRequestsIdReviewPut', 'id', id)
            const localVarPath = `/api/Auth/access-requests/{id}/review`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewAccessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes the password for the currently authenticated user.
         * @param {ChangePasswordDto} [changePasswordDto] Password change request containing current and new password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthChangePasswordPost: async (changePasswordDto?: ChangePasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initiates client authentication using email or phone number and Tax ID verification. This endpoint validates client credentials and sends a verification code if successful.
         * @param {ClientLoginDto} [clientLoginDto] Client login credentials containing email/phone and Tax ID last 4 digits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthClientLoginPost: async (clientLoginDto?: ClientLoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/client-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ⚠️ **WARNING**: This endpoint bypasses all security verification checks and should NEVER be enabled in production.              **Usage Example**: ```bash curl -X POST https://localhost:5001/api/auth/dev-client-login \\   -H \"Content-Type: application/json\" \\   -d \'{\"clientId\":\"3fa85f64-5717-4562-b3fc-2c963f66afa6\",\"emailOrPhone\":\"client@example.com\"}\' ```
         * @summary DEVELOPMENT ONLY: Authenticates a client user bypassing verification code flow. This endpoint is ONLY available in Development environment and returns 403 Forbidden in production. Use this endpoint for testing with Claude Code and other development tools that cannot retrieve verification codes.
         * @param {DevClientLoginDto} [devClientLoginDto] Dev login credentials containing client ID and email/phone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDevClientLoginPost: async (devClientLoginDto?: DevClientLoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/dev-client-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(devClientLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ⚠️ **WARNING**: This endpoint bypasses Azure AD entirely and should NEVER be enabled outside the E2E stack. Defense-in-depth: requires BOTH `ASPNETCORE_ENVIRONMENT=Development` AND `AzureAd:SsoMockMode=true`. Either gate closed → 403.              The synthesized claims are fed through the same `ISsoAuthService.ProcessAzureAdClaimsAsync` method the real Azure AD callback uses, so the resulting JWT is identical in shape (claims, issuer, audience, role mapping) to a token produced by a real SSO login.              **Usage Example**: ```bash curl -X POST http://localhost:5261/api/auth/dev-sso-login \\   -H \"Content-Type: application/json\" \\   -d \'{\"email\":\"prep1@test.com\"}\' ```
         * @summary Development-only mock SSO login endpoint. Mints an application JWT for a target seeded preparer email without actually contacting Azure AD. Used by the E2E test suite to exercise the SSO-authenticated preparer code path in isolation from real Azure AD.
         * @param {DevSsoLoginDto} [devSsoLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDevSsoLoginPost: async (devSsoLoginDto?: DevSsoLoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/dev-sso-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(devSsoLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disables two-factor authentication for the current authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDisable2faPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/disable-2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enables two-factor authentication for the current authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthEnable2faPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/enable-2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security Notes**: - Only Preparer and Admin roles can impersonate clients - Preparers can only impersonate clients they have access to - Admins can impersonate any client - Impersonation sessions are logged in the audit trail - Tokens expire after 30 minutes and cannot be refreshed - Impersonated sessions cannot sign documents              **Usage Example**: ```bash curl -X POST https://localhost:5001/api/auth/impersonate-client \\   -H \"Content-Type: application/json\" \\   -H \"Authorization: Bearer {preparer-token}\" \\   -d \'{\"clientId\":\"3fa85f64-5717-4562-b3fc-2c963f66afa6\",\"userId\":\"...\"}\' ```
         * @summary Allows Preparer/Admin to impersonate a client for support and testing purposes. Generates a limited-scope token (30 min, no refresh) that cannot be used for document signing. Creates audit trail entry for security and compliance tracking.
         * @param {ImpersonateClientDto} [impersonateClientDto] Impersonation request containing the target client ID and user ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthImpersonateClientPost: async (impersonateClientDto?: ImpersonateClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/impersonate-client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(impersonateClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticates admin and preparer users using email and password credentials.
         * @param {LoginDto} [loginDto] Login credentials containing email and password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthLoginPost: async (loginDto?: LoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logs out the current authenticated user and invalidates their session tokens.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthLogoutPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refreshes an expired access token using a valid refresh token.
         * @param {RefreshTokenDto} [refreshTokenDto] Refresh token request containing the refresh token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshTokenPost: async (refreshTokenDto?: RefreshTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initiates a password reset request for the specified email address. Always returns success to prevent email enumeration attacks.
         * @param {RequestPasswordResetDto} [requestPasswordResetDto] Password reset request containing the email address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRequestPasswordResetPost: async (requestPasswordResetDto?: RequestPasswordResetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/request-password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPasswordResetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resets user password using a valid reset token received via email.
         * @param {ResetPasswordDto} [resetPasswordDto] Password reset data containing token and new password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthResetPasswordPost: async (resetPasswordDto?: ResetPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends a verification code to the specified email address for authentication purposes.
         * @param {SendVerificationCodeDto} [sendVerificationCodeDto] Verification code request containing email and delivery method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSendVerificationCodePost: async (sendVerificationCodeDto?: SendVerificationCodeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/send-verification-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendVerificationCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is called by Azure AD after user authentication. It should not be called directly by clients.              On success, redirects to the configured frontend callback URL with query parameters: - `token`: The application JWT access token - `refreshToken`: The refresh token - `expiresAt`: Token expiration timestamp - `isNewUser`: Whether a new account was created              On failure, redirects to frontend with: - `error`: Error code - `message`: Error description
         * @summary Handles the callback from Azure AD after user authentication. Validates the authorization code, exchanges it for tokens, and issues application JWT tokens.
         * @param {string} [code] The authorization code from Azure AD.
         * @param {string} [state] The state parameter for CSRF verification.
         * @param {string} [error] Error code if authentication failed at Azure AD.
         * @param {string} [errorDescription] Error description if authentication failed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoCallbackGet: async (code?: string, state?: string, error?: string, errorDescription?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/sso/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (errorDescription !== undefined) {
                localVarQueryParameter['error_description'] = errorDescription;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **IMPORTANT**: This endpoint returns a 302 redirect, not JSON. The frontend should navigate to this URL directly (window.location.href), not via XHR/fetch.              The OAuth state is stored in a secure cookie and verified in the callback to prevent CSRF attacks.              **Usage Example**: ```javascript // Frontend code - navigate directly, don\'t use fetch/XHR window.location.href = \"https://portal-api.ata.net/api/auth/sso/login?returnUrl=/dashboard\"; ```              Flow: 1. Browser navigates to /api/auth/sso/login 2. Backend sets cookies and returns 302 redirect to Azure AD 3. User authenticates with Azure AD 4. Azure AD redirects to /api/auth/sso/callback 5. Backend validates cookies, issues JWT, redirects to frontend
         * @summary Initiates Azure AD SSO login by redirecting to Azure AD. This endpoint performs a 302 redirect - the browser should navigate directly to this URL.
         * @param {string} [returnUrl] Optional URL to redirect to after successful authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoLoginGet: async (returnUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/sso/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (returnUrl !== undefined) {
                localVarQueryParameter['returnUrl'] = returnUrl;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint generates the Azure AD sign-out URL. After signing out from Azure AD, the user will be redirected to the configured frontend sign-out URL.              **Note**: This does not invalidate the application JWT token. Clients should also call the regular `/api/auth/logout` endpoint to blacklist the JWT token.
         * @summary Initiates SSO logout by returning the Azure AD sign-out URL. The client should redirect to this URL to sign out from both the application and Azure AD.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoLogoutGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/sso/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the current Azure AD SSO configuration status. Returns whether SSO is enabled and basic configuration information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/sso/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verifies the authentication code and completes client login process. Requires client ID from initial login attempt to ensure secure verification.
         * @param {VerifyCodeDto} [verifyCodeDto] Verification request containing email/phone, client ID, and verification code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthVerifyCodePost: async (verifyCodeDto?: VerifyCodeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/verify-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Creates a new client portal access request.
         * @param {CreateClientPortalAccessRequestDto} [createClientPortalAccessRequestDto] Access request details including personal information and tax identification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAccessRequestPost(createClientPortalAccessRequestDto?: CreateClientPortalAccessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPortalAccessRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAccessRequestPost(createClientPortalAccessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthAccessRequestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a paginated list of client portal access requests.
         * @param {number} [page] Page number (default: 1).
         * @param {number} [pageSize] Number of items per page (default: 50, max: 200).
         * @param {string} [status] Optional filter by status (Pending, Accepted, Rejected).
         * @param {string} [officeId] 
         * @param {string} [search] Optional search term to filter by name, email, phone, zip code, tax ID, or connected entities.
         * @param {string} [sortBy] Optional field to sort by (name, email, phone, zipcode, taxid, status, submitted).
         * @param {string} [sortOrder] Optional sort order (asc or desc, default: asc).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAccessRequestsGet(page?: number, pageSize?: number, status?: string, officeId?: string, search?: string, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPortalAccessRequestDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAccessRequestsGet(page, pageSize, status, officeId, search, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthAccessRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a specific client portal access request by ID.
         * @param {string} id The unique identifier of the access request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAccessRequestsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPortalAccessRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAccessRequestsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthAccessRequestsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reviews and updates the status of a client portal access request.
         * @param {string} id The unique identifier of the access request.
         * @param {ReviewAccessRequestDto} [reviewAccessRequestDto] Review details including status and notes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthAccessRequestsIdReviewPut(id: string, reviewAccessRequestDto?: ReviewAccessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPortalAccessRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthAccessRequestsIdReviewPut(id, reviewAccessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthAccessRequestsIdReviewPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Changes the password for the currently authenticated user.
         * @param {ChangePasswordDto} [changePasswordDto] Password change request containing current and new password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthChangePasswordPost(changePasswordDto?: ChangePasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthChangePasswordPost(changePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthChangePasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initiates client authentication using email or phone number and Tax ID verification. This endpoint validates client credentials and sends a verification code if successful.
         * @param {ClientLoginDto} [clientLoginDto] Client login credentials containing email/phone and Tax ID last 4 digits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthClientLoginPost(clientLoginDto?: ClientLoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthClientLoginPost(clientLoginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthClientLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ⚠️ **WARNING**: This endpoint bypasses all security verification checks and should NEVER be enabled in production.              **Usage Example**: ```bash curl -X POST https://localhost:5001/api/auth/dev-client-login \\   -H \"Content-Type: application/json\" \\   -d \'{\"clientId\":\"3fa85f64-5717-4562-b3fc-2c963f66afa6\",\"emailOrPhone\":\"client@example.com\"}\' ```
         * @summary DEVELOPMENT ONLY: Authenticates a client user bypassing verification code flow. This endpoint is ONLY available in Development environment and returns 403 Forbidden in production. Use this endpoint for testing with Claude Code and other development tools that cannot retrieve verification codes.
         * @param {DevClientLoginDto} [devClientLoginDto] Dev login credentials containing client ID and email/phone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthDevClientLoginPost(devClientLoginDto?: DevClientLoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthDevClientLoginPost(devClientLoginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthDevClientLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ⚠️ **WARNING**: This endpoint bypasses Azure AD entirely and should NEVER be enabled outside the E2E stack. Defense-in-depth: requires BOTH `ASPNETCORE_ENVIRONMENT=Development` AND `AzureAd:SsoMockMode=true`. Either gate closed → 403.              The synthesized claims are fed through the same `ISsoAuthService.ProcessAzureAdClaimsAsync` method the real Azure AD callback uses, so the resulting JWT is identical in shape (claims, issuer, audience, role mapping) to a token produced by a real SSO login.              **Usage Example**: ```bash curl -X POST http://localhost:5261/api/auth/dev-sso-login \\   -H \"Content-Type: application/json\" \\   -d \'{\"email\":\"prep1@test.com\"}\' ```
         * @summary Development-only mock SSO login endpoint. Mints an application JWT for a target seeded preparer email without actually contacting Azure AD. Used by the E2E test suite to exercise the SSO-authenticated preparer code path in isolation from real Azure AD.
         * @param {DevSsoLoginDto} [devSsoLoginDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthDevSsoLoginPost(devSsoLoginDto?: DevSsoLoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoLoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthDevSsoLoginPost(devSsoLoginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthDevSsoLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disables two-factor authentication for the current authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthDisable2faPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthDisable2faPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthDisable2faPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enables two-factor authentication for the current authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthEnable2faPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthEnable2faPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthEnable2faPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * **Security Notes**: - Only Preparer and Admin roles can impersonate clients - Preparers can only impersonate clients they have access to - Admins can impersonate any client - Impersonation sessions are logged in the audit trail - Tokens expire after 30 minutes and cannot be refreshed - Impersonated sessions cannot sign documents              **Usage Example**: ```bash curl -X POST https://localhost:5001/api/auth/impersonate-client \\   -H \"Content-Type: application/json\" \\   -H \"Authorization: Bearer {preparer-token}\" \\   -d \'{\"clientId\":\"3fa85f64-5717-4562-b3fc-2c963f66afa6\",\"userId\":\"...\"}\' ```
         * @summary Allows Preparer/Admin to impersonate a client for support and testing purposes. Generates a limited-scope token (30 min, no refresh) that cannot be used for document signing. Creates audit trail entry for security and compliance tracking.
         * @param {ImpersonateClientDto} [impersonateClientDto] Impersonation request containing the target client ID and user ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthImpersonateClientPost(impersonateClientDto?: ImpersonateClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpersonateClientResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthImpersonateClientPost(impersonateClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthImpersonateClientPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Authenticates admin and preparer users using email and password credentials.
         * @param {LoginDto} [loginDto] Login credentials containing email and password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthLoginPost(loginDto?: LoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthLoginPost(loginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logs out the current authenticated user and invalidates their session tokens.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthLogoutPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthLogoutPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refreshes an expired access token using a valid refresh token.
         * @param {RefreshTokenDto} [refreshTokenDto] Refresh token request containing the refresh token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthRefreshTokenPost(refreshTokenDto?: RefreshTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthRefreshTokenPost(refreshTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthRefreshTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initiates a password reset request for the specified email address. Always returns success to prevent email enumeration attacks.
         * @param {RequestPasswordResetDto} [requestPasswordResetDto] Password reset request containing the email address.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthRequestPasswordResetPost(requestPasswordResetDto?: RequestPasswordResetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthRequestPasswordResetPost(requestPasswordResetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthRequestPasswordResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resets user password using a valid reset token received via email.
         * @param {ResetPasswordDto} [resetPasswordDto] Password reset data containing token and new password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthResetPasswordPost(resetPasswordDto?: ResetPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthResetPasswordPost(resetPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthResetPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sends a verification code to the specified email address for authentication purposes.
         * @param {SendVerificationCodeDto} [sendVerificationCodeDto] Verification code request containing email and delivery method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSendVerificationCodePost(sendVerificationCodeDto?: SendVerificationCodeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSendVerificationCodePost(sendVerificationCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthSendVerificationCodePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint is called by Azure AD after user authentication. It should not be called directly by clients.              On success, redirects to the configured frontend callback URL with query parameters: - `token`: The application JWT access token - `refreshToken`: The refresh token - `expiresAt`: Token expiration timestamp - `isNewUser`: Whether a new account was created              On failure, redirects to frontend with: - `error`: Error code - `message`: Error description
         * @summary Handles the callback from Azure AD after user authentication. Validates the authorization code, exchanges it for tokens, and issues application JWT tokens.
         * @param {string} [code] The authorization code from Azure AD.
         * @param {string} [state] The state parameter for CSRF verification.
         * @param {string} [error] Error code if authentication failed at Azure AD.
         * @param {string} [errorDescription] Error description if authentication failed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSsoCallbackGet(code?: string, state?: string, error?: string, errorDescription?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSsoCallbackGet(code, state, error, errorDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthSsoCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * **IMPORTANT**: This endpoint returns a 302 redirect, not JSON. The frontend should navigate to this URL directly (window.location.href), not via XHR/fetch.              The OAuth state is stored in a secure cookie and verified in the callback to prevent CSRF attacks.              **Usage Example**: ```javascript // Frontend code - navigate directly, don\'t use fetch/XHR window.location.href = \"https://portal-api.ata.net/api/auth/sso/login?returnUrl=/dashboard\"; ```              Flow: 1. Browser navigates to /api/auth/sso/login 2. Backend sets cookies and returns 302 redirect to Azure AD 3. User authenticates with Azure AD 4. Azure AD redirects to /api/auth/sso/callback 5. Backend validates cookies, issues JWT, redirects to frontend
         * @summary Initiates Azure AD SSO login by redirecting to Azure AD. This endpoint performs a 302 redirect - the browser should navigate directly to this URL.
         * @param {string} [returnUrl] Optional URL to redirect to after successful authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSsoLoginGet(returnUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSsoLoginGet(returnUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthSsoLoginGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint generates the Azure AD sign-out URL. After signing out from Azure AD, the user will be redirected to the configured frontend sign-out URL.              **Note**: This does not invalidate the application JWT token. Clients should also call the regular `/api/auth/logout` endpoint to blacklist the JWT token.
         * @summary Initiates SSO logout by returning the Azure AD sign-out URL. The client should redirect to this URL to sign out from both the application and Azure AD.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSsoLogoutGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSsoLogoutGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthSsoLogoutGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the current Azure AD SSO configuration status. Returns whether SSO is enabled and basic configuration information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthSsoStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthSsoStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthSsoStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verifies the authentication code and completes client login process. Requires client ID from initial login attempt to ensure secure verification.
         * @param {VerifyCodeDto} [verifyCodeDto] Verification request containing email/phone, client ID, and verification code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthVerifyCodePost(verifyCodeDto?: VerifyCodeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthVerifyCodePost(verifyCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthVerifyCodePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Creates a new client portal access request.
         * @param {AuthApiApiAuthAccessRequestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestPost(requestParameters: AuthApiApiAuthAccessRequestPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse> {
            return localVarFp.apiAuthAccessRequestPost(requestParameters.createClientPortalAccessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a paginated list of client portal access requests.
         * @param {AuthApiApiAuthAccessRequestsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsGet(requestParameters: AuthApiApiAuthAccessRequestsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoPaginatedResponseApiResponse> {
            return localVarFp.apiAuthAccessRequestsGet(requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.officeId, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a specific client portal access request by ID.
         * @param {AuthApiApiAuthAccessRequestsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsIdGet(requestParameters: AuthApiApiAuthAccessRequestsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse> {
            return localVarFp.apiAuthAccessRequestsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reviews and updates the status of a client portal access request.
         * @param {AuthApiApiAuthAccessRequestsIdReviewPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthAccessRequestsIdReviewPut(requestParameters: AuthApiApiAuthAccessRequestsIdReviewPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse> {
            return localVarFp.apiAuthAccessRequestsIdReviewPut(requestParameters.id, requestParameters.reviewAccessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes the password for the currently authenticated user.
         * @param {AuthApiApiAuthChangePasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthChangePasswordPost(requestParameters: AuthApiApiAuthChangePasswordPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthChangePasswordPost(requestParameters.changePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initiates client authentication using email or phone number and Tax ID verification. This endpoint validates client credentials and sends a verification code if successful.
         * @param {AuthApiApiAuthClientLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthClientLoginPost(requestParameters: AuthApiApiAuthClientLoginPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse> {
            return localVarFp.apiAuthClientLoginPost(requestParameters.clientLoginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ⚠️ **WARNING**: This endpoint bypasses all security verification checks and should NEVER be enabled in production.              **Usage Example**: ```bash curl -X POST https://localhost:5001/api/auth/dev-client-login \\   -H \"Content-Type: application/json\" \\   -d \'{\"clientId\":\"3fa85f64-5717-4562-b3fc-2c963f66afa6\",\"emailOrPhone\":\"client@example.com\"}\' ```
         * @summary DEVELOPMENT ONLY: Authenticates a client user bypassing verification code flow. This endpoint is ONLY available in Development environment and returns 403 Forbidden in production. Use this endpoint for testing with Claude Code and other development tools that cannot retrieve verification codes.
         * @param {AuthApiApiAuthDevClientLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDevClientLoginPost(requestParameters: AuthApiApiAuthDevClientLoginPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse> {
            return localVarFp.apiAuthDevClientLoginPost(requestParameters.devClientLoginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * ⚠️ **WARNING**: This endpoint bypasses Azure AD entirely and should NEVER be enabled outside the E2E stack. Defense-in-depth: requires BOTH `ASPNETCORE_ENVIRONMENT=Development` AND `AzureAd:SsoMockMode=true`. Either gate closed → 403.              The synthesized claims are fed through the same `ISsoAuthService.ProcessAzureAdClaimsAsync` method the real Azure AD callback uses, so the resulting JWT is identical in shape (claims, issuer, audience, role mapping) to a token produced by a real SSO login.              **Usage Example**: ```bash curl -X POST http://localhost:5261/api/auth/dev-sso-login \\   -H \"Content-Type: application/json\" \\   -d \'{\"email\":\"prep1@test.com\"}\' ```
         * @summary Development-only mock SSO login endpoint. Mints an application JWT for a target seeded preparer email without actually contacting Azure AD. Used by the E2E test suite to exercise the SSO-authenticated preparer code path in isolation from real Azure AD.
         * @param {AuthApiApiAuthDevSsoLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDevSsoLoginPost(requestParameters: AuthApiApiAuthDevSsoLoginPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SsoLoginResponseDtoApiResponse> {
            return localVarFp.apiAuthDevSsoLoginPost(requestParameters.devSsoLoginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disables two-factor authentication for the current authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthDisable2faPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthDisable2faPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enables two-factor authentication for the current authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthEnable2faPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthEnable2faPost(options).then((request) => request(axios, basePath));
        },
        /**
         * **Security Notes**: - Only Preparer and Admin roles can impersonate clients - Preparers can only impersonate clients they have access to - Admins can impersonate any client - Impersonation sessions are logged in the audit trail - Tokens expire after 30 minutes and cannot be refreshed - Impersonated sessions cannot sign documents              **Usage Example**: ```bash curl -X POST https://localhost:5001/api/auth/impersonate-client \\   -H \"Content-Type: application/json\" \\   -H \"Authorization: Bearer {preparer-token}\" \\   -d \'{\"clientId\":\"3fa85f64-5717-4562-b3fc-2c963f66afa6\",\"userId\":\"...\"}\' ```
         * @summary Allows Preparer/Admin to impersonate a client for support and testing purposes. Generates a limited-scope token (30 min, no refresh) that cannot be used for document signing. Creates audit trail entry for security and compliance tracking.
         * @param {AuthApiApiAuthImpersonateClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthImpersonateClientPost(requestParameters: AuthApiApiAuthImpersonateClientPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ImpersonateClientResponseDtoApiResponse> {
            return localVarFp.apiAuthImpersonateClientPost(requestParameters.impersonateClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticates admin and preparer users using email and password credentials.
         * @param {AuthApiApiAuthLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthLoginPost(requestParameters: AuthApiApiAuthLoginPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse> {
            return localVarFp.apiAuthLoginPost(requestParameters.loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logs out the current authenticated user and invalidates their session tokens.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refreshes an expired access token using a valid refresh token.
         * @param {AuthApiApiAuthRefreshTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshTokenPost(requestParameters: AuthApiApiAuthRefreshTokenPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse> {
            return localVarFp.apiAuthRefreshTokenPost(requestParameters.refreshTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initiates a password reset request for the specified email address. Always returns success to prevent email enumeration attacks.
         * @param {AuthApiApiAuthRequestPasswordResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRequestPasswordResetPost(requestParameters: AuthApiApiAuthRequestPasswordResetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthRequestPasswordResetPost(requestParameters.requestPasswordResetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resets user password using a valid reset token received via email.
         * @param {AuthApiApiAuthResetPasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthResetPasswordPost(requestParameters: AuthApiApiAuthResetPasswordPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthResetPasswordPost(requestParameters.resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends a verification code to the specified email address for authentication purposes.
         * @param {AuthApiApiAuthSendVerificationCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSendVerificationCodePost(requestParameters: AuthApiApiAuthSendVerificationCodePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiAuthSendVerificationCodePost(requestParameters.sendVerificationCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is called by Azure AD after user authentication. It should not be called directly by clients.              On success, redirects to the configured frontend callback URL with query parameters: - `token`: The application JWT access token - `refreshToken`: The refresh token - `expiresAt`: Token expiration timestamp - `isNewUser`: Whether a new account was created              On failure, redirects to frontend with: - `error`: Error code - `message`: Error description
         * @summary Handles the callback from Azure AD after user authentication. Validates the authorization code, exchanges it for tokens, and issues application JWT tokens.
         * @param {AuthApiApiAuthSsoCallbackGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoCallbackGet(requestParameters: AuthApiApiAuthSsoCallbackGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthSsoCallbackGet(requestParameters.code, requestParameters.state, requestParameters.error, requestParameters.errorDescription, options).then((request) => request(axios, basePath));
        },
        /**
         * **IMPORTANT**: This endpoint returns a 302 redirect, not JSON. The frontend should navigate to this URL directly (window.location.href), not via XHR/fetch.              The OAuth state is stored in a secure cookie and verified in the callback to prevent CSRF attacks.              **Usage Example**: ```javascript // Frontend code - navigate directly, don\'t use fetch/XHR window.location.href = \"https://portal-api.ata.net/api/auth/sso/login?returnUrl=/dashboard\"; ```              Flow: 1. Browser navigates to /api/auth/sso/login 2. Backend sets cookies and returns 302 redirect to Azure AD 3. User authenticates with Azure AD 4. Azure AD redirects to /api/auth/sso/callback 5. Backend validates cookies, issues JWT, redirects to frontend
         * @summary Initiates Azure AD SSO login by redirecting to Azure AD. This endpoint performs a 302 redirect - the browser should navigate directly to this URL.
         * @param {AuthApiApiAuthSsoLoginGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoLoginGet(requestParameters: AuthApiApiAuthSsoLoginGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthSsoLoginGet(requestParameters.returnUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint generates the Azure AD sign-out URL. After signing out from Azure AD, the user will be redirected to the configured frontend sign-out URL.              **Note**: This does not invalidate the application JWT token. Clients should also call the regular `/api/auth/logout` endpoint to blacklist the JWT token.
         * @summary Initiates SSO logout by returning the Azure AD sign-out URL. The client should redirect to this URL to sign out from both the application and Azure AD.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoLogoutGet(options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiAuthSsoLogoutGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the current Azure AD SSO configuration status. Returns whether SSO is enabled and basic configuration information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthSsoStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<SsoStatusDtoApiResponse> {
            return localVarFp.apiAuthSsoStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verifies the authentication code and completes client login process. Requires client ID from initial login attempt to ensure secure verification.
         * @param {AuthApiApiAuthVerifyCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthVerifyCodePost(requestParameters: AuthApiApiAuthVerifyCodePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse> {
            return localVarFp.apiAuthVerifyCodePost(requestParameters.verifyCodeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - interface
 */
export interface AuthApiInterface {
    /**
     * 
     * @summary Creates a new client portal access request.
     * @param {AuthApiApiAuthAccessRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthAccessRequestPost(requestParameters?: AuthApiApiAuthAccessRequestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse>;

    /**
     * 
     * @summary Retrieves a paginated list of client portal access requests.
     * @param {AuthApiApiAuthAccessRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthAccessRequestsGet(requestParameters?: AuthApiApiAuthAccessRequestsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Retrieves a specific client portal access request by ID.
     * @param {AuthApiApiAuthAccessRequestsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthAccessRequestsIdGet(requestParameters: AuthApiApiAuthAccessRequestsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse>;

    /**
     * 
     * @summary Reviews and updates the status of a client portal access request.
     * @param {AuthApiApiAuthAccessRequestsIdReviewPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthAccessRequestsIdReviewPut(requestParameters: AuthApiApiAuthAccessRequestsIdReviewPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientPortalAccessRequestDtoApiResponse>;

    /**
     * 
     * @summary Changes the password for the currently authenticated user.
     * @param {AuthApiApiAuthChangePasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthChangePasswordPost(requestParameters?: AuthApiApiAuthChangePasswordPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Initiates client authentication using email or phone number and Tax ID verification. This endpoint validates client credentials and sends a verification code if successful.
     * @param {AuthApiApiAuthClientLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthClientLoginPost(requestParameters?: AuthApiApiAuthClientLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse>;

    /**
     * ⚠️ **WARNING**: This endpoint bypasses all security verification checks and should NEVER be enabled in production.              **Usage Example**: ```bash curl -X POST https://localhost:5001/api/auth/dev-client-login \\   -H \"Content-Type: application/json\" \\   -d \'{\"clientId\":\"3fa85f64-5717-4562-b3fc-2c963f66afa6\",\"emailOrPhone\":\"client@example.com\"}\' ```
     * @summary DEVELOPMENT ONLY: Authenticates a client user bypassing verification code flow. This endpoint is ONLY available in Development environment and returns 403 Forbidden in production. Use this endpoint for testing with Claude Code and other development tools that cannot retrieve verification codes.
     * @param {AuthApiApiAuthDevClientLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthDevClientLoginPost(requestParameters?: AuthApiApiAuthDevClientLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse>;

    /**
     * ⚠️ **WARNING**: This endpoint bypasses Azure AD entirely and should NEVER be enabled outside the E2E stack. Defense-in-depth: requires BOTH `ASPNETCORE_ENVIRONMENT=Development` AND `AzureAd:SsoMockMode=true`. Either gate closed → 403.              The synthesized claims are fed through the same `ISsoAuthService.ProcessAzureAdClaimsAsync` method the real Azure AD callback uses, so the resulting JWT is identical in shape (claims, issuer, audience, role mapping) to a token produced by a real SSO login.              **Usage Example**: ```bash curl -X POST http://localhost:5261/api/auth/dev-sso-login \\   -H \"Content-Type: application/json\" \\   -d \'{\"email\":\"prep1@test.com\"}\' ```
     * @summary Development-only mock SSO login endpoint. Mints an application JWT for a target seeded preparer email without actually contacting Azure AD. Used by the E2E test suite to exercise the SSO-authenticated preparer code path in isolation from real Azure AD.
     * @param {AuthApiApiAuthDevSsoLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthDevSsoLoginPost(requestParameters?: AuthApiApiAuthDevSsoLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SsoLoginResponseDtoApiResponse>;

    /**
     * 
     * @summary Disables two-factor authentication for the current authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthDisable2faPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Enables two-factor authentication for the current authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthEnable2faPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * **Security Notes**: - Only Preparer and Admin roles can impersonate clients - Preparers can only impersonate clients they have access to - Admins can impersonate any client - Impersonation sessions are logged in the audit trail - Tokens expire after 30 minutes and cannot be refreshed - Impersonated sessions cannot sign documents              **Usage Example**: ```bash curl -X POST https://localhost:5001/api/auth/impersonate-client \\   -H \"Content-Type: application/json\" \\   -H \"Authorization: Bearer {preparer-token}\" \\   -d \'{\"clientId\":\"3fa85f64-5717-4562-b3fc-2c963f66afa6\",\"userId\":\"...\"}\' ```
     * @summary Allows Preparer/Admin to impersonate a client for support and testing purposes. Generates a limited-scope token (30 min, no refresh) that cannot be used for document signing. Creates audit trail entry for security and compliance tracking.
     * @param {AuthApiApiAuthImpersonateClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthImpersonateClientPost(requestParameters?: AuthApiApiAuthImpersonateClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImpersonateClientResponseDtoApiResponse>;

    /**
     * 
     * @summary Authenticates admin and preparer users using email and password credentials.
     * @param {AuthApiApiAuthLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthLoginPost(requestParameters?: AuthApiApiAuthLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse>;

    /**
     * 
     * @summary Logs out the current authenticated user and invalidates their session tokens.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Refreshes an expired access token using a valid refresh token.
     * @param {AuthApiApiAuthRefreshTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthRefreshTokenPost(requestParameters?: AuthApiApiAuthRefreshTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse>;

    /**
     * 
     * @summary Initiates a password reset request for the specified email address. Always returns success to prevent email enumeration attacks.
     * @param {AuthApiApiAuthRequestPasswordResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthRequestPasswordResetPost(requestParameters?: AuthApiApiAuthRequestPasswordResetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Resets user password using a valid reset token received via email.
     * @param {AuthApiApiAuthResetPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthResetPasswordPost(requestParameters?: AuthApiApiAuthResetPasswordPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Sends a verification code to the specified email address for authentication purposes.
     * @param {AuthApiApiAuthSendVerificationCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthSendVerificationCodePost(requestParameters?: AuthApiApiAuthSendVerificationCodePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * This endpoint is called by Azure AD after user authentication. It should not be called directly by clients.              On success, redirects to the configured frontend callback URL with query parameters: - `token`: The application JWT access token - `refreshToken`: The refresh token - `expiresAt`: Token expiration timestamp - `isNewUser`: Whether a new account was created              On failure, redirects to frontend with: - `error`: Error code - `message`: Error description
     * @summary Handles the callback from Azure AD after user authentication. Validates the authorization code, exchanges it for tokens, and issues application JWT tokens.
     * @param {AuthApiApiAuthSsoCallbackGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthSsoCallbackGet(requestParameters?: AuthApiApiAuthSsoCallbackGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * **IMPORTANT**: This endpoint returns a 302 redirect, not JSON. The frontend should navigate to this URL directly (window.location.href), not via XHR/fetch.              The OAuth state is stored in a secure cookie and verified in the callback to prevent CSRF attacks.              **Usage Example**: ```javascript // Frontend code - navigate directly, don\'t use fetch/XHR window.location.href = \"https://portal-api.ata.net/api/auth/sso/login?returnUrl=/dashboard\"; ```              Flow: 1. Browser navigates to /api/auth/sso/login 2. Backend sets cookies and returns 302 redirect to Azure AD 3. User authenticates with Azure AD 4. Azure AD redirects to /api/auth/sso/callback 5. Backend validates cookies, issues JWT, redirects to frontend
     * @summary Initiates Azure AD SSO login by redirecting to Azure AD. This endpoint performs a 302 redirect - the browser should navigate directly to this URL.
     * @param {AuthApiApiAuthSsoLoginGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthSsoLoginGet(requestParameters?: AuthApiApiAuthSsoLoginGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * This endpoint generates the Azure AD sign-out URL. After signing out from Azure AD, the user will be redirected to the configured frontend sign-out URL.              **Note**: This does not invalidate the application JWT token. Clients should also call the regular `/api/auth/logout` endpoint to blacklist the JWT token.
     * @summary Initiates SSO logout by returning the Azure AD sign-out URL. The client should redirect to this URL to sign out from both the application and Azure AD.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthSsoLogoutGet(options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @summary Gets the current Azure AD SSO configuration status. Returns whether SSO is enabled and basic configuration information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthSsoStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<SsoStatusDtoApiResponse>;

    /**
     * 
     * @summary Verifies the authentication code and completes client login process. Requires client ID from initial login attempt to ensure secure verification.
     * @param {AuthApiApiAuthVerifyCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthVerifyCodePost(requestParameters?: AuthApiApiAuthVerifyCodePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDtoApiResponse>;

}

/**
 * Request parameters for apiAuthAccessRequestPost operation in AuthApi.
 */
export interface AuthApiApiAuthAccessRequestPostRequest {
    /**
     * Access request details including personal information and tax identification.
     */
    readonly createClientPortalAccessRequestDto?: CreateClientPortalAccessRequestDto
}

/**
 * Request parameters for apiAuthAccessRequestsGet operation in AuthApi.
 */
export interface AuthApiApiAuthAccessRequestsGetRequest {
    /**
     * Page number (default: 1).
     */
    readonly page?: number

    /**
     * Number of items per page (default: 50, max: 200).
     */
    readonly pageSize?: number

    /**
     * Optional filter by status (Pending, Accepted, Rejected).
     */
    readonly status?: string

    readonly officeId?: string

    /**
     * Optional search term to filter by name, email, phone, zip code, tax ID, or connected entities.
     */
    readonly search?: string

    /**
     * Optional field to sort by (name, email, phone, zipcode, taxid, status, submitted).
     */
    readonly sortBy?: string

    /**
     * Optional sort order (asc or desc, default: asc).
     */
    readonly sortOrder?: string
}

/**
 * Request parameters for apiAuthAccessRequestsIdGet operation in AuthApi.
 */
export interface AuthApiApiAuthAccessRequestsIdGetRequest {
    /**
     * The unique identifier of the access request.
     */
    readonly id: string
}

/**
 * Request parameters for apiAuthAccessRequestsIdReviewPut operation in AuthApi.
 */
export interface AuthApiApiAuthAccessRequestsIdReviewPutRequest {
    /**
     * The unique identifier of the access request.
     */
    readonly id: string

    /**
     * Review details including status and notes.
     */
    readonly reviewAccessRequestDto?: ReviewAccessRequestDto
}

/**
 * Request parameters for apiAuthChangePasswordPost operation in AuthApi.
 */
export interface AuthApiApiAuthChangePasswordPostRequest {
    /**
     * Password change request containing current and new password.
     */
    readonly changePasswordDto?: ChangePasswordDto
}

/**
 * Request parameters for apiAuthClientLoginPost operation in AuthApi.
 */
export interface AuthApiApiAuthClientLoginPostRequest {
    /**
     * Client login credentials containing email/phone and Tax ID last 4 digits.
     */
    readonly clientLoginDto?: ClientLoginDto
}

/**
 * Request parameters for apiAuthDevClientLoginPost operation in AuthApi.
 */
export interface AuthApiApiAuthDevClientLoginPostRequest {
    /**
     * Dev login credentials containing client ID and email/phone.
     */
    readonly devClientLoginDto?: DevClientLoginDto
}

/**
 * Request parameters for apiAuthDevSsoLoginPost operation in AuthApi.
 */
export interface AuthApiApiAuthDevSsoLoginPostRequest {
    readonly devSsoLoginDto?: DevSsoLoginDto
}

/**
 * Request parameters for apiAuthImpersonateClientPost operation in AuthApi.
 */
export interface AuthApiApiAuthImpersonateClientPostRequest {
    /**
     * Impersonation request containing the target client ID and user ID.
     */
    readonly impersonateClientDto?: ImpersonateClientDto
}

/**
 * Request parameters for apiAuthLoginPost operation in AuthApi.
 */
export interface AuthApiApiAuthLoginPostRequest {
    /**
     * Login credentials containing email and password.
     */
    readonly loginDto?: LoginDto
}

/**
 * Request parameters for apiAuthRefreshTokenPost operation in AuthApi.
 */
export interface AuthApiApiAuthRefreshTokenPostRequest {
    /**
     * Refresh token request containing the refresh token.
     */
    readonly refreshTokenDto?: RefreshTokenDto
}

/**
 * Request parameters for apiAuthRequestPasswordResetPost operation in AuthApi.
 */
export interface AuthApiApiAuthRequestPasswordResetPostRequest {
    /**
     * Password reset request containing the email address.
     */
    readonly requestPasswordResetDto?: RequestPasswordResetDto
}

/**
 * Request parameters for apiAuthResetPasswordPost operation in AuthApi.
 */
export interface AuthApiApiAuthResetPasswordPostRequest {
    /**
     * Password reset data containing token and new password.
     */
    readonly resetPasswordDto?: ResetPasswordDto
}

/**
 * Request parameters for apiAuthSendVerificationCodePost operation in AuthApi.
 */
export interface AuthApiApiAuthSendVerificationCodePostRequest {
    /**
     * Verification code request containing email and delivery method.
     */
    readonly sendVerificationCodeDto?: SendVerificationCodeDto
}

/**
 * Request parameters for apiAuthSsoCallbackGet operation in AuthApi.
 */
export interface AuthApiApiAuthSsoCallbackGetRequest {
    /**
     * The authorization code from Azure AD.
     */
    readonly code?: string

    /**
     * The state parameter for CSRF verification.
     */
    readonly state?: string

    /**
     * Error code if authentication failed at Azure AD.
     */
    readonly error?: string

    /**
     * Error description if authentication failed.
     */
    readonly errorDescription?: string
}

/**
 * Request parameters for apiAuthSsoLoginGet operation in AuthApi.
 */
export interface AuthApiApiAuthSsoLoginGetRequest {
    /**
     * Optional URL to redirect to after successful authentication.
     */
    readonly returnUrl?: string
}

/**
 * Request parameters for apiAuthVerifyCodePost operation in AuthApi.
 */
export interface AuthApiApiAuthVerifyCodePostRequest {
    /**
     * Verification request containing email/phone, client ID, and verification code.
     */
    readonly verifyCodeDto?: VerifyCodeDto
}

/**
 * AuthApi - object-oriented interface
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
    /**
     * 
     * @summary Creates a new client portal access request.
     * @param {AuthApiApiAuthAccessRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAccessRequestPost(requestParameters: AuthApiApiAuthAccessRequestPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthAccessRequestPost(requestParameters.createClientPortalAccessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a paginated list of client portal access requests.
     * @param {AuthApiApiAuthAccessRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAccessRequestsGet(requestParameters: AuthApiApiAuthAccessRequestsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthAccessRequestsGet(requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.officeId, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a specific client portal access request by ID.
     * @param {AuthApiApiAuthAccessRequestsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAccessRequestsIdGet(requestParameters: AuthApiApiAuthAccessRequestsIdGetRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthAccessRequestsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reviews and updates the status of a client portal access request.
     * @param {AuthApiApiAuthAccessRequestsIdReviewPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthAccessRequestsIdReviewPut(requestParameters: AuthApiApiAuthAccessRequestsIdReviewPutRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthAccessRequestsIdReviewPut(requestParameters.id, requestParameters.reviewAccessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes the password for the currently authenticated user.
     * @param {AuthApiApiAuthChangePasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthChangePasswordPost(requestParameters: AuthApiApiAuthChangePasswordPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthChangePasswordPost(requestParameters.changePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initiates client authentication using email or phone number and Tax ID verification. This endpoint validates client credentials and sends a verification code if successful.
     * @param {AuthApiApiAuthClientLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthClientLoginPost(requestParameters: AuthApiApiAuthClientLoginPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthClientLoginPost(requestParameters.clientLoginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ⚠️ **WARNING**: This endpoint bypasses all security verification checks and should NEVER be enabled in production.              **Usage Example**: ```bash curl -X POST https://localhost:5001/api/auth/dev-client-login \\   -H \"Content-Type: application/json\" \\   -d \'{\"clientId\":\"3fa85f64-5717-4562-b3fc-2c963f66afa6\",\"emailOrPhone\":\"client@example.com\"}\' ```
     * @summary DEVELOPMENT ONLY: Authenticates a client user bypassing verification code flow. This endpoint is ONLY available in Development environment and returns 403 Forbidden in production. Use this endpoint for testing with Claude Code and other development tools that cannot retrieve verification codes.
     * @param {AuthApiApiAuthDevClientLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthDevClientLoginPost(requestParameters: AuthApiApiAuthDevClientLoginPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthDevClientLoginPost(requestParameters.devClientLoginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ⚠️ **WARNING**: This endpoint bypasses Azure AD entirely and should NEVER be enabled outside the E2E stack. Defense-in-depth: requires BOTH `ASPNETCORE_ENVIRONMENT=Development` AND `AzureAd:SsoMockMode=true`. Either gate closed → 403.              The synthesized claims are fed through the same `ISsoAuthService.ProcessAzureAdClaimsAsync` method the real Azure AD callback uses, so the resulting JWT is identical in shape (claims, issuer, audience, role mapping) to a token produced by a real SSO login.              **Usage Example**: ```bash curl -X POST http://localhost:5261/api/auth/dev-sso-login \\   -H \"Content-Type: application/json\" \\   -d \'{\"email\":\"prep1@test.com\"}\' ```
     * @summary Development-only mock SSO login endpoint. Mints an application JWT for a target seeded preparer email without actually contacting Azure AD. Used by the E2E test suite to exercise the SSO-authenticated preparer code path in isolation from real Azure AD.
     * @param {AuthApiApiAuthDevSsoLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthDevSsoLoginPost(requestParameters: AuthApiApiAuthDevSsoLoginPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthDevSsoLoginPost(requestParameters.devSsoLoginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disables two-factor authentication for the current authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthDisable2faPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthDisable2faPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enables two-factor authentication for the current authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthEnable2faPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthEnable2faPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * **Security Notes**: - Only Preparer and Admin roles can impersonate clients - Preparers can only impersonate clients they have access to - Admins can impersonate any client - Impersonation sessions are logged in the audit trail - Tokens expire after 30 minutes and cannot be refreshed - Impersonated sessions cannot sign documents              **Usage Example**: ```bash curl -X POST https://localhost:5001/api/auth/impersonate-client \\   -H \"Content-Type: application/json\" \\   -H \"Authorization: Bearer {preparer-token}\" \\   -d \'{\"clientId\":\"3fa85f64-5717-4562-b3fc-2c963f66afa6\",\"userId\":\"...\"}\' ```
     * @summary Allows Preparer/Admin to impersonate a client for support and testing purposes. Generates a limited-scope token (30 min, no refresh) that cannot be used for document signing. Creates audit trail entry for security and compliance tracking.
     * @param {AuthApiApiAuthImpersonateClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthImpersonateClientPost(requestParameters: AuthApiApiAuthImpersonateClientPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthImpersonateClientPost(requestParameters.impersonateClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticates admin and preparer users using email and password credentials.
     * @param {AuthApiApiAuthLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthLoginPost(requestParameters: AuthApiApiAuthLoginPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthLoginPost(requestParameters.loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logs out the current authenticated user and invalidates their session tokens.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthLogoutPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refreshes an expired access token using a valid refresh token.
     * @param {AuthApiApiAuthRefreshTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthRefreshTokenPost(requestParameters: AuthApiApiAuthRefreshTokenPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthRefreshTokenPost(requestParameters.refreshTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initiates a password reset request for the specified email address. Always returns success to prevent email enumeration attacks.
     * @param {AuthApiApiAuthRequestPasswordResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthRequestPasswordResetPost(requestParameters: AuthApiApiAuthRequestPasswordResetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthRequestPasswordResetPost(requestParameters.requestPasswordResetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resets user password using a valid reset token received via email.
     * @param {AuthApiApiAuthResetPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthResetPasswordPost(requestParameters: AuthApiApiAuthResetPasswordPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthResetPasswordPost(requestParameters.resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends a verification code to the specified email address for authentication purposes.
     * @param {AuthApiApiAuthSendVerificationCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthSendVerificationCodePost(requestParameters: AuthApiApiAuthSendVerificationCodePostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSendVerificationCodePost(requestParameters.sendVerificationCodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is called by Azure AD after user authentication. It should not be called directly by clients.              On success, redirects to the configured frontend callback URL with query parameters: - `token`: The application JWT access token - `refreshToken`: The refresh token - `expiresAt`: Token expiration timestamp - `isNewUser`: Whether a new account was created              On failure, redirects to frontend with: - `error`: Error code - `message`: Error description
     * @summary Handles the callback from Azure AD after user authentication. Validates the authorization code, exchanges it for tokens, and issues application JWT tokens.
     * @param {AuthApiApiAuthSsoCallbackGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthSsoCallbackGet(requestParameters: AuthApiApiAuthSsoCallbackGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSsoCallbackGet(requestParameters.code, requestParameters.state, requestParameters.error, requestParameters.errorDescription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * **IMPORTANT**: This endpoint returns a 302 redirect, not JSON. The frontend should navigate to this URL directly (window.location.href), not via XHR/fetch.              The OAuth state is stored in a secure cookie and verified in the callback to prevent CSRF attacks.              **Usage Example**: ```javascript // Frontend code - navigate directly, don\'t use fetch/XHR window.location.href = \"https://portal-api.ata.net/api/auth/sso/login?returnUrl=/dashboard\"; ```              Flow: 1. Browser navigates to /api/auth/sso/login 2. Backend sets cookies and returns 302 redirect to Azure AD 3. User authenticates with Azure AD 4. Azure AD redirects to /api/auth/sso/callback 5. Backend validates cookies, issues JWT, redirects to frontend
     * @summary Initiates Azure AD SSO login by redirecting to Azure AD. This endpoint performs a 302 redirect - the browser should navigate directly to this URL.
     * @param {AuthApiApiAuthSsoLoginGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthSsoLoginGet(requestParameters: AuthApiApiAuthSsoLoginGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSsoLoginGet(requestParameters.returnUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint generates the Azure AD sign-out URL. After signing out from Azure AD, the user will be redirected to the configured frontend sign-out URL.              **Note**: This does not invalidate the application JWT token. Clients should also call the regular `/api/auth/logout` endpoint to blacklist the JWT token.
     * @summary Initiates SSO logout by returning the Azure AD sign-out URL. The client should redirect to this URL to sign out from both the application and Azure AD.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthSsoLogoutGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSsoLogoutGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the current Azure AD SSO configuration status. Returns whether SSO is enabled and basic configuration information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthSsoStatusGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthSsoStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verifies the authentication code and completes client login process. Requires client ID from initial login attempt to ensure secure verification.
     * @param {AuthApiApiAuthVerifyCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthVerifyCodePost(requestParameters: AuthApiApiAuthVerifyCodePostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthVerifyCodePost(requestParameters.verifyCodeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BinderNotificationPreferencesApi - axios parameter creator
 */
export const BinderNotificationPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sets or clears the current user\'s binder-level override for a single audit action. Pass a null channel to clear the override (revert to the user\'s global preference).
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {NotificationActionType} actionType 
         * @param {UpdateBinderActionPreferenceDto} [updateBinderActionPreferenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdNotificationPreferencesActionTypePut: async (binderId: string, actionType: NotificationActionType, updateBinderActionPreferenceDto?: UpdateBinderActionPreferenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdNotificationPreferencesActionTypePut', 'binderId', binderId)
            // verify required parameter 'actionType' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdNotificationPreferencesActionTypePut', 'actionType', actionType)
            const localVarPath = `/api/audit-binders/{binderId}/notification-preferences/{actionType}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"actionType"}}`, encodeURIComponent(String(actionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBinderActionPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the current user\'s per-binder audit notification overrides for the given audit binder.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdNotificationPreferencesGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiAuditBindersBinderIdNotificationPreferencesGet', 'binderId', binderId)
            const localVarPath = `/api/audit-binders/{binderId}/notification-preferences`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BinderNotificationPreferencesApi - functional programming interface
 */
export const BinderNotificationPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BinderNotificationPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sets or clears the current user\'s binder-level override for a single audit action. Pass a null channel to clear the override (revert to the user\'s global preference).
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {NotificationActionType} actionType 
         * @param {UpdateBinderActionPreferenceDto} [updateBinderActionPreferenceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdNotificationPreferencesActionTypePut(binderId: string, actionType: NotificationActionType, updateBinderActionPreferenceDto?: UpdateBinderActionPreferenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BinderNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdNotificationPreferencesActionTypePut(binderId, actionType, updateBinderActionPreferenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderNotificationPreferencesApi.apiAuditBindersBinderIdNotificationPreferencesActionTypePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the current user\'s per-binder audit notification overrides for the given audit binder.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditBindersBinderIdNotificationPreferencesGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BinderNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditBindersBinderIdNotificationPreferencesGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderNotificationPreferencesApi.apiAuditBindersBinderIdNotificationPreferencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BinderNotificationPreferencesApi - factory interface
 */
export const BinderNotificationPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BinderNotificationPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Sets or clears the current user\'s binder-level override for a single audit action. Pass a null channel to clear the override (revert to the user\'s global preference).
         * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdNotificationPreferencesActionTypePut(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiAuditBindersBinderIdNotificationPreferencesActionTypePut(requestParameters.binderId, requestParameters.actionType, requestParameters.updateBinderActionPreferenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the current user\'s per-binder audit notification overrides for the given audit binder.
         * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditBindersBinderIdNotificationPreferencesGet(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiAuditBindersBinderIdNotificationPreferencesGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BinderNotificationPreferencesApi - interface
 */
export interface BinderNotificationPreferencesApiInterface {
    /**
     * 
     * @summary Sets or clears the current user\'s binder-level override for a single audit action. Pass a null channel to clear the override (revert to the user\'s global preference).
     * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdNotificationPreferencesActionTypePut(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @summary Gets the current user\'s per-binder audit notification overrides for the given audit binder.
     * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuditBindersBinderIdNotificationPreferencesGet(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderNotificationPreferenceDtoApiResponse>;

}

/**
 * Request parameters for apiAuditBindersBinderIdNotificationPreferencesActionTypePut operation in BinderNotificationPreferencesApi.
 */
export interface BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly actionType: NotificationActionType

    readonly updateBinderActionPreferenceDto?: UpdateBinderActionPreferenceDto
}

/**
 * Request parameters for apiAuditBindersBinderIdNotificationPreferencesGet operation in BinderNotificationPreferencesApi.
 */
export interface BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * BinderNotificationPreferencesApi - object-oriented interface
 */
export class BinderNotificationPreferencesApi extends BaseAPI implements BinderNotificationPreferencesApiInterface {
    /**
     * 
     * @summary Sets or clears the current user\'s binder-level override for a single audit action. Pass a null channel to clear the override (revert to the user\'s global preference).
     * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdNotificationPreferencesActionTypePut(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesActionTypePutRequest, options?: RawAxiosRequestConfig) {
        return BinderNotificationPreferencesApiFp(this.configuration).apiAuditBindersBinderIdNotificationPreferencesActionTypePut(requestParameters.binderId, requestParameters.actionType, requestParameters.updateBinderActionPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the current user\'s per-binder audit notification overrides for the given audit binder.
     * @param {BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuditBindersBinderIdNotificationPreferencesGet(requestParameters: BinderNotificationPreferencesApiApiAuditBindersBinderIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig) {
        return BinderNotificationPreferencesApiFp(this.configuration).apiAuditBindersBinderIdNotificationPreferencesGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BinderWatcherApi - axios parameter creator
 */
export const BinderWatcherApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Unfollow a binder as the current user (idempotent). Preparer or Admin only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersDelete: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiBindersBinderIdWatchersDelete', 'binderId', binderId)
            const localVarPath = `/api/binders/{binderId}/watchers`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if the current user is following a specific binder. Preparer or Admin only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersMeGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiBindersBinderIdWatchersMeGet', 'binderId', binderId)
            const localVarPath = `/api/binders/{binderId}/watchers/me`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Follow a binder as the current user (idempotent). Preparer or Admin only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersPost: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiBindersBinderIdWatchersPost', 'binderId', binderId)
            const localVarPath = `/api/binders/{binderId}/watchers`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all binder IDs the current user is following. Preparer or Admin only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersWatchedGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/binders/watched`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BinderWatcherApi - functional programming interface
 */
export const BinderWatcherApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BinderWatcherApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Unfollow a binder as the current user (idempotent). Preparer or Admin only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBindersBinderIdWatchersDelete(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBindersBinderIdWatchersDelete(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderWatcherApi.apiBindersBinderIdWatchersDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if the current user is following a specific binder. Preparer or Admin only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBindersBinderIdWatchersMeGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBindersBinderIdWatchersMeGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderWatcherApi.apiBindersBinderIdWatchersMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Follow a binder as the current user (idempotent). Preparer or Admin only.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBindersBinderIdWatchersPost(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBindersBinderIdWatchersPost(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderWatcherApi.apiBindersBinderIdWatchersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all binder IDs the current user is following. Preparer or Admin only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBindersWatchedGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBindersWatchedGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BinderWatcherApi.apiBindersWatchedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BinderWatcherApi - factory interface
 */
export const BinderWatcherApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BinderWatcherApiFp(configuration)
    return {
        /**
         * 
         * @summary Unfollow a binder as the current user (idempotent). Preparer or Admin only.
         * @param {BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersDelete(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiBindersBinderIdWatchersDelete(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if the current user is following a specific binder. Preparer or Admin only.
         * @param {BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersMeGet(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiBindersBinderIdWatchersMeGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Follow a binder as the current user (idempotent). Preparer or Admin only.
         * @param {BinderWatcherApiApiBindersBinderIdWatchersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersBinderIdWatchersPost(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiBindersBinderIdWatchersPost(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all binder IDs the current user is following. Preparer or Admin only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersWatchedGet(options?: RawAxiosRequestConfig): AxiosPromise<GuidListApiResponse> {
            return localVarFp.apiBindersWatchedGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BinderWatcherApi - interface
 */
export interface BinderWatcherApiInterface {
    /**
     * 
     * @summary Unfollow a binder as the current user (idempotent). Preparer or Admin only.
     * @param {BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBindersBinderIdWatchersDelete(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Check if the current user is following a specific binder. Preparer or Admin only.
     * @param {BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBindersBinderIdWatchersMeGet(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Follow a binder as the current user (idempotent). Preparer or Admin only.
     * @param {BinderWatcherApiApiBindersBinderIdWatchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBindersBinderIdWatchersPost(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Get all binder IDs the current user is following. Preparer or Admin only.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBindersWatchedGet(options?: RawAxiosRequestConfig): AxiosPromise<GuidListApiResponse>;

}

/**
 * Request parameters for apiBindersBinderIdWatchersDelete operation in BinderWatcherApi.
 */
export interface BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiBindersBinderIdWatchersMeGet operation in BinderWatcherApi.
 */
export interface BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiBindersBinderIdWatchersPost operation in BinderWatcherApi.
 */
export interface BinderWatcherApiApiBindersBinderIdWatchersPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * BinderWatcherApi - object-oriented interface
 */
export class BinderWatcherApi extends BaseAPI implements BinderWatcherApiInterface {
    /**
     * 
     * @summary Unfollow a binder as the current user (idempotent). Preparer or Admin only.
     * @param {BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBindersBinderIdWatchersDelete(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersDeleteRequest, options?: RawAxiosRequestConfig) {
        return BinderWatcherApiFp(this.configuration).apiBindersBinderIdWatchersDelete(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if the current user is following a specific binder. Preparer or Admin only.
     * @param {BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBindersBinderIdWatchersMeGet(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersMeGetRequest, options?: RawAxiosRequestConfig) {
        return BinderWatcherApiFp(this.configuration).apiBindersBinderIdWatchersMeGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Follow a binder as the current user (idempotent). Preparer or Admin only.
     * @param {BinderWatcherApiApiBindersBinderIdWatchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBindersBinderIdWatchersPost(requestParameters: BinderWatcherApiApiBindersBinderIdWatchersPostRequest, options?: RawAxiosRequestConfig) {
        return BinderWatcherApiFp(this.configuration).apiBindersBinderIdWatchersPost(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all binder IDs the current user is following. Preparer or Admin only.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBindersWatchedGet(options?: RawAxiosRequestConfig) {
        return BinderWatcherApiFp(this.configuration).apiBindersWatchedGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BindersApi - axios parameter creator
 */
export const BindersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [clientId] Use an existing client ID
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersGet: async (clientId?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/binders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BindersApi - functional programming interface
 */
export const BindersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BindersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [clientId] Use an existing client ID
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBindersGet(clientId?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BinderListItemDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBindersGet(clientId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BindersApi.apiBindersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BindersApi - factory interface
 */
export const BindersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BindersApiFp(configuration)
    return {
        /**
         * 
         * @param {BindersApiApiBindersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBindersGet(requestParameters: BindersApiApiBindersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BinderListItemDtoPaginatedResponseApiResponse> {
            return localVarFp.apiBindersGet(requestParameters.clientId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BindersApi - interface
 */
export interface BindersApiInterface {
    /**
     * 
     * @param {BindersApiApiBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBindersGet(requestParameters?: BindersApiApiBindersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderListItemDtoPaginatedResponseApiResponse>;

}

/**
 * Request parameters for apiBindersGet operation in BindersApi.
 */
export interface BindersApiApiBindersGetRequest {
    /**
     * Use an existing client ID
     */
    readonly clientId?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * BindersApi - object-oriented interface
 */
export class BindersApi extends BaseAPI implements BindersApiInterface {
    /**
     * 
     * @param {BindersApiApiBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBindersGet(requestParameters: BindersApiApiBindersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return BindersApiFp(this.configuration).apiBindersGet(requestParameters.clientId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CCHOAuthApi - axios parameter creator
 */
export const CCHOAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthAuthorizeUrlGet: async (state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/authorize-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthCallbackGet: async (code?: string, state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthConnectGet: async (state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthManageGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/manage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthRefreshPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthRevokePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CCHOAuth/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CCHOAuthApi - functional programming interface
 */
export const CCHOAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CCHOAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthAuthorizeUrlGet(state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthAuthorizeUrlGet(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthAuthorizeUrlGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [code] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthCallbackGet(code?: string, state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthCallbackGet(code, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthConnectGet(state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthConnectGet(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthConnectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthManageGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthManageGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthManageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthRefreshPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthRefreshPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthRevokePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthRevokePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthRevokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCCHOAuthStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCCHOAuthStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CCHOAuthApi.apiCCHOAuthStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CCHOAuthApi - factory interface
 */
export const CCHOAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CCHOAuthApiFp(configuration)
    return {
        /**
         * 
         * @param {CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthAuthorizeUrlGet(requestParameters: CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthAuthorizeUrlGet(requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CCHOAuthApiApiCCHOAuthCallbackGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthCallbackGet(requestParameters: CCHOAuthApiApiCCHOAuthCallbackGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthCallbackGet(requestParameters.code, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CCHOAuthApiApiCCHOAuthConnectGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthConnectGet(requestParameters: CCHOAuthApiApiCCHOAuthConnectGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthConnectGet(requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthManageGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthManageGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthRefreshPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthRefreshPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthRevokePost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthRevokePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCCHOAuthStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCCHOAuthStatusGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CCHOAuthApi - interface
 */
export interface CCHOAuthApiInterface {
    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthAuthorizeUrlGet(requestParameters?: CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthCallbackGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthCallbackGet(requestParameters?: CCHOAuthApiApiCCHOAuthCallbackGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthConnectGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthConnectGet(requestParameters?: CCHOAuthApiApiCCHOAuthConnectGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthGet(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthManageGet(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthRefreshPost(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthRevokePost(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCCHOAuthStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for apiCCHOAuthAuthorizeUrlGet operation in CCHOAuthApi.
 */
export interface CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest {
    readonly state?: string
}

/**
 * Request parameters for apiCCHOAuthCallbackGet operation in CCHOAuthApi.
 */
export interface CCHOAuthApiApiCCHOAuthCallbackGetRequest {
    readonly code?: string

    readonly state?: string
}

/**
 * Request parameters for apiCCHOAuthConnectGet operation in CCHOAuthApi.
 */
export interface CCHOAuthApiApiCCHOAuthConnectGetRequest {
    readonly state?: string
}

/**
 * CCHOAuthApi - object-oriented interface
 */
export class CCHOAuthApi extends BaseAPI implements CCHOAuthApiInterface {
    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthAuthorizeUrlGet(requestParameters: CCHOAuthApiApiCCHOAuthAuthorizeUrlGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthAuthorizeUrlGet(requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthCallbackGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthCallbackGet(requestParameters: CCHOAuthApiApiCCHOAuthCallbackGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthCallbackGet(requestParameters.code, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CCHOAuthApiApiCCHOAuthConnectGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthConnectGet(requestParameters: CCHOAuthApiApiCCHOAuthConnectGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthConnectGet(requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthGet(options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthManageGet(options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthManageGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthRefreshPost(options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthRefreshPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthRevokePost(options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthRevokePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCCHOAuthStatusGet(options?: RawAxiosRequestConfig) {
        return CCHOAuthApiFp(this.configuration).apiCCHOAuthStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CchWorkflowDiagnosticsApi - axios parameter creator
 */
export const CchWorkflowDiagnosticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Uses `Task/search` (M:ATA.CCH.ApiClient.Interfaces.ICCHWorkflowTaskService.SearchTasks(ATA.CCH.ApiClient.Models.WorkflowTask.CCHTaskSearchRequest,System.Threading.CancellationToken)) with `IncludeStatus=Completed` — the same query the nightly poll uses. Default scope is a single period-end date (12/31 of year), which stays within the 3-month range the base endpoint allows. Supply fromPeriod/toPeriod for a wider range; a range over 3 months routes to the v2.2 endpoint and then also requires updatedFrom/updatedTo (≤ 7 days apart), otherwise CCH 400s.
         * @summary Dry-run data source for the matching-quality analysis: pulls every CCH task CCH currently reports as \"Completed\" for the given period-end scope, paged, deduped by taskId, then filtered to the TAX category client-side (the search has no category field). Read-only against CCH; returns raw rows so they can be loaded into a temp DB and matched against portal binders offline.
         * @param {number} [year] 
         * @param {string} [status] 
         * @param {string} [category] 
         * @param {string} [periodEnd] 
         * @param {string} [fromPeriod] 
         * @param {string} [toPeriod] 
         * @param {string} [updatedFrom] 
         * @param {string} [updatedTo] 
         * @param {boolean} [countOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCchCompletedTasksGet: async (year?: number, status?: string, category?: string, periodEnd?: string, fromPeriod?: string, toPeriod?: string, updatedFrom?: string, updatedTo?: string, countOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/cch/completed-tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (periodEnd !== undefined) {
                localVarQueryParameter['periodEnd'] = periodEnd;
            }

            if (fromPeriod !== undefined) {
                localVarQueryParameter['fromPeriod'] = fromPeriod;
            }

            if (toPeriod !== undefined) {
                localVarQueryParameter['toPeriod'] = toPeriod;
            }

            if (updatedFrom !== undefined) {
                localVarQueryParameter['updatedFrom'] = updatedFrom;
            }

            if (updatedTo !== undefined) {
                localVarQueryParameter['updatedTo'] = updatedTo;
            }

            if (countOnly !== undefined) {
                localVarQueryParameter['countOnly'] = countOnly;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Universe probe via SearchTasksAdvanced, which returns a real match TotalCount without paging. Filters are key/value pairs (e.g. Status=Completed, TaskTypeCode=1040). This endpoint has no period-end field, so it counts across all periods.
         * @param {string} [status] 
         * @param {string} [taskType] 
         * @param {string} [taskTypeCode] 
         * @param {string} [accountNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCchTaskCountGet: async (status?: string, taskType?: string, taskTypeCode?: string, accountNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/cch/task-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (taskType !== undefined) {
                localVarQueryParameter['taskType'] = taskType;
            }

            if (taskTypeCode !== undefined) {
                localVarQueryParameter['taskTypeCode'] = taskTypeCode;
            }

            if (accountNumber !== undefined) {
                localVarQueryParameter['accountNumber'] = accountNumber;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the firm-wide list of configured workflow statuses (`ICCHWorkflowFirmService.GetStatusList()`) — the states a binder/task can be in. These are firm-configured, so the set is specific to this tenant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCchWorkflowStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/cch/workflow-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CchWorkflowDiagnosticsApi - functional programming interface
 */
export const CchWorkflowDiagnosticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CchWorkflowDiagnosticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Uses `Task/search` (M:ATA.CCH.ApiClient.Interfaces.ICCHWorkflowTaskService.SearchTasks(ATA.CCH.ApiClient.Models.WorkflowTask.CCHTaskSearchRequest,System.Threading.CancellationToken)) with `IncludeStatus=Completed` — the same query the nightly poll uses. Default scope is a single period-end date (12/31 of year), which stays within the 3-month range the base endpoint allows. Supply fromPeriod/toPeriod for a wider range; a range over 3 months routes to the v2.2 endpoint and then also requires updatedFrom/updatedTo (≤ 7 days apart), otherwise CCH 400s.
         * @summary Dry-run data source for the matching-quality analysis: pulls every CCH task CCH currently reports as \"Completed\" for the given period-end scope, paged, deduped by taskId, then filtered to the TAX category client-side (the search has no category field). Read-only against CCH; returns raw rows so they can be loaded into a temp DB and matched against portal binders offline.
         * @param {number} [year] 
         * @param {string} [status] 
         * @param {string} [category] 
         * @param {string} [periodEnd] 
         * @param {string} [fromPeriod] 
         * @param {string} [toPeriod] 
         * @param {string} [updatedFrom] 
         * @param {string} [updatedTo] 
         * @param {boolean} [countOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminCchCompletedTasksGet(year?: number, status?: string, category?: string, periodEnd?: string, fromPeriod?: string, toPeriod?: string, updatedFrom?: string, updatedTo?: string, countOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminCchCompletedTasksGet(year, status, category, periodEnd, fromPeriod, toPeriod, updatedFrom, updatedTo, countOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CchWorkflowDiagnosticsApi.apiAdminCchCompletedTasksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Universe probe via SearchTasksAdvanced, which returns a real match TotalCount without paging. Filters are key/value pairs (e.g. Status=Completed, TaskTypeCode=1040). This endpoint has no period-end field, so it counts across all periods.
         * @param {string} [status] 
         * @param {string} [taskType] 
         * @param {string} [taskTypeCode] 
         * @param {string} [accountNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminCchTaskCountGet(status?: string, taskType?: string, taskTypeCode?: string, accountNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminCchTaskCountGet(status, taskType, taskTypeCode, accountNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CchWorkflowDiagnosticsApi.apiAdminCchTaskCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the firm-wide list of configured workflow statuses (`ICCHWorkflowFirmService.GetStatusList()`) — the states a binder/task can be in. These are firm-configured, so the set is specific to this tenant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminCchWorkflowStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminCchWorkflowStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CchWorkflowDiagnosticsApi.apiAdminCchWorkflowStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CchWorkflowDiagnosticsApi - factory interface
 */
export const CchWorkflowDiagnosticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CchWorkflowDiagnosticsApiFp(configuration)
    return {
        /**
         * Uses `Task/search` (M:ATA.CCH.ApiClient.Interfaces.ICCHWorkflowTaskService.SearchTasks(ATA.CCH.ApiClient.Models.WorkflowTask.CCHTaskSearchRequest,System.Threading.CancellationToken)) with `IncludeStatus=Completed` — the same query the nightly poll uses. Default scope is a single period-end date (12/31 of year), which stays within the 3-month range the base endpoint allows. Supply fromPeriod/toPeriod for a wider range; a range over 3 months routes to the v2.2 endpoint and then also requires updatedFrom/updatedTo (≤ 7 days apart), otherwise CCH 400s.
         * @summary Dry-run data source for the matching-quality analysis: pulls every CCH task CCH currently reports as \"Completed\" for the given period-end scope, paged, deduped by taskId, then filtered to the TAX category client-side (the search has no category field). Read-only against CCH; returns raw rows so they can be loaded into a temp DB and matched against portal binders offline.
         * @param {CchWorkflowDiagnosticsApiApiAdminCchCompletedTasksGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCchCompletedTasksGet(requestParameters: CchWorkflowDiagnosticsApiApiAdminCchCompletedTasksGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiAdminCchCompletedTasksGet(requestParameters.year, requestParameters.status, requestParameters.category, requestParameters.periodEnd, requestParameters.fromPeriod, requestParameters.toPeriod, requestParameters.updatedFrom, requestParameters.updatedTo, requestParameters.countOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Universe probe via SearchTasksAdvanced, which returns a real match TotalCount without paging. Filters are key/value pairs (e.g. Status=Completed, TaskTypeCode=1040). This endpoint has no period-end field, so it counts across all periods.
         * @param {CchWorkflowDiagnosticsApiApiAdminCchTaskCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCchTaskCountGet(requestParameters: CchWorkflowDiagnosticsApiApiAdminCchTaskCountGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiAdminCchTaskCountGet(requestParameters.status, requestParameters.taskType, requestParameters.taskTypeCode, requestParameters.accountNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the firm-wide list of configured workflow statuses (`ICCHWorkflowFirmService.GetStatusList()`) — the states a binder/task can be in. These are firm-configured, so the set is specific to this tenant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminCchWorkflowStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiAdminCchWorkflowStatusesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CchWorkflowDiagnosticsApi - interface
 */
export interface CchWorkflowDiagnosticsApiInterface {
    /**
     * Uses `Task/search` (M:ATA.CCH.ApiClient.Interfaces.ICCHWorkflowTaskService.SearchTasks(ATA.CCH.ApiClient.Models.WorkflowTask.CCHTaskSearchRequest,System.Threading.CancellationToken)) with `IncludeStatus=Completed` — the same query the nightly poll uses. Default scope is a single period-end date (12/31 of year), which stays within the 3-month range the base endpoint allows. Supply fromPeriod/toPeriod for a wider range; a range over 3 months routes to the v2.2 endpoint and then also requires updatedFrom/updatedTo (≤ 7 days apart), otherwise CCH 400s.
     * @summary Dry-run data source for the matching-quality analysis: pulls every CCH task CCH currently reports as \"Completed\" for the given period-end scope, paged, deduped by taskId, then filtered to the TAX category client-side (the search has no category field). Read-only against CCH; returns raw rows so they can be loaded into a temp DB and matched against portal binders offline.
     * @param {CchWorkflowDiagnosticsApiApiAdminCchCompletedTasksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminCchCompletedTasksGet(requestParameters?: CchWorkflowDiagnosticsApiApiAdminCchCompletedTasksGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary Universe probe via SearchTasksAdvanced, which returns a real match TotalCount without paging. Filters are key/value pairs (e.g. Status=Completed, TaskTypeCode=1040). This endpoint has no period-end field, so it counts across all periods.
     * @param {CchWorkflowDiagnosticsApiApiAdminCchTaskCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminCchTaskCountGet(requestParameters?: CchWorkflowDiagnosticsApiApiAdminCchTaskCountGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary Returns the firm-wide list of configured workflow statuses (`ICCHWorkflowFirmService.GetStatusList()`) — the states a binder/task can be in. These are firm-configured, so the set is specific to this tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAdminCchWorkflowStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

}

/**
 * Request parameters for apiAdminCchCompletedTasksGet operation in CchWorkflowDiagnosticsApi.
 */
export interface CchWorkflowDiagnosticsApiApiAdminCchCompletedTasksGetRequest {
    readonly year?: number

    readonly status?: string

    readonly category?: string

    readonly periodEnd?: string

    readonly fromPeriod?: string

    readonly toPeriod?: string

    readonly updatedFrom?: string

    readonly updatedTo?: string

    readonly countOnly?: boolean
}

/**
 * Request parameters for apiAdminCchTaskCountGet operation in CchWorkflowDiagnosticsApi.
 */
export interface CchWorkflowDiagnosticsApiApiAdminCchTaskCountGetRequest {
    readonly status?: string

    readonly taskType?: string

    readonly taskTypeCode?: string

    readonly accountNumber?: string
}

/**
 * CchWorkflowDiagnosticsApi - object-oriented interface
 */
export class CchWorkflowDiagnosticsApi extends BaseAPI implements CchWorkflowDiagnosticsApiInterface {
    /**
     * Uses `Task/search` (M:ATA.CCH.ApiClient.Interfaces.ICCHWorkflowTaskService.SearchTasks(ATA.CCH.ApiClient.Models.WorkflowTask.CCHTaskSearchRequest,System.Threading.CancellationToken)) with `IncludeStatus=Completed` — the same query the nightly poll uses. Default scope is a single period-end date (12/31 of year), which stays within the 3-month range the base endpoint allows. Supply fromPeriod/toPeriod for a wider range; a range over 3 months routes to the v2.2 endpoint and then also requires updatedFrom/updatedTo (≤ 7 days apart), otherwise CCH 400s.
     * @summary Dry-run data source for the matching-quality analysis: pulls every CCH task CCH currently reports as \"Completed\" for the given period-end scope, paged, deduped by taskId, then filtered to the TAX category client-side (the search has no category field). Read-only against CCH; returns raw rows so they can be loaded into a temp DB and matched against portal binders offline.
     * @param {CchWorkflowDiagnosticsApiApiAdminCchCompletedTasksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminCchCompletedTasksGet(requestParameters: CchWorkflowDiagnosticsApiApiAdminCchCompletedTasksGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CchWorkflowDiagnosticsApiFp(this.configuration).apiAdminCchCompletedTasksGet(requestParameters.year, requestParameters.status, requestParameters.category, requestParameters.periodEnd, requestParameters.fromPeriod, requestParameters.toPeriod, requestParameters.updatedFrom, requestParameters.updatedTo, requestParameters.countOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Universe probe via SearchTasksAdvanced, which returns a real match TotalCount without paging. Filters are key/value pairs (e.g. Status=Completed, TaskTypeCode=1040). This endpoint has no period-end field, so it counts across all periods.
     * @param {CchWorkflowDiagnosticsApiApiAdminCchTaskCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminCchTaskCountGet(requestParameters: CchWorkflowDiagnosticsApiApiAdminCchTaskCountGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CchWorkflowDiagnosticsApiFp(this.configuration).apiAdminCchTaskCountGet(requestParameters.status, requestParameters.taskType, requestParameters.taskTypeCode, requestParameters.accountNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the firm-wide list of configured workflow statuses (`ICCHWorkflowFirmService.GetStatusList()`) — the states a binder/task can be in. These are firm-configured, so the set is specific to this tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminCchWorkflowStatusesGet(options?: RawAxiosRequestConfig) {
        return CchWorkflowDiagnosticsApiFp(this.configuration).apiAdminCchWorkflowStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientAccessApi - axios parameter creator
 */
export const ClientAccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all users who have access to a specific confidential client
         * @param {string} clientId The ID of the client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedUsers: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getAuthorizedUsers', 'clientId', clientId)
            const localVarPath = `/api/ClientAccess/{clientId}/access/authorized-users`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Grant access to a confidential client for a specific user
         * @param {string} clientId The ID of the client
         * @param {GrantAccessRequest} [grantAccessRequest] Request containing the user ID to grant access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAccess: async (clientId: string, grantAccessRequest?: GrantAccessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('grantAccess', 'clientId', clientId)
            const localVarPath = `/api/ClientAccess/{clientId}/access/grant`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grantAccessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a client as confidential
         * @param {string} clientId The ID of the client to mark as confidential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markConfidential: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('markConfidential', 'clientId', clientId)
            const localVarPath = `/api/ClientAccess/{clientId}/confidential`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke access to a confidential client for a specific user
         * @param {string} clientId The ID of the client
         * @param {string} userId The ID of the user to revoke access from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAccess: async (clientId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('revokeAccess', 'clientId', clientId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('revokeAccess', 'userId', userId)
            const localVarPath = `/api/ClientAccess/{clientId}/access/revoke/{userId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for preparers and admins to add to a confidential client
         * @param {string} [query] Search query (name or email)
         * @param {string} [clientId] Optional client ID to exclude users who already have access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPreparers: async (query?: string, clientId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientAccess/search-preparers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unmark a client as confidential (remove confidentiality)
         * @param {string} clientId The ID of the client to unmark as confidential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmarkConfidential: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('unmarkConfidential', 'clientId', clientId)
            const localVarPath = `/api/ClientAccess/{clientId}/confidential`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientAccessApi - functional programming interface
 */
export const ClientAccessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientAccessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all users who have access to a specific confidential client
         * @param {string} clientId The ID of the client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorizedUsers(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAccessPermissionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorizedUsers(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.getAuthorizedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Grant access to a confidential client for a specific user
         * @param {string} clientId The ID of the client
         * @param {GrantAccessRequest} [grantAccessRequest] Request containing the user ID to grant access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantAccess(clientId: string, grantAccessRequest?: GrantAccessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantAccess(clientId, grantAccessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.grantAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a client as confidential
         * @param {string} clientId The ID of the client to mark as confidential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markConfidential(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markConfidential(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.markConfidential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke access to a confidential client for a specific user
         * @param {string} clientId The ID of the client
         * @param {string} userId The ID of the user to revoke access from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAccess(clientId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAccess(clientId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.revokeAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search for preparers and admins to add to a confidential client
         * @param {string} [query] Search query (name or email)
         * @param {string} [clientId] Optional client ID to exclude users who already have access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPreparers(query?: string, clientId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSearchResultDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPreparers(query, clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.searchPreparers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unmark a client as confidential (remove confidentiality)
         * @param {string} clientId The ID of the client to unmark as confidential
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unmarkConfidential(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unmarkConfidential(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAccessApi.unmarkConfidential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientAccessApi - factory interface
 */
export const ClientAccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientAccessApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all users who have access to a specific confidential client
         * @param {ClientAccessApiGetAuthorizedUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedUsers(requestParameters: ClientAccessApiGetAuthorizedUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAccessPermissionDtoListApiResponse> {
            return localVarFp.getAuthorizedUsers(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Grant access to a confidential client for a specific user
         * @param {ClientAccessApiGrantAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAccess(requestParameters: ClientAccessApiGrantAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.grantAccess(requestParameters.clientId, requestParameters.grantAccessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a client as confidential
         * @param {ClientAccessApiMarkConfidentialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markConfidential(requestParameters: ClientAccessApiMarkConfidentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.markConfidential(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke access to a confidential client for a specific user
         * @param {ClientAccessApiRevokeAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAccess(requestParameters: ClientAccessApiRevokeAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.revokeAccess(requestParameters.clientId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for preparers and admins to add to a confidential client
         * @param {ClientAccessApiSearchPreparersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPreparers(requestParameters: ClientAccessApiSearchPreparersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResultDtoListApiResponse> {
            return localVarFp.searchPreparers(requestParameters.query, requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unmark a client as confidential (remove confidentiality)
         * @param {ClientAccessApiUnmarkConfidentialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmarkConfidential(requestParameters: ClientAccessApiUnmarkConfidentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.unmarkConfidential(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientAccessApi - interface
 */
export interface ClientAccessApiInterface {
    /**
     * 
     * @summary Get all users who have access to a specific confidential client
     * @param {ClientAccessApiGetAuthorizedUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthorizedUsers(requestParameters: ClientAccessApiGetAuthorizedUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAccessPermissionDtoListApiResponse>;

    /**
     * 
     * @summary Grant access to a confidential client for a specific user
     * @param {ClientAccessApiGrantAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    grantAccess(requestParameters: ClientAccessApiGrantAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Mark a client as confidential
     * @param {ClientAccessApiMarkConfidentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markConfidential(requestParameters: ClientAccessApiMarkConfidentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Revoke access to a confidential client for a specific user
     * @param {ClientAccessApiRevokeAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revokeAccess(requestParameters: ClientAccessApiRevokeAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Search for preparers and admins to add to a confidential client
     * @param {ClientAccessApiSearchPreparersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchPreparers(requestParameters?: ClientAccessApiSearchPreparersRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResultDtoListApiResponse>;

    /**
     * 
     * @summary Unmark a client as confidential (remove confidentiality)
     * @param {ClientAccessApiUnmarkConfidentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unmarkConfidential(requestParameters: ClientAccessApiUnmarkConfidentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

}

/**
 * Request parameters for getAuthorizedUsers operation in ClientAccessApi.
 */
export interface ClientAccessApiGetAuthorizedUsersRequest {
    /**
     * The ID of the client
     */
    readonly clientId: string
}

/**
 * Request parameters for grantAccess operation in ClientAccessApi.
 */
export interface ClientAccessApiGrantAccessRequest {
    /**
     * The ID of the client
     */
    readonly clientId: string

    /**
     * Request containing the user ID to grant access to
     */
    readonly grantAccessRequest?: GrantAccessRequest
}

/**
 * Request parameters for markConfidential operation in ClientAccessApi.
 */
export interface ClientAccessApiMarkConfidentialRequest {
    /**
     * The ID of the client to mark as confidential
     */
    readonly clientId: string
}

/**
 * Request parameters for revokeAccess operation in ClientAccessApi.
 */
export interface ClientAccessApiRevokeAccessRequest {
    /**
     * The ID of the client
     */
    readonly clientId: string

    /**
     * The ID of the user to revoke access from
     */
    readonly userId: string
}

/**
 * Request parameters for searchPreparers operation in ClientAccessApi.
 */
export interface ClientAccessApiSearchPreparersRequest {
    /**
     * Search query (name or email)
     */
    readonly query?: string

    /**
     * Optional client ID to exclude users who already have access
     */
    readonly clientId?: string
}

/**
 * Request parameters for unmarkConfidential operation in ClientAccessApi.
 */
export interface ClientAccessApiUnmarkConfidentialRequest {
    /**
     * The ID of the client to unmark as confidential
     */
    readonly clientId: string
}

/**
 * ClientAccessApi - object-oriented interface
 */
export class ClientAccessApi extends BaseAPI implements ClientAccessApiInterface {
    /**
     * 
     * @summary Get all users who have access to a specific confidential client
     * @param {ClientAccessApiGetAuthorizedUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAuthorizedUsers(requestParameters: ClientAccessApiGetAuthorizedUsersRequest, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).getAuthorizedUsers(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Grant access to a confidential client for a specific user
     * @param {ClientAccessApiGrantAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public grantAccess(requestParameters: ClientAccessApiGrantAccessRequest, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).grantAccess(requestParameters.clientId, requestParameters.grantAccessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a client as confidential
     * @param {ClientAccessApiMarkConfidentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markConfidential(requestParameters: ClientAccessApiMarkConfidentialRequest, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).markConfidential(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke access to a confidential client for a specific user
     * @param {ClientAccessApiRevokeAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeAccess(requestParameters: ClientAccessApiRevokeAccessRequest, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).revokeAccess(requestParameters.clientId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for preparers and admins to add to a confidential client
     * @param {ClientAccessApiSearchPreparersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchPreparers(requestParameters: ClientAccessApiSearchPreparersRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).searchPreparers(requestParameters.query, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unmark a client as confidential (remove confidentiality)
     * @param {ClientAccessApiUnmarkConfidentialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unmarkConfidential(requestParameters: ClientAccessApiUnmarkConfidentialRequest, options?: RawAxiosRequestConfig) {
        return ClientAccessApiFp(this.configuration).unmarkConfidential(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientNotesApi - axios parameter creator
 */
export const ClientNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves all notes for a client within a service line, newest first.
         * @param {string} [clientId] The client to fetch notes for.
         * @param {ServiceLine} [serviceLine] The service line the notes are scoped to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesGet: async (clientId?: string, serviceLine?: ServiceLine, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientNotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (serviceLine !== undefined) {
                localVarQueryParameter['serviceLine'] = serviceLine;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft deletes a client note. Only the note\'s creator may delete it.
         * @param {string} id The unique identifier of the note to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientNotesIdDelete', 'id', id)
            const localVarPath = `/api/ClientNotes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a specific client note by its unique identifier.
         * @param {string} id The unique identifier of the note to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientNotesIdGet', 'id', id)
            const localVarPath = `/api/ClientNotes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the content of an existing client note. Only the note\'s creator may update it.
         * @param {string} id The unique identifier of the note to update.
         * @param {UpdateClientNoteDto} [updateClientNoteDto] The note update data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdPut: async (id: string, updateClientNoteDto?: UpdateClientNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientNotesIdPut', 'id', id)
            const localVarPath = `/api/ClientNotes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new client note for a client within a service line.
         * @param {CreateClientNoteDto} [createClientNoteDto] Note creation data including client ID, service line, and content.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesPost: async (createClientNoteDto?: CreateClientNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ClientNotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientNotesApi - functional programming interface
 */
export const ClientNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves all notes for a client within a service line, newest first.
         * @param {string} [clientId] The client to fetch notes for.
         * @param {ServiceLine} [serviceLine] The service line the notes are scoped to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientNotesGet(clientId?: string, serviceLine?: ServiceLine, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNoteDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientNotesGet(clientId, serviceLine, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotesApi.apiClientNotesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Soft deletes a client note. Only the note\'s creator may delete it.
         * @param {string} id The unique identifier of the note to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientNotesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientNotesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotesApi.apiClientNotesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a specific client note by its unique identifier.
         * @param {string} id The unique identifier of the note to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientNotesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNoteDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientNotesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotesApi.apiClientNotesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates the content of an existing client note. Only the note\'s creator may update it.
         * @param {string} id The unique identifier of the note to update.
         * @param {UpdateClientNoteDto} [updateClientNoteDto] The note update data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientNotesIdPut(id: string, updateClientNoteDto?: UpdateClientNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNoteDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientNotesIdPut(id, updateClientNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotesApi.apiClientNotesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new client note for a client within a service line.
         * @param {CreateClientNoteDto} [createClientNoteDto] Note creation data including client ID, service line, and content.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientNotesPost(createClientNoteDto?: CreateClientNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNoteDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientNotesPost(createClientNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotesApi.apiClientNotesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientNotesApi - factory interface
 */
export const ClientNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientNotesApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves all notes for a client within a service line, newest first.
         * @param {ClientNotesApiApiClientNotesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesGet(requestParameters: ClientNotesApiApiClientNotesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoListApiResponse> {
            return localVarFp.apiClientNotesGet(requestParameters.clientId, requestParameters.serviceLine, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft deletes a client note. Only the note\'s creator may delete it.
         * @param {ClientNotesApiApiClientNotesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdDelete(requestParameters: ClientNotesApiApiClientNotesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientNotesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a specific client note by its unique identifier.
         * @param {ClientNotesApiApiClientNotesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdGet(requestParameters: ClientNotesApiApiClientNotesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse> {
            return localVarFp.apiClientNotesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the content of an existing client note. Only the note\'s creator may update it.
         * @param {ClientNotesApiApiClientNotesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesIdPut(requestParameters: ClientNotesApiApiClientNotesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse> {
            return localVarFp.apiClientNotesIdPut(requestParameters.id, requestParameters.updateClientNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new client note for a client within a service line.
         * @param {ClientNotesApiApiClientNotesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientNotesPost(requestParameters: ClientNotesApiApiClientNotesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse> {
            return localVarFp.apiClientNotesPost(requestParameters.createClientNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientNotesApi - interface
 */
export interface ClientNotesApiInterface {
    /**
     * 
     * @summary Retrieves all notes for a client within a service line, newest first.
     * @param {ClientNotesApiApiClientNotesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientNotesGet(requestParameters?: ClientNotesApiApiClientNotesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoListApiResponse>;

    /**
     * 
     * @summary Soft deletes a client note. Only the note\'s creator may delete it.
     * @param {ClientNotesApiApiClientNotesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientNotesIdDelete(requestParameters: ClientNotesApiApiClientNotesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Retrieves a specific client note by its unique identifier.
     * @param {ClientNotesApiApiClientNotesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientNotesIdGet(requestParameters: ClientNotesApiApiClientNotesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse>;

    /**
     * 
     * @summary Updates the content of an existing client note. Only the note\'s creator may update it.
     * @param {ClientNotesApiApiClientNotesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientNotesIdPut(requestParameters: ClientNotesApiApiClientNotesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse>;

    /**
     * 
     * @summary Creates a new client note for a client within a service line.
     * @param {ClientNotesApiApiClientNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientNotesPost(requestParameters?: ClientNotesApiApiClientNotesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNoteDtoApiResponse>;

}

/**
 * Request parameters for apiClientNotesGet operation in ClientNotesApi.
 */
export interface ClientNotesApiApiClientNotesGetRequest {
    /**
     * The client to fetch notes for.
     */
    readonly clientId?: string

    /**
     * The service line the notes are scoped to.
     */
    readonly serviceLine?: ServiceLine
}

/**
 * Request parameters for apiClientNotesIdDelete operation in ClientNotesApi.
 */
export interface ClientNotesApiApiClientNotesIdDeleteRequest {
    /**
     * The unique identifier of the note to delete.
     */
    readonly id: string
}

/**
 * Request parameters for apiClientNotesIdGet operation in ClientNotesApi.
 */
export interface ClientNotesApiApiClientNotesIdGetRequest {
    /**
     * The unique identifier of the note to retrieve.
     */
    readonly id: string
}

/**
 * Request parameters for apiClientNotesIdPut operation in ClientNotesApi.
 */
export interface ClientNotesApiApiClientNotesIdPutRequest {
    /**
     * The unique identifier of the note to update.
     */
    readonly id: string

    /**
     * The note update data.
     */
    readonly updateClientNoteDto?: UpdateClientNoteDto
}

/**
 * Request parameters for apiClientNotesPost operation in ClientNotesApi.
 */
export interface ClientNotesApiApiClientNotesPostRequest {
    /**
     * Note creation data including client ID, service line, and content.
     */
    readonly createClientNoteDto?: CreateClientNoteDto
}

/**
 * ClientNotesApi - object-oriented interface
 */
export class ClientNotesApi extends BaseAPI implements ClientNotesApiInterface {
    /**
     * 
     * @summary Retrieves all notes for a client within a service line, newest first.
     * @param {ClientNotesApiApiClientNotesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientNotesGet(requestParameters: ClientNotesApiApiClientNotesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientNotesApiFp(this.configuration).apiClientNotesGet(requestParameters.clientId, requestParameters.serviceLine, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft deletes a client note. Only the note\'s creator may delete it.
     * @param {ClientNotesApiApiClientNotesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientNotesIdDelete(requestParameters: ClientNotesApiApiClientNotesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientNotesApiFp(this.configuration).apiClientNotesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a specific client note by its unique identifier.
     * @param {ClientNotesApiApiClientNotesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientNotesIdGet(requestParameters: ClientNotesApiApiClientNotesIdGetRequest, options?: RawAxiosRequestConfig) {
        return ClientNotesApiFp(this.configuration).apiClientNotesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the content of an existing client note. Only the note\'s creator may update it.
     * @param {ClientNotesApiApiClientNotesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientNotesIdPut(requestParameters: ClientNotesApiApiClientNotesIdPutRequest, options?: RawAxiosRequestConfig) {
        return ClientNotesApiFp(this.configuration).apiClientNotesIdPut(requestParameters.id, requestParameters.updateClientNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new client note for a client within a service line.
     * @param {ClientNotesApiApiClientNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientNotesPost(requestParameters: ClientNotesApiApiClientNotesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientNotesApiFp(this.configuration).apiClientNotesPost(requestParameters.createClientNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientNotificationPreferencesApi - axios parameter creator
 */
export const ClientNotificationPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets notification preferences for a specific client. Creates default preferences if none exist.
         * @param {string} clientId The client ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdNotificationPreferencesGet: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdNotificationPreferencesGet', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/notification-preferences`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates notification preferences for a specific client.
         * @param {string} clientId The client ID
         * @param {UpdateClientNotificationPreferenceDto} [updateClientNotificationPreferenceDto] The updated preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdNotificationPreferencesPut: async (clientId: string, updateClientNotificationPreferenceDto?: UpdateClientNotificationPreferenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdNotificationPreferencesPut', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/notification-preferences`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientNotificationPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientNotificationPreferencesApi - functional programming interface
 */
export const ClientNotificationPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientNotificationPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets notification preferences for a specific client. Creates default preferences if none exist.
         * @param {string} clientId The client ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdNotificationPreferencesGet(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdNotificationPreferencesGet(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotificationPreferencesApi.apiClientsClientIdNotificationPreferencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates notification preferences for a specific client.
         * @param {string} clientId The client ID
         * @param {UpdateClientNotificationPreferenceDto} [updateClientNotificationPreferenceDto] The updated preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdNotificationPreferencesPut(clientId: string, updateClientNotificationPreferenceDto?: UpdateClientNotificationPreferenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdNotificationPreferencesPut(clientId, updateClientNotificationPreferenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientNotificationPreferencesApi.apiClientsClientIdNotificationPreferencesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientNotificationPreferencesApi - factory interface
 */
export const ClientNotificationPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientNotificationPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets notification preferences for a specific client. Creates default preferences if none exist.
         * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdNotificationPreferencesGet(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiClientsClientIdNotificationPreferencesGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates notification preferences for a specific client.
         * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdNotificationPreferencesPut(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiClientsClientIdNotificationPreferencesPut(requestParameters.clientId, requestParameters.updateClientNotificationPreferenceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientNotificationPreferencesApi - interface
 */
export interface ClientNotificationPreferencesApiInterface {
    /**
     * 
     * @summary Gets notification preferences for a specific client. Creates default preferences if none exist.
     * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdNotificationPreferencesGet(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @summary Updates notification preferences for a specific client.
     * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdNotificationPreferencesPut(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientNotificationPreferenceDtoApiResponse>;

}

/**
 * Request parameters for apiClientsClientIdNotificationPreferencesGet operation in ClientNotificationPreferencesApi.
 */
export interface ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest {
    /**
     * The client ID
     */
    readonly clientId: string
}

/**
 * Request parameters for apiClientsClientIdNotificationPreferencesPut operation in ClientNotificationPreferencesApi.
 */
export interface ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest {
    /**
     * The client ID
     */
    readonly clientId: string

    /**
     * The updated preferences
     */
    readonly updateClientNotificationPreferenceDto?: UpdateClientNotificationPreferenceDto
}

/**
 * ClientNotificationPreferencesApi - object-oriented interface
 */
export class ClientNotificationPreferencesApi extends BaseAPI implements ClientNotificationPreferencesApiInterface {
    /**
     * 
     * @summary Gets notification preferences for a specific client. Creates default preferences if none exist.
     * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdNotificationPreferencesGet(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesGetRequest, options?: RawAxiosRequestConfig) {
        return ClientNotificationPreferencesApiFp(this.configuration).apiClientsClientIdNotificationPreferencesGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates notification preferences for a specific client.
     * @param {ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdNotificationPreferencesPut(requestParameters: ClientNotificationPreferencesApiApiClientsClientIdNotificationPreferencesPutRequest, options?: RawAxiosRequestConfig) {
        return ClientNotificationPreferencesApiFp(this.configuration).apiClientsClientIdNotificationPreferencesPut(requestParameters.clientId, requestParameters.updateClientNotificationPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientWatcherApi - axios parameter creator
 */
export const ClientWatcherApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Calling it multiple times with the same parameters will not cause errors. If you are not currently watching the client, the operation succeeds without changes.              **Sample Request**:                  DELETE /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Remove the current user as a watcher for a specific client (idempotent operation)
         * @param {string} clientId The ID of the client to stop watching
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersDelete: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdWatchersDelete', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/watchers`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": [     {       \"userId\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",       \"userName\": \"John Smith\",       \"userEmail\": \"john.smith@example.com\",       \"watchedAt\": \"2025-10-15T13:00:00Z\",       \"isAutoAdded\": true     }   ],   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Get all watchers for a specific client
         * @param {string} clientId The ID of the client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersGet: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdWatchersGet', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/watchers`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/{clientId}/watchers/me              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Check if the current user is watching a specific client
         * @param {string} clientId The ID of the client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersMeGet: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdWatchersMeGet', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/watchers/me`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Calling it multiple times with the same parameters will not create duplicate watch relationships. If you are already watching the client, the operation succeeds without changes.              **Sample Request**:                  POST /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin (INSUFFICIENT_ROLE) - 404 Not Found: User or client does not exist (USER_NOT_FOUND, CLIENT_NOT_FOUND) - 500 Internal Server Error: Unexpected error occurred (INTERNAL_ERROR)
         * @summary Add the current user as a watcher for a specific client (idempotent operation)
         * @param {string} clientId The ID of the client to watch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersPost: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdWatchersPost', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/watchers`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/watched              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": [     \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",     \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"   ],   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Get all clients being watched by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchedGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/watched`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Non-watched clients will be skipped.              **Sample Request**:                  DELETE /api/clients/watchers/bulk     [\"3fa85f64-5717-4562-b3fc-2c963f66afa6\", \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"]              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": 2,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Remove the current user as a watcher for multiple clients in bulk
         * @param {Array<string>} [requestBody] List of client IDs to stop watching
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchersBulkDelete: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/watchers/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Already-watched clients will be skipped.              **Sample Request**:                  POST /api/clients/watchers/bulk     [\"3fa85f64-5717-4562-b3fc-2c963f66afa6\", \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"]              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": 2,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Add the current user as a watcher for multiple clients in bulk
         * @param {Array<string>} [requestBody] List of client IDs to watch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchersBulkPost: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/watchers/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientWatcherApi - functional programming interface
 */
export const ClientWatcherApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientWatcherApiAxiosParamCreator(configuration)
    return {
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Calling it multiple times with the same parameters will not cause errors. If you are not currently watching the client, the operation succeeds without changes.              **Sample Request**:                  DELETE /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Remove the current user as a watcher for a specific client (idempotent operation)
         * @param {string} clientId The ID of the client to stop watching
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdWatchersDelete(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdWatchersDelete(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsClientIdWatchersDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": [     {       \"userId\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",       \"userName\": \"John Smith\",       \"userEmail\": \"john.smith@example.com\",       \"watchedAt\": \"2025-10-15T13:00:00Z\",       \"isAutoAdded\": true     }   ],   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Get all watchers for a specific client
         * @param {string} clientId The ID of the client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdWatchersGet(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientWatcherInfoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdWatchersGet(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsClientIdWatchersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/{clientId}/watchers/me              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Check if the current user is watching a specific client
         * @param {string} clientId The ID of the client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdWatchersMeGet(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdWatchersMeGet(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsClientIdWatchersMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Calling it multiple times with the same parameters will not create duplicate watch relationships. If you are already watching the client, the operation succeeds without changes.              **Sample Request**:                  POST /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin (INSUFFICIENT_ROLE) - 404 Not Found: User or client does not exist (USER_NOT_FOUND, CLIENT_NOT_FOUND) - 500 Internal Server Error: Unexpected error occurred (INTERNAL_ERROR)
         * @summary Add the current user as a watcher for a specific client (idempotent operation)
         * @param {string} clientId The ID of the client to watch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdWatchersPost(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdWatchersPost(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsClientIdWatchersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/watched              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": [     \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",     \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"   ],   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Get all clients being watched by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsWatchedGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsWatchedGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsWatchedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Non-watched clients will be skipped.              **Sample Request**:                  DELETE /api/clients/watchers/bulk     [\"3fa85f64-5717-4562-b3fc-2c963f66afa6\", \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"]              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": 2,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Remove the current user as a watcher for multiple clients in bulk
         * @param {Array<string>} [requestBody] List of client IDs to stop watching
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsWatchersBulkDelete(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsWatchersBulkDelete(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsWatchersBulkDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Already-watched clients will be skipped.              **Sample Request**:                  POST /api/clients/watchers/bulk     [\"3fa85f64-5717-4562-b3fc-2c963f66afa6\", \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"]              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": 2,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Add the current user as a watcher for multiple clients in bulk
         * @param {Array<string>} [requestBody] List of client IDs to watch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsWatchersBulkPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsWatchersBulkPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientWatcherApi.apiClientsWatchersBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientWatcherApi - factory interface
 */
export const ClientWatcherApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientWatcherApiFp(configuration)
    return {
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Calling it multiple times with the same parameters will not cause errors. If you are not currently watching the client, the operation succeeds without changes.              **Sample Request**:                  DELETE /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Remove the current user as a watcher for a specific client (idempotent operation)
         * @param {ClientWatcherApiApiClientsClientIdWatchersDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersDelete(requestParameters: ClientWatcherApiApiClientsClientIdWatchersDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsClientIdWatchersDelete(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": [     {       \"userId\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",       \"userName\": \"John Smith\",       \"userEmail\": \"john.smith@example.com\",       \"watchedAt\": \"2025-10-15T13:00:00Z\",       \"isAutoAdded\": true     }   ],   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Get all watchers for a specific client
         * @param {ClientWatcherApiApiClientsClientIdWatchersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientWatcherInfoListApiResponse> {
            return localVarFp.apiClientsClientIdWatchersGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/{clientId}/watchers/me              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Check if the current user is watching a specific client
         * @param {ClientWatcherApiApiClientsClientIdWatchersMeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersMeGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersMeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsClientIdWatchersMeGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Calling it multiple times with the same parameters will not create duplicate watch relationships. If you are already watching the client, the operation succeeds without changes.              **Sample Request**:                  POST /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin (INSUFFICIENT_ROLE) - 404 Not Found: User or client does not exist (USER_NOT_FOUND, CLIENT_NOT_FOUND) - 500 Internal Server Error: Unexpected error occurred (INTERNAL_ERROR)
         * @summary Add the current user as a watcher for a specific client (idempotent operation)
         * @param {ClientWatcherApiApiClientsClientIdWatchersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdWatchersPost(requestParameters: ClientWatcherApiApiClientsClientIdWatchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsClientIdWatchersPost(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/watched              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": [     \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",     \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"   ],   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Get all clients being watched by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchedGet(options?: RawAxiosRequestConfig): AxiosPromise<GuidListApiResponse> {
            return localVarFp.apiClientsWatchedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Non-watched clients will be skipped.              **Sample Request**:                  DELETE /api/clients/watchers/bulk     [\"3fa85f64-5717-4562-b3fc-2c963f66afa6\", \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"]              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": 2,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Remove the current user as a watcher for multiple clients in bulk
         * @param {ClientWatcherApiApiClientsWatchersBulkDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchersBulkDelete(requestParameters: ClientWatcherApiApiClientsWatchersBulkDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse> {
            return localVarFp.apiClientsWatchersBulkDelete(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Already-watched clients will be skipped.              **Sample Request**:                  POST /api/clients/watchers/bulk     [\"3fa85f64-5717-4562-b3fc-2c963f66afa6\", \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"]              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": 2,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
         * @summary Add the current user as a watcher for multiple clients in bulk
         * @param {ClientWatcherApiApiClientsWatchersBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsWatchersBulkPost(requestParameters: ClientWatcherApiApiClientsWatchersBulkPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse> {
            return localVarFp.apiClientsWatchersBulkPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientWatcherApi - interface
 */
export interface ClientWatcherApiInterface {
    /**
     * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Calling it multiple times with the same parameters will not cause errors. If you are not currently watching the client, the operation succeeds without changes.              **Sample Request**:                  DELETE /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Remove the current user as a watcher for a specific client (idempotent operation)
     * @param {ClientWatcherApiApiClientsClientIdWatchersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdWatchersDelete(requestParameters: ClientWatcherApiApiClientsClientIdWatchersDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": [     {       \"userId\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",       \"userName\": \"John Smith\",       \"userEmail\": \"john.smith@example.com\",       \"watchedAt\": \"2025-10-15T13:00:00Z\",       \"isAutoAdded\": true     }   ],   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Get all watchers for a specific client
     * @param {ClientWatcherApiApiClientsClientIdWatchersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdWatchersGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientWatcherInfoListApiResponse>;

    /**
     * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/{clientId}/watchers/me              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Check if the current user is watching a specific client
     * @param {ClientWatcherApiApiClientsClientIdWatchersMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdWatchersMeGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersMeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Calling it multiple times with the same parameters will not create duplicate watch relationships. If you are already watching the client, the operation succeeds without changes.              **Sample Request**:                  POST /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin (INSUFFICIENT_ROLE) - 404 Not Found: User or client does not exist (USER_NOT_FOUND, CLIENT_NOT_FOUND) - 500 Internal Server Error: Unexpected error occurred (INTERNAL_ERROR)
     * @summary Add the current user as a watcher for a specific client (idempotent operation)
     * @param {ClientWatcherApiApiClientsClientIdWatchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdWatchersPost(requestParameters: ClientWatcherApiApiClientsClientIdWatchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/watched              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": [     \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",     \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"   ],   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Get all clients being watched by the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsWatchedGet(options?: RawAxiosRequestConfig): AxiosPromise<GuidListApiResponse>;

    /**
     * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Non-watched clients will be skipped.              **Sample Request**:                  DELETE /api/clients/watchers/bulk     [\"3fa85f64-5717-4562-b3fc-2c963f66afa6\", \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"]              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": 2,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Remove the current user as a watcher for multiple clients in bulk
     * @param {ClientWatcherApiApiClientsWatchersBulkDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsWatchersBulkDelete(requestParameters?: ClientWatcherApiApiClientsWatchersBulkDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse>;

    /**
     * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Already-watched clients will be skipped.              **Sample Request**:                  POST /api/clients/watchers/bulk     [\"3fa85f64-5717-4562-b3fc-2c963f66afa6\", \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"]              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": 2,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Add the current user as a watcher for multiple clients in bulk
     * @param {ClientWatcherApiApiClientsWatchersBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsWatchersBulkPost(requestParameters?: ClientWatcherApiApiClientsWatchersBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse>;

}

/**
 * Request parameters for apiClientsClientIdWatchersDelete operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsClientIdWatchersDeleteRequest {
    /**
     * The ID of the client to stop watching
     */
    readonly clientId: string
}

/**
 * Request parameters for apiClientsClientIdWatchersGet operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsClientIdWatchersGetRequest {
    /**
     * The ID of the client
     */
    readonly clientId: string
}

/**
 * Request parameters for apiClientsClientIdWatchersMeGet operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsClientIdWatchersMeGetRequest {
    /**
     * The ID of the client
     */
    readonly clientId: string
}

/**
 * Request parameters for apiClientsClientIdWatchersPost operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsClientIdWatchersPostRequest {
    /**
     * The ID of the client to watch
     */
    readonly clientId: string
}

/**
 * Request parameters for apiClientsWatchersBulkDelete operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsWatchersBulkDeleteRequest {
    /**
     * List of client IDs to stop watching
     */
    readonly requestBody?: Array<string>
}

/**
 * Request parameters for apiClientsWatchersBulkPost operation in ClientWatcherApi.
 */
export interface ClientWatcherApiApiClientsWatchersBulkPostRequest {
    /**
     * List of client IDs to watch
     */
    readonly requestBody?: Array<string>
}

/**
 * ClientWatcherApi - object-oriented interface
 */
export class ClientWatcherApi extends BaseAPI implements ClientWatcherApiInterface {
    /**
     * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Calling it multiple times with the same parameters will not cause errors. If you are not currently watching the client, the operation succeeds without changes.              **Sample Request**:                  DELETE /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Remove the current user as a watcher for a specific client (idempotent operation)
     * @param {ClientWatcherApiApiClientsClientIdWatchersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdWatchersDelete(requestParameters: ClientWatcherApiApiClientsClientIdWatchersDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsClientIdWatchersDelete(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": [     {       \"userId\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",       \"userName\": \"John Smith\",       \"userEmail\": \"john.smith@example.com\",       \"watchedAt\": \"2025-10-15T13:00:00Z\",       \"isAutoAdded\": true     }   ],   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Get all watchers for a specific client
     * @param {ClientWatcherApiApiClientsClientIdWatchersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdWatchersGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersGetRequest, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsClientIdWatchersGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/{clientId}/watchers/me              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Check if the current user is watching a specific client
     * @param {ClientWatcherApiApiClientsClientIdWatchersMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdWatchersMeGet(requestParameters: ClientWatcherApiApiClientsClientIdWatchersMeGetRequest, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsClientIdWatchersMeGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Calling it multiple times with the same parameters will not create duplicate watch relationships. If you are already watching the client, the operation succeeds without changes.              **Sample Request**:                  POST /api/clients/{clientId}/watchers              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": true,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin (INSUFFICIENT_ROLE) - 404 Not Found: User or client does not exist (USER_NOT_FOUND, CLIENT_NOT_FOUND) - 500 Internal Server Error: Unexpected error occurred (INTERNAL_ERROR)
     * @summary Add the current user as a watcher for a specific client (idempotent operation)
     * @param {ClientWatcherApiApiClientsClientIdWatchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdWatchersPost(requestParameters: ClientWatcherApiApiClientsClientIdWatchersPostRequest, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsClientIdWatchersPost(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * **Authorization**: Preparer or Admin only.              **Sample Request**:                  GET /api/clients/watched              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": [     \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",     \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"   ],   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Get all clients being watched by the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsWatchedGet(options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsWatchedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Non-watched clients will be skipped.              **Sample Request**:                  DELETE /api/clients/watchers/bulk     [\"3fa85f64-5717-4562-b3fc-2c963f66afa6\", \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"]              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": 2,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Remove the current user as a watcher for multiple clients in bulk
     * @param {ClientWatcherApiApiClientsWatchersBulkDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsWatchersBulkDelete(requestParameters: ClientWatcherApiApiClientsWatchersBulkDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsWatchersBulkDelete(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * **Authorization**: Preparer or Admin only.              **Idempotency**: This endpoint is idempotent. Already-watched clients will be skipped.              **Sample Request**:                  POST /api/clients/watchers/bulk     [\"3fa85f64-5717-4562-b3fc-2c963f66afa6\", \"4fa85f64-5717-4562-b3fc-2c963f66afa7\"]              **Success Response** (200 OK): ```json {   \"success\": true,   \"data\": 2,   \"error\": null } ```              **Error Responses**: - 401 Unauthorized: User not authenticated - 403 Forbidden: User is not a preparer or admin
     * @summary Add the current user as a watcher for multiple clients in bulk
     * @param {ClientWatcherApiApiClientsWatchersBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsWatchersBulkPost(requestParameters: ClientWatcherApiApiClientsWatchersBulkPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientWatcherApiFp(this.configuration).apiClientsWatchersBulkPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientsApi - axios parameter creator
 */
export const ClientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes a bank account
         * @param {string} accountId The unique identifier of the bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsBankAccountsAccountIdDelete: async (accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('apiClientsBankAccountsAccountIdDelete', 'accountId', accountId)
            const localVarPath = `/api/Clients/bank-accounts/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing bank account
         * @param {string} accountId The unique identifier of the bank account
         * @param {ClientBankAccountDto} [clientBankAccountDto] Bank account data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsBankAccountsAccountIdPut: async (accountId: string, clientBankAccountDto?: ClientBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('apiClientsBankAccountsAccountIdPut', 'accountId', accountId)
            const localVarPath = `/api/Clients/bank-accounts/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a client by their client number (unique business identifier).
         * @param {string} clientNumber The unique client number assigned to the client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsByNumberClientNumberGet: async (clientNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientNumber' is not null or undefined
            assertParamExists('apiClientsByNumberClientNumberGet', 'clientNumber', clientNumber)
            const localVarPath = `/api/Clients/by-number/{clientNumber}`
                .replace(`{${"clientNumber"}}`, encodeURIComponent(String(clientNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new bank account for a client
         * @param {string} clientId The unique identifier of the client
         * @param {ClientBankAccountDto} [clientBankAccountDto] Bank account data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdBankAccountsPost: async (clientId: string, clientBankAccountDto?: ClientBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdBankAccountsPost', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/bank-accounts`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new dependent for a client
         * @param {string} clientId The unique identifier of the client
         * @param {ClientDependentDto} [clientDependentDto] Dependent data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdDependentsPost: async (clientId: string, clientDependentDto?: ClientDependentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdDependentsPost', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/dependents`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientDependentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves pre-fill data for tax questionnaires from client profile
         * @param {string} clientId The client ID
         * @param {string} [binderId] Optional binder ID for context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdQuestionnairePreFillDataGet: async (clientId: string, binderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdQuestionnairePreFillDataGet', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/questionnaire-pre-fill-data`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (binderId !== undefined) {
                localVarQueryParameter['binderId'] = binderId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes spouse information for a client
         * @param {string} clientId The unique identifier of the client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdSpouseDelete: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdSpouseDelete', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/spouse`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates or updates spouse information for a client
         * @param {string} clientId The unique identifier of the client
         * @param {ClientSpouseDto} [clientSpouseDto] Spouse data to create or update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdSpousePut: async (clientId: string, clientSpouseDto?: ClientSpouseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdSpousePut', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/spouse`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientSpouseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a dependent
         * @param {string} dependentId The unique identifier of the dependent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDependentsDependentIdDelete: async (dependentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dependentId' is not null or undefined
            assertParamExists('apiClientsDependentsDependentIdDelete', 'dependentId', dependentId)
            const localVarPath = `/api/Clients/dependents/{dependentId}`
                .replace(`{${"dependentId"}}`, encodeURIComponent(String(dependentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing dependent
         * @param {string} dependentId The unique identifier of the dependent
         * @param {ClientDependentDto} [clientDependentDto] Dependent data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDependentsDependentIdPut: async (dependentId: string, clientDependentDto?: ClientDependentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dependentId' is not null or undefined
            assertParamExists('apiClientsDependentsDependentIdPut', 'dependentId', dependentId)
            const localVarPath = `/api/Clients/dependents/{dependentId}`
                .replace(`{${"dependentId"}}`, encodeURIComponent(String(dependentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientDependentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a paginated list of clients with optional filtering and sorting.
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {ClientType} [type] 
         * @param {string} [state] 
         * @param {Array<string>} [tags] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {boolean} [watchedByMe] Filter to only show clients watched by the current user Only applies to Preparer/Admin users
         * @param {ConfidentialFilter} [confidentialFilter] Filter clients based on confidential status and user access Only applies to Preparer/Admin users
         * @param {string} [partnerId] Filter by assigned partner (User ID). Only applies to Preparer/Admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsGet: async (page?: number, limit?: number, sortBy?: string, sortOrder?: string, search?: string, type?: ClientType, state?: string, tags?: Array<string>, createdAfter?: string, createdBefore?: string, watchedByMe?: boolean, confidentialFilter?: ConfidentialFilter, partnerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (state !== undefined) {
                localVarQueryParameter['State'] = state;
            }

            if (tags) {
                localVarQueryParameter['Tags'] = tags;
            }

            if (createdAfter !== undefined) {
                localVarQueryParameter['CreatedAfter'] = (createdAfter as any instanceof Date) ?
                    (createdAfter as any).toISOString() :
                    createdAfter;
            }

            if (createdBefore !== undefined) {
                localVarQueryParameter['CreatedBefore'] = (createdBefore as any instanceof Date) ?
                    (createdBefore as any).toISOString() :
                    createdBefore;
            }

            if (watchedByMe !== undefined) {
                localVarQueryParameter['WatchedByMe'] = watchedByMe;
            }

            if (confidentialFilter !== undefined) {
                localVarQueryParameter['ConfidentialFilter'] = confidentialFilter;
            }

            if (partnerId !== undefined) {
                localVarQueryParameter['PartnerId'] = partnerId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archives a client, marking them as inactive without permanent deletion. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the client to archive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdArchivePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdArchivePost', 'id', id)
            const localVarPath = `/api/Clients/{id}/archive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a detailed audit trail for the specified client including: - Client profile changes - Document uploads and modifications - Binder creation and updates - Document request activity - DocuSeal submission events              Each audit entry includes: - Timestamp of the change - User who made the change - Human-readable description of what changed - Detailed field-level changes with before/after values              Access is restricted to: - Admins and Preparers: Can view audit history for any client - Clients: Can only view audit history for their own client profile              Date Range Filtering: - If no dates provided: Returns last 90 days of audit history - If only startDate provided: Returns from startDate to now - If only endDate provided: Returns 90 days before endDate to endDate - If both provided: Returns audit entries within the specified range
         * @summary Retrieves comprehensive audit history for a client including all related entities
         * @param {string} id The unique identifier of the client
         * @param {string} [startDate] Optional start date for filtering audit entries (inclusive, UTC)
         * @param {string} [endDate] Optional end date for filtering audit entries (inclusive, UTC)
         * @param {string} [search] 
         * @param {string} [action] 
         * @param {string} [entityType] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdAuditHistoryGet: async (id: string, startDate?: string, endDate?: string, search?: string, action?: string, entityType?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdAuditHistoryGet', 'id', id)
            const localVarPath = `/api/Clients/{id}/audit-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves documents from CCH Document Portal for a specific client. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the client to retrieve CCH documents for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdCchDocumentsGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdCchDocumentsGet', 'id', id)
            const localVarPath = `/api/Clients/{id}/cch-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a primary user for a client when the spouse logs in and no primary exists. Only accessible by users with Spouse role on the client. Does NOT send an invitation email - the user can be invited later manually.
         * @param {string} id The client ID
         * @param {CreatePrimaryUserDto} [createPrimaryUserDto] Primary user creation data (name, email, phone)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdCreatePrimaryUserPost: async (id: string, createPrimaryUserDto?: CreatePrimaryUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdCreatePrimaryUserPost', 'id', id)
            const localVarPath = `/api/Clients/{id}/create-primary-user`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPrimaryUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently deletes a client from the system. Requires Admin role.
         * @param {string} id The unique identifier of the client to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdDelete', 'id', id)
            const localVarPath = `/api/Clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get eligible signers for a client. Returns all users associated with the client who can be assigned as signers.
         * @param {string} id The unique identifier of the client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdEligibleSignersGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdEligibleSignersGet', 'id', id)
            const localVarPath = `/api/Clients/{id}/eligible-signers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific client by their unique identifier.
         * @param {string} id The unique identifier of the client to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdGet', 'id', id)
            const localVarPath = `/api/Clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing client\'s information. Requires Preparer or Admin role, or the primary client user.
         * @param {string} id The unique identifier of the client to update.
         * @param {UpdateClientDto} [updateClientDto] The client data to update with new information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdPut: async (id: string, updateClientDto?: UpdateClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdPut', 'id', id)
            const localVarPath = `/api/Clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restores an archived client, making them active again. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the archived client to restore.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdRestorePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdRestorePost', 'id', id)
            const localVarPath = `/api/Clients/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find clients similar to a given client using semantic similarity. Uses AI embeddings to find clients with similar characteristics.
         * @param {string} id The client ID to find similar clients for.
         * @param {number} [limit] Maximum number of similar clients to return (default: 10).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdSimilarGet: async (id: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdSimilarGet', 'id', id)
            const localVarPath = `/api/Clients/{id}/similar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint provides complete visibility into client access, including: - **Direct Access**: Users explicitly assigned to the client via ClientUserDetail records - **Indirect Access**: Users who share email or phone number with direct access users (multi-contact pattern)              The multi-contact pattern allows users sharing contact information to access the same clients. This is intentional for CCH import scenarios where the same person may appear across multiple clients.
         * @summary Retrieves a comprehensive summary of all users who have access to a specific client. Includes both direct access (via ClientUserDetail) and indirect access (via multi-contact pattern).
         * @param {string} id The unique identifier of the client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdUserAccessGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdUserAccessGet', 'id', id)
            const localVarPath = `/api/Clients/{id}/user-access`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Previews client data from CCH Axcess system without importing. Requires Admin role.
         * @param {string} clientId The CCH client ID to preview.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchClientIdPreviewGet: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsImportCchClientIdPreviewGet', 'clientId', clientId)
            const localVarPath = `/api/Clients/import/cch/{clientId}/preview`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Imports multiple clients from CCH Axcess system in a batch operation. Requires Admin role.
         * @param {ImportMultipleClientsDto} [importMultipleClientsDto] Import configuration containing multiple client IDs and batch options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchMultiplePost: async (importMultipleClientsDto?: ImportMultipleClientsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/import/cch/multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importMultipleClientsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Imports a single client from CCH Axcess system. Requires Admin role.
         * @param {ImportClientDto} [importClientDto] Import configuration containing client ID and options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchPost: async (importClientDto?: ImportClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/import/cch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Synchronizes all clients from CCH Axcess system based on last sync timestamp. Requires Admin role.
         * @param {SyncAllClientsDto} [syncAllClientsDto] Sync configuration including last sync date, batch size, and update options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchSyncPost: async (syncAllClientsDto?: SyncAllClientsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/import/cch/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncAllClientsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validates the connection to CCH Axcess API system. Requires Admin role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchValidateConnectionGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/import/cch/validate-connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the list of clients that the current user has access to for client switching. This endpoint is exempt from X-Active-Client-Id header requirement since it provides the list of available clients before a client selection can be made.              Role-based behavior: - Client role: Returns only clients the user has access to via ClientUserDetail (multi-contact pattern) - Preparer/Admin roles: Returns ALL clients in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsMyClientsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/my-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk update search fields for all clients missing NormalizedName or SearchableText. Useful for migrating existing data. Requires Admin role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchBulkUpdateFieldsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/search/bulk-update-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for clients using a text query with pagination support.
         * @param {string} [q] Search query to match against client name, email, or client number.
         * @param {number} [page] The page number to retrieve (minimum: 1, default: 1).
         * @param {number} [pageSize] The number of results per page (minimum: 1, maximum: 200, default: 20).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchGet: async (q?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Advanced hybrid search across clients using exact, fuzzy, and semantic search. Combines exact client number matching, trigram fuzzy search on names, and AI-powered semantic search.
         * @param {ClientSearchQueryDto} [clientSearchQueryDto] Search query with term, filters, and pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchHybridPost: async (clientSearchQueryDto?: ClientSearchQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/search/hybrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientSearchQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh embeddings for clients that are missing or stale. Used to bulk update AI search capabilities. Requires Admin role.
         * @param {number} [maxCount] Maximum number of clients to process (0 &#x3D; all).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchRefreshEmbeddingsPost: async (maxCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/search/refresh-embeddings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (maxCount !== undefined) {
                localVarQueryParameter['maxCount'] = maxCount;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get search suggestions for autocomplete (hybrid search). Returns quick client name suggestions based on partial query. Requires Preparer or Admin role to prevent client role users from searching all clients.
         * @param {string} [q] Partial search term (minimum 2 characters).
         * @param {number} [limit] Maximum number of suggestions (default: 10).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchSuggestionsGet: async (q?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients/search/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientsApi - functional programming interface
 */
export const ClientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deletes a bank account
         * @param {string} accountId The unique identifier of the bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsBankAccountsAccountIdDelete(accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsBankAccountsAccountIdDelete(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsBankAccountsAccountIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing bank account
         * @param {string} accountId The unique identifier of the bank account
         * @param {ClientBankAccountDto} [clientBankAccountDto] Bank account data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsBankAccountsAccountIdPut(accountId: string, clientBankAccountDto?: ClientBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientBankAccountDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsBankAccountsAccountIdPut(accountId, clientBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsBankAccountsAccountIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a client by their client number (unique business identifier).
         * @param {string} clientNumber The unique client number assigned to the client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsByNumberClientNumberGet(clientNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsByNumberClientNumberGet(clientNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsByNumberClientNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new bank account for a client
         * @param {string} clientId The unique identifier of the client
         * @param {ClientBankAccountDto} [clientBankAccountDto] Bank account data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdBankAccountsPost(clientId: string, clientBankAccountDto?: ClientBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientBankAccountDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdBankAccountsPost(clientId, clientBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsClientIdBankAccountsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new dependent for a client
         * @param {string} clientId The unique identifier of the client
         * @param {ClientDependentDto} [clientDependentDto] Dependent data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdDependentsPost(clientId: string, clientDependentDto?: ClientDependentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDependentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdDependentsPost(clientId, clientDependentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsClientIdDependentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves pre-fill data for tax questionnaires from client profile
         * @param {string} clientId The client ID
         * @param {string} [binderId] Optional binder ID for context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdQuestionnairePreFillDataGet(clientId: string, binderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnairePreFillDataDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdQuestionnairePreFillDataGet(clientId, binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsClientIdQuestionnairePreFillDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes spouse information for a client
         * @param {string} clientId The unique identifier of the client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdSpouseDelete(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdSpouseDelete(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsClientIdSpouseDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates or updates spouse information for a client
         * @param {string} clientId The unique identifier of the client
         * @param {ClientSpouseDto} [clientSpouseDto] Spouse data to create or update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdSpousePut(clientId: string, clientSpouseDto?: ClientSpouseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSpouseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdSpousePut(clientId, clientSpouseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsClientIdSpousePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a dependent
         * @param {string} dependentId The unique identifier of the dependent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsDependentsDependentIdDelete(dependentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsDependentsDependentIdDelete(dependentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsDependentsDependentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing dependent
         * @param {string} dependentId The unique identifier of the dependent
         * @param {ClientDependentDto} [clientDependentDto] Dependent data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsDependentsDependentIdPut(dependentId: string, clientDependentDto?: ClientDependentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDependentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsDependentsDependentIdPut(dependentId, clientDependentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsDependentsDependentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a paginated list of clients with optional filtering and sorting.
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {ClientType} [type] 
         * @param {string} [state] 
         * @param {Array<string>} [tags] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {boolean} [watchedByMe] Filter to only show clients watched by the current user Only applies to Preparer/Admin users
         * @param {ConfidentialFilter} [confidentialFilter] Filter clients based on confidential status and user access Only applies to Preparer/Admin users
         * @param {string} [partnerId] Filter by assigned partner (User ID). Only applies to Preparer/Admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsGet(page?: number, limit?: number, sortBy?: string, sortOrder?: string, search?: string, type?: ClientType, state?: string, tags?: Array<string>, createdAfter?: string, createdBefore?: string, watchedByMe?: boolean, confidentialFilter?: ConfidentialFilter, partnerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsGet(page, limit, sortBy, sortOrder, search, type, state, tags, createdAfter, createdBefore, watchedByMe, confidentialFilter, partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archives a client, marking them as inactive without permanent deletion. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the client to archive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdArchivePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdArchivePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdArchivePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a detailed audit trail for the specified client including: - Client profile changes - Document uploads and modifications - Binder creation and updates - Document request activity - DocuSeal submission events              Each audit entry includes: - Timestamp of the change - User who made the change - Human-readable description of what changed - Detailed field-level changes with before/after values              Access is restricted to: - Admins and Preparers: Can view audit history for any client - Clients: Can only view audit history for their own client profile              Date Range Filtering: - If no dates provided: Returns last 90 days of audit history - If only startDate provided: Returns from startDate to now - If only endDate provided: Returns 90 days before endDate to endDate - If both provided: Returns audit entries within the specified range
         * @summary Retrieves comprehensive audit history for a client including all related entities
         * @param {string} id The unique identifier of the client
         * @param {string} [startDate] Optional start date for filtering audit entries (inclusive, UTC)
         * @param {string} [endDate] Optional end date for filtering audit entries (inclusive, UTC)
         * @param {string} [search] 
         * @param {string} [action] 
         * @param {string} [entityType] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdAuditHistoryGet(id: string, startDate?: string, endDate?: string, search?: string, action?: string, entityType?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAuditHistoryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdAuditHistoryGet(id, startDate, endDate, search, action, entityType, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdAuditHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves documents from CCH Document Portal for a specific client. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the client to retrieve CCH documents for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdCchDocumentsGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdCchDocumentsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdCchDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a primary user for a client when the spouse logs in and no primary exists. Only accessible by users with Spouse role on the client. Does NOT send an invitation email - the user can be invited later manually.
         * @param {string} id The client ID
         * @param {CreatePrimaryUserDto} [createPrimaryUserDto] Primary user creation data (name, email, phone)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdCreatePrimaryUserPost(id: string, createPrimaryUserDto?: CreatePrimaryUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithClientsSearchResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdCreatePrimaryUserPost(id, createPrimaryUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdCreatePrimaryUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently deletes a client from the system. Requires Admin role.
         * @param {string} id The unique identifier of the client to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get eligible signers for a client. Returns all users associated with the client who can be assigned as signers.
         * @param {string} id The unique identifier of the client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdEligibleSignersGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibleSignersDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdEligibleSignersGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdEligibleSignersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific client by their unique identifier.
         * @param {string} id The unique identifier of the client to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDetailsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing client\'s information. Requires Preparer or Admin role, or the primary client user.
         * @param {string} id The unique identifier of the client to update.
         * @param {UpdateClientDto} [updateClientDto] The client data to update with new information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdPut(id: string, updateClientDto?: UpdateClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdPut(id, updateClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Restores an archived client, making them active again. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the archived client to restore.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdRestorePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdRestorePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdRestorePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Find clients similar to a given client using semantic similarity. Uses AI embeddings to find clients with similar characteristics.
         * @param {string} id The client ID to find similar clients for.
         * @param {number} [limit] Maximum number of similar clients to return (default: 10).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdSimilarGet(id: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSearchResultDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdSimilarGet(id, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdSimilarGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint provides complete visibility into client access, including: - **Direct Access**: Users explicitly assigned to the client via ClientUserDetail records - **Indirect Access**: Users who share email or phone number with direct access users (multi-contact pattern)              The multi-contact pattern allows users sharing contact information to access the same clients. This is intentional for CCH import scenarios where the same person may appear across multiple clients.
         * @summary Retrieves a comprehensive summary of all users who have access to a specific client. Includes both direct access (via ClientUserDetail) and indirect access (via multi-contact pattern).
         * @param {string} id The unique identifier of the client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdUserAccessGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientAccessSummaryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdUserAccessGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsIdUserAccessGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Previews client data from CCH Axcess system without importing. Requires Admin role.
         * @param {string} clientId The CCH client ID to preview.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsImportCchClientIdPreviewGet(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsImportCchClientIdPreviewGet(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsImportCchClientIdPreviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Imports multiple clients from CCH Axcess system in a batch operation. Requires Admin role.
         * @param {ImportMultipleClientsDto} [importMultipleClientsDto] Import configuration containing multiple client IDs and batch options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsImportCchMultiplePost(importMultipleClientsDto?: ImportMultipleClientsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsImportCchMultiplePost(importMultipleClientsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsImportCchMultiplePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Imports a single client from CCH Axcess system. Requires Admin role.
         * @param {ImportClientDto} [importClientDto] Import configuration containing client ID and options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsImportCchPost(importClientDto?: ImportClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportClientResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsImportCchPost(importClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsImportCchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Synchronizes all clients from CCH Axcess system based on last sync timestamp. Requires Admin role.
         * @param {SyncAllClientsDto} [syncAllClientsDto] Sync configuration including last sync date, batch size, and update options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsImportCchSyncPost(syncAllClientsDto?: SyncAllClientsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsImportCchSyncPost(syncAllClientsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsImportCchSyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validates the connection to CCH Axcess API system. Requires Admin role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsImportCchValidateConnectionGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsImportCchValidateConnectionGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsImportCchValidateConnectionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves the list of clients that the current user has access to for client switching. This endpoint is exempt from X-Active-Client-Id header requirement since it provides the list of available clients before a client selection can be made.              Role-based behavior: - Client role: Returns only clients the user has access to via ClientUserDetail (multi-contact pattern) - Preparer/Admin roles: Returns ALL clients in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsMyClientsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsMyClientsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsMyClientsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk update search fields for all clients missing NormalizedName or SearchableText. Useful for migrating existing data. Requires Admin role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSearchBulkUpdateFieldsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSearchBulkUpdateFieldsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsSearchBulkUpdateFieldsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for clients using a text query with pagination support.
         * @param {string} [q] Search query to match against client name, email, or client number.
         * @param {number} [page] The page number to retrieve (minimum: 1, default: 1).
         * @param {number} [pageSize] The number of results per page (minimum: 1, maximum: 200, default: 20).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSearchGet(q?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSearchGet(q, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Advanced hybrid search across clients using exact, fuzzy, and semantic search. Combines exact client number matching, trigram fuzzy search on names, and AI-powered semantic search.
         * @param {ClientSearchQueryDto} [clientSearchQueryDto] Search query with term, filters, and pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSearchHybridPost(clientSearchQueryDto?: ClientSearchQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSearchResultDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSearchHybridPost(clientSearchQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsSearchHybridPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh embeddings for clients that are missing or stale. Used to bulk update AI search capabilities. Requires Admin role.
         * @param {number} [maxCount] Maximum number of clients to process (0 &#x3D; all).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSearchRefreshEmbeddingsPost(maxCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSearchRefreshEmbeddingsPost(maxCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsSearchRefreshEmbeddingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get search suggestions for autocomplete (hybrid search). Returns quick client name suggestions based on partial query. Requires Preparer or Admin role to prevent client role users from searching all clients.
         * @param {string} [q] Partial search term (minimum 2 characters).
         * @param {number} [limit] Maximum number of suggestions (default: 10).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSearchSuggestionsGet(q?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSearchSuggestionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSearchSuggestionsGet(q, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.apiClientsSearchSuggestionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientsApi - factory interface
 */
export const ClientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientsApiFp(configuration)
    return {
        /**
         * 
         * @summary Deletes a bank account
         * @param {ClientsApiApiClientsBankAccountsAccountIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsBankAccountsAccountIdDelete(requestParameters: ClientsApiApiClientsBankAccountsAccountIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsBankAccountsAccountIdDelete(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing bank account
         * @param {ClientsApiApiClientsBankAccountsAccountIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsBankAccountsAccountIdPut(requestParameters: ClientsApiApiClientsBankAccountsAccountIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBankAccountDtoApiResponse> {
            return localVarFp.apiClientsBankAccountsAccountIdPut(requestParameters.accountId, requestParameters.clientBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a client by their client number (unique business identifier).
         * @param {ClientsApiApiClientsByNumberClientNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsByNumberClientNumberGet(requestParameters: ClientsApiApiClientsByNumberClientNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse> {
            return localVarFp.apiClientsByNumberClientNumberGet(requestParameters.clientNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new bank account for a client
         * @param {ClientsApiApiClientsClientIdBankAccountsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdBankAccountsPost(requestParameters: ClientsApiApiClientsClientIdBankAccountsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBankAccountDtoApiResponse> {
            return localVarFp.apiClientsClientIdBankAccountsPost(requestParameters.clientId, requestParameters.clientBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new dependent for a client
         * @param {ClientsApiApiClientsClientIdDependentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdDependentsPost(requestParameters: ClientsApiApiClientsClientIdDependentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDependentDtoApiResponse> {
            return localVarFp.apiClientsClientIdDependentsPost(requestParameters.clientId, requestParameters.clientDependentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves pre-fill data for tax questionnaires from client profile
         * @param {ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdQuestionnairePreFillDataGet(requestParameters: ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnairePreFillDataDtoApiResponse> {
            return localVarFp.apiClientsClientIdQuestionnairePreFillDataGet(requestParameters.clientId, requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes spouse information for a client
         * @param {ClientsApiApiClientsClientIdSpouseDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdSpouseDelete(requestParameters: ClientsApiApiClientsClientIdSpouseDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsClientIdSpouseDelete(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates or updates spouse information for a client
         * @param {ClientsApiApiClientsClientIdSpousePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdSpousePut(requestParameters: ClientsApiApiClientsClientIdSpousePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSpouseDtoApiResponse> {
            return localVarFp.apiClientsClientIdSpousePut(requestParameters.clientId, requestParameters.clientSpouseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a dependent
         * @param {ClientsApiApiClientsDependentsDependentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDependentsDependentIdDelete(requestParameters: ClientsApiApiClientsDependentsDependentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsDependentsDependentIdDelete(requestParameters.dependentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing dependent
         * @param {ClientsApiApiClientsDependentsDependentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDependentsDependentIdPut(requestParameters: ClientsApiApiClientsDependentsDependentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDependentDtoApiResponse> {
            return localVarFp.apiClientsDependentsDependentIdPut(requestParameters.dependentId, requestParameters.clientDependentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a paginated list of clients with optional filtering and sorting.
         * @param {ClientsApiApiClientsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsGet(requestParameters: ClientsApiApiClientsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoPaginatedResponseApiResponse> {
            return localVarFp.apiClientsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.type, requestParameters.state, requestParameters.tags, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.watchedByMe, requestParameters.confidentialFilter, requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archives a client, marking them as inactive without permanent deletion. Requires Preparer or Admin role.
         * @param {ClientsApiApiClientsIdArchivePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdArchivePost(requestParameters: ClientsApiApiClientsIdArchivePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsIdArchivePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a detailed audit trail for the specified client including: - Client profile changes - Document uploads and modifications - Binder creation and updates - Document request activity - DocuSeal submission events              Each audit entry includes: - Timestamp of the change - User who made the change - Human-readable description of what changed - Detailed field-level changes with before/after values              Access is restricted to: - Admins and Preparers: Can view audit history for any client - Clients: Can only view audit history for their own client profile              Date Range Filtering: - If no dates provided: Returns last 90 days of audit history - If only startDate provided: Returns from startDate to now - If only endDate provided: Returns 90 days before endDate to endDate - If both provided: Returns audit entries within the specified range
         * @summary Retrieves comprehensive audit history for a client including all related entities
         * @param {ClientsApiApiClientsIdAuditHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdAuditHistoryGet(requestParameters: ClientsApiApiClientsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuditHistoryDtoApiResponse> {
            return localVarFp.apiClientsIdAuditHistoryGet(requestParameters.id, requestParameters.startDate, requestParameters.endDate, requestParameters.search, requestParameters.action, requestParameters.entityType, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves documents from CCH Document Portal for a specific client. Requires Preparer or Admin role.
         * @param {ClientsApiApiClientsIdCchDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdCchDocumentsGet(requestParameters: ClientsApiApiClientsIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiClientsIdCchDocumentsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a primary user for a client when the spouse logs in and no primary exists. Only accessible by users with Spouse role on the client. Does NOT send an invitation email - the user can be invited later manually.
         * @param {ClientsApiApiClientsIdCreatePrimaryUserPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdCreatePrimaryUserPost(requestParameters: ClientsApiApiClientsIdCreatePrimaryUserPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoApiResponse> {
            return localVarFp.apiClientsIdCreatePrimaryUserPost(requestParameters.id, requestParameters.createPrimaryUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently deletes a client from the system. Requires Admin role.
         * @param {ClientsApiApiClientsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdDelete(requestParameters: ClientsApiApiClientsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get eligible signers for a client. Returns all users associated with the client who can be assigned as signers.
         * @param {ClientsApiApiClientsIdEligibleSignersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdEligibleSignersGet(requestParameters: ClientsApiApiClientsIdEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse> {
            return localVarFp.apiClientsIdEligibleSignersGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific client by their unique identifier.
         * @param {ClientsApiApiClientsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdGet(requestParameters: ClientsApiApiClientsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDetailsDtoApiResponse> {
            return localVarFp.apiClientsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing client\'s information. Requires Preparer or Admin role, or the primary client user.
         * @param {ClientsApiApiClientsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdPut(requestParameters: ClientsApiApiClientsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse> {
            return localVarFp.apiClientsIdPut(requestParameters.id, requestParameters.updateClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restores an archived client, making them active again. Requires Preparer or Admin role.
         * @param {ClientsApiApiClientsIdRestorePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdRestorePost(requestParameters: ClientsApiApiClientsIdRestorePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsIdRestorePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find clients similar to a given client using semantic similarity. Uses AI embeddings to find clients with similar characteristics.
         * @param {ClientsApiApiClientsIdSimilarGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdSimilarGet(requestParameters: ClientsApiApiClientsIdSimilarGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchResultDtoListApiResponse> {
            return localVarFp.apiClientsIdSimilarGet(requestParameters.id, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint provides complete visibility into client access, including: - **Direct Access**: Users explicitly assigned to the client via ClientUserDetail records - **Indirect Access**: Users who share email or phone number with direct access users (multi-contact pattern)              The multi-contact pattern allows users sharing contact information to access the same clients. This is intentional for CCH import scenarios where the same person may appear across multiple clients.
         * @summary Retrieves a comprehensive summary of all users who have access to a specific client. Includes both direct access (via ClientUserDetail) and indirect access (via multi-contact pattern).
         * @param {ClientsApiApiClientsIdUserAccessGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdUserAccessGet(requestParameters: ClientsApiApiClientsIdUserAccessGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAccessSummaryDtoApiResponse> {
            return localVarFp.apiClientsIdUserAccessGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Previews client data from CCH Axcess system without importing. Requires Admin role.
         * @param {ClientsApiApiClientsImportCchClientIdPreviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchClientIdPreviewGet(requestParameters: ClientsApiApiClientsImportCchClientIdPreviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse> {
            return localVarFp.apiClientsImportCchClientIdPreviewGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Imports multiple clients from CCH Axcess system in a batch operation. Requires Admin role.
         * @param {ClientsApiApiClientsImportCchMultiplePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchMultiplePost(requestParameters: ClientsApiApiClientsImportCchMultiplePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ImportResultDtoApiResponse> {
            return localVarFp.apiClientsImportCchMultiplePost(requestParameters.importMultipleClientsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Imports a single client from CCH Axcess system. Requires Admin role.
         * @param {ClientsApiApiClientsImportCchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchPost(requestParameters: ClientsApiApiClientsImportCchPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ImportClientResultDtoApiResponse> {
            return localVarFp.apiClientsImportCchPost(requestParameters.importClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Synchronizes all clients from CCH Axcess system based on last sync timestamp. Requires Admin role.
         * @param {ClientsApiApiClientsImportCchSyncPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchSyncPost(requestParameters: ClientsApiApiClientsImportCchSyncPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ImportResultDtoApiResponse> {
            return localVarFp.apiClientsImportCchSyncPost(requestParameters.syncAllClientsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validates the connection to CCH Axcess API system. Requires Admin role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsImportCchValidateConnectionGet(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsImportCchValidateConnectionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the list of clients that the current user has access to for client switching. This endpoint is exempt from X-Active-Client-Id header requirement since it provides the list of available clients before a client selection can be made.              Role-based behavior: - Client role: Returns only clients the user has access to via ClientUserDetail (multi-contact pattern) - Preparer/Admin roles: Returns ALL clients in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsMyClientsGet(options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoListApiResponse> {
            return localVarFp.apiClientsMyClientsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk update search fields for all clients missing NormalizedName or SearchableText. Useful for migrating existing data. Requires Admin role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchBulkUpdateFieldsPost(options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse> {
            return localVarFp.apiClientsSearchBulkUpdateFieldsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for clients using a text query with pagination support.
         * @param {ClientsApiApiClientsSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchGet(requestParameters: ClientsApiApiClientsSearchGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoPaginatedResponseApiResponse> {
            return localVarFp.apiClientsSearchGet(requestParameters.q, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Advanced hybrid search across clients using exact, fuzzy, and semantic search. Combines exact client number matching, trigram fuzzy search on names, and AI-powered semantic search.
         * @param {ClientsApiApiClientsSearchHybridPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchHybridPost(requestParameters: ClientsApiApiClientsSearchHybridPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchResultDtoPaginatedResponseApiResponse> {
            return localVarFp.apiClientsSearchHybridPost(requestParameters.clientSearchQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh embeddings for clients that are missing or stale. Used to bulk update AI search capabilities. Requires Admin role.
         * @param {ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchRefreshEmbeddingsPost(requestParameters: ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse> {
            return localVarFp.apiClientsSearchRefreshEmbeddingsPost(requestParameters.maxCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get search suggestions for autocomplete (hybrid search). Returns quick client name suggestions based on partial query. Requires Preparer or Admin role to prevent client role users from searching all clients.
         * @param {ClientsApiApiClientsSearchSuggestionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSearchSuggestionsGet(requestParameters: ClientsApiApiClientsSearchSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchSuggestionDtoListApiResponse> {
            return localVarFp.apiClientsSearchSuggestionsGet(requestParameters.q, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientsApi - interface
 */
export interface ClientsApiInterface {
    /**
     * 
     * @summary Deletes a bank account
     * @param {ClientsApiApiClientsBankAccountsAccountIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsBankAccountsAccountIdDelete(requestParameters: ClientsApiApiClientsBankAccountsAccountIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Updates an existing bank account
     * @param {ClientsApiApiClientsBankAccountsAccountIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsBankAccountsAccountIdPut(requestParameters: ClientsApiApiClientsBankAccountsAccountIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBankAccountDtoApiResponse>;

    /**
     * 
     * @summary Retrieves a client by their client number (unique business identifier).
     * @param {ClientsApiApiClientsByNumberClientNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsByNumberClientNumberGet(requestParameters: ClientsApiApiClientsByNumberClientNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse>;

    /**
     * 
     * @summary Creates a new bank account for a client
     * @param {ClientsApiApiClientsClientIdBankAccountsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdBankAccountsPost(requestParameters: ClientsApiApiClientsClientIdBankAccountsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientBankAccountDtoApiResponse>;

    /**
     * 
     * @summary Creates a new dependent for a client
     * @param {ClientsApiApiClientsClientIdDependentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdDependentsPost(requestParameters: ClientsApiApiClientsClientIdDependentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDependentDtoApiResponse>;

    /**
     * 
     * @summary Retrieves pre-fill data for tax questionnaires from client profile
     * @param {ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdQuestionnairePreFillDataGet(requestParameters: ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnairePreFillDataDtoApiResponse>;

    /**
     * 
     * @summary Deletes spouse information for a client
     * @param {ClientsApiApiClientsClientIdSpouseDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdSpouseDelete(requestParameters: ClientsApiApiClientsClientIdSpouseDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Creates or updates spouse information for a client
     * @param {ClientsApiApiClientsClientIdSpousePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsClientIdSpousePut(requestParameters: ClientsApiApiClientsClientIdSpousePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSpouseDtoApiResponse>;

    /**
     * 
     * @summary Deletes a dependent
     * @param {ClientsApiApiClientsDependentsDependentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsDependentsDependentIdDelete(requestParameters: ClientsApiApiClientsDependentsDependentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Updates an existing dependent
     * @param {ClientsApiApiClientsDependentsDependentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsDependentsDependentIdPut(requestParameters: ClientsApiApiClientsDependentsDependentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDependentDtoApiResponse>;

    /**
     * 
     * @summary Retrieves a paginated list of clients with optional filtering and sorting.
     * @param {ClientsApiApiClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsGet(requestParameters?: ClientsApiApiClientsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Archives a client, marking them as inactive without permanent deletion. Requires Preparer or Admin role.
     * @param {ClientsApiApiClientsIdArchivePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdArchivePost(requestParameters: ClientsApiApiClientsIdArchivePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * Returns a detailed audit trail for the specified client including: - Client profile changes - Document uploads and modifications - Binder creation and updates - Document request activity - DocuSeal submission events              Each audit entry includes: - Timestamp of the change - User who made the change - Human-readable description of what changed - Detailed field-level changes with before/after values              Access is restricted to: - Admins and Preparers: Can view audit history for any client - Clients: Can only view audit history for their own client profile              Date Range Filtering: - If no dates provided: Returns last 90 days of audit history - If only startDate provided: Returns from startDate to now - If only endDate provided: Returns 90 days before endDate to endDate - If both provided: Returns audit entries within the specified range
     * @summary Retrieves comprehensive audit history for a client including all related entities
     * @param {ClientsApiApiClientsIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdAuditHistoryGet(requestParameters: ClientsApiApiClientsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAuditHistoryDtoApiResponse>;

    /**
     * 
     * @summary Retrieves documents from CCH Document Portal for a specific client. Requires Preparer or Admin role.
     * @param {ClientsApiApiClientsIdCchDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdCchDocumentsGet(requestParameters: ClientsApiApiClientsIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary Creates a primary user for a client when the spouse logs in and no primary exists. Only accessible by users with Spouse role on the client. Does NOT send an invitation email - the user can be invited later manually.
     * @param {ClientsApiApiClientsIdCreatePrimaryUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdCreatePrimaryUserPost(requestParameters: ClientsApiApiClientsIdCreatePrimaryUserPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoApiResponse>;

    /**
     * 
     * @summary Permanently deletes a client from the system. Requires Admin role.
     * @param {ClientsApiApiClientsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdDelete(requestParameters: ClientsApiApiClientsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Get eligible signers for a client. Returns all users associated with the client who can be assigned as signers.
     * @param {ClientsApiApiClientsIdEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdEligibleSignersGet(requestParameters: ClientsApiApiClientsIdEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse>;

    /**
     * 
     * @summary Retrieves detailed information about a specific client by their unique identifier.
     * @param {ClientsApiApiClientsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdGet(requestParameters: ClientsApiApiClientsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDetailsDtoApiResponse>;

    /**
     * 
     * @summary Updates an existing client\'s information. Requires Preparer or Admin role, or the primary client user.
     * @param {ClientsApiApiClientsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdPut(requestParameters: ClientsApiApiClientsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse>;

    /**
     * 
     * @summary Restores an archived client, making them active again. Requires Preparer or Admin role.
     * @param {ClientsApiApiClientsIdRestorePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdRestorePost(requestParameters: ClientsApiApiClientsIdRestorePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Find clients similar to a given client using semantic similarity. Uses AI embeddings to find clients with similar characteristics.
     * @param {ClientsApiApiClientsIdSimilarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdSimilarGet(requestParameters: ClientsApiApiClientsIdSimilarGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchResultDtoListApiResponse>;

    /**
     * This endpoint provides complete visibility into client access, including: - **Direct Access**: Users explicitly assigned to the client via ClientUserDetail records - **Indirect Access**: Users who share email or phone number with direct access users (multi-contact pattern)              The multi-contact pattern allows users sharing contact information to access the same clients. This is intentional for CCH import scenarios where the same person may appear across multiple clients.
     * @summary Retrieves a comprehensive summary of all users who have access to a specific client. Includes both direct access (via ClientUserDetail) and indirect access (via multi-contact pattern).
     * @param {ClientsApiApiClientsIdUserAccessGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsIdUserAccessGet(requestParameters: ClientsApiApiClientsIdUserAccessGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientAccessSummaryDtoApiResponse>;

    /**
     * 
     * @summary Previews client data from CCH Axcess system without importing. Requires Admin role.
     * @param {ClientsApiApiClientsImportCchClientIdPreviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsImportCchClientIdPreviewGet(requestParameters: ClientsApiApiClientsImportCchClientIdPreviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoApiResponse>;

    /**
     * 
     * @summary Imports multiple clients from CCH Axcess system in a batch operation. Requires Admin role.
     * @param {ClientsApiApiClientsImportCchMultiplePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsImportCchMultiplePost(requestParameters?: ClientsApiApiClientsImportCchMultiplePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportResultDtoApiResponse>;

    /**
     * 
     * @summary Imports a single client from CCH Axcess system. Requires Admin role.
     * @param {ClientsApiApiClientsImportCchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsImportCchPost(requestParameters?: ClientsApiApiClientsImportCchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportClientResultDtoApiResponse>;

    /**
     * 
     * @summary Synchronizes all clients from CCH Axcess system based on last sync timestamp. Requires Admin role.
     * @param {ClientsApiApiClientsImportCchSyncPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsImportCchSyncPost(requestParameters?: ClientsApiApiClientsImportCchSyncPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportResultDtoApiResponse>;

    /**
     * 
     * @summary Validates the connection to CCH Axcess API system. Requires Admin role.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsImportCchValidateConnectionGet(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Retrieves the list of clients that the current user has access to for client switching. This endpoint is exempt from X-Active-Client-Id header requirement since it provides the list of available clients before a client selection can be made.              Role-based behavior: - Client role: Returns only clients the user has access to via ClientUserDetail (multi-contact pattern) - Preparer/Admin roles: Returns ALL clients in the system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsMyClientsGet(options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoListApiResponse>;

    /**
     * 
     * @summary Bulk update search fields for all clients missing NormalizedName or SearchableText. Useful for migrating existing data. Requires Admin role.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsSearchBulkUpdateFieldsPost(options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse>;

    /**
     * 
     * @summary Searches for clients using a text query with pagination support.
     * @param {ClientsApiApiClientsSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsSearchGet(requestParameters?: ClientsApiApiClientsSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Advanced hybrid search across clients using exact, fuzzy, and semantic search. Combines exact client number matching, trigram fuzzy search on names, and AI-powered semantic search.
     * @param {ClientsApiApiClientsSearchHybridPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsSearchHybridPost(requestParameters?: ClientsApiApiClientsSearchHybridPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchResultDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Refresh embeddings for clients that are missing or stale. Used to bulk update AI search capabilities. Requires Admin role.
     * @param {ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsSearchRefreshEmbeddingsPost(requestParameters?: ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Int32ApiResponse>;

    /**
     * 
     * @summary Get search suggestions for autocomplete (hybrid search). Returns quick client name suggestions based on partial query. Requires Preparer or Admin role to prevent client role users from searching all clients.
     * @param {ClientsApiApiClientsSearchSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsSearchSuggestionsGet(requestParameters?: ClientsApiApiClientsSearchSuggestionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientSearchSuggestionDtoListApiResponse>;

}

/**
 * Request parameters for apiClientsBankAccountsAccountIdDelete operation in ClientsApi.
 */
export interface ClientsApiApiClientsBankAccountsAccountIdDeleteRequest {
    /**
     * The unique identifier of the bank account
     */
    readonly accountId: string
}

/**
 * Request parameters for apiClientsBankAccountsAccountIdPut operation in ClientsApi.
 */
export interface ClientsApiApiClientsBankAccountsAccountIdPutRequest {
    /**
     * The unique identifier of the bank account
     */
    readonly accountId: string

    /**
     * Bank account data to update
     */
    readonly clientBankAccountDto?: ClientBankAccountDto
}

/**
 * Request parameters for apiClientsByNumberClientNumberGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsByNumberClientNumberGetRequest {
    /**
     * The unique client number assigned to the client.
     */
    readonly clientNumber: string
}

/**
 * Request parameters for apiClientsClientIdBankAccountsPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsClientIdBankAccountsPostRequest {
    /**
     * The unique identifier of the client
     */
    readonly clientId: string

    /**
     * Bank account data to create
     */
    readonly clientBankAccountDto?: ClientBankAccountDto
}

/**
 * Request parameters for apiClientsClientIdDependentsPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsClientIdDependentsPostRequest {
    /**
     * The unique identifier of the client
     */
    readonly clientId: string

    /**
     * Dependent data to create
     */
    readonly clientDependentDto?: ClientDependentDto
}

/**
 * Request parameters for apiClientsClientIdQuestionnairePreFillDataGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest {
    /**
     * The client ID
     */
    readonly clientId: string

    /**
     * Optional binder ID for context
     */
    readonly binderId?: string
}

/**
 * Request parameters for apiClientsClientIdSpouseDelete operation in ClientsApi.
 */
export interface ClientsApiApiClientsClientIdSpouseDeleteRequest {
    /**
     * The unique identifier of the client
     */
    readonly clientId: string
}

/**
 * Request parameters for apiClientsClientIdSpousePut operation in ClientsApi.
 */
export interface ClientsApiApiClientsClientIdSpousePutRequest {
    /**
     * The unique identifier of the client
     */
    readonly clientId: string

    /**
     * Spouse data to create or update
     */
    readonly clientSpouseDto?: ClientSpouseDto
}

/**
 * Request parameters for apiClientsDependentsDependentIdDelete operation in ClientsApi.
 */
export interface ClientsApiApiClientsDependentsDependentIdDeleteRequest {
    /**
     * The unique identifier of the dependent
     */
    readonly dependentId: string
}

/**
 * Request parameters for apiClientsDependentsDependentIdPut operation in ClientsApi.
 */
export interface ClientsApiApiClientsDependentsDependentIdPutRequest {
    /**
     * The unique identifier of the dependent
     */
    readonly dependentId: string

    /**
     * Dependent data to update
     */
    readonly clientDependentDto?: ClientDependentDto
}

/**
 * Request parameters for apiClientsGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsGetRequest {
    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly search?: string

    readonly type?: ClientType

    readonly state?: string

    readonly tags?: Array<string>

    readonly createdAfter?: string

    readonly createdBefore?: string

    /**
     * Filter to only show clients watched by the current user Only applies to Preparer/Admin users
     */
    readonly watchedByMe?: boolean

    /**
     * Filter clients based on confidential status and user access Only applies to Preparer/Admin users
     */
    readonly confidentialFilter?: ConfidentialFilter

    /**
     * Filter by assigned partner (User ID). Only applies to Preparer/Admin users.
     */
    readonly partnerId?: string
}

/**
 * Request parameters for apiClientsIdArchivePost operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdArchivePostRequest {
    /**
     * The unique identifier of the client to archive.
     */
    readonly id: string
}

/**
 * Request parameters for apiClientsIdAuditHistoryGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdAuditHistoryGetRequest {
    /**
     * The unique identifier of the client
     */
    readonly id: string

    /**
     * Optional start date for filtering audit entries (inclusive, UTC)
     */
    readonly startDate?: string

    /**
     * Optional end date for filtering audit entries (inclusive, UTC)
     */
    readonly endDate?: string

    readonly search?: string

    readonly action?: string

    readonly entityType?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiClientsIdCchDocumentsGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdCchDocumentsGetRequest {
    /**
     * The unique identifier of the client to retrieve CCH documents for.
     */
    readonly id: string
}

/**
 * Request parameters for apiClientsIdCreatePrimaryUserPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdCreatePrimaryUserPostRequest {
    /**
     * The client ID
     */
    readonly id: string

    /**
     * Primary user creation data (name, email, phone)
     */
    readonly createPrimaryUserDto?: CreatePrimaryUserDto
}

/**
 * Request parameters for apiClientsIdDelete operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdDeleteRequest {
    /**
     * The unique identifier of the client to delete.
     */
    readonly id: string
}

/**
 * Request parameters for apiClientsIdEligibleSignersGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdEligibleSignersGetRequest {
    /**
     * The unique identifier of the client
     */
    readonly id: string
}

/**
 * Request parameters for apiClientsIdGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdGetRequest {
    /**
     * The unique identifier of the client to retrieve.
     */
    readonly id: string
}

/**
 * Request parameters for apiClientsIdPut operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdPutRequest {
    /**
     * The unique identifier of the client to update.
     */
    readonly id: string

    /**
     * The client data to update with new information.
     */
    readonly updateClientDto?: UpdateClientDto
}

/**
 * Request parameters for apiClientsIdRestorePost operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdRestorePostRequest {
    /**
     * The unique identifier of the archived client to restore.
     */
    readonly id: string
}

/**
 * Request parameters for apiClientsIdSimilarGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdSimilarGetRequest {
    /**
     * The client ID to find similar clients for.
     */
    readonly id: string

    /**
     * Maximum number of similar clients to return (default: 10).
     */
    readonly limit?: number
}

/**
 * Request parameters for apiClientsIdUserAccessGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsIdUserAccessGetRequest {
    /**
     * The unique identifier of the client.
     */
    readonly id: string
}

/**
 * Request parameters for apiClientsImportCchClientIdPreviewGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsImportCchClientIdPreviewGetRequest {
    /**
     * The CCH client ID to preview.
     */
    readonly clientId: string
}

/**
 * Request parameters for apiClientsImportCchMultiplePost operation in ClientsApi.
 */
export interface ClientsApiApiClientsImportCchMultiplePostRequest {
    /**
     * Import configuration containing multiple client IDs and batch options.
     */
    readonly importMultipleClientsDto?: ImportMultipleClientsDto
}

/**
 * Request parameters for apiClientsImportCchPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsImportCchPostRequest {
    /**
     * Import configuration containing client ID and options.
     */
    readonly importClientDto?: ImportClientDto
}

/**
 * Request parameters for apiClientsImportCchSyncPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsImportCchSyncPostRequest {
    /**
     * Sync configuration including last sync date, batch size, and update options.
     */
    readonly syncAllClientsDto?: SyncAllClientsDto
}

/**
 * Request parameters for apiClientsSearchGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsSearchGetRequest {
    /**
     * Search query to match against client name, email, or client number.
     */
    readonly q?: string

    /**
     * The page number to retrieve (minimum: 1, default: 1).
     */
    readonly page?: number

    /**
     * The number of results per page (minimum: 1, maximum: 200, default: 20).
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiClientsSearchHybridPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsSearchHybridPostRequest {
    /**
     * Search query with term, filters, and pagination.
     */
    readonly clientSearchQueryDto?: ClientSearchQueryDto
}

/**
 * Request parameters for apiClientsSearchRefreshEmbeddingsPost operation in ClientsApi.
 */
export interface ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest {
    /**
     * Maximum number of clients to process (0 &#x3D; all).
     */
    readonly maxCount?: number
}

/**
 * Request parameters for apiClientsSearchSuggestionsGet operation in ClientsApi.
 */
export interface ClientsApiApiClientsSearchSuggestionsGetRequest {
    /**
     * Partial search term (minimum 2 characters).
     */
    readonly q?: string

    /**
     * Maximum number of suggestions (default: 10).
     */
    readonly limit?: number
}

/**
 * ClientsApi - object-oriented interface
 */
export class ClientsApi extends BaseAPI implements ClientsApiInterface {
    /**
     * 
     * @summary Deletes a bank account
     * @param {ClientsApiApiClientsBankAccountsAccountIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsBankAccountsAccountIdDelete(requestParameters: ClientsApiApiClientsBankAccountsAccountIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsBankAccountsAccountIdDelete(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing bank account
     * @param {ClientsApiApiClientsBankAccountsAccountIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsBankAccountsAccountIdPut(requestParameters: ClientsApiApiClientsBankAccountsAccountIdPutRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsBankAccountsAccountIdPut(requestParameters.accountId, requestParameters.clientBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a client by their client number (unique business identifier).
     * @param {ClientsApiApiClientsByNumberClientNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsByNumberClientNumberGet(requestParameters: ClientsApiApiClientsByNumberClientNumberGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsByNumberClientNumberGet(requestParameters.clientNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new bank account for a client
     * @param {ClientsApiApiClientsClientIdBankAccountsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdBankAccountsPost(requestParameters: ClientsApiApiClientsClientIdBankAccountsPostRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdBankAccountsPost(requestParameters.clientId, requestParameters.clientBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new dependent for a client
     * @param {ClientsApiApiClientsClientIdDependentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdDependentsPost(requestParameters: ClientsApiApiClientsClientIdDependentsPostRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdDependentsPost(requestParameters.clientId, requestParameters.clientDependentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves pre-fill data for tax questionnaires from client profile
     * @param {ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdQuestionnairePreFillDataGet(requestParameters: ClientsApiApiClientsClientIdQuestionnairePreFillDataGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdQuestionnairePreFillDataGet(requestParameters.clientId, requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes spouse information for a client
     * @param {ClientsApiApiClientsClientIdSpouseDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdSpouseDelete(requestParameters: ClientsApiApiClientsClientIdSpouseDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdSpouseDelete(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates or updates spouse information for a client
     * @param {ClientsApiApiClientsClientIdSpousePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsClientIdSpousePut(requestParameters: ClientsApiApiClientsClientIdSpousePutRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdSpousePut(requestParameters.clientId, requestParameters.clientSpouseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a dependent
     * @param {ClientsApiApiClientsDependentsDependentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsDependentsDependentIdDelete(requestParameters: ClientsApiApiClientsDependentsDependentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsDependentsDependentIdDelete(requestParameters.dependentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing dependent
     * @param {ClientsApiApiClientsDependentsDependentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsDependentsDependentIdPut(requestParameters: ClientsApiApiClientsDependentsDependentIdPutRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsDependentsDependentIdPut(requestParameters.dependentId, requestParameters.clientDependentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a paginated list of clients with optional filtering and sorting.
     * @param {ClientsApiApiClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsGet(requestParameters: ClientsApiApiClientsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.search, requestParameters.type, requestParameters.state, requestParameters.tags, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.watchedByMe, requestParameters.confidentialFilter, requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archives a client, marking them as inactive without permanent deletion. Requires Preparer or Admin role.
     * @param {ClientsApiApiClientsIdArchivePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdArchivePost(requestParameters: ClientsApiApiClientsIdArchivePostRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdArchivePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a detailed audit trail for the specified client including: - Client profile changes - Document uploads and modifications - Binder creation and updates - Document request activity - DocuSeal submission events              Each audit entry includes: - Timestamp of the change - User who made the change - Human-readable description of what changed - Detailed field-level changes with before/after values              Access is restricted to: - Admins and Preparers: Can view audit history for any client - Clients: Can only view audit history for their own client profile              Date Range Filtering: - If no dates provided: Returns last 90 days of audit history - If only startDate provided: Returns from startDate to now - If only endDate provided: Returns 90 days before endDate to endDate - If both provided: Returns audit entries within the specified range
     * @summary Retrieves comprehensive audit history for a client including all related entities
     * @param {ClientsApiApiClientsIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdAuditHistoryGet(requestParameters: ClientsApiApiClientsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdAuditHistoryGet(requestParameters.id, requestParameters.startDate, requestParameters.endDate, requestParameters.search, requestParameters.action, requestParameters.entityType, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves documents from CCH Document Portal for a specific client. Requires Preparer or Admin role.
     * @param {ClientsApiApiClientsIdCchDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdCchDocumentsGet(requestParameters: ClientsApiApiClientsIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdCchDocumentsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a primary user for a client when the spouse logs in and no primary exists. Only accessible by users with Spouse role on the client. Does NOT send an invitation email - the user can be invited later manually.
     * @param {ClientsApiApiClientsIdCreatePrimaryUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdCreatePrimaryUserPost(requestParameters: ClientsApiApiClientsIdCreatePrimaryUserPostRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdCreatePrimaryUserPost(requestParameters.id, requestParameters.createPrimaryUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently deletes a client from the system. Requires Admin role.
     * @param {ClientsApiApiClientsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdDelete(requestParameters: ClientsApiApiClientsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get eligible signers for a client. Returns all users associated with the client who can be assigned as signers.
     * @param {ClientsApiApiClientsIdEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdEligibleSignersGet(requestParameters: ClientsApiApiClientsIdEligibleSignersGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdEligibleSignersGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves detailed information about a specific client by their unique identifier.
     * @param {ClientsApiApiClientsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdGet(requestParameters: ClientsApiApiClientsIdGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing client\'s information. Requires Preparer or Admin role, or the primary client user.
     * @param {ClientsApiApiClientsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdPut(requestParameters: ClientsApiApiClientsIdPutRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdPut(requestParameters.id, requestParameters.updateClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restores an archived client, making them active again. Requires Preparer or Admin role.
     * @param {ClientsApiApiClientsIdRestorePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdRestorePost(requestParameters: ClientsApiApiClientsIdRestorePostRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdRestorePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find clients similar to a given client using semantic similarity. Uses AI embeddings to find clients with similar characteristics.
     * @param {ClientsApiApiClientsIdSimilarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdSimilarGet(requestParameters: ClientsApiApiClientsIdSimilarGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdSimilarGet(requestParameters.id, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint provides complete visibility into client access, including: - **Direct Access**: Users explicitly assigned to the client via ClientUserDetail records - **Indirect Access**: Users who share email or phone number with direct access users (multi-contact pattern)              The multi-contact pattern allows users sharing contact information to access the same clients. This is intentional for CCH import scenarios where the same person may appear across multiple clients.
     * @summary Retrieves a comprehensive summary of all users who have access to a specific client. Includes both direct access (via ClientUserDetail) and indirect access (via multi-contact pattern).
     * @param {ClientsApiApiClientsIdUserAccessGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsIdUserAccessGet(requestParameters: ClientsApiApiClientsIdUserAccessGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdUserAccessGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Previews client data from CCH Axcess system without importing. Requires Admin role.
     * @param {ClientsApiApiClientsImportCchClientIdPreviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsImportCchClientIdPreviewGet(requestParameters: ClientsApiApiClientsImportCchClientIdPreviewGetRequest, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsImportCchClientIdPreviewGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Imports multiple clients from CCH Axcess system in a batch operation. Requires Admin role.
     * @param {ClientsApiApiClientsImportCchMultiplePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsImportCchMultiplePost(requestParameters: ClientsApiApiClientsImportCchMultiplePostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsImportCchMultiplePost(requestParameters.importMultipleClientsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Imports a single client from CCH Axcess system. Requires Admin role.
     * @param {ClientsApiApiClientsImportCchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsImportCchPost(requestParameters: ClientsApiApiClientsImportCchPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsImportCchPost(requestParameters.importClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Synchronizes all clients from CCH Axcess system based on last sync timestamp. Requires Admin role.
     * @param {ClientsApiApiClientsImportCchSyncPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsImportCchSyncPost(requestParameters: ClientsApiApiClientsImportCchSyncPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsImportCchSyncPost(requestParameters.syncAllClientsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validates the connection to CCH Axcess API system. Requires Admin role.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsImportCchValidateConnectionGet(options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsImportCchValidateConnectionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the list of clients that the current user has access to for client switching. This endpoint is exempt from X-Active-Client-Id header requirement since it provides the list of available clients before a client selection can be made.              Role-based behavior: - Client role: Returns only clients the user has access to via ClientUserDetail (multi-contact pattern) - Preparer/Admin roles: Returns ALL clients in the system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsMyClientsGet(options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsMyClientsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk update search fields for all clients missing NormalizedName or SearchableText. Useful for migrating existing data. Requires Admin role.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsSearchBulkUpdateFieldsPost(options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsSearchBulkUpdateFieldsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for clients using a text query with pagination support.
     * @param {ClientsApiApiClientsSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsSearchGet(requestParameters: ClientsApiApiClientsSearchGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsSearchGet(requestParameters.q, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Advanced hybrid search across clients using exact, fuzzy, and semantic search. Combines exact client number matching, trigram fuzzy search on names, and AI-powered semantic search.
     * @param {ClientsApiApiClientsSearchHybridPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsSearchHybridPost(requestParameters: ClientsApiApiClientsSearchHybridPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsSearchHybridPost(requestParameters.clientSearchQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh embeddings for clients that are missing or stale. Used to bulk update AI search capabilities. Requires Admin role.
     * @param {ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsSearchRefreshEmbeddingsPost(requestParameters: ClientsApiApiClientsSearchRefreshEmbeddingsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsSearchRefreshEmbeddingsPost(requestParameters.maxCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get search suggestions for autocomplete (hybrid search). Returns quick client name suggestions based on partial query. Requires Preparer or Admin role to prevent client role users from searching all clients.
     * @param {ClientsApiApiClientsSearchSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsSearchSuggestionsGet(requestParameters: ClientsApiApiClientsSearchSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsSearchSuggestionsGet(requestParameters.q, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommentsApi - axios parameter creator
 */
export const CommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves a paginated list of comments with optional filtering by entity type and ID.
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [documentId] Copy this from the Staging Data response or Preprocessing results
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} [documentRequestId] Copy this from the Staging Data response or Preprocessing results
         * @param {string} [createdById] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsGet: async (page?: number, limit?: number, sortBy?: string, sortOrder?: string, documentId?: string, binderId?: string, documentRequestId?: string, createdById?: string, createdAfter?: string, createdBefore?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (documentId !== undefined) {
                localVarQueryParameter['DocumentId'] = documentId;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (documentRequestId !== undefined) {
                localVarQueryParameter['DocumentRequestId'] = documentRequestId;
            }

            if (createdById !== undefined) {
                localVarQueryParameter['CreatedById'] = createdById;
            }

            if (createdAfter !== undefined) {
                localVarQueryParameter['CreatedAfter'] = (createdAfter as any instanceof Date) ?
                    (createdAfter as any).toISOString() :
                    createdAfter;
            }

            if (createdBefore !== undefined) {
                localVarQueryParameter['CreatedBefore'] = (createdBefore as any instanceof Date) ?
                    (createdBefore as any).toISOString() :
                    createdBefore;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves comments for a binder grouped by their parent entity (document, document request, or binder-level). Comments are organized with entity context (names, descriptions) for easy display in a unified panel.
         * @param {string} binderId The binder ID to fetch grouped comments for (required)
         * @param {boolean} [includeResolved] Whether to include resolved comments (default: true)
         * @param {string} [sortBy] Sort order for groups: \&quot;latestComment\&quot; (default), \&quot;entityName\&quot;, or \&quot;unreadFirst\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsGroupedGet: async (binderId: string, includeResolved?: boolean, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiCommentsGroupedGet', 'binderId', binderId)
            const localVarPath = `/api/Comments/grouped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (includeResolved !== undefined) {
                localVarQueryParameter['IncludeResolved'] = includeResolved;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently deletes a comment from the system. Only the comment author or Admin can delete comments.
         * @param {string} id The unique identifier of the comment to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCommentsIdDelete', 'id', id)
            const localVarPath = `/api/Comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific comment by its unique identifier.
         * @param {string} id The unique identifier of the comment to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCommentsIdGet', 'id', id)
            const localVarPath = `/api/Comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing comment\'s content. Only the comment author can modify their own comments.
         * @param {string} id The unique identifier of the comment to update.
         * @param {UpdateCommentDto} [updateCommentDto] Comment update data containing the new content.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdPut: async (id: string, updateCommentDto?: UpdateCommentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCommentsIdPut', 'id', id)
            const localVarPath = `/api/Comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks a comment as read by the current user
         * @param {string} id The unique identifier of the comment to mark as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdReadPut: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCommentsIdReadPut', 'id', id)
            const localVarPath = `/api/Comments/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks a comment as unread (clears read status)
         * @param {string} id The unique identifier of the comment to mark as unread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdUnreadPut: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCommentsIdUnreadPut', 'id', id)
            const localVarPath = `/api/Comments/{id}/unread`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new comment for a specific entity (client, document, etc.).
         * @param {CreateCommentDto} [createCommentDto] Comment creation data including entity type, entity ID, and comment content.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsPost: async (createCommentDto?: CreateCommentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentsApi - functional programming interface
 */
export const CommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves a paginated list of comments with optional filtering by entity type and ID.
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [documentId] Copy this from the Staging Data response or Preprocessing results
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} [documentRequestId] Copy this from the Staging Data response or Preprocessing results
         * @param {string} [createdById] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsGet(page?: number, limit?: number, sortBy?: string, sortOrder?: string, documentId?: string, binderId?: string, documentRequestId?: string, createdById?: string, createdAfter?: string, createdBefore?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsGet(page, limit, sortBy, sortOrder, documentId, binderId, documentRequestId, createdById, createdAfter, createdBefore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves comments for a binder grouped by their parent entity (document, document request, or binder-level). Comments are organized with entity context (names, descriptions) for easy display in a unified panel.
         * @param {string} binderId The binder ID to fetch grouped comments for (required)
         * @param {boolean} [includeResolved] Whether to include resolved comments (default: true)
         * @param {string} [sortBy] Sort order for groups: \&quot;latestComment\&quot; (default), \&quot;entityName\&quot;, or \&quot;unreadFirst\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsGroupedGet(binderId: string, includeResolved?: boolean, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupedCommentsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsGroupedGet(binderId, includeResolved, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsGroupedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently deletes a comment from the system. Only the comment author or Admin can delete comments.
         * @param {string} id The unique identifier of the comment to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific comment by its unique identifier.
         * @param {string} id The unique identifier of the comment to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing comment\'s content. Only the comment author can modify their own comments.
         * @param {string} id The unique identifier of the comment to update.
         * @param {UpdateCommentDto} [updateCommentDto] Comment update data containing the new content.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsIdPut(id: string, updateCommentDto?: UpdateCommentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsIdPut(id, updateCommentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks a comment as read by the current user
         * @param {string} id The unique identifier of the comment to mark as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsIdReadPut(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsIdReadPut(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsIdReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks a comment as unread (clears read status)
         * @param {string} id The unique identifier of the comment to mark as unread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsIdUnreadPut(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsIdUnreadPut(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsIdUnreadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new comment for a specific entity (client, document, etc.).
         * @param {CreateCommentDto} [createCommentDto] Comment creation data including entity type, entity ID, and comment content.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommentsPost(createCommentDto?: CreateCommentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommentsPost(createCommentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.apiCommentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommentsApi - factory interface
 */
export const CommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves a paginated list of comments with optional filtering by entity type and ID.
         * @param {CommentsApiApiCommentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsGet(requestParameters: CommentsApiApiCommentsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoPaginatedResponseApiResponse> {
            return localVarFp.apiCommentsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.documentId, requestParameters.binderId, requestParameters.documentRequestId, requestParameters.createdById, requestParameters.createdAfter, requestParameters.createdBefore, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves comments for a binder grouped by their parent entity (document, document request, or binder-level). Comments are organized with entity context (names, descriptions) for easy display in a unified panel.
         * @param {CommentsApiApiCommentsGroupedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsGroupedGet(requestParameters: CommentsApiApiCommentsGroupedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupedCommentsDtoApiResponse> {
            return localVarFp.apiCommentsGroupedGet(requestParameters.binderId, requestParameters.includeResolved, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently deletes a comment from the system. Only the comment author or Admin can delete comments.
         * @param {CommentsApiApiCommentsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdDelete(requestParameters: CommentsApiApiCommentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiCommentsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific comment by its unique identifier.
         * @param {CommentsApiApiCommentsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdGet(requestParameters: CommentsApiApiCommentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse> {
            return localVarFp.apiCommentsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing comment\'s content. Only the comment author can modify their own comments.
         * @param {CommentsApiApiCommentsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdPut(requestParameters: CommentsApiApiCommentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse> {
            return localVarFp.apiCommentsIdPut(requestParameters.id, requestParameters.updateCommentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks a comment as read by the current user
         * @param {CommentsApiApiCommentsIdReadPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdReadPut(requestParameters: CommentsApiApiCommentsIdReadPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse> {
            return localVarFp.apiCommentsIdReadPut(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks a comment as unread (clears read status)
         * @param {CommentsApiApiCommentsIdUnreadPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsIdUnreadPut(requestParameters: CommentsApiApiCommentsIdUnreadPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse> {
            return localVarFp.apiCommentsIdUnreadPut(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new comment for a specific entity (client, document, etc.).
         * @param {CommentsApiApiCommentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommentsPost(requestParameters: CommentsApiApiCommentsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse> {
            return localVarFp.apiCommentsPost(requestParameters.createCommentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommentsApi - interface
 */
export interface CommentsApiInterface {
    /**
     * 
     * @summary Retrieves a paginated list of comments with optional filtering by entity type and ID.
     * @param {CommentsApiApiCommentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsGet(requestParameters?: CommentsApiApiCommentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Retrieves comments for a binder grouped by their parent entity (document, document request, or binder-level). Comments are organized with entity context (names, descriptions) for easy display in a unified panel.
     * @param {CommentsApiApiCommentsGroupedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsGroupedGet(requestParameters: CommentsApiApiCommentsGroupedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupedCommentsDtoApiResponse>;

    /**
     * 
     * @summary Permanently deletes a comment from the system. Only the comment author or Admin can delete comments.
     * @param {CommentsApiApiCommentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsIdDelete(requestParameters: CommentsApiApiCommentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Retrieves detailed information about a specific comment by its unique identifier.
     * @param {CommentsApiApiCommentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsIdGet(requestParameters: CommentsApiApiCommentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse>;

    /**
     * 
     * @summary Updates an existing comment\'s content. Only the comment author can modify their own comments.
     * @param {CommentsApiApiCommentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsIdPut(requestParameters: CommentsApiApiCommentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse>;

    /**
     * 
     * @summary Marks a comment as read by the current user
     * @param {CommentsApiApiCommentsIdReadPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsIdReadPut(requestParameters: CommentsApiApiCommentsIdReadPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse>;

    /**
     * 
     * @summary Marks a comment as unread (clears read status)
     * @param {CommentsApiApiCommentsIdUnreadPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsIdUnreadPut(requestParameters: CommentsApiApiCommentsIdUnreadPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse>;

    /**
     * 
     * @summary Creates a new comment for a specific entity (client, document, etc.).
     * @param {CommentsApiApiCommentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCommentsPost(requestParameters?: CommentsApiApiCommentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommentDtoApiResponse>;

}

/**
 * Request parameters for apiCommentsGet operation in CommentsApi.
 */
export interface CommentsApiApiCommentsGetRequest {
    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    /**
     * Copy this from the Staging Data response or Preprocessing results
     */
    readonly documentId?: string

    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId?: string

    /**
     * Copy this from the Staging Data response or Preprocessing results
     */
    readonly documentRequestId?: string

    readonly createdById?: string

    readonly createdAfter?: string

    readonly createdBefore?: string
}

/**
 * Request parameters for apiCommentsGroupedGet operation in CommentsApi.
 */
export interface CommentsApiApiCommentsGroupedGetRequest {
    /**
     * The binder ID to fetch grouped comments for (required)
     */
    readonly binderId: string

    /**
     * Whether to include resolved comments (default: true)
     */
    readonly includeResolved?: boolean

    /**
     * Sort order for groups: \&quot;latestComment\&quot; (default), \&quot;entityName\&quot;, or \&quot;unreadFirst\&quot;
     */
    readonly sortBy?: string
}

/**
 * Request parameters for apiCommentsIdDelete operation in CommentsApi.
 */
export interface CommentsApiApiCommentsIdDeleteRequest {
    /**
     * The unique identifier of the comment to delete.
     */
    readonly id: string
}

/**
 * Request parameters for apiCommentsIdGet operation in CommentsApi.
 */
export interface CommentsApiApiCommentsIdGetRequest {
    /**
     * The unique identifier of the comment to retrieve.
     */
    readonly id: string
}

/**
 * Request parameters for apiCommentsIdPut operation in CommentsApi.
 */
export interface CommentsApiApiCommentsIdPutRequest {
    /**
     * The unique identifier of the comment to update.
     */
    readonly id: string

    /**
     * Comment update data containing the new content.
     */
    readonly updateCommentDto?: UpdateCommentDto
}

/**
 * Request parameters for apiCommentsIdReadPut operation in CommentsApi.
 */
export interface CommentsApiApiCommentsIdReadPutRequest {
    /**
     * The unique identifier of the comment to mark as read
     */
    readonly id: string
}

/**
 * Request parameters for apiCommentsIdUnreadPut operation in CommentsApi.
 */
export interface CommentsApiApiCommentsIdUnreadPutRequest {
    /**
     * The unique identifier of the comment to mark as unread
     */
    readonly id: string
}

/**
 * Request parameters for apiCommentsPost operation in CommentsApi.
 */
export interface CommentsApiApiCommentsPostRequest {
    /**
     * Comment creation data including entity type, entity ID, and comment content.
     */
    readonly createCommentDto?: CreateCommentDto
}

/**
 * CommentsApi - object-oriented interface
 */
export class CommentsApi extends BaseAPI implements CommentsApiInterface {
    /**
     * 
     * @summary Retrieves a paginated list of comments with optional filtering by entity type and ID.
     * @param {CommentsApiApiCommentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsGet(requestParameters: CommentsApiApiCommentsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.documentId, requestParameters.binderId, requestParameters.documentRequestId, requestParameters.createdById, requestParameters.createdAfter, requestParameters.createdBefore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves comments for a binder grouped by their parent entity (document, document request, or binder-level). Comments are organized with entity context (names, descriptions) for easy display in a unified panel.
     * @param {CommentsApiApiCommentsGroupedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsGroupedGet(requestParameters: CommentsApiApiCommentsGroupedGetRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsGroupedGet(requestParameters.binderId, requestParameters.includeResolved, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently deletes a comment from the system. Only the comment author or Admin can delete comments.
     * @param {CommentsApiApiCommentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsIdDelete(requestParameters: CommentsApiApiCommentsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves detailed information about a specific comment by its unique identifier.
     * @param {CommentsApiApiCommentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsIdGet(requestParameters: CommentsApiApiCommentsIdGetRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing comment\'s content. Only the comment author can modify their own comments.
     * @param {CommentsApiApiCommentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsIdPut(requestParameters: CommentsApiApiCommentsIdPutRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsIdPut(requestParameters.id, requestParameters.updateCommentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks a comment as read by the current user
     * @param {CommentsApiApiCommentsIdReadPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsIdReadPut(requestParameters: CommentsApiApiCommentsIdReadPutRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsIdReadPut(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks a comment as unread (clears read status)
     * @param {CommentsApiApiCommentsIdUnreadPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsIdUnreadPut(requestParameters: CommentsApiApiCommentsIdUnreadPutRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsIdUnreadPut(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new comment for a specific entity (client, document, etc.).
     * @param {CommentsApiApiCommentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiCommentsPost(requestParameters: CommentsApiApiCommentsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).apiCommentsPost(requestParameters.createCommentDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocuSealApi - axios parameter creator
 */
export const DocuSealApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Validate DocuSeal service connection and configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocuSeal/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all submissions with optional filtering
         * @param {number} [templateId] Filter submissions by template ID
         * @param {SubmissionStatus} [status] Filter submissions by status
         * @param {string} [q] Filter submissions based on submitters name, email or phone partial match
         * @param {string} [slug] Filter submissions by unique slug
         * @param {string} [templateFolder] Filter submissions by template folder name
         * @param {boolean} [archived] Returns only archived submissions when true and only active submissions when false
         * @param {number} [limit] The number of submissions to return (1-100, default: 10)
         * @param {number} [after] The unique identifier of the submission to start the list from
         * @param {number} [before] The unique identifier of the submission that marks the end of the list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsGet: async (templateId?: number, status?: SubmissionStatus, q?: string, slug?: string, templateFolder?: string, archived?: boolean, limit?: number, after?: number, before?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocuSeal/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (templateFolder !== undefined) {
                localVarQueryParameter['templateFolder'] = templateFolder;
            }

            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }

            if (before !== undefined) {
                localVarQueryParameter['before'] = before;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get documents for a specific submission
         * @param {number} id The unique identifier of the submission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsIdDocumentsGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocuSealSubmissionsIdDocumentsGet', 'id', id)
            const localVarPath = `/api/DocuSeal/submissions/{id}/documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific submission by ID
         * @param {number} id The unique identifier of the submission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocuSealSubmissionsIdGet', 'id', id)
            const localVarPath = `/api/DocuSeal/submissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a submission from PDF document(s)
         * @param {CreateSubmissionFromPdfDto} [createSubmissionFromPdfDto] The submission request with documents and submitters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsPdfPost: async (createSubmissionFromPdfDto?: CreateSubmissionFromPdfDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocuSeal/submissions/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubmissionFromPdfDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocuSealApi - functional programming interface
 */
export const DocuSealApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocuSealApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Validate DocuSeal service connection and configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocuSealHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocuSealHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocuSealApi.apiDocuSealHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all submissions with optional filtering
         * @param {number} [templateId] Filter submissions by template ID
         * @param {SubmissionStatus} [status] Filter submissions by status
         * @param {string} [q] Filter submissions based on submitters name, email or phone partial match
         * @param {string} [slug] Filter submissions by unique slug
         * @param {string} [templateFolder] Filter submissions by template folder name
         * @param {boolean} [archived] Returns only archived submissions when true and only active submissions when false
         * @param {number} [limit] The number of submissions to return (1-100, default: 10)
         * @param {number} [after] The unique identifier of the submission to start the list from
         * @param {number} [before] The unique identifier of the submission that marks the end of the list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocuSealSubmissionsGet(templateId?: number, status?: SubmissionStatus, q?: string, slug?: string, templateFolder?: string, archived?: boolean, limit?: number, after?: number, before?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSubmissionsResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocuSealSubmissionsGet(templateId, status, q, slug, templateFolder, archived, limit, after, before, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocuSealApi.apiDocuSealSubmissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get documents for a specific submission
         * @param {number} id The unique identifier of the submission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocuSealSubmissionsIdDocumentsGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDocumentsResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocuSealSubmissionsIdDocumentsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocuSealApi.apiDocuSealSubmissionsIdDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific submission by ID
         * @param {number} id The unique identifier of the submission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocuSealSubmissionsIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocuSealSubmissionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocuSealApi.apiDocuSealSubmissionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a submission from PDF document(s)
         * @param {CreateSubmissionFromPdfDto} [createSubmissionFromPdfDto] The submission request with documents and submitters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocuSealSubmissionsPdfPost(createSubmissionFromPdfDto?: CreateSubmissionFromPdfDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocuSealSubmissionsPdfPost(createSubmissionFromPdfDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocuSealApi.apiDocuSealSubmissionsPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocuSealApi - factory interface
 */
export const DocuSealApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocuSealApiFp(configuration)
    return {
        /**
         * 
         * @summary Validate DocuSeal service connection and configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiDocuSealHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all submissions with optional filtering
         * @param {DocuSealApiApiDocuSealSubmissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsGet(requestParameters: DocuSealApiApiDocuSealSubmissionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListSubmissionsResponseDtoApiResponse> {
            return localVarFp.apiDocuSealSubmissionsGet(requestParameters.templateId, requestParameters.status, requestParameters.q, requestParameters.slug, requestParameters.templateFolder, requestParameters.archived, requestParameters.limit, requestParameters.after, requestParameters.before, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get documents for a specific submission
         * @param {DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsIdDocumentsGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionDocumentsResponseDtoApiResponse> {
            return localVarFp.apiDocuSealSubmissionsIdDocumentsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific submission by ID
         * @param {DocuSealApiApiDocuSealSubmissionsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsIdGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponseDtoApiResponse> {
            return localVarFp.apiDocuSealSubmissionsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a submission from PDF document(s)
         * @param {DocuSealApiApiDocuSealSubmissionsPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocuSealSubmissionsPdfPost(requestParameters: DocuSealApiApiDocuSealSubmissionsPdfPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponseDtoApiResponse> {
            return localVarFp.apiDocuSealSubmissionsPdfPost(requestParameters.createSubmissionFromPdfDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocuSealApi - interface
 */
export interface DocuSealApiInterface {
    /**
     * 
     * @summary Validate DocuSeal service connection and configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocuSealHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary List all submissions with optional filtering
     * @param {DocuSealApiApiDocuSealSubmissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocuSealSubmissionsGet(requestParameters?: DocuSealApiApiDocuSealSubmissionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSubmissionsResponseDtoApiResponse>;

    /**
     * 
     * @summary Get documents for a specific submission
     * @param {DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocuSealSubmissionsIdDocumentsGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionDocumentsResponseDtoApiResponse>;

    /**
     * 
     * @summary Get a specific submission by ID
     * @param {DocuSealApiApiDocuSealSubmissionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocuSealSubmissionsIdGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponseDtoApiResponse>;

    /**
     * 
     * @summary Create a submission from PDF document(s)
     * @param {DocuSealApiApiDocuSealSubmissionsPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocuSealSubmissionsPdfPost(requestParameters?: DocuSealApiApiDocuSealSubmissionsPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponseDtoApiResponse>;

}

/**
 * Request parameters for apiDocuSealSubmissionsGet operation in DocuSealApi.
 */
export interface DocuSealApiApiDocuSealSubmissionsGetRequest {
    /**
     * Filter submissions by template ID
     */
    readonly templateId?: number

    /**
     * Filter submissions by status
     */
    readonly status?: SubmissionStatus

    /**
     * Filter submissions based on submitters name, email or phone partial match
     */
    readonly q?: string

    /**
     * Filter submissions by unique slug
     */
    readonly slug?: string

    /**
     * Filter submissions by template folder name
     */
    readonly templateFolder?: string

    /**
     * Returns only archived submissions when true and only active submissions when false
     */
    readonly archived?: boolean

    /**
     * The number of submissions to return (1-100, default: 10)
     */
    readonly limit?: number

    /**
     * The unique identifier of the submission to start the list from
     */
    readonly after?: number

    /**
     * The unique identifier of the submission that marks the end of the list
     */
    readonly before?: number
}

/**
 * Request parameters for apiDocuSealSubmissionsIdDocumentsGet operation in DocuSealApi.
 */
export interface DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest {
    /**
     * The unique identifier of the submission
     */
    readonly id: number
}

/**
 * Request parameters for apiDocuSealSubmissionsIdGet operation in DocuSealApi.
 */
export interface DocuSealApiApiDocuSealSubmissionsIdGetRequest {
    /**
     * The unique identifier of the submission
     */
    readonly id: number
}

/**
 * Request parameters for apiDocuSealSubmissionsPdfPost operation in DocuSealApi.
 */
export interface DocuSealApiApiDocuSealSubmissionsPdfPostRequest {
    /**
     * The submission request with documents and submitters
     */
    readonly createSubmissionFromPdfDto?: CreateSubmissionFromPdfDto
}

/**
 * DocuSealApi - object-oriented interface
 */
export class DocuSealApi extends BaseAPI implements DocuSealApiInterface {
    /**
     * 
     * @summary Validate DocuSeal service connection and configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocuSealHealthGet(options?: RawAxiosRequestConfig) {
        return DocuSealApiFp(this.configuration).apiDocuSealHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all submissions with optional filtering
     * @param {DocuSealApiApiDocuSealSubmissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocuSealSubmissionsGet(requestParameters: DocuSealApiApiDocuSealSubmissionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocuSealApiFp(this.configuration).apiDocuSealSubmissionsGet(requestParameters.templateId, requestParameters.status, requestParameters.q, requestParameters.slug, requestParameters.templateFolder, requestParameters.archived, requestParameters.limit, requestParameters.after, requestParameters.before, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get documents for a specific submission
     * @param {DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocuSealSubmissionsIdDocumentsGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return DocuSealApiFp(this.configuration).apiDocuSealSubmissionsIdDocumentsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific submission by ID
     * @param {DocuSealApiApiDocuSealSubmissionsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocuSealSubmissionsIdGet(requestParameters: DocuSealApiApiDocuSealSubmissionsIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocuSealApiFp(this.configuration).apiDocuSealSubmissionsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a submission from PDF document(s)
     * @param {DocuSealApiApiDocuSealSubmissionsPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocuSealSubmissionsPdfPost(requestParameters: DocuSealApiApiDocuSealSubmissionsPdfPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocuSealApiFp(this.configuration).apiDocuSealSubmissionsPdfPost(requestParameters.createSubmissionFromPdfDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentRequestsApi - axios parameter creator
 */
export const DocumentRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get document requests awaiting review
         * @param {string} [clientId] Use an existing client ID
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {DocumentRequestStatus} [status] 
         * @param {DocumentRequestPriority} [priority] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {number} [taxYear] 
         * @param {boolean} [isOverdue] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsAwaitingReviewGet: async (clientId?: string, binderId?: string, status?: DocumentRequestStatus, priority?: DocumentRequestPriority, requestType?: AuditDocumentRequestType, taxYear?: number, isOverdue?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests/awaiting-review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (priority !== undefined) {
                localVarQueryParameter['Priority'] = priority;
            }

            if (requestType !== undefined) {
                localVarQueryParameter['RequestType'] = requestType;
            }

            if (taxYear !== undefined) {
                localVarQueryParameter['TaxYear'] = taxYear;
            }

            if (isOverdue !== undefined) {
                localVarQueryParameter['IsOverdue'] = isOverdue;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve multiple document requests at once. Each approved request is marked Completed and every uploaded document inside it is marked Approved.
         * @param {BulkApproveDocumentRequestsDto} [bulkApproveDocumentRequestsDto] The selected document request IDs plus optional review notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsBulkApprovePost: async (bulkApproveDocumentRequestsDto?: BulkApproveDocumentRequestsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests/bulk-approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkApproveDocumentRequestsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a paginated list of document requests with optional filtering and sorting.
         * @param {string} [clientId] Use an existing client ID
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {DocumentRequestStatus} [status] 
         * @param {DocumentRequestPriority} [priority] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {number} [taxYear] 
         * @param {boolean} [isOverdue] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsGet: async (clientId?: string, binderId?: string, status?: DocumentRequestStatus, priority?: DocumentRequestPriority, requestType?: AuditDocumentRequestType, taxYear?: number, isOverdue?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (priority !== undefined) {
                localVarQueryParameter['Priority'] = priority;
            }

            if (requestType !== undefined) {
                localVarQueryParameter['RequestType'] = requestType;
            }

            if (taxYear !== undefined) {
                localVarQueryParameter['TaxYear'] = taxYear;
            }

            if (isOverdue !== undefined) {
                localVarQueryParameter['IsOverdue'] = isOverdue;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the audit history for a document request showing all changes in human-readable format.
         * @param {string} id The unique identifier of the document request to retrieve audit history for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdAuditHistoryGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdAuditHistoryGet', 'id', id)
            const localVarPath = `/api/document-requests/{id}/audit-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Client responds to document request indicating they cannot provide or request is not applicable. This creates a comment with the client\'s note.
         * @param {string} id Document request ID
         * @param {ClientResponseDto} [clientResponseDto] Client response with type and explanation note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdClientResponsePost: async (id: string, clientResponseDto?: ClientResponseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdClientResponsePost', 'id', id)
            const localVarPath = `/api/document-requests/{id}/client-response`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SetConfidentialDto} [setConfidentialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdConfidentialPatch: async (id: string, setConfidentialDto?: SetConfidentialDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdConfidentialPatch', 'id', id)
            const localVarPath = `/api/document-requests/{id}/confidential`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setConfidentialDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently deletes a document request from the system. Requires appropriate permissions.
         * @param {string} id The unique identifier of the document request to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdDelete', 'id', id)
            const localVarPath = `/api/document-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific document request by its unique identifier.
         * @param {string} id The unique identifier of the document request to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdGet', 'id', id)
            const localVarPath = `/api/document-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a document request as submitted (used when client uploads files)
         * @param {string} id Document request ID
         * @param {MarkSubmittedDto} [markSubmittedDto] Submission notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdMarkSubmittedPost: async (id: string, markSubmittedDto?: MarkSubmittedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdMarkSubmittedPost', 'id', id)
            const localVarPath = `/api/document-requests/{id}/mark-submitted`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markSubmittedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SetNeedsAttentionDto} [setNeedsAttentionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdNeedsAttentionPatch: async (id: string, setNeedsAttentionDto?: SetNeedsAttentionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdNeedsAttentionPatch', 'id', id)
            const localVarPath = `/api/document-requests/{id}/needs-attention`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setNeedsAttentionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing document request\'s information. Requires appropriate permissions.
         * @param {string} id The unique identifier of the document request to update.
         * @param {UpdateDocumentRequestDto} [updateDocumentRequestDto] The document request data to update with new information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdPut: async (id: string, updateDocumentRequestDto?: UpdateDocumentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdPut', 'id', id)
            const localVarPath = `/api/document-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What sending the client a reminder about this audit binder request would do right now: recipients, the reminder\'s content, the request\'s reminder history, and anything that blocks sending.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdReminderGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdReminderGet', 'id', id)
            const localVarPath = `/api/document-requests/{id}/reminder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reminds the client that this audit binder request is still waiting on them. One reminder per request per cooldown period, for every staff member; returns 409 when one can\'t be sent right now.
         * @param {string} id 
         * @param {SendDocumentRequestReminderDto} [sendDocumentRequestReminderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdReminderPost: async (id: string, sendDocumentRequestReminderDto?: SendDocumentRequestReminderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdReminderPost', 'id', id)
            const localVarPath = `/api/document-requests/{id}/reminder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendDocumentRequestReminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Review a document request (approve, reject, or request changes)
         * @param {string} id Document request ID
         * @param {ReviewDocumentRequestDto} [reviewDocumentRequestDto] Review action data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdReviewPost: async (id: string, reviewDocumentRequestDto?: ReviewDocumentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdReviewPost', 'id', id)
            const localVarPath = `/api/document-requests/{id}/review`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDocumentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the status of a specific document request. Requires appropriate permissions.
         * @param {string} id The unique identifier of the document request to update.
         * @param {string} [body] The new status to assign to the document request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdStatusPatch: async (id: string, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdStatusPatch', 'id', id)
            const localVarPath = `/api/document-requests/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload documents to fulfill a specific document request
         * @param {string} id Document request ID
         * @param {Array<File>} [files] Files to upload
         * @param {boolean} [replaceExisting] If true, deletes any existing documents for this request before uploading new ones
         * @param {boolean} [runAiDetection] If true, runs Azure Document Intelligence to detect form type (default: true)
         * @param {boolean} [generateAiDescription] If true, generates AI-powered description for the uploaded documents (default: true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdUploadPost: async (id: string, files?: Array<File>, replaceExisting?: boolean, runAiDetection?: boolean, generateAiDescription?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentRequestsIdUploadPost', 'id', id)
            const localVarPath = `/api/document-requests/{id}/upload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }


            if (replaceExisting !== undefined) { 
                localVarFormParams.append('replaceExisting', String(replaceExisting) as any);
            }

            if (runAiDetection !== undefined) { 
                localVarFormParams.append('runAiDetection', String(runAiDetection) as any);
            }

            if (generateAiDescription !== undefined) { 
                localVarFormParams.append('generateAiDescription', String(generateAiDescription) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all document requests that are past their due date and still pending.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsOverdueGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests/overdue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new document request for a client. Requires appropriate permissions.
         * @param {CreateDocumentRequestDto} [createDocumentRequestDto] The document request data to create with required information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsPost: async (createDocumentRequestDto?: CreateDocumentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDocumentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Release audit-binder document requests that were held for approval. Each released request becomes visible to the client and the deferred \"document requested\" notification is sent (delivered per the client\'s notification settings — immediate or digest). Requests that can\'t be released are reported back as skipped.
         * @param {ReleaseDocumentRequestsDto} [releaseDocumentRequestsDto] The selected document request IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsReleasePost: async (releaseDocumentRequestsDto?: ReleaseDocumentRequestsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests/release`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseDocumentRequestsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves statistical information about document requests with optional filtering.
         * @param {string} [clientId] Optional client ID to filter statistics for a specific client.
         * @param {number} [taxYear] Optional tax year to filter statistics for a specific year.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsStatisticsGet: async (clientId?: string, taxYear?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-requests/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (taxYear !== undefined) {
                localVarQueryParameter['taxYear'] = taxYear;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentRequestsApi - functional programming interface
 */
export const DocumentRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get document requests awaiting review
         * @param {string} [clientId] Use an existing client ID
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {DocumentRequestStatus} [status] 
         * @param {DocumentRequestPriority} [priority] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {number} [taxYear] 
         * @param {boolean} [isOverdue] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsAwaitingReviewGet(clientId?: string, binderId?: string, status?: DocumentRequestStatus, priority?: DocumentRequestPriority, requestType?: AuditDocumentRequestType, taxYear?: number, isOverdue?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsAwaitingReviewGet(clientId, binderId, status, priority, requestType, taxYear, isOverdue, search, sortBy, sortDirection, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsAwaitingReviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Approve multiple document requests at once. Each approved request is marked Completed and every uploaded document inside it is marked Approved.
         * @param {BulkApproveDocumentRequestsDto} [bulkApproveDocumentRequestsDto] The selected document request IDs plus optional review notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsBulkApprovePost(bulkApproveDocumentRequestsDto?: BulkApproveDocumentRequestsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkApproveDocumentRequestsResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsBulkApprovePost(bulkApproveDocumentRequestsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsBulkApprovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a paginated list of document requests with optional filtering and sorting.
         * @param {string} [clientId] Use an existing client ID
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {DocumentRequestStatus} [status] 
         * @param {DocumentRequestPriority} [priority] 
         * @param {AuditDocumentRequestType} [requestType] 
         * @param {number} [taxYear] 
         * @param {boolean} [isOverdue] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsGet(clientId?: string, binderId?: string, status?: DocumentRequestStatus, priority?: DocumentRequestPriority, requestType?: AuditDocumentRequestType, taxYear?: number, isOverdue?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsGet(clientId, binderId, status, priority, requestType, taxYear, isOverdue, search, sortBy, sortDirection, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves the audit history for a document request showing all changes in human-readable format.
         * @param {string} id The unique identifier of the document request to retrieve audit history for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdAuditHistoryGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestAuditHistoryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdAuditHistoryGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdAuditHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Client responds to document request indicating they cannot provide or request is not applicable. This creates a comment with the client\'s note.
         * @param {string} id Document request ID
         * @param {ClientResponseDto} [clientResponseDto] Client response with type and explanation note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdClientResponsePost(id: string, clientResponseDto?: ClientResponseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdClientResponsePost(id, clientResponseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdClientResponsePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SetConfidentialDto} [setConfidentialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdConfidentialPatch(id: string, setConfidentialDto?: SetConfidentialDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdConfidentialPatch(id, setConfidentialDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdConfidentialPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently deletes a document request from the system. Requires appropriate permissions.
         * @param {string} id The unique identifier of the document request to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific document request by its unique identifier.
         * @param {string} id The unique identifier of the document request to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a document request as submitted (used when client uploads files)
         * @param {string} id Document request ID
         * @param {MarkSubmittedDto} [markSubmittedDto] Submission notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdMarkSubmittedPost(id: string, markSubmittedDto?: MarkSubmittedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdMarkSubmittedPost(id, markSubmittedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdMarkSubmittedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SetNeedsAttentionDto} [setNeedsAttentionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdNeedsAttentionPatch(id: string, setNeedsAttentionDto?: SetNeedsAttentionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdNeedsAttentionPatch(id, setNeedsAttentionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdNeedsAttentionPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing document request\'s information. Requires appropriate permissions.
         * @param {string} id The unique identifier of the document request to update.
         * @param {UpdateDocumentRequestDto} [updateDocumentRequestDto] The document request data to update with new information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdPut(id: string, updateDocumentRequestDto?: UpdateDocumentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdPut(id, updateDocumentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary What sending the client a reminder about this audit binder request would do right now: recipients, the reminder\'s content, the request\'s reminder history, and anything that blocks sending.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdReminderGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestReminderPreviewDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdReminderGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdReminderGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reminds the client that this audit binder request is still waiting on them. One reminder per request per cooldown period, for every staff member; returns 409 when one can\'t be sent right now.
         * @param {string} id 
         * @param {SendDocumentRequestReminderDto} [sendDocumentRequestReminderDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdReminderPost(id: string, sendDocumentRequestReminderDto?: SendDocumentRequestReminderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestReminderResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdReminderPost(id, sendDocumentRequestReminderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdReminderPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Review a document request (approve, reject, or request changes)
         * @param {string} id Document request ID
         * @param {ReviewDocumentRequestDto} [reviewDocumentRequestDto] Review action data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdReviewPost(id: string, reviewDocumentRequestDto?: ReviewDocumentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdReviewPost(id, reviewDocumentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates the status of a specific document request. Requires appropriate permissions.
         * @param {string} id The unique identifier of the document request to update.
         * @param {string} [body] The new status to assign to the document request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdStatusPatch(id: string, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdStatusPatch(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdStatusPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload documents to fulfill a specific document request
         * @param {string} id Document request ID
         * @param {Array<File>} [files] Files to upload
         * @param {boolean} [replaceExisting] If true, deletes any existing documents for this request before uploading new ones
         * @param {boolean} [runAiDetection] If true, runs Azure Document Intelligence to detect form type (default: true)
         * @param {boolean} [generateAiDescription] If true, generates AI-powered description for the uploaded documents (default: true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsIdUploadPost(id: string, files?: Array<File>, replaceExisting?: boolean, runAiDetection?: boolean, generateAiDescription?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsIdUploadPost(id, files, replaceExisting, runAiDetection, generateAiDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsIdUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all document requests that are past their due date and still pending.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsOverdueGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsOverdueGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsOverdueGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new document request for a client. Requires appropriate permissions.
         * @param {CreateDocumentRequestDto} [createDocumentRequestDto] The document request data to create with required information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsPost(createDocumentRequestDto?: CreateDocumentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentRequestDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsPost(createDocumentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Release audit-binder document requests that were held for approval. Each released request becomes visible to the client and the deferred \"document requested\" notification is sent (delivered per the client\'s notification settings — immediate or digest). Requests that can\'t be released are reported back as skipped.
         * @param {ReleaseDocumentRequestsDto} [releaseDocumentRequestsDto] The selected document request IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsReleasePost(releaseDocumentRequestsDto?: ReleaseDocumentRequestsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseDocumentRequestsResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsReleasePost(releaseDocumentRequestsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsReleasePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves statistical information about document requests with optional filtering.
         * @param {string} [clientId] Optional client ID to filter statistics for a specific client.
         * @param {number} [taxYear] Optional tax year to filter statistics for a specific year.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentRequestsStatisticsGet(clientId?: string, taxYear?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringInt32DictionaryApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentRequestsStatisticsGet(clientId, taxYear, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentRequestsApi.apiDocumentRequestsStatisticsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentRequestsApi - factory interface
 */
export const DocumentRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentRequestsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get document requests awaiting review
         * @param {DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsAwaitingReviewGet(requestParameters: DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse> {
            return localVarFp.apiDocumentRequestsAwaitingReviewGet(requestParameters.clientId, requestParameters.binderId, requestParameters.status, requestParameters.priority, requestParameters.requestType, requestParameters.taxYear, requestParameters.isOverdue, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve multiple document requests at once. Each approved request is marked Completed and every uploaded document inside it is marked Approved.
         * @param {DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsBulkApprovePost(requestParameters: DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BulkApproveDocumentRequestsResultDtoApiResponse> {
            return localVarFp.apiDocumentRequestsBulkApprovePost(requestParameters.bulkApproveDocumentRequestsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a paginated list of document requests with optional filtering and sorting.
         * @param {DocumentRequestsApiApiDocumentRequestsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsGet(requestParameters: DocumentRequestsApiApiDocumentRequestsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse> {
            return localVarFp.apiDocumentRequestsGet(requestParameters.clientId, requestParameters.binderId, requestParameters.status, requestParameters.priority, requestParameters.requestType, requestParameters.taxYear, requestParameters.isOverdue, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the audit history for a document request showing all changes in human-readable format.
         * @param {DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdAuditHistoryGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestAuditHistoryDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdAuditHistoryGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Client responds to document request indicating they cannot provide or request is not applicable. This creates a comment with the client\'s note.
         * @param {DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdClientResponsePost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdClientResponsePost(requestParameters.id, requestParameters.clientResponseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdConfidentialPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdConfidentialPatch(requestParameters.id, requestParameters.setConfidentialDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently deletes a document request from the system. Requires appropriate permissions.
         * @param {DocumentRequestsApiApiDocumentRequestsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdDelete(requestParameters: DocumentRequestsApiApiDocumentRequestsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiDocumentRequestsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific document request by its unique identifier.
         * @param {DocumentRequestsApiApiDocumentRequestsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a document request as submitted (used when client uploads files)
         * @param {DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdMarkSubmittedPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdMarkSubmittedPost(requestParameters.id, requestParameters.markSubmittedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentRequestsApiApiDocumentRequestsIdNeedsAttentionPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdNeedsAttentionPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdNeedsAttentionPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdNeedsAttentionPatch(requestParameters.id, requestParameters.setNeedsAttentionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing document request\'s information. Requires appropriate permissions.
         * @param {DocumentRequestsApiApiDocumentRequestsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdPut(requestParameters: DocumentRequestsApiApiDocumentRequestsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdPut(requestParameters.id, requestParameters.updateDocumentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What sending the client a reminder about this audit binder request would do right now: recipients, the reminder\'s content, the request\'s reminder history, and anything that blocks sending.
         * @param {DocumentRequestsApiApiDocumentRequestsIdReminderGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdReminderGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReminderGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestReminderPreviewDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdReminderGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reminds the client that this audit binder request is still waiting on them. One reminder per request per cooldown period, for every staff member; returns 409 when one can\'t be sent right now.
         * @param {DocumentRequestsApiApiDocumentRequestsIdReminderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdReminderPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReminderPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestReminderResultDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdReminderPost(requestParameters.id, requestParameters.sendDocumentRequestReminderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Review a document request (approve, reject, or request changes)
         * @param {DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdReviewPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdReviewPost(requestParameters.id, requestParameters.reviewDocumentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the status of a specific document request. Requires appropriate permissions.
         * @param {DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdStatusPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdStatusPatch(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload documents to fulfill a specific document request
         * @param {DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsIdUploadPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse> {
            return localVarFp.apiDocumentRequestsIdUploadPost(requestParameters.id, requestParameters.files, requestParameters.replaceExisting, requestParameters.runAiDetection, requestParameters.generateAiDescription, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all document requests that are past their due date and still pending.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsOverdueGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoListApiResponse> {
            return localVarFp.apiDocumentRequestsOverdueGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new document request for a client. Requires appropriate permissions.
         * @param {DocumentRequestsApiApiDocumentRequestsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsPost(requestParameters: DocumentRequestsApiApiDocumentRequestsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse> {
            return localVarFp.apiDocumentRequestsPost(requestParameters.createDocumentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Release audit-binder document requests that were held for approval. Each released request becomes visible to the client and the deferred \"document requested\" notification is sent (delivered per the client\'s notification settings — immediate or digest). Requests that can\'t be released are reported back as skipped.
         * @param {DocumentRequestsApiApiDocumentRequestsReleasePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsReleasePost(requestParameters: DocumentRequestsApiApiDocumentRequestsReleasePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseDocumentRequestsResultDtoApiResponse> {
            return localVarFp.apiDocumentRequestsReleasePost(requestParameters.releaseDocumentRequestsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves statistical information about document requests with optional filtering.
         * @param {DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentRequestsStatisticsGet(requestParameters: DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<StringInt32DictionaryApiResponse> {
            return localVarFp.apiDocumentRequestsStatisticsGet(requestParameters.clientId, requestParameters.taxYear, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentRequestsApi - interface
 */
export interface DocumentRequestsApiInterface {
    /**
     * 
     * @summary Get document requests awaiting review
     * @param {DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsAwaitingReviewGet(requestParameters?: DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Approve multiple document requests at once. Each approved request is marked Completed and every uploaded document inside it is marked Approved.
     * @param {DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsBulkApprovePost(requestParameters?: DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkApproveDocumentRequestsResultDtoApiResponse>;

    /**
     * 
     * @summary Retrieves a paginated list of document requests with optional filtering and sorting.
     * @param {DocumentRequestsApiApiDocumentRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsGet(requestParameters?: DocumentRequestsApiApiDocumentRequestsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Retrieves the audit history for a document request showing all changes in human-readable format.
     * @param {DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdAuditHistoryGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestAuditHistoryDtoApiResponse>;

    /**
     * 
     * @summary Client responds to document request indicating they cannot provide or request is not applicable. This creates a comment with the client\'s note.
     * @param {DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdClientResponsePost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdConfidentialPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @summary Permanently deletes a document request from the system. Requires appropriate permissions.
     * @param {DocumentRequestsApiApiDocumentRequestsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdDelete(requestParameters: DocumentRequestsApiApiDocumentRequestsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Retrieves detailed information about a specific document request by its unique identifier.
     * @param {DocumentRequestsApiApiDocumentRequestsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @summary Mark a document request as submitted (used when client uploads files)
     * @param {DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdMarkSubmittedPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdNeedsAttentionPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdNeedsAttentionPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdNeedsAttentionPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @summary Updates an existing document request\'s information. Requires appropriate permissions.
     * @param {DocumentRequestsApiApiDocumentRequestsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdPut(requestParameters: DocumentRequestsApiApiDocumentRequestsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @summary What sending the client a reminder about this audit binder request would do right now: recipients, the reminder\'s content, the request\'s reminder history, and anything that blocks sending.
     * @param {DocumentRequestsApiApiDocumentRequestsIdReminderGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdReminderGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReminderGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestReminderPreviewDtoApiResponse>;

    /**
     * 
     * @summary Reminds the client that this audit binder request is still waiting on them. One reminder per request per cooldown period, for every staff member; returns 409 when one can\'t be sent right now.
     * @param {DocumentRequestsApiApiDocumentRequestsIdReminderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdReminderPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReminderPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestReminderResultDtoApiResponse>;

    /**
     * 
     * @summary Review a document request (approve, reject, or request changes)
     * @param {DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdReviewPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @summary Updates the status of a specific document request. Requires appropriate permissions.
     * @param {DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdStatusPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @summary Upload documents to fulfill a specific document request
     * @param {DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsIdUploadPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse>;

    /**
     * 
     * @summary Retrieves all document requests that are past their due date and still pending.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsOverdueGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoListApiResponse>;

    /**
     * 
     * @summary Creates a new document request for a client. Requires appropriate permissions.
     * @param {DocumentRequestsApiApiDocumentRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsPost(requestParameters?: DocumentRequestsApiApiDocumentRequestsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentRequestDtoApiResponse>;

    /**
     * 
     * @summary Release audit-binder document requests that were held for approval. Each released request becomes visible to the client and the deferred \"document requested\" notification is sent (delivered per the client\'s notification settings — immediate or digest). Requests that can\'t be released are reported back as skipped.
     * @param {DocumentRequestsApiApiDocumentRequestsReleasePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsReleasePost(requestParameters?: DocumentRequestsApiApiDocumentRequestsReleasePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseDocumentRequestsResultDtoApiResponse>;

    /**
     * 
     * @summary Retrieves statistical information about document requests with optional filtering.
     * @param {DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentRequestsStatisticsGet(requestParameters?: DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringInt32DictionaryApiResponse>;

}

/**
 * Request parameters for apiDocumentRequestsAwaitingReviewGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest {
    /**
     * Use an existing client ID
     */
    readonly clientId?: string

    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId?: string

    readonly status?: DocumentRequestStatus

    readonly priority?: DocumentRequestPriority

    readonly requestType?: AuditDocumentRequestType

    readonly taxYear?: number

    readonly isOverdue?: boolean

    readonly search?: string

    readonly sortBy?: string

    readonly sortDirection?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiDocumentRequestsBulkApprovePost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest {
    /**
     * The selected document request IDs plus optional review notes
     */
    readonly bulkApproveDocumentRequestsDto?: BulkApproveDocumentRequestsDto
}

/**
 * Request parameters for apiDocumentRequestsGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsGetRequest {
    /**
     * Use an existing client ID
     */
    readonly clientId?: string

    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId?: string

    readonly status?: DocumentRequestStatus

    readonly priority?: DocumentRequestPriority

    readonly requestType?: AuditDocumentRequestType

    readonly taxYear?: number

    readonly isOverdue?: boolean

    readonly search?: string

    readonly sortBy?: string

    readonly sortDirection?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiDocumentRequestsIdAuditHistoryGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest {
    /**
     * The unique identifier of the document request to retrieve audit history for.
     */
    readonly id: string
}

/**
 * Request parameters for apiDocumentRequestsIdClientResponsePost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest {
    /**
     * Document request ID
     */
    readonly id: string

    /**
     * Client response with type and explanation note
     */
    readonly clientResponseDto?: ClientResponseDto
}

/**
 * Request parameters for apiDocumentRequestsIdConfidentialPatch operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest {
    readonly id: string

    readonly setConfidentialDto?: SetConfidentialDto
}

/**
 * Request parameters for apiDocumentRequestsIdDelete operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdDeleteRequest {
    /**
     * The unique identifier of the document request to delete.
     */
    readonly id: string
}

/**
 * Request parameters for apiDocumentRequestsIdGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdGetRequest {
    /**
     * The unique identifier of the document request to retrieve.
     */
    readonly id: string
}

/**
 * Request parameters for apiDocumentRequestsIdMarkSubmittedPost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest {
    /**
     * Document request ID
     */
    readonly id: string

    /**
     * Submission notes
     */
    readonly markSubmittedDto?: MarkSubmittedDto
}

/**
 * Request parameters for apiDocumentRequestsIdNeedsAttentionPatch operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdNeedsAttentionPatchRequest {
    readonly id: string

    readonly setNeedsAttentionDto?: SetNeedsAttentionDto
}

/**
 * Request parameters for apiDocumentRequestsIdPut operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdPutRequest {
    /**
     * The unique identifier of the document request to update.
     */
    readonly id: string

    /**
     * The document request data to update with new information.
     */
    readonly updateDocumentRequestDto?: UpdateDocumentRequestDto
}

/**
 * Request parameters for apiDocumentRequestsIdReminderGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdReminderGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiDocumentRequestsIdReminderPost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdReminderPostRequest {
    readonly id: string

    readonly sendDocumentRequestReminderDto?: SendDocumentRequestReminderDto
}

/**
 * Request parameters for apiDocumentRequestsIdReviewPost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest {
    /**
     * Document request ID
     */
    readonly id: string

    /**
     * Review action data
     */
    readonly reviewDocumentRequestDto?: ReviewDocumentRequestDto
}

/**
 * Request parameters for apiDocumentRequestsIdStatusPatch operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest {
    /**
     * The unique identifier of the document request to update.
     */
    readonly id: string

    /**
     * The new status to assign to the document request.
     */
    readonly body?: string
}

/**
 * Request parameters for apiDocumentRequestsIdUploadPost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest {
    /**
     * Document request ID
     */
    readonly id: string

    /**
     * Files to upload
     */
    readonly files?: Array<File>

    /**
     * If true, deletes any existing documents for this request before uploading new ones
     */
    readonly replaceExisting?: boolean

    /**
     * If true, runs Azure Document Intelligence to detect form type (default: true)
     */
    readonly runAiDetection?: boolean

    /**
     * If true, generates AI-powered description for the uploaded documents (default: true)
     */
    readonly generateAiDescription?: boolean
}

/**
 * Request parameters for apiDocumentRequestsPost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsPostRequest {
    /**
     * The document request data to create with required information.
     */
    readonly createDocumentRequestDto?: CreateDocumentRequestDto
}

/**
 * Request parameters for apiDocumentRequestsReleasePost operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsReleasePostRequest {
    /**
     * The selected document request IDs
     */
    readonly releaseDocumentRequestsDto?: ReleaseDocumentRequestsDto
}

/**
 * Request parameters for apiDocumentRequestsStatisticsGet operation in DocumentRequestsApi.
 */
export interface DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest {
    /**
     * Optional client ID to filter statistics for a specific client.
     */
    readonly clientId?: string

    /**
     * Optional tax year to filter statistics for a specific year.
     */
    readonly taxYear?: number
}

/**
 * DocumentRequestsApi - object-oriented interface
 */
export class DocumentRequestsApi extends BaseAPI implements DocumentRequestsApiInterface {
    /**
     * 
     * @summary Get document requests awaiting review
     * @param {DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsAwaitingReviewGet(requestParameters: DocumentRequestsApiApiDocumentRequestsAwaitingReviewGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsAwaitingReviewGet(requestParameters.clientId, requestParameters.binderId, requestParameters.status, requestParameters.priority, requestParameters.requestType, requestParameters.taxYear, requestParameters.isOverdue, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve multiple document requests at once. Each approved request is marked Completed and every uploaded document inside it is marked Approved.
     * @param {DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsBulkApprovePost(requestParameters: DocumentRequestsApiApiDocumentRequestsBulkApprovePostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsBulkApprovePost(requestParameters.bulkApproveDocumentRequestsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a paginated list of document requests with optional filtering and sorting.
     * @param {DocumentRequestsApiApiDocumentRequestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsGet(requestParameters: DocumentRequestsApiApiDocumentRequestsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsGet(requestParameters.clientId, requestParameters.binderId, requestParameters.status, requestParameters.priority, requestParameters.requestType, requestParameters.taxYear, requestParameters.isOverdue, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the audit history for a document request showing all changes in human-readable format.
     * @param {DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdAuditHistoryGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdAuditHistoryGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Client responds to document request indicating they cannot provide or request is not applicable. This creates a comment with the client\'s note.
     * @param {DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdClientResponsePost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdClientResponsePostRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdClientResponsePost(requestParameters.id, requestParameters.clientResponseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdConfidentialPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdConfidentialPatchRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdConfidentialPatch(requestParameters.id, requestParameters.setConfidentialDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently deletes a document request from the system. Requires appropriate permissions.
     * @param {DocumentRequestsApiApiDocumentRequestsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdDelete(requestParameters: DocumentRequestsApiApiDocumentRequestsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves detailed information about a specific document request by its unique identifier.
     * @param {DocumentRequestsApiApiDocumentRequestsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a document request as submitted (used when client uploads files)
     * @param {DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdMarkSubmittedPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdMarkSubmittedPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdMarkSubmittedPost(requestParameters.id, requestParameters.markSubmittedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentRequestsApiApiDocumentRequestsIdNeedsAttentionPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdNeedsAttentionPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdNeedsAttentionPatchRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdNeedsAttentionPatch(requestParameters.id, requestParameters.setNeedsAttentionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing document request\'s information. Requires appropriate permissions.
     * @param {DocumentRequestsApiApiDocumentRequestsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdPut(requestParameters: DocumentRequestsApiApiDocumentRequestsIdPutRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdPut(requestParameters.id, requestParameters.updateDocumentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What sending the client a reminder about this audit binder request would do right now: recipients, the reminder\'s content, the request\'s reminder history, and anything that blocks sending.
     * @param {DocumentRequestsApiApiDocumentRequestsIdReminderGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdReminderGet(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReminderGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdReminderGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reminds the client that this audit binder request is still waiting on them. One reminder per request per cooldown period, for every staff member; returns 409 when one can\'t be sent right now.
     * @param {DocumentRequestsApiApiDocumentRequestsIdReminderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdReminderPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReminderPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdReminderPost(requestParameters.id, requestParameters.sendDocumentRequestReminderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Review a document request (approve, reject, or request changes)
     * @param {DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdReviewPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdReviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdReviewPost(requestParameters.id, requestParameters.reviewDocumentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the status of a specific document request. Requires appropriate permissions.
     * @param {DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdStatusPatch(requestParameters: DocumentRequestsApiApiDocumentRequestsIdStatusPatchRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdStatusPatch(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload documents to fulfill a specific document request
     * @param {DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsIdUploadPost(requestParameters: DocumentRequestsApiApiDocumentRequestsIdUploadPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsIdUploadPost(requestParameters.id, requestParameters.files, requestParameters.replaceExisting, requestParameters.runAiDetection, requestParameters.generateAiDescription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all document requests that are past their due date and still pending.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsOverdueGet(options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsOverdueGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new document request for a client. Requires appropriate permissions.
     * @param {DocumentRequestsApiApiDocumentRequestsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsPost(requestParameters: DocumentRequestsApiApiDocumentRequestsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsPost(requestParameters.createDocumentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Release audit-binder document requests that were held for approval. Each released request becomes visible to the client and the deferred \"document requested\" notification is sent (delivered per the client\'s notification settings — immediate or digest). Requests that can\'t be released are reported back as skipped.
     * @param {DocumentRequestsApiApiDocumentRequestsReleasePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsReleasePost(requestParameters: DocumentRequestsApiApiDocumentRequestsReleasePostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsReleasePost(requestParameters.releaseDocumentRequestsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves statistical information about document requests with optional filtering.
     * @param {DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentRequestsStatisticsGet(requestParameters: DocumentRequestsApiApiDocumentRequestsStatisticsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentRequestsApiFp(this.configuration).apiDocumentRequestsStatisticsGet(requestParameters.clientId, requestParameters.taxYear, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentTypesApi - axios parameter creator
 */
export const DocumentTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all available document type categories and common form types for frontend dropdowns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get suggested form types based on a search query (for autocomplete)
         * @param {string} [query] Search query
         * @param {number} [limit] Maximum number of suggestions to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentTypesSuggestionsGet: async (query?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-types/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentTypesApi - functional programming interface
 */
export const DocumentTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all available document type categories and common form types for frontend dropdowns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeOptionsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTypesApi.apiDocumentTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get suggested form types based on a search query (for autocomplete)
         * @param {string} [query] Search query
         * @param {number} [limit] Maximum number of suggestions to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentTypesSuggestionsGet(query?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentTypesSuggestionsGet(query, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTypesApi.apiDocumentTypesSuggestionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentTypesApi - factory interface
 */
export const DocumentTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all available document type categories and common form types for frontend dropdowns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeOptionsDtoApiResponse> {
            return localVarFp.apiDocumentTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get suggested form types based on a search query (for autocomplete)
         * @param {DocumentTypesApiApiDocumentTypesSuggestionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentTypesSuggestionsGet(requestParameters: DocumentTypesApiApiDocumentTypesSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<StringListApiResponse> {
            return localVarFp.apiDocumentTypesSuggestionsGet(requestParameters.query, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentTypesApi - interface
 */
export interface DocumentTypesApiInterface {
    /**
     * 
     * @summary Get all available document type categories and common form types for frontend dropdowns
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeOptionsDtoApiResponse>;

    /**
     * 
     * @summary Get suggested form types based on a search query (for autocomplete)
     * @param {DocumentTypesApiApiDocumentTypesSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentTypesSuggestionsGet(requestParameters?: DocumentTypesApiApiDocumentTypesSuggestionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringListApiResponse>;

}

/**
 * Request parameters for apiDocumentTypesSuggestionsGet operation in DocumentTypesApi.
 */
export interface DocumentTypesApiApiDocumentTypesSuggestionsGetRequest {
    /**
     * Search query
     */
    readonly query?: string

    /**
     * Maximum number of suggestions to return
     */
    readonly limit?: number
}

/**
 * DocumentTypesApi - object-oriented interface
 */
export class DocumentTypesApi extends BaseAPI implements DocumentTypesApiInterface {
    /**
     * 
     * @summary Get all available document type categories and common form types for frontend dropdowns
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentTypesGet(options?: RawAxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).apiDocumentTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get suggested form types based on a search query (for autocomplete)
     * @param {DocumentTypesApiApiDocumentTypesSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentTypesSuggestionsGet(requestParameters: DocumentTypesApiApiDocumentTypesSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).apiDocumentTypesSuggestionsGet(requestParameters.query, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentsApi - axios parameter creator
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint uses Azure Document Intelligence to: 1. Detect the form type on each page (W-2, 1099, 8879, state forms, etc.) 2. Identify page boundaries where form types change 3. Group consecutive pages of the same form type (respecting multi-page forms) 4. Generate suggested document names and types for each group              Use this endpoint to preview splitting suggestions before uploading. The frontend can display suggestions to users and allow them to accept, modify, or reject.              Confidence scoring: - High confidence (0.80+): Automatic splitting recommended - Medium confidence (0.60-0.79): Manual review suggested - Low confidence (below 0.60): Manual intervention required
         * @summary Analyzes a multi-page PDF for intelligent page splitting suggestions using Azure Document Intelligence. Detects form type changes across pages and recommends optimal page groupings for separate documents. This endpoint does not permanently upload the file - it only analyzes and returns suggestions. Requires Client, Preparer, or Admin role.
         * @param {File} [file] PDF file to analyze for splitting suggestions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsAnalyzeForSplittingPost: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents/analyze-for-splitting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preprocesses a document with intelligent analysis including automatic splitting, signature field detection, and document structure recognition. This advanced preprocessing workflow prepares documents for optimized upload workflows and e-signature integration. Requires Preparer or Admin role.
         * @param {string} binderId The unique identifier of the binder to associate with preprocessing results and document categorization.
         * @param {File} file 
         * @param {boolean} [autoSplit] 
         * @param {boolean} [detectSignatures] 
         * @param {DocumentDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsBindersBinderIdPreprocessPost: async (binderId: string, file: File, autoSplit?: boolean, detectSignatures?: boolean, direction?: DocumentDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiDocumentsBindersBinderIdPreprocessPost', 'binderId', binderId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiDocumentsBindersBinderIdPreprocessPost', 'file', file)
            const localVarPath = `/api/Documents/binders/{binderId}/preprocess`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }

            if (autoSplit !== undefined) { 
                localVarFormParams.append('AutoSplit', String(autoSplit) as any);
            }

            if (detectSignatures !== undefined) { 
                localVarFormParams.append('DetectSignatures', String(detectSignatures) as any);
            }

            if (direction !== undefined) { 
                localVarFormParams.append('Direction', direction as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint performs a fast duplicate check (target: less than 2 seconds) without permanently uploading the file. Warnings are returned for files with similarity >= 0.70, but uploads are never blocked. Detection tiers: - Tier 1 (Fast): File hash, size, and filename comparison - Tier 2 (Medium): Form type and extracted data comparison - Tier 3 (Slow, fallback): AI-powered visual similarity analysis
         * @summary Checks for potential duplicate documents before uploading. Uses multi-tier detection: file hash, metadata similarity, and AI visual comparison.
         * @param {string} [binderId] ID of the binder to check within
         * @param {File} [file] File to check for duplicates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsCheckDuplicatePost: async (binderId?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents/check-duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (binderId !== undefined) {
                localVarQueryParameter['binderId'] = binderId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Classifies a document using AI to suggest appropriate categorization based on content analysis. Analyzes document content, detected form types, and extracted data to recommend document type and tags.
         * @param {string} documentId ID of the document to classify
         * @param {boolean} [autoApply] Automatically apply suggestions if confidence &gt;&#x3D; 0.80 (default: false)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdClassifyPost: async (documentId: string, autoApply?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdClassifyPost', 'documentId', documentId)
            const localVarPath = `/api/Documents/{documentId}/classify`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (autoApply !== undefined) {
                localVarQueryParameter['autoApply'] = autoApply;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extracts structured data from a single tax form document using Azure Document Intelligence. Supports W-2, 1099 series, and 1098 forms with prebuilt AI models. Extracted data is saved to the document\'s ExtractedDataJson field. Requires Preparer or Admin role.
         * @param {string} documentId The unique identifier of the document to extract data from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdExtractDataPost: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdExtractDataPost', 'documentId', documentId)
            const localVarPath = `/api/Documents/{documentId}/extract-data`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a specific file from a document while preserving the document structure. Requires Admin role.
         * @param {string} documentId The unique identifier of the document containing the file.
         * @param {string} fileId The unique identifier of the file to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdFilesFileIdDelete: async (documentId: string, fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdFilesFileIdDelete', 'documentId', documentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdFilesFileIdDelete', 'fileId', fileId)
            const localVarPath = `/api/Documents/{documentId}/files/{fileId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reviews a document by approving or rejecting it with optional comment (Issue #74 - Document Review Workflow). This endpoint allows preparers to review client-uploaded documents and provide feedback. Requires Preparer or Admin role.
         * @param {string} documentId The unique identifier of the document to review.
         * @param {ReviewDocumentRequest} [reviewDocumentRequest] Review request containing status (approved/rejected) and optional comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdReviewPatch: async (documentId: string, reviewDocumentRequest?: ReviewDocumentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdReviewPatch', 'documentId', documentId)
            const localVarPath = `/api/Documents/{documentId}/review`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Review an individual document within a document request
         * @param {string} documentId The document ID to review
         * @param {ReviewDocumentDto} [reviewDocumentDto] Review action and details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdReviewPost: async (documentId: string, reviewDocumentDto?: ReviewDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdReviewPost', 'documentId', documentId)
            const localVarPath = `/api/Documents/{documentId}/review`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Triggers AI processing for a document (Admin only, for debugging/reprocessing).
         * @param {string} documentId ID of the document to process
         * @param {boolean} [runFormDetection] Whether to run form detection (default: true)
         * @param {boolean} [generateDescription] Whether to generate AI description (default: true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdTriggerAiProcessingPost: async (documentId: string, runFormDetection?: boolean, generateDescription?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentsDocumentIdTriggerAiProcessingPost', 'documentId', documentId)
            const localVarPath = `/api/Documents/{documentId}/trigger-ai-processing`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (runFormDetection !== undefined) {
                localVarQueryParameter['runFormDetection'] = runFormDetection;
            }

            if (generateDescription !== undefined) {
                localVarQueryParameter['generateDescription'] = generateDescription;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extracts structured data from multiple tax form documents in batch. Processes all documents in an binder or a specified subset of document IDs. Only documents with supported form types (W-2, 1099, 1098) are processed. Requires Preparer or Admin role.
         * @param {BatchExtractionRequest} [batchExtractionRequest] Batch extraction request containing binder ID and optional document ID filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsExtractDataBatchPost: async (batchExtractionRequest?: BatchExtractionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents/extract-data-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchExtractionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client\'s documents. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client\'s documents.
         * @summary Retrieves a paginated list of documents with optional filtering, sorting, search, and client-specific access control. Supports filtering by direction (ReceivedFromClient vs SentToClient) to distinguish client-uploaded from preparer-generated documents. Supports search across filename, description, document type display names, and form types (detected/override). Enhanced for Issue #74: Supports category filter (\"client\" or \"firm\") with archive-based access control. Enhanced for Issue #91 Phase 3.1: Supports active client filtering for client role users.
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {DocumentType} [type] 
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [hasDocumentRequest] Filter by document-request assignment: true returns only documents attached to a document request, false returns only unattached documents.
         * @param {string} [category] 
         * @param {string} [searchTerm] Search term for filtering documents across multiple fields. Minimum length: 2 characters. Maximum length: 200 characters.
         * @param {boolean} [isExported] 
         * @param {string} [exportedAfter] 
         * @param {string} [exportedBefore] 
         * @param {string} [exportedById] 
         * @param {boolean} [excludeK1Documents] When true, excludes K1-extracted documents (DetectedFormType &#x3D;&#x3D; \&quot;K-1\&quot;) from results. Set automatically by the controller for Client role users — K1s are served via the K1 endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsGet: async (page?: number, limit?: number, sortBy?: string, sortOrder?: string, type?: DocumentType, binderId?: string, direction?: DocumentDirection, hasDocumentRequest?: boolean, category?: string, searchTerm?: string, isExported?: boolean, exportedAfter?: string, exportedBefore?: string, exportedById?: string, excludeK1Documents?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            if (hasDocumentRequest !== undefined) {
                localVarQueryParameter['HasDocumentRequest'] = hasDocumentRequest;
            }

            if (category !== undefined) {
                localVarQueryParameter['Category'] = category;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (isExported !== undefined) {
                localVarQueryParameter['IsExported'] = isExported;
            }

            if (exportedAfter !== undefined) {
                localVarQueryParameter['ExportedAfter'] = (exportedAfter as any instanceof Date) ?
                    (exportedAfter as any).toISOString() :
                    exportedAfter;
            }

            if (exportedBefore !== undefined) {
                localVarQueryParameter['ExportedBefore'] = (exportedBefore as any instanceof Date) ?
                    (exportedBefore as any).toISOString() :
                    exportedBefore;
            }

            if (exportedById !== undefined) {
                localVarQueryParameter['ExportedById'] = exportedById;
            }

            if (excludeK1Documents !== undefined) {
                localVarQueryParameter['ExcludeK1Documents'] = excludeK1Documents;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Converts document files to PDF format using advanced document processing algorithms. This feature supports multiple input formats and provides options for compression, quality settings, and format optimization. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the document containing files to convert to PDF format.
         * @param {any} [body] Conversion configuration including quality settings, compression options, and output preferences.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdConvertToPdfPost: async (id: string, body?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdConvertToPdfPost', 'id', id)
            const localVarPath = `/api/Documents/{id}/convert-to-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Permanently deletes a document from the system. Requires Admin role or document ownership. Enhanced for Issue #74 with authorization checks and RequiredDocument unlinking. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {string} id The unique identifier of the document to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdDelete', 'id', id)
            const localVarPath = `/api/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assigns a document to a document request, moves it to a different request, or detaches it from its current request (null DocumentRequestId). The target request must belong to the same binder as the document. The document\'s review state is never changed by a move. Staff only.
         * @param {string} id The unique identifier of the document to reassign.
         * @param {AssignDocumentToRequestDto} [assignDocumentToRequestDto] The target document request ID, or null to detach the document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdDocumentRequestPut: async (id: string, assignDocumentToRequestDto?: AssignDocumentToRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdDocumentRequestPut', 'id', id)
            const localVarPath = `/api/Documents/{id}/document-request`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignDocumentToRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads a complete document by returning a presigned URL for Azure storage or streaming for local storage. For Azure Blob Storage, returns a time-limited presigned URL with 1-hour expiration. For local storage or multi-file documents, falls back to file streaming.
         * @param {string} id The unique identifier of the document to download.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdDownloadGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdDownloadGet', 'id', id)
            const localVarPath = `/api/Documents/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json,application/octet-stream,text/plain,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the document must belong to that client. Supports AI-powered description generation which analyzes the added file to create intelligent descriptions.
         * @summary Adds additional files to an existing document. Requires Preparer or Admin role. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {string} id The unique identifier of the document to add files to.
         * @param {boolean} [generateAiDescription] Whether to generate AI-powered description for the updated document (default: true).
         * @param {File} [file] The file to add to the existing document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdFilesPost: async (id: string, generateAiDescription?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdFilesPost', 'id', id)
            const localVarPath = `/api/Documents/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (generateAiDescription !== undefined) {
                localVarQueryParameter['generateAiDescription'] = generateAiDescription;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Retrieves detailed information about a specific document by its unique identifier. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client.
         * @param {string} id The unique identifier of the document to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdGet', 'id', id)
            const localVarPath = `/api/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prepares a document for electronic signature by creating DocuSeal submission with signature fields and client details. Requires Preparer or Admin role for signature preparation.
         * @param {string} id The unique identifier of the document to prepare for signing.
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] Signature preparation details including client information, signature fields, and delivery options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdPrepareForSignaturePost: async (id: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdPrepareForSignaturePost', 'id', id)
            const localVarPath = `/api/Documents/{id}/prepare-for-signature`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleDocumentSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates document properties including type, status, and user override for AI-detected form type.
         * @param {string} id The unique identifier of the document to update.
         * @param {UpdateDocumentDto} [updateDocumentDto] The update data with optional Type, Status, and UserOverrideFormType fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdPut: async (id: string, updateDocumentDto?: UpdateDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdPut', 'id', id)
            const localVarPath = `/api/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancels an active preprocessing operation and cleans up associated resources including temporary files and cached data. This operation cannot be undone and will terminate all preprocessing activities. Requires Preparer or Admin role.
         * @param {string} preprocessingId The unique identifier of the preprocessing operation to cancel and clean up.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreprocessingPreprocessingIdDelete: async (preprocessingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preprocessingId' is not null or undefined
            assertParamExists('apiDocumentsPreprocessingPreprocessingIdDelete', 'preprocessingId', preprocessingId)
            const localVarPath = `/api/Documents/preprocessing/{preprocessingId}`
                .replace(`{${"preprocessingId"}}`, encodeURIComponent(String(preprocessingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves comprehensive preprocessing results including document analysis, split recommendations, and signature field detection. Provides detailed status and results from document preprocessing operations. Requires Preparer or Admin role.
         * @param {string} preprocessingId The unique identifier of the preprocessing operation to retrieve detailed results for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreprocessingPreprocessingIdGet: async (preprocessingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preprocessingId' is not null or undefined
            assertParamExists('apiDocumentsPreprocessingPreprocessingIdGet', 'preprocessingId', preprocessingId)
            const localVarPath = `/api/Documents/preprocessing/{preprocessingId}`
                .replace(`{${"preprocessingId"}}`, encodeURIComponent(String(preprocessingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates an interactive preview of a PDF document with page thumbnails, bookmark detection, and grouping analysis. Requires Preparer or Admin role for document preview generation.
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreviewPost: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiDocumentsPreviewPost', 'file', file)
            const localVarPath = `/api/Documents/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get documents awaiting review for a document request
         * @param {string} documentRequestId The document request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdAwaitingReviewGet: async (documentRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiDocumentsRequestDocumentRequestIdAwaitingReviewGet', 'documentRequestId', documentRequestId)
            const localVarPath = `/api/Documents/request/{documentRequestId}/awaiting-review`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Perform bulk review of multiple documents within a document request
         * @param {string} documentRequestId The document request ID
         * @param {BulkReviewDocumentsDto} [bulkReviewDocumentsDto] Bulk review actions for multiple documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdBulkReviewPost: async (documentRequestId: string, bulkReviewDocumentsDto?: BulkReviewDocumentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiDocumentsRequestDocumentRequestIdBulkReviewPost', 'documentRequestId', documentRequestId)
            const localVarPath = `/api/Documents/request/{documentRequestId}/bulk-review`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkReviewDocumentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all documents associated with a specific document request
         * @param {string} documentRequestId The unique identifier of the document request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdDocumentsGet: async (documentRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiDocumentsRequestDocumentRequestIdDocumentsGet', 'documentRequestId', documentRequestId)
            const localVarPath = `/api/Documents/request/{documentRequestId}/documents`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all available document types for upload with metadata for frontend selection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
         * @summary Uploads one or more documents with specified type, binder, category (\"client\" or \"firm\"), optional comment, and optional e-signature template assignment. Requires Preparer or Admin role for document uploads. Supports frontend type strings (e.g., \"w2\", \"1099\") or direct DocumentType enum. Issue #74: Category field added for client vs firm document tracking. Issue #75: Comment field and virus scanning added for enhanced security. Enhanced for Issue #91 Phase 3.1: Validates binder belongs to active client when provided.
         * @param {Array<File>} files 
         * @param {string} binderId 
         * @param {string} [frontendType] Frontend document type string (e.g., \\\&quot;w2\\\&quot;, \\\&quot;1099\\\&quot;, \\\&quot;receipt\\\&quot;). If provided, takes precedence over Type field.
         * @param {DocumentType} [type] 
         * @param {string} [comment] Optional comment/note provided by the uploader about the document.
         * @param {string} [documentRequestId] 
         * @param {string} [signatureTemplateId] 
         * @param {boolean} [runAiDetection] 
         * @param {boolean} [generateAiDescription] Whether to generate AI-powered description for the document (default: true). If true, generates description from Azure Document Intelligence extracted data or falls back to Claude vision API.
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [skipDuplicateCheck] When true, skips the SHA-256 duplicate-file check against existing binder files (both within the batch and against the binder). This is an opt-out honored for any authenticated caller of the upload endpoint; it is primarily intended for the signature-request upload flow, where re-sending an identical PDF is legitimate. Bypassing dedup only affects storage of duplicate content — it grants no additional access — so it is not gated on SignatureTemplateId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsUploadPost: async (files: Array<File>, binderId: string, frontendType?: string, type?: DocumentType, comment?: string, documentRequestId?: string, signatureTemplateId?: string, runAiDetection?: boolean, generateAiDescription?: boolean, direction?: DocumentDirection, skipDuplicateCheck?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('apiDocumentsUploadPost', 'files', files)
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiDocumentsUploadPost', 'binderId', binderId)
            const localVarPath = `/api/Documents/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element as any);
                })
            }


            if (frontendType !== undefined) { 
                localVarFormParams.append('FrontendType', frontendType as any);
            }

            if (type !== undefined) { 
                localVarFormParams.append('Type', type as any);
            }

            if (binderId !== undefined) { 
                localVarFormParams.append('BinderId', binderId as any);
            }

            if (comment !== undefined) { 
                localVarFormParams.append('Comment', comment as any);
            }

            if (documentRequestId !== undefined) { 
                localVarFormParams.append('DocumentRequestId', documentRequestId as any);
            }

            if (signatureTemplateId !== undefined) { 
                localVarFormParams.append('SignatureTemplateId', signatureTemplateId as any);
            }

            if (runAiDetection !== undefined) { 
                localVarFormParams.append('RunAiDetection', String(runAiDetection) as any);
            }

            if (generateAiDescription !== undefined) { 
                localVarFormParams.append('GenerateAiDescription', String(generateAiDescription) as any);
            }

            if (direction !== undefined) { 
                localVarFormParams.append('Direction', direction as any);
            }

            if (skipDuplicateCheck !== undefined) { 
                localVarFormParams.append('SkipDuplicateCheck', String(skipDuplicateCheck) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads documents with intelligent page selection based on preview analysis, bookmark detection, and document splitting. This advanced workflow allows users to selectively upload specific pages or page ranges from a previewed document, with automatic e-signature template assignment and DocuSeal integration. Requires Client, Preparer, or Admin role.
         * @param {DocumentUploadWithPagesDto} [documentUploadWithPagesDto] Document upload configuration including selected page groups, split options, binder assignment, signature templates, and e-signature delivery preferences.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsUploadWithPagesPost: async (documentUploadWithPagesDto?: DocumentUploadWithPagesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Documents/upload-with-pages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentUploadWithPagesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint uses Azure Document Intelligence to: 1. Detect the form type on each page (W-2, 1099, 8879, state forms, etc.) 2. Identify page boundaries where form types change 3. Group consecutive pages of the same form type (respecting multi-page forms) 4. Generate suggested document names and types for each group              Use this endpoint to preview splitting suggestions before uploading. The frontend can display suggestions to users and allow them to accept, modify, or reject.              Confidence scoring: - High confidence (0.80+): Automatic splitting recommended - Medium confidence (0.60-0.79): Manual review suggested - Low confidence (below 0.60): Manual intervention required
         * @summary Analyzes a multi-page PDF for intelligent page splitting suggestions using Azure Document Intelligence. Detects form type changes across pages and recommends optimal page groupings for separate documents. This endpoint does not permanently upload the file - it only analyzes and returns suggestions. Requires Client, Preparer, or Admin role.
         * @param {string} version 
         * @param {File} [file] PDF file to analyze for splitting suggestions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsAnalyzeForSplittingPost: async (version: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsAnalyzeForSplittingPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/analyze-for-splitting`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preprocesses a document with intelligent analysis including automatic splitting, signature field detection, and document structure recognition. This advanced preprocessing workflow prepares documents for optimized upload workflows and e-signature integration. Requires Preparer or Admin role.
         * @param {string} binderId The unique identifier of the binder to associate with preprocessing results and document categorization.
         * @param {string} version 
         * @param {File} file 
         * @param {boolean} [autoSplit] 
         * @param {boolean} [detectSignatures] 
         * @param {DocumentDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsBindersBinderIdPreprocessPost: async (binderId: string, version: string, file: File, autoSplit?: boolean, detectSignatures?: boolean, direction?: DocumentDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiVversionDocumentsBindersBinderIdPreprocessPost', 'binderId', binderId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsBindersBinderIdPreprocessPost', 'version', version)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiVversionDocumentsBindersBinderIdPreprocessPost', 'file', file)
            const localVarPath = `/api/v{version}/Documents/binders/{binderId}/preprocess`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }

            if (autoSplit !== undefined) { 
                localVarFormParams.append('AutoSplit', String(autoSplit) as any);
            }

            if (detectSignatures !== undefined) { 
                localVarFormParams.append('DetectSignatures', String(detectSignatures) as any);
            }

            if (direction !== undefined) { 
                localVarFormParams.append('Direction', direction as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint performs a fast duplicate check (target: less than 2 seconds) without permanently uploading the file. Warnings are returned for files with similarity >= 0.70, but uploads are never blocked. Detection tiers: - Tier 1 (Fast): File hash, size, and filename comparison - Tier 2 (Medium): Form type and extracted data comparison - Tier 3 (Slow, fallback): AI-powered visual similarity analysis
         * @summary Checks for potential duplicate documents before uploading. Uses multi-tier detection: file hash, metadata similarity, and AI visual comparison.
         * @param {string} version 
         * @param {string} [binderId] ID of the binder to check within
         * @param {File} [file] File to check for duplicates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsCheckDuplicatePost: async (version: string, binderId?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsCheckDuplicatePost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/check-duplicate`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (binderId !== undefined) {
                localVarQueryParameter['binderId'] = binderId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Classifies a document using AI to suggest appropriate categorization based on content analysis. Analyzes document content, detected form types, and extracted data to recommend document type and tags.
         * @param {string} documentId ID of the document to classify
         * @param {string} version 
         * @param {boolean} [autoApply] Automatically apply suggestions if confidence &gt;&#x3D; 0.80 (default: false)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdClassifyPost: async (documentId: string, version: string, autoApply?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdClassifyPost', 'documentId', documentId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdClassifyPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/classify`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (autoApply !== undefined) {
                localVarQueryParameter['autoApply'] = autoApply;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extracts structured data from a single tax form document using Azure Document Intelligence. Supports W-2, 1099 series, and 1098 forms with prebuilt AI models. Extracted data is saved to the document\'s ExtractedDataJson field. Requires Preparer or Admin role.
         * @param {string} documentId The unique identifier of the document to extract data from.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdExtractDataPost: async (documentId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdExtractDataPost', 'documentId', documentId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdExtractDataPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/extract-data`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a specific file from a document while preserving the document structure. Requires Admin role.
         * @param {string} documentId The unique identifier of the document containing the file.
         * @param {string} fileId The unique identifier of the file to delete.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdFilesFileIdDelete: async (documentId: string, fileId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdFilesFileIdDelete', 'documentId', documentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdFilesFileIdDelete', 'fileId', fileId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdFilesFileIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/files/{fileId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reviews a document by approving or rejecting it with optional comment (Issue #74 - Document Review Workflow). This endpoint allows preparers to review client-uploaded documents and provide feedback. Requires Preparer or Admin role.
         * @param {string} documentId The unique identifier of the document to review.
         * @param {string} version 
         * @param {ReviewDocumentRequest} [reviewDocumentRequest] Review request containing status (approved/rejected) and optional comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdReviewPatch: async (documentId: string, version: string, reviewDocumentRequest?: ReviewDocumentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdReviewPatch', 'documentId', documentId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdReviewPatch', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/review`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Review an individual document within a document request
         * @param {string} documentId The document ID to review
         * @param {string} version 
         * @param {ReviewDocumentDto} [reviewDocumentDto] Review action and details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdReviewPost: async (documentId: string, version: string, reviewDocumentDto?: ReviewDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdReviewPost', 'documentId', documentId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdReviewPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/review`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Triggers AI processing for a document (Admin only, for debugging/reprocessing).
         * @param {string} documentId ID of the document to process
         * @param {string} version 
         * @param {boolean} [runFormDetection] Whether to run form detection (default: true)
         * @param {boolean} [generateDescription] Whether to generate AI description (default: true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdTriggerAiProcessingPost: async (documentId: string, version: string, runFormDetection?: boolean, generateDescription?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdTriggerAiProcessingPost', 'documentId', documentId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsDocumentIdTriggerAiProcessingPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{documentId}/trigger-ai-processing`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (runFormDetection !== undefined) {
                localVarQueryParameter['runFormDetection'] = runFormDetection;
            }

            if (generateDescription !== undefined) {
                localVarQueryParameter['generateDescription'] = generateDescription;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extracts structured data from multiple tax form documents in batch. Processes all documents in an binder or a specified subset of document IDs. Only documents with supported form types (W-2, 1099, 1098) are processed. Requires Preparer or Admin role.
         * @param {string} version 
         * @param {BatchExtractionRequest} [batchExtractionRequest] Batch extraction request containing binder ID and optional document ID filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsExtractDataBatchPost: async (version: string, batchExtractionRequest?: BatchExtractionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsExtractDataBatchPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/extract-data-batch`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchExtractionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client\'s documents. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client\'s documents.
         * @summary Retrieves a paginated list of documents with optional filtering, sorting, search, and client-specific access control. Supports filtering by direction (ReceivedFromClient vs SentToClient) to distinguish client-uploaded from preparer-generated documents. Supports search across filename, description, document type display names, and form types (detected/override). Enhanced for Issue #74: Supports category filter (\"client\" or \"firm\") with archive-based access control. Enhanced for Issue #91 Phase 3.1: Supports active client filtering for client role users.
         * @param {string} version 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {DocumentType} [type] 
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [hasDocumentRequest] Filter by document-request assignment: true returns only documents attached to a document request, false returns only unattached documents.
         * @param {string} [category] 
         * @param {string} [searchTerm] Search term for filtering documents across multiple fields. Minimum length: 2 characters. Maximum length: 200 characters.
         * @param {boolean} [isExported] 
         * @param {string} [exportedAfter] 
         * @param {string} [exportedBefore] 
         * @param {string} [exportedById] 
         * @param {boolean} [excludeK1Documents] When true, excludes K1-extracted documents (DetectedFormType &#x3D;&#x3D; \&quot;K-1\&quot;) from results. Set automatically by the controller for Client role users — K1s are served via the K1 endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsGet: async (version: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, type?: DocumentType, binderId?: string, direction?: DocumentDirection, hasDocumentRequest?: boolean, category?: string, searchTerm?: string, isExported?: boolean, exportedAfter?: string, exportedBefore?: string, exportedById?: string, excludeK1Documents?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            if (hasDocumentRequest !== undefined) {
                localVarQueryParameter['HasDocumentRequest'] = hasDocumentRequest;
            }

            if (category !== undefined) {
                localVarQueryParameter['Category'] = category;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (isExported !== undefined) {
                localVarQueryParameter['IsExported'] = isExported;
            }

            if (exportedAfter !== undefined) {
                localVarQueryParameter['ExportedAfter'] = (exportedAfter as any instanceof Date) ?
                    (exportedAfter as any).toISOString() :
                    exportedAfter;
            }

            if (exportedBefore !== undefined) {
                localVarQueryParameter['ExportedBefore'] = (exportedBefore as any instanceof Date) ?
                    (exportedBefore as any).toISOString() :
                    exportedBefore;
            }

            if (exportedById !== undefined) {
                localVarQueryParameter['ExportedById'] = exportedById;
            }

            if (excludeK1Documents !== undefined) {
                localVarQueryParameter['ExcludeK1Documents'] = excludeK1Documents;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Converts document files to PDF format using advanced document processing algorithms. This feature supports multiple input formats and provides options for compression, quality settings, and format optimization. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the document containing files to convert to PDF format.
         * @param {string} version 
         * @param {any} [body] Conversion configuration including quality settings, compression options, and output preferences.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdConvertToPdfPost: async (id: string, version: string, body?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdConvertToPdfPost', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdConvertToPdfPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}/convert-to-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Permanently deletes a document from the system. Requires Admin role or document ownership. Enhanced for Issue #74 with authorization checks and RequiredDocument unlinking. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {string} id The unique identifier of the document to delete.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdDelete: async (id: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assigns a document to a document request, moves it to a different request, or detaches it from its current request (null DocumentRequestId). The target request must belong to the same binder as the document. The document\'s review state is never changed by a move. Staff only.
         * @param {string} id The unique identifier of the document to reassign.
         * @param {string} version 
         * @param {AssignDocumentToRequestDto} [assignDocumentToRequestDto] The target document request ID, or null to detach the document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdDocumentRequestPut: async (id: string, version: string, assignDocumentToRequestDto?: AssignDocumentToRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdDocumentRequestPut', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdDocumentRequestPut', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}/document-request`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignDocumentToRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads a complete document by returning a presigned URL for Azure storage or streaming for local storage. For Azure Blob Storage, returns a time-limited presigned URL with 1-hour expiration. For local storage or multi-file documents, falls back to file streaming.
         * @param {string} id The unique identifier of the document to download.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdDownloadGet: async (id: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdDownloadGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdDownloadGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json,application/octet-stream,text/plain,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the document must belong to that client. Supports AI-powered description generation which analyzes the added file to create intelligent descriptions.
         * @summary Adds additional files to an existing document. Requires Preparer or Admin role. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {string} id The unique identifier of the document to add files to.
         * @param {string} version 
         * @param {boolean} [generateAiDescription] Whether to generate AI-powered description for the updated document (default: true).
         * @param {File} [file] The file to add to the existing document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdFilesPost: async (id: string, version: string, generateAiDescription?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdFilesPost', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdFilesPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (generateAiDescription !== undefined) {
                localVarQueryParameter['generateAiDescription'] = generateAiDescription;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Retrieves detailed information about a specific document by its unique identifier. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client.
         * @param {string} id The unique identifier of the document to retrieve.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdGet: async (id: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prepares a document for electronic signature by creating DocuSeal submission with signature fields and client details. Requires Preparer or Admin role for signature preparation.
         * @param {string} id The unique identifier of the document to prepare for signing.
         * @param {string} version 
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] Signature preparation details including client information, signature fields, and delivery options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdPrepareForSignaturePost: async (id: string, version: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdPrepareForSignaturePost', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdPrepareForSignaturePost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}/prepare-for-signature`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleDocumentSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates document properties including type, status, and user override for AI-detected form type.
         * @param {string} id The unique identifier of the document to update.
         * @param {string} version 
         * @param {UpdateDocumentDto} [updateDocumentDto] The update data with optional Type, Status, and UserOverrideFormType fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdPut: async (id: string, version: string, updateDocumentDto?: UpdateDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionDocumentsIdPut', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsIdPut', 'version', version)
            const localVarPath = `/api/v{version}/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancels an active preprocessing operation and cleans up associated resources including temporary files and cached data. This operation cannot be undone and will terminate all preprocessing activities. Requires Preparer or Admin role.
         * @param {string} preprocessingId The unique identifier of the preprocessing operation to cancel and clean up.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreprocessingPreprocessingIdDelete: async (preprocessingId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preprocessingId' is not null or undefined
            assertParamExists('apiVversionDocumentsPreprocessingPreprocessingIdDelete', 'preprocessingId', preprocessingId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsPreprocessingPreprocessingIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/Documents/preprocessing/{preprocessingId}`
                .replace(`{${"preprocessingId"}}`, encodeURIComponent(String(preprocessingId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves comprehensive preprocessing results including document analysis, split recommendations, and signature field detection. Provides detailed status and results from document preprocessing operations. Requires Preparer or Admin role.
         * @param {string} preprocessingId The unique identifier of the preprocessing operation to retrieve detailed results for.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreprocessingPreprocessingIdGet: async (preprocessingId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preprocessingId' is not null or undefined
            assertParamExists('apiVversionDocumentsPreprocessingPreprocessingIdGet', 'preprocessingId', preprocessingId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsPreprocessingPreprocessingIdGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/preprocessing/{preprocessingId}`
                .replace(`{${"preprocessingId"}}`, encodeURIComponent(String(preprocessingId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates an interactive preview of a PDF document with page thumbnails, bookmark detection, and grouping analysis. Requires Preparer or Admin role for document preview generation.
         * @param {string} version 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreviewPost: async (version: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsPreviewPost', 'version', version)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiVversionDocumentsPreviewPost', 'file', file)
            const localVarPath = `/api/v{version}/Documents/preview`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get documents awaiting review for a document request
         * @param {string} documentRequestId The document request ID
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet: async (documentRequestId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet', 'documentRequestId', documentRequestId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/request/{documentRequestId}/awaiting-review`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Perform bulk review of multiple documents within a document request
         * @param {string} documentRequestId The document request ID
         * @param {string} version 
         * @param {BulkReviewDocumentsDto} [bulkReviewDocumentsDto] Bulk review actions for multiple documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost: async (documentRequestId: string, version: string, bulkReviewDocumentsDto?: BulkReviewDocumentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost', 'documentRequestId', documentRequestId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/request/{documentRequestId}/bulk-review`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkReviewDocumentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all documents associated with a specific document request
         * @param {string} documentRequestId The unique identifier of the document request
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdDocumentsGet: async (documentRequestId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentRequestId' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdDocumentsGet', 'documentRequestId', documentRequestId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsRequestDocumentRequestIdDocumentsGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/request/{documentRequestId}/documents`
                .replace(`{${"documentRequestId"}}`, encodeURIComponent(String(documentRequestId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all available document types for upload with metadata for frontend selection.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsTypesGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsTypesGet', 'version', version)
            const localVarPath = `/api/v{version}/Documents/types`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
         * @summary Uploads one or more documents with specified type, binder, category (\"client\" or \"firm\"), optional comment, and optional e-signature template assignment. Requires Preparer or Admin role for document uploads. Supports frontend type strings (e.g., \"w2\", \"1099\") or direct DocumentType enum. Issue #74: Category field added for client vs firm document tracking. Issue #75: Comment field and virus scanning added for enhanced security. Enhanced for Issue #91 Phase 3.1: Validates binder belongs to active client when provided.
         * @param {string} version 
         * @param {Array<File>} files 
         * @param {string} binderId 
         * @param {string} [frontendType] Frontend document type string (e.g., \\\&quot;w2\\\&quot;, \\\&quot;1099\\\&quot;, \\\&quot;receipt\\\&quot;). If provided, takes precedence over Type field.
         * @param {DocumentType} [type] 
         * @param {string} [comment] Optional comment/note provided by the uploader about the document.
         * @param {string} [documentRequestId] 
         * @param {string} [signatureTemplateId] 
         * @param {boolean} [runAiDetection] 
         * @param {boolean} [generateAiDescription] Whether to generate AI-powered description for the document (default: true). If true, generates description from Azure Document Intelligence extracted data or falls back to Claude vision API.
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [skipDuplicateCheck] When true, skips the SHA-256 duplicate-file check against existing binder files (both within the batch and against the binder). This is an opt-out honored for any authenticated caller of the upload endpoint; it is primarily intended for the signature-request upload flow, where re-sending an identical PDF is legitimate. Bypassing dedup only affects storage of duplicate content — it grants no additional access — so it is not gated on SignatureTemplateId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsUploadPost: async (version: string, files: Array<File>, binderId: string, frontendType?: string, type?: DocumentType, comment?: string, documentRequestId?: string, signatureTemplateId?: string, runAiDetection?: boolean, generateAiDescription?: boolean, direction?: DocumentDirection, skipDuplicateCheck?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsUploadPost', 'version', version)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('apiVversionDocumentsUploadPost', 'files', files)
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiVversionDocumentsUploadPost', 'binderId', binderId)
            const localVarPath = `/api/v{version}/Documents/upload`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element as any);
                })
            }


            if (frontendType !== undefined) { 
                localVarFormParams.append('FrontendType', frontendType as any);
            }

            if (type !== undefined) { 
                localVarFormParams.append('Type', type as any);
            }

            if (binderId !== undefined) { 
                localVarFormParams.append('BinderId', binderId as any);
            }

            if (comment !== undefined) { 
                localVarFormParams.append('Comment', comment as any);
            }

            if (documentRequestId !== undefined) { 
                localVarFormParams.append('DocumentRequestId', documentRequestId as any);
            }

            if (signatureTemplateId !== undefined) { 
                localVarFormParams.append('SignatureTemplateId', signatureTemplateId as any);
            }

            if (runAiDetection !== undefined) { 
                localVarFormParams.append('RunAiDetection', String(runAiDetection) as any);
            }

            if (generateAiDescription !== undefined) { 
                localVarFormParams.append('GenerateAiDescription', String(generateAiDescription) as any);
            }

            if (direction !== undefined) { 
                localVarFormParams.append('Direction', direction as any);
            }

            if (skipDuplicateCheck !== undefined) { 
                localVarFormParams.append('SkipDuplicateCheck', String(skipDuplicateCheck) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads documents with intelligent page selection based on preview analysis, bookmark detection, and document splitting. This advanced workflow allows users to selectively upload specific pages or page ranges from a previewed document, with automatic e-signature template assignment and DocuSeal integration. Requires Client, Preparer, or Admin role.
         * @param {string} version 
         * @param {DocumentUploadWithPagesDto} [documentUploadWithPagesDto] Document upload configuration including selected page groups, split options, binder assignment, signature templates, and e-signature delivery preferences.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsUploadWithPagesPost: async (version: string, documentUploadWithPagesDto?: DocumentUploadWithPagesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionDocumentsUploadWithPagesPost', 'version', version)
            const localVarPath = `/api/v{version}/Documents/upload-with-pages`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentUploadWithPagesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint uses Azure Document Intelligence to: 1. Detect the form type on each page (W-2, 1099, 8879, state forms, etc.) 2. Identify page boundaries where form types change 3. Group consecutive pages of the same form type (respecting multi-page forms) 4. Generate suggested document names and types for each group              Use this endpoint to preview splitting suggestions before uploading. The frontend can display suggestions to users and allow them to accept, modify, or reject.              Confidence scoring: - High confidence (0.80+): Automatic splitting recommended - Medium confidence (0.60-0.79): Manual review suggested - Low confidence (below 0.60): Manual intervention required
         * @summary Analyzes a multi-page PDF for intelligent page splitting suggestions using Azure Document Intelligence. Detects form type changes across pages and recommends optimal page groupings for separate documents. This endpoint does not permanently upload the file - it only analyzes and returns suggestions. Requires Client, Preparer, or Admin role.
         * @param {File} [file] PDF file to analyze for splitting suggestions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsAnalyzeForSplittingPost(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageSplittingResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsAnalyzeForSplittingPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsAnalyzeForSplittingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preprocesses a document with intelligent analysis including automatic splitting, signature field detection, and document structure recognition. This advanced preprocessing workflow prepares documents for optimized upload workflows and e-signature integration. Requires Preparer or Admin role.
         * @param {string} binderId The unique identifier of the binder to associate with preprocessing results and document categorization.
         * @param {File} file 
         * @param {boolean} [autoSplit] 
         * @param {boolean} [detectSignatures] 
         * @param {DocumentDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsBindersBinderIdPreprocessPost(binderId: string, file: File, autoSplit?: boolean, detectSignatures?: boolean, direction?: DocumentDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreprocessingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsBindersBinderIdPreprocessPost(binderId, file, autoSplit, detectSignatures, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsBindersBinderIdPreprocessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint performs a fast duplicate check (target: less than 2 seconds) without permanently uploading the file. Warnings are returned for files with similarity >= 0.70, but uploads are never blocked. Detection tiers: - Tier 1 (Fast): File hash, size, and filename comparison - Tier 2 (Medium): Form type and extracted data comparison - Tier 3 (Slow, fallback): AI-powered visual similarity analysis
         * @summary Checks for potential duplicate documents before uploading. Uses multi-tier detection: file hash, metadata similarity, and AI visual comparison.
         * @param {string} [binderId] ID of the binder to check within
         * @param {File} [file] File to check for duplicates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsCheckDuplicatePost(binderId?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DuplicateDetectionResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsCheckDuplicatePost(binderId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsCheckDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Classifies a document using AI to suggest appropriate categorization based on content analysis. Analyzes document content, detected form types, and extracted data to recommend document type and tags.
         * @param {string} documentId ID of the document to classify
         * @param {boolean} [autoApply] Automatically apply suggestions if confidence &gt;&#x3D; 0.80 (default: false)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdClassifyPost(documentId: string, autoApply?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentClassificationResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdClassifyPost(documentId, autoApply, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdClassifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Extracts structured data from a single tax form document using Azure Document Intelligence. Supports W-2, 1099 series, and 1098 forms with prebuilt AI models. Extracted data is saved to the document\'s ExtractedDataJson field. Requires Preparer or Admin role.
         * @param {string} documentId The unique identifier of the document to extract data from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdExtractDataPost(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtractedDataResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdExtractDataPost(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdExtractDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a specific file from a document while preserving the document structure. Requires Admin role.
         * @param {string} documentId The unique identifier of the document containing the file.
         * @param {string} fileId The unique identifier of the file to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdFilesFileIdDelete(documentId: string, fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdFilesFileIdDelete(documentId, fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdFilesFileIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reviews a document by approving or rejecting it with optional comment (Issue #74 - Document Review Workflow). This endpoint allows preparers to review client-uploaded documents and provide feedback. Requires Preparer or Admin role.
         * @param {string} documentId The unique identifier of the document to review.
         * @param {ReviewDocumentRequest} [reviewDocumentRequest] Review request containing status (approved/rejected) and optional comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdReviewPatch(documentId: string, reviewDocumentRequest?: ReviewDocumentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentReviewResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdReviewPatch(documentId, reviewDocumentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdReviewPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Review an individual document within a document request
         * @param {string} documentId The document ID to review
         * @param {ReviewDocumentDto} [reviewDocumentDto] Review action and details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdReviewPost(documentId: string, reviewDocumentDto?: ReviewDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdReviewPost(documentId, reviewDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Triggers AI processing for a document (Admin only, for debugging/reprocessing).
         * @param {string} documentId ID of the document to process
         * @param {boolean} [runFormDetection] Whether to run form detection (default: true)
         * @param {boolean} [generateDescription] Whether to generate AI description (default: true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsDocumentIdTriggerAiProcessingPost(documentId: string, runFormDetection?: boolean, generateDescription?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsDocumentIdTriggerAiProcessingPost(documentId, runFormDetection, generateDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsDocumentIdTriggerAiProcessingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Extracts structured data from multiple tax form documents in batch. Processes all documents in an binder or a specified subset of document IDs. Only documents with supported form types (W-2, 1099, 1098) are processed. Requires Preparer or Admin role.
         * @param {BatchExtractionRequest} [batchExtractionRequest] Batch extraction request containing binder ID and optional document ID filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsExtractDataBatchPost(batchExtractionRequest?: BatchExtractionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchExtractionResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsExtractDataBatchPost(batchExtractionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsExtractDataBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client\'s documents. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client\'s documents.
         * @summary Retrieves a paginated list of documents with optional filtering, sorting, search, and client-specific access control. Supports filtering by direction (ReceivedFromClient vs SentToClient) to distinguish client-uploaded from preparer-generated documents. Supports search across filename, description, document type display names, and form types (detected/override). Enhanced for Issue #74: Supports category filter (\"client\" or \"firm\") with archive-based access control. Enhanced for Issue #91 Phase 3.1: Supports active client filtering for client role users.
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {DocumentType} [type] 
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [hasDocumentRequest] Filter by document-request assignment: true returns only documents attached to a document request, false returns only unattached documents.
         * @param {string} [category] 
         * @param {string} [searchTerm] Search term for filtering documents across multiple fields. Minimum length: 2 characters. Maximum length: 200 characters.
         * @param {boolean} [isExported] 
         * @param {string} [exportedAfter] 
         * @param {string} [exportedBefore] 
         * @param {string} [exportedById] 
         * @param {boolean} [excludeK1Documents] When true, excludes K1-extracted documents (DetectedFormType &#x3D;&#x3D; \&quot;K-1\&quot;) from results. Set automatically by the controller for Client role users — K1s are served via the K1 endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsGet(page?: number, limit?: number, sortBy?: string, sortOrder?: string, type?: DocumentType, binderId?: string, direction?: DocumentDirection, hasDocumentRequest?: boolean, category?: string, searchTerm?: string, isExported?: boolean, exportedAfter?: string, exportedBefore?: string, exportedById?: string, excludeK1Documents?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsGet(page, limit, sortBy, sortOrder, type, binderId, direction, hasDocumentRequest, category, searchTerm, isExported, exportedAfter, exportedBefore, exportedById, excludeK1Documents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Converts document files to PDF format using advanced document processing algorithms. This feature supports multiple input formats and provides options for compression, quality settings, and format optimization. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the document containing files to convert to PDF format.
         * @param {any} [body] Conversion configuration including quality settings, compression options, and output preferences.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdConvertToPdfPost(id: string, body?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdConvertToPdfPost(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdConvertToPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Permanently deletes a document from the system. Requires Admin role or document ownership. Enhanced for Issue #74 with authorization checks and RequiredDocument unlinking. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {string} id The unique identifier of the document to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assigns a document to a document request, moves it to a different request, or detaches it from its current request (null DocumentRequestId). The target request must belong to the same binder as the document. The document\'s review state is never changed by a move. Staff only.
         * @param {string} id The unique identifier of the document to reassign.
         * @param {AssignDocumentToRequestDto} [assignDocumentToRequestDto] The target document request ID, or null to detach the document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdDocumentRequestPut(id: string, assignDocumentToRequestDto?: AssignDocumentToRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdDocumentRequestPut(id, assignDocumentToRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdDocumentRequestPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Downloads a complete document by returning a presigned URL for Azure storage or streaming for local storage. For Azure Blob Storage, returns a time-limited presigned URL with 1-hour expiration. For local storage or multi-file documents, falls back to file streaming.
         * @param {string} id The unique identifier of the document to download.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdDownloadGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDownloadUrlDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdDownloadGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the document must belong to that client. Supports AI-powered description generation which analyzes the added file to create intelligent descriptions.
         * @summary Adds additional files to an existing document. Requires Preparer or Admin role. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {string} id The unique identifier of the document to add files to.
         * @param {boolean} [generateAiDescription] Whether to generate AI-powered description for the updated document (default: true).
         * @param {File} [file] The file to add to the existing document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdFilesPost(id: string, generateAiDescription?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdFilesPost(id, generateAiDescription, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Retrieves detailed information about a specific document by its unique identifier. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client.
         * @param {string} id The unique identifier of the document to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Prepares a document for electronic signature by creating DocuSeal submission with signature fields and client details. Requires Preparer or Admin role for signature preparation.
         * @param {string} id The unique identifier of the document to prepare for signing.
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] Signature preparation details including client information, signature fields, and delivery options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdPrepareForSignaturePost(id: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureSubmissionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdPrepareForSignaturePost(id, singleDocumentSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdPrepareForSignaturePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates document properties including type, status, and user override for AI-detected form type.
         * @param {string} id The unique identifier of the document to update.
         * @param {UpdateDocumentDto} [updateDocumentDto] The update data with optional Type, Status, and UserOverrideFormType fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdPut(id: string, updateDocumentDto?: UpdateDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdPut(id, updateDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancels an active preprocessing operation and cleans up associated resources including temporary files and cached data. This operation cannot be undone and will terminate all preprocessing activities. Requires Preparer or Admin role.
         * @param {string} preprocessingId The unique identifier of the preprocessing operation to cancel and clean up.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsPreprocessingPreprocessingIdDelete(preprocessingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsPreprocessingPreprocessingIdDelete(preprocessingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsPreprocessingPreprocessingIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves comprehensive preprocessing results including document analysis, split recommendations, and signature field detection. Provides detailed status and results from document preprocessing operations. Requires Preparer or Admin role.
         * @param {string} preprocessingId The unique identifier of the preprocessing operation to retrieve detailed results for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsPreprocessingPreprocessingIdGet(preprocessingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreprocessingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsPreprocessingPreprocessingIdGet(preprocessingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsPreprocessingPreprocessingIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generates an interactive preview of a PDF document with page thumbnails, bookmark detection, and grouping analysis. Requires Preparer or Admin role for document preview generation.
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsPreviewPost(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreviewResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsPreviewPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get documents awaiting review for a document request
         * @param {string} documentRequestId The document request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(documentRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(documentRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsRequestDocumentRequestIdAwaitingReviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Perform bulk review of multiple documents within a document request
         * @param {string} documentRequestId The document request ID
         * @param {BulkReviewDocumentsDto} [bulkReviewDocumentsDto] Bulk review actions for multiple documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsRequestDocumentRequestIdBulkReviewPost(documentRequestId: string, bulkReviewDocumentsDto?: BulkReviewDocumentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsRequestDocumentRequestIdBulkReviewPost(documentRequestId, bulkReviewDocumentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsRequestDocumentRequestIdBulkReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all documents associated with a specific document request
         * @param {string} documentRequestId The unique identifier of the document request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsRequestDocumentRequestIdDocumentsGet(documentRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsRequestDocumentRequestIdDocumentsGet(documentRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsRequestDocumentRequestIdDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all available document types for upload with metadata for frontend selection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
         * @summary Uploads one or more documents with specified type, binder, category (\"client\" or \"firm\"), optional comment, and optional e-signature template assignment. Requires Preparer or Admin role for document uploads. Supports frontend type strings (e.g., \"w2\", \"1099\") or direct DocumentType enum. Issue #74: Category field added for client vs firm document tracking. Issue #75: Comment field and virus scanning added for enhanced security. Enhanced for Issue #91 Phase 3.1: Validates binder belongs to active client when provided.
         * @param {Array<File>} files 
         * @param {string} binderId 
         * @param {string} [frontendType] Frontend document type string (e.g., \\\&quot;w2\\\&quot;, \\\&quot;1099\\\&quot;, \\\&quot;receipt\\\&quot;). If provided, takes precedence over Type field.
         * @param {DocumentType} [type] 
         * @param {string} [comment] Optional comment/note provided by the uploader about the document.
         * @param {string} [documentRequestId] 
         * @param {string} [signatureTemplateId] 
         * @param {boolean} [runAiDetection] 
         * @param {boolean} [generateAiDescription] Whether to generate AI-powered description for the document (default: true). If true, generates description from Azure Document Intelligence extracted data or falls back to Claude vision API.
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [skipDuplicateCheck] When true, skips the SHA-256 duplicate-file check against existing binder files (both within the batch and against the binder). This is an opt-out honored for any authenticated caller of the upload endpoint; it is primarily intended for the signature-request upload flow, where re-sending an identical PDF is legitimate. Bypassing dedup only affects storage of duplicate content — it grants no additional access — so it is not gated on SignatureTemplateId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsUploadPost(files: Array<File>, binderId: string, frontendType?: string, type?: DocumentType, comment?: string, documentRequestId?: string, signatureTemplateId?: string, runAiDetection?: boolean, generateAiDescription?: boolean, direction?: DocumentDirection, skipDuplicateCheck?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsUploadPost(files, binderId, frontendType, type, comment, documentRequestId, signatureTemplateId, runAiDetection, generateAiDescription, direction, skipDuplicateCheck, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Uploads documents with intelligent page selection based on preview analysis, bookmark detection, and document splitting. This advanced workflow allows users to selectively upload specific pages or page ranges from a previewed document, with automatic e-signature template assignment and DocuSeal integration. Requires Client, Preparer, or Admin role.
         * @param {DocumentUploadWithPagesDto} [documentUploadWithPagesDto] Document upload configuration including selected page groups, split options, binder assignment, signature templates, and e-signature delivery preferences.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsUploadWithPagesPost(documentUploadWithPagesDto?: DocumentUploadWithPagesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsUploadWithPagesPost(documentUploadWithPagesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiDocumentsUploadWithPagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint uses Azure Document Intelligence to: 1. Detect the form type on each page (W-2, 1099, 8879, state forms, etc.) 2. Identify page boundaries where form types change 3. Group consecutive pages of the same form type (respecting multi-page forms) 4. Generate suggested document names and types for each group              Use this endpoint to preview splitting suggestions before uploading. The frontend can display suggestions to users and allow them to accept, modify, or reject.              Confidence scoring: - High confidence (0.80+): Automatic splitting recommended - Medium confidence (0.60-0.79): Manual review suggested - Low confidence (below 0.60): Manual intervention required
         * @summary Analyzes a multi-page PDF for intelligent page splitting suggestions using Azure Document Intelligence. Detects form type changes across pages and recommends optimal page groupings for separate documents. This endpoint does not permanently upload the file - it only analyzes and returns suggestions. Requires Client, Preparer, or Admin role.
         * @param {string} version 
         * @param {File} [file] PDF file to analyze for splitting suggestions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsAnalyzeForSplittingPost(version: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageSplittingResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsAnalyzeForSplittingPost(version, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsAnalyzeForSplittingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preprocesses a document with intelligent analysis including automatic splitting, signature field detection, and document structure recognition. This advanced preprocessing workflow prepares documents for optimized upload workflows and e-signature integration. Requires Preparer or Admin role.
         * @param {string} binderId The unique identifier of the binder to associate with preprocessing results and document categorization.
         * @param {string} version 
         * @param {File} file 
         * @param {boolean} [autoSplit] 
         * @param {boolean} [detectSignatures] 
         * @param {DocumentDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsBindersBinderIdPreprocessPost(binderId: string, version: string, file: File, autoSplit?: boolean, detectSignatures?: boolean, direction?: DocumentDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreprocessingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsBindersBinderIdPreprocessPost(binderId, version, file, autoSplit, detectSignatures, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsBindersBinderIdPreprocessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint performs a fast duplicate check (target: less than 2 seconds) without permanently uploading the file. Warnings are returned for files with similarity >= 0.70, but uploads are never blocked. Detection tiers: - Tier 1 (Fast): File hash, size, and filename comparison - Tier 2 (Medium): Form type and extracted data comparison - Tier 3 (Slow, fallback): AI-powered visual similarity analysis
         * @summary Checks for potential duplicate documents before uploading. Uses multi-tier detection: file hash, metadata similarity, and AI visual comparison.
         * @param {string} version 
         * @param {string} [binderId] ID of the binder to check within
         * @param {File} [file] File to check for duplicates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsCheckDuplicatePost(version: string, binderId?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DuplicateDetectionResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsCheckDuplicatePost(version, binderId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsCheckDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Classifies a document using AI to suggest appropriate categorization based on content analysis. Analyzes document content, detected form types, and extracted data to recommend document type and tags.
         * @param {string} documentId ID of the document to classify
         * @param {string} version 
         * @param {boolean} [autoApply] Automatically apply suggestions if confidence &gt;&#x3D; 0.80 (default: false)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdClassifyPost(documentId: string, version: string, autoApply?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentClassificationResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdClassifyPost(documentId, version, autoApply, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdClassifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Extracts structured data from a single tax form document using Azure Document Intelligence. Supports W-2, 1099 series, and 1098 forms with prebuilt AI models. Extracted data is saved to the document\'s ExtractedDataJson field. Requires Preparer or Admin role.
         * @param {string} documentId The unique identifier of the document to extract data from.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdExtractDataPost(documentId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtractedDataResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdExtractDataPost(documentId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdExtractDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a specific file from a document while preserving the document structure. Requires Admin role.
         * @param {string} documentId The unique identifier of the document containing the file.
         * @param {string} fileId The unique identifier of the file to delete.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdFilesFileIdDelete(documentId: string, fileId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdFilesFileIdDelete(documentId, fileId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdFilesFileIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reviews a document by approving or rejecting it with optional comment (Issue #74 - Document Review Workflow). This endpoint allows preparers to review client-uploaded documents and provide feedback. Requires Preparer or Admin role.
         * @param {string} documentId The unique identifier of the document to review.
         * @param {string} version 
         * @param {ReviewDocumentRequest} [reviewDocumentRequest] Review request containing status (approved/rejected) and optional comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdReviewPatch(documentId: string, version: string, reviewDocumentRequest?: ReviewDocumentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentReviewResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdReviewPatch(documentId, version, reviewDocumentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdReviewPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Review an individual document within a document request
         * @param {string} documentId The document ID to review
         * @param {string} version 
         * @param {ReviewDocumentDto} [reviewDocumentDto] Review action and details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdReviewPost(documentId: string, version: string, reviewDocumentDto?: ReviewDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdReviewPost(documentId, version, reviewDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Triggers AI processing for a document (Admin only, for debugging/reprocessing).
         * @param {string} documentId ID of the document to process
         * @param {string} version 
         * @param {boolean} [runFormDetection] Whether to run form detection (default: true)
         * @param {boolean} [generateDescription] Whether to generate AI description (default: true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsDocumentIdTriggerAiProcessingPost(documentId: string, version: string, runFormDetection?: boolean, generateDescription?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsDocumentIdTriggerAiProcessingPost(documentId, version, runFormDetection, generateDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsDocumentIdTriggerAiProcessingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Extracts structured data from multiple tax form documents in batch. Processes all documents in an binder or a specified subset of document IDs. Only documents with supported form types (W-2, 1099, 1098) are processed. Requires Preparer or Admin role.
         * @param {string} version 
         * @param {BatchExtractionRequest} [batchExtractionRequest] Batch extraction request containing binder ID and optional document ID filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsExtractDataBatchPost(version: string, batchExtractionRequest?: BatchExtractionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchExtractionResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsExtractDataBatchPost(version, batchExtractionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsExtractDataBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client\'s documents. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client\'s documents.
         * @summary Retrieves a paginated list of documents with optional filtering, sorting, search, and client-specific access control. Supports filtering by direction (ReceivedFromClient vs SentToClient) to distinguish client-uploaded from preparer-generated documents. Supports search across filename, description, document type display names, and form types (detected/override). Enhanced for Issue #74: Supports category filter (\"client\" or \"firm\") with archive-based access control. Enhanced for Issue #91 Phase 3.1: Supports active client filtering for client role users.
         * @param {string} version 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {DocumentType} [type] 
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [hasDocumentRequest] Filter by document-request assignment: true returns only documents attached to a document request, false returns only unattached documents.
         * @param {string} [category] 
         * @param {string} [searchTerm] Search term for filtering documents across multiple fields. Minimum length: 2 characters. Maximum length: 200 characters.
         * @param {boolean} [isExported] 
         * @param {string} [exportedAfter] 
         * @param {string} [exportedBefore] 
         * @param {string} [exportedById] 
         * @param {boolean} [excludeK1Documents] When true, excludes K1-extracted documents (DetectedFormType &#x3D;&#x3D; \&quot;K-1\&quot;) from results. Set automatically by the controller for Client role users — K1s are served via the K1 endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsGet(version: string, page?: number, limit?: number, sortBy?: string, sortOrder?: string, type?: DocumentType, binderId?: string, direction?: DocumentDirection, hasDocumentRequest?: boolean, category?: string, searchTerm?: string, isExported?: boolean, exportedAfter?: string, exportedBefore?: string, exportedById?: string, excludeK1Documents?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsGet(version, page, limit, sortBy, sortOrder, type, binderId, direction, hasDocumentRequest, category, searchTerm, isExported, exportedAfter, exportedBefore, exportedById, excludeK1Documents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Converts document files to PDF format using advanced document processing algorithms. This feature supports multiple input formats and provides options for compression, quality settings, and format optimization. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the document containing files to convert to PDF format.
         * @param {string} version 
         * @param {any} [body] Conversion configuration including quality settings, compression options, and output preferences.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdConvertToPdfPost(id: string, version: string, body?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdConvertToPdfPost(id, version, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdConvertToPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Permanently deletes a document from the system. Requires Admin role or document ownership. Enhanced for Issue #74 with authorization checks and RequiredDocument unlinking. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {string} id The unique identifier of the document to delete.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdDelete(id: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assigns a document to a document request, moves it to a different request, or detaches it from its current request (null DocumentRequestId). The target request must belong to the same binder as the document. The document\'s review state is never changed by a move. Staff only.
         * @param {string} id The unique identifier of the document to reassign.
         * @param {string} version 
         * @param {AssignDocumentToRequestDto} [assignDocumentToRequestDto] The target document request ID, or null to detach the document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdDocumentRequestPut(id: string, version: string, assignDocumentToRequestDto?: AssignDocumentToRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdDocumentRequestPut(id, version, assignDocumentToRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdDocumentRequestPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Downloads a complete document by returning a presigned URL for Azure storage or streaming for local storage. For Azure Blob Storage, returns a time-limited presigned URL with 1-hour expiration. For local storage or multi-file documents, falls back to file streaming.
         * @param {string} id The unique identifier of the document to download.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdDownloadGet(id: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDownloadUrlDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdDownloadGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the document must belong to that client. Supports AI-powered description generation which analyzes the added file to create intelligent descriptions.
         * @summary Adds additional files to an existing document. Requires Preparer or Admin role. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {string} id The unique identifier of the document to add files to.
         * @param {string} version 
         * @param {boolean} [generateAiDescription] Whether to generate AI-powered description for the updated document (default: true).
         * @param {File} [file] The file to add to the existing document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdFilesPost(id: string, version: string, generateAiDescription?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdFilesPost(id, version, generateAiDescription, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Retrieves detailed information about a specific document by its unique identifier. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client.
         * @param {string} id The unique identifier of the document to retrieve.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdGet(id: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Prepares a document for electronic signature by creating DocuSeal submission with signature fields and client details. Requires Preparer or Admin role for signature preparation.
         * @param {string} id The unique identifier of the document to prepare for signing.
         * @param {string} version 
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] Signature preparation details including client information, signature fields, and delivery options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdPrepareForSignaturePost(id: string, version: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureSubmissionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdPrepareForSignaturePost(id, version, singleDocumentSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdPrepareForSignaturePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates document properties including type, status, and user override for AI-detected form type.
         * @param {string} id The unique identifier of the document to update.
         * @param {string} version 
         * @param {UpdateDocumentDto} [updateDocumentDto] The update data with optional Type, Status, and UserOverrideFormType fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsIdPut(id: string, version: string, updateDocumentDto?: UpdateDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsIdPut(id, version, updateDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancels an active preprocessing operation and cleans up associated resources including temporary files and cached data. This operation cannot be undone and will terminate all preprocessing activities. Requires Preparer or Admin role.
         * @param {string} preprocessingId The unique identifier of the preprocessing operation to cancel and clean up.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsPreprocessingPreprocessingIdDelete(preprocessingId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsPreprocessingPreprocessingIdDelete(preprocessingId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsPreprocessingPreprocessingIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves comprehensive preprocessing results including document analysis, split recommendations, and signature field detection. Provides detailed status and results from document preprocessing operations. Requires Preparer or Admin role.
         * @param {string} preprocessingId The unique identifier of the preprocessing operation to retrieve detailed results for.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsPreprocessingPreprocessingIdGet(preprocessingId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreprocessingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsPreprocessingPreprocessingIdGet(preprocessingId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsPreprocessingPreprocessingIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generates an interactive preview of a PDF document with page thumbnails, bookmark detection, and grouping analysis. Requires Preparer or Admin role for document preview generation.
         * @param {string} version 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsPreviewPost(version: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPreviewResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsPreviewPost(version, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get documents awaiting review for a document request
         * @param {string} documentRequestId The document request ID
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(documentRequestId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(documentRequestId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Perform bulk review of multiple documents within a document request
         * @param {string} documentRequestId The document request ID
         * @param {string} version 
         * @param {BulkReviewDocumentsDto} [bulkReviewDocumentsDto] Bulk review actions for multiple documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(documentRequestId: string, version: string, bulkReviewDocumentsDto?: BulkReviewDocumentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(documentRequestId, version, bulkReviewDocumentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all documents associated with a specific document request
         * @param {string} documentRequestId The unique identifier of the document request
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(documentRequestId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(documentRequestId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsRequestDocumentRequestIdDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all available document types for upload with metadata for frontend selection.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsTypesGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsTypesGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
         * @summary Uploads one or more documents with specified type, binder, category (\"client\" or \"firm\"), optional comment, and optional e-signature template assignment. Requires Preparer or Admin role for document uploads. Supports frontend type strings (e.g., \"w2\", \"1099\") or direct DocumentType enum. Issue #74: Category field added for client vs firm document tracking. Issue #75: Comment field and virus scanning added for enhanced security. Enhanced for Issue #91 Phase 3.1: Validates binder belongs to active client when provided.
         * @param {string} version 
         * @param {Array<File>} files 
         * @param {string} binderId 
         * @param {string} [frontendType] Frontend document type string (e.g., \\\&quot;w2\\\&quot;, \\\&quot;1099\\\&quot;, \\\&quot;receipt\\\&quot;). If provided, takes precedence over Type field.
         * @param {DocumentType} [type] 
         * @param {string} [comment] Optional comment/note provided by the uploader about the document.
         * @param {string} [documentRequestId] 
         * @param {string} [signatureTemplateId] 
         * @param {boolean} [runAiDetection] 
         * @param {boolean} [generateAiDescription] Whether to generate AI-powered description for the document (default: true). If true, generates description from Azure Document Intelligence extracted data or falls back to Claude vision API.
         * @param {DocumentDirection} [direction] 
         * @param {boolean} [skipDuplicateCheck] When true, skips the SHA-256 duplicate-file check against existing binder files (both within the batch and against the binder). This is an opt-out honored for any authenticated caller of the upload endpoint; it is primarily intended for the signature-request upload flow, where re-sending an identical PDF is legitimate. Bypassing dedup only affects storage of duplicate content — it grants no additional access — so it is not gated on SignatureTemplateId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsUploadPost(version: string, files: Array<File>, binderId: string, frontendType?: string, type?: DocumentType, comment?: string, documentRequestId?: string, signatureTemplateId?: string, runAiDetection?: boolean, generateAiDescription?: boolean, direction?: DocumentDirection, skipDuplicateCheck?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsUploadPost(version, files, binderId, frontendType, type, comment, documentRequestId, signatureTemplateId, runAiDetection, generateAiDescription, direction, skipDuplicateCheck, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Uploads documents with intelligent page selection based on preview analysis, bookmark detection, and document splitting. This advanced workflow allows users to selectively upload specific pages or page ranges from a previewed document, with automatic e-signature template assignment and DocuSeal integration. Requires Client, Preparer, or Admin role.
         * @param {string} version 
         * @param {DocumentUploadWithPagesDto} [documentUploadWithPagesDto] Document upload configuration including selected page groups, split options, binder assignment, signature templates, and e-signature delivery preferences.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionDocumentsUploadWithPagesPost(version: string, documentUploadWithPagesDto?: DocumentUploadWithPagesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionDocumentsUploadWithPagesPost(version, documentUploadWithPagesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.apiVversionDocumentsUploadWithPagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentsApi - factory interface
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * This endpoint uses Azure Document Intelligence to: 1. Detect the form type on each page (W-2, 1099, 8879, state forms, etc.) 2. Identify page boundaries where form types change 3. Group consecutive pages of the same form type (respecting multi-page forms) 4. Generate suggested document names and types for each group              Use this endpoint to preview splitting suggestions before uploading. The frontend can display suggestions to users and allow them to accept, modify, or reject.              Confidence scoring: - High confidence (0.80+): Automatic splitting recommended - Medium confidence (0.60-0.79): Manual review suggested - Low confidence (below 0.60): Manual intervention required
         * @summary Analyzes a multi-page PDF for intelligent page splitting suggestions using Azure Document Intelligence. Detects form type changes across pages and recommends optimal page groupings for separate documents. This endpoint does not permanently upload the file - it only analyzes and returns suggestions. Requires Client, Preparer, or Admin role.
         * @param {DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsAnalyzeForSplittingPost(requestParameters: DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageSplittingResultDtoApiResponse> {
            return localVarFp.apiDocumentsAnalyzeForSplittingPost(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preprocesses a document with intelligent analysis including automatic splitting, signature field detection, and document structure recognition. This advanced preprocessing workflow prepares documents for optimized upload workflows and e-signature integration. Requires Preparer or Admin role.
         * @param {DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse> {
            return localVarFp.apiDocumentsBindersBinderIdPreprocessPost(requestParameters.binderId, requestParameters.file, requestParameters.autoSplit, requestParameters.detectSignatures, requestParameters.direction, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint performs a fast duplicate check (target: less than 2 seconds) without permanently uploading the file. Warnings are returned for files with similarity >= 0.70, but uploads are never blocked. Detection tiers: - Tier 1 (Fast): File hash, size, and filename comparison - Tier 2 (Medium): Form type and extracted data comparison - Tier 3 (Slow, fallback): AI-powered visual similarity analysis
         * @summary Checks for potential duplicate documents before uploading. Uses multi-tier detection: file hash, metadata similarity, and AI visual comparison.
         * @param {DocumentsApiApiDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsCheckDuplicatePost(requestParameters: DocumentsApiApiDocumentsCheckDuplicatePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateDetectionResultApiResponse> {
            return localVarFp.apiDocumentsCheckDuplicatePost(requestParameters.binderId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Classifies a document using AI to suggest appropriate categorization based on content analysis. Analyzes document content, detected form types, and extracted data to recommend document type and tags.
         * @param {DocumentsApiApiDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentClassificationResultApiResponse> {
            return localVarFp.apiDocumentsDocumentIdClassifyPost(requestParameters.documentId, requestParameters.autoApply, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extracts structured data from a single tax form document using Azure Document Intelligence. Supports W-2, 1099 series, and 1098 forms with prebuilt AI models. Extracted data is saved to the document\'s ExtractedDataJson field. Requires Preparer or Admin role.
         * @param {DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractedDataResultApiResponse> {
            return localVarFp.apiDocumentsDocumentIdExtractDataPost(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a specific file from a document while preserving the document structure. Requires Admin role.
         * @param {DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiDocumentsDocumentIdFilesFileIdDelete(requestParameters.documentId, requestParameters.fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reviews a document by approving or rejecting it with optional comment (Issue #74 - Document Review Workflow). This endpoint allows preparers to review client-uploaded documents and provide feedback. Requires Preparer or Admin role.
         * @param {DocumentsApiApiDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentReviewResultDtoApiResponse> {
            return localVarFp.apiDocumentsDocumentIdReviewPatch(requestParameters.documentId, requestParameters.reviewDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Review an individual document within a document request
         * @param {DocumentsApiApiDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiDocumentsDocumentIdReviewPost(requestParameters.documentId, requestParameters.reviewDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Triggers AI processing for a document (Admin only, for debugging/reprocessing).
         * @param {DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiDocumentsDocumentIdTriggerAiProcessingPost(requestParameters.documentId, requestParameters.runFormDetection, requestParameters.generateDescription, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extracts structured data from multiple tax form documents in batch. Processes all documents in an binder or a specified subset of document IDs. Only documents with supported form types (W-2, 1099, 1098) are processed. Requires Preparer or Admin role.
         * @param {DocumentsApiApiDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsExtractDataBatchPost(requestParameters: DocumentsApiApiDocumentsExtractDataBatchPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BatchExtractionResponseApiResponse> {
            return localVarFp.apiDocumentsExtractDataBatchPost(requestParameters.batchExtractionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client\'s documents. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client\'s documents.
         * @summary Retrieves a paginated list of documents with optional filtering, sorting, search, and client-specific access control. Supports filtering by direction (ReceivedFromClient vs SentToClient) to distinguish client-uploaded from preparer-generated documents. Supports search across filename, description, document type display names, and form types (detected/override). Enhanced for Issue #74: Supports category filter (\"client\" or \"firm\") with archive-based access control. Enhanced for Issue #91 Phase 3.1: Supports active client filtering for client role users.
         * @param {DocumentsApiApiDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsGet(requestParameters: DocumentsApiApiDocumentsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoPaginatedResponseApiResponse> {
            return localVarFp.apiDocumentsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.type, requestParameters.binderId, requestParameters.direction, requestParameters.hasDocumentRequest, requestParameters.category, requestParameters.searchTerm, requestParameters.isExported, requestParameters.exportedAfter, requestParameters.exportedBefore, requestParameters.exportedById, requestParameters.excludeK1Documents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Converts document files to PDF format using advanced document processing algorithms. This feature supports multiple input formats and provides options for compression, quality settings, and format optimization. Requires Preparer or Admin role.
         * @param {DocumentsApiApiDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiDocumentsIdConvertToPdfPost(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Permanently deletes a document from the system. Requires Admin role or document ownership. Enhanced for Issue #74 with authorization checks and RequiredDocument unlinking. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {DocumentsApiApiDocumentsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdDelete(requestParameters: DocumentsApiApiDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiDocumentsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assigns a document to a document request, moves it to a different request, or detaches it from its current request (null DocumentRequestId). The target request must belong to the same binder as the document. The document\'s review state is never changed by a move. Staff only.
         * @param {DocumentsApiApiDocumentsIdDocumentRequestPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdDocumentRequestPut(requestParameters: DocumentsApiApiDocumentsIdDocumentRequestPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiDocumentsIdDocumentRequestPut(requestParameters.id, requestParameters.assignDocumentToRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads a complete document by returning a presigned URL for Azure storage or streaming for local storage. For Azure Blob Storage, returns a time-limited presigned URL with 1-hour expiration. For local storage or multi-file documents, falls back to file streaming.
         * @param {DocumentsApiApiDocumentsIdDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdDownloadGet(requestParameters: DocumentsApiApiDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDownloadUrlDtoApiResponse> {
            return localVarFp.apiDocumentsIdDownloadGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the document must belong to that client. Supports AI-powered description generation which analyzes the added file to create intelligent descriptions.
         * @summary Adds additional files to an existing document. Requires Preparer or Admin role. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {DocumentsApiApiDocumentsIdFilesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdFilesPost(requestParameters: DocumentsApiApiDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiDocumentsIdFilesPost(requestParameters.id, requestParameters.generateAiDescription, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Retrieves detailed information about a specific document by its unique identifier. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client.
         * @param {DocumentsApiApiDocumentsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdGet(requestParameters: DocumentsApiApiDocumentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiDocumentsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prepares a document for electronic signature by creating DocuSeal submission with signature fields and client details. Requires Preparer or Admin role for signature preparation.
         * @param {DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse> {
            return localVarFp.apiDocumentsIdPrepareForSignaturePost(requestParameters.id, requestParameters.singleDocumentSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates document properties including type, status, and user override for AI-detected form type.
         * @param {DocumentsApiApiDocumentsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdPut(requestParameters: DocumentsApiApiDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiDocumentsIdPut(requestParameters.id, requestParameters.updateDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancels an active preprocessing operation and cleans up associated resources including temporary files and cached data. This operation cannot be undone and will terminate all preprocessing activities. Requires Preparer or Admin role.
         * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiDocumentsPreprocessingPreprocessingIdDelete(requestParameters.preprocessingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves comprehensive preprocessing results including document analysis, split recommendations, and signature field detection. Provides detailed status and results from document preprocessing operations. Requires Preparer or Admin role.
         * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse> {
            return localVarFp.apiDocumentsPreprocessingPreprocessingIdGet(requestParameters.preprocessingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates an interactive preview of a PDF document with page thumbnails, bookmark detection, and grouping analysis. Requires Preparer or Admin role for document preview generation.
         * @param {DocumentsApiApiDocumentsPreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsPreviewPost(requestParameters: DocumentsApiApiDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreviewResponseDtoApiResponse> {
            return localVarFp.apiDocumentsPreviewPost(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get documents awaiting review for a document request
         * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters.documentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Perform bulk review of multiple documents within a document request
         * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters.documentRequestId, requestParameters.bulkReviewDocumentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all documents associated with a specific document request
         * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters.documentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all available document types for upload with metadata for frontend selection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeDtoListApiResponse> {
            return localVarFp.apiDocumentsTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
         * @summary Uploads one or more documents with specified type, binder, category (\"client\" or \"firm\"), optional comment, and optional e-signature template assignment. Requires Preparer or Admin role for document uploads. Supports frontend type strings (e.g., \"w2\", \"1099\") or direct DocumentType enum. Issue #74: Category field added for client vs firm document tracking. Issue #75: Comment field and virus scanning added for enhanced security. Enhanced for Issue #91 Phase 3.1: Validates binder belongs to active client when provided.
         * @param {DocumentsApiApiDocumentsUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsUploadPost(requestParameters: DocumentsApiApiDocumentsUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse> {
            return localVarFp.apiDocumentsUploadPost(requestParameters.files, requestParameters.binderId, requestParameters.frontendType, requestParameters.type, requestParameters.comment, requestParameters.documentRequestId, requestParameters.signatureTemplateId, requestParameters.runAiDetection, requestParameters.generateAiDescription, requestParameters.direction, requestParameters.skipDuplicateCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads documents with intelligent page selection based on preview analysis, bookmark detection, and document splitting. This advanced workflow allows users to selectively upload specific pages or page ranges from a previewed document, with automatic e-signature template assignment and DocuSeal integration. Requires Client, Preparer, or Admin role.
         * @param {DocumentsApiApiDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsUploadWithPagesPost(requestParameters: DocumentsApiApiDocumentsUploadWithPagesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse> {
            return localVarFp.apiDocumentsUploadWithPagesPost(requestParameters.documentUploadWithPagesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint uses Azure Document Intelligence to: 1. Detect the form type on each page (W-2, 1099, 8879, state forms, etc.) 2. Identify page boundaries where form types change 3. Group consecutive pages of the same form type (respecting multi-page forms) 4. Generate suggested document names and types for each group              Use this endpoint to preview splitting suggestions before uploading. The frontend can display suggestions to users and allow them to accept, modify, or reject.              Confidence scoring: - High confidence (0.80+): Automatic splitting recommended - Medium confidence (0.60-0.79): Manual review suggested - Low confidence (below 0.60): Manual intervention required
         * @summary Analyzes a multi-page PDF for intelligent page splitting suggestions using Azure Document Intelligence. Detects form type changes across pages and recommends optimal page groupings for separate documents. This endpoint does not permanently upload the file - it only analyzes and returns suggestions. Requires Client, Preparer, or Admin role.
         * @param {DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsAnalyzeForSplittingPost(requestParameters: DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageSplittingResultDtoApiResponse> {
            return localVarFp.apiVversionDocumentsAnalyzeForSplittingPost(requestParameters.version, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preprocesses a document with intelligent analysis including automatic splitting, signature field detection, and document structure recognition. This advanced preprocessing workflow prepares documents for optimized upload workflows and e-signature integration. Requires Preparer or Admin role.
         * @param {DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse> {
            return localVarFp.apiVversionDocumentsBindersBinderIdPreprocessPost(requestParameters.binderId, requestParameters.version, requestParameters.file, requestParameters.autoSplit, requestParameters.detectSignatures, requestParameters.direction, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint performs a fast duplicate check (target: less than 2 seconds) without permanently uploading the file. Warnings are returned for files with similarity >= 0.70, but uploads are never blocked. Detection tiers: - Tier 1 (Fast): File hash, size, and filename comparison - Tier 2 (Medium): Form type and extracted data comparison - Tier 3 (Slow, fallback): AI-powered visual similarity analysis
         * @summary Checks for potential duplicate documents before uploading. Uses multi-tier detection: file hash, metadata similarity, and AI visual comparison.
         * @param {DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsCheckDuplicatePost(requestParameters: DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateDetectionResultApiResponse> {
            return localVarFp.apiVversionDocumentsCheckDuplicatePost(requestParameters.version, requestParameters.binderId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Classifies a document using AI to suggest appropriate categorization based on content analysis. Analyzes document content, detected form types, and extracted data to recommend document type and tags.
         * @param {DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentClassificationResultApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdClassifyPost(requestParameters.documentId, requestParameters.version, requestParameters.autoApply, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extracts structured data from a single tax form document using Azure Document Intelligence. Supports W-2, 1099 series, and 1098 forms with prebuilt AI models. Extracted data is saved to the document\'s ExtractedDataJson field. Requires Preparer or Admin role.
         * @param {DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractedDataResultApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdExtractDataPost(requestParameters.documentId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a specific file from a document while preserving the document structure. Requires Admin role.
         * @param {DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdFilesFileIdDelete(requestParameters.documentId, requestParameters.fileId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reviews a document by approving or rejecting it with optional comment (Issue #74 - Document Review Workflow). This endpoint allows preparers to review client-uploaded documents and provide feedback. Requires Preparer or Admin role.
         * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentReviewResultDtoApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdReviewPatch(requestParameters.documentId, requestParameters.version, requestParameters.reviewDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Review an individual document within a document request
         * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdReviewPost(requestParameters.documentId, requestParameters.version, requestParameters.reviewDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Triggers AI processing for a document (Admin only, for debugging/reprocessing).
         * @param {DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiVversionDocumentsDocumentIdTriggerAiProcessingPost(requestParameters.documentId, requestParameters.version, requestParameters.runFormDetection, requestParameters.generateDescription, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extracts structured data from multiple tax form documents in batch. Processes all documents in an binder or a specified subset of document IDs. Only documents with supported form types (W-2, 1099, 1098) are processed. Requires Preparer or Admin role.
         * @param {DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsExtractDataBatchPost(requestParameters: DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchExtractionResponseApiResponse> {
            return localVarFp.apiVversionDocumentsExtractDataBatchPost(requestParameters.version, requestParameters.batchExtractionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client\'s documents. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client\'s documents.
         * @summary Retrieves a paginated list of documents with optional filtering, sorting, search, and client-specific access control. Supports filtering by direction (ReceivedFromClient vs SentToClient) to distinguish client-uploaded from preparer-generated documents. Supports search across filename, description, document type display names, and form types (detected/override). Enhanced for Issue #74: Supports category filter (\"client\" or \"firm\") with archive-based access control. Enhanced for Issue #91 Phase 3.1: Supports active client filtering for client role users.
         * @param {DocumentsApiApiVversionDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoPaginatedResponseApiResponse> {
            return localVarFp.apiVversionDocumentsGet(requestParameters.version, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.type, requestParameters.binderId, requestParameters.direction, requestParameters.hasDocumentRequest, requestParameters.category, requestParameters.searchTerm, requestParameters.isExported, requestParameters.exportedAfter, requestParameters.exportedBefore, requestParameters.exportedById, requestParameters.excludeK1Documents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Converts document files to PDF format using advanced document processing algorithms. This feature supports multiple input formats and provides options for compression, quality settings, and format optimization. Requires Preparer or Admin role.
         * @param {DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiVversionDocumentsIdConvertToPdfPost(requestParameters.id, requestParameters.version, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Permanently deletes a document from the system. Requires Admin role or document ownership. Enhanced for Issue #74 with authorization checks and RequiredDocument unlinking. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {DocumentsApiApiVversionDocumentsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdDelete(requestParameters: DocumentsApiApiVversionDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiVversionDocumentsIdDelete(requestParameters.id, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assigns a document to a document request, moves it to a different request, or detaches it from its current request (null DocumentRequestId). The target request must belong to the same binder as the document. The document\'s review state is never changed by a move. Staff only.
         * @param {DocumentsApiApiVversionDocumentsIdDocumentRequestPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdDocumentRequestPut(requestParameters: DocumentsApiApiVversionDocumentsIdDocumentRequestPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdDocumentRequestPut(requestParameters.id, requestParameters.version, requestParameters.assignDocumentToRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads a complete document by returning a presigned URL for Azure storage or streaming for local storage. For Azure Blob Storage, returns a time-limited presigned URL with 1-hour expiration. For local storage or multi-file documents, falls back to file streaming.
         * @param {DocumentsApiApiVversionDocumentsIdDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdDownloadGet(requestParameters: DocumentsApiApiVversionDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDownloadUrlDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdDownloadGet(requestParameters.id, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the document must belong to that client. Supports AI-powered description generation which analyzes the added file to create intelligent descriptions.
         * @summary Adds additional files to an existing document. Requires Preparer or Admin role. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
         * @param {DocumentsApiApiVversionDocumentsIdFilesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdFilesPost(requestParameters: DocumentsApiApiVversionDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdFilesPost(requestParameters.id, requestParameters.version, requestParameters.generateAiDescription, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
         * @summary Retrieves detailed information about a specific document by its unique identifier. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client.
         * @param {DocumentsApiApiVversionDocumentsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdGet(requestParameters: DocumentsApiApiVversionDocumentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdGet(requestParameters.id, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prepares a document for electronic signature by creating DocuSeal submission with signature fields and client details. Requires Preparer or Admin role for signature preparation.
         * @param {DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdPrepareForSignaturePost(requestParameters.id, requestParameters.version, requestParameters.singleDocumentSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates document properties including type, status, and user override for AI-detected form type.
         * @param {DocumentsApiApiVversionDocumentsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsIdPut(requestParameters: DocumentsApiApiVversionDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse> {
            return localVarFp.apiVversionDocumentsIdPut(requestParameters.id, requestParameters.version, requestParameters.updateDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancels an active preprocessing operation and cleans up associated resources including temporary files and cached data. This operation cannot be undone and will terminate all preprocessing activities. Requires Preparer or Admin role.
         * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiVversionDocumentsPreprocessingPreprocessingIdDelete(requestParameters.preprocessingId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves comprehensive preprocessing results including document analysis, split recommendations, and signature field detection. Provides detailed status and results from document preprocessing operations. Requires Preparer or Admin role.
         * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse> {
            return localVarFp.apiVversionDocumentsPreprocessingPreprocessingIdGet(requestParameters.preprocessingId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates an interactive preview of a PDF document with page thumbnails, bookmark detection, and grouping analysis. Requires Preparer or Admin role for document preview generation.
         * @param {DocumentsApiApiVversionDocumentsPreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsPreviewPost(requestParameters: DocumentsApiApiVversionDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreviewResponseDtoApiResponse> {
            return localVarFp.apiVversionDocumentsPreviewPost(requestParameters.version, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get documents awaiting review for a document request
         * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters.documentRequestId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Perform bulk review of multiple documents within a document request
         * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters.documentRequestId, requestParameters.version, requestParameters.bulkReviewDocumentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all documents associated with a specific document request
         * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse> {
            return localVarFp.apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters.documentRequestId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all available document types for upload with metadata for frontend selection.
         * @param {DocumentsApiApiVversionDocumentsTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsTypesGet(requestParameters: DocumentsApiApiVversionDocumentsTypesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeDtoListApiResponse> {
            return localVarFp.apiVversionDocumentsTypesGet(requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
         * @summary Uploads one or more documents with specified type, binder, category (\"client\" or \"firm\"), optional comment, and optional e-signature template assignment. Requires Preparer or Admin role for document uploads. Supports frontend type strings (e.g., \"w2\", \"1099\") or direct DocumentType enum. Issue #74: Category field added for client vs firm document tracking. Issue #75: Comment field and virus scanning added for enhanced security. Enhanced for Issue #91 Phase 3.1: Validates binder belongs to active client when provided.
         * @param {DocumentsApiApiVversionDocumentsUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsUploadPost(requestParameters: DocumentsApiApiVversionDocumentsUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse> {
            return localVarFp.apiVversionDocumentsUploadPost(requestParameters.version, requestParameters.files, requestParameters.binderId, requestParameters.frontendType, requestParameters.type, requestParameters.comment, requestParameters.documentRequestId, requestParameters.signatureTemplateId, requestParameters.runAiDetection, requestParameters.generateAiDescription, requestParameters.direction, requestParameters.skipDuplicateCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads documents with intelligent page selection based on preview analysis, bookmark detection, and document splitting. This advanced workflow allows users to selectively upload specific pages or page ranges from a previewed document, with automatic e-signature template assignment and DocuSeal integration. Requires Client, Preparer, or Admin role.
         * @param {DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionDocumentsUploadWithPagesPost(requestParameters: DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse> {
            return localVarFp.apiVversionDocumentsUploadWithPagesPost(requestParameters.version, requestParameters.documentUploadWithPagesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - interface
 */
export interface DocumentsApiInterface {
    /**
     * This endpoint uses Azure Document Intelligence to: 1. Detect the form type on each page (W-2, 1099, 8879, state forms, etc.) 2. Identify page boundaries where form types change 3. Group consecutive pages of the same form type (respecting multi-page forms) 4. Generate suggested document names and types for each group              Use this endpoint to preview splitting suggestions before uploading. The frontend can display suggestions to users and allow them to accept, modify, or reject.              Confidence scoring: - High confidence (0.80+): Automatic splitting recommended - Medium confidence (0.60-0.79): Manual review suggested - Low confidence (below 0.60): Manual intervention required
     * @summary Analyzes a multi-page PDF for intelligent page splitting suggestions using Azure Document Intelligence. Detects form type changes across pages and recommends optimal page groupings for separate documents. This endpoint does not permanently upload the file - it only analyzes and returns suggestions. Requires Client, Preparer, or Admin role.
     * @param {DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsAnalyzeForSplittingPost(requestParameters?: DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageSplittingResultDtoApiResponse>;

    /**
     * 
     * @summary Preprocesses a document with intelligent analysis including automatic splitting, signature field detection, and document structure recognition. This advanced preprocessing workflow prepares documents for optimized upload workflows and e-signature integration. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse>;

    /**
     * This endpoint performs a fast duplicate check (target: less than 2 seconds) without permanently uploading the file. Warnings are returned for files with similarity >= 0.70, but uploads are never blocked. Detection tiers: - Tier 1 (Fast): File hash, size, and filename comparison - Tier 2 (Medium): Form type and extracted data comparison - Tier 3 (Slow, fallback): AI-powered visual similarity analysis
     * @summary Checks for potential duplicate documents before uploading. Uses multi-tier detection: file hash, metadata similarity, and AI visual comparison.
     * @param {DocumentsApiApiDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsCheckDuplicatePost(requestParameters?: DocumentsApiApiDocumentsCheckDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateDetectionResultApiResponse>;

    /**
     * 
     * @summary Classifies a document using AI to suggest appropriate categorization based on content analysis. Analyzes document content, detected form types, and extracted data to recommend document type and tags.
     * @param {DocumentsApiApiDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentClassificationResultApiResponse>;

    /**
     * 
     * @summary Extracts structured data from a single tax form document using Azure Document Intelligence. Supports W-2, 1099 series, and 1098 forms with prebuilt AI models. Extracted data is saved to the document\'s ExtractedDataJson field. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractedDataResultApiResponse>;

    /**
     * 
     * @summary Deletes a specific file from a document while preserving the document structure. Requires Admin role.
     * @param {DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Reviews a document by approving or rejecting it with optional comment (Issue #74 - Document Review Workflow). This endpoint allows preparers to review client-uploaded documents and provide feedback. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentReviewResultDtoApiResponse>;

    /**
     * 
     * @summary Review an individual document within a document request
     * @param {DocumentsApiApiDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @summary Triggers AI processing for a document (Admin only, for debugging/reprocessing).
     * @param {DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @summary Extracts structured data from multiple tax form documents in batch. Processes all documents in an binder or a specified subset of document IDs. Only documents with supported form types (W-2, 1099, 1098) are processed. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsExtractDataBatchPost(requestParameters?: DocumentsApiApiDocumentsExtractDataBatchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchExtractionResponseApiResponse>;

    /**
     * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client\'s documents. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client\'s documents.
     * @summary Retrieves a paginated list of documents with optional filtering, sorting, search, and client-specific access control. Supports filtering by direction (ReceivedFromClient vs SentToClient) to distinguish client-uploaded from preparer-generated documents. Supports search across filename, description, document type display names, and form types (detected/override). Enhanced for Issue #74: Supports category filter (\"client\" or \"firm\") with archive-based access control. Enhanced for Issue #91 Phase 3.1: Supports active client filtering for client role users.
     * @param {DocumentsApiApiDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsGet(requestParameters?: DocumentsApiApiDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Converts document files to PDF format using advanced document processing algorithms. This feature supports multiple input formats and provides options for compression, quality settings, and format optimization. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
     * @summary Permanently deletes a document from the system. Requires Admin role or document ownership. Enhanced for Issue #74 with authorization checks and RequiredDocument unlinking. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
     * @param {DocumentsApiApiDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdDelete(requestParameters: DocumentsApiApiDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Assigns a document to a document request, moves it to a different request, or detaches it from its current request (null DocumentRequestId). The target request must belong to the same binder as the document. The document\'s review state is never changed by a move. Staff only.
     * @param {DocumentsApiApiDocumentsIdDocumentRequestPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdDocumentRequestPut(requestParameters: DocumentsApiApiDocumentsIdDocumentRequestPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @summary Downloads a complete document by returning a presigned URL for Azure storage or streaming for local storage. For Azure Blob Storage, returns a time-limited presigned URL with 1-hour expiration. For local storage or multi-file documents, falls back to file streaming.
     * @param {DocumentsApiApiDocumentsIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdDownloadGet(requestParameters: DocumentsApiApiDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDownloadUrlDtoApiResponse>;

    /**
     * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the document must belong to that client. Supports AI-powered description generation which analyzes the added file to create intelligent descriptions.
     * @summary Adds additional files to an existing document. Requires Preparer or Admin role. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
     * @param {DocumentsApiApiDocumentsIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdFilesPost(requestParameters: DocumentsApiApiDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
     * @summary Retrieves detailed information about a specific document by its unique identifier. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client.
     * @param {DocumentsApiApiDocumentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdGet(requestParameters: DocumentsApiApiDocumentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @summary Prepares a document for electronic signature by creating DocuSeal submission with signature fields and client details. Requires Preparer or Admin role for signature preparation.
     * @param {DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse>;

    /**
     * 
     * @summary Updates document properties including type, status, and user override for AI-detected form type.
     * @param {DocumentsApiApiDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsIdPut(requestParameters: DocumentsApiApiDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @summary Cancels an active preprocessing operation and cleans up associated resources including temporary files and cached data. This operation cannot be undone and will terminate all preprocessing activities. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Retrieves comprehensive preprocessing results including document analysis, split recommendations, and signature field detection. Provides detailed status and results from document preprocessing operations. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse>;

    /**
     * 
     * @summary Generates an interactive preview of a PDF document with page thumbnails, bookmark detection, and grouping analysis. Requires Preparer or Admin role for document preview generation.
     * @param {DocumentsApiApiDocumentsPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsPreviewPost(requestParameters: DocumentsApiApiDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreviewResponseDtoApiResponse>;

    /**
     * 
     * @summary Get documents awaiting review for a document request
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @summary Perform bulk review of multiple documents within a document request
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all documents associated with a specific document request
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @summary Gets all available document types for upload with metadata for frontend selection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeDtoListApiResponse>;

    /**
     * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
     * @summary Uploads one or more documents with specified type, binder, category (\"client\" or \"firm\"), optional comment, and optional e-signature template assignment. Requires Preparer or Admin role for document uploads. Supports frontend type strings (e.g., \"w2\", \"1099\") or direct DocumentType enum. Issue #74: Category field added for client vs firm document tracking. Issue #75: Comment field and virus scanning added for enhanced security. Enhanced for Issue #91 Phase 3.1: Validates binder belongs to active client when provided.
     * @param {DocumentsApiApiDocumentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsUploadPost(requestParameters: DocumentsApiApiDocumentsUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse>;

    /**
     * 
     * @summary Uploads documents with intelligent page selection based on preview analysis, bookmark detection, and document splitting. This advanced workflow allows users to selectively upload specific pages or page ranges from a previewed document, with automatic e-signature template assignment and DocuSeal integration. Requires Client, Preparer, or Admin role.
     * @param {DocumentsApiApiDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentsUploadWithPagesPost(requestParameters?: DocumentsApiApiDocumentsUploadWithPagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse>;

    /**
     * This endpoint uses Azure Document Intelligence to: 1. Detect the form type on each page (W-2, 1099, 8879, state forms, etc.) 2. Identify page boundaries where form types change 3. Group consecutive pages of the same form type (respecting multi-page forms) 4. Generate suggested document names and types for each group              Use this endpoint to preview splitting suggestions before uploading. The frontend can display suggestions to users and allow them to accept, modify, or reject.              Confidence scoring: - High confidence (0.80+): Automatic splitting recommended - Medium confidence (0.60-0.79): Manual review suggested - Low confidence (below 0.60): Manual intervention required
     * @summary Analyzes a multi-page PDF for intelligent page splitting suggestions using Azure Document Intelligence. Detects form type changes across pages and recommends optimal page groupings for separate documents. This endpoint does not permanently upload the file - it only analyzes and returns suggestions. Requires Client, Preparer, or Admin role.
     * @param {DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsAnalyzeForSplittingPost(requestParameters: DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageSplittingResultDtoApiResponse>;

    /**
     * 
     * @summary Preprocesses a document with intelligent analysis including automatic splitting, signature field detection, and document structure recognition. This advanced preprocessing workflow prepares documents for optimized upload workflows and e-signature integration. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse>;

    /**
     * This endpoint performs a fast duplicate check (target: less than 2 seconds) without permanently uploading the file. Warnings are returned for files with similarity >= 0.70, but uploads are never blocked. Detection tiers: - Tier 1 (Fast): File hash, size, and filename comparison - Tier 2 (Medium): Form type and extracted data comparison - Tier 3 (Slow, fallback): AI-powered visual similarity analysis
     * @summary Checks for potential duplicate documents before uploading. Uses multi-tier detection: file hash, metadata similarity, and AI visual comparison.
     * @param {DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsCheckDuplicatePost(requestParameters: DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateDetectionResultApiResponse>;

    /**
     * 
     * @summary Classifies a document using AI to suggest appropriate categorization based on content analysis. Analyzes document content, detected form types, and extracted data to recommend document type and tags.
     * @param {DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentClassificationResultApiResponse>;

    /**
     * 
     * @summary Extracts structured data from a single tax form document using Azure Document Intelligence. Supports W-2, 1099 series, and 1098 forms with prebuilt AI models. Extracted data is saved to the document\'s ExtractedDataJson field. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractedDataResultApiResponse>;

    /**
     * 
     * @summary Deletes a specific file from a document while preserving the document structure. Requires Admin role.
     * @param {DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Reviews a document by approving or rejecting it with optional comment (Issue #74 - Document Review Workflow). This endpoint allows preparers to review client-uploaded documents and provide feedback. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentReviewResultDtoApiResponse>;

    /**
     * 
     * @summary Review an individual document within a document request
     * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @summary Triggers AI processing for a document (Admin only, for debugging/reprocessing).
     * @param {DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @summary Extracts structured data from multiple tax form documents in batch. Processes all documents in an binder or a specified subset of document IDs. Only documents with supported form types (W-2, 1099, 1098) are processed. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsExtractDataBatchPost(requestParameters: DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchExtractionResponseApiResponse>;

    /**
     * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client\'s documents. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client\'s documents.
     * @summary Retrieves a paginated list of documents with optional filtering, sorting, search, and client-specific access control. Supports filtering by direction (ReceivedFromClient vs SentToClient) to distinguish client-uploaded from preparer-generated documents. Supports search across filename, description, document type display names, and form types (detected/override). Enhanced for Issue #74: Supports category filter (\"client\" or \"firm\") with archive-based access control. Enhanced for Issue #91 Phase 3.1: Supports active client filtering for client role users.
     * @param {DocumentsApiApiVversionDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Converts document files to PDF format using advanced document processing algorithms. This feature supports multiple input formats and provides options for compression, quality settings, and format optimization. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
     * @summary Permanently deletes a document from the system. Requires Admin role or document ownership. Enhanced for Issue #74 with authorization checks and RequiredDocument unlinking. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
     * @param {DocumentsApiApiVversionDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdDelete(requestParameters: DocumentsApiApiVversionDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Assigns a document to a document request, moves it to a different request, or detaches it from its current request (null DocumentRequestId). The target request must belong to the same binder as the document. The document\'s review state is never changed by a move. Staff only.
     * @param {DocumentsApiApiVversionDocumentsIdDocumentRequestPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdDocumentRequestPut(requestParameters: DocumentsApiApiVversionDocumentsIdDocumentRequestPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @summary Downloads a complete document by returning a presigned URL for Azure storage or streaming for local storage. For Azure Blob Storage, returns a time-limited presigned URL with 1-hour expiration. For local storage or multi-file documents, falls back to file streaming.
     * @param {DocumentsApiApiVversionDocumentsIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdDownloadGet(requestParameters: DocumentsApiApiVversionDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDownloadUrlDtoApiResponse>;

    /**
     * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the document must belong to that client. Supports AI-powered description generation which analyzes the added file to create intelligent descriptions.
     * @summary Adds additional files to an existing document. Requires Preparer or Admin role. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
     * @param {DocumentsApiApiVversionDocumentsIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdFilesPost(requestParameters: DocumentsApiApiVversionDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
     * @summary Retrieves detailed information about a specific document by its unique identifier. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client.
     * @param {DocumentsApiApiVversionDocumentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdGet(requestParameters: DocumentsApiApiVversionDocumentsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @summary Prepares a document for electronic signature by creating DocuSeal submission with signature fields and client details. Requires Preparer or Admin role for signature preparation.
     * @param {DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse>;

    /**
     * 
     * @summary Updates document properties including type, status, and user override for AI-detected form type.
     * @param {DocumentsApiApiVversionDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsIdPut(requestParameters: DocumentsApiApiVversionDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoApiResponse>;

    /**
     * 
     * @summary Cancels an active preprocessing operation and cleans up associated resources including temporary files and cached data. This operation cannot be undone and will terminate all preprocessing activities. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Retrieves comprehensive preprocessing results including document analysis, split recommendations, and signature field detection. Provides detailed status and results from document preprocessing operations. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreprocessingDtoApiResponse>;

    /**
     * 
     * @summary Generates an interactive preview of a PDF document with page thumbnails, bookmark detection, and grouping analysis. Requires Preparer or Admin role for document preview generation.
     * @param {DocumentsApiApiVversionDocumentsPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsPreviewPost(requestParameters: DocumentsApiApiVversionDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPreviewResponseDtoApiResponse>;

    /**
     * 
     * @summary Get documents awaiting review for a document request
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @summary Perform bulk review of multiple documents within a document request
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all documents associated with a specific document request
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoListApiResponse>;

    /**
     * 
     * @summary Gets all available document types for upload with metadata for frontend selection.
     * @param {DocumentsApiApiVversionDocumentsTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsTypesGet(requestParameters: DocumentsApiApiVversionDocumentsTypesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentTypeDtoListApiResponse>;

    /**
     * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
     * @summary Uploads one or more documents with specified type, binder, category (\"client\" or \"firm\"), optional comment, and optional e-signature template assignment. Requires Preparer or Admin role for document uploads. Supports frontend type strings (e.g., \"w2\", \"1099\") or direct DocumentType enum. Issue #74: Category field added for client vs firm document tracking. Issue #75: Comment field and virus scanning added for enhanced security. Enhanced for Issue #91 Phase 3.1: Validates binder belongs to active client when provided.
     * @param {DocumentsApiApiVversionDocumentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsUploadPost(requestParameters: DocumentsApiApiVversionDocumentsUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadResponseDtoApiResponse>;

    /**
     * 
     * @summary Uploads documents with intelligent page selection based on preview analysis, bookmark detection, and document splitting. This advanced workflow allows users to selectively upload specific pages or page ranges from a previewed document, with automatic e-signature template assignment and DocuSeal integration. Requires Client, Preparer, or Admin role.
     * @param {DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVversionDocumentsUploadWithPagesPost(requestParameters: DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentUploadWithPagesResponseDtoApiResponse>;

}

/**
 * Request parameters for apiDocumentsAnalyzeForSplittingPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest {
    /**
     * PDF file to analyze for splitting suggestions
     */
    readonly file?: File
}

/**
 * Request parameters for apiDocumentsBindersBinderIdPreprocessPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest {
    /**
     * The unique identifier of the binder to associate with preprocessing results and document categorization.
     */
    readonly binderId: string

    readonly file: File

    readonly autoSplit?: boolean

    readonly detectSignatures?: boolean

    readonly direction?: DocumentDirection
}

/**
 * Request parameters for apiDocumentsCheckDuplicatePost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsCheckDuplicatePostRequest {
    /**
     * ID of the binder to check within
     */
    readonly binderId?: string

    /**
     * File to check for duplicates
     */
    readonly file?: File
}

/**
 * Request parameters for apiDocumentsDocumentIdClassifyPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdClassifyPostRequest {
    /**
     * ID of the document to classify
     */
    readonly documentId: string

    /**
     * Automatically apply suggestions if confidence &gt;&#x3D; 0.80 (default: false)
     */
    readonly autoApply?: boolean
}

/**
 * Request parameters for apiDocumentsDocumentIdExtractDataPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest {
    /**
     * The unique identifier of the document to extract data from.
     */
    readonly documentId: string
}

/**
 * Request parameters for apiDocumentsDocumentIdFilesFileIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest {
    /**
     * The unique identifier of the document containing the file.
     */
    readonly documentId: string

    /**
     * The unique identifier of the file to delete.
     */
    readonly fileId: string
}

/**
 * Request parameters for apiDocumentsDocumentIdReviewPatch operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdReviewPatchRequest {
    /**
     * The unique identifier of the document to review.
     */
    readonly documentId: string

    /**
     * Review request containing status (approved/rejected) and optional comment.
     */
    readonly reviewDocumentRequest?: ReviewDocumentRequest
}

/**
 * Request parameters for apiDocumentsDocumentIdReviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdReviewPostRequest {
    /**
     * The document ID to review
     */
    readonly documentId: string

    /**
     * Review action and details
     */
    readonly reviewDocumentDto?: ReviewDocumentDto
}

/**
 * Request parameters for apiDocumentsDocumentIdTriggerAiProcessingPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest {
    /**
     * ID of the document to process
     */
    readonly documentId: string

    /**
     * Whether to run form detection (default: true)
     */
    readonly runFormDetection?: boolean

    /**
     * Whether to generate AI description (default: true)
     */
    readonly generateDescription?: boolean
}

/**
 * Request parameters for apiDocumentsExtractDataBatchPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsExtractDataBatchPostRequest {
    /**
     * Batch extraction request containing binder ID and optional document ID filter.
     */
    readonly batchExtractionRequest?: BatchExtractionRequest
}

/**
 * Request parameters for apiDocumentsGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsGetRequest {
    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly type?: DocumentType

    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId?: string

    readonly direction?: DocumentDirection

    /**
     * Filter by document-request assignment: true returns only documents attached to a document request, false returns only unattached documents.
     */
    readonly hasDocumentRequest?: boolean

    readonly category?: string

    /**
     * Search term for filtering documents across multiple fields. Minimum length: 2 characters. Maximum length: 200 characters.
     */
    readonly searchTerm?: string

    readonly isExported?: boolean

    readonly exportedAfter?: string

    readonly exportedBefore?: string

    readonly exportedById?: string

    /**
     * When true, excludes K1-extracted documents (DetectedFormType &#x3D;&#x3D; \&quot;K-1\&quot;) from results. Set automatically by the controller for Client role users — K1s are served via the K1 endpoint.
     */
    readonly excludeK1Documents?: boolean
}

/**
 * Request parameters for apiDocumentsIdConvertToPdfPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdConvertToPdfPostRequest {
    /**
     * The unique identifier of the document containing files to convert to PDF format.
     */
    readonly id: string

    /**
     * Conversion configuration including quality settings, compression options, and output preferences.
     */
    readonly body?: any
}

/**
 * Request parameters for apiDocumentsIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdDeleteRequest {
    /**
     * The unique identifier of the document to delete.
     */
    readonly id: string
}

/**
 * Request parameters for apiDocumentsIdDocumentRequestPut operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdDocumentRequestPutRequest {
    /**
     * The unique identifier of the document to reassign.
     */
    readonly id: string

    /**
     * The target document request ID, or null to detach the document.
     */
    readonly assignDocumentToRequestDto?: AssignDocumentToRequestDto
}

/**
 * Request parameters for apiDocumentsIdDownloadGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdDownloadGetRequest {
    /**
     * The unique identifier of the document to download.
     */
    readonly id: string
}

/**
 * Request parameters for apiDocumentsIdFilesPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdFilesPostRequest {
    /**
     * The unique identifier of the document to add files to.
     */
    readonly id: string

    /**
     * Whether to generate AI-powered description for the updated document (default: true).
     */
    readonly generateAiDescription?: boolean

    /**
     * The file to add to the existing document.
     */
    readonly file?: File
}

/**
 * Request parameters for apiDocumentsIdGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdGetRequest {
    /**
     * The unique identifier of the document to retrieve.
     */
    readonly id: string
}

/**
 * Request parameters for apiDocumentsIdPrepareForSignaturePost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest {
    /**
     * The unique identifier of the document to prepare for signing.
     */
    readonly id: string

    /**
     * Signature preparation details including client information, signature fields, and delivery options.
     */
    readonly singleDocumentSignatureDto?: SingleDocumentSignatureDto
}

/**
 * Request parameters for apiDocumentsIdPut operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsIdPutRequest {
    /**
     * The unique identifier of the document to update.
     */
    readonly id: string

    /**
     * The update data with optional Type, Status, and UserOverrideFormType fields.
     */
    readonly updateDocumentDto?: UpdateDocumentDto
}

/**
 * Request parameters for apiDocumentsPreprocessingPreprocessingIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest {
    /**
     * The unique identifier of the preprocessing operation to cancel and clean up.
     */
    readonly preprocessingId: string
}

/**
 * Request parameters for apiDocumentsPreprocessingPreprocessingIdGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest {
    /**
     * The unique identifier of the preprocessing operation to retrieve detailed results for.
     */
    readonly preprocessingId: string
}

/**
 * Request parameters for apiDocumentsPreviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsPreviewPostRequest {
    readonly file: File
}

/**
 * Request parameters for apiDocumentsRequestDocumentRequestIdAwaitingReviewGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest {
    /**
     * The document request ID
     */
    readonly documentRequestId: string
}

/**
 * Request parameters for apiDocumentsRequestDocumentRequestIdBulkReviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest {
    /**
     * The document request ID
     */
    readonly documentRequestId: string

    /**
     * Bulk review actions for multiple documents
     */
    readonly bulkReviewDocumentsDto?: BulkReviewDocumentsDto
}

/**
 * Request parameters for apiDocumentsRequestDocumentRequestIdDocumentsGet operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest {
    /**
     * The unique identifier of the document request
     */
    readonly documentRequestId: string
}

/**
 * Request parameters for apiDocumentsUploadPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsUploadPostRequest {
    readonly files: Array<File>

    readonly binderId: string

    /**
     * Frontend document type string (e.g., \\\&quot;w2\\\&quot;, \\\&quot;1099\\\&quot;, \\\&quot;receipt\\\&quot;). If provided, takes precedence over Type field.
     */
    readonly frontendType?: string

    readonly type?: DocumentType

    /**
     * Optional comment/note provided by the uploader about the document.
     */
    readonly comment?: string

    readonly documentRequestId?: string

    readonly signatureTemplateId?: string

    readonly runAiDetection?: boolean

    /**
     * Whether to generate AI-powered description for the document (default: true). If true, generates description from Azure Document Intelligence extracted data or falls back to Claude vision API.
     */
    readonly generateAiDescription?: boolean

    readonly direction?: DocumentDirection

    /**
     * When true, skips the SHA-256 duplicate-file check against existing binder files (both within the batch and against the binder). This is an opt-out honored for any authenticated caller of the upload endpoint; it is primarily intended for the signature-request upload flow, where re-sending an identical PDF is legitimate. Bypassing dedup only affects storage of duplicate content — it grants no additional access — so it is not gated on SignatureTemplateId.
     */
    readonly skipDuplicateCheck?: boolean
}

/**
 * Request parameters for apiDocumentsUploadWithPagesPost operation in DocumentsApi.
 */
export interface DocumentsApiApiDocumentsUploadWithPagesPostRequest {
    /**
     * Document upload configuration including selected page groups, split options, binder assignment, signature templates, and e-signature delivery preferences.
     */
    readonly documentUploadWithPagesDto?: DocumentUploadWithPagesDto
}

/**
 * Request parameters for apiVversionDocumentsAnalyzeForSplittingPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest {
    readonly version: string

    /**
     * PDF file to analyze for splitting suggestions
     */
    readonly file?: File
}

/**
 * Request parameters for apiVversionDocumentsBindersBinderIdPreprocessPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest {
    /**
     * The unique identifier of the binder to associate with preprocessing results and document categorization.
     */
    readonly binderId: string

    readonly version: string

    readonly file: File

    readonly autoSplit?: boolean

    readonly detectSignatures?: boolean

    readonly direction?: DocumentDirection
}

/**
 * Request parameters for apiVversionDocumentsCheckDuplicatePost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest {
    readonly version: string

    /**
     * ID of the binder to check within
     */
    readonly binderId?: string

    /**
     * File to check for duplicates
     */
    readonly file?: File
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdClassifyPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest {
    /**
     * ID of the document to classify
     */
    readonly documentId: string

    readonly version: string

    /**
     * Automatically apply suggestions if confidence &gt;&#x3D; 0.80 (default: false)
     */
    readonly autoApply?: boolean
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdExtractDataPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest {
    /**
     * The unique identifier of the document to extract data from.
     */
    readonly documentId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdFilesFileIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest {
    /**
     * The unique identifier of the document containing the file.
     */
    readonly documentId: string

    /**
     * The unique identifier of the file to delete.
     */
    readonly fileId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdReviewPatch operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest {
    /**
     * The unique identifier of the document to review.
     */
    readonly documentId: string

    readonly version: string

    /**
     * Review request containing status (approved/rejected) and optional comment.
     */
    readonly reviewDocumentRequest?: ReviewDocumentRequest
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdReviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest {
    /**
     * The document ID to review
     */
    readonly documentId: string

    readonly version: string

    /**
     * Review action and details
     */
    readonly reviewDocumentDto?: ReviewDocumentDto
}

/**
 * Request parameters for apiVversionDocumentsDocumentIdTriggerAiProcessingPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest {
    /**
     * ID of the document to process
     */
    readonly documentId: string

    readonly version: string

    /**
     * Whether to run form detection (default: true)
     */
    readonly runFormDetection?: boolean

    /**
     * Whether to generate AI description (default: true)
     */
    readonly generateDescription?: boolean
}

/**
 * Request parameters for apiVversionDocumentsExtractDataBatchPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest {
    readonly version: string

    /**
     * Batch extraction request containing binder ID and optional document ID filter.
     */
    readonly batchExtractionRequest?: BatchExtractionRequest
}

/**
 * Request parameters for apiVversionDocumentsGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsGetRequest {
    readonly version: string

    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly type?: DocumentType

    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId?: string

    readonly direction?: DocumentDirection

    /**
     * Filter by document-request assignment: true returns only documents attached to a document request, false returns only unattached documents.
     */
    readonly hasDocumentRequest?: boolean

    readonly category?: string

    /**
     * Search term for filtering documents across multiple fields. Minimum length: 2 characters. Maximum length: 200 characters.
     */
    readonly searchTerm?: string

    readonly isExported?: boolean

    readonly exportedAfter?: string

    readonly exportedBefore?: string

    readonly exportedById?: string

    /**
     * When true, excludes K1-extracted documents (DetectedFormType &#x3D;&#x3D; \&quot;K-1\&quot;) from results. Set automatically by the controller for Client role users — K1s are served via the K1 endpoint.
     */
    readonly excludeK1Documents?: boolean
}

/**
 * Request parameters for apiVversionDocumentsIdConvertToPdfPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest {
    /**
     * The unique identifier of the document containing files to convert to PDF format.
     */
    readonly id: string

    readonly version: string

    /**
     * Conversion configuration including quality settings, compression options, and output preferences.
     */
    readonly body?: any
}

/**
 * Request parameters for apiVversionDocumentsIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdDeleteRequest {
    /**
     * The unique identifier of the document to delete.
     */
    readonly id: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsIdDocumentRequestPut operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdDocumentRequestPutRequest {
    /**
     * The unique identifier of the document to reassign.
     */
    readonly id: string

    readonly version: string

    /**
     * The target document request ID, or null to detach the document.
     */
    readonly assignDocumentToRequestDto?: AssignDocumentToRequestDto
}

/**
 * Request parameters for apiVversionDocumentsIdDownloadGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdDownloadGetRequest {
    /**
     * The unique identifier of the document to download.
     */
    readonly id: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsIdFilesPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdFilesPostRequest {
    /**
     * The unique identifier of the document to add files to.
     */
    readonly id: string

    readonly version: string

    /**
     * Whether to generate AI-powered description for the updated document (default: true).
     */
    readonly generateAiDescription?: boolean

    /**
     * The file to add to the existing document.
     */
    readonly file?: File
}

/**
 * Request parameters for apiVversionDocumentsIdGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdGetRequest {
    /**
     * The unique identifier of the document to retrieve.
     */
    readonly id: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsIdPrepareForSignaturePost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest {
    /**
     * The unique identifier of the document to prepare for signing.
     */
    readonly id: string

    readonly version: string

    /**
     * Signature preparation details including client information, signature fields, and delivery options.
     */
    readonly singleDocumentSignatureDto?: SingleDocumentSignatureDto
}

/**
 * Request parameters for apiVversionDocumentsIdPut operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsIdPutRequest {
    /**
     * The unique identifier of the document to update.
     */
    readonly id: string

    readonly version: string

    /**
     * The update data with optional Type, Status, and UserOverrideFormType fields.
     */
    readonly updateDocumentDto?: UpdateDocumentDto
}

/**
 * Request parameters for apiVversionDocumentsPreprocessingPreprocessingIdDelete operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest {
    /**
     * The unique identifier of the preprocessing operation to cancel and clean up.
     */
    readonly preprocessingId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsPreprocessingPreprocessingIdGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest {
    /**
     * The unique identifier of the preprocessing operation to retrieve detailed results for.
     */
    readonly preprocessingId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsPreviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsPreviewPostRequest {
    readonly version: string

    readonly file: File
}

/**
 * Request parameters for apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest {
    /**
     * The document request ID
     */
    readonly documentRequestId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest {
    /**
     * The document request ID
     */
    readonly documentRequestId: string

    readonly version: string

    /**
     * Bulk review actions for multiple documents
     */
    readonly bulkReviewDocumentsDto?: BulkReviewDocumentsDto
}

/**
 * Request parameters for apiVversionDocumentsRequestDocumentRequestIdDocumentsGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest {
    /**
     * The unique identifier of the document request
     */
    readonly documentRequestId: string

    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsTypesGet operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsTypesGetRequest {
    readonly version: string
}

/**
 * Request parameters for apiVversionDocumentsUploadPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsUploadPostRequest {
    readonly version: string

    readonly files: Array<File>

    readonly binderId: string

    /**
     * Frontend document type string (e.g., \\\&quot;w2\\\&quot;, \\\&quot;1099\\\&quot;, \\\&quot;receipt\\\&quot;). If provided, takes precedence over Type field.
     */
    readonly frontendType?: string

    readonly type?: DocumentType

    /**
     * Optional comment/note provided by the uploader about the document.
     */
    readonly comment?: string

    readonly documentRequestId?: string

    readonly signatureTemplateId?: string

    readonly runAiDetection?: boolean

    /**
     * Whether to generate AI-powered description for the document (default: true). If true, generates description from Azure Document Intelligence extracted data or falls back to Claude vision API.
     */
    readonly generateAiDescription?: boolean

    readonly direction?: DocumentDirection

    /**
     * When true, skips the SHA-256 duplicate-file check against existing binder files (both within the batch and against the binder). This is an opt-out honored for any authenticated caller of the upload endpoint; it is primarily intended for the signature-request upload flow, where re-sending an identical PDF is legitimate. Bypassing dedup only affects storage of duplicate content — it grants no additional access — so it is not gated on SignatureTemplateId.
     */
    readonly skipDuplicateCheck?: boolean
}

/**
 * Request parameters for apiVversionDocumentsUploadWithPagesPost operation in DocumentsApi.
 */
export interface DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest {
    readonly version: string

    /**
     * Document upload configuration including selected page groups, split options, binder assignment, signature templates, and e-signature delivery preferences.
     */
    readonly documentUploadWithPagesDto?: DocumentUploadWithPagesDto
}

/**
 * DocumentsApi - object-oriented interface
 */
export class DocumentsApi extends BaseAPI implements DocumentsApiInterface {
    /**
     * This endpoint uses Azure Document Intelligence to: 1. Detect the form type on each page (W-2, 1099, 8879, state forms, etc.) 2. Identify page boundaries where form types change 3. Group consecutive pages of the same form type (respecting multi-page forms) 4. Generate suggested document names and types for each group              Use this endpoint to preview splitting suggestions before uploading. The frontend can display suggestions to users and allow them to accept, modify, or reject.              Confidence scoring: - High confidence (0.80+): Automatic splitting recommended - Medium confidence (0.60-0.79): Manual review suggested - Low confidence (below 0.60): Manual intervention required
     * @summary Analyzes a multi-page PDF for intelligent page splitting suggestions using Azure Document Intelligence. Detects form type changes across pages and recommends optimal page groupings for separate documents. This endpoint does not permanently upload the file - it only analyzes and returns suggestions. Requires Client, Preparer, or Admin role.
     * @param {DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsAnalyzeForSplittingPost(requestParameters: DocumentsApiApiDocumentsAnalyzeForSplittingPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsAnalyzeForSplittingPost(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preprocesses a document with intelligent analysis including automatic splitting, signature field detection, and document structure recognition. This advanced preprocessing workflow prepares documents for optimized upload workflows and e-signature integration. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsBindersBinderIdPreprocessPost(requestParameters.binderId, requestParameters.file, requestParameters.autoSplit, requestParameters.detectSignatures, requestParameters.direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint performs a fast duplicate check (target: less than 2 seconds) without permanently uploading the file. Warnings are returned for files with similarity >= 0.70, but uploads are never blocked. Detection tiers: - Tier 1 (Fast): File hash, size, and filename comparison - Tier 2 (Medium): Form type and extracted data comparison - Tier 3 (Slow, fallback): AI-powered visual similarity analysis
     * @summary Checks for potential duplicate documents before uploading. Uses multi-tier detection: file hash, metadata similarity, and AI visual comparison.
     * @param {DocumentsApiApiDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsCheckDuplicatePost(requestParameters: DocumentsApiApiDocumentsCheckDuplicatePostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsCheckDuplicatePost(requestParameters.binderId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Classifies a document using AI to suggest appropriate categorization based on content analysis. Analyzes document content, detected form types, and extracted data to recommend document type and tags.
     * @param {DocumentsApiApiDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdClassifyPost(requestParameters.documentId, requestParameters.autoApply, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extracts structured data from a single tax form document using Azure Document Intelligence. Supports W-2, 1099 series, and 1098 forms with prebuilt AI models. Extracted data is saved to the document\'s ExtractedDataJson field. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdExtractDataPost(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a specific file from a document while preserving the document structure. Requires Admin role.
     * @param {DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdFilesFileIdDelete(requestParameters.documentId, requestParameters.fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reviews a document by approving or rejecting it with optional comment (Issue #74 - Document Review Workflow). This endpoint allows preparers to review client-uploaded documents and provide feedback. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdReviewPatch(requestParameters.documentId, requestParameters.reviewDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Review an individual document within a document request
     * @param {DocumentsApiApiDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdReviewPost(requestParameters.documentId, requestParameters.reviewDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Triggers AI processing for a document (Admin only, for debugging/reprocessing).
     * @param {DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsDocumentIdTriggerAiProcessingPost(requestParameters.documentId, requestParameters.runFormDetection, requestParameters.generateDescription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extracts structured data from multiple tax form documents in batch. Processes all documents in an binder or a specified subset of document IDs. Only documents with supported form types (W-2, 1099, 1098) are processed. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsExtractDataBatchPost(requestParameters: DocumentsApiApiDocumentsExtractDataBatchPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsExtractDataBatchPost(requestParameters.batchExtractionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client\'s documents. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client\'s documents.
     * @summary Retrieves a paginated list of documents with optional filtering, sorting, search, and client-specific access control. Supports filtering by direction (ReceivedFromClient vs SentToClient) to distinguish client-uploaded from preparer-generated documents. Supports search across filename, description, document type display names, and form types (detected/override). Enhanced for Issue #74: Supports category filter (\"client\" or \"firm\") with archive-based access control. Enhanced for Issue #91 Phase 3.1: Supports active client filtering for client role users.
     * @param {DocumentsApiApiDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsGet(requestParameters: DocumentsApiApiDocumentsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsGet(requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.type, requestParameters.binderId, requestParameters.direction, requestParameters.hasDocumentRequest, requestParameters.category, requestParameters.searchTerm, requestParameters.isExported, requestParameters.exportedAfter, requestParameters.exportedBefore, requestParameters.exportedById, requestParameters.excludeK1Documents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Converts document files to PDF format using advanced document processing algorithms. This feature supports multiple input formats and provides options for compression, quality settings, and format optimization. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdConvertToPdfPost(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
     * @summary Permanently deletes a document from the system. Requires Admin role or document ownership. Enhanced for Issue #74 with authorization checks and RequiredDocument unlinking. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
     * @param {DocumentsApiApiDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdDelete(requestParameters: DocumentsApiApiDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assigns a document to a document request, moves it to a different request, or detaches it from its current request (null DocumentRequestId). The target request must belong to the same binder as the document. The document\'s review state is never changed by a move. Staff only.
     * @param {DocumentsApiApiDocumentsIdDocumentRequestPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdDocumentRequestPut(requestParameters: DocumentsApiApiDocumentsIdDocumentRequestPutRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdDocumentRequestPut(requestParameters.id, requestParameters.assignDocumentToRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads a complete document by returning a presigned URL for Azure storage or streaming for local storage. For Azure Blob Storage, returns a time-limited presigned URL with 1-hour expiration. For local storage or multi-file documents, falls back to file streaming.
     * @param {DocumentsApiApiDocumentsIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdDownloadGet(requestParameters: DocumentsApiApiDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdDownloadGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the document must belong to that client. Supports AI-powered description generation which analyzes the added file to create intelligent descriptions.
     * @summary Adds additional files to an existing document. Requires Preparer or Admin role. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
     * @param {DocumentsApiApiDocumentsIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdFilesPost(requestParameters: DocumentsApiApiDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdFilesPost(requestParameters.id, requestParameters.generateAiDescription, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
     * @summary Retrieves detailed information about a specific document by its unique identifier. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client.
     * @param {DocumentsApiApiDocumentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdGet(requestParameters: DocumentsApiApiDocumentsIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prepares a document for electronic signature by creating DocuSeal submission with signature fields and client details. Requires Preparer or Admin role for signature preparation.
     * @param {DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdPrepareForSignaturePost(requestParameters.id, requestParameters.singleDocumentSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates document properties including type, status, and user override for AI-detected form type.
     * @param {DocumentsApiApiDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsIdPut(requestParameters: DocumentsApiApiDocumentsIdPutRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdPut(requestParameters.id, requestParameters.updateDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancels an active preprocessing operation and cleans up associated resources including temporary files and cached data. This operation cannot be undone and will terminate all preprocessing activities. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsPreprocessingPreprocessingIdDelete(requestParameters.preprocessingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves comprehensive preprocessing results including document analysis, split recommendations, and signature field detection. Provides detailed status and results from document preprocessing operations. Requires Preparer or Admin role.
     * @param {DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsPreprocessingPreprocessingIdGet(requestParameters.preprocessingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates an interactive preview of a PDF document with page thumbnails, bookmark detection, and grouping analysis. Requires Preparer or Admin role for document preview generation.
     * @param {DocumentsApiApiDocumentsPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsPreviewPost(requestParameters: DocumentsApiApiDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsPreviewPost(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get documents awaiting review for a document request
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters.documentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Perform bulk review of multiple documents within a document request
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters.documentRequestId, requestParameters.bulkReviewDocumentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all documents associated with a specific document request
     * @param {DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters.documentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all available document types for upload with metadata for frontend selection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsTypesGet(options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
     * @summary Uploads one or more documents with specified type, binder, category (\"client\" or \"firm\"), optional comment, and optional e-signature template assignment. Requires Preparer or Admin role for document uploads. Supports frontend type strings (e.g., \"w2\", \"1099\") or direct DocumentType enum. Issue #74: Category field added for client vs firm document tracking. Issue #75: Comment field and virus scanning added for enhanced security. Enhanced for Issue #91 Phase 3.1: Validates binder belongs to active client when provided.
     * @param {DocumentsApiApiDocumentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsUploadPost(requestParameters: DocumentsApiApiDocumentsUploadPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsUploadPost(requestParameters.files, requestParameters.binderId, requestParameters.frontendType, requestParameters.type, requestParameters.comment, requestParameters.documentRequestId, requestParameters.signatureTemplateId, requestParameters.runAiDetection, requestParameters.generateAiDescription, requestParameters.direction, requestParameters.skipDuplicateCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads documents with intelligent page selection based on preview analysis, bookmark detection, and document splitting. This advanced workflow allows users to selectively upload specific pages or page ranges from a previewed document, with automatic e-signature template assignment and DocuSeal integration. Requires Client, Preparer, or Admin role.
     * @param {DocumentsApiApiDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentsUploadWithPagesPost(requestParameters: DocumentsApiApiDocumentsUploadWithPagesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiDocumentsUploadWithPagesPost(requestParameters.documentUploadWithPagesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint uses Azure Document Intelligence to: 1. Detect the form type on each page (W-2, 1099, 8879, state forms, etc.) 2. Identify page boundaries where form types change 3. Group consecutive pages of the same form type (respecting multi-page forms) 4. Generate suggested document names and types for each group              Use this endpoint to preview splitting suggestions before uploading. The frontend can display suggestions to users and allow them to accept, modify, or reject.              Confidence scoring: - High confidence (0.80+): Automatic splitting recommended - Medium confidence (0.60-0.79): Manual review suggested - Low confidence (below 0.60): Manual intervention required
     * @summary Analyzes a multi-page PDF for intelligent page splitting suggestions using Azure Document Intelligence. Detects form type changes across pages and recommends optimal page groupings for separate documents. This endpoint does not permanently upload the file - it only analyzes and returns suggestions. Requires Client, Preparer, or Admin role.
     * @param {DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsAnalyzeForSplittingPost(requestParameters: DocumentsApiApiVversionDocumentsAnalyzeForSplittingPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsAnalyzeForSplittingPost(requestParameters.version, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preprocesses a document with intelligent analysis including automatic splitting, signature field detection, and document structure recognition. This advanced preprocessing workflow prepares documents for optimized upload workflows and e-signature integration. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsBindersBinderIdPreprocessPost(requestParameters: DocumentsApiApiVversionDocumentsBindersBinderIdPreprocessPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsBindersBinderIdPreprocessPost(requestParameters.binderId, requestParameters.version, requestParameters.file, requestParameters.autoSplit, requestParameters.detectSignatures, requestParameters.direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint performs a fast duplicate check (target: less than 2 seconds) without permanently uploading the file. Warnings are returned for files with similarity >= 0.70, but uploads are never blocked. Detection tiers: - Tier 1 (Fast): File hash, size, and filename comparison - Tier 2 (Medium): Form type and extracted data comparison - Tier 3 (Slow, fallback): AI-powered visual similarity analysis
     * @summary Checks for potential duplicate documents before uploading. Uses multi-tier detection: file hash, metadata similarity, and AI visual comparison.
     * @param {DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsCheckDuplicatePost(requestParameters: DocumentsApiApiVversionDocumentsCheckDuplicatePostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsCheckDuplicatePost(requestParameters.version, requestParameters.binderId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Classifies a document using AI to suggest appropriate categorization based on content analysis. Analyzes document content, detected form types, and extracted data to recommend document type and tags.
     * @param {DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdClassifyPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdClassifyPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdClassifyPost(requestParameters.documentId, requestParameters.version, requestParameters.autoApply, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extracts structured data from a single tax form document using Azure Document Intelligence. Supports W-2, 1099 series, and 1098 forms with prebuilt AI models. Extracted data is saved to the document\'s ExtractedDataJson field. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdExtractDataPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdExtractDataPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdExtractDataPost(requestParameters.documentId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a specific file from a document while preserving the document structure. Requires Admin role.
     * @param {DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdFilesFileIdDelete(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdFilesFileIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdFilesFileIdDelete(requestParameters.documentId, requestParameters.fileId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reviews a document by approving or rejecting it with optional comment (Issue #74 - Document Review Workflow). This endpoint allows preparers to review client-uploaded documents and provide feedback. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdReviewPatch(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPatchRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdReviewPatch(requestParameters.documentId, requestParameters.version, requestParameters.reviewDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Review an individual document within a document request
     * @param {DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdReviewPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdReviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdReviewPost(requestParameters.documentId, requestParameters.version, requestParameters.reviewDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Triggers AI processing for a document (Admin only, for debugging/reprocessing).
     * @param {DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsDocumentIdTriggerAiProcessingPost(requestParameters: DocumentsApiApiVversionDocumentsDocumentIdTriggerAiProcessingPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsDocumentIdTriggerAiProcessingPost(requestParameters.documentId, requestParameters.version, requestParameters.runFormDetection, requestParameters.generateDescription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extracts structured data from multiple tax form documents in batch. Processes all documents in an binder or a specified subset of document IDs. Only documents with supported form types (W-2, 1099, 1098) are processed. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsExtractDataBatchPost(requestParameters: DocumentsApiApiVversionDocumentsExtractDataBatchPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsExtractDataBatchPost(requestParameters.version, requestParameters.batchExtractionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client\'s documents. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client\'s documents.
     * @summary Retrieves a paginated list of documents with optional filtering, sorting, search, and client-specific access control. Supports filtering by direction (ReceivedFromClient vs SentToClient) to distinguish client-uploaded from preparer-generated documents. Supports search across filename, description, document type display names, and form types (detected/override). Enhanced for Issue #74: Supports category filter (\"client\" or \"firm\") with archive-based access control. Enhanced for Issue #91 Phase 3.1: Supports active client filtering for client role users.
     * @param {DocumentsApiApiVversionDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsGet(requestParameters.version, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.type, requestParameters.binderId, requestParameters.direction, requestParameters.hasDocumentRequest, requestParameters.category, requestParameters.searchTerm, requestParameters.isExported, requestParameters.exportedAfter, requestParameters.exportedBefore, requestParameters.exportedById, requestParameters.excludeK1Documents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Converts document files to PDF format using advanced document processing algorithms. This feature supports multiple input formats and provides options for compression, quality settings, and format optimization. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdConvertToPdfPost(requestParameters: DocumentsApiApiVversionDocumentsIdConvertToPdfPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdConvertToPdfPost(requestParameters.id, requestParameters.version, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
     * @summary Permanently deletes a document from the system. Requires Admin role or document ownership. Enhanced for Issue #74 with authorization checks and RequiredDocument unlinking. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
     * @param {DocumentsApiApiVversionDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdDelete(requestParameters: DocumentsApiApiVversionDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdDelete(requestParameters.id, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assigns a document to a document request, moves it to a different request, or detaches it from its current request (null DocumentRequestId). The target request must belong to the same binder as the document. The document\'s review state is never changed by a move. Staff only.
     * @param {DocumentsApiApiVversionDocumentsIdDocumentRequestPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdDocumentRequestPut(requestParameters: DocumentsApiApiVversionDocumentsIdDocumentRequestPutRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdDocumentRequestPut(requestParameters.id, requestParameters.version, requestParameters.assignDocumentToRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads a complete document by returning a presigned URL for Azure storage or streaming for local storage. For Azure Blob Storage, returns a time-limited presigned URL with 1-hour expiration. For local storage or multi-file documents, falls back to file streaming.
     * @param {DocumentsApiApiVversionDocumentsIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdDownloadGet(requestParameters: DocumentsApiApiVversionDocumentsIdDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdDownloadGet(requestParameters.id, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the document must belong to that client. Supports AI-powered description generation which analyzes the added file to create intelligent descriptions.
     * @summary Adds additional files to an existing document. Requires Preparer or Admin role. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client when provided.
     * @param {DocumentsApiApiVversionDocumentsIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdFilesPost(requestParameters: DocumentsApiApiVversionDocumentsIdFilesPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdFilesPost(requestParameters.id, requestParameters.version, requestParameters.generateAiDescription, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Client role users, the X-Active-Client-Id header is required and document must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, document must belong to that client.
     * @summary Retrieves detailed information about a specific document by its unique identifier. Enhanced for Issue #91 Phase 3.1: Validates document belongs to active client.
     * @param {DocumentsApiApiVversionDocumentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdGet(requestParameters: DocumentsApiApiVversionDocumentsIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdGet(requestParameters.id, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prepares a document for electronic signature by creating DocuSeal submission with signature fields and client details. Requires Preparer or Admin role for signature preparation.
     * @param {DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdPrepareForSignaturePost(requestParameters: DocumentsApiApiVversionDocumentsIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdPrepareForSignaturePost(requestParameters.id, requestParameters.version, requestParameters.singleDocumentSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates document properties including type, status, and user override for AI-detected form type.
     * @param {DocumentsApiApiVversionDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsIdPut(requestParameters: DocumentsApiApiVversionDocumentsIdPutRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsIdPut(requestParameters.id, requestParameters.version, requestParameters.updateDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancels an active preprocessing operation and cleans up associated resources including temporary files and cached data. This operation cannot be undone and will terminate all preprocessing activities. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsPreprocessingPreprocessingIdDelete(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsPreprocessingPreprocessingIdDelete(requestParameters.preprocessingId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves comprehensive preprocessing results including document analysis, split recommendations, and signature field detection. Provides detailed status and results from document preprocessing operations. Requires Preparer or Admin role.
     * @param {DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsPreprocessingPreprocessingIdGet(requestParameters: DocumentsApiApiVversionDocumentsPreprocessingPreprocessingIdGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsPreprocessingPreprocessingIdGet(requestParameters.preprocessingId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates an interactive preview of a PDF document with page thumbnails, bookmark detection, and grouping analysis. Requires Preparer or Admin role for document preview generation.
     * @param {DocumentsApiApiVversionDocumentsPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsPreviewPost(requestParameters: DocumentsApiApiVversionDocumentsPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsPreviewPost(requestParameters.version, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get documents awaiting review for a document request
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsRequestDocumentRequestIdAwaitingReviewGet(requestParameters.documentRequestId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Perform bulk review of multiple documents within a document request
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdBulkReviewPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsRequestDocumentRequestIdBulkReviewPost(requestParameters.documentRequestId, requestParameters.version, requestParameters.bulkReviewDocumentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all documents associated with a specific document request
     * @param {DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters: DocumentsApiApiVversionDocumentsRequestDocumentRequestIdDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsRequestDocumentRequestIdDocumentsGet(requestParameters.documentRequestId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all available document types for upload with metadata for frontend selection.
     * @param {DocumentsApiApiVversionDocumentsTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsTypesGet(requestParameters: DocumentsApiApiVversionDocumentsTypesGetRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsTypesGet(requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
     * @summary Uploads one or more documents with specified type, binder, category (\"client\" or \"firm\"), optional comment, and optional e-signature template assignment. Requires Preparer or Admin role for document uploads. Supports frontend type strings (e.g., \"w2\", \"1099\") or direct DocumentType enum. Issue #74: Category field added for client vs firm document tracking. Issue #75: Comment field and virus scanning added for enhanced security. Enhanced for Issue #91 Phase 3.1: Validates binder belongs to active client when provided.
     * @param {DocumentsApiApiVversionDocumentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsUploadPost(requestParameters: DocumentsApiApiVversionDocumentsUploadPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsUploadPost(requestParameters.version, requestParameters.files, requestParameters.binderId, requestParameters.frontendType, requestParameters.type, requestParameters.comment, requestParameters.documentRequestId, requestParameters.signatureTemplateId, requestParameters.runAiDetection, requestParameters.generateAiDescription, requestParameters.direction, requestParameters.skipDuplicateCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads documents with intelligent page selection based on preview analysis, bookmark detection, and document splitting. This advanced workflow allows users to selectively upload specific pages or page ranges from a previewed document, with automatic e-signature template assignment and DocuSeal integration. Requires Client, Preparer, or Admin role.
     * @param {DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVversionDocumentsUploadWithPagesPost(requestParameters: DocumentsApiApiVversionDocumentsUploadWithPagesPostRequest, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).apiVversionDocumentsUploadWithPagesPost(requestParameters.version, requestParameters.documentUploadWithPagesDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalClientsApi - axios parameter creator
 */
export const ExternalClientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The CSV file should have a single column named \"ClientId\" containing external client IDs (maps to ExternalClient.ExternalId). Each client ID will be looked up in the ExternalClients table and, if found, imported using the standard CCH import flow.              **CSV Format:** ``` ClientId 12345 67890 ```              **DryRun Mode:** When dryRun=true, the job will only check for client existence without performing actual imports. Use this to validate your CSV before running a real import.              **Response:** Returns immediately with a job ID. Use GET /bulk-import-jobs/{jobId} to check status and GET /bulk-import-jobs/{jobId}/csv to download results when complete.              **Progress Notifications:** Real-time progress updates are sent via SignalR with operation type \"cch_client_import\".              **Usage with cURL:** ```bash # Get auth token TOKEN=$(curl -s -X POST https://api.example.com/api/auth/login \\   -H \"Content-Type: application/json\" \\   -d \'{\"email\":\"admin@example.com\",\"password\":\"...\"}\' | jq -r \'.data.token\')              # Start bulk import job curl -X POST https://api.example.com/api/clients/external/bulk-import-csv?dryRun=false \\   -H \"Authorization: Bearer $TOKEN\" \\   -F \"file=@clients.csv\"              # Check job status curl https://api.example.com/api/clients/external/bulk-import-jobs/{jobId} \\   -H \"Authorization: Bearer $TOKEN\"              # Download results CSV when complete curl https://api.example.com/api/clients/external/bulk-import-jobs/{jobId}/csv \\   -H \"Authorization: Bearer $TOKEN\" \\   --output results.csv ```
         * @summary Bulk import clients from a CSV file containing external client IDs. Runs as a background job with real-time progress notifications via SignalR. Requires Admin role authentication.
         * @param {boolean} [dryRun] If true, only check existence without importing (default: false)
         * @param {string} [sourceSystem] Source system to search in (default: \&quot;CCH\&quot;)
         * @param {File} [file] CSV file with a single \\\&quot;ClientId\\\&quot; column
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportCsvPost: async (dryRun?: boolean, sourceSystem?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/bulk-import-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }

            if (sourceSystem !== undefined) {
                localVarQueryParameter['sourceSystem'] = sourceSystem;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the results of a completed bulk import job as a CSV file.
         * @param {string} jobId The job ID returned from bulk-import-csv endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportJobsJobIdCsvGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiClientsExternalBulkImportJobsJobIdCsvGet', 'jobId', jobId)
            const localVarPath = `/api/clients/external/bulk-import-jobs/{jobId}/csv`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/csv';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the status of a bulk import job.
         * @param {string} jobId The job ID returned from bulk-import-csv endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportJobsJobIdGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiClientsExternalBulkImportJobsJobIdGet', 'jobId', jobId)
            const localVarPath = `/api/clients/external/bulk-import-jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find external client by client number
         * @param {string} clientNumber Client number to search
         * @param {string} [source] Optional source system filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalByClientNumberClientNumberGet: async (clientNumber: string, source?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientNumber' is not null or undefined
            assertParamExists('apiClientsExternalByClientNumberClientNumberGet', 'clientNumber', clientNumber)
            const localVarPath = `/api/clients/external/by-client-number/{clientNumber}`
                .replace(`{${"clientNumber"}}`, encodeURIComponent(String(clientNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get external clients by office name
         * @param {string} officeName Office name (partial match, case-insensitive)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalByOfficeOfficeNameGet: async (officeName: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'officeName' is not null or undefined
            assertParamExists('apiClientsExternalByOfficeOfficeNameGet', 'officeName', officeName)
            const localVarPath = `/api/clients/external/by-office/{officeName}`
                .replace(`{${"officeName"}}`, encodeURIComponent(String(officeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger embedding refresh for clients with missing or stale embeddings
         * @param {number} [maxCount] Maximum number of clients to process (0 for unlimited)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalEmbeddingsRefreshPost: async (maxCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/embeddings/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (maxCount !== undefined) {
                localVarQueryParameter['maxCount'] = maxCount;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an external client by ID
         * @param {string} id External client ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsExternalIdGet', 'id', id)
            const localVarPath = `/api/clients/external/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlink an external client from its imported local client
         * @param {string} id External client ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdLinkDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsExternalIdLinkDelete', 'id', id)
            const localVarPath = `/api/clients/external/{id}/link`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Link an external client to an imported local client
         * @param {string} id External client ID
         * @param {LinkExternalClientDto} [linkExternalClientDto] Link request with imported client ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdLinkPost: async (id: string, linkExternalClientDto?: LinkExternalClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsExternalIdLinkPost', 'id', id)
            const localVarPath = `/api/clients/external/{id}/link`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkExternalClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find clients similar to a given client (semantic similarity)
         * @param {string} id Reference client ID
         * @param {number} [limit] Maximum number of similar clients (default: 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdSimilarGet: async (id: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsExternalIdSimilarGet', 'id', id)
            const localVarPath = `/api/clients/external/{id}/similar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get history and status of all background sync jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalJobsHistoryGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/jobs/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search external clients using hybrid search (exact, fuzzy, semantic)
         * @param {string} searchTerm Search term for name, client number, email, or phone
         * @param {string} [sourceSystem] Filter by source system (e.g., \&quot;CCH\&quot;)
         * @param {string} [officeName] Filter by office name (partial match, case-insensitive)
         * @param {string} [clientType] Filter by client type
         * @param {boolean} [isActive] Filter by active status (null &#x3D; all, true &#x3D; active only, false &#x3D; inactive only)
         * @param {boolean} [isImported] Include only clients that have been imported
         * @param {boolean} [enableSemanticSearch] Enable semantic search (default: uses configuration setting)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size (default: 25, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSearchGet: async (searchTerm: string, sourceSystem?: string, officeName?: string, clientType?: string, isActive?: boolean, isImported?: boolean, enableSemanticSearch?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchTerm' is not null or undefined
            assertParamExists('apiClientsExternalSearchGet', 'searchTerm', searchTerm)
            const localVarPath = `/api/clients/external/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (sourceSystem !== undefined) {
                localVarQueryParameter['SourceSystem'] = sourceSystem;
            }

            if (officeName !== undefined) {
                localVarQueryParameter['OfficeName'] = officeName;
            }

            if (clientType !== undefined) {
                localVarQueryParameter['ClientType'] = clientType;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (isImported !== undefined) {
                localVarQueryParameter['IsImported'] = isImported;
            }

            if (enableSemanticSearch !== undefined) {
                localVarQueryParameter['EnableSemanticSearch'] = enableSemanticSearch;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an external client by source system and external ID
         * @param {string} source Source system (e.g., \&quot;CCH\&quot;)
         * @param {string} externalId External ID in the source system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSourceExternalIdGet: async (source: string, externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('apiClientsExternalSourceExternalIdGet', 'source', source)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('apiClientsExternalSourceExternalIdGet', 'externalId', externalId)
            const localVarPath = `/api/clients/external/{source}/{externalId}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)))
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get search suggestions for autocomplete
         * @param {string} [q] Partial search query (minimum 2 characters)
         * @param {number} [limit] Maximum number of suggestions (default: 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSuggestionsGet: async (q?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger manual sync from all enabled source systems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger manual sync from a specific source system
         * @param {string} source Source system to sync (e.g., \&quot;CCH\&quot;)
         * @param {ExternalClientSyncRequestDto} [externalClientSyncRequestDto] Optional sync parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncSourcePost: async (source: string, externalClientSyncRequestDto?: ExternalClientSyncRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('apiClientsExternalSyncSourcePost', 'source', source)
            const localVarPath = `/api/clients/external/sync/{source}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalClientSyncRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sync status and statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/external/sync/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalClientsApi - functional programming interface
 */
export const ExternalClientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalClientsApiAxiosParamCreator(configuration)
    return {
        /**
         * The CSV file should have a single column named \"ClientId\" containing external client IDs (maps to ExternalClient.ExternalId). Each client ID will be looked up in the ExternalClients table and, if found, imported using the standard CCH import flow.              **CSV Format:** ``` ClientId 12345 67890 ```              **DryRun Mode:** When dryRun=true, the job will only check for client existence without performing actual imports. Use this to validate your CSV before running a real import.              **Response:** Returns immediately with a job ID. Use GET /bulk-import-jobs/{jobId} to check status and GET /bulk-import-jobs/{jobId}/csv to download results when complete.              **Progress Notifications:** Real-time progress updates are sent via SignalR with operation type \"cch_client_import\".              **Usage with cURL:** ```bash # Get auth token TOKEN=$(curl -s -X POST https://api.example.com/api/auth/login \\   -H \"Content-Type: application/json\" \\   -d \'{\"email\":\"admin@example.com\",\"password\":\"...\"}\' | jq -r \'.data.token\')              # Start bulk import job curl -X POST https://api.example.com/api/clients/external/bulk-import-csv?dryRun=false \\   -H \"Authorization: Bearer $TOKEN\" \\   -F \"file=@clients.csv\"              # Check job status curl https://api.example.com/api/clients/external/bulk-import-jobs/{jobId} \\   -H \"Authorization: Bearer $TOKEN\"              # Download results CSV when complete curl https://api.example.com/api/clients/external/bulk-import-jobs/{jobId}/csv \\   -H \"Authorization: Bearer $TOKEN\" \\   --output results.csv ```
         * @summary Bulk import clients from a CSV file containing external client IDs. Runs as a background job with real-time progress notifications via SignalR. Requires Admin role authentication.
         * @param {boolean} [dryRun] If true, only check existence without importing (default: false)
         * @param {string} [sourceSystem] Source system to search in (default: \&quot;CCH\&quot;)
         * @param {File} [file] CSV file with a single \\\&quot;ClientId\\\&quot; column
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalBulkImportCsvPost(dryRun?: boolean, sourceSystem?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkImportJobStartedDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalBulkImportCsvPost(dryRun, sourceSystem, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalBulkImportCsvPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download the results of a completed bulk import job as a CSV file.
         * @param {string} jobId The job ID returned from bulk-import-csv endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalBulkImportJobsJobIdCsvGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalBulkImportJobsJobIdCsvGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalBulkImportJobsJobIdCsvGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the status of a bulk import job.
         * @param {string} jobId The job ID returned from bulk-import-csv endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalBulkImportJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkImportJobStateApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalBulkImportJobsJobIdGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalBulkImportJobsJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Find external client by client number
         * @param {string} clientNumber Client number to search
         * @param {string} [source] Optional source system filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalByClientNumberClientNumberGet(clientNumber: string, source?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalByClientNumberClientNumberGet(clientNumber, source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalByClientNumberClientNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get external clients by office name
         * @param {string} officeName Office name (partial match, case-insensitive)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalByOfficeOfficeNameGet(officeName: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalByOfficeOfficeNameGet(officeName, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalByOfficeOfficeNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger embedding refresh for clients with missing or stale embeddings
         * @param {number} [maxCount] Maximum number of clients to process (0 for unlimited)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalEmbeddingsRefreshPost(maxCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalEmbeddingsRefreshPost(maxCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalEmbeddingsRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an external client by ID
         * @param {string} id External client ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unlink an external client from its imported local client
         * @param {string} id External client ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalIdLinkDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalIdLinkDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalIdLinkDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Link an external client to an imported local client
         * @param {string} id External client ID
         * @param {LinkExternalClientDto} [linkExternalClientDto] Link request with imported client ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalIdLinkPost(id: string, linkExternalClientDto?: LinkExternalClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalIdLinkPost(id, linkExternalClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalIdLinkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Find clients similar to a given client (semantic similarity)
         * @param {string} id Reference client ID
         * @param {number} [limit] Maximum number of similar clients (default: 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalIdSimilarGet(id: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientSearchResultDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalIdSimilarGet(id, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalIdSimilarGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get history and status of all background sync jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalJobsHistoryGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobStatusSummaryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalJobsHistoryGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalJobsHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search external clients using hybrid search (exact, fuzzy, semantic)
         * @param {string} searchTerm Search term for name, client number, email, or phone
         * @param {string} [sourceSystem] Filter by source system (e.g., \&quot;CCH\&quot;)
         * @param {string} [officeName] Filter by office name (partial match, case-insensitive)
         * @param {string} [clientType] Filter by client type
         * @param {boolean} [isActive] Filter by active status (null &#x3D; all, true &#x3D; active only, false &#x3D; inactive only)
         * @param {boolean} [isImported] Include only clients that have been imported
         * @param {boolean} [enableSemanticSearch] Enable semantic search (default: uses configuration setting)
         * @param {number} [page] Page number (1-based)
         * @param {number} [pageSize] Page size (default: 25, max: 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSearchGet(searchTerm: string, sourceSystem?: string, officeName?: string, clientType?: string, isActive?: boolean, isImported?: boolean, enableSemanticSearch?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientSearchResultDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSearchGet(searchTerm, sourceSystem, officeName, clientType, isActive, isImported, enableSemanticSearch, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an external client by source system and external ID
         * @param {string} source Source system (e.g., \&quot;CCH\&quot;)
         * @param {string} externalId External ID in the source system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSourceExternalIdGet(source: string, externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSourceExternalIdGet(source, externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSourceExternalIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get search suggestions for autocomplete
         * @param {string} [q] Partial search query (minimum 2 characters)
         * @param {number} [limit] Maximum number of suggestions (default: 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSuggestionsGet(q?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientSearchSuggestionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSuggestionsGet(q, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSuggestionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger manual sync from all enabled source systems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSyncPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSyncPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger manual sync from a specific source system
         * @param {string} source Source system to sync (e.g., \&quot;CCH\&quot;)
         * @param {ExternalClientSyncRequestDto} [externalClientSyncRequestDto] Optional sync parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSyncSourcePost(source: string, externalClientSyncRequestDto?: ExternalClientSyncRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSyncSourcePost(source, externalClientSyncRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSyncSourcePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sync status and statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsExternalSyncStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientSyncStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsExternalSyncStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientsApi.apiClientsExternalSyncStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalClientsApi - factory interface
 */
export const ExternalClientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalClientsApiFp(configuration)
    return {
        /**
         * The CSV file should have a single column named \"ClientId\" containing external client IDs (maps to ExternalClient.ExternalId). Each client ID will be looked up in the ExternalClients table and, if found, imported using the standard CCH import flow.              **CSV Format:** ``` ClientId 12345 67890 ```              **DryRun Mode:** When dryRun=true, the job will only check for client existence without performing actual imports. Use this to validate your CSV before running a real import.              **Response:** Returns immediately with a job ID. Use GET /bulk-import-jobs/{jobId} to check status and GET /bulk-import-jobs/{jobId}/csv to download results when complete.              **Progress Notifications:** Real-time progress updates are sent via SignalR with operation type \"cch_client_import\".              **Usage with cURL:** ```bash # Get auth token TOKEN=$(curl -s -X POST https://api.example.com/api/auth/login \\   -H \"Content-Type: application/json\" \\   -d \'{\"email\":\"admin@example.com\",\"password\":\"...\"}\' | jq -r \'.data.token\')              # Start bulk import job curl -X POST https://api.example.com/api/clients/external/bulk-import-csv?dryRun=false \\   -H \"Authorization: Bearer $TOKEN\" \\   -F \"file=@clients.csv\"              # Check job status curl https://api.example.com/api/clients/external/bulk-import-jobs/{jobId} \\   -H \"Authorization: Bearer $TOKEN\"              # Download results CSV when complete curl https://api.example.com/api/clients/external/bulk-import-jobs/{jobId}/csv \\   -H \"Authorization: Bearer $TOKEN\" \\   --output results.csv ```
         * @summary Bulk import clients from a CSV file containing external client IDs. Runs as a background job with real-time progress notifications via SignalR. Requires Admin role authentication.
         * @param {ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportCsvPost(requestParameters: ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BulkImportJobStartedDtoApiResponse> {
            return localVarFp.apiClientsExternalBulkImportCsvPost(requestParameters.dryRun, requestParameters.sourceSystem, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the results of a completed bulk import job as a CSV file.
         * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportJobsJobIdCsvGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiClientsExternalBulkImportJobsJobIdCsvGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the status of a bulk import job.
         * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalBulkImportJobsJobIdGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkImportJobStateApiResponse> {
            return localVarFp.apiClientsExternalBulkImportJobsJobIdGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find external client by client number
         * @param {ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalByClientNumberClientNumberGet(requestParameters: ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse> {
            return localVarFp.apiClientsExternalByClientNumberClientNumberGet(requestParameters.clientNumber, requestParameters.source, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get external clients by office name
         * @param {ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalByOfficeOfficeNameGet(requestParameters: ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoPaginatedResponseApiResponse> {
            return localVarFp.apiClientsExternalByOfficeOfficeNameGet(requestParameters.officeName, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger embedding refresh for clients with missing or stale embeddings
         * @param {ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalEmbeddingsRefreshPost(requestParameters: ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiClientsExternalEmbeddingsRefreshPost(requestParameters.maxCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an external client by ID
         * @param {ExternalClientsApiApiClientsExternalIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse> {
            return localVarFp.apiClientsExternalIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlink an external client from its imported local client
         * @param {ExternalClientsApiApiClientsExternalIdLinkDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdLinkDelete(requestParameters: ExternalClientsApiApiClientsExternalIdLinkDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsExternalIdLinkDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Link an external client to an imported local client
         * @param {ExternalClientsApiApiClientsExternalIdLinkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdLinkPost(requestParameters: ExternalClientsApiApiClientsExternalIdLinkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiClientsExternalIdLinkPost(requestParameters.id, requestParameters.linkExternalClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find clients similar to a given client (semantic similarity)
         * @param {ExternalClientsApiApiClientsExternalIdSimilarGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalIdSimilarGet(requestParameters: ExternalClientsApiApiClientsExternalIdSimilarGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchResultDtoListApiResponse> {
            return localVarFp.apiClientsExternalIdSimilarGet(requestParameters.id, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get history and status of all background sync jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalJobsHistoryGet(options?: RawAxiosRequestConfig): AxiosPromise<JobStatusSummaryDtoApiResponse> {
            return localVarFp.apiClientsExternalJobsHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search external clients using hybrid search (exact, fuzzy, semantic)
         * @param {ExternalClientsApiApiClientsExternalSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSearchGet(requestParameters: ExternalClientsApiApiClientsExternalSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchResultDtoPaginatedResponseApiResponse> {
            return localVarFp.apiClientsExternalSearchGet(requestParameters.searchTerm, requestParameters.sourceSystem, requestParameters.officeName, requestParameters.clientType, requestParameters.isActive, requestParameters.isImported, requestParameters.enableSemanticSearch, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an external client by source system and external ID
         * @param {ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSourceExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse> {
            return localVarFp.apiClientsExternalSourceExternalIdGet(requestParameters.source, requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get search suggestions for autocomplete
         * @param {ExternalClientsApiApiClientsExternalSuggestionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSuggestionsGet(requestParameters: ExternalClientsApiApiClientsExternalSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchSuggestionDtoListApiResponse> {
            return localVarFp.apiClientsExternalSuggestionsGet(requestParameters.q, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger manual sync from all enabled source systems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncPost(options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiClientsExternalSyncPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger manual sync from a specific source system
         * @param {ExternalClientsApiApiClientsExternalSyncSourcePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncSourcePost(requestParameters: ExternalClientsApiApiClientsExternalSyncSourcePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiClientsExternalSyncSourcePost(requestParameters.source, requestParameters.externalClientSyncRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sync status and statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsExternalSyncStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSyncStatusDtoApiResponse> {
            return localVarFp.apiClientsExternalSyncStatusGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalClientsApi - interface
 */
export interface ExternalClientsApiInterface {
    /**
     * The CSV file should have a single column named \"ClientId\" containing external client IDs (maps to ExternalClient.ExternalId). Each client ID will be looked up in the ExternalClients table and, if found, imported using the standard CCH import flow.              **CSV Format:** ``` ClientId 12345 67890 ```              **DryRun Mode:** When dryRun=true, the job will only check for client existence without performing actual imports. Use this to validate your CSV before running a real import.              **Response:** Returns immediately with a job ID. Use GET /bulk-import-jobs/{jobId} to check status and GET /bulk-import-jobs/{jobId}/csv to download results when complete.              **Progress Notifications:** Real-time progress updates are sent via SignalR with operation type \"cch_client_import\".              **Usage with cURL:** ```bash # Get auth token TOKEN=$(curl -s -X POST https://api.example.com/api/auth/login \\   -H \"Content-Type: application/json\" \\   -d \'{\"email\":\"admin@example.com\",\"password\":\"...\"}\' | jq -r \'.data.token\')              # Start bulk import job curl -X POST https://api.example.com/api/clients/external/bulk-import-csv?dryRun=false \\   -H \"Authorization: Bearer $TOKEN\" \\   -F \"file=@clients.csv\"              # Check job status curl https://api.example.com/api/clients/external/bulk-import-jobs/{jobId} \\   -H \"Authorization: Bearer $TOKEN\"              # Download results CSV when complete curl https://api.example.com/api/clients/external/bulk-import-jobs/{jobId}/csv \\   -H \"Authorization: Bearer $TOKEN\" \\   --output results.csv ```
     * @summary Bulk import clients from a CSV file containing external client IDs. Runs as a background job with real-time progress notifications via SignalR. Requires Admin role authentication.
     * @param {ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalBulkImportCsvPost(requestParameters?: ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkImportJobStartedDtoApiResponse>;

    /**
     * 
     * @summary Download the results of a completed bulk import job as a CSV file.
     * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalBulkImportJobsJobIdCsvGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Get the status of a bulk import job.
     * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalBulkImportJobsJobIdGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkImportJobStateApiResponse>;

    /**
     * 
     * @summary Find external client by client number
     * @param {ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalByClientNumberClientNumberGet(requestParameters: ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse>;

    /**
     * 
     * @summary Get external clients by office name
     * @param {ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalByOfficeOfficeNameGet(requestParameters: ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Trigger embedding refresh for clients with missing or stale embeddings
     * @param {ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalEmbeddingsRefreshPost(requestParameters?: ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @summary Get an external client by ID
     * @param {ExternalClientsApiApiClientsExternalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse>;

    /**
     * 
     * @summary Unlink an external client from its imported local client
     * @param {ExternalClientsApiApiClientsExternalIdLinkDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalIdLinkDelete(requestParameters: ExternalClientsApiApiClientsExternalIdLinkDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Link an external client to an imported local client
     * @param {ExternalClientsApiApiClientsExternalIdLinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalIdLinkPost(requestParameters: ExternalClientsApiApiClientsExternalIdLinkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Find clients similar to a given client (semantic similarity)
     * @param {ExternalClientsApiApiClientsExternalIdSimilarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalIdSimilarGet(requestParameters: ExternalClientsApiApiClientsExternalIdSimilarGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchResultDtoListApiResponse>;

    /**
     * 
     * @summary Get history and status of all background sync jobs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalJobsHistoryGet(options?: RawAxiosRequestConfig): AxiosPromise<JobStatusSummaryDtoApiResponse>;

    /**
     * 
     * @summary Search external clients using hybrid search (exact, fuzzy, semantic)
     * @param {ExternalClientsApiApiClientsExternalSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSearchGet(requestParameters: ExternalClientsApiApiClientsExternalSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchResultDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Get an external client by source system and external ID
     * @param {ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSourceExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientDtoApiResponse>;

    /**
     * 
     * @summary Get search suggestions for autocomplete
     * @param {ExternalClientsApiApiClientsExternalSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSuggestionsGet(requestParameters?: ExternalClientsApiApiClientsExternalSuggestionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSearchSuggestionDtoListApiResponse>;

    /**
     * 
     * @summary Trigger manual sync from all enabled source systems
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSyncPost(options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @summary Trigger manual sync from a specific source system
     * @param {ExternalClientsApiApiClientsExternalSyncSourcePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSyncSourcePost(requestParameters: ExternalClientsApiApiClientsExternalSyncSourcePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * 
     * @summary Get sync status and statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiClientsExternalSyncStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientSyncStatusDtoApiResponse>;

}

/**
 * Request parameters for apiClientsExternalBulkImportCsvPost operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest {
    /**
     * If true, only check existence without importing (default: false)
     */
    readonly dryRun?: boolean

    /**
     * Source system to search in (default: \&quot;CCH\&quot;)
     */
    readonly sourceSystem?: string

    /**
     * CSV file with a single \\\&quot;ClientId\\\&quot; column
     */
    readonly file?: File
}

/**
 * Request parameters for apiClientsExternalBulkImportJobsJobIdCsvGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest {
    /**
     * The job ID returned from bulk-import-csv endpoint
     */
    readonly jobId: string
}

/**
 * Request parameters for apiClientsExternalBulkImportJobsJobIdGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest {
    /**
     * The job ID returned from bulk-import-csv endpoint
     */
    readonly jobId: string
}

/**
 * Request parameters for apiClientsExternalByClientNumberClientNumberGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest {
    /**
     * Client number to search
     */
    readonly clientNumber: string

    /**
     * Optional source system filter
     */
    readonly source?: string
}

/**
 * Request parameters for apiClientsExternalByOfficeOfficeNameGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest {
    /**
     * Office name (partial match, case-insensitive)
     */
    readonly officeName: string

    /**
     * Page number (1-based)
     */
    readonly page?: number

    /**
     * Page size
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiClientsExternalEmbeddingsRefreshPost operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest {
    /**
     * Maximum number of clients to process (0 for unlimited)
     */
    readonly maxCount?: number
}

/**
 * Request parameters for apiClientsExternalIdGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalIdGetRequest {
    /**
     * External client ID
     */
    readonly id: string
}

/**
 * Request parameters for apiClientsExternalIdLinkDelete operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalIdLinkDeleteRequest {
    /**
     * External client ID
     */
    readonly id: string
}

/**
 * Request parameters for apiClientsExternalIdLinkPost operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalIdLinkPostRequest {
    /**
     * External client ID
     */
    readonly id: string

    /**
     * Link request with imported client ID
     */
    readonly linkExternalClientDto?: LinkExternalClientDto
}

/**
 * Request parameters for apiClientsExternalIdSimilarGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalIdSimilarGetRequest {
    /**
     * Reference client ID
     */
    readonly id: string

    /**
     * Maximum number of similar clients (default: 10)
     */
    readonly limit?: number
}

/**
 * Request parameters for apiClientsExternalSearchGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalSearchGetRequest {
    /**
     * Search term for name, client number, email, or phone
     */
    readonly searchTerm: string

    /**
     * Filter by source system (e.g., \&quot;CCH\&quot;)
     */
    readonly sourceSystem?: string

    /**
     * Filter by office name (partial match, case-insensitive)
     */
    readonly officeName?: string

    /**
     * Filter by client type
     */
    readonly clientType?: string

    /**
     * Filter by active status (null &#x3D; all, true &#x3D; active only, false &#x3D; inactive only)
     */
    readonly isActive?: boolean

    /**
     * Include only clients that have been imported
     */
    readonly isImported?: boolean

    /**
     * Enable semantic search (default: uses configuration setting)
     */
    readonly enableSemanticSearch?: boolean

    /**
     * Page number (1-based)
     */
    readonly page?: number

    /**
     * Page size (default: 25, max: 100)
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiClientsExternalSourceExternalIdGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest {
    /**
     * Source system (e.g., \&quot;CCH\&quot;)
     */
    readonly source: string

    /**
     * External ID in the source system
     */
    readonly externalId: string
}

/**
 * Request parameters for apiClientsExternalSuggestionsGet operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalSuggestionsGetRequest {
    /**
     * Partial search query (minimum 2 characters)
     */
    readonly q?: string

    /**
     * Maximum number of suggestions (default: 10)
     */
    readonly limit?: number
}

/**
 * Request parameters for apiClientsExternalSyncSourcePost operation in ExternalClientsApi.
 */
export interface ExternalClientsApiApiClientsExternalSyncSourcePostRequest {
    /**
     * Source system to sync (e.g., \&quot;CCH\&quot;)
     */
    readonly source: string

    /**
     * Optional sync parameters
     */
    readonly externalClientSyncRequestDto?: ExternalClientSyncRequestDto
}

/**
 * ExternalClientsApi - object-oriented interface
 */
export class ExternalClientsApi extends BaseAPI implements ExternalClientsApiInterface {
    /**
     * The CSV file should have a single column named \"ClientId\" containing external client IDs (maps to ExternalClient.ExternalId). Each client ID will be looked up in the ExternalClients table and, if found, imported using the standard CCH import flow.              **CSV Format:** ``` ClientId 12345 67890 ```              **DryRun Mode:** When dryRun=true, the job will only check for client existence without performing actual imports. Use this to validate your CSV before running a real import.              **Response:** Returns immediately with a job ID. Use GET /bulk-import-jobs/{jobId} to check status and GET /bulk-import-jobs/{jobId}/csv to download results when complete.              **Progress Notifications:** Real-time progress updates are sent via SignalR with operation type \"cch_client_import\".              **Usage with cURL:** ```bash # Get auth token TOKEN=$(curl -s -X POST https://api.example.com/api/auth/login \\   -H \"Content-Type: application/json\" \\   -d \'{\"email\":\"admin@example.com\",\"password\":\"...\"}\' | jq -r \'.data.token\')              # Start bulk import job curl -X POST https://api.example.com/api/clients/external/bulk-import-csv?dryRun=false \\   -H \"Authorization: Bearer $TOKEN\" \\   -F \"file=@clients.csv\"              # Check job status curl https://api.example.com/api/clients/external/bulk-import-jobs/{jobId} \\   -H \"Authorization: Bearer $TOKEN\"              # Download results CSV when complete curl https://api.example.com/api/clients/external/bulk-import-jobs/{jobId}/csv \\   -H \"Authorization: Bearer $TOKEN\" \\   --output results.csv ```
     * @summary Bulk import clients from a CSV file containing external client IDs. Runs as a background job with real-time progress notifications via SignalR. Requires Admin role authentication.
     * @param {ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalBulkImportCsvPost(requestParameters: ExternalClientsApiApiClientsExternalBulkImportCsvPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalBulkImportCsvPost(requestParameters.dryRun, requestParameters.sourceSystem, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the results of a completed bulk import job as a CSV file.
     * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalBulkImportJobsJobIdCsvGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdCsvGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalBulkImportJobsJobIdCsvGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the status of a bulk import job.
     * @param {ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalBulkImportJobsJobIdGet(requestParameters: ExternalClientsApiApiClientsExternalBulkImportJobsJobIdGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalBulkImportJobsJobIdGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find external client by client number
     * @param {ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalByClientNumberClientNumberGet(requestParameters: ExternalClientsApiApiClientsExternalByClientNumberClientNumberGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalByClientNumberClientNumberGet(requestParameters.clientNumber, requestParameters.source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get external clients by office name
     * @param {ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalByOfficeOfficeNameGet(requestParameters: ExternalClientsApiApiClientsExternalByOfficeOfficeNameGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalByOfficeOfficeNameGet(requestParameters.officeName, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger embedding refresh for clients with missing or stale embeddings
     * @param {ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalEmbeddingsRefreshPost(requestParameters: ExternalClientsApiApiClientsExternalEmbeddingsRefreshPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalEmbeddingsRefreshPost(requestParameters.maxCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an external client by ID
     * @param {ExternalClientsApiApiClientsExternalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalIdGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlink an external client from its imported local client
     * @param {ExternalClientsApiApiClientsExternalIdLinkDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalIdLinkDelete(requestParameters: ExternalClientsApiApiClientsExternalIdLinkDeleteRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalIdLinkDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Link an external client to an imported local client
     * @param {ExternalClientsApiApiClientsExternalIdLinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalIdLinkPost(requestParameters: ExternalClientsApiApiClientsExternalIdLinkPostRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalIdLinkPost(requestParameters.id, requestParameters.linkExternalClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find clients similar to a given client (semantic similarity)
     * @param {ExternalClientsApiApiClientsExternalIdSimilarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalIdSimilarGet(requestParameters: ExternalClientsApiApiClientsExternalIdSimilarGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalIdSimilarGet(requestParameters.id, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get history and status of all background sync jobs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalJobsHistoryGet(options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalJobsHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search external clients using hybrid search (exact, fuzzy, semantic)
     * @param {ExternalClientsApiApiClientsExternalSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSearchGet(requestParameters: ExternalClientsApiApiClientsExternalSearchGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSearchGet(requestParameters.searchTerm, requestParameters.sourceSystem, requestParameters.officeName, requestParameters.clientType, requestParameters.isActive, requestParameters.isImported, requestParameters.enableSemanticSearch, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an external client by source system and external ID
     * @param {ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSourceExternalIdGet(requestParameters: ExternalClientsApiApiClientsExternalSourceExternalIdGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSourceExternalIdGet(requestParameters.source, requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get search suggestions for autocomplete
     * @param {ExternalClientsApiApiClientsExternalSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSuggestionsGet(requestParameters: ExternalClientsApiApiClientsExternalSuggestionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSuggestionsGet(requestParameters.q, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger manual sync from all enabled source systems
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSyncPost(options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSyncPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger manual sync from a specific source system
     * @param {ExternalClientsApiApiClientsExternalSyncSourcePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSyncSourcePost(requestParameters: ExternalClientsApiApiClientsExternalSyncSourcePostRequest, options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSyncSourcePost(requestParameters.source, requestParameters.externalClientSyncRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sync status and statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiClientsExternalSyncStatusGet(options?: RawAxiosRequestConfig) {
        return ExternalClientsApiFp(this.configuration).apiClientsExternalSyncStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalDocumentSharesApi - axios parameter creator
 */
export const ExternalDocumentSharesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Lists the documents the current user has shared, newest first.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesGet: async (page?: number, pageSize?: number, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/external-document-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a shared document owned by the current user.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiExternalDocumentSharesIdDelete', 'id', id)
            const localVarPath = `/api/external-document-shares/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Streams the file for the owner to download/view their own shared document.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdDownloadGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiExternalDocumentSharesIdDownloadGet', 'id', id)
            const localVarPath = `/api/external-document-shares/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Immediately expires a shared document the current user owns (revokes the link).
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdExpirePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiExternalDocumentSharesIdExpirePost', 'id', id)
            const localVarPath = `/api/external-document-shares/{id}/expire`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads one or more documents (zipped into a single archive) and sends each recipient an email with a tokenized download link.
         * @param {Array<File>} files The documents to send. Zipped into a single archive; at least one file is required.
         * @param {Array<string>} recipientEmails The external recipient email addresses. Each receives the same download link. At least one is required.
         * @param {string} [message] Optional message included in each recipient\\\&#39;s email.
         * @param {string} [expiresAt] Optional expiration date for the link. If omitted, defaults to 7 days from creation. The link remains valid through the end (UTC) of the chosen day.
         * @param {boolean} [expireOnDownload] When true, the link expires immediately after the first download (by any recipient).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPost: async (files: Array<File>, recipientEmails: Array<string>, message?: string, expiresAt?: string, expireOnDownload?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('apiExternalDocumentSharesPost', 'files', files)
            // verify required parameter 'recipientEmails' is not null or undefined
            assertParamExists('apiExternalDocumentSharesPost', 'recipientEmails', recipientEmails)
            const localVarPath = `/api/external-document-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element as any);
                })
            }

            if (recipientEmails) {
                recipientEmails.forEach((element) => {
                    localVarFormParams.append('RecipientEmails', element as any);
                })
            }


            if (message !== undefined) { 
                localVarFormParams.append('Message', message as any);
            }

            if (expiresAt !== undefined) { 
                localVarFormParams.append('ExpiresAt', expiresAt as any);
            }

            if (expireOnDownload !== undefined) { 
                localVarFormParams.append('ExpireOnDownload', String(expireOnDownload) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Public download of a shared document by token. Records the download and emails the sender. No authentication required.
         * @param {string} token 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPublicTokenDownloadGet: async (token: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiExternalDocumentSharesPublicTokenDownloadGet', 'token', token)
            const localVarPath = `/api/external-document-shares/public/{token}/download`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Public landing-page metadata for a share token. No authentication required.
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPublicTokenGet: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiExternalDocumentSharesPublicTokenGet', 'token', token)
            const localVarPath = `/api/external-document-shares/public/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalDocumentSharesApi - functional programming interface
 */
export const ExternalDocumentSharesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalDocumentSharesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Lists the documents the current user has shared, newest first.
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesGet(page?: number, pageSize?: number, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalDocumentShareDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesGet(page, pageSize, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a shared document owned by the current user.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Streams the file for the owner to download/view their own shared document.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesIdDownloadGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesIdDownloadGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Immediately expires a shared document the current user owns (revokes the link).
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesIdExpirePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalDocumentShareDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesIdExpirePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesIdExpirePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Uploads one or more documents (zipped into a single archive) and sends each recipient an email with a tokenized download link.
         * @param {Array<File>} files The documents to send. Zipped into a single archive; at least one file is required.
         * @param {Array<string>} recipientEmails The external recipient email addresses. Each receives the same download link. At least one is required.
         * @param {string} [message] Optional message included in each recipient\\\&#39;s email.
         * @param {string} [expiresAt] Optional expiration date for the link. If omitted, defaults to 7 days from creation. The link remains valid through the end (UTC) of the chosen day.
         * @param {boolean} [expireOnDownload] When true, the link expires immediately after the first download (by any recipient).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesPost(files: Array<File>, recipientEmails: Array<string>, message?: string, expiresAt?: string, expireOnDownload?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalDocumentShareDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesPost(files, recipientEmails, message, expiresAt, expireOnDownload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Public download of a shared document by token. Records the download and emails the sender. No authentication required.
         * @param {string} token 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesPublicTokenDownloadGet(token: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesPublicTokenDownloadGet(token, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesPublicTokenDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Public landing-page metadata for a share token. No authentication required.
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalDocumentSharesPublicTokenGet(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicExternalDocumentShareDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalDocumentSharesPublicTokenGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalDocumentSharesApi.apiExternalDocumentSharesPublicTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalDocumentSharesApi - factory interface
 */
export const ExternalDocumentSharesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalDocumentSharesApiFp(configuration)
    return {
        /**
         * 
         * @summary Lists the documents the current user has shared, newest first.
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoPaginatedResponseApiResponse> {
            return localVarFp.apiExternalDocumentSharesGet(requestParameters.page, requestParameters.pageSize, requestParameters.skip, requestParameters.take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a shared document owned by the current user.
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdDelete(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiExternalDocumentSharesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Streams the file for the owner to download/view their own shared document.
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiExternalDocumentSharesIdDownloadGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Immediately expires a shared document the current user owns (revokes the link).
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesIdExpirePost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoApiResponse> {
            return localVarFp.apiExternalDocumentSharesIdExpirePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads one or more documents (zipped into a single archive) and sends each recipient an email with a tokenized download link.
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoApiResponse> {
            return localVarFp.apiExternalDocumentSharesPost(requestParameters.files, requestParameters.recipientEmails, requestParameters.message, requestParameters.expiresAt, requestParameters.expireOnDownload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Public download of a shared document by token. Records the download and emails the sender. No authentication required.
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPublicTokenDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiExternalDocumentSharesPublicTokenDownloadGet(requestParameters.token, requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Public landing-page metadata for a share token. No authentication required.
         * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalDocumentSharesPublicTokenGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicExternalDocumentShareDtoApiResponse> {
            return localVarFp.apiExternalDocumentSharesPublicTokenGet(requestParameters.token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalDocumentSharesApi - interface
 */
export interface ExternalDocumentSharesApiInterface {
    /**
     * 
     * @summary Lists the documents the current user has shared, newest first.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesGet(requestParameters?: ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Deletes a shared document owned by the current user.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesIdDelete(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Streams the file for the owner to download/view their own shared document.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesIdDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Immediately expires a shared document the current user owns (revokes the link).
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesIdExpirePost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoApiResponse>;

    /**
     * 
     * @summary Uploads one or more documents (zipped into a single archive) and sends each recipient an email with a tokenized download link.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesPost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalDocumentShareDtoApiResponse>;

    /**
     * 
     * @summary Public download of a shared document by token. Records the download and emails the sender. No authentication required.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesPublicTokenDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Public landing-page metadata for a share token. No authentication required.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalDocumentSharesPublicTokenGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicExternalDocumentShareDtoApiResponse>;

}

/**
 * Request parameters for apiExternalDocumentSharesGet operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly skip?: number

    readonly take?: number
}

/**
 * Request parameters for apiExternalDocumentSharesIdDelete operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for apiExternalDocumentSharesIdDownloadGet operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiExternalDocumentSharesIdExpirePost operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest {
    readonly id: string
}

/**
 * Request parameters for apiExternalDocumentSharesPost operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest {
    /**
     * The documents to send. Zipped into a single archive; at least one file is required.
     */
    readonly files: Array<File>

    /**
     * The external recipient email addresses. Each receives the same download link. At least one is required.
     */
    readonly recipientEmails: Array<string>

    /**
     * Optional message included in each recipient\\\&#39;s email.
     */
    readonly message?: string

    /**
     * Optional expiration date for the link. If omitted, defaults to 7 days from creation. The link remains valid through the end (UTC) of the chosen day.
     */
    readonly expiresAt?: string

    /**
     * When true, the link expires immediately after the first download (by any recipient).
     */
    readonly expireOnDownload?: boolean
}

/**
 * Request parameters for apiExternalDocumentSharesPublicTokenDownloadGet operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest {
    readonly token: string

    readonly email?: string
}

/**
 * Request parameters for apiExternalDocumentSharesPublicTokenGet operation in ExternalDocumentSharesApi.
 */
export interface ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest {
    readonly token: string
}

/**
 * ExternalDocumentSharesApi - object-oriented interface
 */
export class ExternalDocumentSharesApi extends BaseAPI implements ExternalDocumentSharesApiInterface {
    /**
     * 
     * @summary Lists the documents the current user has shared, newest first.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesGet(requestParameters.page, requestParameters.pageSize, requestParameters.skip, requestParameters.take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a shared document owned by the current user.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesIdDelete(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Streams the file for the owner to download/view their own shared document.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesIdDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesIdDownloadGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Immediately expires a shared document the current user owns (revokes the link).
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesIdExpirePost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesIdExpirePostRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesIdExpirePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads one or more documents (zipped into a single archive) and sends each recipient an email with a tokenized download link.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesPost(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPostRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesPost(requestParameters.files, requestParameters.recipientEmails, requestParameters.message, requestParameters.expiresAt, requestParameters.expireOnDownload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Public download of a shared document by token. Records the download and emails the sender. No authentication required.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesPublicTokenDownloadGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesPublicTokenDownloadGet(requestParameters.token, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Public landing-page metadata for a share token. No authentication required.
     * @param {ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalDocumentSharesPublicTokenGet(requestParameters: ExternalDocumentSharesApiApiExternalDocumentSharesPublicTokenGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalDocumentSharesApiFp(this.configuration).apiExternalDocumentSharesPublicTokenGet(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalUploadApi - axios parameter creator
 */
export const ExternalUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Uploads one or more files via an active upload link. Returns metadata (FileName + UploadedAt) for the newly-created files only.
         * @param {string} id 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalUploadIdFilesPost: async (id: string, files?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiExternalUploadIdFilesPost', 'id', id)
            const localVarPath = `/api/external-upload/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the label and existing uploads for an active upload link. The id is the sole credential — never reveal whether an id exists or is expired; always return a generic 404 on miss to prevent enumeration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalUploadIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiExternalUploadIdGet', 'id', id)
            const localVarPath = `/api/external-upload/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalUploadApi - functional programming interface
 */
export const ExternalUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Uploads one or more files via an active upload link. Returns metadata (FileName + UploadedAt) for the newly-created files only.
         * @param {string} id 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalUploadIdFilesPost(id: string, files?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedFileDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalUploadIdFilesPost(id, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalUploadApi.apiExternalUploadIdFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the label and existing uploads for an active upload link. The id is the sole credential — never reveal whether an id exists or is expired; always return a generic 404 on miss to prevent enumeration.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiExternalUploadIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalUploadViewDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiExternalUploadIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalUploadApi.apiExternalUploadIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalUploadApi - factory interface
 */
export const ExternalUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalUploadApiFp(configuration)
    return {
        /**
         * 
         * @summary Uploads one or more files via an active upload link. Returns metadata (FileName + UploadedAt) for the newly-created files only.
         * @param {ExternalUploadApiApiExternalUploadIdFilesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalUploadIdFilesPost(requestParameters: ExternalUploadApiApiExternalUploadIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadedFileDtoListApiResponse> {
            return localVarFp.apiExternalUploadIdFilesPost(requestParameters.id, requestParameters.files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the label and existing uploads for an active upload link. The id is the sole credential — never reveal whether an id exists or is expired; always return a generic 404 on miss to prevent enumeration.
         * @param {ExternalUploadApiApiExternalUploadIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiExternalUploadIdGet(requestParameters: ExternalUploadApiApiExternalUploadIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalUploadViewDtoApiResponse> {
            return localVarFp.apiExternalUploadIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalUploadApi - interface
 */
export interface ExternalUploadApiInterface {
    /**
     * 
     * @summary Uploads one or more files via an active upload link. Returns metadata (FileName + UploadedAt) for the newly-created files only.
     * @param {ExternalUploadApiApiExternalUploadIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalUploadIdFilesPost(requestParameters: ExternalUploadApiApiExternalUploadIdFilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadedFileDtoListApiResponse>;

    /**
     * 
     * @summary Returns the label and existing uploads for an active upload link. The id is the sole credential — never reveal whether an id exists or is expired; always return a generic 404 on miss to prevent enumeration.
     * @param {ExternalUploadApiApiExternalUploadIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiExternalUploadIdGet(requestParameters: ExternalUploadApiApiExternalUploadIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalUploadViewDtoApiResponse>;

}

/**
 * Request parameters for apiExternalUploadIdFilesPost operation in ExternalUploadApi.
 */
export interface ExternalUploadApiApiExternalUploadIdFilesPostRequest {
    readonly id: string

    readonly files?: Array<File>
}

/**
 * Request parameters for apiExternalUploadIdGet operation in ExternalUploadApi.
 */
export interface ExternalUploadApiApiExternalUploadIdGetRequest {
    readonly id: string
}

/**
 * ExternalUploadApi - object-oriented interface
 */
export class ExternalUploadApi extends BaseAPI implements ExternalUploadApiInterface {
    /**
     * 
     * @summary Uploads one or more files via an active upload link. Returns metadata (FileName + UploadedAt) for the newly-created files only.
     * @param {ExternalUploadApiApiExternalUploadIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalUploadIdFilesPost(requestParameters: ExternalUploadApiApiExternalUploadIdFilesPostRequest, options?: RawAxiosRequestConfig) {
        return ExternalUploadApiFp(this.configuration).apiExternalUploadIdFilesPost(requestParameters.id, requestParameters.files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the label and existing uploads for an active upload link. The id is the sole credential — never reveal whether an id exists or is expired; always return a generic 404 on miss to prevent enumeration.
     * @param {ExternalUploadApiApiExternalUploadIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiExternalUploadIdGet(requestParameters: ExternalUploadApiApiExternalUploadIdGetRequest, options?: RawAxiosRequestConfig) {
        return ExternalUploadApiFp(this.configuration).apiExternalUploadIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * Form8879DiagnosticApi - axios parameter creator
 */
export const Form8879DiagnosticApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDiagnostic8879DetectionGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/diagnostic/8879-detection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDiagnostic8879TextFileNameGet: async (fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('apiDiagnostic8879TextFileNameGet', 'fileName', fileName)
            const localVarPath = `/api/diagnostic/8879-text/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Form8879DiagnosticApi - functional programming interface
 */
export const Form8879DiagnosticApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Form8879DiagnosticApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDiagnostic8879DetectionGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Form8879DiagnosticReportApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDiagnostic8879DetectionGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Form8879DiagnosticApi.apiDiagnostic8879DetectionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDiagnostic8879TextFileNameGet(fileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDiagnostic8879TextFileNameGet(fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Form8879DiagnosticApi.apiDiagnostic8879TextFileNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * Form8879DiagnosticApi - factory interface
 */
export const Form8879DiagnosticApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Form8879DiagnosticApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDiagnostic8879DetectionGet(options?: RawAxiosRequestConfig): AxiosPromise<Form8879DiagnosticReportApiResponse> {
            return localVarFp.apiDiagnostic8879DetectionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDiagnostic8879TextFileNameGet(requestParameters: Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiDiagnostic8879TextFileNameGet(requestParameters.fileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Form8879DiagnosticApi - interface
 */
export interface Form8879DiagnosticApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDiagnostic8879DetectionGet(options?: RawAxiosRequestConfig): AxiosPromise<Form8879DiagnosticReportApiResponse>;

    /**
     * 
     * @param {Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDiagnostic8879TextFileNameGet(requestParameters: Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

}

/**
 * Request parameters for apiDiagnostic8879TextFileNameGet operation in Form8879DiagnosticApi.
 */
export interface Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest {
    readonly fileName: string
}

/**
 * Form8879DiagnosticApi - object-oriented interface
 */
export class Form8879DiagnosticApi extends BaseAPI implements Form8879DiagnosticApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDiagnostic8879DetectionGet(options?: RawAxiosRequestConfig) {
        return Form8879DiagnosticApiFp(this.configuration).apiDiagnostic8879DetectionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDiagnostic8879TextFileNameGet(requestParameters: Form8879DiagnosticApiApiDiagnostic8879TextFileNameGetRequest, options?: RawAxiosRequestConfig) {
        return Form8879DiagnosticApiFp(this.configuration).apiDiagnostic8879TextFileNameGet(requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * K1Api - axios parameter creator
 */
export const K1ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Soft-delete an unassigned K1 document. The document must not have an active K1RecipientAssignment. Also deletes the associated storage blob.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1DocumentsDocumentIdDelete: async (binderId: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1DocumentsDocumentIdDelete', 'binderId', binderId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1DocumentsDocumentIdDelete', 'documentId', documentId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/documents/{documentId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extract all partner K1s from the K1 bundle PDF using bookmark parsing.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ExtractPost: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1ExtractPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/extract`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all K1 partner documents already extracted for this binder (regardless of assignment status). Used to pre-populate the K-1 distribution panel without requiring a re-extract.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ExtractedGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1ExtractedGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/extracted`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete a K1 recipient assignment.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} assignmentId 
         * @param {K1PushedCopyAction} [pushedCopy] What to do with a live copy of this K-1 already pushed into the recipient\&#39;s tax binder; keep when omitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdDelete: async (binderId: string, assignmentId: string, pushedCopy?: K1PushedCopyAction, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdDelete', 'binderId', binderId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdDelete', 'assignmentId', assignmentId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners/{assignmentId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pushedCopy !== undefined) {
                localVarQueryParameter['pushedCopy'] = pushedCopy;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a K1 recipient\'s email and name. If the existing user is only linked as a K1 recipient to this client, updates the user in place. If the user is linked to other clients, creates a new user with the updated values and re-points the assignment.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} assignmentId 
         * @param {UpdateK1RecipientAssignmentDto} [updateK1RecipientAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdPut: async (binderId: string, assignmentId: string, updateK1RecipientAssignmentDto?: UpdateK1RecipientAssignmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdPut', 'binderId', binderId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdPut', 'assignmentId', assignmentId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners/{assignmentId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateK1RecipientAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend the K1 ready notification to a specific K1 recipient assignment. Requires the binder to be in the Complete stage.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost: async (binderId: string, assignmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost', 'binderId', binderId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost', 'assignmentId', assignmentId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners/{assignmentId}/resend-notification`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all K1 recipient assignments for a binder.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a K1 recipient assignment. Creates or finds the user, adds ClientUserDetail with K1Recipient role, and creates the K1RecipientAssignment.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {CreateK1RecipientAssignmentDto} [createK1RecipientAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersPost: async (binderId: string, createK1RecipientAssignmentDto?: CreateK1RecipientAssignmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createK1RecipientAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload or replace the K1 bundle PDF. If a K1 bundle already exists, deletes all existing K1 assignments and extracted documents, replaces the file, and re-runs partner extraction. If no K1 bundle exists yet, creates one and extracts partners.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {File} [k1Pdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ReuploadPost: async (binderId: string, k1Pdf?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1ReuploadPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/reupload`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (k1Pdf !== undefined) { 
                localVarFormParams.append('k1Pdf', k1Pdf as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary K1 status endpoint. Returns binder completion status and, if the current user is a K1 recipient, their specific document ID. Also accessible to any client linked to the binder\'s client (primary, spouse, etc.) so they can see K1 distribution status on the completed screen.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1StatusGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1StatusGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/status`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * K1Api - functional programming interface
 */
export const K1ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = K1ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Soft-delete an unassigned K1 document. The document must not have an active K1RecipientAssignment. Also deletes the associated storage blob.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(binderId: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(binderId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1DocumentsDocumentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Extract all partner K1s from the K1 bundle PDF using bookmark parsing.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1ExtractPost(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1ExtractedPartnerDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1ExtractPost(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1ExtractPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all K1 partner documents already extracted for this binder (regardless of assignment status). Used to pre-populate the K-1 distribution panel without requiring a re-extract.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1ExtractedGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1ExtractedPartnerDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1ExtractedGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1ExtractedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Soft-delete a K1 recipient assignment.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} assignmentId 
         * @param {K1PushedCopyAction} [pushedCopy] What to do with a live copy of this K-1 already pushed into the recipient\&#39;s tax binder; keep when omitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(binderId: string, assignmentId: string, pushedCopy?: K1PushedCopyAction, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(binderId, assignmentId, pushedCopy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1PartnersAssignmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a K1 recipient\'s email and name. If the existing user is only linked as a K1 recipient to this client, updates the user in place. If the user is linked to other clients, creates a new user with the updated values and re-points the assignment.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} assignmentId 
         * @param {UpdateK1RecipientAssignmentDto} [updateK1RecipientAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersAssignmentIdPut(binderId: string, assignmentId: string, updateK1RecipientAssignmentDto?: UpdateK1RecipientAssignmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1RecipientAssignmentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersAssignmentIdPut(binderId, assignmentId, updateK1RecipientAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1PartnersAssignmentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend the K1 ready notification to a specific K1 recipient assignment. Requires the binder to be in the Complete stage.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(binderId: string, assignmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(binderId, assignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all K1 recipient assignments for a binder.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1RecipientAssignmentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1PartnersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a K1 recipient assignment. Creates or finds the user, adds ClientUserDetail with K1Recipient role, and creates the K1RecipientAssignment.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {CreateK1RecipientAssignmentDto} [createK1RecipientAssignmentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersPost(binderId: string, createK1RecipientAssignmentDto?: CreateK1RecipientAssignmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1RecipientAssignmentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersPost(binderId, createK1RecipientAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1PartnersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload or replace the K1 bundle PDF. If a K1 bundle already exists, deletes all existing K1 assignments and extracted documents, replaces the file, and re-runs partner extraction. If no K1 bundle exists yet, creates one and extracts partners.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {File} [k1Pdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1ReuploadPost(binderId: string, k1Pdf?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1ExtractedPartnerDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1ReuploadPost(binderId, k1Pdf, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1ReuploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary K1 status endpoint. Returns binder completion status and, if the current user is a K1 recipient, their specific document ID. Also accessible to any client linked to the binder\'s client (primary, spouse, etc.) so they can see K1 distribution status on the completed screen.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1StatusGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1StatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1StatusGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1Api.apiTaxBindersBinderIdK1StatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * K1Api - factory interface
 */
export const K1ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = K1ApiFp(configuration)
    return {
        /**
         * 
         * @summary Soft-delete an unassigned K1 document. The document must not have an active K1RecipientAssignment. Also deletes the associated storage blob.
         * @param {K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(requestParameters.binderId, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extract all partner K1s from the K1 bundle PDF using bookmark parsing.
         * @param {K1ApiApiTaxBindersBinderIdK1ExtractPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ExtractPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1ExtractPost(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all K1 partner documents already extracted for this binder (regardless of assignment status). Used to pre-populate the K-1 distribution panel without requiring a re-extract.
         * @param {K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ExtractedGet(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1ExtractedGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete a K1 recipient assignment.
         * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(requestParameters.binderId, requestParameters.assignmentId, requestParameters.pushedCopy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a K1 recipient\'s email and name. If the existing user is only linked as a K1 recipient to this client, updates the user in place. If the user is linked to other clients, creates a new user with the updated values and re-points the assignment.
         * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdPut(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersAssignmentIdPut(requestParameters.binderId, requestParameters.assignmentId, requestParameters.updateK1RecipientAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend the K1 ready notification to a specific K1 recipient assignment. Requires the binder to be in the Complete stage.
         * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(requestParameters.binderId, requestParameters.assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all K1 recipient assignments for a binder.
         * @param {K1ApiApiTaxBindersBinderIdK1PartnersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersGet(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a K1 recipient assignment. Creates or finds the user, adds ClientUserDetail with K1Recipient role, and creates the K1RecipientAssignment.
         * @param {K1ApiApiTaxBindersBinderIdK1PartnersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersPost(requestParameters.binderId, requestParameters.createK1RecipientAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload or replace the K1 bundle PDF. If a K1 bundle already exists, deletes all existing K1 assignments and extracted documents, replaces the file, and re-runs partner extraction. If no K1 bundle exists yet, creates one and extracts partners.
         * @param {K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1ReuploadPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1ReuploadPost(requestParameters.binderId, requestParameters.k1Pdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary K1 status endpoint. Returns binder completion status and, if the current user is a K1 recipient, their specific document ID. Also accessible to any client linked to the binder\'s client (primary, spouse, etc.) so they can see K1 distribution status on the completed screen.
         * @param {K1ApiApiTaxBindersBinderIdK1StatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1StatusGet(requestParameters: K1ApiApiTaxBindersBinderIdK1StatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1StatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1StatusGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * K1Api - interface
 */
export interface K1ApiInterface {
    /**
     * 
     * @summary Soft-delete an unassigned K1 document. The document must not have an active K1RecipientAssignment. Also deletes the associated storage blob.
     * @param {K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Extract all partner K1s from the K1 bundle PDF using bookmark parsing.
     * @param {K1ApiApiTaxBindersBinderIdK1ExtractPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1ExtractPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse>;

    /**
     * 
     * @summary Returns all K1 partner documents already extracted for this binder (regardless of assignment status). Used to pre-populate the K-1 distribution panel without requiring a re-extract.
     * @param {K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1ExtractedGet(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse>;

    /**
     * 
     * @summary Soft-delete a K1 recipient assignment.
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Update a K1 recipient\'s email and name. If the existing user is only linked as a K1 recipient to this client, updates the user in place. If the user is linked to other clients, creates a new user with the updated values and re-points the assignment.
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersAssignmentIdPut(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoApiResponse>;

    /**
     * 
     * @summary Resend the K1 ready notification to a specific K1 recipient assignment. Requires the binder to be in the Complete stage.
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary List all K1 recipient assignments for a binder.
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersGet(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoListApiResponse>;

    /**
     * 
     * @summary Create a K1 recipient assignment. Creates or finds the user, adds ClientUserDetail with K1Recipient role, and creates the K1RecipientAssignment.
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1RecipientAssignmentDtoApiResponse>;

    /**
     * 
     * @summary Upload or replace the K1 bundle PDF. If a K1 bundle already exists, deletes all existing K1 assignments and extracted documents, replaces the file, and re-runs partner extraction. If no K1 bundle exists yet, creates one and extracts partners.
     * @param {K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1ReuploadPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1ExtractedPartnerDtoListApiResponse>;

    /**
     * 
     * @summary K1 status endpoint. Returns binder completion status and, if the current user is a K1 recipient, their specific document ID. Also accessible to any client linked to the binder\'s client (primary, spouse, etc.) so they can see K1 distribution status on the completed screen.
     * @param {K1ApiApiTaxBindersBinderIdK1StatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1StatusGet(requestParameters: K1ApiApiTaxBindersBinderIdK1StatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1StatusDtoApiResponse>;

}

/**
 * Request parameters for apiTaxBindersBinderIdK1DocumentsDocumentIdDelete operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    /**
     * Copy this from the Staging Data response or Preprocessing results
     */
    readonly documentId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1ExtractPost operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1ExtractPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1ExtractedGet operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersAssignmentIdDelete operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly assignmentId: string

    /**
     * What to do with a live copy of this K-1 already pushed into the recipient\&#39;s tax binder; keep when omitted.
     */
    readonly pushedCopy?: K1PushedCopyAction
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersAssignmentIdPut operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly assignmentId: string

    readonly updateK1RecipientAssignmentDto?: UpdateK1RecipientAssignmentDto
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly assignmentId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersGet operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1PartnersGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersPost operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1PartnersPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly createK1RecipientAssignmentDto?: CreateK1RecipientAssignmentDto
}

/**
 * Request parameters for apiTaxBindersBinderIdK1ReuploadPost operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly k1Pdf?: File
}

/**
 * Request parameters for apiTaxBindersBinderIdK1StatusGet operation in K1Api.
 */
export interface K1ApiApiTaxBindersBinderIdK1StatusGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * K1Api - object-oriented interface
 */
export class K1Api extends BaseAPI implements K1ApiInterface {
    /**
     * 
     * @summary Soft-delete an unassigned K1 document. The document must not have an active K1RecipientAssignment. Also deletes the associated storage blob.
     * @param {K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1DocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1DocumentsDocumentIdDelete(requestParameters.binderId, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extract all partner K1s from the K1 bundle PDF using bookmark parsing.
     * @param {K1ApiApiTaxBindersBinderIdK1ExtractPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1ExtractPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractPostRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1ExtractPost(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all K1 partner documents already extracted for this binder (regardless of assignment status). Used to pre-populate the K-1 distribution panel without requiring a re-extract.
     * @param {K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1ExtractedGet(requestParameters: K1ApiApiTaxBindersBinderIdK1ExtractedGetRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1ExtractedGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete a K1 recipient assignment.
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersAssignmentIdDelete(requestParameters.binderId, requestParameters.assignmentId, requestParameters.pushedCopy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a K1 recipient\'s email and name. If the existing user is only linked as a K1 recipient to this client, updates the user in place. If the user is linked to other clients, creates a new user with the updated values and re-points the assignment.
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersAssignmentIdPut(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdPutRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersAssignmentIdPut(requestParameters.binderId, requestParameters.assignmentId, requestParameters.updateK1RecipientAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend the K1 ready notification to a specific K1 recipient assignment. Requires the binder to be in the Complete stage.
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPostRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersAssignmentIdResendNotificationPost(requestParameters.binderId, requestParameters.assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all K1 recipient assignments for a binder.
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersGet(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersGetRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a K1 recipient assignment. Creates or finds the user, adds ClientUserDetail with K1Recipient role, and creates the K1RecipientAssignment.
     * @param {K1ApiApiTaxBindersBinderIdK1PartnersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersPost(requestParameters: K1ApiApiTaxBindersBinderIdK1PartnersPostRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersPost(requestParameters.binderId, requestParameters.createK1RecipientAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload or replace the K1 bundle PDF. If a K1 bundle already exists, deletes all existing K1 assignments and extracted documents, replaces the file, and re-runs partner extraction. If no K1 bundle exists yet, creates one and extracts partners.
     * @param {K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1ReuploadPost(requestParameters: K1ApiApiTaxBindersBinderIdK1ReuploadPostRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1ReuploadPost(requestParameters.binderId, requestParameters.k1Pdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary K1 status endpoint. Returns binder completion status and, if the current user is a K1 recipient, their specific document ID. Also accessible to any client linked to the binder\'s client (primary, spouse, etc.) so they can see K1 distribution status on the completed screen.
     * @param {K1ApiApiTaxBindersBinderIdK1StatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1StatusGet(requestParameters: K1ApiApiTaxBindersBinderIdK1StatusGetRequest, options?: RawAxiosRequestConfig) {
        return K1ApiFp(this.configuration).apiTaxBindersBinderIdK1StatusGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * K1PushApi - axios parameter creator
 */
export const K1PushApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary The binders this assigned K-1 can be pushed into. Nothing is preselected.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet: async (binderId: string, assignmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet', 'binderId', binderId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet', 'assignmentId', assignmentId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners/{assignmentId}/push-destinations`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds the K-1 to the chosen destination binder as the recipient\'s client document.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} assignmentId 
         * @param {PushK1Request} [pushK1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost: async (binderId: string, assignmentId: string, pushK1Request?: PushK1Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost', 'binderId', binderId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost', 'assignmentId', assignmentId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/partners/{assignmentId}/push`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pushK1Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Push state of each K-1 on this binder: every assignment for staff, the caller\'s own for a recipient.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PushesGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdK1PushesGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/k1/pushes`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * K1PushApi - functional programming interface
 */
export const K1PushApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = K1PushApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary The binders this assigned K-1 can be pushed into. Nothing is preselected.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet(binderId: string, assignmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1PushDestinationsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet(binderId, assignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1PushApi.apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Adds the K-1 to the chosen destination binder as the recipient\'s client document.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} assignmentId 
         * @param {PushK1Request} [pushK1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost(binderId: string, assignmentId: string, pushK1Request?: PushK1Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1PushResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost(binderId, assignmentId, pushK1Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1PushApi.apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Push state of each K-1 on this binder: every assignment for staff, the caller\'s own for a recipient.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdK1PushesGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<K1PushStateDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdK1PushesGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['K1PushApi.apiTaxBindersBinderIdK1PushesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * K1PushApi - factory interface
 */
export const K1PushApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = K1PushApiFp(configuration)
    return {
        /**
         * 
         * @summary The binders this assigned K-1 can be pushed into. Nothing is preselected.
         * @param {K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet(requestParameters: K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1PushDestinationsDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet(requestParameters.binderId, requestParameters.assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds the K-1 to the chosen destination binder as the recipient\'s client document.
         * @param {K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost(requestParameters: K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1PushResultDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost(requestParameters.binderId, requestParameters.assignmentId, requestParameters.pushK1Request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Push state of each K-1 on this binder: every assignment for staff, the caller\'s own for a recipient.
         * @param {K1PushApiApiTaxBindersBinderIdK1PushesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdK1PushesGet(requestParameters: K1PushApiApiTaxBindersBinderIdK1PushesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1PushStateDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdK1PushesGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * K1PushApi - interface
 */
export interface K1PushApiInterface {
    /**
     * 
     * @summary The binders this assigned K-1 can be pushed into. Nothing is preselected.
     * @param {K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet(requestParameters: K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1PushDestinationsDtoApiResponse>;

    /**
     * 
     * @summary Adds the K-1 to the chosen destination binder as the recipient\'s client document.
     * @param {K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost(requestParameters: K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1PushResultDtoApiResponse>;

    /**
     * 
     * @summary Push state of each K-1 on this binder: every assignment for staff, the caller\'s own for a recipient.
     * @param {K1PushApiApiTaxBindersBinderIdK1PushesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdK1PushesGet(requestParameters: K1PushApiApiTaxBindersBinderIdK1PushesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<K1PushStateDtoListApiResponse>;

}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet operation in K1PushApi.
 */
export interface K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly assignmentId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost operation in K1PushApi.
 */
export interface K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly assignmentId: string

    readonly pushK1Request?: PushK1Request
}

/**
 * Request parameters for apiTaxBindersBinderIdK1PushesGet operation in K1PushApi.
 */
export interface K1PushApiApiTaxBindersBinderIdK1PushesGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * K1PushApi - object-oriented interface
 */
export class K1PushApi extends BaseAPI implements K1PushApiInterface {
    /**
     * 
     * @summary The binders this assigned K-1 can be pushed into. Nothing is preselected.
     * @param {K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet(requestParameters: K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGetRequest, options?: RawAxiosRequestConfig) {
        return K1PushApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersAssignmentIdPushDestinationsGet(requestParameters.binderId, requestParameters.assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds the K-1 to the chosen destination binder as the recipient\'s client document.
     * @param {K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost(requestParameters: K1PushApiApiTaxBindersBinderIdK1PartnersAssignmentIdPushPostRequest, options?: RawAxiosRequestConfig) {
        return K1PushApiFp(this.configuration).apiTaxBindersBinderIdK1PartnersAssignmentIdPushPost(requestParameters.binderId, requestParameters.assignmentId, requestParameters.pushK1Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Push state of each K-1 on this binder: every assignment for staff, the caller\'s own for a recipient.
     * @param {K1PushApiApiTaxBindersBinderIdK1PushesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdK1PushesGet(requestParameters: K1PushApiApiTaxBindersBinderIdK1PushesGetRequest, options?: RawAxiosRequestConfig) {
        return K1PushApiFp(this.configuration).apiTaxBindersBinderIdK1PushesGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationPreferencesApi - axios parameter creator
 */
export const NotificationPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all available notification action types with metadata. Use this to display the list of configurable notification types in the UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences/action-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes custom preference for a specific action type (reverts to defaults).
         * @param {NotificationActionType} actionType The action type to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypeDelete: async (actionType: NotificationActionType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionType' is not null or undefined
            assertParamExists('apiNotificationPreferencesActionsActionTypeDelete', 'actionType', actionType)
            const localVarPath = `/api/notification-preferences/actions/{actionType}`
                .replace(`{${"actionType"}}`, encodeURIComponent(String(actionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets preference for a specific action type.
         * @param {NotificationActionType} actionType The action type to get preference for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypeGet: async (actionType: NotificationActionType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionType' is not null or undefined
            assertParamExists('apiNotificationPreferencesActionsActionTypeGet', 'actionType', actionType)
            const localVarPath = `/api/notification-preferences/actions/{actionType}`
                .replace(`{${"actionType"}}`, encodeURIComponent(String(actionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates preference for a specific action type. Pass null values to remove overrides and use defaults.
         * @param {NotificationActionType} actionType The action type to update
         * @param {UpdateActionPreferenceDto} [updateActionPreferenceDto] The preference updates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypePut: async (actionType: NotificationActionType, updateActionPreferenceDto?: UpdateActionPreferenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionType' is not null or undefined
            assertParamExists('apiNotificationPreferencesActionsActionTypePut', 'actionType', actionType)
            const localVarPath = `/api/notification-preferences/actions/{actionType}`
                .replace(`{${"actionType"}}`, encodeURIComponent(String(actionType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateActionPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all action preferences for the current user, grouped by category. Shows both custom overrides and effective values (with defaults applied).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences/actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disables all notifications for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesDisablePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enables all notifications for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesEnablePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets notification preferences for the current user. Creates default preferences if none exist.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates notification preferences for the current user. Only provided fields will be updated; null/missing fields remain unchanged.
         * @param {UpdateUserNotificationPreferenceDto} [updateUserNotificationPreferenceDto] The preference updates to apply
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesPut: async (updateUserNotificationPreferenceDto?: UpdateUserNotificationPreferenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserNotificationPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resets notification preferences to role-appropriate default values for the current user. Clients get batched delivery with 60-minute intervals. Preparers/Admins get immediate delivery.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesResetPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification-preferences/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationPreferencesApi - functional programming interface
 */
export const NotificationPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all available notification action types with metadata. Use this to display the list of configurable notification types in the UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesActionTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionTypeDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesActionTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesActionTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Removes custom preference for a specific action type (reverts to defaults).
         * @param {NotificationActionType} actionType The action type to reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesActionsActionTypeDelete(actionType: NotificationActionType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesActionsActionTypeDelete(actionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesActionsActionTypeDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets preference for a specific action type.
         * @param {NotificationActionType} actionType The action type to get preference for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesActionsActionTypeGet(actionType: NotificationActionType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesActionsActionTypeGet(actionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesActionsActionTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates preference for a specific action type. Pass null values to remove overrides and use defaults.
         * @param {NotificationActionType} actionType The action type to update
         * @param {UpdateActionPreferenceDto} [updateActionPreferenceDto] The preference updates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesActionsActionTypePut(actionType: NotificationActionType, updateActionPreferenceDto?: UpdateActionPreferenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesActionsActionTypePut(actionType, updateActionPreferenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesActionsActionTypePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all action preferences for the current user, grouped by category. Shows both custom overrides and effective values (with defaults applied).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesActionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionPreferencesResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesActionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesActionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disables all notifications for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesDisablePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesDisablePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesDisablePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enables all notifications for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesEnablePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesEnablePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesEnablePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets notification preferences for the current user. Creates default preferences if none exist.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates notification preferences for the current user. Only provided fields will be updated; null/missing fields remain unchanged.
         * @param {UpdateUserNotificationPreferenceDto} [updateUserNotificationPreferenceDto] The preference updates to apply
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesPut(updateUserNotificationPreferenceDto?: UpdateUserNotificationPreferenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesPut(updateUserNotificationPreferenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resets notification preferences to role-appropriate default values for the current user. Clients get batched delivery with 60-minute intervals. Preparers/Admins get immediate delivery.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPreferencesResetPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPreferencesResetPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationPreferencesApi.apiNotificationPreferencesResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationPreferencesApi - factory interface
 */
export const NotificationPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all available notification action types with metadata. Use this to display the list of configurable notification types in the UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<ActionTypeDtoListApiResponse> {
            return localVarFp.apiNotificationPreferencesActionTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes custom preference for a specific action type (reverts to defaults).
         * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypeDelete(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiNotificationPreferencesActionsActionTypeDelete(requestParameters.actionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets preference for a specific action type.
         * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypeGet(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesActionsActionTypeGet(requestParameters.actionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates preference for a specific action type. Pass null values to remove overrides and use defaults.
         * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsActionTypePut(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesActionsActionTypePut(requestParameters.actionType, requestParameters.updateActionPreferenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all action preferences for the current user, grouped by category. Shows both custom overrides and effective values (with defaults applied).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesActionsGet(options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferencesResponseDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesActionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disables all notifications for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesDisablePost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesDisablePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enables all notifications for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesEnablePost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesEnablePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets notification preferences for the current user. Creates default preferences if none exist.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesGet(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates notification preferences for the current user. Only provided fields will be updated; null/missing fields remain unchanged.
         * @param {NotificationPreferencesApiApiNotificationPreferencesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesPut(requestParameters: NotificationPreferencesApiApiNotificationPreferencesPutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesPut(requestParameters.updateUserNotificationPreferenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resets notification preferences to role-appropriate default values for the current user. Clients get batched delivery with 60-minute intervals. Preparers/Admins get immediate delivery.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPreferencesResetPost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse> {
            return localVarFp.apiNotificationPreferencesResetPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationPreferencesApi - interface
 */
export interface NotificationPreferencesApiInterface {
    /**
     * 
     * @summary Gets all available notification action types with metadata. Use this to display the list of configurable notification types in the UI.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesActionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<ActionTypeDtoListApiResponse>;

    /**
     * 
     * @summary Removes custom preference for a specific action type (reverts to defaults).
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesActionsActionTypeDelete(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary Gets preference for a specific action type.
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesActionsActionTypeGet(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferenceDtoApiResponse>;

    /**
     * 
     * @summary Updates preference for a specific action type. Pass null values to remove overrides and use defaults.
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesActionsActionTypePut(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferenceDtoApiResponse>;

    /**
     * 
     * @summary Gets all action preferences for the current user, grouped by category. Shows both custom overrides and effective values (with defaults applied).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesActionsGet(options?: RawAxiosRequestConfig): AxiosPromise<ActionPreferencesResponseDtoApiResponse>;

    /**
     * 
     * @summary Disables all notifications for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesDisablePost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @summary Enables all notifications for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesEnablePost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @summary Gets notification preferences for the current user. Creates default preferences if none exist.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesGet(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @summary Updates notification preferences for the current user. Only provided fields will be updated; null/missing fields remain unchanged.
     * @param {NotificationPreferencesApiApiNotificationPreferencesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesPut(requestParameters?: NotificationPreferencesApiApiNotificationPreferencesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse>;

    /**
     * 
     * @summary Resets notification preferences to role-appropriate default values for the current user. Clients get batched delivery with 60-minute intervals. Preparers/Admins get immediate delivery.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationPreferencesResetPost(options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationPreferenceDtoApiResponse>;

}

/**
 * Request parameters for apiNotificationPreferencesActionsActionTypeDelete operation in NotificationPreferencesApi.
 */
export interface NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest {
    /**
     * The action type to reset
     */
    readonly actionType: NotificationActionType
}

/**
 * Request parameters for apiNotificationPreferencesActionsActionTypeGet operation in NotificationPreferencesApi.
 */
export interface NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest {
    /**
     * The action type to get preference for
     */
    readonly actionType: NotificationActionType
}

/**
 * Request parameters for apiNotificationPreferencesActionsActionTypePut operation in NotificationPreferencesApi.
 */
export interface NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest {
    /**
     * The action type to update
     */
    readonly actionType: NotificationActionType

    /**
     * The preference updates
     */
    readonly updateActionPreferenceDto?: UpdateActionPreferenceDto
}

/**
 * Request parameters for apiNotificationPreferencesPut operation in NotificationPreferencesApi.
 */
export interface NotificationPreferencesApiApiNotificationPreferencesPutRequest {
    /**
     * The preference updates to apply
     */
    readonly updateUserNotificationPreferenceDto?: UpdateUserNotificationPreferenceDto
}

/**
 * NotificationPreferencesApi - object-oriented interface
 */
export class NotificationPreferencesApi extends BaseAPI implements NotificationPreferencesApiInterface {
    /**
     * 
     * @summary Gets all available notification action types with metadata. Use this to display the list of configurable notification types in the UI.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesActionTypesGet(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesActionTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes custom preference for a specific action type (reverts to defaults).
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesActionsActionTypeDelete(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeDeleteRequest, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesActionsActionTypeDelete(requestParameters.actionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets preference for a specific action type.
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesActionsActionTypeGet(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypeGetRequest, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesActionsActionTypeGet(requestParameters.actionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates preference for a specific action type. Pass null values to remove overrides and use defaults.
     * @param {NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesActionsActionTypePut(requestParameters: NotificationPreferencesApiApiNotificationPreferencesActionsActionTypePutRequest, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesActionsActionTypePut(requestParameters.actionType, requestParameters.updateActionPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all action preferences for the current user, grouped by category. Shows both custom overrides and effective values (with defaults applied).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesActionsGet(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesActionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disables all notifications for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesDisablePost(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesDisablePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enables all notifications for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesEnablePost(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesEnablePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets notification preferences for the current user. Creates default preferences if none exist.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesGet(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates notification preferences for the current user. Only provided fields will be updated; null/missing fields remain unchanged.
     * @param {NotificationPreferencesApiApiNotificationPreferencesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesPut(requestParameters: NotificationPreferencesApiApiNotificationPreferencesPutRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesPut(requestParameters.updateUserNotificationPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resets notification preferences to role-appropriate default values for the current user. Clients get batched delivery with 60-minute intervals. Preparers/Admins get immediate delivery.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPreferencesResetPost(options?: RawAxiosRequestConfig) {
        return NotificationPreferencesApiFp(this.configuration).apiNotificationPreferencesResetPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets available action types for the preferences UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsActionTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/action-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets available delivery channels for the preferences UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsDeliveryChannelsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/delivery-channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets paginated notifications for the current user. Supports filtering by client, binder, action type, read status, and date range.
         * @param {string} [clientId] Filter notifications about this client (the client the notification is related to).
         * @param {string} [recipientClientId] Show notifications received by users of this client (the client\&#39;s inbox view). When set, returns notifications where the recipient is any user associated with this client. Requires preparer/admin role.
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {NotificationActionType} [actionType] 
         * @param {boolean} [isRead] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGet: async (clientId?: string, recipientClientId?: string, binderId?: string, actionType?: NotificationActionType, isRead?: boolean, dateFrom?: string, dateTo?: string, sortBy?: string, sortOrder?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (recipientClientId !== undefined) {
                localVarQueryParameter['RecipientClientId'] = recipientClientId;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (actionType !== undefined) {
                localVarQueryParameter['ActionType'] = actionType;
            }

            if (isRead !== undefined) {
                localVarQueryParameter['IsRead'] = isRead;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['DateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['DateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dismisses a notification without marking it as read.
         * @param {string} id The notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsIdDismissPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiNotificationsIdDismissPost', 'id', id)
            const localVarPath = `/api/notifications/{id}/dismiss`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks a single notification as read.
         * @param {string} id The notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsIdReadPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiNotificationsIdReadPost', 'id', id)
            const localVarPath = `/api/notifications/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks all notifications as read for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsReadAllPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/read-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks multiple notifications as read.
         * @param {MarkNotificationsReadDto} [markNotificationsReadDto] List of notification IDs to mark as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsReadBatchPost: async (markNotificationsReadDto?: MarkNotificationsReadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/read-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markNotificationsReadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets recent notifications for the dropdown display.
         * @param {number} [limit] Maximum number of notifications to return (default: 5)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsRecentGet: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the count of unread notifications for the current user. Used for the notification badge in the UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsUnreadCountGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/unread-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets available action types for the preferences UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsActionTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsActionTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsActionTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets available delivery channels for the preferences UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsDeliveryChannelsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsDeliveryChannelsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsDeliveryChannelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets paginated notifications for the current user. Supports filtering by client, binder, action type, read status, and date range.
         * @param {string} [clientId] Filter notifications about this client (the client the notification is related to).
         * @param {string} [recipientClientId] Show notifications received by users of this client (the client\&#39;s inbox view). When set, returns notifications where the recipient is any user associated with this client. Requires preparer/admin role.
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {NotificationActionType} [actionType] 
         * @param {boolean} [isRead] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsGet(clientId?: string, recipientClientId?: string, binderId?: string, actionType?: NotificationActionType, isRead?: boolean, dateFrom?: string, dateTo?: string, sortBy?: string, sortOrder?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedNotificationDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsGet(clientId, recipientClientId, binderId, actionType, isRead, dateFrom, dateTo, sortBy, sortOrder, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Dismisses a notification without marking it as read.
         * @param {string} id The notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsIdDismissPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsIdDismissPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsIdDismissPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks a single notification as read.
         * @param {string} id The notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsIdReadPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsIdReadPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsIdReadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks all notifications as read for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsReadAllPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsReadAllPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsReadAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks multiple notifications as read.
         * @param {MarkNotificationsReadDto} [markNotificationsReadDto] List of notification IDs to mark as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsReadBatchPost(markNotificationsReadDto?: MarkNotificationsReadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsReadBatchPost(markNotificationsReadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsReadBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets recent notifications for the dropdown display.
         * @param {number} [limit] Maximum number of notifications to return (default: 5)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsRecentGet(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedNotificationDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsRecentGet(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsRecentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the count of unread notifications for the current user. Used for the notification badge in the UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsUnreadCountGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationCountSummaryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsUnreadCountGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsUnreadCountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets available action types for the preferences UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsActionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiNotificationsActionTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets available delivery channels for the preferences UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsDeliveryChannelsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiNotificationsDeliveryChannelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets paginated notifications for the current user. Supports filtering by client, binder, action type, read status, and date range.
         * @param {NotificationsApiApiNotificationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGet(requestParameters: NotificationsApiApiNotificationsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedNotificationDtoPaginatedResponseApiResponse> {
            return localVarFp.apiNotificationsGet(requestParameters.clientId, requestParameters.recipientClientId, requestParameters.binderId, requestParameters.actionType, requestParameters.isRead, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dismisses a notification without marking it as read.
         * @param {NotificationsApiApiNotificationsIdDismissPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsIdDismissPost(requestParameters: NotificationsApiApiNotificationsIdDismissPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiNotificationsIdDismissPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks a single notification as read.
         * @param {NotificationsApiApiNotificationsIdReadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsIdReadPost(requestParameters: NotificationsApiApiNotificationsIdReadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiNotificationsIdReadPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks all notifications as read for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsReadAllPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiNotificationsReadAllPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks multiple notifications as read.
         * @param {NotificationsApiApiNotificationsReadBatchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsReadBatchPost(requestParameters: NotificationsApiApiNotificationsReadBatchPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiNotificationsReadBatchPost(requestParameters.markNotificationsReadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets recent notifications for the dropdown display.
         * @param {NotificationsApiApiNotificationsRecentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsRecentGet(requestParameters: NotificationsApiApiNotificationsRecentGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedNotificationDtoListApiResponse> {
            return localVarFp.apiNotificationsRecentGet(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the count of unread notifications for the current user. Used for the notification badge in the UI.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsUnreadCountGet(options?: RawAxiosRequestConfig): AxiosPromise<NotificationCountSummaryDtoApiResponse> {
            return localVarFp.apiNotificationsUnreadCountGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - interface
 */
export interface NotificationsApiInterface {
    /**
     * 
     * @summary Gets available action types for the preferences UI.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsActionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Gets available delivery channels for the preferences UI.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsDeliveryChannelsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Gets paginated notifications for the current user. Supports filtering by client, binder, action type, read status, and date range.
     * @param {NotificationsApiApiNotificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsGet(requestParameters?: NotificationsApiApiNotificationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedNotificationDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Dismisses a notification without marking it as read.
     * @param {NotificationsApiApiNotificationsIdDismissPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsIdDismissPost(requestParameters: NotificationsApiApiNotificationsIdDismissPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Marks a single notification as read.
     * @param {NotificationsApiApiNotificationsIdReadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsIdReadPost(requestParameters: NotificationsApiApiNotificationsIdReadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Marks all notifications as read for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsReadAllPost(options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Marks multiple notifications as read.
     * @param {NotificationsApiApiNotificationsReadBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsReadBatchPost(requestParameters?: NotificationsApiApiNotificationsReadBatchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Gets recent notifications for the dropdown display.
     * @param {NotificationsApiApiNotificationsRecentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsRecentGet(requestParameters?: NotificationsApiApiNotificationsRecentGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnifiedNotificationDtoListApiResponse>;

    /**
     * 
     * @summary Gets the count of unread notifications for the current user. Used for the notification badge in the UI.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotificationsUnreadCountGet(options?: RawAxiosRequestConfig): AxiosPromise<NotificationCountSummaryDtoApiResponse>;

}

/**
 * Request parameters for apiNotificationsGet operation in NotificationsApi.
 */
export interface NotificationsApiApiNotificationsGetRequest {
    /**
     * Filter notifications about this client (the client the notification is related to).
     */
    readonly clientId?: string

    /**
     * Show notifications received by users of this client (the client\&#39;s inbox view). When set, returns notifications where the recipient is any user associated with this client. Requires preparer/admin role.
     */
    readonly recipientClientId?: string

    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId?: string

    readonly actionType?: NotificationActionType

    readonly isRead?: boolean

    readonly dateFrom?: string

    readonly dateTo?: string

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiNotificationsIdDismissPost operation in NotificationsApi.
 */
export interface NotificationsApiApiNotificationsIdDismissPostRequest {
    /**
     * The notification ID
     */
    readonly id: string
}

/**
 * Request parameters for apiNotificationsIdReadPost operation in NotificationsApi.
 */
export interface NotificationsApiApiNotificationsIdReadPostRequest {
    /**
     * The notification ID
     */
    readonly id: string
}

/**
 * Request parameters for apiNotificationsReadBatchPost operation in NotificationsApi.
 */
export interface NotificationsApiApiNotificationsReadBatchPostRequest {
    /**
     * List of notification IDs to mark as read
     */
    readonly markNotificationsReadDto?: MarkNotificationsReadDto
}

/**
 * Request parameters for apiNotificationsRecentGet operation in NotificationsApi.
 */
export interface NotificationsApiApiNotificationsRecentGetRequest {
    /**
     * Maximum number of notifications to return (default: 5)
     */
    readonly limit?: number
}

/**
 * NotificationsApi - object-oriented interface
 */
export class NotificationsApi extends BaseAPI implements NotificationsApiInterface {
    /**
     * 
     * @summary Gets available action types for the preferences UI.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsActionTypesGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsActionTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets available delivery channels for the preferences UI.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsDeliveryChannelsGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsDeliveryChannelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets paginated notifications for the current user. Supports filtering by client, binder, action type, read status, and date range.
     * @param {NotificationsApiApiNotificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsGet(requestParameters: NotificationsApiApiNotificationsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsGet(requestParameters.clientId, requestParameters.recipientClientId, requestParameters.binderId, requestParameters.actionType, requestParameters.isRead, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dismisses a notification without marking it as read.
     * @param {NotificationsApiApiNotificationsIdDismissPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsIdDismissPost(requestParameters: NotificationsApiApiNotificationsIdDismissPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsIdDismissPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks a single notification as read.
     * @param {NotificationsApiApiNotificationsIdReadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsIdReadPost(requestParameters: NotificationsApiApiNotificationsIdReadPostRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsIdReadPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks all notifications as read for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsReadAllPost(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsReadAllPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks multiple notifications as read.
     * @param {NotificationsApiApiNotificationsReadBatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsReadBatchPost(requestParameters: NotificationsApiApiNotificationsReadBatchPostRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsReadBatchPost(requestParameters.markNotificationsReadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets recent notifications for the dropdown display.
     * @param {NotificationsApiApiNotificationsRecentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsRecentGet(requestParameters: NotificationsApiApiNotificationsRecentGetRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsRecentGet(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the count of unread notifications for the current user. Used for the notification badge in the UI.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsUnreadCountGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsUnreadCountGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OptionsApi - axios parameter creator
 */
export const OptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves all AnchorPoint enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsAnchorPointsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/anchor-points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all BinderStage enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderStagesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/binder-stages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all BinderStage enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/binder-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all BinderType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/binder-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all ClientResponseType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientResponseTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/client-response-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all ClientStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/client-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all ClientType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/client-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all ClientUserRole enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientUserRolesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/client-user-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all CoordinateSystem enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsCoordinateSystemsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/coordinate-systems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all DocumentDirection enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentDirectionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/document-directions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all DocumentRequestPriority enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentRequestPrioritiesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/document-request-priorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all DocumentRequestStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentRequestStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/document-request-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue #95 Item #20: Cached for 1 hour (3600 seconds) as enum values rarely change
         * @summary Retrieves all DocumentStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/document-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue #95 Item #20: Cached for 1 hour (3600 seconds) as enum values rarely change
         * @summary Retrieves all DocumentType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/document-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all NotificationPriority enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationPrioritiesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/notification-priorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all NotificationStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/notification-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all NotificationType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/notification-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all ProcessingStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsProcessingStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/processing-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all QuestionType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsQuestionTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/question-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all QuestionnaireStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsQuestionnaireStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/questionnaire-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all SignatureCancellationStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureCancellationStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/signature-cancellation-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all SignatureFieldType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureFieldTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/signature-field-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all SignatureStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/signature-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all TaxType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsTaxTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/tax-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all UserRole enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsUserRolesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/enums/user-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cached for 30 minutes as office data rarely changes
         * @summary Retrieves all offices as options for dropdowns/filters. Public endpoint for access request form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsOfficesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Options/offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OptionsApi - functional programming interface
 */
export const OptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves all AnchorPoint enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsAnchorPointsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsAnchorPointsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsAnchorPointsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all BinderStage enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsBinderStagesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsBinderStagesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsBinderStagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all BinderStage enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsBinderStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsBinderStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsBinderStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all BinderType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsBinderTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsBinderTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsBinderTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all ClientResponseType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsClientResponseTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsClientResponseTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsClientResponseTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all ClientStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsClientStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsClientStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsClientStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all ClientType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsClientTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsClientTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsClientTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all ClientUserRole enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsClientUserRolesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsClientUserRolesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsClientUserRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all CoordinateSystem enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsCoordinateSystemsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsCoordinateSystemsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsCoordinateSystemsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all DocumentDirection enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsDocumentDirectionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsDocumentDirectionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsDocumentDirectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all DocumentRequestPriority enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsDocumentRequestPrioritiesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsDocumentRequestPrioritiesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsDocumentRequestPrioritiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all DocumentRequestStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsDocumentRequestStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsDocumentRequestStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsDocumentRequestStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue #95 Item #20: Cached for 1 hour (3600 seconds) as enum values rarely change
         * @summary Retrieves all DocumentStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsDocumentStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsDocumentStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsDocumentStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue #95 Item #20: Cached for 1 hour (3600 seconds) as enum values rarely change
         * @summary Retrieves all DocumentType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsDocumentTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsDocumentTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsDocumentTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all NotificationPriority enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsNotificationPrioritiesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsNotificationPrioritiesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsNotificationPrioritiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all NotificationStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsNotificationStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsNotificationStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsNotificationStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all NotificationType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsNotificationTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsNotificationTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsNotificationTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all ProcessingStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsProcessingStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsProcessingStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsProcessingStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all QuestionType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsQuestionTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsQuestionTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsQuestionTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all QuestionnaireStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsQuestionnaireStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsQuestionnaireStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsQuestionnaireStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all SignatureCancellationStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsSignatureCancellationStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsSignatureCancellationStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsSignatureCancellationStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all SignatureFieldType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsSignatureFieldTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsSignatureFieldTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsSignatureFieldTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all SignatureStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsSignatureStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsSignatureStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsSignatureStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all TaxType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsTaxTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsTaxTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsTaxTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all UserRole enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsEnumsUserRolesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumOptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsEnumsUserRolesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsEnumsUserRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cached for 30 minutes as office data rarely changes
         * @summary Retrieves all offices as options for dropdowns/filters. Public endpoint for access request form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsOfficesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OptionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsOfficesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptionsApi.apiOptionsOfficesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OptionsApi - factory interface
 */
export const OptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OptionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves all AnchorPoint enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsAnchorPointsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsAnchorPointsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all BinderStage enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderStagesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsBinderStagesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all BinderStage enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsBinderStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all BinderType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsBinderTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsBinderTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all ClientResponseType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientResponseTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsClientResponseTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all ClientStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsClientStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all ClientType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsClientTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all ClientUserRole enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsClientUserRolesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsClientUserRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all CoordinateSystem enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsCoordinateSystemsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsCoordinateSystemsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all DocumentDirection enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentDirectionsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsDocumentDirectionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all DocumentRequestPriority enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentRequestPrioritiesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsDocumentRequestPrioritiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all DocumentRequestStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentRequestStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsDocumentRequestStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Issue #95 Item #20: Cached for 1 hour (3600 seconds) as enum values rarely change
         * @summary Retrieves all DocumentStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsDocumentStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Issue #95 Item #20: Cached for 1 hour (3600 seconds) as enum values rarely change
         * @summary Retrieves all DocumentType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsDocumentTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsDocumentTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all NotificationPriority enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationPrioritiesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsNotificationPrioritiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all NotificationStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsNotificationStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all NotificationType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsNotificationTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsNotificationTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all ProcessingStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsProcessingStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsProcessingStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all QuestionType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsQuestionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsQuestionTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all QuestionnaireStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsQuestionnaireStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsQuestionnaireStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all SignatureCancellationStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureCancellationStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsSignatureCancellationStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all SignatureFieldType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureFieldTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsSignatureFieldTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all SignatureStatus enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsSignatureStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsSignatureStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all TaxType enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsTaxTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsTaxTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all UserRole enum values with display names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsEnumsUserRolesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse> {
            return localVarFp.apiOptionsEnumsUserRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Cached for 30 minutes as office data rarely changes
         * @summary Retrieves all offices as options for dropdowns/filters. Public endpoint for access request form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsOfficesGet(options?: RawAxiosRequestConfig): AxiosPromise<OptionDtoListApiResponse> {
            return localVarFp.apiOptionsOfficesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OptionsApi - interface
 */
export interface OptionsApiInterface {
    /**
     * 
     * @summary Retrieves all AnchorPoint enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsAnchorPointsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all BinderStage enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsBinderStagesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all BinderStage enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsBinderStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all BinderType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsBinderTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all ClientResponseType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsClientResponseTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all ClientStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsClientStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all ClientType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsClientTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all ClientUserRole enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsClientUserRolesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all CoordinateSystem enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsCoordinateSystemsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all DocumentDirection enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsDocumentDirectionsGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all DocumentRequestPriority enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsDocumentRequestPrioritiesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all DocumentRequestStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsDocumentRequestStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * Issue #95 Item #20: Cached for 1 hour (3600 seconds) as enum values rarely change
     * @summary Retrieves all DocumentStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsDocumentStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * Issue #95 Item #20: Cached for 1 hour (3600 seconds) as enum values rarely change
     * @summary Retrieves all DocumentType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsDocumentTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all NotificationPriority enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsNotificationPrioritiesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all NotificationStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsNotificationStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all NotificationType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsNotificationTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all ProcessingStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsProcessingStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all QuestionType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsQuestionTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all QuestionnaireStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsQuestionnaireStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all SignatureCancellationStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsSignatureCancellationStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all SignatureFieldType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsSignatureFieldTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all SignatureStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsSignatureStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all TaxType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsTaxTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves all UserRole enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsEnumsUserRolesGet(options?: RawAxiosRequestConfig): AxiosPromise<EnumOptionDtoListApiResponse>;

    /**
     * Cached for 30 minutes as office data rarely changes
     * @summary Retrieves all offices as options for dropdowns/filters. Public endpoint for access request form.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOptionsOfficesGet(options?: RawAxiosRequestConfig): AxiosPromise<OptionDtoListApiResponse>;

}

/**
 * OptionsApi - object-oriented interface
 */
export class OptionsApi extends BaseAPI implements OptionsApiInterface {
    /**
     * 
     * @summary Retrieves all AnchorPoint enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsAnchorPointsGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsAnchorPointsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all BinderStage enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsBinderStagesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsBinderStagesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all BinderStage enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsBinderStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsBinderStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all BinderType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsBinderTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsBinderTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all ClientResponseType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsClientResponseTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsClientResponseTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all ClientStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsClientStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsClientStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all ClientType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsClientTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsClientTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all ClientUserRole enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsClientUserRolesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsClientUserRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all CoordinateSystem enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsCoordinateSystemsGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsCoordinateSystemsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all DocumentDirection enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsDocumentDirectionsGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsDocumentDirectionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all DocumentRequestPriority enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsDocumentRequestPrioritiesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsDocumentRequestPrioritiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all DocumentRequestStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsDocumentRequestStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsDocumentRequestStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue #95 Item #20: Cached for 1 hour (3600 seconds) as enum values rarely change
     * @summary Retrieves all DocumentStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsDocumentStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsDocumentStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue #95 Item #20: Cached for 1 hour (3600 seconds) as enum values rarely change
     * @summary Retrieves all DocumentType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsDocumentTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsDocumentTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all NotificationPriority enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsNotificationPrioritiesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsNotificationPrioritiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all NotificationStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsNotificationStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsNotificationStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all NotificationType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsNotificationTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsNotificationTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all ProcessingStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsProcessingStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsProcessingStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all QuestionType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsQuestionTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsQuestionTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all QuestionnaireStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsQuestionnaireStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsQuestionnaireStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all SignatureCancellationStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsSignatureCancellationStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsSignatureCancellationStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all SignatureFieldType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsSignatureFieldTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsSignatureFieldTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all SignatureStatus enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsSignatureStatusesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsSignatureStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all TaxType enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsTaxTypesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsTaxTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all UserRole enum values with display names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsEnumsUserRolesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsEnumsUserRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cached for 30 minutes as office data rarely changes
     * @summary Retrieves all offices as options for dropdowns/filters. Public endpoint for access request form.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOptionsOfficesGet(options?: RawAxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsOfficesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PreparerDashboardApi - axios parameter creator
 */
export const PreparerDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves recent client activities including document uploads, signatures completed, and other workflow events.
         * @param {number} [limit] Maximum number of activities to return (default: 10, range: 1-50).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardActivitiesGet: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preparer-dashboard/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves recently active clients for the authenticated preparer based on recent document activity and interactions.
         * @param {number} [limit] Maximum number of clients to return (default: 10, range: 1-50).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardClientsGet: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preparer-dashboard/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves comprehensive dashboard data for the authenticated preparer including statistics, metrics, and recent activities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preparer-dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves dashboard metrics including documents awaiting review, pending signatures, and workflow status indicators.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardMetricsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preparer-dashboard/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves dashboard statistics including binder counts with percentage changes and period comparisons.
         * @param {string} [officeId] Optional office ID to filter statistics by a specific office
         * @param {string} [preparerId] Optional preparer ID to filter statistics (for Admin users viewing a specific preparer\&#39;s stats)
         * @param {number} [taxYear] Optional tax year to filter statistics (defaults to current year)
         * @param {boolean} [watchedClientsOnly] Filter to only show statistics for clients watched by the current user. Applies to all users (both admins and preparers) when explicitly set to true.
         * @param {boolean} [assignedToMe] Filter to only show statistics for binders assigned to the current user. When true, shows only binders where the current user is the preparer. When false or null (default), shows statistics for all binders (firm-wide stats).
         * @param {BinderStage} [stage] Optional binder stage filter to match the binder table filter
         * @param {ClientType} [taxType] Optional tax type (client type) filter to match the binder table filter
         * @param {boolean} [isClientSubmitted] Optional filter for client-submitted binders (Client Ready filter)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardStatsGet: async (officeId?: string, preparerId?: string, taxYear?: number, watchedClientsOnly?: boolean, assignedToMe?: boolean, stage?: BinderStage, taxType?: ClientType, isClientSubmitted?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preparer-dashboard/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            if (preparerId !== undefined) {
                localVarQueryParameter['PreparerId'] = preparerId;
            }

            if (taxYear !== undefined) {
                localVarQueryParameter['TaxYear'] = taxYear;
            }

            if (watchedClientsOnly !== undefined) {
                localVarQueryParameter['WatchedClientsOnly'] = watchedClientsOnly;
            }

            if (assignedToMe !== undefined) {
                localVarQueryParameter['AssignedToMe'] = assignedToMe;
            }

            if (stage !== undefined) {
                localVarQueryParameter['Stage'] = stage;
            }

            if (taxType !== undefined) {
                localVarQueryParameter['TaxType'] = taxType;
            }

            if (isClientSubmitted !== undefined) {
                localVarQueryParameter['IsClientSubmitted'] = isClientSubmitted;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreparerDashboardApi - functional programming interface
 */
export const PreparerDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreparerDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves recent client activities including document uploads, signatures completed, and other workflow events.
         * @param {number} [limit] Maximum number of activities to return (default: 10, range: 1-50).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPreparerDashboardActivitiesGet(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentActivityDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPreparerDashboardActivitiesGet(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparerDashboardApi.apiPreparerDashboardActivitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves recently active clients for the authenticated preparer based on recent document activity and interactions.
         * @param {number} [limit] Maximum number of clients to return (default: 10, range: 1-50).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPreparerDashboardClientsGet(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentClientDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPreparerDashboardClientsGet(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparerDashboardApi.apiPreparerDashboardClientsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves comprehensive dashboard data for the authenticated preparer including statistics, metrics, and recent activities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPreparerDashboardGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPreparerDashboardGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparerDashboardApi.apiPreparerDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves dashboard metrics including documents awaiting review, pending signatures, and workflow status indicators.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPreparerDashboardMetricsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardMetricsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPreparerDashboardMetricsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparerDashboardApi.apiPreparerDashboardMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves dashboard statistics including binder counts with percentage changes and period comparisons.
         * @param {string} [officeId] Optional office ID to filter statistics by a specific office
         * @param {string} [preparerId] Optional preparer ID to filter statistics (for Admin users viewing a specific preparer\&#39;s stats)
         * @param {number} [taxYear] Optional tax year to filter statistics (defaults to current year)
         * @param {boolean} [watchedClientsOnly] Filter to only show statistics for clients watched by the current user. Applies to all users (both admins and preparers) when explicitly set to true.
         * @param {boolean} [assignedToMe] Filter to only show statistics for binders assigned to the current user. When true, shows only binders where the current user is the preparer. When false or null (default), shows statistics for all binders (firm-wide stats).
         * @param {BinderStage} [stage] Optional binder stage filter to match the binder table filter
         * @param {ClientType} [taxType] Optional tax type (client type) filter to match the binder table filter
         * @param {boolean} [isClientSubmitted] Optional filter for client-submitted binders (Client Ready filter)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPreparerDashboardStatsGet(officeId?: string, preparerId?: string, taxYear?: number, watchedClientsOnly?: boolean, assignedToMe?: boolean, stage?: BinderStage, taxType?: ClientType, isClientSubmitted?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardStatsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPreparerDashboardStatsGet(officeId, preparerId, taxYear, watchedClientsOnly, assignedToMe, stage, taxType, isClientSubmitted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparerDashboardApi.apiPreparerDashboardStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PreparerDashboardApi - factory interface
 */
export const PreparerDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreparerDashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves recent client activities including document uploads, signatures completed, and other workflow events.
         * @param {PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardActivitiesGet(requestParameters: PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RecentActivityDtoListApiResponse> {
            return localVarFp.apiPreparerDashboardActivitiesGet(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves recently active clients for the authenticated preparer based on recent document activity and interactions.
         * @param {PreparerDashboardApiApiPreparerDashboardClientsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardClientsGet(requestParameters: PreparerDashboardApiApiPreparerDashboardClientsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RecentClientDtoListApiResponse> {
            return localVarFp.apiPreparerDashboardClientsGet(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves comprehensive dashboard data for the authenticated preparer including statistics, metrics, and recent activities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<DashboardDtoApiResponse> {
            return localVarFp.apiPreparerDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves dashboard metrics including documents awaiting review, pending signatures, and workflow status indicators.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<DashboardMetricsDtoApiResponse> {
            return localVarFp.apiPreparerDashboardMetricsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves dashboard statistics including binder counts with percentage changes and period comparisons.
         * @param {PreparerDashboardApiApiPreparerDashboardStatsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPreparerDashboardStatsGet(requestParameters: PreparerDashboardApiApiPreparerDashboardStatsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DashboardStatsDtoApiResponse> {
            return localVarFp.apiPreparerDashboardStatsGet(requestParameters.officeId, requestParameters.preparerId, requestParameters.taxYear, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.stage, requestParameters.taxType, requestParameters.isClientSubmitted, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PreparerDashboardApi - interface
 */
export interface PreparerDashboardApiInterface {
    /**
     * 
     * @summary Retrieves recent client activities including document uploads, signatures completed, and other workflow events.
     * @param {PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPreparerDashboardActivitiesGet(requestParameters?: PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecentActivityDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves recently active clients for the authenticated preparer based on recent document activity and interactions.
     * @param {PreparerDashboardApiApiPreparerDashboardClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPreparerDashboardClientsGet(requestParameters?: PreparerDashboardApiApiPreparerDashboardClientsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecentClientDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves comprehensive dashboard data for the authenticated preparer including statistics, metrics, and recent activities.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPreparerDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<DashboardDtoApiResponse>;

    /**
     * 
     * @summary Retrieves dashboard metrics including documents awaiting review, pending signatures, and workflow status indicators.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPreparerDashboardMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<DashboardMetricsDtoApiResponse>;

    /**
     * 
     * @summary Retrieves dashboard statistics including binder counts with percentage changes and period comparisons.
     * @param {PreparerDashboardApiApiPreparerDashboardStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPreparerDashboardStatsGet(requestParameters?: PreparerDashboardApiApiPreparerDashboardStatsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardStatsDtoApiResponse>;

}

/**
 * Request parameters for apiPreparerDashboardActivitiesGet operation in PreparerDashboardApi.
 */
export interface PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest {
    /**
     * Maximum number of activities to return (default: 10, range: 1-50).
     */
    readonly limit?: number
}

/**
 * Request parameters for apiPreparerDashboardClientsGet operation in PreparerDashboardApi.
 */
export interface PreparerDashboardApiApiPreparerDashboardClientsGetRequest {
    /**
     * Maximum number of clients to return (default: 10, range: 1-50).
     */
    readonly limit?: number
}

/**
 * Request parameters for apiPreparerDashboardStatsGet operation in PreparerDashboardApi.
 */
export interface PreparerDashboardApiApiPreparerDashboardStatsGetRequest {
    /**
     * Optional office ID to filter statistics by a specific office
     */
    readonly officeId?: string

    /**
     * Optional preparer ID to filter statistics (for Admin users viewing a specific preparer\&#39;s stats)
     */
    readonly preparerId?: string

    /**
     * Optional tax year to filter statistics (defaults to current year)
     */
    readonly taxYear?: number

    /**
     * Filter to only show statistics for clients watched by the current user. Applies to all users (both admins and preparers) when explicitly set to true.
     */
    readonly watchedClientsOnly?: boolean

    /**
     * Filter to only show statistics for binders assigned to the current user. When true, shows only binders where the current user is the preparer. When false or null (default), shows statistics for all binders (firm-wide stats).
     */
    readonly assignedToMe?: boolean

    /**
     * Optional binder stage filter to match the binder table filter
     */
    readonly stage?: BinderStage

    /**
     * Optional tax type (client type) filter to match the binder table filter
     */
    readonly taxType?: ClientType

    /**
     * Optional filter for client-submitted binders (Client Ready filter)
     */
    readonly isClientSubmitted?: boolean
}

/**
 * PreparerDashboardApi - object-oriented interface
 */
export class PreparerDashboardApi extends BaseAPI implements PreparerDashboardApiInterface {
    /**
     * 
     * @summary Retrieves recent client activities including document uploads, signatures completed, and other workflow events.
     * @param {PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPreparerDashboardActivitiesGet(requestParameters: PreparerDashboardApiApiPreparerDashboardActivitiesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PreparerDashboardApiFp(this.configuration).apiPreparerDashboardActivitiesGet(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves recently active clients for the authenticated preparer based on recent document activity and interactions.
     * @param {PreparerDashboardApiApiPreparerDashboardClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPreparerDashboardClientsGet(requestParameters: PreparerDashboardApiApiPreparerDashboardClientsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PreparerDashboardApiFp(this.configuration).apiPreparerDashboardClientsGet(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves comprehensive dashboard data for the authenticated preparer including statistics, metrics, and recent activities.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPreparerDashboardGet(options?: RawAxiosRequestConfig) {
        return PreparerDashboardApiFp(this.configuration).apiPreparerDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves dashboard metrics including documents awaiting review, pending signatures, and workflow status indicators.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPreparerDashboardMetricsGet(options?: RawAxiosRequestConfig) {
        return PreparerDashboardApiFp(this.configuration).apiPreparerDashboardMetricsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves dashboard statistics including binder counts with percentage changes and period comparisons.
     * @param {PreparerDashboardApiApiPreparerDashboardStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPreparerDashboardStatsGet(requestParameters: PreparerDashboardApiApiPreparerDashboardStatsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PreparerDashboardApiFp(this.configuration).apiPreparerDashboardStatsGet(requestParameters.officeId, requestParameters.preparerId, requestParameters.taxYear, requestParameters.watchedClientsOnly, requestParameters.assignedToMe, requestParameters.stage, requestParameters.taxType, requestParameters.isClientSubmitted, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionnaireApi - axios parameter creator
 */
export const QuestionnaireApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint returns the raw JSON string that was submitted when the questionnaire was completed. If the questionnaire has not been completed, a 404 error is returned.
         * @summary Retrieves the questionnaire answers for a binder. Only preparers and admins can view questionnaire answers.
         * @param {string} binderId The unique identifier of the binder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireAnswersGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdQuestionnaireAnswersGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/questionnaire/answers`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation clears both the completion timestamp and the stored answers. A SignalR notification is sent to inform relevant parties of the reset.
         * @summary Resets a binder\'s questionnaire completion status, clearing the timestamp and answers. Only preparers and admins can reset questionnaires.
         * @param {string} binderId The unique identifier of the binder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireCompleteDelete: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdQuestionnaireCompleteDelete', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/questionnaire/complete`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                  PUT /api/tax-binders/3fa85f64-5717-4562-b3fc-2c963f66afa6/questionnaire/complete     {       \"answers\": {         \"question1\": \"answer1\",         \"question2\": 42,         \"question3\": [\"option1\", \"option2\"]       }     }              For Client role users, the X-Active-Client-Id header is required and the binder must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional. Archived binders cannot have their questionnaires completed.
         * @summary Marks a binder\'s questionnaire as complete with the provided answers. Clients can only complete questionnaires for their own binders (via active client context). Preparers and admins can complete questionnaires for any binder.
         * @param {string} binderId The unique identifier of the binder.
         * @param {CompleteQuestionnaireRequest} [completeQuestionnaireRequest] The questionnaire answers as a JSON object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireCompletePut: async (binderId: string, completeQuestionnaireRequest?: CompleteQuestionnaireRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdQuestionnaireCompletePut', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/questionnaire/complete`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeQuestionnaireRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionnaireApi - functional programming interface
 */
export const QuestionnaireApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionnaireApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint returns the raw JSON string that was submitted when the questionnaire was completed. If the questionnaire has not been completed, a 404 error is returned.
         * @summary Retrieves the questionnaire answers for a binder. Only preparers and admins can view questionnaire answers.
         * @param {string} binderId The unique identifier of the binder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdQuestionnaireAnswersGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdQuestionnaireAnswersGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireApi.apiTaxBindersBinderIdQuestionnaireAnswersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This operation clears both the completion timestamp and the stored answers. A SignalR notification is sent to inform relevant parties of the reset.
         * @summary Resets a binder\'s questionnaire completion status, clearing the timestamp and answers. Only preparers and admins can reset questionnaires.
         * @param {string} binderId The unique identifier of the binder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdQuestionnaireCompleteDelete(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdQuestionnaireCompleteDelete(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireApi.apiTaxBindersBinderIdQuestionnaireCompleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                  PUT /api/tax-binders/3fa85f64-5717-4562-b3fc-2c963f66afa6/questionnaire/complete     {       \"answers\": {         \"question1\": \"answer1\",         \"question2\": 42,         \"question3\": [\"option1\", \"option2\"]       }     }              For Client role users, the X-Active-Client-Id header is required and the binder must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional. Archived binders cannot have their questionnaires completed.
         * @summary Marks a binder\'s questionnaire as complete with the provided answers. Clients can only complete questionnaires for their own binders (via active client context). Preparers and admins can complete questionnaires for any binder.
         * @param {string} binderId The unique identifier of the binder.
         * @param {CompleteQuestionnaireRequest} [completeQuestionnaireRequest] The questionnaire answers as a JSON object.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdQuestionnaireCompletePut(binderId: string, completeQuestionnaireRequest?: CompleteQuestionnaireRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdQuestionnaireCompletePut(binderId, completeQuestionnaireRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireApi.apiTaxBindersBinderIdQuestionnaireCompletePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionnaireApi - factory interface
 */
export const QuestionnaireApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionnaireApiFp(configuration)
    return {
        /**
         * This endpoint returns the raw JSON string that was submitted when the questionnaire was completed. If the questionnaire has not been completed, a 404 error is returned.
         * @summary Retrieves the questionnaire answers for a binder. Only preparers and admins can view questionnaire answers.
         * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireAnswersGet(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiTaxBindersBinderIdQuestionnaireAnswersGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation clears both the completion timestamp and the stored answers. A SignalR notification is sent to inform relevant parties of the reset.
         * @summary Resets a binder\'s questionnaire completion status, clearing the timestamp and answers. Only preparers and admins can reset questionnaires.
         * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireCompleteDelete(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdQuestionnaireCompleteDelete(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                  PUT /api/tax-binders/3fa85f64-5717-4562-b3fc-2c963f66afa6/questionnaire/complete     {       \"answers\": {         \"question1\": \"answer1\",         \"question2\": 42,         \"question3\": [\"option1\", \"option2\"]       }     }              For Client role users, the X-Active-Client-Id header is required and the binder must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional. Archived binders cannot have their questionnaires completed.
         * @summary Marks a binder\'s questionnaire as complete with the provided answers. Clients can only complete questionnaires for their own binders (via active client context). Preparers and admins can complete questionnaires for any binder.
         * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdQuestionnaireCompletePut(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdQuestionnaireCompletePut(requestParameters.binderId, requestParameters.completeQuestionnaireRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionnaireApi - interface
 */
export interface QuestionnaireApiInterface {
    /**
     * This endpoint returns the raw JSON string that was submitted when the questionnaire was completed. If the questionnaire has not been completed, a 404 error is returned.
     * @summary Retrieves the questionnaire answers for a binder. Only preparers and admins can view questionnaire answers.
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdQuestionnaireAnswersGet(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

    /**
     * This operation clears both the completion timestamp and the stored answers. A SignalR notification is sent to inform relevant parties of the reset.
     * @summary Resets a binder\'s questionnaire completion status, clearing the timestamp and answers. Only preparers and admins can reset questionnaires.
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdQuestionnaireCompleteDelete(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * Sample request:                  PUT /api/tax-binders/3fa85f64-5717-4562-b3fc-2c963f66afa6/questionnaire/complete     {       \"answers\": {         \"question1\": \"answer1\",         \"question2\": 42,         \"question3\": [\"option1\", \"option2\"]       }     }              For Client role users, the X-Active-Client-Id header is required and the binder must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional. Archived binders cannot have their questionnaires completed.
     * @summary Marks a binder\'s questionnaire as complete with the provided answers. Clients can only complete questionnaires for their own binders (via active client context). Preparers and admins can complete questionnaires for any binder.
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdQuestionnaireCompletePut(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

}

/**
 * Request parameters for apiTaxBindersBinderIdQuestionnaireAnswersGet operation in QuestionnaireApi.
 */
export interface QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest {
    /**
     * The unique identifier of the binder.
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdQuestionnaireCompleteDelete operation in QuestionnaireApi.
 */
export interface QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest {
    /**
     * The unique identifier of the binder.
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdQuestionnaireCompletePut operation in QuestionnaireApi.
 */
export interface QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest {
    /**
     * The unique identifier of the binder.
     */
    readonly binderId: string

    /**
     * The questionnaire answers as a JSON object.
     */
    readonly completeQuestionnaireRequest?: CompleteQuestionnaireRequest
}

/**
 * QuestionnaireApi - object-oriented interface
 */
export class QuestionnaireApi extends BaseAPI implements QuestionnaireApiInterface {
    /**
     * This endpoint returns the raw JSON string that was submitted when the questionnaire was completed. If the questionnaire has not been completed, a 404 error is returned.
     * @summary Retrieves the questionnaire answers for a binder. Only preparers and admins can view questionnaire answers.
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdQuestionnaireAnswersGet(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireAnswersGetRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).apiTaxBindersBinderIdQuestionnaireAnswersGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation clears both the completion timestamp and the stored answers. A SignalR notification is sent to inform relevant parties of the reset.
     * @summary Resets a binder\'s questionnaire completion status, clearing the timestamp and answers. Only preparers and admins can reset questionnaires.
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdQuestionnaireCompleteDelete(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).apiTaxBindersBinderIdQuestionnaireCompleteDelete(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                  PUT /api/tax-binders/3fa85f64-5717-4562-b3fc-2c963f66afa6/questionnaire/complete     {       \"answers\": {         \"question1\": \"answer1\",         \"question2\": 42,         \"question3\": [\"option1\", \"option2\"]       }     }              For Client role users, the X-Active-Client-Id header is required and the binder must belong to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional. Archived binders cannot have their questionnaires completed.
     * @summary Marks a binder\'s questionnaire as complete with the provided answers. Clients can only complete questionnaires for their own binders (via active client context). Preparers and admins can complete questionnaires for any binder.
     * @param {QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdQuestionnaireCompletePut(requestParameters: QuestionnaireApiApiTaxBindersBinderIdQuestionnaireCompletePutRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireApiFp(this.configuration).apiTaxBindersBinderIdQuestionnaireCompletePut(requestParameters.binderId, requestParameters.completeQuestionnaireRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionnaireResponsesApi - axios parameter creator
 */
export const QuestionnaireResponsesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves a paginated list of questionnaire responses with optional filtering. Client role: Requires X-Active-Client-Id header. Preparer/Admin: Optional filtering by client.
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {QuestionnaireStatus} [status] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesGet: async (page?: number, limit?: number, binderId?: string, status?: QuestionnaireStatus, fromDate?: string, toDate?: string, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/questionnaire-responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (binderId !== undefined) {
                localVarQueryParameter['BinderId'] = binderId;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['FromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['ToDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently deletes a questionnaire response from the database. Clients can delete their own responses. Preparers/Admins can delete any response.
         * @param {string} id The unique identifier of the questionnaire response to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnaireResponsesIdDelete', 'id', id)
            const localVarPath = `/api/questionnaire-responses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific questionnaire response by its unique identifier.
         * @param {string} id The unique identifier of the questionnaire response to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnaireResponsesIdGet', 'id', id)
            const localVarPath = `/api/questionnaire-responses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing questionnaire response. Only Draft responses can be updated. Once submitted, responses cannot be edited - they can only be reviewed.
         * @param {string} id The unique identifier of the questionnaire response to update.
         * @param {UpdateQuestionnaireResponseDto} [updateQuestionnaireResponseDto] Questionnaire response update data containing new JSON payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdPut: async (id: string, updateQuestionnaireResponseDto?: UpdateQuestionnaireResponseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnaireResponsesIdPut', 'id', id)
            const localVarPath = `/api/questionnaire-responses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionnaireResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submits a questionnaire response for review. Changes status from Draft to Submitted. Increments version number and triggers notification to preparers/admins.
         * @param {string} id The unique identifier of the questionnaire response to submit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdSubmitPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnaireResponsesIdSubmitPost', 'id', id)
            const localVarPath = `/api/questionnaire-responses/{id}/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new questionnaire response in Draft status for a specific organizer. Response data is stored as JSONB for maximum flexibility.
         * @param {CreateQuestionnaireResponseDto} [createQuestionnaireResponseDto] Questionnaire response creation data including organizer ID and JSON payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesPost: async (createQuestionnaireResponseDto?: CreateQuestionnaireResponseDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/questionnaire-responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionnaireResponseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionnaireResponsesApi - functional programming interface
 */
export const QuestionnaireResponsesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionnaireResponsesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves a paginated list of questionnaire responses with optional filtering. Client role: Requires X-Active-Client-Id header. Preparer/Admin: Optional filtering by client.
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [binderId] Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {QuestionnaireStatus} [status] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesGet(page?: number, limit?: number, binderId?: string, status?: QuestionnaireStatus, fromDate?: string, toDate?: string, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponseDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesGet(page, limit, binderId, status, fromDate, toDate, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently deletes a questionnaire response from the database. Clients can delete their own responses. Preparers/Admins can delete any response.
         * @param {string} id The unique identifier of the questionnaire response to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific questionnaire response by its unique identifier.
         * @param {string} id The unique identifier of the questionnaire response to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing questionnaire response. Only Draft responses can be updated. Once submitted, responses cannot be edited - they can only be reviewed.
         * @param {string} id The unique identifier of the questionnaire response to update.
         * @param {UpdateQuestionnaireResponseDto} [updateQuestionnaireResponseDto] Questionnaire response update data containing new JSON payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesIdPut(id: string, updateQuestionnaireResponseDto?: UpdateQuestionnaireResponseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesIdPut(id, updateQuestionnaireResponseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submits a questionnaire response for review. Changes status from Draft to Submitted. Increments version number and triggers notification to preparers/admins.
         * @param {string} id The unique identifier of the questionnaire response to submit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesIdSubmitPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesIdSubmitPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesIdSubmitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new questionnaire response in Draft status for a specific organizer. Response data is stored as JSONB for maximum flexibility.
         * @param {CreateQuestionnaireResponseDto} [createQuestionnaireResponseDto] Questionnaire response creation data including organizer ID and JSON payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnaireResponsesPost(createQuestionnaireResponseDto?: CreateQuestionnaireResponseDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnaireResponsesPost(createQuestionnaireResponseDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnaireResponsesApi.apiQuestionnaireResponsesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionnaireResponsesApi - factory interface
 */
export const QuestionnaireResponsesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionnaireResponsesApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves a paginated list of questionnaire responses with optional filtering. Client role: Requires X-Active-Client-Id header. Preparer/Admin: Optional filtering by client.
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesGet(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoPaginatedResponseApiResponse> {
            return localVarFp.apiQuestionnaireResponsesGet(requestParameters.page, requestParameters.limit, requestParameters.binderId, requestParameters.status, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently deletes a questionnaire response from the database. Clients can delete their own responses. Preparers/Admins can delete any response.
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdDelete(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiQuestionnaireResponsesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific questionnaire response by its unique identifier.
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdGet(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse> {
            return localVarFp.apiQuestionnaireResponsesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing questionnaire response. Only Draft responses can be updated. Once submitted, responses cannot be edited - they can only be reviewed.
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdPut(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse> {
            return localVarFp.apiQuestionnaireResponsesIdPut(requestParameters.id, requestParameters.updateQuestionnaireResponseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submits a questionnaire response for review. Changes status from Draft to Submitted. Increments version number and triggers notification to preparers/admins.
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesIdSubmitPost(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse> {
            return localVarFp.apiQuestionnaireResponsesIdSubmitPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new questionnaire response in Draft status for a specific organizer. Response data is stored as JSONB for maximum flexibility.
         * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnaireResponsesPost(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse> {
            return localVarFp.apiQuestionnaireResponsesPost(requestParameters.createQuestionnaireResponseDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionnaireResponsesApi - interface
 */
export interface QuestionnaireResponsesApiInterface {
    /**
     * 
     * @summary Retrieves a paginated list of questionnaire responses with optional filtering. Client role: Requires X-Active-Client-Id header. Preparer/Admin: Optional filtering by client.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesGet(requestParameters?: QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Permanently deletes a questionnaire response from the database. Clients can delete their own responses. Preparers/Admins can delete any response.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesIdDelete(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Retrieves detailed information about a specific questionnaire response by its unique identifier.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesIdGet(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse>;

    /**
     * 
     * @summary Updates an existing questionnaire response. Only Draft responses can be updated. Once submitted, responses cannot be edited - they can only be reviewed.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesIdPut(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse>;

    /**
     * 
     * @summary Submits a questionnaire response for review. Changes status from Draft to Submitted. Increments version number and triggers notification to preparers/admins.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesIdSubmitPost(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse>;

    /**
     * 
     * @summary Creates a new questionnaire response in Draft status for a specific organizer. Response data is stored as JSONB for maximum flexibility.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnaireResponsesPost(requestParameters?: QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponseDtoApiResponse>;

}

/**
 * Request parameters for apiQuestionnaireResponsesGet operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest {
    readonly page?: number

    readonly limit?: number

    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId?: string

    readonly status?: QuestionnaireStatus

    readonly fromDate?: string

    readonly toDate?: string

    readonly sortBy?: string

    readonly sortOrder?: string
}

/**
 * Request parameters for apiQuestionnaireResponsesIdDelete operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest {
    /**
     * The unique identifier of the questionnaire response to delete.
     */
    readonly id: string
}

/**
 * Request parameters for apiQuestionnaireResponsesIdGet operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest {
    /**
     * The unique identifier of the questionnaire response to retrieve.
     */
    readonly id: string
}

/**
 * Request parameters for apiQuestionnaireResponsesIdPut operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest {
    /**
     * The unique identifier of the questionnaire response to update.
     */
    readonly id: string

    /**
     * Questionnaire response update data containing new JSON payload.
     */
    readonly updateQuestionnaireResponseDto?: UpdateQuestionnaireResponseDto
}

/**
 * Request parameters for apiQuestionnaireResponsesIdSubmitPost operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest {
    /**
     * The unique identifier of the questionnaire response to submit.
     */
    readonly id: string
}

/**
 * Request parameters for apiQuestionnaireResponsesPost operation in QuestionnaireResponsesApi.
 */
export interface QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest {
    /**
     * Questionnaire response creation data including organizer ID and JSON payload.
     */
    readonly createQuestionnaireResponseDto?: CreateQuestionnaireResponseDto
}

/**
 * QuestionnaireResponsesApi - object-oriented interface
 */
export class QuestionnaireResponsesApi extends BaseAPI implements QuestionnaireResponsesApiInterface {
    /**
     * 
     * @summary Retrieves a paginated list of questionnaire responses with optional filtering. Client role: Requires X-Active-Client-Id header. Preparer/Admin: Optional filtering by client.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesGet(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesGet(requestParameters.page, requestParameters.limit, requestParameters.binderId, requestParameters.status, requestParameters.fromDate, requestParameters.toDate, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently deletes a questionnaire response from the database. Clients can delete their own responses. Preparers/Admins can delete any response.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesIdDelete(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves detailed information about a specific questionnaire response by its unique identifier.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesIdGet(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdGetRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing questionnaire response. Only Draft responses can be updated. Once submitted, responses cannot be edited - they can only be reviewed.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesIdPut(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdPutRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesIdPut(requestParameters.id, requestParameters.updateQuestionnaireResponseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submits a questionnaire response for review. Changes status from Draft to Submitted. Increments version number and triggers notification to preparers/admins.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesIdSubmitPost(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesIdSubmitPostRequest, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesIdSubmitPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new questionnaire response in Draft status for a specific organizer. Response data is stored as JSONB for maximum flexibility.
     * @param {QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnaireResponsesPost(requestParameters: QuestionnaireResponsesApiApiQuestionnaireResponsesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionnaireResponsesApiFp(this.configuration).apiQuestionnaireResponsesPost(requestParameters.createQuestionnaireResponseDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionnairesApi - axios parameter creator
 */
export const QuestionnairesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves all active questionnaires available for a specific tax year.
         * @param {number} taxYear The tax year to filter questionnaires by (e.g., 2024).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesActiveTaxYearGet: async (taxYear: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taxYear' is not null or undefined
            assertParamExists('apiQuestionnairesActiveTaxYearGet', 'taxYear', taxYear)
            const localVarPath = `/api/questionnaires/active/{taxYear}`
                .replace(`{${"taxYear"}}`, encodeURIComponent(String(taxYear)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a paginated list of questionnaires with optional filtering and sorting.
         * @param {number} [taxYear] 
         * @param {boolean} [isActive] 
         * @param {boolean} [isRequired] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesGet: async (taxYear?: number, isActive?: boolean, isRequired?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/questionnaires`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (taxYear !== undefined) {
                localVarQueryParameter['TaxYear'] = taxYear;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (isRequired !== undefined) {
                localVarQueryParameter['IsRequired'] = isRequired;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently deletes a questionnaire from the system. Requires Admin role.
         * @param {string} id The unique identifier of the questionnaire to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnairesIdDelete', 'id', id)
            const localVarPath = `/api/questionnaires/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific questionnaire by its unique identifier.
         * @param {string} id The unique identifier of the questionnaire to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnairesIdGet', 'id', id)
            const localVarPath = `/api/questionnaires/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Publishes a questionnaire, making it active and available for client responses. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the questionnaire to publish.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdPublishPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnairesIdPublishPost', 'id', id)
            const localVarPath = `/api/questionnaires/{id}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing questionnaire\'s information and questions. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the questionnaire to update.
         * @param {UpdateQuestionnaireDto} [updateQuestionnaireDto] The questionnaire data to update with new information and questions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdPut: async (id: string, updateQuestionnaireDto?: UpdateQuestionnaireDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnairesIdPut', 'id', id)
            const localVarPath = `/api/questionnaires/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionnaireDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves statistical information and analytics for a specific questionnaire.
         * @param {string} id The unique identifier of the questionnaire to get statistics for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdStatisticsGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiQuestionnairesIdStatisticsGet', 'id', id)
            const localVarPath = `/api/questionnaires/{id}/statistics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new questionnaire with specified questions and configuration. Requires Preparer or Admin role.
         * @param {CreateQuestionnaireDto} [createQuestionnaireDto] The questionnaire data to create with questions and configuration options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesPost: async (createQuestionnaireDto?: CreateQuestionnaireDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/questionnaires`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionnaireDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionnairesApi - functional programming interface
 */
export const QuestionnairesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionnairesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves all active questionnaires available for a specific tax year.
         * @param {number} taxYear The tax year to filter questionnaires by (e.g., 2024).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesActiveTaxYearGet(taxYear: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesActiveTaxYearGet(taxYear, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesActiveTaxYearGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a paginated list of questionnaires with optional filtering and sorting.
         * @param {number} [taxYear] 
         * @param {boolean} [isActive] 
         * @param {boolean} [isRequired] 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesGet(taxYear?: number, isActive?: boolean, isRequired?: boolean, search?: string, sortBy?: string, sortDirection?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesGet(taxYear, isActive, isRequired, search, sortBy, sortDirection, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently deletes a questionnaire from the system. Requires Admin role.
         * @param {string} id The unique identifier of the questionnaire to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific questionnaire by its unique identifier.
         * @param {string} id The unique identifier of the questionnaire to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Publishes a questionnaire, making it active and available for client responses. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the questionnaire to publish.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesIdPublishPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesIdPublishPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesIdPublishPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing questionnaire\'s information and questions. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the questionnaire to update.
         * @param {UpdateQuestionnaireDto} [updateQuestionnaireDto] The questionnaire data to update with new information and questions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesIdPut(id: string, updateQuestionnaireDto?: UpdateQuestionnaireDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesIdPut(id, updateQuestionnaireDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves statistical information and analytics for a specific questionnaire.
         * @param {string} id The unique identifier of the questionnaire to get statistics for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesIdStatisticsGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringObjectDictionaryApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesIdStatisticsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesIdStatisticsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new questionnaire with specified questions and configuration. Requires Preparer or Admin role.
         * @param {CreateQuestionnaireDto} [createQuestionnaireDto] The questionnaire data to create with questions and configuration options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiQuestionnairesPost(createQuestionnaireDto?: CreateQuestionnaireDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiQuestionnairesPost(createQuestionnaireDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionnairesApi.apiQuestionnairesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionnairesApi - factory interface
 */
export const QuestionnairesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionnairesApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves all active questionnaires available for a specific tax year.
         * @param {QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesActiveTaxYearGet(requestParameters: QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoListApiResponse> {
            return localVarFp.apiQuestionnairesActiveTaxYearGet(requestParameters.taxYear, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a paginated list of questionnaires with optional filtering and sorting.
         * @param {QuestionnairesApiApiQuestionnairesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesGet(requestParameters: QuestionnairesApiApiQuestionnairesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoPaginatedResponseApiResponse> {
            return localVarFp.apiQuestionnairesGet(requestParameters.taxYear, requestParameters.isActive, requestParameters.isRequired, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently deletes a questionnaire from the system. Requires Admin role.
         * @param {QuestionnairesApiApiQuestionnairesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdDelete(requestParameters: QuestionnairesApiApiQuestionnairesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiQuestionnairesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific questionnaire by its unique identifier.
         * @param {QuestionnairesApiApiQuestionnairesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdGet(requestParameters: QuestionnairesApiApiQuestionnairesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse> {
            return localVarFp.apiQuestionnairesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Publishes a questionnaire, making it active and available for client responses. Requires Preparer or Admin role.
         * @param {QuestionnairesApiApiQuestionnairesIdPublishPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdPublishPost(requestParameters: QuestionnairesApiApiQuestionnairesIdPublishPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse> {
            return localVarFp.apiQuestionnairesIdPublishPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing questionnaire\'s information and questions. Requires Preparer or Admin role.
         * @param {QuestionnairesApiApiQuestionnairesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdPut(requestParameters: QuestionnairesApiApiQuestionnairesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse> {
            return localVarFp.apiQuestionnairesIdPut(requestParameters.id, requestParameters.updateQuestionnaireDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves statistical information and analytics for a specific questionnaire.
         * @param {QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesIdStatisticsGet(requestParameters: QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringObjectDictionaryApiResponse> {
            return localVarFp.apiQuestionnairesIdStatisticsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new questionnaire with specified questions and configuration. Requires Preparer or Admin role.
         * @param {QuestionnairesApiApiQuestionnairesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiQuestionnairesPost(requestParameters: QuestionnairesApiApiQuestionnairesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse> {
            return localVarFp.apiQuestionnairesPost(requestParameters.createQuestionnaireDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionnairesApi - interface
 */
export interface QuestionnairesApiInterface {
    /**
     * 
     * @summary Retrieves all active questionnaires available for a specific tax year.
     * @param {QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesActiveTaxYearGet(requestParameters: QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoListApiResponse>;

    /**
     * 
     * @summary Retrieves a paginated list of questionnaires with optional filtering and sorting.
     * @param {QuestionnairesApiApiQuestionnairesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesGet(requestParameters?: QuestionnairesApiApiQuestionnairesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Permanently deletes a questionnaire from the system. Requires Admin role.
     * @param {QuestionnairesApiApiQuestionnairesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesIdDelete(requestParameters: QuestionnairesApiApiQuestionnairesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Retrieves detailed information about a specific questionnaire by its unique identifier.
     * @param {QuestionnairesApiApiQuestionnairesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesIdGet(requestParameters: QuestionnairesApiApiQuestionnairesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse>;

    /**
     * 
     * @summary Publishes a questionnaire, making it active and available for client responses. Requires Preparer or Admin role.
     * @param {QuestionnairesApiApiQuestionnairesIdPublishPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesIdPublishPost(requestParameters: QuestionnairesApiApiQuestionnairesIdPublishPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse>;

    /**
     * 
     * @summary Updates an existing questionnaire\'s information and questions. Requires Preparer or Admin role.
     * @param {QuestionnairesApiApiQuestionnairesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesIdPut(requestParameters: QuestionnairesApiApiQuestionnairesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse>;

    /**
     * 
     * @summary Retrieves statistical information and analytics for a specific questionnaire.
     * @param {QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesIdStatisticsGet(requestParameters: QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringObjectDictionaryApiResponse>;

    /**
     * 
     * @summary Creates a new questionnaire with specified questions and configuration. Requires Preparer or Admin role.
     * @param {QuestionnairesApiApiQuestionnairesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiQuestionnairesPost(requestParameters?: QuestionnairesApiApiQuestionnairesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireDtoApiResponse>;

}

/**
 * Request parameters for apiQuestionnairesActiveTaxYearGet operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest {
    /**
     * The tax year to filter questionnaires by (e.g., 2024).
     */
    readonly taxYear: number
}

/**
 * Request parameters for apiQuestionnairesGet operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesGetRequest {
    readonly taxYear?: number

    readonly isActive?: boolean

    readonly isRequired?: boolean

    readonly search?: string

    readonly sortBy?: string

    readonly sortDirection?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiQuestionnairesIdDelete operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesIdDeleteRequest {
    /**
     * The unique identifier of the questionnaire to delete.
     */
    readonly id: string
}

/**
 * Request parameters for apiQuestionnairesIdGet operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesIdGetRequest {
    /**
     * The unique identifier of the questionnaire to retrieve.
     */
    readonly id: string
}

/**
 * Request parameters for apiQuestionnairesIdPublishPost operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesIdPublishPostRequest {
    /**
     * The unique identifier of the questionnaire to publish.
     */
    readonly id: string
}

/**
 * Request parameters for apiQuestionnairesIdPut operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesIdPutRequest {
    /**
     * The unique identifier of the questionnaire to update.
     */
    readonly id: string

    /**
     * The questionnaire data to update with new information and questions.
     */
    readonly updateQuestionnaireDto?: UpdateQuestionnaireDto
}

/**
 * Request parameters for apiQuestionnairesIdStatisticsGet operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest {
    /**
     * The unique identifier of the questionnaire to get statistics for.
     */
    readonly id: string
}

/**
 * Request parameters for apiQuestionnairesPost operation in QuestionnairesApi.
 */
export interface QuestionnairesApiApiQuestionnairesPostRequest {
    /**
     * The questionnaire data to create with questions and configuration options.
     */
    readonly createQuestionnaireDto?: CreateQuestionnaireDto
}

/**
 * QuestionnairesApi - object-oriented interface
 */
export class QuestionnairesApi extends BaseAPI implements QuestionnairesApiInterface {
    /**
     * 
     * @summary Retrieves all active questionnaires available for a specific tax year.
     * @param {QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesActiveTaxYearGet(requestParameters: QuestionnairesApiApiQuestionnairesActiveTaxYearGetRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesActiveTaxYearGet(requestParameters.taxYear, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a paginated list of questionnaires with optional filtering and sorting.
     * @param {QuestionnairesApiApiQuestionnairesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesGet(requestParameters: QuestionnairesApiApiQuestionnairesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesGet(requestParameters.taxYear, requestParameters.isActive, requestParameters.isRequired, requestParameters.search, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently deletes a questionnaire from the system. Requires Admin role.
     * @param {QuestionnairesApiApiQuestionnairesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesIdDelete(requestParameters: QuestionnairesApiApiQuestionnairesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves detailed information about a specific questionnaire by its unique identifier.
     * @param {QuestionnairesApiApiQuestionnairesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesIdGet(requestParameters: QuestionnairesApiApiQuestionnairesIdGetRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Publishes a questionnaire, making it active and available for client responses. Requires Preparer or Admin role.
     * @param {QuestionnairesApiApiQuestionnairesIdPublishPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesIdPublishPost(requestParameters: QuestionnairesApiApiQuestionnairesIdPublishPostRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesIdPublishPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing questionnaire\'s information and questions. Requires Preparer or Admin role.
     * @param {QuestionnairesApiApiQuestionnairesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesIdPut(requestParameters: QuestionnairesApiApiQuestionnairesIdPutRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesIdPut(requestParameters.id, requestParameters.updateQuestionnaireDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves statistical information and analytics for a specific questionnaire.
     * @param {QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesIdStatisticsGet(requestParameters: QuestionnairesApiApiQuestionnairesIdStatisticsGetRequest, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesIdStatisticsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new questionnaire with specified questions and configuration. Requires Preparer or Admin role.
     * @param {QuestionnairesApiApiQuestionnairesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiQuestionnairesPost(requestParameters: QuestionnairesApiApiQuestionnairesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionnairesApiFp(this.configuration).apiQuestionnairesPost(requestParameters.createQuestionnaireDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SignatureTemplatesApi - axios parameter creator
 */
export const SignatureTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create template from an existing document
         * @param {CreateTemplateFromDocumentDto} [createTemplateFromDocumentDto] Document-to-template conversion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesCreateFromDocumentPost: async (createTemplateFromDocumentDto?: CreateTemplateFromDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/create-from-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTemplateFromDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the default signature template configured for a specific document type.
         * @param {DocumentType} documentType Document type enumeration to get the default template for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesDefaultDocumentTypeGet: async (documentType: DocumentType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('apiSignaturesTemplatesDefaultDocumentTypeGet', 'documentType', documentType)
            const localVarPath = `/api/signatures/templates/default/{documentType}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a signature template by document type for automatic template selection.
         * @param {DocumentType} documentType Document type enumeration (e.g., W2&#x3D;0, Form1099&#x3D;1, Receipt&#x3D;2, TaxReturn&#x3D;3, etc.).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesDocumentTypeDocumentTypeGet: async (documentType: DocumentType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('apiSignaturesTemplatesDocumentTypeDocumentTypeGet', 'documentType', documentType)
            const localVarPath = `/api/signatures/templates/document-type/{documentType}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle form builder save callback from DocuSeal
         * @param {FormBuilderSaveDto} [formBuilderSaveDto] Form builder save data from DocuSeal onSave callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesFormBuilderSavePost: async (formBuilderSaveDto?: FormBuilderSaveDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/form-builder-save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formBuilderSaveDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create template from form builder data (DocuSeal callback endpoint)
         * @param {FormBuilderSaveDto} [formBuilderSaveDto] Form builder save data from DocuSeal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesFromBuilderPost: async (formBuilderSaveDto?: FormBuilderSaveDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/from-builder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formBuilderSaveDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get form builder configuration
         * @param {string} id Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdBuilderConfigGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdBuilderConfigGet', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}/builder-config`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate JWT token for form builder
         * @param {string} id Template ID
         * @param {FormBuilderTokenRequestDto} [formBuilderTokenRequestDto] Token request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdBuilderTokenPost: async (id: string, formBuilderTokenRequestDto?: FormBuilderTokenRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdBuilderTokenPost', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}/builder-token`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formBuilderTokenRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific signature template by its unique identifier.
         * @param {string} id The unique identifier of the signature template to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdGet', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manually delete a one-time template from DocuSeal and mark as used. This endpoint allows admins to clean up one-time templates without waiting for webhook completion. WARNING: This permanently deletes the template from DocuSeal.
         * @param {string} id Template ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdOneTimeCleanupDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdOneTimeCleanupDelete', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}/one-time-cleanup`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates a preview of a signature template with field overlays applied to a PDF document. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the signature template to preview.
         * @param {PreviewRequestDto} [previewRequestDto] The preview request containing the PDF document as base64 encoded data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdPreviewPost: async (id: string, previewRequestDto?: PreviewRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdPreviewPost', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing signature template\'s configuration and field definitions. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the signature template to update.
         * @param {UpdateSignatureTemplateDto} [updateSignatureTemplateDto] The signature template data to update with new configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdPut: async (id: string, updateSignatureTemplateDto?: UpdateSignatureTemplateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSignaturesTemplatesIdPut', 'id', id)
            const localVarPath = `/api/signatures/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSignatureTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new signature template with field configuration. Requires Preparer or Admin role.
         * @param {CreateSignatureTemplateDto} [createSignatureTemplateDto] The signature template data to create with field definitions and document type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesPost: async (createSignatureTemplateDto?: CreateSignatureTemplateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSignatureTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get signing form configuration
         * @param {boolean} [previewMode] Whether to get configuration for preview mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesSigningFormConfigGet: async (previewMode?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/signing-form-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (previewMode !== undefined) {
                localVarQueryParameter['previewMode'] = previewMode;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all signature templates as a simple list without pagination for dropdown selections.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesSimpleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/signatures/templates/simple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignatureTemplatesApi - functional programming interface
 */
export const SignatureTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignatureTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create template from an existing document
         * @param {CreateTemplateFromDocumentDto} [createTemplateFromDocumentDto] Document-to-template conversion request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesCreateFromDocumentPost(createTemplateFromDocumentDto?: CreateTemplateFromDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesCreateFromDocumentPost(createTemplateFromDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesCreateFromDocumentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves the default signature template configured for a specific document type.
         * @param {DocumentType} documentType Document type enumeration to get the default template for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesDefaultDocumentTypeGet(documentType: DocumentType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesDefaultDocumentTypeGet(documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesDefaultDocumentTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a signature template by document type for automatic template selection.
         * @param {DocumentType} documentType Document type enumeration (e.g., W2&#x3D;0, Form1099&#x3D;1, Receipt&#x3D;2, TaxReturn&#x3D;3, etc.).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesDocumentTypeDocumentTypeGet(documentType: DocumentType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesDocumentTypeDocumentTypeGet(documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesDocumentTypeDocumentTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Handle form builder save callback from DocuSeal
         * @param {FormBuilderSaveDto} [formBuilderSaveDto] Form builder save data from DocuSeal onSave callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesFormBuilderSavePost(formBuilderSaveDto?: FormBuilderSaveDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesFormBuilderSavePost(formBuilderSaveDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesFormBuilderSavePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create template from form builder data (DocuSeal callback endpoint)
         * @param {FormBuilderSaveDto} [formBuilderSaveDto] Form builder save data from DocuSeal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesFromBuilderPost(formBuilderSaveDto?: FormBuilderSaveDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesFromBuilderPost(formBuilderSaveDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesFromBuilderPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get form builder configuration
         * @param {string} id Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdBuilderConfigGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormBuilderConfigDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdBuilderConfigGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdBuilderConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate JWT token for form builder
         * @param {string} id Template ID
         * @param {FormBuilderTokenRequestDto} [formBuilderTokenRequestDto] Token request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdBuilderTokenPost(id: string, formBuilderTokenRequestDto?: FormBuilderTokenRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdBuilderTokenPost(id, formBuilderTokenRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdBuilderTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific signature template by its unique identifier.
         * @param {string} id The unique identifier of the signature template to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Manually delete a one-time template from DocuSeal and mark as used. This endpoint allows admins to clean up one-time templates without waiting for webhook completion. WARNING: This permanently deletes the template from DocuSeal.
         * @param {string} id Template ID to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdOneTimeCleanupDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdOneTimeCleanupDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdOneTimeCleanupDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generates a preview of a signature template with field overlays applied to a PDF document. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the signature template to preview.
         * @param {PreviewRequestDto} [previewRequestDto] The preview request containing the PDF document as base64 encoded data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdPreviewPost(id: string, previewRequestDto?: PreviewRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdPreviewPost(id, previewRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing signature template\'s configuration and field definitions. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the signature template to update.
         * @param {UpdateSignatureTemplateDto} [updateSignatureTemplateDto] The signature template data to update with new configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesIdPut(id: string, updateSignatureTemplateDto?: UpdateSignatureTemplateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesIdPut(id, updateSignatureTemplateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new signature template with field configuration. Requires Preparer or Admin role.
         * @param {CreateSignatureTemplateDto} [createSignatureTemplateDto] The signature template data to create with field definitions and document type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesPost(createSignatureTemplateDto?: CreateSignatureTemplateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesPost(createSignatureTemplateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get signing form configuration
         * @param {boolean} [previewMode] Whether to get configuration for preview mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesSigningFormConfigGet(previewMode?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SigningFormConfigDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesSigningFormConfigGet(previewMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesSigningFormConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves all signature templates as a simple list without pagination for dropdown selections.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesTemplatesSimpleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureTemplateDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesTemplatesSimpleGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignatureTemplatesApi.apiSignaturesTemplatesSimpleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SignatureTemplatesApi - factory interface
 */
export const SignatureTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignatureTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create template from an existing document
         * @param {SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesCreateFromDocumentPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesCreateFromDocumentPost(requestParameters.createTemplateFromDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the default signature template configured for a specific document type.
         * @param {SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesDefaultDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesDefaultDocumentTypeGet(requestParameters.documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a signature template by document type for automatic template selection.
         * @param {SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesDocumentTypeDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesDocumentTypeDocumentTypeGet(requestParameters.documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle form builder save callback from DocuSeal
         * @param {SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesFormBuilderSavePost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesFormBuilderSavePost(requestParameters.formBuilderSaveDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create template from form builder data (DocuSeal callback endpoint)
         * @param {SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesFromBuilderPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesFromBuilderPost(requestParameters.formBuilderSaveDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get form builder configuration
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdBuilderConfigGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormBuilderConfigDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdBuilderConfigGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate JWT token for form builder
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdBuilderTokenPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdBuilderTokenPost(requestParameters.id, requestParameters.formBuilderTokenRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific signature template by its unique identifier.
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manually delete a one-time template from DocuSeal and mark as used. This endpoint allows admins to clean up one-time templates without waiting for webhook completion. WARNING: This permanently deletes the template from DocuSeal.
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdOneTimeCleanupDelete(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdOneTimeCleanupDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates a preview of a signature template with field overlays applied to a PDF document. Requires Preparer or Admin role.
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdPreviewPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiSignaturesTemplatesIdPreviewPost(requestParameters.id, requestParameters.previewRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing signature template\'s configuration and field definitions. Requires Preparer or Admin role.
         * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesIdPut(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesIdPut(requestParameters.id, requestParameters.updateSignatureTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new signature template with field configuration. Requires Preparer or Admin role.
         * @param {SignatureTemplatesApiApiSignaturesTemplatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesPost(requestParameters.createSignatureTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get signing form configuration
         * @param {SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesSigningFormConfigGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SigningFormConfigDtoApiResponse> {
            return localVarFp.apiSignaturesTemplatesSigningFormConfigGet(requestParameters.previewMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all signature templates as a simple list without pagination for dropdown selections.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesTemplatesSimpleGet(options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoListApiResponse> {
            return localVarFp.apiSignaturesTemplatesSimpleGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignatureTemplatesApi - interface
 */
export interface SignatureTemplatesApiInterface {
    /**
     * 
     * @summary Create template from an existing document
     * @param {SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesCreateFromDocumentPost(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @summary Retrieves the default signature template configured for a specific document type.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesDefaultDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @summary Retrieves a signature template by document type for automatic template selection.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesDocumentTypeDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @summary Handle form builder save callback from DocuSeal
     * @param {SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesFormBuilderSavePost(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @summary Create template from form builder data (DocuSeal callback endpoint)
     * @param {SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesFromBuilderPost(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @summary Get form builder configuration
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdBuilderConfigGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormBuilderConfigDtoApiResponse>;

    /**
     * 
     * @summary Generate JWT token for form builder
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdBuilderTokenPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary Retrieves detailed information about a specific signature template by its unique identifier.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @summary Manually delete a one-time template from DocuSeal and mark as used. This endpoint allows admins to clean up one-time templates without waiting for webhook completion. WARNING: This permanently deletes the template from DocuSeal.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdOneTimeCleanupDelete(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary Generates a preview of a signature template with field overlays applied to a PDF document. Requires Preparer or Admin role.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdPreviewPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Updates an existing signature template\'s configuration and field definitions. Requires Preparer or Admin role.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesIdPut(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @summary Creates a new signature template with field configuration. Requires Preparer or Admin role.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesPost(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoApiResponse>;

    /**
     * 
     * @summary Get signing form configuration
     * @param {SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesSigningFormConfigGet(requestParameters?: SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SigningFormConfigDtoApiResponse>;

    /**
     * 
     * @summary Retrieves all signature templates as a simple list without pagination for dropdown selections.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesTemplatesSimpleGet(options?: RawAxiosRequestConfig): AxiosPromise<SignatureTemplateDtoListApiResponse>;

}

/**
 * Request parameters for apiSignaturesTemplatesCreateFromDocumentPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest {
    /**
     * Document-to-template conversion request
     */
    readonly createTemplateFromDocumentDto?: CreateTemplateFromDocumentDto
}

/**
 * Request parameters for apiSignaturesTemplatesDefaultDocumentTypeGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest {
    /**
     * Document type enumeration to get the default template for.
     */
    readonly documentType: DocumentType
}

/**
 * Request parameters for apiSignaturesTemplatesDocumentTypeDocumentTypeGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest {
    /**
     * Document type enumeration (e.g., W2&#x3D;0, Form1099&#x3D;1, Receipt&#x3D;2, TaxReturn&#x3D;3, etc.).
     */
    readonly documentType: DocumentType
}

/**
 * Request parameters for apiSignaturesTemplatesFormBuilderSavePost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest {
    /**
     * Form builder save data from DocuSeal onSave callback
     */
    readonly formBuilderSaveDto?: FormBuilderSaveDto
}

/**
 * Request parameters for apiSignaturesTemplatesFromBuilderPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest {
    /**
     * Form builder save data from DocuSeal
     */
    readonly formBuilderSaveDto?: FormBuilderSaveDto
}

/**
 * Request parameters for apiSignaturesTemplatesIdBuilderConfigGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest {
    /**
     * Template ID
     */
    readonly id: string
}

/**
 * Request parameters for apiSignaturesTemplatesIdBuilderTokenPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest {
    /**
     * Template ID
     */
    readonly id: string

    /**
     * Token request parameters
     */
    readonly formBuilderTokenRequestDto?: FormBuilderTokenRequestDto
}

/**
 * Request parameters for apiSignaturesTemplatesIdGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest {
    /**
     * The unique identifier of the signature template to retrieve.
     */
    readonly id: string
}

/**
 * Request parameters for apiSignaturesTemplatesIdOneTimeCleanupDelete operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest {
    /**
     * Template ID to delete
     */
    readonly id: string
}

/**
 * Request parameters for apiSignaturesTemplatesIdPreviewPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest {
    /**
     * The unique identifier of the signature template to preview.
     */
    readonly id: string

    /**
     * The preview request containing the PDF document as base64 encoded data.
     */
    readonly previewRequestDto?: PreviewRequestDto
}

/**
 * Request parameters for apiSignaturesTemplatesIdPut operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest {
    /**
     * The unique identifier of the signature template to update.
     */
    readonly id: string

    /**
     * The signature template data to update with new configuration.
     */
    readonly updateSignatureTemplateDto?: UpdateSignatureTemplateDto
}

/**
 * Request parameters for apiSignaturesTemplatesPost operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesPostRequest {
    /**
     * The signature template data to create with field definitions and document type.
     */
    readonly createSignatureTemplateDto?: CreateSignatureTemplateDto
}

/**
 * Request parameters for apiSignaturesTemplatesSigningFormConfigGet operation in SignatureTemplatesApi.
 */
export interface SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest {
    /**
     * Whether to get configuration for preview mode
     */
    readonly previewMode?: boolean
}

/**
 * SignatureTemplatesApi - object-oriented interface
 */
export class SignatureTemplatesApi extends BaseAPI implements SignatureTemplatesApiInterface {
    /**
     * 
     * @summary Create template from an existing document
     * @param {SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesCreateFromDocumentPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesCreateFromDocumentPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesCreateFromDocumentPost(requestParameters.createTemplateFromDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the default signature template configured for a specific document type.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesDefaultDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDefaultDocumentTypeGetRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesDefaultDocumentTypeGet(requestParameters.documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a signature template by document type for automatic template selection.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesDocumentTypeDocumentTypeGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesDocumentTypeDocumentTypeGetRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesDocumentTypeDocumentTypeGet(requestParameters.documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle form builder save callback from DocuSeal
     * @param {SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesFormBuilderSavePost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesFormBuilderSavePostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesFormBuilderSavePost(requestParameters.formBuilderSaveDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create template from form builder data (DocuSeal callback endpoint)
     * @param {SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesFromBuilderPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesFromBuilderPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesFromBuilderPost(requestParameters.formBuilderSaveDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get form builder configuration
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdBuilderConfigGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderConfigGetRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdBuilderConfigGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate JWT token for form builder
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdBuilderTokenPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdBuilderTokenPostRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdBuilderTokenPost(requestParameters.id, requestParameters.formBuilderTokenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves detailed information about a specific signature template by its unique identifier.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdGetRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manually delete a one-time template from DocuSeal and mark as used. This endpoint allows admins to clean up one-time templates without waiting for webhook completion. WARNING: This permanently deletes the template from DocuSeal.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdOneTimeCleanupDelete(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdOneTimeCleanupDeleteRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdOneTimeCleanupDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates a preview of a signature template with field overlays applied to a PDF document. Requires Preparer or Admin role.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdPreviewPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdPreviewPost(requestParameters.id, requestParameters.previewRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing signature template\'s configuration and field definitions. Requires Preparer or Admin role.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesIdPut(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesIdPutRequest, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesIdPut(requestParameters.id, requestParameters.updateSignatureTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new signature template with field configuration. Requires Preparer or Admin role.
     * @param {SignatureTemplatesApiApiSignaturesTemplatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesPost(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesPost(requestParameters.createSignatureTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get signing form configuration
     * @param {SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesSigningFormConfigGet(requestParameters: SignatureTemplatesApiApiSignaturesTemplatesSigningFormConfigGetRequest = {}, options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesSigningFormConfigGet(requestParameters.previewMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all signature templates as a simple list without pagination for dropdown selections.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesTemplatesSimpleGet(options?: RawAxiosRequestConfig) {
        return SignatureTemplatesApiFp(this.configuration).apiSignaturesTemplatesSimpleGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SignaturesApi - axios parameter creator
 */
export const SignaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint performs the following operations: 1. Validates user access to the submission (via Document → Binder → Client hierarchy for Client role) 2. Calls DocuSeal API to get the latest submission status 3. Syncs submitter/submission completion status to the local DB (best-effort, mirrors DocuSealMaintenanceJob) 4. Returns the current status from DocuSeal API              The DB sync bridges the delay between when a user signs and when the webhook callback arrives, allowing the frontend to immediately advance the user to the next step. The webhook remains the primary handler for heavier operations (signed PDF storage, notifications, audit logs, stage transitions). Concurrent webhook processing is handled via DbUpdateConcurrencyException catch.
         * @summary Retrieves the current status of a DocuSeal submission by polling the DocuSeal API and performs a best-effort sync of submitter/submission completion status to the local DB.
         * @param {number} submissionId The unique DocuSeal submission identifier (numeric ID) to get status for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRefreshStatusPost: async (submissionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdRefreshStatusPost', 'submissionId', submissionId)
            const localVarPath = `/api/Signatures/{submissionId}/refresh-status`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send reminders to all pending signers for a submission. Can optionally skip signers who were recently reminded.
         * @param {string} submissionId The DocuSeal submission ID
         * @param {SendBulkReminderDto} [sendBulkReminderDto] Bulk reminder options including message and skip recently reminded flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRemindersBulkPost: async (submissionId: string, sendBulkReminderDto?: SendBulkReminderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdRemindersBulkPost', 'submissionId', submissionId)
            const localVarPath = `/api/Signatures/{submissionId}/reminders/bulk`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendBulkReminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a reminder to a single signer for a signature request. Respects reminder cooldown period (default 24 hours).
         * @param {string} submissionId The DocuSeal submission ID
         * @param {string} signerId The signer/submitter ID
         * @param {SendSignerReminderDto} [sendSignerReminderDto] Optional reminder message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRemindersSignerIdPost: async (submissionId: string, signerId: string, sendSignerReminderDto?: SendSignerReminderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdRemindersSignerIdPost', 'submissionId', submissionId)
            // verify required parameter 'signerId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdRemindersSignerIdPost', 'signerId', signerId)
            const localVarPath = `/api/Signatures/{submissionId}/reminders/{signerId}`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)))
                .replace(`{${"signerId"}}`, encodeURIComponent(String(signerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendSignerReminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new signer (e.g., spouse) to an existing e-signature submission. If no signers have completed: voids original submission and creates new one with all signers. If first signer has completed: creates addon submission from the signed PDF. Signature fields are auto-detected from the PDF document.
         * @param {string} submissionId The DocuSeal submission ID
         * @param {AddSignerRequestDto} [addSignerRequestDto] New signer information (name, email, phone, role)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdSignersPost: async (submissionId: string, addSignerRequestDto?: AddSignerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdSignersPost', 'submissionId', submissionId)
            const localVarPath = `/api/Signatures/{submissionId}/signers`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSignerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a signer in an active submission. The original signer must not have already signed.
         * @param {string} submissionId The DocuSeal submission ID
         * @param {string} signerId The signer/submitter ID to replace
         * @param {ReplaceSignerDto} [replaceSignerDto] New signer information and reason for replacement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdSignersSignerIdReplacePut: async (submissionId: string, signerId: string, replaceSignerDto?: ReplaceSignerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdSignersSignerIdReplacePut', 'submissionId', submissionId)
            // verify required parameter 'signerId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdSignersSignerIdReplacePut', 'signerId', signerId)
            const localVarPath = `/api/Signatures/{submissionId}/signers/{signerId}/replace`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)))
                .replace(`{${"signerId"}}`, encodeURIComponent(String(signerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceSignerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the current status of a DocuSeal signature submission. Client users can only access submissions for their active client.
         * @param {string} submissionId The unique DocuSeal submission identifier to check status for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdStatusGet: async (submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('apiSignaturesSubmissionIdStatusGet', 'submissionId', submissionId)
            const localVarPath = `/api/Signatures/{submissionId}/status`
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Processes incoming DocuSeal webhook events for signature status updates. This endpoint is accessed by DocuSeal services and does not require authentication.
         * @param {DocuSealWebhookDto} [docuSealWebhookDto] The webhook payload containing event data from DocuSeal.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesWebhookPost: async (docuSealWebhookDto?: DocuSealWebhookDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Signatures/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(docuSealWebhookDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignaturesApi - functional programming interface
 */
export const SignaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint performs the following operations: 1. Validates user access to the submission (via Document → Binder → Client hierarchy for Client role) 2. Calls DocuSeal API to get the latest submission status 3. Syncs submitter/submission completion status to the local DB (best-effort, mirrors DocuSealMaintenanceJob) 4. Returns the current status from DocuSeal API              The DB sync bridges the delay between when a user signs and when the webhook callback arrives, allowing the frontend to immediately advance the user to the next step. The webhook remains the primary handler for heavier operations (signed PDF storage, notifications, audit logs, stage transitions). Concurrent webhook processing is handled via DbUpdateConcurrencyException catch.
         * @summary Retrieves the current status of a DocuSeal submission by polling the DocuSeal API and performs a best-effort sync of submitter/submission completion status to the local DB.
         * @param {number} submissionId The unique DocuSeal submission identifier (numeric ID) to get status for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdRefreshStatusPost(submissionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdRefreshStatusPost(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdRefreshStatusPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send reminders to all pending signers for a submission. Can optionally skip signers who were recently reminded.
         * @param {string} submissionId The DocuSeal submission ID
         * @param {SendBulkReminderDto} [sendBulkReminderDto] Bulk reminder options including message and skip recently reminded flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdRemindersBulkPost(submissionId: string, sendBulkReminderDto?: SendBulkReminderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendBulkReminderResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdRemindersBulkPost(submissionId, sendBulkReminderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdRemindersBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send a reminder to a single signer for a signature request. Respects reminder cooldown period (default 24 hours).
         * @param {string} submissionId The DocuSeal submission ID
         * @param {string} signerId The signer/submitter ID
         * @param {SendSignerReminderDto} [sendSignerReminderDto] Optional reminder message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdRemindersSignerIdPost(submissionId: string, signerId: string, sendSignerReminderDto?: SendSignerReminderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendReminderResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdRemindersSignerIdPost(submissionId, signerId, sendSignerReminderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdRemindersSignerIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new signer (e.g., spouse) to an existing e-signature submission. If no signers have completed: voids original submission and creates new one with all signers. If first signer has completed: creates addon submission from the signed PDF. Signature fields are auto-detected from the PDF document.
         * @param {string} submissionId The DocuSeal submission ID
         * @param {AddSignerRequestDto} [addSignerRequestDto] New signer information (name, email, phone, role)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdSignersPost(submissionId: string, addSignerRequestDto?: AddSignerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddSignerResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdSignersPost(submissionId, addSignerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdSignersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace a signer in an active submission. The original signer must not have already signed.
         * @param {string} submissionId The DocuSeal submission ID
         * @param {string} signerId The signer/submitter ID to replace
         * @param {ReplaceSignerDto} [replaceSignerDto] New signer information and reason for replacement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdSignersSignerIdReplacePut(submissionId: string, signerId: string, replaceSignerDto?: ReplaceSignerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplaceSignerResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdSignersSignerIdReplacePut(submissionId, signerId, replaceSignerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdSignersSignerIdReplacePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves the current status of a DocuSeal signature submission. Client users can only access submissions for their active client.
         * @param {string} submissionId The unique DocuSeal submission identifier to check status for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesSubmissionIdStatusGet(submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesSubmissionIdStatusGet(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesSubmissionIdStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Processes incoming DocuSeal webhook events for signature status updates. This endpoint is accessed by DocuSeal services and does not require authentication.
         * @param {DocuSealWebhookDto} [docuSealWebhookDto] The webhook payload containing event data from DocuSeal.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSignaturesWebhookPost(docuSealWebhookDto?: DocuSealWebhookDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSignaturesWebhookPost(docuSealWebhookDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignaturesApi.apiSignaturesWebhookPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SignaturesApi - factory interface
 */
export const SignaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignaturesApiFp(configuration)
    return {
        /**
         * This endpoint performs the following operations: 1. Validates user access to the submission (via Document → Binder → Client hierarchy for Client role) 2. Calls DocuSeal API to get the latest submission status 3. Syncs submitter/submission completion status to the local DB (best-effort, mirrors DocuSealMaintenanceJob) 4. Returns the current status from DocuSeal API              The DB sync bridges the delay between when a user signs and when the webhook callback arrives, allowing the frontend to immediately advance the user to the next step. The webhook remains the primary handler for heavier operations (signed PDF storage, notifications, audit logs, stage transitions). Concurrent webhook processing is handled via DbUpdateConcurrencyException catch.
         * @summary Retrieves the current status of a DocuSeal submission by polling the DocuSeal API and performs a best-effort sync of submitter/submission completion status to the local DB.
         * @param {SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRefreshStatusPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureStatusDtoApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdRefreshStatusPost(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send reminders to all pending signers for a submission. Can optionally skip signers who were recently reminded.
         * @param {SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRemindersBulkPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendBulkReminderResponseDtoApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdRemindersBulkPost(requestParameters.submissionId, requestParameters.sendBulkReminderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a reminder to a single signer for a signature request. Respects reminder cooldown period (default 24 hours).
         * @param {SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdRemindersSignerIdPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendReminderResponseDtoApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdRemindersSignerIdPost(requestParameters.submissionId, requestParameters.signerId, requestParameters.sendSignerReminderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new signer (e.g., spouse) to an existing e-signature submission. If no signers have completed: voids original submission and creates new one with all signers. If first signer has completed: creates addon submission from the signed PDF. Signature fields are auto-detected from the PDF document.
         * @param {SignaturesApiApiSignaturesSubmissionIdSignersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdSignersPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddSignerResponseDtoApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdSignersPost(requestParameters.submissionId, requestParameters.addSignerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a signer in an active submission. The original signer must not have already signed.
         * @param {SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdSignersSignerIdReplacePut(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReplaceSignerResponseDtoApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdSignersSignerIdReplacePut(requestParameters.submissionId, requestParameters.signerId, requestParameters.replaceSignerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the current status of a DocuSeal signature submission. Client users can only access submissions for their active client.
         * @param {SignaturesApiApiSignaturesSubmissionIdStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesSubmissionIdStatusGet(requestParameters: SignaturesApiApiSignaturesSubmissionIdStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiSignaturesSubmissionIdStatusGet(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Processes incoming DocuSeal webhook events for signature status updates. This endpoint is accessed by DocuSeal services and does not require authentication.
         * @param {SignaturesApiApiSignaturesWebhookPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSignaturesWebhookPost(requestParameters: SignaturesApiApiSignaturesWebhookPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse> {
            return localVarFp.apiSignaturesWebhookPost(requestParameters.docuSealWebhookDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignaturesApi - interface
 */
export interface SignaturesApiInterface {
    /**
     * This endpoint performs the following operations: 1. Validates user access to the submission (via Document → Binder → Client hierarchy for Client role) 2. Calls DocuSeal API to get the latest submission status 3. Syncs submitter/submission completion status to the local DB (best-effort, mirrors DocuSealMaintenanceJob) 4. Returns the current status from DocuSeal API              The DB sync bridges the delay between when a user signs and when the webhook callback arrives, allowing the frontend to immediately advance the user to the next step. The webhook remains the primary handler for heavier operations (signed PDF storage, notifications, audit logs, stage transitions). Concurrent webhook processing is handled via DbUpdateConcurrencyException catch.
     * @summary Retrieves the current status of a DocuSeal submission by polling the DocuSeal API and performs a best-effort sync of submitter/submission completion status to the local DB.
     * @param {SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdRefreshStatusPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureStatusDtoApiResponse>;

    /**
     * 
     * @summary Send reminders to all pending signers for a submission. Can optionally skip signers who were recently reminded.
     * @param {SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdRemindersBulkPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendBulkReminderResponseDtoApiResponse>;

    /**
     * 
     * @summary Send a reminder to a single signer for a signature request. Respects reminder cooldown period (default 24 hours).
     * @param {SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdRemindersSignerIdPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendReminderResponseDtoApiResponse>;

    /**
     * 
     * @summary Add a new signer (e.g., spouse) to an existing e-signature submission. If no signers have completed: voids original submission and creates new one with all signers. If first signer has completed: creates addon submission from the signed PDF. Signature fields are auto-detected from the PDF document.
     * @param {SignaturesApiApiSignaturesSubmissionIdSignersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdSignersPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddSignerResponseDtoApiResponse>;

    /**
     * 
     * @summary Replace a signer in an active submission. The original signer must not have already signed.
     * @param {SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdSignersSignerIdReplacePut(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReplaceSignerResponseDtoApiResponse>;

    /**
     * 
     * @summary Retrieves the current status of a DocuSeal signature submission. Client users can only access submissions for their active client.
     * @param {SignaturesApiApiSignaturesSubmissionIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesSubmissionIdStatusGet(requestParameters: SignaturesApiApiSignaturesSubmissionIdStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary Processes incoming DocuSeal webhook events for signature status updates. This endpoint is accessed by DocuSeal services and does not require authentication.
     * @param {SignaturesApiApiSignaturesWebhookPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSignaturesWebhookPost(requestParameters?: SignaturesApiApiSignaturesWebhookPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StringApiResponse>;

}

/**
 * Request parameters for apiSignaturesSubmissionIdRefreshStatusPost operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest {
    /**
     * The unique DocuSeal submission identifier (numeric ID) to get status for.
     */
    readonly submissionId: number
}

/**
 * Request parameters for apiSignaturesSubmissionIdRemindersBulkPost operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest {
    /**
     * The DocuSeal submission ID
     */
    readonly submissionId: string

    /**
     * Bulk reminder options including message and skip recently reminded flag
     */
    readonly sendBulkReminderDto?: SendBulkReminderDto
}

/**
 * Request parameters for apiSignaturesSubmissionIdRemindersSignerIdPost operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest {
    /**
     * The DocuSeal submission ID
     */
    readonly submissionId: string

    /**
     * The signer/submitter ID
     */
    readonly signerId: string

    /**
     * Optional reminder message
     */
    readonly sendSignerReminderDto?: SendSignerReminderDto
}

/**
 * Request parameters for apiSignaturesSubmissionIdSignersPost operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdSignersPostRequest {
    /**
     * The DocuSeal submission ID
     */
    readonly submissionId: string

    /**
     * New signer information (name, email, phone, role)
     */
    readonly addSignerRequestDto?: AddSignerRequestDto
}

/**
 * Request parameters for apiSignaturesSubmissionIdSignersSignerIdReplacePut operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest {
    /**
     * The DocuSeal submission ID
     */
    readonly submissionId: string

    /**
     * The signer/submitter ID to replace
     */
    readonly signerId: string

    /**
     * New signer information and reason for replacement
     */
    readonly replaceSignerDto?: ReplaceSignerDto
}

/**
 * Request parameters for apiSignaturesSubmissionIdStatusGet operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesSubmissionIdStatusGetRequest {
    /**
     * The unique DocuSeal submission identifier to check status for.
     */
    readonly submissionId: string
}

/**
 * Request parameters for apiSignaturesWebhookPost operation in SignaturesApi.
 */
export interface SignaturesApiApiSignaturesWebhookPostRequest {
    /**
     * The webhook payload containing event data from DocuSeal.
     */
    readonly docuSealWebhookDto?: DocuSealWebhookDto
}

/**
 * SignaturesApi - object-oriented interface
 */
export class SignaturesApi extends BaseAPI implements SignaturesApiInterface {
    /**
     * This endpoint performs the following operations: 1. Validates user access to the submission (via Document → Binder → Client hierarchy for Client role) 2. Calls DocuSeal API to get the latest submission status 3. Syncs submitter/submission completion status to the local DB (best-effort, mirrors DocuSealMaintenanceJob) 4. Returns the current status from DocuSeal API              The DB sync bridges the delay between when a user signs and when the webhook callback arrives, allowing the frontend to immediately advance the user to the next step. The webhook remains the primary handler for heavier operations (signed PDF storage, notifications, audit logs, stage transitions). Concurrent webhook processing is handled via DbUpdateConcurrencyException catch.
     * @summary Retrieves the current status of a DocuSeal submission by polling the DocuSeal API and performs a best-effort sync of submitter/submission completion status to the local DB.
     * @param {SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdRefreshStatusPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRefreshStatusPostRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdRefreshStatusPost(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send reminders to all pending signers for a submission. Can optionally skip signers who were recently reminded.
     * @param {SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdRemindersBulkPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersBulkPostRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdRemindersBulkPost(requestParameters.submissionId, requestParameters.sendBulkReminderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a reminder to a single signer for a signature request. Respects reminder cooldown period (default 24 hours).
     * @param {SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdRemindersSignerIdPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdRemindersSignerIdPostRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdRemindersSignerIdPost(requestParameters.submissionId, requestParameters.signerId, requestParameters.sendSignerReminderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new signer (e.g., spouse) to an existing e-signature submission. If no signers have completed: voids original submission and creates new one with all signers. If first signer has completed: creates addon submission from the signed PDF. Signature fields are auto-detected from the PDF document.
     * @param {SignaturesApiApiSignaturesSubmissionIdSignersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdSignersPost(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersPostRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdSignersPost(requestParameters.submissionId, requestParameters.addSignerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a signer in an active submission. The original signer must not have already signed.
     * @param {SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdSignersSignerIdReplacePut(requestParameters: SignaturesApiApiSignaturesSubmissionIdSignersSignerIdReplacePutRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdSignersSignerIdReplacePut(requestParameters.submissionId, requestParameters.signerId, requestParameters.replaceSignerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the current status of a DocuSeal signature submission. Client users can only access submissions for their active client.
     * @param {SignaturesApiApiSignaturesSubmissionIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesSubmissionIdStatusGet(requestParameters: SignaturesApiApiSignaturesSubmissionIdStatusGetRequest, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesSubmissionIdStatusGet(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Processes incoming DocuSeal webhook events for signature status updates. This endpoint is accessed by DocuSeal services and does not require authentication.
     * @param {SignaturesApiApiSignaturesWebhookPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSignaturesWebhookPost(requestParameters: SignaturesApiApiSignaturesWebhookPostRequest = {}, options?: RawAxiosRequestConfig) {
        return SignaturesApiFp(this.configuration).apiSignaturesWebhookPost(requestParameters.docuSealWebhookDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StructuredAuditsApi - axios parameter creator
 */
export const StructuredAuditsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves the complete audit trail for a specific entity showing all changes over time. Requires Preparer or Admin role.
         * @param {string} entityType The type of entity (Client, Document, Binder, etc.).
         * @param {string} entityId The unique identifier of the entity to retrieve audit trail for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsEntityEntityTypeEntityIdGet: async (entityType: string, entityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('apiStructuredAuditsEntityEntityTypeEntityIdGet', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiStructuredAuditsEntityEntityTypeEntityIdGet', 'entityId', entityId)
            const localVarPath = `/api/StructuredAudits/entity/{entityType}/{entityId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a paginated list of structured audit records with optional filtering and sorting. Requires Admin role.
         * @param {string} [entityType] Part of the entity selector.
         * @param {string} [entityId] Part of the entity selector. See Op.ClientTaxSystem.Api.DTOs.StructuredAudits.StructuredAuditQueryDto.EntityType for how the two selectors combine.
         * @param {string} [parentEntityType] Part of the parent selector. See Op.ClientTaxSystem.Api.DTOs.StructuredAudits.StructuredAuditQueryDto.EntityType for how the two selectors combine.
         * @param {string} [parentEntityId] Part of the parent selector. See Op.ClientTaxSystem.Api.DTOs.StructuredAudits.StructuredAuditQueryDto.EntityType for how the two selectors combine.
         * @param {string} [userId] Use an existing user ID
         * @param {string} [action] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsGet: async (entityType?: string, entityId?: string, parentEntityType?: string, parentEntityId?: string, userId?: string, action?: string, fromDate?: string, toDate?: string, search?: string, page?: number, pageSize?: number, sortBy?: string, sortDirection?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StructuredAudits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['EntityType'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['EntityId'] = entityId;
            }

            if (parentEntityType !== undefined) {
                localVarQueryParameter['ParentEntityType'] = parentEntityType;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['ParentEntityId'] = parentEntityId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['UserId'] = userId;
            }

            if (action !== undefined) {
                localVarQueryParameter['Action'] = action;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['FromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['ToDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific structured audit record by its unique identifier. Requires Admin role.
         * @param {number} id The unique identifier of the audit record to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStructuredAuditsIdGet', 'id', id)
            const localVarPath = `/api/StructuredAudits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves audit trails for all child entities under a specific parent entity. Requires Preparer or Admin role.
         * @param {string} parentEntityType The type of parent entity (Client, Binder, etc.).
         * @param {string} parentEntityId The unique identifier of the parent entity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsParentParentEntityTypeParentEntityIdGet: async (parentEntityType: string, parentEntityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentEntityType' is not null or undefined
            assertParamExists('apiStructuredAuditsParentParentEntityTypeParentEntityIdGet', 'parentEntityType', parentEntityType)
            // verify required parameter 'parentEntityId' is not null or undefined
            assertParamExists('apiStructuredAuditsParentParentEntityTypeParentEntityIdGet', 'parentEntityId', parentEntityId)
            const localVarPath = `/api/StructuredAudits/parent/{parentEntityType}/{parentEntityId}`
                .replace(`{${"parentEntityType"}}`, encodeURIComponent(String(parentEntityType)))
                .replace(`{${"parentEntityId"}}`, encodeURIComponent(String(parentEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StructuredAuditsApi - functional programming interface
 */
export const StructuredAuditsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StructuredAuditsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves the complete audit trail for a specific entity showing all changes over time. Requires Preparer or Admin role.
         * @param {string} entityType The type of entity (Client, Document, Binder, etc.).
         * @param {string} entityId The unique identifier of the entity to retrieve audit trail for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStructuredAuditsEntityEntityTypeEntityIdGet(entityType: string, entityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAuditTrailDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStructuredAuditsEntityEntityTypeEntityIdGet(entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StructuredAuditsApi.apiStructuredAuditsEntityEntityTypeEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a paginated list of structured audit records with optional filtering and sorting. Requires Admin role.
         * @param {string} [entityType] Part of the entity selector.
         * @param {string} [entityId] Part of the entity selector. See Op.ClientTaxSystem.Api.DTOs.StructuredAudits.StructuredAuditQueryDto.EntityType for how the two selectors combine.
         * @param {string} [parentEntityType] Part of the parent selector. See Op.ClientTaxSystem.Api.DTOs.StructuredAudits.StructuredAuditQueryDto.EntityType for how the two selectors combine.
         * @param {string} [parentEntityId] Part of the parent selector. See Op.ClientTaxSystem.Api.DTOs.StructuredAudits.StructuredAuditQueryDto.EntityType for how the two selectors combine.
         * @param {string} [userId] Use an existing user ID
         * @param {string} [action] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStructuredAuditsGet(entityType?: string, entityId?: string, parentEntityType?: string, parentEntityId?: string, userId?: string, action?: string, fromDate?: string, toDate?: string, search?: string, page?: number, pageSize?: number, sortBy?: string, sortDirection?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructuredAuditDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStructuredAuditsGet(entityType, entityId, parentEntityType, parentEntityId, userId, action, fromDate, toDate, search, page, pageSize, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StructuredAuditsApi.apiStructuredAuditsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific structured audit record by its unique identifier. Requires Admin role.
         * @param {number} id The unique identifier of the audit record to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStructuredAuditsIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructuredAuditDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStructuredAuditsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StructuredAuditsApi.apiStructuredAuditsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves audit trails for all child entities under a specific parent entity. Requires Preparer or Admin role.
         * @param {string} parentEntityType The type of parent entity (Client, Binder, etc.).
         * @param {string} parentEntityId The unique identifier of the parent entity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(parentEntityType: string, parentEntityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructuredAuditDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(parentEntityType, parentEntityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StructuredAuditsApi.apiStructuredAuditsParentParentEntityTypeParentEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StructuredAuditsApi - factory interface
 */
export const StructuredAuditsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StructuredAuditsApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves the complete audit trail for a specific entity showing all changes over time. Requires Preparer or Admin role.
         * @param {StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsEntityEntityTypeEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityAuditTrailDtoApiResponse> {
            return localVarFp.apiStructuredAuditsEntityEntityTypeEntityIdGet(requestParameters.entityType, requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a paginated list of structured audit records with optional filtering and sorting. Requires Admin role.
         * @param {StructuredAuditsApiApiStructuredAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsGet(requestParameters: StructuredAuditsApiApiStructuredAuditsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoPaginatedResponseApiResponse> {
            return localVarFp.apiStructuredAuditsGet(requestParameters.entityType, requestParameters.entityId, requestParameters.parentEntityType, requestParameters.parentEntityId, requestParameters.userId, requestParameters.action, requestParameters.fromDate, requestParameters.toDate, requestParameters.search, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific structured audit record by its unique identifier. Requires Admin role.
         * @param {StructuredAuditsApiApiStructuredAuditsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoApiResponse> {
            return localVarFp.apiStructuredAuditsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves audit trails for all child entities under a specific parent entity. Requires Preparer or Admin role.
         * @param {StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoListApiResponse> {
            return localVarFp.apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(requestParameters.parentEntityType, requestParameters.parentEntityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StructuredAuditsApi - interface
 */
export interface StructuredAuditsApiInterface {
    /**
     * 
     * @summary Retrieves the complete audit trail for a specific entity showing all changes over time. Requires Preparer or Admin role.
     * @param {StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiStructuredAuditsEntityEntityTypeEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityAuditTrailDtoApiResponse>;

    /**
     * 
     * @summary Retrieves a paginated list of structured audit records with optional filtering and sorting. Requires Admin role.
     * @param {StructuredAuditsApiApiStructuredAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiStructuredAuditsGet(requestParameters?: StructuredAuditsApiApiStructuredAuditsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Retrieves detailed information about a specific structured audit record by its unique identifier. Requires Admin role.
     * @param {StructuredAuditsApiApiStructuredAuditsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiStructuredAuditsIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoApiResponse>;

    /**
     * 
     * @summary Retrieves audit trails for all child entities under a specific parent entity. Requires Preparer or Admin role.
     * @param {StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<StructuredAuditDtoListApiResponse>;

}

/**
 * Request parameters for apiStructuredAuditsEntityEntityTypeEntityIdGet operation in StructuredAuditsApi.
 */
export interface StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest {
    /**
     * The type of entity (Client, Document, Binder, etc.).
     */
    readonly entityType: string

    /**
     * The unique identifier of the entity to retrieve audit trail for.
     */
    readonly entityId: string
}

/**
 * Request parameters for apiStructuredAuditsGet operation in StructuredAuditsApi.
 */
export interface StructuredAuditsApiApiStructuredAuditsGetRequest {
    /**
     * Part of the entity selector.
     */
    readonly entityType?: string

    /**
     * Part of the entity selector. See Op.ClientTaxSystem.Api.DTOs.StructuredAudits.StructuredAuditQueryDto.EntityType for how the two selectors combine.
     */
    readonly entityId?: string

    /**
     * Part of the parent selector. See Op.ClientTaxSystem.Api.DTOs.StructuredAudits.StructuredAuditQueryDto.EntityType for how the two selectors combine.
     */
    readonly parentEntityType?: string

    /**
     * Part of the parent selector. See Op.ClientTaxSystem.Api.DTOs.StructuredAudits.StructuredAuditQueryDto.EntityType for how the two selectors combine.
     */
    readonly parentEntityId?: string

    /**
     * Use an existing user ID
     */
    readonly userId?: string

    readonly action?: string

    readonly fromDate?: string

    readonly toDate?: string

    readonly search?: string

    readonly page?: number

    readonly pageSize?: number

    readonly sortBy?: string

    readonly sortDirection?: string
}

/**
 * Request parameters for apiStructuredAuditsIdGet operation in StructuredAuditsApi.
 */
export interface StructuredAuditsApiApiStructuredAuditsIdGetRequest {
    /**
     * The unique identifier of the audit record to retrieve.
     */
    readonly id: number
}

/**
 * Request parameters for apiStructuredAuditsParentParentEntityTypeParentEntityIdGet operation in StructuredAuditsApi.
 */
export interface StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest {
    /**
     * The type of parent entity (Client, Binder, etc.).
     */
    readonly parentEntityType: string

    /**
     * The unique identifier of the parent entity.
     */
    readonly parentEntityId: string
}

/**
 * StructuredAuditsApi - object-oriented interface
 */
export class StructuredAuditsApi extends BaseAPI implements StructuredAuditsApiInterface {
    /**
     * 
     * @summary Retrieves the complete audit trail for a specific entity showing all changes over time. Requires Preparer or Admin role.
     * @param {StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStructuredAuditsEntityEntityTypeEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsEntityEntityTypeEntityIdGetRequest, options?: RawAxiosRequestConfig) {
        return StructuredAuditsApiFp(this.configuration).apiStructuredAuditsEntityEntityTypeEntityIdGet(requestParameters.entityType, requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a paginated list of structured audit records with optional filtering and sorting. Requires Admin role.
     * @param {StructuredAuditsApiApiStructuredAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStructuredAuditsGet(requestParameters: StructuredAuditsApiApiStructuredAuditsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return StructuredAuditsApiFp(this.configuration).apiStructuredAuditsGet(requestParameters.entityType, requestParameters.entityId, requestParameters.parentEntityType, requestParameters.parentEntityId, requestParameters.userId, requestParameters.action, requestParameters.fromDate, requestParameters.toDate, requestParameters.search, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves detailed information about a specific structured audit record by its unique identifier. Requires Admin role.
     * @param {StructuredAuditsApiApiStructuredAuditsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStructuredAuditsIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsIdGetRequest, options?: RawAxiosRequestConfig) {
        return StructuredAuditsApiFp(this.configuration).apiStructuredAuditsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves audit trails for all child entities under a specific parent entity. Requires Preparer or Admin role.
     * @param {StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(requestParameters: StructuredAuditsApiApiStructuredAuditsParentParentEntityTypeParentEntityIdGetRequest, options?: RawAxiosRequestConfig) {
        return StructuredAuditsApiFp(this.configuration).apiStructuredAuditsParentParentEntityTypeParentEntityIdGet(requestParameters.parentEntityType, requestParameters.parentEntityId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaxBindersApi - axios parameter creator
 */
export const TaxBindersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint returns the complete results after the job has finished processing.              **Prerequisites**: - Job status must be \"completed\" - If job is still processing, returns 425 Too Early - If job failed, returns 400 with error details              **Result Information**: - List of created documents with page numbers and form types - Auto-assignment results (which documents matched required slots) - Processing summary with statistics - Any warnings or issues encountered              **Authorization**: - Users can only query their own job results - Admins can query any job results
         * @summary Gets the final results of a completed batch upload job.
         * @param {string} jobId The unique job identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBatchUploadJobIdResultsGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiTaxBindersBatchUploadJobIdResultsGet', 'jobId', jobId)
            const localVarPath = `/api/tax-binders/batch-upload/{jobId}/results`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Poll this endpoint to check job progress and completion.              **Status Values**: - `queued`: Job is waiting to be processed - `processing`: Job is currently running - `completed`: Job finished successfully (use GetBatchUploadResults to get results) - `failed`: Job failed (check ErrorMessage for details)              **Authorization**: - Users can only query their own jobs - Admins can query any job
         * @summary Gets the current status of a batch upload job.
         * @param {string} jobId The unique job identifier returned from the upload endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBatchUploadJobIdStatusGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiTaxBindersBatchUploadJobIdStatusGet', 'jobId', jobId)
            const localVarPath = `/api/tax-binders/batch-upload/{jobId}/status`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Records the current user\'s acknowledgment of the engagement-letter upload warning for this binder. Shown once per binder (before \"Client Submitted\") when no engagement letter is attached yet, to inform the client that ATA will not begin work on the return until the engagement letter is signed. Idempotent — repeated calls keep the original acknowledgment timestamp.
         * @param {string} binderId The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/acknowledge-engagement-letter-warning`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Analyzes an organizer PDF against an existing binder and creates document requests. Optionally extracts the engagement letter into its own Document.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {boolean} [extractEngagementLetter] 
         * @param {string} [clientOperationId] Use an existing client ID
         * @param {File} [organizerPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdAnalyzeOrganizerPost: async (binderId: string, extractEngagementLetter?: boolean, clientOperationId?: string, organizerPdf?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdAnalyzeOrganizerPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/analyze-organizer`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (extractEngagementLetter !== undefined) {
                localVarQueryParameter['extractEngagementLetter'] = extractEngagementLetter;
            }

            if (clientOperationId !== undefined) {
                localVarQueryParameter['clientOperationId'] = clientOperationId;
            }


            if (organizerPdf !== undefined) { 
                localVarFormParams.append('organizerPdf', organizerPdf as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archived binders: - Prevent client uploads (cannot add new documents) - Allow clients to view firm-delivered documents - Indicate completed tax preparation workflow              Only Preparers and Admins can archive binders. When X-Active-Client-Id header is provided, the binder must belong to that client.
         * @summary Archives or unarchives an binder to control client upload permissions and document visibility.
         * @param {string} binderId The unique identifier of the binder to archive/unarchive
         * @param {ArchiveTaxBinderRequest} [archiveTaxBinderRequest] The archive request containing the desired archive status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdArchivePatch: async (binderId: string, archiveTaxBinderRequest?: ArchiveTaxBinderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdArchivePatch', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/archive`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveTaxBinderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint queues a background job to: - Split the PDF into individual pages (or process only selected pages if specified) - Run AI form detection on each page (optional) - Group related pages into documents - Auto-assign documents to required document slots (if matches found)              The job runs asynchronously in the background. Use the returned JobId to poll for status and results.              **Authorization**: - Clients: Can upload to own binders only - Preparers/Admins: Can upload to any binder              **File Requirements**: - Must be PDF format - Maximum size: configured via FileUploadOptions.MaxFileSizeBytes - Binder must not be archived              **Page Selection**: - If selectedPageNumbers is null or empty, all pages will be processed - If specified, only the listed page numbers will be processed (1-based) - Example: \"1,3,5,10\" will process only pages 1, 3, 5, and 10              **Auto-Split (Phase 2 Enhancement)**: - Enable autoSplitPages to automatically detect form boundaries and create separate documents - Requires runAiDetection=true - Falls back to manual page selection if confidence is below threshold - Cannot be used with manual selectedPageNumbers
         * @summary Uploads a multipage PDF for batch processing with AI-powered form detection.
         * @param {string} binderId The binder to upload documents to
         * @param {boolean} [runAiDetection] Enable AI-powered tax form detection (default: true)
         * @param {number} [confidenceThreshold] Minimum confidence for AI detections (0.0-1.0, default: 0.70)
         * @param {boolean} [createSeparateDocuments] Create separate document records for each form (default: true)
         * @param {boolean} [extractDocumentData] Extract structured data from forms (default: false, Phase 3 feature)
         * @param {boolean} [groupMultiPageForms] Group consecutive pages of same form type (default: true)
         * @param {DocumentDirection} [direction] Document direction: ReceivedFromClient or SentToClient. If not provided, uses role-based inference
         * @param {string} [selectedPageNumbers] Optional comma-separated list of page numbers to process (1-based). If not provided, all pages are processed. Can be combined with autoSplitPages to first filter pages, then auto-split within the selection
         * @param {boolean} [autoSplitPages] Enable automatic page splitting based on detected form boundaries within selected pages. Requires runAiDetection&#x3D;true. Works with selectedPageNumbers as a pre-filter (default: false)
         * @param {number} [autoSplitConfidenceThreshold] Minimum confidence threshold (0.0-1.0) for auto-split decisions (default: 0.80)
         * @param {boolean} [generateAiDescriptionsForAutoSplit] Generate AI descriptions for each auto-split document (default: true)
         * @param {File} [file] The multipage PDF file to process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdDocumentsBatchUploadPost: async (binderId: string, runAiDetection?: boolean, confidenceThreshold?: number, createSeparateDocuments?: boolean, extractDocumentData?: boolean, groupMultiPageForms?: boolean, direction?: DocumentDirection, selectedPageNumbers?: string, autoSplitPages?: boolean, autoSplitConfidenceThreshold?: number, generateAiDescriptionsForAutoSplit?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdDocumentsBatchUploadPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/documents/batch-upload`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (runAiDetection !== undefined) {
                localVarQueryParameter['runAiDetection'] = runAiDetection;
            }

            if (confidenceThreshold !== undefined) {
                localVarQueryParameter['confidenceThreshold'] = confidenceThreshold;
            }

            if (createSeparateDocuments !== undefined) {
                localVarQueryParameter['createSeparateDocuments'] = createSeparateDocuments;
            }

            if (extractDocumentData !== undefined) {
                localVarQueryParameter['extractDocumentData'] = extractDocumentData;
            }

            if (groupMultiPageForms !== undefined) {
                localVarQueryParameter['groupMultiPageForms'] = groupMultiPageForms;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (selectedPageNumbers !== undefined) {
                localVarQueryParameter['selectedPageNumbers'] = selectedPageNumbers;
            }

            if (autoSplitPages !== undefined) {
                localVarQueryParameter['autoSplitPages'] = autoSplitPages;
            }

            if (autoSplitConfidenceThreshold !== undefined) {
                localVarQueryParameter['autoSplitConfidenceThreshold'] = autoSplitConfidenceThreshold;
            }

            if (generateAiDescriptionsForAutoSplit !== undefined) {
                localVarQueryParameter['generateAiDescriptionsForAutoSplit'] = generateAiDescriptionsForAutoSplit;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the estimated tax payments that apply to this binder\'s tax year, resolved from the client\'s prior-year binder\'s tax return bundle. Returns an empty result (SourceBinderId == null) when no prior-year data exists.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdEstimatedPaymentsGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdEstimatedPaymentsGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/estimated-payments`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a document in staging workflow, allowing modifications to inclusion status, naming, and signature settings.
         * @param {string} binderId The unique identifier of the binder containing the document.
         * @param {string} documentId The unique identifier of the document to update in staging.
         * @param {UpdatePreprocessedDocumentDto} [updatePreprocessedDocumentDto] The document updates including inclusion status, name changes, and signature configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingDocumentsDocumentIdPut: async (binderId: string, documentId: string, updatePreprocessedDocumentDto?: UpdatePreprocessedDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdStagingDocumentsDocumentIdPut', 'binderId', binderId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdStagingDocumentsDocumentIdPut', 'documentId', documentId)
            const localVarPath = `/api/tax-binders/{binderId}/staging/documents/{documentId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePreprocessedDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finalizes the staging workflow by moving the binder to final stage and preparing documents for client delivery.
         * @param {string} binderId The unique identifier of the binder to finalize staging for.
         * @param {FinalizeStagingDto} [finalizeStagingDto] The finalization request containing delivery options and final document configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingFinalizePost: async (binderId: string, finalizeStagingDto?: FinalizeStagingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdStagingFinalizePost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/staging/finalize`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finalizeStagingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves staging data for an binder showing all preprocessed documents ready for review and finalization.
         * @param {string} binderId The unique identifier of the binder to get staging data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdStagingGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/staging`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the verification status for a binder, including spouse info verification state and the current user\'s role (Primary vs Spouse).
         * @param {string} binderId The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdVerificationStatusGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdVerificationStatusGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/verification-status`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks the spouse info as verified for this binder. For Primary users: Can update marital status and spouse contact info before marking verified. For Spouse users: Can only acknowledge/confirm the information (read-only).
         * @param {string} binderId The unique identifier of the binder
         * @param {VerifySpouseInfoDto} [verifySpouseInfoDto] Optional spouse info update (for Primary users only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdVerifySpouseInfoPost: async (binderId: string, verifySpouseInfoDto?: VerifySpouseInfoDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdVerifySpouseInfoPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/verify-spouse-info`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifySpouseInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client.
         * @summary Retrieves a paginated list of binders with optional filtering and sorting. Includes document requests and completion status but not the full document list. Use GET /api/documents?BinderId={id} to retrieve documents for each binder separately.
         * @param {number} [taxYear] 
         * @param {string} [clientId] Use an existing client ID
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {string} [partnerId] Filter by assigned partner (User ID). Filters binders whose client has this partner assigned.
         * @param {ClientType} [taxType] Filter by client tax type (Individual, Business, Partnership, etc.)
         * @param {string} [dueDateFrom] 
         * @param {string} [dueDateTo] 
         * @param {string} [search] Search term to filter binders by client name, email, or phone number
         * @param {string} [priority] Filter by priority level: \&quot;urgent\&quot;, \&quot;high\&quot;, \&quot;medium\&quot;, \&quot;low\&quot;
         * @param {boolean} [isOverdue] Filter to show only overdue binders (past due date)
         * @param {boolean} [watchedClientsOnly] Filter to only show binders for clients watched by the current user. Only applies to Preparer users; Admins see all binders regardless.
         * @param {boolean} [isClientSubmitted] Filter to show only client-submitted or non-submitted binders. True &#x3D; only submitted binders, False &#x3D; only non-submitted binders, null &#x3D; no filter
         * @param {boolean} [hasUnreviewedDocuments] Filter to show only binders with documents pending review. True &#x3D; only binders with unreviewed documents, False &#x3D; only binders without, null &#x3D; no filter
         * @param {boolean} [hasUnreviewedComments] Filter to show only binders with comments pending review. True &#x3D; only binders with unread comments, False &#x3D; only binders without, null &#x3D; no filter
         * @param {boolean} [hasLateDocuments] Filter to show only binders with late documents (documents uploaded after SentForPreparation stage). True &#x3D; only binders with late documents, False &#x3D; only binders without, null &#x3D; no filter
         * @param {boolean} [assignedToMe] Filter to show only binders assigned to the current user. True &#x3D; only binders where the current user is the preparer False or null (default) &#x3D; show all binders regardless of assignment
         * @param {BinderStage} [stage] Filter by binder processing stage (New, Open, ClientSubmitted, InReview, etc.)
         * @param {TaxBinderType} [type] Filter by binder type (Normal or GiftTax).
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersGet: async (taxYear?: number, clientId?: string, preparerId?: string, officeId?: string, partnerId?: string, taxType?: ClientType, dueDateFrom?: string, dueDateTo?: string, search?: string, priority?: string, isOverdue?: boolean, watchedClientsOnly?: boolean, isClientSubmitted?: boolean, hasUnreviewedDocuments?: boolean, hasUnreviewedComments?: boolean, hasLateDocuments?: boolean, assignedToMe?: boolean, stage?: BinderStage, type?: TaxBinderType, page?: number, limit?: number, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tax-binders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (taxYear !== undefined) {
                localVarQueryParameter['TaxYear'] = taxYear;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (preparerId !== undefined) {
                localVarQueryParameter['PreparerId'] = preparerId;
            }

            if (officeId !== undefined) {
                localVarQueryParameter['OfficeId'] = officeId;
            }

            if (partnerId !== undefined) {
                localVarQueryParameter['PartnerId'] = partnerId;
            }

            if (taxType !== undefined) {
                localVarQueryParameter['TaxType'] = taxType;
            }

            if (dueDateFrom !== undefined) {
                localVarQueryParameter['DueDateFrom'] = (dueDateFrom as any instanceof Date) ?
                    (dueDateFrom as any).toISOString() :
                    dueDateFrom;
            }

            if (dueDateTo !== undefined) {
                localVarQueryParameter['DueDateTo'] = (dueDateTo as any instanceof Date) ?
                    (dueDateTo as any).toISOString() :
                    dueDateTo;
            }

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (priority !== undefined) {
                localVarQueryParameter['Priority'] = priority;
            }

            if (isOverdue !== undefined) {
                localVarQueryParameter['IsOverdue'] = isOverdue;
            }

            if (watchedClientsOnly !== undefined) {
                localVarQueryParameter['WatchedClientsOnly'] = watchedClientsOnly;
            }

            if (isClientSubmitted !== undefined) {
                localVarQueryParameter['IsClientSubmitted'] = isClientSubmitted;
            }

            if (hasUnreviewedDocuments !== undefined) {
                localVarQueryParameter['HasUnreviewedDocuments'] = hasUnreviewedDocuments;
            }

            if (hasUnreviewedComments !== undefined) {
                localVarQueryParameter['HasUnreviewedComments'] = hasUnreviewedComments;
            }

            if (hasLateDocuments !== undefined) {
                localVarQueryParameter['HasLateDocuments'] = hasLateDocuments;
            }

            if (assignedToMe !== undefined) {
                localVarQueryParameter['AssignedToMe'] = assignedToMe;
            }

            if (stage !== undefined) {
                localVarQueryParameter['Stage'] = stage;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Starts an amended return on a completed binder. Advances the binder\'s amendment round and moves it back to Sent For Preparation so the amended bundle can be uploaded. Earlier rounds\' documents stay downloadable. The client is not notified until the amended return is released.
         * @param {string} id The completed binder to amend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdAmendmentsPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdAmendmentsPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/amendments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a detailed audit trail for the specified binder including: - Binder profile changes - Document uploads and modifications - Document request activity              Each audit entry includes: - Timestamp of the change - User who made the change - Human-readable description of what changed - Detailed field-level changes with before/after values              Access is restricted to: - Admins and Preparers: Can view audit history for any binder - Clients: Can only view audit history for their own binders              Date Range Filtering: - If no dates provided: Returns last 90 days of audit history - If only startDate provided: Returns from startDate to now - If only endDate provided: Returns 90 days before endDate to endDate - If both provided: Returns audit entries within the specified range
         * @summary Retrieves comprehensive audit history for an binder including all related entities
         * @param {string} id The unique identifier of the binder
         * @param {string} [startDate] Optional start date for filtering audit entries (inclusive, UTC)
         * @param {string} [endDate] Optional end date for filtering audit entries (inclusive, UTC)
         * @param {string} [search] 
         * @param {string} [action] 
         * @param {string} [entityType] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdAuditHistoryGet: async (id: string, startDate?: string, endDate?: string, search?: string, action?: string, entityType?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdAuditHistoryGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/audit-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Which of the signed-in client user\'s own clients a binder belongs to, so the app can make that client active before opening the binder. Not found unless the caller is linked to the binder\'s client, so nothing is revealed.
         * @param {string} id The binder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCallerClientGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdCallerClientGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/caller-client`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Browse available documents in CCH Axcess for this binder\'s client and tax year. Returns document metadata with an AlreadyImported flag and MappedDocumentType for each document.              To find tax return bundles (Client Copy, Government Copy, K-1) for import:   GET /api/tax-binders/{id}/cch-documents?className=Tax&subClassName=Returns
         * @param {string} id Binder ID
         * @param {string} [className] Optional CCH class filter (e.g. \&quot;Tax\&quot;, \&quot;Income\&quot;, \&quot;Deduction\&quot;)
         * @param {string} [subClassName] Optional CCH subclass filter (e.g. \&quot;Returns\&quot;, \&quot;Extensions\&quot;, \&quot;Vouchers\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCchDocumentsGet: async (id: string, className?: string, subClassName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdCchDocumentsGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/cch-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (className !== undefined) {
                localVarQueryParameter['className'] = className;
            }

            if (subClassName !== undefined) {
                localVarQueryParameter['subClassName'] = subClassName;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import selected CCH documents into the binder. Downloads each document from CCH, stores in blob storage, and creates document entities. Documents are automatically categorized based on their CCH class/subclass. Skips duplicates and continues on individual failures.
         * @param {string} id 
         * @param {CchDocumentImportRequest} [cchDocumentImportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCchDocumentsImportPost: async (id: string, cchDocumentImportRequest?: CchDocumentImportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdCchDocumentsImportPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/cch-documents/import`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cchDocumentImportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A client that is not linked to CCH is not an error: the response has `available: false` and an `unavailableReason` the export dialog can show while leaving the download destination usable.
         * @summary Lists the CCH Axcess Document filing locations available for this binder\'s client.
         * @param {string} id The unique identifier of the tax binder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCchExportDestinationsGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdCchExportDestinationsGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/cch-export-destinations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clears the late documents flag on a binder. This is used by preparers to indicate they have reviewed late document uploads. Resets LateDocumentsUploadedAt to null and LateDocumentsCount to 0. Audit trail is automatically captured by the StructuredAudit system.
         * @param {string} id The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdClearLateDocumentsPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdClearLateDocumentsPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/clear-late-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently deletes a tax binder and all associated documents. This operation cannot be undone.
         * @param {string} id The unique identifier of the tax binder to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdDelete', 'id', id)
            const localVarPath = `/api/tax-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a document that requires signature, invalidating existing signatures. All existing signatures will be reset and signers will need to sign the new document.
         * @param {string} id The unique identifier of the binder
         * @param {string} documentId The unique identifier of the document to replace
         * @param {boolean} [confirmReset] Must be true to confirm that replacing the document will invalidate all existing signatures
         * @param {boolean} [sendNotification] Whether to send notifications to signers about the replacement
         * @param {File} [file] The new document file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDocumentsDocumentIdReplacePost: async (id: string, documentId: string, confirmReset?: boolean, sendNotification?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdDocumentsDocumentIdReplacePost', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiTaxBindersIdDocumentsDocumentIdReplacePost', 'documentId', documentId)
            const localVarPath = `/api/tax-binders/{id}/documents/{documentId}/replace`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (confirmReset !== undefined) {
                localVarQueryParameter['confirmReset'] = confirmReset;
            }

            if (sendNotification !== undefined) {
                localVarQueryParameter['sendNotification'] = sendNotification;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads the completed signed documents for an binder after e-signature workflow completion.
         * @param {string} id The unique identifier of the binder with completed signatures.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDownloadSignedGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdDownloadSignedGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/download-signed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get e-signature audit history for a binder (IRS compliance). Returns complete audit trail of all e-signature events per IRS Publication 1345 requirements.
         * @param {string} id The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdESignatureAuditGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdESignatureAuditGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/e-signature-audit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all e-signature documents for a binder with real-time status from DocuSeal. Returns documents that require signatures along with their submission status and signer information.
         * @param {string} id The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdESignaturesGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdESignaturesGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/e-signatures`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint uploads an engagement letter PDF to an existing binder and automatically creates a DocuSeal e-signature submission.              **Workflow**: 1. Validates the uploaded file is a PDF 2. If an engagement letter already exists and `ReplaceExisting=false`, returns 409 Conflict 3. If `ReplaceExisting=true` and an engagement letter exists:    - Cancels the existing DocuSeal submission    - Archives the existing document and submission 4. Creates a new Document with Type=EngagementLetter 5. Detects signature fields in the PDF 6. Creates a DocuSeal submission with optional email notification 7. Returns the signing URL and submission details              **Client/Spouse Information**: - If `ClientName`, `ClientEmail`, `SpouseName`, or `SpouseEmail` are not provided,   they default to the values from the binder\'s associated client and spouse records              **Authorization**: - Admin/Preparer only - When X-Active-Client-Id header is provided, binder must belong to that client
         * @summary Attaches an engagement letter PDF to an existing binder and creates a DocuSeal signing request.
         * @param {string} id The unique identifier of the binder
         * @param {File} file The engagement letter PDF file to attach
         * @param {boolean} [replaceExisting] If true, replaces any existing engagement letter. If false, returns error when one exists.
         * @param {string} [clientName] Optional override for client name (defaults to client data from binder)
         * @param {string} [clientEmail] Optional override for client email (defaults to client data from binder)
         * @param {string} [spouseName] Optional override for spouse name (defaults to spouse data from binder)
         * @param {string} [spouseEmail] Optional override for spouse email (defaults to spouse data from binder)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterAttachPost: async (id: string, file: File, replaceExisting?: boolean, clientName?: string, clientEmail?: string, spouseName?: string, spouseEmail?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdEngagementLetterAttachPost', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiTaxBindersIdEngagementLetterAttachPost', 'file', file)
            const localVarPath = `/api/tax-binders/{id}/engagement-letter/attach`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }

            if (replaceExisting !== undefined) { 
                localVarFormParams.append('ReplaceExisting', String(replaceExisting) as any);
            }

            if (clientName !== undefined) { 
                localVarFormParams.append('ClientName', clientName as any);
            }

            if (clientEmail !== undefined) { 
                localVarFormParams.append('ClientEmail', clientEmail as any);
            }

            if (spouseName !== undefined) { 
                localVarFormParams.append('SpouseName', spouseName as any);
            }

            if (spouseEmail !== undefined) { 
                localVarFormParams.append('SpouseEmail', spouseEmail as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint gets or creates a DocuSeal e-signature request for the engagement letter document.              **Workflow**: 1. If a submission already exists for the engagement letter, returns the existing submission details 2. If no submission exists, creates a new one using the signature service              **Prerequisites**: - Binder must have an engagement letter document (EngagementLetterDocumentId must be set) - User must have Admin or Preparer role              **Authorization**: - Admin/Preparer only - When X-Active-Client-Id header is provided, binder must belong to that client
         * @summary Prepares the binder\'s engagement letter for e-signature via DocuSeal.
         * @param {string} id The unique identifier of the binder
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] Signature preparation request with client/spouse information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterPrepareSignaturePost: async (id: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdEngagementLetterPrepareSignaturePost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/engagement-letter/prepare-signature`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleDocumentSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint allows clients to upload a scanned or photographed copy of a physically signed engagement letter instead of using the electronic signature flow.              **Requirements**: - The binder must have an existing engagement letter document - The client must have AllowPhysicalSignature enabled - File must be PDF or image (JPEG, PNG)              **What happens**: - The original engagement letter document is archived - The uploaded signed document becomes the new engagement letter - The binder is marked as having the engagement letter signed (via physical upload) - Any pending DocuSeal submission is cancelled
         * @summary Uploads a physically signed engagement letter to complete the signing process.
         * @param {string} id 
         * @param {File} file The signed engagement letter file (PDF or image)
         * @param {string} [comment] Optional comment from the client about the upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterUploadSignedPost: async (id: string, file: File, comment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdEngagementLetterUploadSignedPost', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiTaxBindersIdEngagementLetterUploadSignedPost', 'file', file)
            const localVarPath = `/api/tax-binders/{id}/engagement-letter/upload-signed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }

            if (comment !== undefined) { 
                localVarFormParams.append('Comment', comment as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exports all documents in an binder as a downloadable archive file (ZIP).
         * @param {string} id The unique identifier of the binder to export.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdExportGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The package is assembled exactly as the download export assembles it; only the destination differs. When the binder has non-PDF attachments they are filed as separate documents in the same folder rather than zipped, because a ZIP is not viewable in CCH.              CCH has no delete operation, so a filed document cannot be withdrawn from the portal. A name that already exists in the target folder is reported back as `CCH_DUPLICATE_DOCUMENT_NAME` for the preparer to rename.
         * @summary Builds the binder\'s export package and files it directly into CCH Axcess Document.
         * @param {string} id The unique identifier of the tax binder to export.
         * @param {TaxBinderCchExportRequestDto} [taxBinderCchExportRequestDto] Package options plus the chosen CCH filing destination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportPackageCchPost: async (id: string, taxBinderCchExportRequestDto?: TaxBinderCchExportRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdExportPackageCchPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/export-package/cch`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taxBinderCchExportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:                  POST /api/tax-binders/{id}/export-package     {         \"includeQuestionnaire\": true,         \"includeClientInfo\": true,         \"includeSpouseInfo\": true,         \"includeDependents\": true,         \"includeBankAccounts\": true,         \"documentFilter\": \"ApprovedOnly\",         \"selectedDocumentIds\": []     }              Export order (when included): 1. Questionnaire responses (tabular format with question/answer pairs) 2. Client information (contact, spouse, dependents, bank accounts) 3. Documents (filtered by DocumentFilter option)              DocumentFilter options: - ApprovedOnly: Include only approved documents (default) - All: Include all documents regardless of status - Selected: Include only documents specified in selectedDocumentIds              Note: Questionnaire is only included if the client has completed it. If no questionnaire answers exist, this section is skipped.
         * @summary Exports a comprehensive binder package containing questionnaire responses, client information, and selected documents as a single PDF. Combines questionnaire answers (as the first section), client data tables (contact info, spouse, dependents, bank accounts), and document PDFs.
         * @param {string} id The unique identifier of the binder to export as a package.
         * @param {TaxBinderPackageExportDto} [taxBinderPackageExportDto] Export options including questionnaire, client info sections, and document filter (ApprovedOnly, All, or Selected).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportPackagePost: async (id: string, taxBinderPackageExportDto?: TaxBinderPackageExportDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdExportPackagePost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/export-package`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taxBinderPackageExportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates a preview of selected documents for export, showing file sizes and organization structure.
         * @param {string} id The unique identifier of the binder.
         * @param {TaxBinderExportSelectionDto} [taxBinderExportSelectionDto] The document selection criteria for the export preview.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportPreviewPost: async (id: string, taxBinderExportSelectionDto?: TaxBinderExportSelectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdExportPreviewPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/export/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taxBinderExportSelectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exports selected documents from an binder as a downloadable archive file (ZIP).
         * @param {string} id The unique identifier of the binder.
         * @param {TaxBinderExportSelectionDto} [taxBinderExportSelectionDto] The document selection criteria specifying which documents to export.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportSelectedPost: async (id: string, taxBinderExportSelectionDto?: TaxBinderExportSelectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdExportSelectedPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/export/selected`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taxBinderExportSelectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For Client role users, the binder must belong to the active client specified in X-Active-Client-Id header. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
         * @summary Retrieves detailed information about a specific binder by their unique identifier. Includes document requests and completion status but not the full document list. Use GET /api/documents?BinderId={id} to retrieve the complete document list separately.
         * @param {string} id The unique identifier of the binder to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prepares binder documents for e-signature workflow through DocuSeal integration.
         * @param {string} id The unique identifier of the binder to prepare for signing.
         * @param {PrepareForSignatureDto} [prepareForSignatureDto] The signature preparation configuration including client email and signature fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdPrepareForSignaturePost: async (id: string, prepareForSignatureDto?: PrepareForSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdPrepareForSignaturePost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/prepare-for-signature`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prepareForSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * When X-Active-Client-Id header is provided, the tax binder must belong to that client. This prevents updates to tax binders outside the currently active client context.              **Engagement Letter Auto-Submission**: When EngagementLetterDocumentId is set or changed, the system automatically creates a DocuSeal e-signature submission for the document (without sending email/SMS notifications). The preparer can then manually send the signing link to the client when ready.
         * @summary Updates an existing tax binder\'s information including status, due dates, notification settings, and engagement letter assignment.
         * @param {string} id The unique identifier of the tax binder to update.
         * @param {UpdateTaxBinderDto} [updateTaxBinderDto] The tax binder data to update with new information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdPut: async (id: string, updateTaxBinderDto?: UpdateTaxBinderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdPut', 'id', id)
            const localVarPath = `/api/tax-binders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaxBinderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recalls a released tax return, reverting the binder to Sent For Preparation stage. Archives the DocuSeal signature submission, soft-deletes bundle documents, resets signature fields, and notifies the client.
         * @param {string} id The binder ID to recall
         * @param {RecallReturnDto} [recallReturnDto] Recall options including required reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdRecallReturnPost: async (id: string, recallReturnDto?: RecallReturnDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdRecallReturnPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/recall-return`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recallReturnDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the release status for a binder including signature progress.
         * @param {string} id The binder ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdReleaseStatusGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdReleaseStatusGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/release-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Releases returns to client for final review and signing. Sends signature requests for all 8879 forms and Direct Deposit Report (if present), transitions binder to FinalClientReview stage, and notifies the client.
         * @param {string} id The binder ID to release
         * @param {ReleaseToClientDto} [releaseToClientDto] Release options including optional custom message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdReleaseToClientPost: async (id: string, releaseToClientDto?: ReleaseToClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdReleaseToClientPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/release-to-client`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseToClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Client requests changes to their tax return during FinalClientReview stage. This transitions the binder to ClientRequestsChanges stage and notifies preparers.
         * @param {string} id The unique identifier of the binder
         * @param {RequestChangesDto} [requestChangesDto] The request with reason for changes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdRequestChangesPost: async (id: string, requestChangesDto?: RequestChangesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdRequestChangesPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/request-changes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resends the welcome email to the client for a binder.
         * @param {string} id The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdResendWelcomeEmailPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdResendWelcomeEmailPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/resend-welcome-email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Every return round recorded against a binder, oldest first, with the document ids needed to download each round\'s client copy and signed package. Drives the preparer\'s original-return history and the client\'s permanent download list.
         * @param {string} id The binder to read return history for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdReturnsHistoryGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdReturnsHistoryGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/returns/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends a binder back to the client for additional information. This transitions the binder from ClientSubmitted or InReview stage back to Open, creates a comment with the reason, and sends an email notification to the client.
         * @param {string} id The unique identifier of the binder to send back
         * @param {SendBackToClientDto} [sendBackToClientDto] The request containing the required reason for sending back
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSendBackPost: async (id: string, sendBackToClientDto?: SendBackToClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSendBackPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/send-back`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendBackToClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Embedded signing session (DocuSeal slug) for the current user on a signature document. Returns 403 if the caller isn\'t an assigned signer. Clients are scoped to their active client.
         * @param {string} id 
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet: async (id: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet', 'id', id)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet', 'documentId', documentId)
            const localVarPath = `/api/tax-binders/{id}/signature-documents/{documentId}/signing-session`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Client users eligible to be assigned as signers on a signature document for this binder\'s client. Includes all client-user relationships on the account.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsEligibleSignersGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureDocumentsEligibleSignersGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/signature-documents/eligible-signers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lists this binder\'s signature documents (sent for e-signature) with per-signer status. Used by the preparer management view and the client \"documents to sign\" surface. Clients are scoped to their active client.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureDocumentsGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/signature-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a binder document for e-signature. Placed fields are assigned to client-user signers by role. Creates a DocuSeal submission in embedded mode (signers sign in-app); notifications are driven by our system.
         * @param {string} id 
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsPost: async (id: string, createSignatureRequestDto?: CreateSignatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureDocumentsPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/signature-documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSignatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the e-signature status for an binder, including completion status and signing progress.
         * @param {string} id The unique identifier of the binder to check signature status for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureStatusGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSignatureStatusGet', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/signature-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the processing stage of a binder to track workflow progress (New → Preprocessing → Staging → Final). Use this endpoint to mark workflow transitions as the preparer processes documents through different stages. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the binder to update stage for.
         * @param {UpdateTaxBinderStageDto} [updateTaxBinderStageDto] The new stage data containing the desired binder processing stage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdStagePatch: async (id: string, updateTaxBinderStageDto?: UpdateTaxBinderStageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdStagePatch', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/stage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaxBinderStageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is idempotent - re-submitting an already-submitted binder updates the timestamp. If a note is provided, it will be saved as a Comment visible to both client and preparer. A SignalR notification is sent to preparers and admins when a binder is submitted.
         * @summary Submits a binder for preparer review (Ready to Proceed). Indicates the client has finished uploading documents and is ready for the preparer to begin working.
         * @param {string} id The unique identifier of the binder to submit
         * @param {SubmitTaxBinderRequest} [submitTaxBinderRequest] Optional note to the preparer (creates a Comment on the binder)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSubmitPost: async (id: string, submitTaxBinderRequest?: SubmitTaxBinderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdSubmitPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitTaxBinderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Withdraws a binder submission, allowing the client to continue uploading documents.
         * @param {string} id The unique identifier of the binder to withdraw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdWithdrawSubmissionPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersIdWithdrawSubmissionPost', 'id', id)
            const localVarPath = `/api/tax-binders/{id}/withdraw-submission`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * When X-Active-Client-Id header is provided, the ClientId in the request body is automatically set to the active client. This ensures preparers/admins can only create tax binders for the currently active client in the UI.
         * @summary Creates a new tax binder for a specific client and tax year.
         * @param {string} name 
         * @param {number} taxYear 
         * @param {string} clientId 
         * @param {TaxBinderType} [type] 
         * @param {string} [preparerId] 
         * @param {string} [dueDate] 
         * @param {number} [notificationDaysPrior] 
         * @param {string} [invoiceLink] URL link to the invoice for this binder (optional)
         * @param {File} [organizerPdf] Optional binder PDF file generated by tax software for processing
         * @param {File} [engagementLetterPdf] Optional standalone engagement letter PDF. Takes precedence over ExtractEngagementLetter.
         * @param {boolean} [extractEngagementLetter] Extract engagement letter pages from OrganizerPdf. Ignored when EngagementLetterPdf is provided.
         * @param {boolean} [sendWelcomeEmail] If true, sends a welcome email to the client with a link to the binder. The email is sent using the Postmark template \\\&#39;client-portal-binder-link\\\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersPost: async (name: string, taxYear: number, clientId: string, type?: TaxBinderType, preparerId?: string, dueDate?: string, notificationDaysPrior?: number, invoiceLink?: string, organizerPdf?: File, engagementLetterPdf?: File, extractEngagementLetter?: boolean, sendWelcomeEmail?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiTaxBindersPost', 'name', name)
            // verify required parameter 'taxYear' is not null or undefined
            assertParamExists('apiTaxBindersPost', 'taxYear', taxYear)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiTaxBindersPost', 'clientId', clientId)
            const localVarPath = `/api/tax-binders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }

            if (taxYear !== undefined) { 
                localVarFormParams.append('TaxYear', taxYear as any);
            }

            if (clientId !== undefined) { 
                localVarFormParams.append('ClientId', clientId as any);
            }

            if (type !== undefined) { 
                localVarFormParams.append('Type', type as any);
            }

            if (preparerId !== undefined) { 
                localVarFormParams.append('PreparerId', preparerId as any);
            }

            if (dueDate !== undefined) { 
                localVarFormParams.append('DueDate', dueDate as any);
            }

            if (notificationDaysPrior !== undefined) { 
                localVarFormParams.append('NotificationDaysPrior', notificationDaysPrior as any);
            }

            if (invoiceLink !== undefined) { 
                localVarFormParams.append('InvoiceLink', invoiceLink as any);
            }

            if (organizerPdf !== undefined) { 
                localVarFormParams.append('OrganizerPdf', organizerPdf as any);
            }

            if (engagementLetterPdf !== undefined) { 
                localVarFormParams.append('EngagementLetterPdf', engagementLetterPdf as any);
            }

            if (extractEngagementLetter !== undefined) { 
                localVarFormParams.append('ExtractEngagementLetter', String(extractEngagementLetter) as any);
            }

            if (sendWelcomeEmail !== undefined) { 
                localVarFormParams.append('SendWelcomeEmail', String(sendWelcomeEmail) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the available tax type options for filtering binders.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersTaxTypeOptionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tax-binders/tax-type-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint creates the tax binder with PreparerId automatically set to the current user. If a tax binder of the same type already exists for the client + tax year combination, a 409 Conflict is returned. The bundle PDFs are processed to extract individual returns based on bookmark structure.
         * @summary Creates a new tax binder and uploads tax return bundle PDFs in a single atomic operation. Use this when a preparer wants to upload returns to a client without an existing tax binder.
         * @param {string} clientId The client ID to create the binder for (required)
         * @param {number} taxYear Tax year for the binder (required)
         * @param {string} name Display name for the binder (required)
         * @param {File} clientCopyPdf Client Copy PDF file (required)
         * @param {File} governmentCopyPdf Government Copy PDF file (required)
         * @param {TaxBinderType} [type] 
         * @param {string} [dueDate] Due date for the binder (optional)
         * @param {string} [invoiceLink] URL link to the invoice for this binder (optional)
         * @param {File} [k1Pdf] K-1 PDF file (optional) - contains Schedule K-1 forms for pass-through entities
         * @param {boolean} [engagementLetterAlreadySigned] If true, marks the engagement letter as already signed (e.g. physical signature). Defaults to false. Only applies when an engagement letter is found in the bundle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersWithBundlePost: async (clientId: string, taxYear: number, name: string, clientCopyPdf: File, governmentCopyPdf: File, type?: TaxBinderType, dueDate?: string, invoiceLink?: string, k1Pdf?: File, engagementLetterAlreadySigned?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiTaxBindersWithBundlePost', 'clientId', clientId)
            // verify required parameter 'taxYear' is not null or undefined
            assertParamExists('apiTaxBindersWithBundlePost', 'taxYear', taxYear)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiTaxBindersWithBundlePost', 'name', name)
            // verify required parameter 'clientCopyPdf' is not null or undefined
            assertParamExists('apiTaxBindersWithBundlePost', 'clientCopyPdf', clientCopyPdf)
            // verify required parameter 'governmentCopyPdf' is not null or undefined
            assertParamExists('apiTaxBindersWithBundlePost', 'governmentCopyPdf', governmentCopyPdf)
            const localVarPath = `/api/tax-binders/with-bundle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (clientId !== undefined) { 
                localVarFormParams.append('ClientId', clientId as any);
            }

            if (taxYear !== undefined) { 
                localVarFormParams.append('TaxYear', taxYear as any);
            }

            if (type !== undefined) { 
                localVarFormParams.append('Type', type as any);
            }

            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }

            if (dueDate !== undefined) { 
                localVarFormParams.append('DueDate', dueDate as any);
            }

            if (invoiceLink !== undefined) { 
                localVarFormParams.append('InvoiceLink', invoiceLink as any);
            }

            if (clientCopyPdf !== undefined) { 
                localVarFormParams.append('ClientCopyPdf', clientCopyPdf as any);
            }

            if (governmentCopyPdf !== undefined) { 
                localVarFormParams.append('GovernmentCopyPdf', governmentCopyPdf as any);
            }

            if (k1Pdf !== undefined) { 
                localVarFormParams.append('K1Pdf', k1Pdf as any);
            }

            if (engagementLetterAlreadySigned !== undefined) { 
                localVarFormParams.append('EngagementLetterAlreadySigned', String(engagementLetterAlreadySigned) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxBindersApi - functional programming interface
 */
export const TaxBindersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaxBindersApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint returns the complete results after the job has finished processing.              **Prerequisites**: - Job status must be \"completed\" - If job is still processing, returns 425 Too Early - If job failed, returns 400 with error details              **Result Information**: - List of created documents with page numbers and form types - Auto-assignment results (which documents matched required slots) - Processing summary with statistics - Any warnings or issues encountered              **Authorization**: - Users can only query their own job results - Admins can query any job results
         * @summary Gets the final results of a completed batch upload job.
         * @param {string} jobId The unique job identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBatchUploadJobIdResultsGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchUploadResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBatchUploadJobIdResultsGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBatchUploadJobIdResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Poll this endpoint to check job progress and completion.              **Status Values**: - `queued`: Job is waiting to be processed - `processing`: Job is currently running - `completed`: Job finished successfully (use GetBatchUploadResults to get results) - `failed`: Job failed (check ErrorMessage for details)              **Authorization**: - Users can only query their own jobs - Admins can query any job
         * @summary Gets the current status of a batch upload job.
         * @param {string} jobId The unique job identifier returned from the upload endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBatchUploadJobIdStatusGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchUploadStatusResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBatchUploadJobIdStatusGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBatchUploadJobIdStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Records the current user\'s acknowledgment of the engagement-letter upload warning for this binder. Shown once per binder (before \"Client Submitted\") when no engagement letter is attached yet, to inform the client that ATA will not begin work on the return until the engagement letter is signed. Idempotent — repeated calls keep the original acknowledgment timestamp.
         * @param {string} binderId The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderVerificationStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Analyzes an organizer PDF against an existing binder and creates document requests. Optionally extracts the engagement letter into its own Document.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {boolean} [extractEngagementLetter] 
         * @param {string} [clientOperationId] Use an existing client ID
         * @param {File} [organizerPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdAnalyzeOrganizerPost(binderId: string, extractEngagementLetter?: boolean, clientOperationId?: string, organizerPdf?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizerAnalysisResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdAnalyzeOrganizerPost(binderId, extractEngagementLetter, clientOperationId, organizerPdf, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdAnalyzeOrganizerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archived binders: - Prevent client uploads (cannot add new documents) - Allow clients to view firm-delivered documents - Indicate completed tax preparation workflow              Only Preparers and Admins can archive binders. When X-Active-Client-Id header is provided, the binder must belong to that client.
         * @summary Archives or unarchives an binder to control client upload permissions and document visibility.
         * @param {string} binderId The unique identifier of the binder to archive/unarchive
         * @param {ArchiveTaxBinderRequest} [archiveTaxBinderRequest] The archive request containing the desired archive status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdArchivePatch(binderId: string, archiveTaxBinderRequest?: ArchiveTaxBinderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdArchivePatch(binderId, archiveTaxBinderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint queues a background job to: - Split the PDF into individual pages (or process only selected pages if specified) - Run AI form detection on each page (optional) - Group related pages into documents - Auto-assign documents to required document slots (if matches found)              The job runs asynchronously in the background. Use the returned JobId to poll for status and results.              **Authorization**: - Clients: Can upload to own binders only - Preparers/Admins: Can upload to any binder              **File Requirements**: - Must be PDF format - Maximum size: configured via FileUploadOptions.MaxFileSizeBytes - Binder must not be archived              **Page Selection**: - If selectedPageNumbers is null or empty, all pages will be processed - If specified, only the listed page numbers will be processed (1-based) - Example: \"1,3,5,10\" will process only pages 1, 3, 5, and 10              **Auto-Split (Phase 2 Enhancement)**: - Enable autoSplitPages to automatically detect form boundaries and create separate documents - Requires runAiDetection=true - Falls back to manual page selection if confidence is below threshold - Cannot be used with manual selectedPageNumbers
         * @summary Uploads a multipage PDF for batch processing with AI-powered form detection.
         * @param {string} binderId The binder to upload documents to
         * @param {boolean} [runAiDetection] Enable AI-powered tax form detection (default: true)
         * @param {number} [confidenceThreshold] Minimum confidence for AI detections (0.0-1.0, default: 0.70)
         * @param {boolean} [createSeparateDocuments] Create separate document records for each form (default: true)
         * @param {boolean} [extractDocumentData] Extract structured data from forms (default: false, Phase 3 feature)
         * @param {boolean} [groupMultiPageForms] Group consecutive pages of same form type (default: true)
         * @param {DocumentDirection} [direction] Document direction: ReceivedFromClient or SentToClient. If not provided, uses role-based inference
         * @param {string} [selectedPageNumbers] Optional comma-separated list of page numbers to process (1-based). If not provided, all pages are processed. Can be combined with autoSplitPages to first filter pages, then auto-split within the selection
         * @param {boolean} [autoSplitPages] Enable automatic page splitting based on detected form boundaries within selected pages. Requires runAiDetection&#x3D;true. Works with selectedPageNumbers as a pre-filter (default: false)
         * @param {number} [autoSplitConfidenceThreshold] Minimum confidence threshold (0.0-1.0) for auto-split decisions (default: 0.80)
         * @param {boolean} [generateAiDescriptionsForAutoSplit] Generate AI descriptions for each auto-split document (default: true)
         * @param {File} [file] The multipage PDF file to process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdDocumentsBatchUploadPost(binderId: string, runAiDetection?: boolean, confidenceThreshold?: number, createSeparateDocuments?: boolean, extractDocumentData?: boolean, groupMultiPageForms?: boolean, direction?: DocumentDirection, selectedPageNumbers?: string, autoSplitPages?: boolean, autoSplitConfidenceThreshold?: number, generateAiDescriptionsForAutoSplit?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchUploadJobResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdDocumentsBatchUploadPost(binderId, runAiDetection, confidenceThreshold, createSeparateDocuments, extractDocumentData, groupMultiPageForms, direction, selectedPageNumbers, autoSplitPages, autoSplitConfidenceThreshold, generateAiDescriptionsForAutoSplit, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdDocumentsBatchUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the estimated tax payments that apply to this binder\'s tax year, resolved from the client\'s prior-year binder\'s tax return bundle. Returns an empty result (SourceBinderId == null) when no prior-year data exists.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdEstimatedPaymentsGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BinderEstimatedPaymentsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdEstimatedPaymentsGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdEstimatedPaymentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a document in staging workflow, allowing modifications to inclusion status, naming, and signature settings.
         * @param {string} binderId The unique identifier of the binder containing the document.
         * @param {string} documentId The unique identifier of the document to update in staging.
         * @param {UpdatePreprocessedDocumentDto} [updatePreprocessedDocumentDto] The document updates including inclusion status, name changes, and signature configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(binderId: string, documentId: string, updatePreprocessedDocumentDto?: UpdatePreprocessedDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreprocessedDocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(binderId, documentId, updatePreprocessedDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdStagingDocumentsDocumentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Finalizes the staging workflow by moving the binder to final stage and preparing documents for client delivery.
         * @param {string} binderId The unique identifier of the binder to finalize staging for.
         * @param {FinalizeStagingDto} [finalizeStagingDto] The finalization request containing delivery options and final document configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdStagingFinalizePost(binderId: string, finalizeStagingDto?: FinalizeStagingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinalizeStagingResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdStagingFinalizePost(binderId, finalizeStagingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdStagingFinalizePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves staging data for an binder showing all preprocessed documents ready for review and finalization.
         * @param {string} binderId The unique identifier of the binder to get staging data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdStagingGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentStagingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdStagingGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdStagingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the verification status for a binder, including spouse info verification state and the current user\'s role (Primary vs Spouse).
         * @param {string} binderId The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdVerificationStatusGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderVerificationStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdVerificationStatusGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdVerificationStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks the spouse info as verified for this binder. For Primary users: Can update marital status and spouse contact info before marking verified. For Spouse users: Can only acknowledge/confirm the information (read-only).
         * @param {string} binderId The unique identifier of the binder
         * @param {VerifySpouseInfoDto} [verifySpouseInfoDto] Optional spouse info update (for Primary users only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdVerifySpouseInfoPost(binderId: string, verifySpouseInfoDto?: VerifySpouseInfoDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderVerificationStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdVerifySpouseInfoPost(binderId, verifySpouseInfoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersBinderIdVerifySpouseInfoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client.
         * @summary Retrieves a paginated list of binders with optional filtering and sorting. Includes document requests and completion status but not the full document list. Use GET /api/documents?BinderId={id} to retrieve documents for each binder separately.
         * @param {number} [taxYear] 
         * @param {string} [clientId] Use an existing client ID
         * @param {string} [preparerId] 
         * @param {string} [officeId] 
         * @param {string} [partnerId] Filter by assigned partner (User ID). Filters binders whose client has this partner assigned.
         * @param {ClientType} [taxType] Filter by client tax type (Individual, Business, Partnership, etc.)
         * @param {string} [dueDateFrom] 
         * @param {string} [dueDateTo] 
         * @param {string} [search] Search term to filter binders by client name, email, or phone number
         * @param {string} [priority] Filter by priority level: \&quot;urgent\&quot;, \&quot;high\&quot;, \&quot;medium\&quot;, \&quot;low\&quot;
         * @param {boolean} [isOverdue] Filter to show only overdue binders (past due date)
         * @param {boolean} [watchedClientsOnly] Filter to only show binders for clients watched by the current user. Only applies to Preparer users; Admins see all binders regardless.
         * @param {boolean} [isClientSubmitted] Filter to show only client-submitted or non-submitted binders. True &#x3D; only submitted binders, False &#x3D; only non-submitted binders, null &#x3D; no filter
         * @param {boolean} [hasUnreviewedDocuments] Filter to show only binders with documents pending review. True &#x3D; only binders with unreviewed documents, False &#x3D; only binders without, null &#x3D; no filter
         * @param {boolean} [hasUnreviewedComments] Filter to show only binders with comments pending review. True &#x3D; only binders with unread comments, False &#x3D; only binders without, null &#x3D; no filter
         * @param {boolean} [hasLateDocuments] Filter to show only binders with late documents (documents uploaded after SentForPreparation stage). True &#x3D; only binders with late documents, False &#x3D; only binders without, null &#x3D; no filter
         * @param {boolean} [assignedToMe] Filter to show only binders assigned to the current user. True &#x3D; only binders where the current user is the preparer False or null (default) &#x3D; show all binders regardless of assignment
         * @param {BinderStage} [stage] Filter by binder processing stage (New, Open, ClientSubmitted, InReview, etc.)
         * @param {TaxBinderType} [type] Filter by binder type (Normal or GiftTax).
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersGet(taxYear?: number, clientId?: string, preparerId?: string, officeId?: string, partnerId?: string, taxType?: ClientType, dueDateFrom?: string, dueDateTo?: string, search?: string, priority?: string, isOverdue?: boolean, watchedClientsOnly?: boolean, isClientSubmitted?: boolean, hasUnreviewedDocuments?: boolean, hasUnreviewedComments?: boolean, hasLateDocuments?: boolean, assignedToMe?: boolean, stage?: BinderStage, type?: TaxBinderType, page?: number, limit?: number, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersGet(taxYear, clientId, preparerId, officeId, partnerId, taxType, dueDateFrom, dueDateTo, search, priority, isOverdue, watchedClientsOnly, isClientSubmitted, hasUnreviewedDocuments, hasUnreviewedComments, hasLateDocuments, assignedToMe, stage, type, page, limit, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Starts an amended return on a completed binder. Advances the binder\'s amendment round and moves it back to Sent For Preparation so the amended bundle can be uploaded. Earlier rounds\' documents stay downloadable. The client is not notified until the amended return is released.
         * @param {string} id The completed binder to amend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdAmendmentsPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartAmendmentResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdAmendmentsPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdAmendmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a detailed audit trail for the specified binder including: - Binder profile changes - Document uploads and modifications - Document request activity              Each audit entry includes: - Timestamp of the change - User who made the change - Human-readable description of what changed - Detailed field-level changes with before/after values              Access is restricted to: - Admins and Preparers: Can view audit history for any binder - Clients: Can only view audit history for their own binders              Date Range Filtering: - If no dates provided: Returns last 90 days of audit history - If only startDate provided: Returns from startDate to now - If only endDate provided: Returns 90 days before endDate to endDate - If both provided: Returns audit entries within the specified range
         * @summary Retrieves comprehensive audit history for an binder including all related entities
         * @param {string} id The unique identifier of the binder
         * @param {string} [startDate] Optional start date for filtering audit entries (inclusive, UTC)
         * @param {string} [endDate] Optional end date for filtering audit entries (inclusive, UTC)
         * @param {string} [search] 
         * @param {string} [action] 
         * @param {string} [entityType] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdAuditHistoryGet(id: string, startDate?: string, endDate?: string, search?: string, action?: string, entityType?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderAuditHistoryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdAuditHistoryGet(id, startDate, endDate, search, action, entityType, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdAuditHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Which of the signed-in client user\'s own clients a binder belongs to, so the app can make that client active before opening the binder. Not found unless the caller is linked to the binder\'s client, so nothing is revealed.
         * @param {string} id The binder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdCallerClientGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BinderClientDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdCallerClientGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdCallerClientGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Browse available documents in CCH Axcess for this binder\'s client and tax year. Returns document metadata with an AlreadyImported flag and MappedDocumentType for each document.              To find tax return bundles (Client Copy, Government Copy, K-1) for import:   GET /api/tax-binders/{id}/cch-documents?className=Tax&subClassName=Returns
         * @param {string} id Binder ID
         * @param {string} [className] Optional CCH class filter (e.g. \&quot;Tax\&quot;, \&quot;Income\&quot;, \&quot;Deduction\&quot;)
         * @param {string} [subClassName] Optional CCH subclass filter (e.g. \&quot;Returns\&quot;, \&quot;Extensions\&quot;, \&quot;Vouchers\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdCchDocumentsGet(id: string, className?: string, subClassName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CchDocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdCchDocumentsGet(id, className, subClassName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdCchDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import selected CCH documents into the binder. Downloads each document from CCH, stores in blob storage, and creates document entities. Documents are automatically categorized based on their CCH class/subclass. Skips duplicates and continues on individual failures.
         * @param {string} id 
         * @param {CchDocumentImportRequest} [cchDocumentImportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdCchDocumentsImportPost(id: string, cchDocumentImportRequest?: CchDocumentImportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CchDocumentImportResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdCchDocumentsImportPost(id, cchDocumentImportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdCchDocumentsImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A client that is not linked to CCH is not an error: the response has `available: false` and an `unavailableReason` the export dialog can show while leaving the download destination usable.
         * @summary Lists the CCH Axcess Document filing locations available for this binder\'s client.
         * @param {string} id The unique identifier of the tax binder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdCchExportDestinationsGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CchExportDestinationOptionsDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdCchExportDestinationsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdCchExportDestinationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Clears the late documents flag on a binder. This is used by preparers to indicate they have reviewed late document uploads. Resets LateDocumentsUploadedAt to null and LateDocumentsCount to 0. Audit trail is automatically captured by the StructuredAudit system.
         * @param {string} id The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdClearLateDocumentsPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdClearLateDocumentsPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdClearLateDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently deletes a tax binder and all associated documents. This operation cannot be undone.
         * @param {string} id The unique identifier of the tax binder to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace a document that requires signature, invalidating existing signatures. All existing signatures will be reset and signers will need to sign the new document.
         * @param {string} id The unique identifier of the binder
         * @param {string} documentId The unique identifier of the document to replace
         * @param {boolean} [confirmReset] Must be true to confirm that replacing the document will invalidate all existing signatures
         * @param {boolean} [sendNotification] Whether to send notifications to signers about the replacement
         * @param {File} [file] The new document file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdDocumentsDocumentIdReplacePost(id: string, documentId: string, confirmReset?: boolean, sendNotification?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplaceDocumentResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdDocumentsDocumentIdReplacePost(id, documentId, confirmReset, sendNotification, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdDocumentsDocumentIdReplacePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Downloads the completed signed documents for an binder after e-signature workflow completion.
         * @param {string} id The unique identifier of the binder with completed signatures.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdDownloadSignedGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdDownloadSignedGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdDownloadSignedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get e-signature audit history for a binder (IRS compliance). Returns complete audit trail of all e-signature events per IRS Publication 1345 requirements.
         * @param {string} id The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdESignatureAuditGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ESignatureAuditHistoryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdESignatureAuditGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdESignatureAuditGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all e-signature documents for a binder with real-time status from DocuSeal. Returns documents that require signatures along with their submission status and signer information.
         * @param {string} id The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdESignaturesGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ESignatureDocumentListDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdESignaturesGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdESignaturesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint uploads an engagement letter PDF to an existing binder and automatically creates a DocuSeal e-signature submission.              **Workflow**: 1. Validates the uploaded file is a PDF 2. If an engagement letter already exists and `ReplaceExisting=false`, returns 409 Conflict 3. If `ReplaceExisting=true` and an engagement letter exists:    - Cancels the existing DocuSeal submission    - Archives the existing document and submission 4. Creates a new Document with Type=EngagementLetter 5. Detects signature fields in the PDF 6. Creates a DocuSeal submission with optional email notification 7. Returns the signing URL and submission details              **Client/Spouse Information**: - If `ClientName`, `ClientEmail`, `SpouseName`, or `SpouseEmail` are not provided,   they default to the values from the binder\'s associated client and spouse records              **Authorization**: - Admin/Preparer only - When X-Active-Client-Id header is provided, binder must belong to that client
         * @summary Attaches an engagement letter PDF to an existing binder and creates a DocuSeal signing request.
         * @param {string} id The unique identifier of the binder
         * @param {File} file The engagement letter PDF file to attach
         * @param {boolean} [replaceExisting] If true, replaces any existing engagement letter. If false, returns error when one exists.
         * @param {string} [clientName] Optional override for client name (defaults to client data from binder)
         * @param {string} [clientEmail] Optional override for client email (defaults to client data from binder)
         * @param {string} [spouseName] Optional override for spouse name (defaults to spouse data from binder)
         * @param {string} [spouseEmail] Optional override for spouse email (defaults to spouse data from binder)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdEngagementLetterAttachPost(id: string, file: File, replaceExisting?: boolean, clientName?: string, clientEmail?: string, spouseName?: string, spouseEmail?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachEngagementLetterResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdEngagementLetterAttachPost(id, file, replaceExisting, clientName, clientEmail, spouseName, spouseEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdEngagementLetterAttachPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint gets or creates a DocuSeal e-signature request for the engagement letter document.              **Workflow**: 1. If a submission already exists for the engagement letter, returns the existing submission details 2. If no submission exists, creates a new one using the signature service              **Prerequisites**: - Binder must have an engagement letter document (EngagementLetterDocumentId must be set) - User must have Admin or Preparer role              **Authorization**: - Admin/Preparer only - When X-Active-Client-Id header is provided, binder must belong to that client
         * @summary Prepares the binder\'s engagement letter for e-signature via DocuSeal.
         * @param {string} id The unique identifier of the binder
         * @param {SingleDocumentSignatureDto} [singleDocumentSignatureDto] Signature preparation request with client/spouse information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdEngagementLetterPrepareSignaturePost(id: string, singleDocumentSignatureDto?: SingleDocumentSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureSubmissionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdEngagementLetterPrepareSignaturePost(id, singleDocumentSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdEngagementLetterPrepareSignaturePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint allows clients to upload a scanned or photographed copy of a physically signed engagement letter instead of using the electronic signature flow.              **Requirements**: - The binder must have an existing engagement letter document - The client must have AllowPhysicalSignature enabled - File must be PDF or image (JPEG, PNG)              **What happens**: - The original engagement letter document is archived - The uploaded signed document becomes the new engagement letter - The binder is marked as having the engagement letter signed (via physical upload) - Any pending DocuSeal submission is cancelled
         * @summary Uploads a physically signed engagement letter to complete the signing process.
         * @param {string} id 
         * @param {File} file The signed engagement letter file (PDF or image)
         * @param {string} [comment] Optional comment from the client about the upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdEngagementLetterUploadSignedPost(id: string, file: File, comment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadSignedEngagementLetterResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdEngagementLetterUploadSignedPost(id, file, comment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdEngagementLetterUploadSignedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Exports all documents in an binder as a downloadable archive file (ZIP).
         * @param {string} id The unique identifier of the binder to export.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdExportGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdExportGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdExportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The package is assembled exactly as the download export assembles it; only the destination differs. When the binder has non-PDF attachments they are filed as separate documents in the same folder rather than zipped, because a ZIP is not viewable in CCH.              CCH has no delete operation, so a filed document cannot be withdrawn from the portal. A name that already exists in the target folder is reported back as `CCH_DUPLICATE_DOCUMENT_NAME` for the preparer to rename.
         * @summary Builds the binder\'s export package and files it directly into CCH Axcess Document.
         * @param {string} id The unique identifier of the tax binder to export.
         * @param {TaxBinderCchExportRequestDto} [taxBinderCchExportRequestDto] Package options plus the chosen CCH filing destination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdExportPackageCchPost(id: string, taxBinderCchExportRequestDto?: TaxBinderCchExportRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderCchExportResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdExportPackageCchPost(id, taxBinderCchExportRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdExportPackageCchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:                  POST /api/tax-binders/{id}/export-package     {         \"includeQuestionnaire\": true,         \"includeClientInfo\": true,         \"includeSpouseInfo\": true,         \"includeDependents\": true,         \"includeBankAccounts\": true,         \"documentFilter\": \"ApprovedOnly\",         \"selectedDocumentIds\": []     }              Export order (when included): 1. Questionnaire responses (tabular format with question/answer pairs) 2. Client information (contact, spouse, dependents, bank accounts) 3. Documents (filtered by DocumentFilter option)              DocumentFilter options: - ApprovedOnly: Include only approved documents (default) - All: Include all documents regardless of status - Selected: Include only documents specified in selectedDocumentIds              Note: Questionnaire is only included if the client has completed it. If no questionnaire answers exist, this section is skipped.
         * @summary Exports a comprehensive binder package containing questionnaire responses, client information, and selected documents as a single PDF. Combines questionnaire answers (as the first section), client data tables (contact info, spouse, dependents, bank accounts), and document PDFs.
         * @param {string} id The unique identifier of the binder to export as a package.
         * @param {TaxBinderPackageExportDto} [taxBinderPackageExportDto] Export options including questionnaire, client info sections, and document filter (ApprovedOnly, All, or Selected).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdExportPackagePost(id: string, taxBinderPackageExportDto?: TaxBinderPackageExportDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdExportPackagePost(id, taxBinderPackageExportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdExportPackagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generates a preview of selected documents for export, showing file sizes and organization structure.
         * @param {string} id The unique identifier of the binder.
         * @param {TaxBinderExportSelectionDto} [taxBinderExportSelectionDto] The document selection criteria for the export preview.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdExportPreviewPost(id: string, taxBinderExportSelectionDto?: TaxBinderExportSelectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderExportPreviewDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdExportPreviewPost(id, taxBinderExportSelectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdExportPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Exports selected documents from an binder as a downloadable archive file (ZIP).
         * @param {string} id The unique identifier of the binder.
         * @param {TaxBinderExportSelectionDto} [taxBinderExportSelectionDto] The document selection criteria specifying which documents to export.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdExportSelectedPost(id: string, taxBinderExportSelectionDto?: TaxBinderExportSelectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdExportSelectedPost(id, taxBinderExportSelectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdExportSelectedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For Client role users, the binder must belong to the active client specified in X-Active-Client-Id header. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
         * @summary Retrieves detailed information about a specific binder by their unique identifier. Includes document requests and completion status but not the full document list. Use GET /api/documents?BinderId={id} to retrieve the complete document list separately.
         * @param {string} id The unique identifier of the binder to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Prepares binder documents for e-signature workflow through DocuSeal integration.
         * @param {string} id The unique identifier of the binder to prepare for signing.
         * @param {PrepareForSignatureDto} [prepareForSignatureDto] The signature preparation configuration including client email and signature fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdPrepareForSignaturePost(id: string, prepareForSignatureDto?: PrepareForSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrepareForSignatureResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdPrepareForSignaturePost(id, prepareForSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdPrepareForSignaturePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * When X-Active-Client-Id header is provided, the tax binder must belong to that client. This prevents updates to tax binders outside the currently active client context.              **Engagement Letter Auto-Submission**: When EngagementLetterDocumentId is set or changed, the system automatically creates a DocuSeal e-signature submission for the document (without sending email/SMS notifications). The preparer can then manually send the signing link to the client when ready.
         * @summary Updates an existing tax binder\'s information including status, due dates, notification settings, and engagement letter assignment.
         * @param {string} id The unique identifier of the tax binder to update.
         * @param {UpdateTaxBinderDto} [updateTaxBinderDto] The tax binder data to update with new information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdPut(id: string, updateTaxBinderDto?: UpdateTaxBinderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdPut(id, updateTaxBinderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recalls a released tax return, reverting the binder to Sent For Preparation stage. Archives the DocuSeal signature submission, soft-deletes bundle documents, resets signature fields, and notifies the client.
         * @param {string} id The binder ID to recall
         * @param {RecallReturnDto} [recallReturnDto] Recall options including required reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdRecallReturnPost(id: string, recallReturnDto?: RecallReturnDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecallReturnResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdRecallReturnPost(id, recallReturnDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdRecallReturnPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets the release status for a binder including signature progress.
         * @param {string} id The binder ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdReleaseStatusGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdReleaseStatusGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdReleaseStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Releases returns to client for final review and signing. Sends signature requests for all 8879 forms and Direct Deposit Report (if present), transitions binder to FinalClientReview stage, and notifies the client.
         * @param {string} id The binder ID to release
         * @param {ReleaseToClientDto} [releaseToClientDto] Release options including optional custom message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdReleaseToClientPost(id: string, releaseToClientDto?: ReleaseToClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseToClientResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdReleaseToClientPost(id, releaseToClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdReleaseToClientPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Client requests changes to their tax return during FinalClientReview stage. This transitions the binder to ClientRequestsChanges stage and notifies preparers.
         * @param {string} id The unique identifier of the binder
         * @param {RequestChangesDto} [requestChangesDto] The request with reason for changes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdRequestChangesPost(id: string, requestChangesDto?: RequestChangesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdRequestChangesPost(id, requestChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdRequestChangesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resends the welcome email to the client for a binder.
         * @param {string} id The unique identifier of the binder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdResendWelcomeEmailPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdResendWelcomeEmailPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdResendWelcomeEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Every return round recorded against a binder, oldest first, with the document ids needed to download each round\'s client copy and signed package. Drives the preparer\'s original-return history and the client\'s permanent download list.
         * @param {string} id The binder to read return history for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdReturnsHistoryGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnHistoryDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdReturnsHistoryGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdReturnsHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sends a binder back to the client for additional information. This transitions the binder from ClientSubmitted or InReview stage back to Open, creates a comment with the reason, and sends an email notification to the client.
         * @param {string} id The unique identifier of the binder to send back
         * @param {SendBackToClientDto} [sendBackToClientDto] The request containing the required reason for sending back
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSendBackPost(id: string, sendBackToClientDto?: SendBackToClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSendBackPost(id, sendBackToClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSendBackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Embedded signing session (DocuSeal slug) for the current user on a signature document. Returns 403 if the caller isn\'t an assigned signer. Clients are scoped to their active client.
         * @param {string} id 
         * @param {string} documentId Copy this from the Staging Data response or Preprocessing results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(id: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureSigningSessionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(id, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Client users eligible to be assigned as signers on a signature document for this binder\'s client. Includes all client-user relationships on the account.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSignatureDocumentsEligibleSignersGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibleSignersDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSignatureDocumentsEligibleSignersGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSignatureDocumentsEligibleSignersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lists this binder\'s signature documents (sent for e-signature) with per-signer status. Used by the preparer management view and the client \"documents to sign\" surface. Clients are scoped to their active client.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSignatureDocumentsGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureDocumentListDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSignatureDocumentsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSignatureDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send a binder document for e-signature. Placed fields are assigned to client-user signers by role. Creates a DocuSeal submission in embedded mode (signers sign in-app); notifications are driven by our system.
         * @param {string} id 
         * @param {CreateSignatureRequestDto} [createSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSignatureDocumentsPost(id: string, createSignatureRequestDto?: CreateSignatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureRequestResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSignatureDocumentsPost(id, createSignatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSignatureDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves the e-signature status for an binder, including completion status and signing progress.
         * @param {string} id The unique identifier of the binder to check signature status for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSignatureStatusGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSignatureStatusGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSignatureStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates the processing stage of a binder to track workflow progress (New → Preprocessing → Staging → Final). Use this endpoint to mark workflow transitions as the preparer processes documents through different stages. Requires Preparer or Admin role.
         * @param {string} id The unique identifier of the binder to update stage for.
         * @param {UpdateTaxBinderStageDto} [updateTaxBinderStageDto] The new stage data containing the desired binder processing stage.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdStagePatch(id: string, updateTaxBinderStageDto?: UpdateTaxBinderStageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdStagePatch(id, updateTaxBinderStageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdStagePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint is idempotent - re-submitting an already-submitted binder updates the timestamp. If a note is provided, it will be saved as a Comment visible to both client and preparer. A SignalR notification is sent to preparers and admins when a binder is submitted.
         * @summary Submits a binder for preparer review (Ready to Proceed). Indicates the client has finished uploading documents and is ready for the preparer to begin working.
         * @param {string} id The unique identifier of the binder to submit
         * @param {SubmitTaxBinderRequest} [submitTaxBinderRequest] Optional note to the preparer (creates a Comment on the binder)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdSubmitPost(id: string, submitTaxBinderRequest?: SubmitTaxBinderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdSubmitPost(id, submitTaxBinderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdSubmitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Withdraws a binder submission, allowing the client to continue uploading documents.
         * @param {string} id The unique identifier of the binder to withdraw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersIdWithdrawSubmissionPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersIdWithdrawSubmissionPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersIdWithdrawSubmissionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * When X-Active-Client-Id header is provided, the ClientId in the request body is automatically set to the active client. This ensures preparers/admins can only create tax binders for the currently active client in the UI.
         * @summary Creates a new tax binder for a specific client and tax year.
         * @param {string} name 
         * @param {number} taxYear 
         * @param {string} clientId 
         * @param {TaxBinderType} [type] 
         * @param {string} [preparerId] 
         * @param {string} [dueDate] 
         * @param {number} [notificationDaysPrior] 
         * @param {string} [invoiceLink] URL link to the invoice for this binder (optional)
         * @param {File} [organizerPdf] Optional binder PDF file generated by tax software for processing
         * @param {File} [engagementLetterPdf] Optional standalone engagement letter PDF. Takes precedence over ExtractEngagementLetter.
         * @param {boolean} [extractEngagementLetter] Extract engagement letter pages from OrganizerPdf. Ignored when EngagementLetterPdf is provided.
         * @param {boolean} [sendWelcomeEmail] If true, sends a welcome email to the client with a link to the binder. The email is sent using the Postmark template \\\&#39;client-portal-binder-link\\\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersPost(name: string, taxYear: number, clientId: string, type?: TaxBinderType, preparerId?: string, dueDate?: string, notificationDaysPrior?: number, invoiceLink?: string, organizerPdf?: File, engagementLetterPdf?: File, extractEngagementLetter?: boolean, sendWelcomeEmail?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxBinderDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersPost(name, taxYear, clientId, type, preparerId, dueDate, notificationDaysPrior, invoiceLink, organizerPdf, engagementLetterPdf, extractEngagementLetter, sendWelcomeEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves the available tax type options for filtering binders.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersTaxTypeOptionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxTypeOptionListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersTaxTypeOptionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersTaxTypeOptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint creates the tax binder with PreparerId automatically set to the current user. If a tax binder of the same type already exists for the client + tax year combination, a 409 Conflict is returned. The bundle PDFs are processed to extract individual returns based on bookmark structure.
         * @summary Creates a new tax binder and uploads tax return bundle PDFs in a single atomic operation. Use this when a preparer wants to upload returns to a client without an existing tax binder.
         * @param {string} clientId The client ID to create the binder for (required)
         * @param {number} taxYear Tax year for the binder (required)
         * @param {string} name Display name for the binder (required)
         * @param {File} clientCopyPdf Client Copy PDF file (required)
         * @param {File} governmentCopyPdf Government Copy PDF file (required)
         * @param {TaxBinderType} [type] 
         * @param {string} [dueDate] Due date for the binder (optional)
         * @param {string} [invoiceLink] URL link to the invoice for this binder (optional)
         * @param {File} [k1Pdf] K-1 PDF file (optional) - contains Schedule K-1 forms for pass-through entities
         * @param {boolean} [engagementLetterAlreadySigned] If true, marks the engagement letter as already signed (e.g. physical signature). Defaults to false. Only applies when an engagement letter is found in the bundle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersWithBundlePost(clientId: string, taxYear: number, name: string, clientCopyPdf: File, governmentCopyPdf: File, type?: TaxBinderType, dueDate?: string, invoiceLink?: string, k1Pdf?: File, engagementLetterAlreadySigned?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBinderWithBundleResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersWithBundlePost(clientId, taxYear, name, clientCopyPdf, governmentCopyPdf, type, dueDate, invoiceLink, k1Pdf, engagementLetterAlreadySigned, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxBindersApi.apiTaxBindersWithBundlePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaxBindersApi - factory interface
 */
export const TaxBindersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaxBindersApiFp(configuration)
    return {
        /**
         * This endpoint returns the complete results after the job has finished processing.              **Prerequisites**: - Job status must be \"completed\" - If job is still processing, returns 425 Too Early - If job failed, returns 400 with error details              **Result Information**: - List of created documents with page numbers and form types - Auto-assignment results (which documents matched required slots) - Processing summary with statistics - Any warnings or issues encountered              **Authorization**: - Users can only query their own job results - Admins can query any job results
         * @summary Gets the final results of a completed batch upload job.
         * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBatchUploadJobIdResultsGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadResultApiResponse> {
            return localVarFp.apiTaxBindersBatchUploadJobIdResultsGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Poll this endpoint to check job progress and completion.              **Status Values**: - `queued`: Job is waiting to be processed - `processing`: Job is currently running - `completed`: Job finished successfully (use GetBatchUploadResults to get results) - `failed`: Job failed (check ErrorMessage for details)              **Authorization**: - Users can only query their own jobs - Admins can query any job
         * @summary Gets the current status of a batch upload job.
         * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBatchUploadJobIdStatusGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadStatusResponseApiResponse> {
            return localVarFp.apiTaxBindersBatchUploadJobIdStatusGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Records the current user\'s acknowledgment of the engagement-letter upload warning for this binder. Shown once per binder (before \"Client Submitted\") when no engagement letter is attached yet, to inform the client that ATA will not begin work on the return until the engagement letter is signed. Idempotent — repeated calls keep the original acknowledgment timestamp.
         * @param {TaxBindersApiApiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderVerificationStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Analyzes an organizer PDF against an existing binder and creates document requests. Optionally extracts the engagement letter into its own Document.
         * @param {TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdAnalyzeOrganizerPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizerAnalysisResultDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdAnalyzeOrganizerPost(requestParameters.binderId, requestParameters.extractEngagementLetter, requestParameters.clientOperationId, requestParameters.organizerPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * Archived binders: - Prevent client uploads (cannot add new documents) - Allow clients to view firm-delivered documents - Indicate completed tax preparation workflow              Only Preparers and Admins can archive binders. When X-Active-Client-Id header is provided, the binder must belong to that client.
         * @summary Archives or unarchives an binder to control client upload permissions and document visibility.
         * @param {TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdArchivePatch(requestParameters: TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdArchivePatch(requestParameters.binderId, requestParameters.archiveTaxBinderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint queues a background job to: - Split the PDF into individual pages (or process only selected pages if specified) - Run AI form detection on each page (optional) - Group related pages into documents - Auto-assign documents to required document slots (if matches found)              The job runs asynchronously in the background. Use the returned JobId to poll for status and results.              **Authorization**: - Clients: Can upload to own binders only - Preparers/Admins: Can upload to any binder              **File Requirements**: - Must be PDF format - Maximum size: configured via FileUploadOptions.MaxFileSizeBytes - Binder must not be archived              **Page Selection**: - If selectedPageNumbers is null or empty, all pages will be processed - If specified, only the listed page numbers will be processed (1-based) - Example: \"1,3,5,10\" will process only pages 1, 3, 5, and 10              **Auto-Split (Phase 2 Enhancement)**: - Enable autoSplitPages to automatically detect form boundaries and create separate documents - Requires runAiDetection=true - Falls back to manual page selection if confidence is below threshold - Cannot be used with manual selectedPageNumbers
         * @summary Uploads a multipage PDF for batch processing with AI-powered form detection.
         * @param {TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdDocumentsBatchUploadPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadJobResponseApiResponse> {
            return localVarFp.apiTaxBindersBinderIdDocumentsBatchUploadPost(requestParameters.binderId, requestParameters.runAiDetection, requestParameters.confidenceThreshold, requestParameters.createSeparateDocuments, requestParameters.extractDocumentData, requestParameters.groupMultiPageForms, requestParameters.direction, requestParameters.selectedPageNumbers, requestParameters.autoSplitPages, requestParameters.autoSplitConfidenceThreshold, requestParameters.generateAiDescriptionsForAutoSplit, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the estimated tax payments that apply to this binder\'s tax year, resolved from the client\'s prior-year binder\'s tax return bundle. Returns an empty result (SourceBinderId == null) when no prior-year data exists.
         * @param {TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdEstimatedPaymentsGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderEstimatedPaymentsDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdEstimatedPaymentsGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a document in staging workflow, allowing modifications to inclusion status, naming, and signature settings.
         * @param {TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreprocessedDocumentDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(requestParameters.binderId, requestParameters.documentId, requestParameters.updatePreprocessedDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finalizes the staging workflow by moving the binder to final stage and preparing documents for client delivery.
         * @param {TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingFinalizePost(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FinalizeStagingResultDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdStagingFinalizePost(requestParameters.binderId, requestParameters.finalizeStagingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves staging data for an binder showing all preprocessed documents ready for review and finalization.
         * @param {TaxBindersApiApiTaxBindersBinderIdStagingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdStagingGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStagingDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdStagingGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the verification status for a binder, including spouse info verification state and the current user\'s role (Primary vs Spouse).
         * @param {TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdVerificationStatusGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderVerificationStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdVerificationStatusGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks the spouse info as verified for this binder. For Primary users: Can update marital status and spouse contact info before marking verified. For Spouse users: Can only acknowledge/confirm the information (read-only).
         * @param {TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdVerifySpouseInfoPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderVerificationStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdVerifySpouseInfoPost(requestParameters.binderId, requestParameters.verifySpouseInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client.
         * @summary Retrieves a paginated list of binders with optional filtering and sorting. Includes document requests and completion status but not the full document list. Use GET /api/documents?BinderId={id} to retrieve documents for each binder separately.
         * @param {TaxBindersApiApiTaxBindersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersGet(requestParameters: TaxBindersApiApiTaxBindersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoPaginatedResponseApiResponse> {
            return localVarFp.apiTaxBindersGet(requestParameters.taxYear, requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.partnerId, requestParameters.taxType, requestParameters.dueDateFrom, requestParameters.dueDateTo, requestParameters.search, requestParameters.priority, requestParameters.isOverdue, requestParameters.watchedClientsOnly, requestParameters.isClientSubmitted, requestParameters.hasUnreviewedDocuments, requestParameters.hasUnreviewedComments, requestParameters.hasLateDocuments, requestParameters.assignedToMe, requestParameters.stage, requestParameters.type, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Starts an amended return on a completed binder. Advances the binder\'s amendment round and moves it back to Sent For Preparation so the amended bundle can be uploaded. Earlier rounds\' documents stay downloadable. The client is not notified until the amended return is released.
         * @param {TaxBindersApiApiTaxBindersIdAmendmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdAmendmentsPost(requestParameters: TaxBindersApiApiTaxBindersIdAmendmentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartAmendmentResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdAmendmentsPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a detailed audit trail for the specified binder including: - Binder profile changes - Document uploads and modifications - Document request activity              Each audit entry includes: - Timestamp of the change - User who made the change - Human-readable description of what changed - Detailed field-level changes with before/after values              Access is restricted to: - Admins and Preparers: Can view audit history for any binder - Clients: Can only view audit history for their own binders              Date Range Filtering: - If no dates provided: Returns last 90 days of audit history - If only startDate provided: Returns from startDate to now - If only endDate provided: Returns 90 days before endDate to endDate - If both provided: Returns audit entries within the specified range
         * @summary Retrieves comprehensive audit history for an binder including all related entities
         * @param {TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdAuditHistoryGet(requestParameters: TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderAuditHistoryDtoApiResponse> {
            return localVarFp.apiTaxBindersIdAuditHistoryGet(requestParameters.id, requestParameters.startDate, requestParameters.endDate, requestParameters.search, requestParameters.action, requestParameters.entityType, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Which of the signed-in client user\'s own clients a binder belongs to, so the app can make that client active before opening the binder. Not found unless the caller is linked to the binder\'s client, so nothing is revealed.
         * @param {TaxBindersApiApiTaxBindersIdCallerClientGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCallerClientGet(requestParameters: TaxBindersApiApiTaxBindersIdCallerClientGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderClientDtoApiResponse> {
            return localVarFp.apiTaxBindersIdCallerClientGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Browse available documents in CCH Axcess for this binder\'s client and tax year. Returns document metadata with an AlreadyImported flag and MappedDocumentType for each document.              To find tax return bundles (Client Copy, Government Copy, K-1) for import:   GET /api/tax-binders/{id}/cch-documents?className=Tax&subClassName=Returns
         * @param {TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCchDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CchDocumentDtoListApiResponse> {
            return localVarFp.apiTaxBindersIdCchDocumentsGet(requestParameters.id, requestParameters.className, requestParameters.subClassName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import selected CCH documents into the binder. Downloads each document from CCH, stores in blob storage, and creates document entities. Documents are automatically categorized based on their CCH class/subclass. Skips duplicates and continues on individual failures.
         * @param {TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCchDocumentsImportPost(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CchDocumentImportResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdCchDocumentsImportPost(requestParameters.id, requestParameters.cchDocumentImportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * A client that is not linked to CCH is not an error: the response has `available: false` and an `unavailableReason` the export dialog can show while leaving the download destination usable.
         * @summary Lists the CCH Axcess Document filing locations available for this binder\'s client.
         * @param {TaxBindersApiApiTaxBindersIdCchExportDestinationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdCchExportDestinationsGet(requestParameters: TaxBindersApiApiTaxBindersIdCchExportDestinationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CchExportDestinationOptionsDtoApiResponse> {
            return localVarFp.apiTaxBindersIdCchExportDestinationsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Clears the late documents flag on a binder. This is used by preparers to indicate they have reviewed late document uploads. Resets LateDocumentsUploadedAt to null and LateDocumentsCount to 0. Audit trail is automatically captured by the StructuredAudit system.
         * @param {TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdClearLateDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdClearLateDocumentsPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently deletes a tax binder and all associated documents. This operation cannot be undone.
         * @param {TaxBindersApiApiTaxBindersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDelete(requestParameters: TaxBindersApiApiTaxBindersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTaxBindersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a document that requires signature, invalidating existing signatures. All existing signatures will be reset and signers will need to sign the new document.
         * @param {TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDocumentsDocumentIdReplacePost(requestParameters: TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReplaceDocumentResponseDtoApiResponse> {
            return localVarFp.apiTaxBindersIdDocumentsDocumentIdReplacePost(requestParameters.id, requestParameters.documentId, requestParameters.confirmReset, requestParameters.sendNotification, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads the completed signed documents for an binder after e-signature workflow completion.
         * @param {TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdDownloadSignedGet(requestParameters: TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTaxBindersIdDownloadSignedGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get e-signature audit history for a binder (IRS compliance). Returns complete audit trail of all e-signature events per IRS Publication 1345 requirements.
         * @param {TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdESignatureAuditGet(requestParameters: TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ESignatureAuditHistoryDtoApiResponse> {
            return localVarFp.apiTaxBindersIdESignatureAuditGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all e-signature documents for a binder with real-time status from DocuSeal. Returns documents that require signatures along with their submission status and signer information.
         * @param {TaxBindersApiApiTaxBindersIdESignaturesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdESignaturesGet(requestParameters: TaxBindersApiApiTaxBindersIdESignaturesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ESignatureDocumentListDtoApiResponse> {
            return localVarFp.apiTaxBindersIdESignaturesGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint uploads an engagement letter PDF to an existing binder and automatically creates a DocuSeal e-signature submission.              **Workflow**: 1. Validates the uploaded file is a PDF 2. If an engagement letter already exists and `ReplaceExisting=false`, returns 409 Conflict 3. If `ReplaceExisting=true` and an engagement letter exists:    - Cancels the existing DocuSeal submission    - Archives the existing document and submission 4. Creates a new Document with Type=EngagementLetter 5. Detects signature fields in the PDF 6. Creates a DocuSeal submission with optional email notification 7. Returns the signing URL and submission details              **Client/Spouse Information**: - If `ClientName`, `ClientEmail`, `SpouseName`, or `SpouseEmail` are not provided,   they default to the values from the binder\'s associated client and spouse records              **Authorization**: - Admin/Preparer only - When X-Active-Client-Id header is provided, binder must belong to that client
         * @summary Attaches an engagement letter PDF to an existing binder and creates a DocuSeal signing request.
         * @param {TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterAttachPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttachEngagementLetterResponseDtoApiResponse> {
            return localVarFp.apiTaxBindersIdEngagementLetterAttachPost(requestParameters.id, requestParameters.file, requestParameters.replaceExisting, requestParameters.clientName, requestParameters.clientEmail, requestParameters.spouseName, requestParameters.spouseEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint gets or creates a DocuSeal e-signature request for the engagement letter document.              **Workflow**: 1. If a submission already exists for the engagement letter, returns the existing submission details 2. If no submission exists, creates a new one using the signature service              **Prerequisites**: - Binder must have an engagement letter document (EngagementLetterDocumentId must be set) - User must have Admin or Preparer role              **Authorization**: - Admin/Preparer only - When X-Active-Client-Id header is provided, binder must belong to that client
         * @summary Prepares the binder\'s engagement letter for e-signature via DocuSeal.
         * @param {TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterPrepareSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse> {
            return localVarFp.apiTaxBindersIdEngagementLetterPrepareSignaturePost(requestParameters.id, requestParameters.singleDocumentSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows clients to upload a scanned or photographed copy of a physically signed engagement letter instead of using the electronic signature flow.              **Requirements**: - The binder must have an existing engagement letter document - The client must have AllowPhysicalSignature enabled - File must be PDF or image (JPEG, PNG)              **What happens**: - The original engagement letter document is archived - The uploaded signed document becomes the new engagement letter - The binder is marked as having the engagement letter signed (via physical upload) - Any pending DocuSeal submission is cancelled
         * @summary Uploads a physically signed engagement letter to complete the signing process.
         * @param {TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdEngagementLetterUploadSignedPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadSignedEngagementLetterResponseDtoApiResponse> {
            return localVarFp.apiTaxBindersIdEngagementLetterUploadSignedPost(requestParameters.id, requestParameters.file, requestParameters.comment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exports all documents in an binder as a downloadable archive file (ZIP).
         * @param {TaxBindersApiApiTaxBindersIdExportGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportGet(requestParameters: TaxBindersApiApiTaxBindersIdExportGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTaxBindersIdExportGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * The package is assembled exactly as the download export assembles it; only the destination differs. When the binder has non-PDF attachments they are filed as separate documents in the same folder rather than zipped, because a ZIP is not viewable in CCH.              CCH has no delete operation, so a filed document cannot be withdrawn from the portal. A name that already exists in the target folder is reported back as `CCH_DUPLICATE_DOCUMENT_NAME` for the preparer to rename.
         * @summary Builds the binder\'s export package and files it directly into CCH Axcess Document.
         * @param {TaxBindersApiApiTaxBindersIdExportPackageCchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportPackageCchPost(requestParameters: TaxBindersApiApiTaxBindersIdExportPackageCchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderCchExportResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdExportPackageCchPost(requestParameters.id, requestParameters.taxBinderCchExportRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:                  POST /api/tax-binders/{id}/export-package     {         \"includeQuestionnaire\": true,         \"includeClientInfo\": true,         \"includeSpouseInfo\": true,         \"includeDependents\": true,         \"includeBankAccounts\": true,         \"documentFilter\": \"ApprovedOnly\",         \"selectedDocumentIds\": []     }              Export order (when included): 1. Questionnaire responses (tabular format with question/answer pairs) 2. Client information (contact, spouse, dependents, bank accounts) 3. Documents (filtered by DocumentFilter option)              DocumentFilter options: - ApprovedOnly: Include only approved documents (default) - All: Include all documents regardless of status - Selected: Include only documents specified in selectedDocumentIds              Note: Questionnaire is only included if the client has completed it. If no questionnaire answers exist, this section is skipped.
         * @summary Exports a comprehensive binder package containing questionnaire responses, client information, and selected documents as a single PDF. Combines questionnaire answers (as the first section), client data tables (contact info, spouse, dependents, bank accounts), and document PDFs.
         * @param {TaxBindersApiApiTaxBindersIdExportPackagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportPackagePost(requestParameters: TaxBindersApiApiTaxBindersIdExportPackagePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTaxBindersIdExportPackagePost(requestParameters.id, requestParameters.taxBinderPackageExportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates a preview of selected documents for export, showing file sizes and organization structure.
         * @param {TaxBindersApiApiTaxBindersIdExportPreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportPreviewPost(requestParameters: TaxBindersApiApiTaxBindersIdExportPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderExportPreviewDtoApiResponse> {
            return localVarFp.apiTaxBindersIdExportPreviewPost(requestParameters.id, requestParameters.taxBinderExportSelectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exports selected documents from an binder as a downloadable archive file (ZIP).
         * @param {TaxBindersApiApiTaxBindersIdExportSelectedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdExportSelectedPost(requestParameters: TaxBindersApiApiTaxBindersIdExportSelectedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTaxBindersIdExportSelectedPost(requestParameters.id, requestParameters.taxBinderExportSelectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * For Client role users, the binder must belong to the active client specified in X-Active-Client-Id header. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
         * @summary Retrieves detailed information about a specific binder by their unique identifier. Includes document requests and completion status but not the full document list. Use GET /api/documents?BinderId={id} to retrieve the complete document list separately.
         * @param {TaxBindersApiApiTaxBindersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdGet(requestParameters: TaxBindersApiApiTaxBindersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prepares binder documents for e-signature workflow through DocuSeal integration.
         * @param {TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdPrepareForSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrepareForSignatureResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdPrepareForSignaturePost(requestParameters.id, requestParameters.prepareForSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * When X-Active-Client-Id header is provided, the tax binder must belong to that client. This prevents updates to tax binders outside the currently active client context.              **Engagement Letter Auto-Submission**: When EngagementLetterDocumentId is set or changed, the system automatically creates a DocuSeal e-signature submission for the document (without sending email/SMS notifications). The preparer can then manually send the signing link to the client when ready.
         * @summary Updates an existing tax binder\'s information including status, due dates, notification settings, and engagement letter assignment.
         * @param {TaxBindersApiApiTaxBindersIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdPut(requestParameters: TaxBindersApiApiTaxBindersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdPut(requestParameters.id, requestParameters.updateTaxBinderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recalls a released tax return, reverting the binder to Sent For Preparation stage. Archives the DocuSeal signature submission, soft-deletes bundle documents, resets signature fields, and notifies the client.
         * @param {TaxBindersApiApiTaxBindersIdRecallReturnPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdRecallReturnPost(requestParameters: TaxBindersApiApiTaxBindersIdRecallReturnPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecallReturnResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdRecallReturnPost(requestParameters.id, requestParameters.recallReturnDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the release status for a binder including signature progress.
         * @param {TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdReleaseStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersIdReleaseStatusGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Releases returns to client for final review and signing. Sends signature requests for all 8879 forms and Direct Deposit Report (if present), transitions binder to FinalClientReview stage, and notifies the client.
         * @param {TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdReleaseToClientPost(requestParameters: TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseToClientResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdReleaseToClientPost(requestParameters.id, requestParameters.releaseToClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Client requests changes to their tax return during FinalClientReview stage. This transitions the binder to ClientRequestsChanges stage and notifies preparers.
         * @param {TaxBindersApiApiTaxBindersIdRequestChangesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdRequestChangesPost(requestParameters: TaxBindersApiApiTaxBindersIdRequestChangesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdRequestChangesPost(requestParameters.id, requestParameters.requestChangesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resends the welcome email to the client for a binder.
         * @param {TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdResendWelcomeEmailPost(requestParameters: TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersIdResendWelcomeEmailPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Every return round recorded against a binder, oldest first, with the document ids needed to download each round\'s client copy and signed package. Drives the preparer\'s original-return history and the client\'s permanent download list.
         * @param {TaxBindersApiApiTaxBindersIdReturnsHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdReturnsHistoryGet(requestParameters: TaxBindersApiApiTaxBindersIdReturnsHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnHistoryDtoApiResponse> {
            return localVarFp.apiTaxBindersIdReturnsHistoryGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends a binder back to the client for additional information. This transitions the binder from ClientSubmitted or InReview stage back to Open, creates a comment with the reason, and sends an email notification to the client.
         * @param {TaxBindersApiApiTaxBindersIdSendBackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSendBackPost(requestParameters: TaxBindersApiApiTaxBindersIdSendBackPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSendBackPost(requestParameters.id, requestParameters.sendBackToClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Embedded signing session (DocuSeal slug) for the current user on a signature document. Returns 403 if the caller isn\'t an assigned signer. Clients are scoped to their active client.
         * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSigningSessionDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters.id, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Client users eligible to be assigned as signers on a signature document for this binder\'s client. Includes all client-user relationships on the account.
         * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSignatureDocumentsEligibleSignersGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lists this binder\'s signature documents (sent for e-signature) with per-signer status. Used by the preparer management view and the client \"documents to sign\" surface. Clients are scoped to their active client.
         * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureDocumentListDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSignatureDocumentsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a binder document for e-signature. Placed fields are assigned to client-user signers by role. Creates a DocuSeal submission in embedded mode (signers sign in-app); notifications are driven by our system.
         * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSignatureDocumentsPost(requestParameters.id, requestParameters.createSignatureRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the e-signature status for an binder, including completion status and signing progress.
         * @param {TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSignatureStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse> {
            return localVarFp.apiTaxBindersIdSignatureStatusGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the processing stage of a binder to track workflow progress (New → Preprocessing → Staging → Final). Use this endpoint to mark workflow transitions as the preparer processes documents through different stages. Requires Preparer or Admin role.
         * @param {TaxBindersApiApiTaxBindersIdStagePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdStagePatch(requestParameters: TaxBindersApiApiTaxBindersIdStagePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdStagePatch(requestParameters.id, requestParameters.updateTaxBinderStageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is idempotent - re-submitting an already-submitted binder updates the timestamp. If a note is provided, it will be saved as a Comment visible to both client and preparer. A SignalR notification is sent to preparers and admins when a binder is submitted.
         * @summary Submits a binder for preparer review (Ready to Proceed). Indicates the client has finished uploading documents and is ready for the preparer to begin working.
         * @param {TaxBindersApiApiTaxBindersIdSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdSubmitPost(requestParameters: TaxBindersApiApiTaxBindersIdSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdSubmitPost(requestParameters.id, requestParameters.submitTaxBinderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Withdraws a binder submission, allowing the client to continue uploading documents.
         * @param {TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersIdWithdrawSubmissionPost(requestParameters: TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersIdWithdrawSubmissionPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * When X-Active-Client-Id header is provided, the ClientId in the request body is automatically set to the active client. This ensures preparers/admins can only create tax binders for the currently active client in the UI.
         * @summary Creates a new tax binder for a specific client and tax year.
         * @param {TaxBindersApiApiTaxBindersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersPost(requestParameters: TaxBindersApiApiTaxBindersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse> {
            return localVarFp.apiTaxBindersPost(requestParameters.name, requestParameters.taxYear, requestParameters.clientId, requestParameters.type, requestParameters.preparerId, requestParameters.dueDate, requestParameters.notificationDaysPrior, requestParameters.invoiceLink, requestParameters.organizerPdf, requestParameters.engagementLetterPdf, requestParameters.extractEngagementLetter, requestParameters.sendWelcomeEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the available tax type options for filtering binders.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersTaxTypeOptionsGet(options?: RawAxiosRequestConfig): AxiosPromise<TaxTypeOptionListApiResponse> {
            return localVarFp.apiTaxBindersTaxTypeOptionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint creates the tax binder with PreparerId automatically set to the current user. If a tax binder of the same type already exists for the client + tax year combination, a 409 Conflict is returned. The bundle PDFs are processed to extract individual returns based on bookmark structure.
         * @summary Creates a new tax binder and uploads tax return bundle PDFs in a single atomic operation. Use this when a preparer wants to upload returns to a client without an existing tax binder.
         * @param {TaxBindersApiApiTaxBindersWithBundlePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersWithBundlePost(requestParameters: TaxBindersApiApiTaxBindersWithBundlePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBinderWithBundleResultDtoApiResponse> {
            return localVarFp.apiTaxBindersWithBundlePost(requestParameters.clientId, requestParameters.taxYear, requestParameters.name, requestParameters.clientCopyPdf, requestParameters.governmentCopyPdf, requestParameters.type, requestParameters.dueDate, requestParameters.invoiceLink, requestParameters.k1Pdf, requestParameters.engagementLetterAlreadySigned, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaxBindersApi - interface
 */
export interface TaxBindersApiInterface {
    /**
     * This endpoint returns the complete results after the job has finished processing.              **Prerequisites**: - Job status must be \"completed\" - If job is still processing, returns 425 Too Early - If job failed, returns 400 with error details              **Result Information**: - List of created documents with page numbers and form types - Auto-assignment results (which documents matched required slots) - Processing summary with statistics - Any warnings or issues encountered              **Authorization**: - Users can only query their own job results - Admins can query any job results
     * @summary Gets the final results of a completed batch upload job.
     * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBatchUploadJobIdResultsGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadResultApiResponse>;

    /**
     * Poll this endpoint to check job progress and completion.              **Status Values**: - `queued`: Job is waiting to be processed - `processing`: Job is currently running - `completed`: Job finished successfully (use GetBatchUploadResults to get results) - `failed`: Job failed (check ErrorMessage for details)              **Authorization**: - Users can only query their own jobs - Admins can query any job
     * @summary Gets the current status of a batch upload job.
     * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBatchUploadJobIdStatusGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadStatusResponseApiResponse>;

    /**
     * 
     * @summary Records the current user\'s acknowledgment of the engagement-letter upload warning for this binder. Shown once per binder (before \"Client Submitted\") when no engagement letter is attached yet, to inform the client that ATA will not begin work on the return until the engagement letter is signed. Idempotent — repeated calls keep the original acknowledgment timestamp.
     * @param {TaxBindersApiApiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderVerificationStatusDtoApiResponse>;

    /**
     * 
     * @summary Analyzes an organizer PDF against an existing binder and creates document requests. Optionally extracts the engagement letter into its own Document.
     * @param {TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdAnalyzeOrganizerPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizerAnalysisResultDtoApiResponse>;

    /**
     * Archived binders: - Prevent client uploads (cannot add new documents) - Allow clients to view firm-delivered documents - Indicate completed tax preparation workflow              Only Preparers and Admins can archive binders. When X-Active-Client-Id header is provided, the binder must belong to that client.
     * @summary Archives or unarchives an binder to control client upload permissions and document visibility.
     * @param {TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdArchivePatch(requestParameters: TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * This endpoint queues a background job to: - Split the PDF into individual pages (or process only selected pages if specified) - Run AI form detection on each page (optional) - Group related pages into documents - Auto-assign documents to required document slots (if matches found)              The job runs asynchronously in the background. Use the returned JobId to poll for status and results.              **Authorization**: - Clients: Can upload to own binders only - Preparers/Admins: Can upload to any binder              **File Requirements**: - Must be PDF format - Maximum size: configured via FileUploadOptions.MaxFileSizeBytes - Binder must not be archived              **Page Selection**: - If selectedPageNumbers is null or empty, all pages will be processed - If specified, only the listed page numbers will be processed (1-based) - Example: \"1,3,5,10\" will process only pages 1, 3, 5, and 10              **Auto-Split (Phase 2 Enhancement)**: - Enable autoSplitPages to automatically detect form boundaries and create separate documents - Requires runAiDetection=true - Falls back to manual page selection if confidence is below threshold - Cannot be used with manual selectedPageNumbers
     * @summary Uploads a multipage PDF for batch processing with AI-powered form detection.
     * @param {TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdDocumentsBatchUploadPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchUploadJobResponseApiResponse>;

    /**
     * 
     * @summary Gets the estimated tax payments that apply to this binder\'s tax year, resolved from the client\'s prior-year binder\'s tax return bundle. Returns an empty result (SourceBinderId == null) when no prior-year data exists.
     * @param {TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdEstimatedPaymentsGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderEstimatedPaymentsDtoApiResponse>;

    /**
     * 
     * @summary Updates a document in staging workflow, allowing modifications to inclusion status, naming, and signature settings.
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreprocessedDocumentDtoApiResponse>;

    /**
     * 
     * @summary Finalizes the staging workflow by moving the binder to final stage and preparing documents for client delivery.
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdStagingFinalizePost(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FinalizeStagingResultDtoApiResponse>;

    /**
     * 
     * @summary Retrieves staging data for an binder showing all preprocessed documents ready for review and finalization.
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdStagingGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStagingDtoApiResponse>;

    /**
     * 
     * @summary Gets the verification status for a binder, including spouse info verification state and the current user\'s role (Primary vs Spouse).
     * @param {TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdVerificationStatusGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderVerificationStatusDtoApiResponse>;

    /**
     * 
     * @summary Marks the spouse info as verified for this binder. For Primary users: Can update marital status and spouse contact info before marking verified. For Spouse users: Can only acknowledge/confirm the information (read-only).
     * @param {TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdVerifySpouseInfoPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderVerificationStatusDtoApiResponse>;

    /**
     * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client.
     * @summary Retrieves a paginated list of binders with optional filtering and sorting. Includes document requests and completion status but not the full document list. Use GET /api/documents?BinderId={id} to retrieve documents for each binder separately.
     * @param {TaxBindersApiApiTaxBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersGet(requestParameters?: TaxBindersApiApiTaxBindersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Starts an amended return on a completed binder. Advances the binder\'s amendment round and moves it back to Sent For Preparation so the amended bundle can be uploaded. Earlier rounds\' documents stay downloadable. The client is not notified until the amended return is released.
     * @param {TaxBindersApiApiTaxBindersIdAmendmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdAmendmentsPost(requestParameters: TaxBindersApiApiTaxBindersIdAmendmentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartAmendmentResultDtoApiResponse>;

    /**
     * Returns a detailed audit trail for the specified binder including: - Binder profile changes - Document uploads and modifications - Document request activity              Each audit entry includes: - Timestamp of the change - User who made the change - Human-readable description of what changed - Detailed field-level changes with before/after values              Access is restricted to: - Admins and Preparers: Can view audit history for any binder - Clients: Can only view audit history for their own binders              Date Range Filtering: - If no dates provided: Returns last 90 days of audit history - If only startDate provided: Returns from startDate to now - If only endDate provided: Returns 90 days before endDate to endDate - If both provided: Returns audit entries within the specified range
     * @summary Retrieves comprehensive audit history for an binder including all related entities
     * @param {TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdAuditHistoryGet(requestParameters: TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderAuditHistoryDtoApiResponse>;

    /**
     * 
     * @summary Which of the signed-in client user\'s own clients a binder belongs to, so the app can make that client active before opening the binder. Not found unless the caller is linked to the binder\'s client, so nothing is revealed.
     * @param {TaxBindersApiApiTaxBindersIdCallerClientGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdCallerClientGet(requestParameters: TaxBindersApiApiTaxBindersIdCallerClientGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BinderClientDtoApiResponse>;

    /**
     * 
     * @summary Browse available documents in CCH Axcess for this binder\'s client and tax year. Returns document metadata with an AlreadyImported flag and MappedDocumentType for each document.              To find tax return bundles (Client Copy, Government Copy, K-1) for import:   GET /api/tax-binders/{id}/cch-documents?className=Tax&subClassName=Returns
     * @param {TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdCchDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CchDocumentDtoListApiResponse>;

    /**
     * 
     * @summary Import selected CCH documents into the binder. Downloads each document from CCH, stores in blob storage, and creates document entities. Documents are automatically categorized based on their CCH class/subclass. Skips duplicates and continues on individual failures.
     * @param {TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdCchDocumentsImportPost(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CchDocumentImportResultDtoApiResponse>;

    /**
     * A client that is not linked to CCH is not an error: the response has `available: false` and an `unavailableReason` the export dialog can show while leaving the download destination usable.
     * @summary Lists the CCH Axcess Document filing locations available for this binder\'s client.
     * @param {TaxBindersApiApiTaxBindersIdCchExportDestinationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdCchExportDestinationsGet(requestParameters: TaxBindersApiApiTaxBindersIdCchExportDestinationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CchExportDestinationOptionsDtoApiResponse>;

    /**
     * 
     * @summary Clears the late documents flag on a binder. This is used by preparers to indicate they have reviewed late document uploads. Resets LateDocumentsUploadedAt to null and LateDocumentsCount to 0. Audit trail is automatically captured by the StructuredAudit system.
     * @param {TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdClearLateDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @summary Permanently deletes a tax binder and all associated documents. This operation cannot be undone.
     * @param {TaxBindersApiApiTaxBindersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdDelete(requestParameters: TaxBindersApiApiTaxBindersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Replace a document that requires signature, invalidating existing signatures. All existing signatures will be reset and signers will need to sign the new document.
     * @param {TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdDocumentsDocumentIdReplacePost(requestParameters: TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReplaceDocumentResponseDtoApiResponse>;

    /**
     * 
     * @summary Downloads the completed signed documents for an binder after e-signature workflow completion.
     * @param {TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdDownloadSignedGet(requestParameters: TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Get e-signature audit history for a binder (IRS compliance). Returns complete audit trail of all e-signature events per IRS Publication 1345 requirements.
     * @param {TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdESignatureAuditGet(requestParameters: TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ESignatureAuditHistoryDtoApiResponse>;

    /**
     * 
     * @summary Get all e-signature documents for a binder with real-time status from DocuSeal. Returns documents that require signatures along with their submission status and signer information.
     * @param {TaxBindersApiApiTaxBindersIdESignaturesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdESignaturesGet(requestParameters: TaxBindersApiApiTaxBindersIdESignaturesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ESignatureDocumentListDtoApiResponse>;

    /**
     * This endpoint uploads an engagement letter PDF to an existing binder and automatically creates a DocuSeal e-signature submission.              **Workflow**: 1. Validates the uploaded file is a PDF 2. If an engagement letter already exists and `ReplaceExisting=false`, returns 409 Conflict 3. If `ReplaceExisting=true` and an engagement letter exists:    - Cancels the existing DocuSeal submission    - Archives the existing document and submission 4. Creates a new Document with Type=EngagementLetter 5. Detects signature fields in the PDF 6. Creates a DocuSeal submission with optional email notification 7. Returns the signing URL and submission details              **Client/Spouse Information**: - If `ClientName`, `ClientEmail`, `SpouseName`, or `SpouseEmail` are not provided,   they default to the values from the binder\'s associated client and spouse records              **Authorization**: - Admin/Preparer only - When X-Active-Client-Id header is provided, binder must belong to that client
     * @summary Attaches an engagement letter PDF to an existing binder and creates a DocuSeal signing request.
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdEngagementLetterAttachPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttachEngagementLetterResponseDtoApiResponse>;

    /**
     * This endpoint gets or creates a DocuSeal e-signature request for the engagement letter document.              **Workflow**: 1. If a submission already exists for the engagement letter, returns the existing submission details 2. If no submission exists, creates a new one using the signature service              **Prerequisites**: - Binder must have an engagement letter document (EngagementLetterDocumentId must be set) - User must have Admin or Preparer role              **Authorization**: - Admin/Preparer only - When X-Active-Client-Id header is provided, binder must belong to that client
     * @summary Prepares the binder\'s engagement letter for e-signature via DocuSeal.
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdEngagementLetterPrepareSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSubmissionDtoApiResponse>;

    /**
     * This endpoint allows clients to upload a scanned or photographed copy of a physically signed engagement letter instead of using the electronic signature flow.              **Requirements**: - The binder must have an existing engagement letter document - The client must have AllowPhysicalSignature enabled - File must be PDF or image (JPEG, PNG)              **What happens**: - The original engagement letter document is archived - The uploaded signed document becomes the new engagement letter - The binder is marked as having the engagement letter signed (via physical upload) - Any pending DocuSeal submission is cancelled
     * @summary Uploads a physically signed engagement letter to complete the signing process.
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdEngagementLetterUploadSignedPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadSignedEngagementLetterResponseDtoApiResponse>;

    /**
     * 
     * @summary Exports all documents in an binder as a downloadable archive file (ZIP).
     * @param {TaxBindersApiApiTaxBindersIdExportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdExportGet(requestParameters: TaxBindersApiApiTaxBindersIdExportGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * The package is assembled exactly as the download export assembles it; only the destination differs. When the binder has non-PDF attachments they are filed as separate documents in the same folder rather than zipped, because a ZIP is not viewable in CCH.              CCH has no delete operation, so a filed document cannot be withdrawn from the portal. A name that already exists in the target folder is reported back as `CCH_DUPLICATE_DOCUMENT_NAME` for the preparer to rename.
     * @summary Builds the binder\'s export package and files it directly into CCH Axcess Document.
     * @param {TaxBindersApiApiTaxBindersIdExportPackageCchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdExportPackageCchPost(requestParameters: TaxBindersApiApiTaxBindersIdExportPackageCchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderCchExportResultDtoApiResponse>;

    /**
     * Sample request:                  POST /api/tax-binders/{id}/export-package     {         \"includeQuestionnaire\": true,         \"includeClientInfo\": true,         \"includeSpouseInfo\": true,         \"includeDependents\": true,         \"includeBankAccounts\": true,         \"documentFilter\": \"ApprovedOnly\",         \"selectedDocumentIds\": []     }              Export order (when included): 1. Questionnaire responses (tabular format with question/answer pairs) 2. Client information (contact, spouse, dependents, bank accounts) 3. Documents (filtered by DocumentFilter option)              DocumentFilter options: - ApprovedOnly: Include only approved documents (default) - All: Include all documents regardless of status - Selected: Include only documents specified in selectedDocumentIds              Note: Questionnaire is only included if the client has completed it. If no questionnaire answers exist, this section is skipped.
     * @summary Exports a comprehensive binder package containing questionnaire responses, client information, and selected documents as a single PDF. Combines questionnaire answers (as the first section), client data tables (contact info, spouse, dependents, bank accounts), and document PDFs.
     * @param {TaxBindersApiApiTaxBindersIdExportPackagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdExportPackagePost(requestParameters: TaxBindersApiApiTaxBindersIdExportPackagePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Generates a preview of selected documents for export, showing file sizes and organization structure.
     * @param {TaxBindersApiApiTaxBindersIdExportPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdExportPreviewPost(requestParameters: TaxBindersApiApiTaxBindersIdExportPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderExportPreviewDtoApiResponse>;

    /**
     * 
     * @summary Exports selected documents from an binder as a downloadable archive file (ZIP).
     * @param {TaxBindersApiApiTaxBindersIdExportSelectedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdExportSelectedPost(requestParameters: TaxBindersApiApiTaxBindersIdExportSelectedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * For Client role users, the binder must belong to the active client specified in X-Active-Client-Id header. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
     * @summary Retrieves detailed information about a specific binder by their unique identifier. Includes document requests and completion status but not the full document list. Use GET /api/documents?BinderId={id} to retrieve the complete document list separately.
     * @param {TaxBindersApiApiTaxBindersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdGet(requestParameters: TaxBindersApiApiTaxBindersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @summary Prepares binder documents for e-signature workflow through DocuSeal integration.
     * @param {TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdPrepareForSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrepareForSignatureResultDtoApiResponse>;

    /**
     * When X-Active-Client-Id header is provided, the tax binder must belong to that client. This prevents updates to tax binders outside the currently active client context.              **Engagement Letter Auto-Submission**: When EngagementLetterDocumentId is set or changed, the system automatically creates a DocuSeal e-signature submission for the document (without sending email/SMS notifications). The preparer can then manually send the signing link to the client when ready.
     * @summary Updates an existing tax binder\'s information including status, due dates, notification settings, and engagement letter assignment.
     * @param {TaxBindersApiApiTaxBindersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdPut(requestParameters: TaxBindersApiApiTaxBindersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @summary Recalls a released tax return, reverting the binder to Sent For Preparation stage. Archives the DocuSeal signature submission, soft-deletes bundle documents, resets signature fields, and notifies the client.
     * @param {TaxBindersApiApiTaxBindersIdRecallReturnPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdRecallReturnPost(requestParameters: TaxBindersApiApiTaxBindersIdRecallReturnPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecallReturnResultDtoApiResponse>;

    /**
     * 
     * @summary Gets the release status for a binder including signature progress.
     * @param {TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdReleaseStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseStatusDtoApiResponse>;

    /**
     * 
     * @summary Releases returns to client for final review and signing. Sends signature requests for all 8879 forms and Direct Deposit Report (if present), transitions binder to FinalClientReview stage, and notifies the client.
     * @param {TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdReleaseToClientPost(requestParameters: TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseToClientResultDtoApiResponse>;

    /**
     * 
     * @summary Client requests changes to their tax return during FinalClientReview stage. This transitions the binder to ClientRequestsChanges stage and notifies preparers.
     * @param {TaxBindersApiApiTaxBindersIdRequestChangesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdRequestChangesPost(requestParameters: TaxBindersApiApiTaxBindersIdRequestChangesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @summary Resends the welcome email to the client for a binder.
     * @param {TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdResendWelcomeEmailPost(requestParameters: TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Every return round recorded against a binder, oldest first, with the document ids needed to download each round\'s client copy and signed package. Drives the preparer\'s original-return history and the client\'s permanent download list.
     * @param {TaxBindersApiApiTaxBindersIdReturnsHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdReturnsHistoryGet(requestParameters: TaxBindersApiApiTaxBindersIdReturnsHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnHistoryDtoApiResponse>;

    /**
     * 
     * @summary Sends a binder back to the client for additional information. This transitions the binder from ClientSubmitted or InReview stage back to Open, creates a comment with the reason, and sends an email notification to the client.
     * @param {TaxBindersApiApiTaxBindersIdSendBackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSendBackPost(requestParameters: TaxBindersApiApiTaxBindersIdSendBackPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @summary Embedded signing session (DocuSeal slug) for the current user on a signature document. Returns 403 if the caller isn\'t an assigned signer. Clients are scoped to their active client.
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureSigningSessionDtoApiResponse>;

    /**
     * 
     * @summary Client users eligible to be assigned as signers on a signature document for this binder\'s client. Includes all client-user relationships on the account.
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSignersDtoApiResponse>;

    /**
     * 
     * @summary Lists this binder\'s signature documents (sent for e-signature) with per-signer status. Used by the preparer management view and the client \"documents to sign\" surface. Clients are scoped to their active client.
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSignatureDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureDocumentListDtoApiResponse>;

    /**
     * 
     * @summary Send a binder document for e-signature. Placed fields are assigned to client-user signers by role. Creates a DocuSeal submission in embedded mode (signers sign in-app); notifications are driven by our system.
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSignatureDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignatureRequestResultDtoApiResponse>;

    /**
     * 
     * @summary Retrieves the e-signature status for an binder, including completion status and signing progress.
     * @param {TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSignatureStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ObjectApiResponse>;

    /**
     * 
     * @summary Updates the processing stage of a binder to track workflow progress (New → Preprocessing → Staging → Final). Use this endpoint to mark workflow transitions as the preparer processes documents through different stages. Requires Preparer or Admin role.
     * @param {TaxBindersApiApiTaxBindersIdStagePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdStagePatch(requestParameters: TaxBindersApiApiTaxBindersIdStagePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * This endpoint is idempotent - re-submitting an already-submitted binder updates the timestamp. If a note is provided, it will be saved as a Comment visible to both client and preparer. A SignalR notification is sent to preparers and admins when a binder is submitted.
     * @summary Submits a binder for preparer review (Ready to Proceed). Indicates the client has finished uploading documents and is ready for the preparer to begin working.
     * @param {TaxBindersApiApiTaxBindersIdSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdSubmitPost(requestParameters: TaxBindersApiApiTaxBindersIdSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @summary Withdraws a binder submission, allowing the client to continue uploading documents.
     * @param {TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersIdWithdrawSubmissionPost(requestParameters: TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * When X-Active-Client-Id header is provided, the ClientId in the request body is automatically set to the active client. This ensures preparers/admins can only create tax binders for the currently active client in the UI.
     * @summary Creates a new tax binder for a specific client and tax year.
     * @param {TaxBindersApiApiTaxBindersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersPost(requestParameters: TaxBindersApiApiTaxBindersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxBinderDtoApiResponse>;

    /**
     * 
     * @summary Retrieves the available tax type options for filtering binders.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersTaxTypeOptionsGet(options?: RawAxiosRequestConfig): AxiosPromise<TaxTypeOptionListApiResponse>;

    /**
     * This endpoint creates the tax binder with PreparerId automatically set to the current user. If a tax binder of the same type already exists for the client + tax year combination, a 409 Conflict is returned. The bundle PDFs are processed to extract individual returns based on bookmark structure.
     * @summary Creates a new tax binder and uploads tax return bundle PDFs in a single atomic operation. Use this when a preparer wants to upload returns to a client without an existing tax binder.
     * @param {TaxBindersApiApiTaxBindersWithBundlePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersWithBundlePost(requestParameters: TaxBindersApiApiTaxBindersWithBundlePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBinderWithBundleResultDtoApiResponse>;

}

/**
 * Request parameters for apiTaxBindersBatchUploadJobIdResultsGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest {
    /**
     * The unique job identifier
     */
    readonly jobId: string
}

/**
 * Request parameters for apiTaxBindersBatchUploadJobIdStatusGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest {
    /**
     * The unique job identifier returned from the upload endpoint
     */
    readonly jobId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPostRequest {
    /**
     * The unique identifier of the binder
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdAnalyzeOrganizerPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly extractEngagementLetter?: boolean

    /**
     * Use an existing client ID
     */
    readonly clientOperationId?: string

    readonly organizerPdf?: File
}

/**
 * Request parameters for apiTaxBindersBinderIdArchivePatch operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest {
    /**
     * The unique identifier of the binder to archive/unarchive
     */
    readonly binderId: string

    /**
     * The archive request containing the desired archive status
     */
    readonly archiveTaxBinderRequest?: ArchiveTaxBinderRequest
}

/**
 * Request parameters for apiTaxBindersBinderIdDocumentsBatchUploadPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest {
    /**
     * The binder to upload documents to
     */
    readonly binderId: string

    /**
     * Enable AI-powered tax form detection (default: true)
     */
    readonly runAiDetection?: boolean

    /**
     * Minimum confidence for AI detections (0.0-1.0, default: 0.70)
     */
    readonly confidenceThreshold?: number

    /**
     * Create separate document records for each form (default: true)
     */
    readonly createSeparateDocuments?: boolean

    /**
     * Extract structured data from forms (default: false, Phase 3 feature)
     */
    readonly extractDocumentData?: boolean

    /**
     * Group consecutive pages of same form type (default: true)
     */
    readonly groupMultiPageForms?: boolean

    /**
     * Document direction: ReceivedFromClient or SentToClient. If not provided, uses role-based inference
     */
    readonly direction?: DocumentDirection

    /**
     * Optional comma-separated list of page numbers to process (1-based). If not provided, all pages are processed. Can be combined with autoSplitPages to first filter pages, then auto-split within the selection
     */
    readonly selectedPageNumbers?: string

    /**
     * Enable automatic page splitting based on detected form boundaries within selected pages. Requires runAiDetection&#x3D;true. Works with selectedPageNumbers as a pre-filter (default: false)
     */
    readonly autoSplitPages?: boolean

    /**
     * Minimum confidence threshold (0.0-1.0) for auto-split decisions (default: 0.80)
     */
    readonly autoSplitConfidenceThreshold?: number

    /**
     * Generate AI descriptions for each auto-split document (default: true)
     */
    readonly generateAiDescriptionsForAutoSplit?: boolean

    /**
     * The multipage PDF file to process
     */
    readonly file?: File
}

/**
 * Request parameters for apiTaxBindersBinderIdEstimatedPaymentsGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdStagingDocumentsDocumentIdPut operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest {
    /**
     * The unique identifier of the binder containing the document.
     */
    readonly binderId: string

    /**
     * The unique identifier of the document to update in staging.
     */
    readonly documentId: string

    /**
     * The document updates including inclusion status, name changes, and signature configuration.
     */
    readonly updatePreprocessedDocumentDto?: UpdatePreprocessedDocumentDto
}

/**
 * Request parameters for apiTaxBindersBinderIdStagingFinalizePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest {
    /**
     * The unique identifier of the binder to finalize staging for.
     */
    readonly binderId: string

    /**
     * The finalization request containing delivery options and final document configuration.
     */
    readonly finalizeStagingDto?: FinalizeStagingDto
}

/**
 * Request parameters for apiTaxBindersBinderIdStagingGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdStagingGetRequest {
    /**
     * The unique identifier of the binder to get staging data for.
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdVerificationStatusGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest {
    /**
     * The unique identifier of the binder
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdVerifySpouseInfoPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest {
    /**
     * The unique identifier of the binder
     */
    readonly binderId: string

    /**
     * Optional spouse info update (for Primary users only)
     */
    readonly verifySpouseInfoDto?: VerifySpouseInfoDto
}

/**
 * Request parameters for apiTaxBindersGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersGetRequest {
    readonly taxYear?: number

    /**
     * Use an existing client ID
     */
    readonly clientId?: string

    readonly preparerId?: string

    readonly officeId?: string

    /**
     * Filter by assigned partner (User ID). Filters binders whose client has this partner assigned.
     */
    readonly partnerId?: string

    /**
     * Filter by client tax type (Individual, Business, Partnership, etc.)
     */
    readonly taxType?: ClientType

    readonly dueDateFrom?: string

    readonly dueDateTo?: string

    /**
     * Search term to filter binders by client name, email, or phone number
     */
    readonly search?: string

    /**
     * Filter by priority level: \&quot;urgent\&quot;, \&quot;high\&quot;, \&quot;medium\&quot;, \&quot;low\&quot;
     */
    readonly priority?: string

    /**
     * Filter to show only overdue binders (past due date)
     */
    readonly isOverdue?: boolean

    /**
     * Filter to only show binders for clients watched by the current user. Only applies to Preparer users; Admins see all binders regardless.
     */
    readonly watchedClientsOnly?: boolean

    /**
     * Filter to show only client-submitted or non-submitted binders. True &#x3D; only submitted binders, False &#x3D; only non-submitted binders, null &#x3D; no filter
     */
    readonly isClientSubmitted?: boolean

    /**
     * Filter to show only binders with documents pending review. True &#x3D; only binders with unreviewed documents, False &#x3D; only binders without, null &#x3D; no filter
     */
    readonly hasUnreviewedDocuments?: boolean

    /**
     * Filter to show only binders with comments pending review. True &#x3D; only binders with unread comments, False &#x3D; only binders without, null &#x3D; no filter
     */
    readonly hasUnreviewedComments?: boolean

    /**
     * Filter to show only binders with late documents (documents uploaded after SentForPreparation stage). True &#x3D; only binders with late documents, False &#x3D; only binders without, null &#x3D; no filter
     */
    readonly hasLateDocuments?: boolean

    /**
     * Filter to show only binders assigned to the current user. True &#x3D; only binders where the current user is the preparer False or null (default) &#x3D; show all binders regardless of assignment
     */
    readonly assignedToMe?: boolean

    /**
     * Filter by binder processing stage (New, Open, ClientSubmitted, InReview, etc.)
     */
    readonly stage?: BinderStage

    /**
     * Filter by binder type (Normal or GiftTax).
     */
    readonly type?: TaxBinderType

    readonly page?: number

    readonly limit?: number

    readonly sortBy?: string

    readonly sortOrder?: string
}

/**
 * Request parameters for apiTaxBindersIdAmendmentsPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdAmendmentsPostRequest {
    /**
     * The completed binder to amend
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdAuditHistoryGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest {
    /**
     * The unique identifier of the binder
     */
    readonly id: string

    /**
     * Optional start date for filtering audit entries (inclusive, UTC)
     */
    readonly startDate?: string

    /**
     * Optional end date for filtering audit entries (inclusive, UTC)
     */
    readonly endDate?: string

    readonly search?: string

    readonly action?: string

    readonly entityType?: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiTaxBindersIdCallerClientGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdCallerClientGetRequest {
    /**
     * The binder.
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdCchDocumentsGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest {
    /**
     * Binder ID
     */
    readonly id: string

    /**
     * Optional CCH class filter (e.g. \&quot;Tax\&quot;, \&quot;Income\&quot;, \&quot;Deduction\&quot;)
     */
    readonly className?: string

    /**
     * Optional CCH subclass filter (e.g. \&quot;Returns\&quot;, \&quot;Extensions\&quot;, \&quot;Vouchers\&quot;)
     */
    readonly subClassName?: string
}

/**
 * Request parameters for apiTaxBindersIdCchDocumentsImportPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest {
    readonly id: string

    readonly cchDocumentImportRequest?: CchDocumentImportRequest
}

/**
 * Request parameters for apiTaxBindersIdCchExportDestinationsGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdCchExportDestinationsGetRequest {
    /**
     * The unique identifier of the tax binder.
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdClearLateDocumentsPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest {
    /**
     * The unique identifier of the binder
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdDelete operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdDeleteRequest {
    /**
     * The unique identifier of the tax binder to delete.
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdDocumentsDocumentIdReplacePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest {
    /**
     * The unique identifier of the binder
     */
    readonly id: string

    /**
     * The unique identifier of the document to replace
     */
    readonly documentId: string

    /**
     * Must be true to confirm that replacing the document will invalidate all existing signatures
     */
    readonly confirmReset?: boolean

    /**
     * Whether to send notifications to signers about the replacement
     */
    readonly sendNotification?: boolean

    /**
     * The new document file
     */
    readonly file?: File
}

/**
 * Request parameters for apiTaxBindersIdDownloadSignedGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest {
    /**
     * The unique identifier of the binder with completed signatures.
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdESignatureAuditGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest {
    /**
     * The unique identifier of the binder
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdESignaturesGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdESignaturesGetRequest {
    /**
     * The unique identifier of the binder
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdEngagementLetterAttachPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest {
    /**
     * The unique identifier of the binder
     */
    readonly id: string

    /**
     * The engagement letter PDF file to attach
     */
    readonly file: File

    /**
     * If true, replaces any existing engagement letter. If false, returns error when one exists.
     */
    readonly replaceExisting?: boolean

    /**
     * Optional override for client name (defaults to client data from binder)
     */
    readonly clientName?: string

    /**
     * Optional override for client email (defaults to client data from binder)
     */
    readonly clientEmail?: string

    /**
     * Optional override for spouse name (defaults to spouse data from binder)
     */
    readonly spouseName?: string

    /**
     * Optional override for spouse email (defaults to spouse data from binder)
     */
    readonly spouseEmail?: string
}

/**
 * Request parameters for apiTaxBindersIdEngagementLetterPrepareSignaturePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest {
    /**
     * The unique identifier of the binder
     */
    readonly id: string

    /**
     * Signature preparation request with client/spouse information
     */
    readonly singleDocumentSignatureDto?: SingleDocumentSignatureDto
}

/**
 * Request parameters for apiTaxBindersIdEngagementLetterUploadSignedPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest {
    readonly id: string

    /**
     * The signed engagement letter file (PDF or image)
     */
    readonly file: File

    /**
     * Optional comment from the client about the upload
     */
    readonly comment?: string
}

/**
 * Request parameters for apiTaxBindersIdExportGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdExportGetRequest {
    /**
     * The unique identifier of the binder to export.
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdExportPackageCchPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdExportPackageCchPostRequest {
    /**
     * The unique identifier of the tax binder to export.
     */
    readonly id: string

    /**
     * Package options plus the chosen CCH filing destination.
     */
    readonly taxBinderCchExportRequestDto?: TaxBinderCchExportRequestDto
}

/**
 * Request parameters for apiTaxBindersIdExportPackagePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdExportPackagePostRequest {
    /**
     * The unique identifier of the binder to export as a package.
     */
    readonly id: string

    /**
     * Export options including questionnaire, client info sections, and document filter (ApprovedOnly, All, or Selected).
     */
    readonly taxBinderPackageExportDto?: TaxBinderPackageExportDto
}

/**
 * Request parameters for apiTaxBindersIdExportPreviewPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdExportPreviewPostRequest {
    /**
     * The unique identifier of the binder.
     */
    readonly id: string

    /**
     * The document selection criteria for the export preview.
     */
    readonly taxBinderExportSelectionDto?: TaxBinderExportSelectionDto
}

/**
 * Request parameters for apiTaxBindersIdExportSelectedPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdExportSelectedPostRequest {
    /**
     * The unique identifier of the binder.
     */
    readonly id: string

    /**
     * The document selection criteria specifying which documents to export.
     */
    readonly taxBinderExportSelectionDto?: TaxBinderExportSelectionDto
}

/**
 * Request parameters for apiTaxBindersIdGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdGetRequest {
    /**
     * The unique identifier of the binder to retrieve.
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdPrepareForSignaturePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest {
    /**
     * The unique identifier of the binder to prepare for signing.
     */
    readonly id: string

    /**
     * The signature preparation configuration including client email and signature fields.
     */
    readonly prepareForSignatureDto?: PrepareForSignatureDto
}

/**
 * Request parameters for apiTaxBindersIdPut operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdPutRequest {
    /**
     * The unique identifier of the tax binder to update.
     */
    readonly id: string

    /**
     * The tax binder data to update with new information.
     */
    readonly updateTaxBinderDto?: UpdateTaxBinderDto
}

/**
 * Request parameters for apiTaxBindersIdRecallReturnPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdRecallReturnPostRequest {
    /**
     * The binder ID to recall
     */
    readonly id: string

    /**
     * Recall options including required reason
     */
    readonly recallReturnDto?: RecallReturnDto
}

/**
 * Request parameters for apiTaxBindersIdReleaseStatusGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest {
    /**
     * The binder ID
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdReleaseToClientPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest {
    /**
     * The binder ID to release
     */
    readonly id: string

    /**
     * Release options including optional custom message
     */
    readonly releaseToClientDto?: ReleaseToClientDto
}

/**
 * Request parameters for apiTaxBindersIdRequestChangesPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdRequestChangesPostRequest {
    /**
     * The unique identifier of the binder
     */
    readonly id: string

    /**
     * The request with reason for changes
     */
    readonly requestChangesDto?: RequestChangesDto
}

/**
 * Request parameters for apiTaxBindersIdResendWelcomeEmailPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest {
    /**
     * The unique identifier of the binder
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdReturnsHistoryGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdReturnsHistoryGetRequest {
    /**
     * The binder to read return history for
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdSendBackPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSendBackPostRequest {
    /**
     * The unique identifier of the binder to send back
     */
    readonly id: string

    /**
     * The request containing the required reason for sending back
     */
    readonly sendBackToClientDto?: SendBackToClientDto
}

/**
 * Request parameters for apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest {
    readonly id: string

    /**
     * Copy this from the Staging Data response or Preprocessing results
     */
    readonly documentId: string
}

/**
 * Request parameters for apiTaxBindersIdSignatureDocumentsEligibleSignersGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdSignatureDocumentsGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest {
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdSignatureDocumentsPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest {
    readonly id: string

    readonly createSignatureRequestDto?: CreateSignatureRequestDto
}

/**
 * Request parameters for apiTaxBindersIdSignatureStatusGet operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest {
    /**
     * The unique identifier of the binder to check signature status for.
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersIdStagePatch operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdStagePatchRequest {
    /**
     * The unique identifier of the binder to update stage for.
     */
    readonly id: string

    /**
     * The new stage data containing the desired binder processing stage.
     */
    readonly updateTaxBinderStageDto?: UpdateTaxBinderStageDto
}

/**
 * Request parameters for apiTaxBindersIdSubmitPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdSubmitPostRequest {
    /**
     * The unique identifier of the binder to submit
     */
    readonly id: string

    /**
     * Optional note to the preparer (creates a Comment on the binder)
     */
    readonly submitTaxBinderRequest?: SubmitTaxBinderRequest
}

/**
 * Request parameters for apiTaxBindersIdWithdrawSubmissionPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest {
    /**
     * The unique identifier of the binder to withdraw
     */
    readonly id: string
}

/**
 * Request parameters for apiTaxBindersPost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersPostRequest {
    readonly name: string

    readonly taxYear: number

    readonly clientId: string

    readonly type?: TaxBinderType

    readonly preparerId?: string

    readonly dueDate?: string

    readonly notificationDaysPrior?: number

    /**
     * URL link to the invoice for this binder (optional)
     */
    readonly invoiceLink?: string

    /**
     * Optional binder PDF file generated by tax software for processing
     */
    readonly organizerPdf?: File

    /**
     * Optional standalone engagement letter PDF. Takes precedence over ExtractEngagementLetter.
     */
    readonly engagementLetterPdf?: File

    /**
     * Extract engagement letter pages from OrganizerPdf. Ignored when EngagementLetterPdf is provided.
     */
    readonly extractEngagementLetter?: boolean

    /**
     * If true, sends a welcome email to the client with a link to the binder. The email is sent using the Postmark template \\\&#39;client-portal-binder-link\\\&#39;.
     */
    readonly sendWelcomeEmail?: boolean
}

/**
 * Request parameters for apiTaxBindersWithBundlePost operation in TaxBindersApi.
 */
export interface TaxBindersApiApiTaxBindersWithBundlePostRequest {
    /**
     * The client ID to create the binder for (required)
     */
    readonly clientId: string

    /**
     * Tax year for the binder (required)
     */
    readonly taxYear: number

    /**
     * Display name for the binder (required)
     */
    readonly name: string

    /**
     * Client Copy PDF file (required)
     */
    readonly clientCopyPdf: File

    /**
     * Government Copy PDF file (required)
     */
    readonly governmentCopyPdf: File

    readonly type?: TaxBinderType

    /**
     * Due date for the binder (optional)
     */
    readonly dueDate?: string

    /**
     * URL link to the invoice for this binder (optional)
     */
    readonly invoiceLink?: string

    /**
     * K-1 PDF file (optional) - contains Schedule K-1 forms for pass-through entities
     */
    readonly k1Pdf?: File

    /**
     * If true, marks the engagement letter as already signed (e.g. physical signature). Defaults to false. Only applies when an engagement letter is found in the bundle.
     */
    readonly engagementLetterAlreadySigned?: boolean
}

/**
 * TaxBindersApi - object-oriented interface
 */
export class TaxBindersApi extends BaseAPI implements TaxBindersApiInterface {
    /**
     * This endpoint returns the complete results after the job has finished processing.              **Prerequisites**: - Job status must be \"completed\" - If job is still processing, returns 425 Too Early - If job failed, returns 400 with error details              **Result Information**: - List of created documents with page numbers and form types - Auto-assignment results (which documents matched required slots) - Processing summary with statistics - Any warnings or issues encountered              **Authorization**: - Users can only query their own job results - Admins can query any job results
     * @summary Gets the final results of a completed batch upload job.
     * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBatchUploadJobIdResultsGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdResultsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBatchUploadJobIdResultsGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Poll this endpoint to check job progress and completion.              **Status Values**: - `queued`: Job is waiting to be processed - `processing`: Job is currently running - `completed`: Job finished successfully (use GetBatchUploadResults to get results) - `failed`: Job failed (check ErrorMessage for details)              **Authorization**: - Users can only query their own jobs - Admins can query any job
     * @summary Gets the current status of a batch upload job.
     * @param {TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBatchUploadJobIdStatusGet(requestParameters: TaxBindersApiApiTaxBindersBatchUploadJobIdStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBatchUploadJobIdStatusGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Records the current user\'s acknowledgment of the engagement-letter upload warning for this binder. Shown once per binder (before \"Client Submitted\") when no engagement letter is attached yet, to inform the client that ATA will not begin work on the return until the engagement letter is signed. Idempotent — repeated calls keep the original acknowledgment timestamp.
     * @param {TaxBindersApiApiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdAcknowledgeEngagementLetterWarningPost(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Analyzes an organizer PDF against an existing binder and creates document requests. Optionally extracts the engagement letter into its own Document.
     * @param {TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdAnalyzeOrganizerPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdAnalyzeOrganizerPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdAnalyzeOrganizerPost(requestParameters.binderId, requestParameters.extractEngagementLetter, requestParameters.clientOperationId, requestParameters.organizerPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archived binders: - Prevent client uploads (cannot add new documents) - Allow clients to view firm-delivered documents - Indicate completed tax preparation workflow              Only Preparers and Admins can archive binders. When X-Active-Client-Id header is provided, the binder must belong to that client.
     * @summary Archives or unarchives an binder to control client upload permissions and document visibility.
     * @param {TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdArchivePatch(requestParameters: TaxBindersApiApiTaxBindersBinderIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdArchivePatch(requestParameters.binderId, requestParameters.archiveTaxBinderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint queues a background job to: - Split the PDF into individual pages (or process only selected pages if specified) - Run AI form detection on each page (optional) - Group related pages into documents - Auto-assign documents to required document slots (if matches found)              The job runs asynchronously in the background. Use the returned JobId to poll for status and results.              **Authorization**: - Clients: Can upload to own binders only - Preparers/Admins: Can upload to any binder              **File Requirements**: - Must be PDF format - Maximum size: configured via FileUploadOptions.MaxFileSizeBytes - Binder must not be archived              **Page Selection**: - If selectedPageNumbers is null or empty, all pages will be processed - If specified, only the listed page numbers will be processed (1-based) - Example: \"1,3,5,10\" will process only pages 1, 3, 5, and 10              **Auto-Split (Phase 2 Enhancement)**: - Enable autoSplitPages to automatically detect form boundaries and create separate documents - Requires runAiDetection=true - Falls back to manual page selection if confidence is below threshold - Cannot be used with manual selectedPageNumbers
     * @summary Uploads a multipage PDF for batch processing with AI-powered form detection.
     * @param {TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdDocumentsBatchUploadPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdDocumentsBatchUploadPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdDocumentsBatchUploadPost(requestParameters.binderId, requestParameters.runAiDetection, requestParameters.confidenceThreshold, requestParameters.createSeparateDocuments, requestParameters.extractDocumentData, requestParameters.groupMultiPageForms, requestParameters.direction, requestParameters.selectedPageNumbers, requestParameters.autoSplitPages, requestParameters.autoSplitConfidenceThreshold, requestParameters.generateAiDescriptionsForAutoSplit, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the estimated tax payments that apply to this binder\'s tax year, resolved from the client\'s prior-year binder\'s tax return bundle. Returns an empty result (SourceBinderId == null) when no prior-year data exists.
     * @param {TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdEstimatedPaymentsGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdEstimatedPaymentsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdEstimatedPaymentsGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a document in staging workflow, allowing modifications to inclusion status, naming, and signature settings.
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingDocumentsDocumentIdPutRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdStagingDocumentsDocumentIdPut(requestParameters.binderId, requestParameters.documentId, requestParameters.updatePreprocessedDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finalizes the staging workflow by moving the binder to final stage and preparing documents for client delivery.
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdStagingFinalizePost(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingFinalizePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdStagingFinalizePost(requestParameters.binderId, requestParameters.finalizeStagingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves staging data for an binder showing all preprocessed documents ready for review and finalization.
     * @param {TaxBindersApiApiTaxBindersBinderIdStagingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdStagingGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdStagingGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdStagingGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the verification status for a binder, including spouse info verification state and the current user\'s role (Primary vs Spouse).
     * @param {TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdVerificationStatusGet(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerificationStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdVerificationStatusGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks the spouse info as verified for this binder. For Primary users: Can update marital status and spouse contact info before marking verified. For Spouse users: Can only acknowledge/confirm the information (read-only).
     * @param {TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdVerifySpouseInfoPost(requestParameters: TaxBindersApiApiTaxBindersBinderIdVerifySpouseInfoPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersBinderIdVerifySpouseInfoPost(requestParameters.binderId, requestParameters.verifySpouseInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Client role users, the X-Active-Client-Id header is required and results are automatically filtered to that client. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, results are filtered to that client.
     * @summary Retrieves a paginated list of binders with optional filtering and sorting. Includes document requests and completion status but not the full document list. Use GET /api/documents?BinderId={id} to retrieve documents for each binder separately.
     * @param {TaxBindersApiApiTaxBindersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersGet(requestParameters: TaxBindersApiApiTaxBindersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersGet(requestParameters.taxYear, requestParameters.clientId, requestParameters.preparerId, requestParameters.officeId, requestParameters.partnerId, requestParameters.taxType, requestParameters.dueDateFrom, requestParameters.dueDateTo, requestParameters.search, requestParameters.priority, requestParameters.isOverdue, requestParameters.watchedClientsOnly, requestParameters.isClientSubmitted, requestParameters.hasUnreviewedDocuments, requestParameters.hasUnreviewedComments, requestParameters.hasLateDocuments, requestParameters.assignedToMe, requestParameters.stage, requestParameters.type, requestParameters.page, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Starts an amended return on a completed binder. Advances the binder\'s amendment round and moves it back to Sent For Preparation so the amended bundle can be uploaded. Earlier rounds\' documents stay downloadable. The client is not notified until the amended return is released.
     * @param {TaxBindersApiApiTaxBindersIdAmendmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdAmendmentsPost(requestParameters: TaxBindersApiApiTaxBindersIdAmendmentsPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdAmendmentsPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a detailed audit trail for the specified binder including: - Binder profile changes - Document uploads and modifications - Document request activity              Each audit entry includes: - Timestamp of the change - User who made the change - Human-readable description of what changed - Detailed field-level changes with before/after values              Access is restricted to: - Admins and Preparers: Can view audit history for any binder - Clients: Can only view audit history for their own binders              Date Range Filtering: - If no dates provided: Returns last 90 days of audit history - If only startDate provided: Returns from startDate to now - If only endDate provided: Returns 90 days before endDate to endDate - If both provided: Returns audit entries within the specified range
     * @summary Retrieves comprehensive audit history for an binder including all related entities
     * @param {TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdAuditHistoryGet(requestParameters: TaxBindersApiApiTaxBindersIdAuditHistoryGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdAuditHistoryGet(requestParameters.id, requestParameters.startDate, requestParameters.endDate, requestParameters.search, requestParameters.action, requestParameters.entityType, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Which of the signed-in client user\'s own clients a binder belongs to, so the app can make that client active before opening the binder. Not found unless the caller is linked to the binder\'s client, so nothing is revealed.
     * @param {TaxBindersApiApiTaxBindersIdCallerClientGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdCallerClientGet(requestParameters: TaxBindersApiApiTaxBindersIdCallerClientGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdCallerClientGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Browse available documents in CCH Axcess for this binder\'s client and tax year. Returns document metadata with an AlreadyImported flag and MappedDocumentType for each document.              To find tax return bundles (Client Copy, Government Copy, K-1) for import:   GET /api/tax-binders/{id}/cch-documents?className=Tax&subClassName=Returns
     * @param {TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdCchDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdCchDocumentsGet(requestParameters.id, requestParameters.className, requestParameters.subClassName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import selected CCH documents into the binder. Downloads each document from CCH, stores in blob storage, and creates document entities. Documents are automatically categorized based on their CCH class/subclass. Skips duplicates and continues on individual failures.
     * @param {TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdCchDocumentsImportPost(requestParameters: TaxBindersApiApiTaxBindersIdCchDocumentsImportPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdCchDocumentsImportPost(requestParameters.id, requestParameters.cchDocumentImportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A client that is not linked to CCH is not an error: the response has `available: false` and an `unavailableReason` the export dialog can show while leaving the download destination usable.
     * @summary Lists the CCH Axcess Document filing locations available for this binder\'s client.
     * @param {TaxBindersApiApiTaxBindersIdCchExportDestinationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdCchExportDestinationsGet(requestParameters: TaxBindersApiApiTaxBindersIdCchExportDestinationsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdCchExportDestinationsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Clears the late documents flag on a binder. This is used by preparers to indicate they have reviewed late document uploads. Resets LateDocumentsUploadedAt to null and LateDocumentsCount to 0. Audit trail is automatically captured by the StructuredAudit system.
     * @param {TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdClearLateDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdClearLateDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdClearLateDocumentsPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently deletes a tax binder and all associated documents. This operation cannot be undone.
     * @param {TaxBindersApiApiTaxBindersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdDelete(requestParameters: TaxBindersApiApiTaxBindersIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a document that requires signature, invalidating existing signatures. All existing signatures will be reset and signers will need to sign the new document.
     * @param {TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdDocumentsDocumentIdReplacePost(requestParameters: TaxBindersApiApiTaxBindersIdDocumentsDocumentIdReplacePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdDocumentsDocumentIdReplacePost(requestParameters.id, requestParameters.documentId, requestParameters.confirmReset, requestParameters.sendNotification, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads the completed signed documents for an binder after e-signature workflow completion.
     * @param {TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdDownloadSignedGet(requestParameters: TaxBindersApiApiTaxBindersIdDownloadSignedGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdDownloadSignedGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get e-signature audit history for a binder (IRS compliance). Returns complete audit trail of all e-signature events per IRS Publication 1345 requirements.
     * @param {TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdESignatureAuditGet(requestParameters: TaxBindersApiApiTaxBindersIdESignatureAuditGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdESignatureAuditGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all e-signature documents for a binder with real-time status from DocuSeal. Returns documents that require signatures along with their submission status and signer information.
     * @param {TaxBindersApiApiTaxBindersIdESignaturesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdESignaturesGet(requestParameters: TaxBindersApiApiTaxBindersIdESignaturesGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdESignaturesGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint uploads an engagement letter PDF to an existing binder and automatically creates a DocuSeal e-signature submission.              **Workflow**: 1. Validates the uploaded file is a PDF 2. If an engagement letter already exists and `ReplaceExisting=false`, returns 409 Conflict 3. If `ReplaceExisting=true` and an engagement letter exists:    - Cancels the existing DocuSeal submission    - Archives the existing document and submission 4. Creates a new Document with Type=EngagementLetter 5. Detects signature fields in the PDF 6. Creates a DocuSeal submission with optional email notification 7. Returns the signing URL and submission details              **Client/Spouse Information**: - If `ClientName`, `ClientEmail`, `SpouseName`, or `SpouseEmail` are not provided,   they default to the values from the binder\'s associated client and spouse records              **Authorization**: - Admin/Preparer only - When X-Active-Client-Id header is provided, binder must belong to that client
     * @summary Attaches an engagement letter PDF to an existing binder and creates a DocuSeal signing request.
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdEngagementLetterAttachPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterAttachPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdEngagementLetterAttachPost(requestParameters.id, requestParameters.file, requestParameters.replaceExisting, requestParameters.clientName, requestParameters.clientEmail, requestParameters.spouseName, requestParameters.spouseEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint gets or creates a DocuSeal e-signature request for the engagement letter document.              **Workflow**: 1. If a submission already exists for the engagement letter, returns the existing submission details 2. If no submission exists, creates a new one using the signature service              **Prerequisites**: - Binder must have an engagement letter document (EngagementLetterDocumentId must be set) - User must have Admin or Preparer role              **Authorization**: - Admin/Preparer only - When X-Active-Client-Id header is provided, binder must belong to that client
     * @summary Prepares the binder\'s engagement letter for e-signature via DocuSeal.
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdEngagementLetterPrepareSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterPrepareSignaturePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdEngagementLetterPrepareSignaturePost(requestParameters.id, requestParameters.singleDocumentSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint allows clients to upload a scanned or photographed copy of a physically signed engagement letter instead of using the electronic signature flow.              **Requirements**: - The binder must have an existing engagement letter document - The client must have AllowPhysicalSignature enabled - File must be PDF or image (JPEG, PNG)              **What happens**: - The original engagement letter document is archived - The uploaded signed document becomes the new engagement letter - The binder is marked as having the engagement letter signed (via physical upload) - Any pending DocuSeal submission is cancelled
     * @summary Uploads a physically signed engagement letter to complete the signing process.
     * @param {TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdEngagementLetterUploadSignedPost(requestParameters: TaxBindersApiApiTaxBindersIdEngagementLetterUploadSignedPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdEngagementLetterUploadSignedPost(requestParameters.id, requestParameters.file, requestParameters.comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exports all documents in an binder as a downloadable archive file (ZIP).
     * @param {TaxBindersApiApiTaxBindersIdExportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdExportGet(requestParameters: TaxBindersApiApiTaxBindersIdExportGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdExportGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The package is assembled exactly as the download export assembles it; only the destination differs. When the binder has non-PDF attachments they are filed as separate documents in the same folder rather than zipped, because a ZIP is not viewable in CCH.              CCH has no delete operation, so a filed document cannot be withdrawn from the portal. A name that already exists in the target folder is reported back as `CCH_DUPLICATE_DOCUMENT_NAME` for the preparer to rename.
     * @summary Builds the binder\'s export package and files it directly into CCH Axcess Document.
     * @param {TaxBindersApiApiTaxBindersIdExportPackageCchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdExportPackageCchPost(requestParameters: TaxBindersApiApiTaxBindersIdExportPackageCchPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdExportPackageCchPost(requestParameters.id, requestParameters.taxBinderCchExportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sample request:                  POST /api/tax-binders/{id}/export-package     {         \"includeQuestionnaire\": true,         \"includeClientInfo\": true,         \"includeSpouseInfo\": true,         \"includeDependents\": true,         \"includeBankAccounts\": true,         \"documentFilter\": \"ApprovedOnly\",         \"selectedDocumentIds\": []     }              Export order (when included): 1. Questionnaire responses (tabular format with question/answer pairs) 2. Client information (contact, spouse, dependents, bank accounts) 3. Documents (filtered by DocumentFilter option)              DocumentFilter options: - ApprovedOnly: Include only approved documents (default) - All: Include all documents regardless of status - Selected: Include only documents specified in selectedDocumentIds              Note: Questionnaire is only included if the client has completed it. If no questionnaire answers exist, this section is skipped.
     * @summary Exports a comprehensive binder package containing questionnaire responses, client information, and selected documents as a single PDF. Combines questionnaire answers (as the first section), client data tables (contact info, spouse, dependents, bank accounts), and document PDFs.
     * @param {TaxBindersApiApiTaxBindersIdExportPackagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdExportPackagePost(requestParameters: TaxBindersApiApiTaxBindersIdExportPackagePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdExportPackagePost(requestParameters.id, requestParameters.taxBinderPackageExportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates a preview of selected documents for export, showing file sizes and organization structure.
     * @param {TaxBindersApiApiTaxBindersIdExportPreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdExportPreviewPost(requestParameters: TaxBindersApiApiTaxBindersIdExportPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdExportPreviewPost(requestParameters.id, requestParameters.taxBinderExportSelectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exports selected documents from an binder as a downloadable archive file (ZIP).
     * @param {TaxBindersApiApiTaxBindersIdExportSelectedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdExportSelectedPost(requestParameters: TaxBindersApiApiTaxBindersIdExportSelectedPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdExportSelectedPost(requestParameters.id, requestParameters.taxBinderExportSelectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For Client role users, the binder must belong to the active client specified in X-Active-Client-Id header. For Admin/Preparer roles, the X-Active-Client-Id header is optional - when provided, the binder must belong to that client.
     * @summary Retrieves detailed information about a specific binder by their unique identifier. Includes document requests and completion status but not the full document list. Use GET /api/documents?BinderId={id} to retrieve the complete document list separately.
     * @param {TaxBindersApiApiTaxBindersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdGet(requestParameters: TaxBindersApiApiTaxBindersIdGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prepares binder documents for e-signature workflow through DocuSeal integration.
     * @param {TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdPrepareForSignaturePost(requestParameters: TaxBindersApiApiTaxBindersIdPrepareForSignaturePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdPrepareForSignaturePost(requestParameters.id, requestParameters.prepareForSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * When X-Active-Client-Id header is provided, the tax binder must belong to that client. This prevents updates to tax binders outside the currently active client context.              **Engagement Letter Auto-Submission**: When EngagementLetterDocumentId is set or changed, the system automatically creates a DocuSeal e-signature submission for the document (without sending email/SMS notifications). The preparer can then manually send the signing link to the client when ready.
     * @summary Updates an existing tax binder\'s information including status, due dates, notification settings, and engagement letter assignment.
     * @param {TaxBindersApiApiTaxBindersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdPut(requestParameters: TaxBindersApiApiTaxBindersIdPutRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdPut(requestParameters.id, requestParameters.updateTaxBinderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recalls a released tax return, reverting the binder to Sent For Preparation stage. Archives the DocuSeal signature submission, soft-deletes bundle documents, resets signature fields, and notifies the client.
     * @param {TaxBindersApiApiTaxBindersIdRecallReturnPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdRecallReturnPost(requestParameters: TaxBindersApiApiTaxBindersIdRecallReturnPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdRecallReturnPost(requestParameters.id, requestParameters.recallReturnDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the release status for a binder including signature progress.
     * @param {TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdReleaseStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdReleaseStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdReleaseStatusGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Releases returns to client for final review and signing. Sends signature requests for all 8879 forms and Direct Deposit Report (if present), transitions binder to FinalClientReview stage, and notifies the client.
     * @param {TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdReleaseToClientPost(requestParameters: TaxBindersApiApiTaxBindersIdReleaseToClientPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdReleaseToClientPost(requestParameters.id, requestParameters.releaseToClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Client requests changes to their tax return during FinalClientReview stage. This transitions the binder to ClientRequestsChanges stage and notifies preparers.
     * @param {TaxBindersApiApiTaxBindersIdRequestChangesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdRequestChangesPost(requestParameters: TaxBindersApiApiTaxBindersIdRequestChangesPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdRequestChangesPost(requestParameters.id, requestParameters.requestChangesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resends the welcome email to the client for a binder.
     * @param {TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdResendWelcomeEmailPost(requestParameters: TaxBindersApiApiTaxBindersIdResendWelcomeEmailPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdResendWelcomeEmailPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Every return round recorded against a binder, oldest first, with the document ids needed to download each round\'s client copy and signed package. Drives the preparer\'s original-return history and the client\'s permanent download list.
     * @param {TaxBindersApiApiTaxBindersIdReturnsHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdReturnsHistoryGet(requestParameters: TaxBindersApiApiTaxBindersIdReturnsHistoryGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdReturnsHistoryGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends a binder back to the client for additional information. This transitions the binder from ClientSubmitted or InReview stage back to Open, creates a comment with the reason, and sends an email notification to the client.
     * @param {TaxBindersApiApiTaxBindersIdSendBackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSendBackPost(requestParameters: TaxBindersApiApiTaxBindersIdSendBackPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSendBackPost(requestParameters.id, requestParameters.sendBackToClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Embedded signing session (DocuSeal slug) for the current user on a signature document. Returns 403 if the caller isn\'t an assigned signer. Clients are scoped to their active client.
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSignatureDocumentsDocumentIdSigningSessionGet(requestParameters.id, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Client users eligible to be assigned as signers on a signature document for this binder\'s client. Includes all client-user relationships on the account.
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSignatureDocumentsEligibleSignersGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsEligibleSignersGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSignatureDocumentsEligibleSignersGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lists this binder\'s signature documents (sent for e-signature) with per-signer status. Used by the preparer management view and the client \"documents to sign\" surface. Clients are scoped to their active client.
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSignatureDocumentsGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSignatureDocumentsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a binder document for e-signature. Placed fields are assigned to client-user signers by role. Creates a DocuSeal submission in embedded mode (signers sign in-app); notifications are driven by our system.
     * @param {TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSignatureDocumentsPost(requestParameters: TaxBindersApiApiTaxBindersIdSignatureDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSignatureDocumentsPost(requestParameters.id, requestParameters.createSignatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the e-signature status for an binder, including completion status and signing progress.
     * @param {TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSignatureStatusGet(requestParameters: TaxBindersApiApiTaxBindersIdSignatureStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSignatureStatusGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the processing stage of a binder to track workflow progress (New → Preprocessing → Staging → Final). Use this endpoint to mark workflow transitions as the preparer processes documents through different stages. Requires Preparer or Admin role.
     * @param {TaxBindersApiApiTaxBindersIdStagePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdStagePatch(requestParameters: TaxBindersApiApiTaxBindersIdStagePatchRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdStagePatch(requestParameters.id, requestParameters.updateTaxBinderStageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is idempotent - re-submitting an already-submitted binder updates the timestamp. If a note is provided, it will be saved as a Comment visible to both client and preparer. A SignalR notification is sent to preparers and admins when a binder is submitted.
     * @summary Submits a binder for preparer review (Ready to Proceed). Indicates the client has finished uploading documents and is ready for the preparer to begin working.
     * @param {TaxBindersApiApiTaxBindersIdSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdSubmitPost(requestParameters: TaxBindersApiApiTaxBindersIdSubmitPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdSubmitPost(requestParameters.id, requestParameters.submitTaxBinderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Withdraws a binder submission, allowing the client to continue uploading documents.
     * @param {TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersIdWithdrawSubmissionPost(requestParameters: TaxBindersApiApiTaxBindersIdWithdrawSubmissionPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersIdWithdrawSubmissionPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * When X-Active-Client-Id header is provided, the ClientId in the request body is automatically set to the active client. This ensures preparers/admins can only create tax binders for the currently active client in the UI.
     * @summary Creates a new tax binder for a specific client and tax year.
     * @param {TaxBindersApiApiTaxBindersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersPost(requestParameters: TaxBindersApiApiTaxBindersPostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersPost(requestParameters.name, requestParameters.taxYear, requestParameters.clientId, requestParameters.type, requestParameters.preparerId, requestParameters.dueDate, requestParameters.notificationDaysPrior, requestParameters.invoiceLink, requestParameters.organizerPdf, requestParameters.engagementLetterPdf, requestParameters.extractEngagementLetter, requestParameters.sendWelcomeEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the available tax type options for filtering binders.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersTaxTypeOptionsGet(options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersTaxTypeOptionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint creates the tax binder with PreparerId automatically set to the current user. If a tax binder of the same type already exists for the client + tax year combination, a 409 Conflict is returned. The bundle PDFs are processed to extract individual returns based on bookmark structure.
     * @summary Creates a new tax binder and uploads tax return bundle PDFs in a single atomic operation. Use this when a preparer wants to upload returns to a client without an existing tax binder.
     * @param {TaxBindersApiApiTaxBindersWithBundlePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersWithBundlePost(requestParameters: TaxBindersApiApiTaxBindersWithBundlePostRequest, options?: RawAxiosRequestConfig) {
        return TaxBindersApiFp(this.configuration).apiTaxBindersWithBundlePost(requestParameters.clientId, requestParameters.taxYear, requestParameters.name, requestParameters.clientCopyPdf, requestParameters.governmentCopyPdf, requestParameters.type, requestParameters.dueDate, requestParameters.invoiceLink, requestParameters.k1Pdf, requestParameters.engagementLetterAlreadySigned, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaxReturnBundleApi - axios parameter creator
 */
export const TaxReturnBundleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all BundleDocument records for this binder\'s tax return bundle. Returns the structured list of extracted and tracked documents within the bundle.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/bundle-documents`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a preparer-added document from the bundle. Cannot delete documents that are awaiting signature or already signed.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete: async (binderId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete', 'binderId', binderId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete', 'id', id)
            const localVarPath = `/api/tax-binders/{binderId}/returns/bundle-documents/{id}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update metadata on a preparer-added document. Cannot update documents that are awaiting signature or already signed.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} id 
         * @param {UpdatePreparerDocumentDto} [updatePreparerDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsIdPut: async (binderId: string, id: string, updatePreparerDocumentDto?: UpdatePreparerDocumentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsIdPut', 'binderId', binderId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsIdPut', 'id', id)
            const localVarPath = `/api/tax-binders/{binderId}/returns/bundle-documents/{id}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePreparerDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a preparer-uploaded PDF document to the bundle. Supports custom documents like POA, custom letters, and state-specific forms. Documents with RequiresSignature=true automatically join the unified signing session.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} displayName Display name shown to clients and preparers.
         * @param {BundleDocumentCategory} category 
         * @param {File} file The PDF file to upload.
         * @param {string} [jurisdictionId] Optional jurisdiction association. Must belong to the same bundle if provided.
         * @param {boolean} [requiresSignature] Whether this document requires an e-signature from the client.
         * @param {string} [signatureFieldPlacementsJson] JSON string containing signature field placements for custom positioning. Uses JSON string because multipart form data cannot bind nested objects cleanly. Expected format: { \\\&quot;signatureFieldPlacements\\\&quot;: [{ \\\&quot;page\\\&quot;: 1, \\\&quot;x\\\&quot;: 0.33, \\\&quot;y\\\&quot;: 0.82, \\\&quot;w\\\&quot;: 0.33, \\\&quot;h\\\&quot;: 0.05 }] }
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsPost: async (binderId: string, displayName: string, category: BundleDocumentCategory, file: File, jurisdictionId?: string, requiresSignature?: boolean, signatureFieldPlacementsJson?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsPost', 'binderId', binderId)
            // verify required parameter 'displayName' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsPost', 'displayName', displayName)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsPost', 'category', category)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleDocumentsPost', 'file', file)
            const localVarPath = `/api/tax-binders/{binderId}/returns/bundle-documents`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (displayName !== undefined) { 
                localVarFormParams.append('DisplayName', displayName as any);
            }

            if (category !== undefined) { 
                localVarFormParams.append('Category', category as any);
            }

            if (jurisdictionId !== undefined) { 
                localVarFormParams.append('JurisdictionId', jurisdictionId as any);
            }

            if (requiresSignature !== undefined) { 
                localVarFormParams.append('RequiresSignature', String(requiresSignature) as any);
            }

            if (signatureFieldPlacementsJson !== undefined) { 
                localVarFormParams.append('SignatureFieldPlacementsJson', signatureFieldPlacementsJson as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the current status of a bundle signature request. Returns status for all jurisdictions and signers included in the bundle signature.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleSignatureStatusGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsBundleSignatureStatusGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/bundle-signature-status`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record that the calling user reviewed and accepted the client copy, unlocking signing for them. Idempotent: a repeat call returns the original acceptance.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/client-copy/acknowledge`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the client copy a signer must review, with the calling user\'s acceptance state. The PDF itself is fetched through the standard document download endpoint.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsClientCopyGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsClientCopyGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/client-copy`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all returns for a binder.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the processing status of bundle returns for a binder.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsProcessingStatusGet: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsProcessingStatusGet', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/processing-status`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reprocess bundle PDFs from storage without re-uploading. Deletes existing returns and re-parses the stored bundle PDFs. Useful after detection improvements or to fix processing issues.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReprocessPost: async (binderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReprocessPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/reprocess`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request unified e-signatures for all signature-required BundleDocuments. Creates a single DocuSeal submission with extracted PDFs as separate documents. Replaces the separate 8879 and DD report signature flows.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {RequestBundleSignatureDto} [requestBundleSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost: async (binderId: string, requestBundleSignatureDto?: RequestBundleSignatureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost', 'binderId', binderId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/request-document-signatures`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBundleSignatureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Convert a return to paper copy signing. Cancels any active DocuSeal e-signature session and switches to wet-ink paper workflow. The return status is reset to ReadyForReview and all signers are marked as manual-sign required.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {ConvertToPaperDto} [convertToPaperDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost: async (binderId: string, returnId: string, convertToPaperDto?: ConvertToPaperDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/convert-to-paper`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(convertToPaperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete a return. Cancels any active DocuSeal e-signature sessions before deleting.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {DeleteReturnDto} [deleteReturnDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdDelete: async (binderId: string, returnId: string, deleteReturnDto?: DeleteReturnDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdDelete', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdDelete', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteReturnDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get filing instructions for a return.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {FilingInstructionType} [instructionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet: async (binderId: string, returnId: string, instructionType?: FilingInstructionType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/filing-instructions`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (instructionType !== undefined) {
                localVarQueryParameter['instructionType'] = instructionType;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update filing instructions for a return. Only provided fields will be updated.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {FilingInstructionType} [instructionType] 
         * @param {UpdateFilingInstructionDto} [updateFilingInstructionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch: async (binderId: string, returnId: string, instructionType?: FilingInstructionType, updateFilingInstructionDto?: UpdateFilingInstructionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/filing-instructions`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (instructionType !== undefined) {
                localVarQueryParameter['instructionType'] = instructionType;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFilingInstructionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific return by ID.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdGet: async (binderId: string, returnId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdGet', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdGet', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a return as accepted by the taxing authority.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost: async (binderId: string, returnId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/mark-accepted`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a return as filed.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {MarkTaxReturnFiledDto} [markTaxReturnFiledDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost: async (binderId: string, returnId: string, markTaxReturnFiledDto?: MarkTaxReturnFiledDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/mark-filed`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markTaxReturnFiledDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a paper-copy return as signed by the client. Optionally upload the scanned signed form (PDF). The return status advances to Signed.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} signedAt The date the physical signature was obtained.
         * @param {File} [file] Reserved for future use. File uploads are not yet supported on this endpoint. Upload the scanned signed copy via the document upload endpoint first, then call mark-paper-signed to record the signature date. Submitting a file will return FILE_UPLOAD_NOT_SUPPORTED.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost: async (binderId: string, returnId: string, signedAt: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost', 'returnId', returnId)
            // verify required parameter 'signedAt' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost', 'signedAt', signedAt)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/mark-paper-signed`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (signedAt !== undefined) { 
                localVarFormParams.append('SignedAt', signedAt as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a return as rejected by the taxing authority.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {MarkTaxReturnRejectedDto} [markTaxReturnRejectedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost: async (binderId: string, returnId: string, markTaxReturnRejectedDto?: MarkTaxReturnRejectedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/mark-rejected`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markTaxReturnRejectedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a return\'s status and notes.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {UpdateJurisdictionDto} [updateJurisdictionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdPatch: async (binderId: string, returnId: string, updateJurisdictionDto?: UpdateJurisdictionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdPatch', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdPatch', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateJurisdictionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a signature requirement (reassign user, toggle manual sign).
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} requirementId 
         * @param {UpdateBundleSignatureRequirementDto} [updateBundleSignatureRequirementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut: async (binderId: string, returnId: string, requirementId: string, updateBundleSignatureRequirementDto?: UpdateBundleSignatureRequirementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut', 'returnId', returnId)
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut', 'requirementId', requirementId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/signature-requirements/{requirementId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)))
                .replace(`{${"requirementId"}}`, encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBundleSignatureRequirementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment vouchers for a return.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersGet: async (binderId: string, returnId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersGet', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersGet', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manually create a payment voucher for a return.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {CreatePaymentVoucherDto} [createPaymentVoucherDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersPost: async (binderId: string, returnId: string, createPaymentVoucherDto?: CreatePaymentVoucherDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersPost', 'returnId', returnId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentVoucherDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete a payment voucher.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete: async (binderId: string, returnId: string, voucherId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete', 'returnId', returnId)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete', 'voucherId', voucherId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers/{voucherId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)))
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a voucher as paid, edit the amount actually paid, or un-mark it (IsPaid = false).
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {MarkPaymentVoucherPaidDto} [markPaymentVoucherPaidDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost: async (binderId: string, returnId: string, voucherId: string, markPaymentVoucherPaidDto?: MarkPaymentVoucherPaidDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost', 'returnId', returnId)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost', 'voucherId', voucherId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers/{voucherId}/mark-paid`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)))
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markPaymentVoucherPaidDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable or disable reminder for a voucher.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {PaymentVoucherReminderOptInDto} [paymentVoucherReminderOptInDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost: async (binderId: string, returnId: string, voucherId: string, paymentVoucherReminderOptInDto?: PaymentVoucherReminderOptInDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost', 'returnId', returnId)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost', 'voucherId', voucherId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers/{voucherId}/opt-in`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)))
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentVoucherReminderOptInDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing payment voucher.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {UpdatePaymentVoucherDto} [updatePaymentVoucherDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch: async (binderId: string, returnId: string, voucherId: string, updatePaymentVoucherDto?: UpdatePaymentVoucherDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch', 'binderId', binderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch', 'returnId', returnId)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch', 'voucherId', voucherId)
            const localVarPath = `/api/tax-binders/{binderId}/returns/{returnId}/vouchers/{voucherId}`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)))
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)))
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentVoucherDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload tax return bundle PDFs (Client Copy and Government Copy). Processes the PDFs to extract individual returns based on bookmark structure.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {File} clientCopyPdf Client Copy PDF file (required)
         * @param {File} governmentCopyPdf Government Copy PDF file (required)
         * @param {File} [k1Pdf] K-1 PDF file (optional) - contains Schedule K-1 forms for pass-through entities
         * @param {string} [invoiceLink] URL link to the invoice for this binder (optional, stored at binder level)
         * @param {boolean} [forceReprocess] If true, delete existing returns and reprocess from scratch
         * @param {boolean} [isAmendment] If true, this bundle amends a completed return: the amended round is opened server-side once the bundle parses, so a rejected PDF leaves the filed return untouched. Cannot be combined with ForceReprocess. The server re-applies the amendment preconditions regardless of this flag.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsUploadBundlePost: async (binderId: string, clientCopyPdf: File, governmentCopyPdf: File, k1Pdf?: File, invoiceLink?: string, forceReprocess?: boolean, isAmendment?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'binderId' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsUploadBundlePost', 'binderId', binderId)
            // verify required parameter 'clientCopyPdf' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsUploadBundlePost', 'clientCopyPdf', clientCopyPdf)
            // verify required parameter 'governmentCopyPdf' is not null or undefined
            assertParamExists('apiTaxBindersBinderIdReturnsUploadBundlePost', 'governmentCopyPdf', governmentCopyPdf)
            const localVarPath = `/api/tax-binders/{binderId}/returns/upload-bundle`
                .replace(`{${"binderId"}}`, encodeURIComponent(String(binderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (clientCopyPdf !== undefined) { 
                localVarFormParams.append('ClientCopyPdf', clientCopyPdf as any);
            }

            if (governmentCopyPdf !== undefined) { 
                localVarFormParams.append('GovernmentCopyPdf', governmentCopyPdf as any);
            }

            if (k1Pdf !== undefined) { 
                localVarFormParams.append('K1Pdf', k1Pdf as any);
            }

            if (invoiceLink !== undefined) { 
                localVarFormParams.append('InvoiceLink', invoiceLink as any);
            }

            if (forceReprocess !== undefined) { 
                localVarFormParams.append('ForceReprocess', String(forceReprocess) as any);
            }

            if (isAmendment !== undefined) { 
                localVarFormParams.append('IsAmendment', String(isAmendment) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxReturnBundleApi - functional programming interface
 */
export const TaxReturnBundleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaxReturnBundleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all BundleDocument records for this binder\'s tax return bundle. Returns the structured list of extracted and tracked documents within the bundle.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsBundleDocumentsGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleDocumentDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsBundleDocumentsGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsBundleDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a preparer-added document from the bundle. Cannot delete documents that are awaiting signature or already signed.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(binderId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(binderId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update metadata on a preparer-added document. Cannot update documents that are awaiting signature or already signed.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} id 
         * @param {UpdatePreparerDocumentDto} [updatePreparerDocumentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(binderId: string, id: string, updatePreparerDocumentDto?: UpdatePreparerDocumentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleDocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(binderId, id, updatePreparerDocumentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsBundleDocumentsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a preparer-uploaded PDF document to the bundle. Supports custom documents like POA, custom letters, and state-specific forms. Documents with RequiresSignature=true automatically join the unified signing session.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} displayName Display name shown to clients and preparers.
         * @param {BundleDocumentCategory} category 
         * @param {File} file The PDF file to upload.
         * @param {string} [jurisdictionId] Optional jurisdiction association. Must belong to the same bundle if provided.
         * @param {boolean} [requiresSignature] Whether this document requires an e-signature from the client.
         * @param {string} [signatureFieldPlacementsJson] JSON string containing signature field placements for custom positioning. Uses JSON string because multipart form data cannot bind nested objects cleanly. Expected format: { \\\&quot;signatureFieldPlacements\\\&quot;: [{ \\\&quot;page\\\&quot;: 1, \\\&quot;x\\\&quot;: 0.33, \\\&quot;y\\\&quot;: 0.82, \\\&quot;w\\\&quot;: 0.33, \\\&quot;h\\\&quot;: 0.05 }] }
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsBundleDocumentsPost(binderId: string, displayName: string, category: BundleDocumentCategory, file: File, jurisdictionId?: string, requiresSignature?: boolean, signatureFieldPlacementsJson?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleDocumentDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsBundleDocumentsPost(binderId, displayName, category, file, jurisdictionId, requiresSignature, signatureFieldPlacementsJson, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsBundleDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the current status of a bundle signature request. Returns status for all jurisdictions and signers included in the bundle signature.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleSignatureStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsBundleSignatureStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Record that the calling user reviewed and accepted the client copy, unlocking signing for them. Idempotent: a repeat call returns the original acceptance.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientCopyReviewDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the client copy a signer must review, with the calling user\'s acceptance state. The PDF itself is fetched through the standard document download endpoint.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsClientCopyGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientCopyReviewDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsClientCopyGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsClientCopyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all returns for a binder.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the processing status of bundle returns for a binder.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsProcessingStatusGet(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleProcessingStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsProcessingStatusGet(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsProcessingStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reprocess bundle PDFs from storage without re-uploading. Deletes existing returns and re-parses the stored bundle PDFs. Useful after detection improvements or to fix processing issues.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReprocessPost(binderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleProcessingResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReprocessPost(binderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReprocessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request unified e-signatures for all signature-required BundleDocuments. Creates a single DocuSeal submission with extracted PDFs as separate documents. Replaces the separate 8879 and DD report signature flows.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {RequestBundleSignatureDto} [requestBundleSignatureDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(binderId: string, requestBundleSignatureDto?: RequestBundleSignatureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleDocumentSignatureResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(binderId, requestBundleSignatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Convert a return to paper copy signing. Cancels any active DocuSeal e-signature session and switches to wet-ink paper workflow. The return status is reset to ReadyForReview and all signers are marked as manual-sign required.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {ConvertToPaperDto} [convertToPaperDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(binderId: string, returnId: string, convertToPaperDto?: ConvertToPaperDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(binderId, returnId, convertToPaperDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Soft-delete a return. Cancels any active DocuSeal e-signature sessions before deleting.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {DeleteReturnDto} [deleteReturnDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdDelete(binderId: string, returnId: string, deleteReturnDto?: DeleteReturnDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdDelete(binderId, returnId, deleteReturnDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get filing instructions for a return.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {FilingInstructionType} [instructionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(binderId: string, returnId: string, instructionType?: FilingInstructionType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(binderId, returnId, instructionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update filing instructions for a return. Only provided fields will be updated.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {FilingInstructionType} [instructionType] 
         * @param {UpdateFilingInstructionDto} [updateFilingInstructionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(binderId: string, returnId: string, instructionType?: FilingInstructionType, updateFilingInstructionDto?: UpdateFilingInstructionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(binderId, returnId, instructionType, updateFilingInstructionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific return by ID.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdGet(binderId: string, returnId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdGet(binderId, returnId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a return as accepted by the taxing authority.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(binderId: string, returnId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(binderId, returnId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a return as filed.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {MarkTaxReturnFiledDto} [markTaxReturnFiledDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(binderId: string, returnId: string, markTaxReturnFiledDto?: MarkTaxReturnFiledDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(binderId, returnId, markTaxReturnFiledDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a paper-copy return as signed by the client. Optionally upload the scanned signed form (PDF). The return status advances to Signed.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} signedAt The date the physical signature was obtained.
         * @param {File} [file] Reserved for future use. File uploads are not yet supported on this endpoint. Upload the scanned signed copy via the document upload endpoint first, then call mark-paper-signed to record the signature date. Submitting a file will return FILE_UPLOAD_NOT_SUPPORTED.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(binderId: string, returnId: string, signedAt: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(binderId, returnId, signedAt, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a return as rejected by the taxing authority.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {MarkTaxReturnRejectedDto} [markTaxReturnRejectedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(binderId: string, returnId: string, markTaxReturnRejectedDto?: MarkTaxReturnRejectedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(binderId, returnId, markTaxReturnRejectedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a return\'s status and notes.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {UpdateJurisdictionDto} [updateJurisdictionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdPatch(binderId: string, returnId: string, updateJurisdictionDto?: UpdateJurisdictionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdPatch(binderId, returnId, updateJurisdictionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a signature requirement (reassign user, toggle manual sign).
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} requirementId 
         * @param {UpdateBundleSignatureRequirementDto} [updateBundleSignatureRequirementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(binderId: string, returnId: string, requirementId: string, updateBundleSignatureRequirementDto?: UpdateBundleSignatureRequirementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleSignatureRequirementDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(binderId, returnId, requirementId, updateBundleSignatureRequirementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get payment vouchers for a return.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersGet(binderId: string, returnId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundlePaymentVoucherDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersGet(binderId, returnId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Manually create a payment voucher for a return.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {CreatePaymentVoucherDto} [createPaymentVoucherDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersPost(binderId: string, returnId: string, createPaymentVoucherDto?: CreatePaymentVoucherDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersPost(binderId, returnId, createPaymentVoucherDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Soft-delete a payment voucher.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(binderId: string, returnId: string, voucherId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(binderId, returnId, voucherId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a voucher as paid, edit the amount actually paid, or un-mark it (IsPaid = false).
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {MarkPaymentVoucherPaidDto} [markPaymentVoucherPaidDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(binderId: string, returnId: string, voucherId: string, markPaymentVoucherPaidDto?: MarkPaymentVoucherPaidDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(binderId, returnId, voucherId, markPaymentVoucherPaidDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enable or disable reminder for a voucher.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {PaymentVoucherReminderOptInDto} [paymentVoucherReminderOptInDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(binderId: string, returnId: string, voucherId: string, paymentVoucherReminderOptInDto?: PaymentVoucherReminderOptInDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(binderId, returnId, voucherId, paymentVoucherReminderOptInDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing payment voucher.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {string} returnId 
         * @param {string} voucherId 
         * @param {UpdatePaymentVoucherDto} [updatePaymentVoucherDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(binderId: string, returnId: string, voucherId: string, updatePaymentVoucherDto?: UpdatePaymentVoucherDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(binderId, returnId, voucherId, updatePaymentVoucherDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload tax return bundle PDFs (Client Copy and Government Copy). Processes the PDFs to extract individual returns based on bookmark structure.
         * @param {string} binderId Copy this from the Create Tax Binder response or Get Tax Binders list
         * @param {File} clientCopyPdf Client Copy PDF file (required)
         * @param {File} governmentCopyPdf Government Copy PDF file (required)
         * @param {File} [k1Pdf] K-1 PDF file (optional) - contains Schedule K-1 forms for pass-through entities
         * @param {string} [invoiceLink] URL link to the invoice for this binder (optional, stored at binder level)
         * @param {boolean} [forceReprocess] If true, delete existing returns and reprocess from scratch
         * @param {boolean} [isAmendment] If true, this bundle amends a completed return: the amended round is opened server-side once the bundle parses, so a rejected PDF leaves the filed return untouched. Cannot be combined with ForceReprocess. The server re-applies the amendment preconditions regardless of this flag.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTaxBindersBinderIdReturnsUploadBundlePost(binderId: string, clientCopyPdf: File, governmentCopyPdf: File, k1Pdf?: File, invoiceLink?: string, forceReprocess?: boolean, isAmendment?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleProcessingResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTaxBindersBinderIdReturnsUploadBundlePost(binderId, clientCopyPdf, governmentCopyPdf, k1Pdf, invoiceLink, forceReprocess, isAmendment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxReturnBundleApi.apiTaxBindersBinderIdReturnsUploadBundlePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaxReturnBundleApi - factory interface
 */
export const TaxReturnBundleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaxReturnBundleApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all BundleDocument records for this binder\'s tax return bundle. Returns the structured list of extracted and tracked documents within the bundle.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsBundleDocumentsGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a preparer-added document from the bundle. Cannot delete documents that are awaiting signature or already signed.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(requestParameters.binderId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update metadata on a preparer-added document. Cannot update documents that are awaiting signature or already signed.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(requestParameters.binderId, requestParameters.id, requestParameters.updatePreparerDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a preparer-uploaded PDF document to the bundle. Supports custom documents like POA, custom letters, and state-specific forms. Documents with RequiresSignature=true automatically join the unified signing session.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleDocumentsPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsBundleDocumentsPost(requestParameters.binderId, requestParameters.displayName, requestParameters.category, requestParameters.file, requestParameters.jurisdictionId, requestParameters.requiresSignature, requestParameters.signatureFieldPlacementsJson, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the current status of a bundle signature request. Returns status for all jurisdictions and signers included in the bundle signature.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleSignatureStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record that the calling user reviewed and accepted the client copy, unlocking signing for them. Idempotent: a repeat call returns the original acceptance.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyAcknowledgePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyAcknowledgePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientCopyReviewDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the client copy a signer must review, with the calling user\'s acceptance state. The PDF itself is fetched through the standard document download endpoint.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsClientCopyGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientCopyReviewDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsClientCopyGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all returns for a binder.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the processing status of bundle returns for a binder.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsProcessingStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingStatusDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsProcessingStatusGet(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reprocess bundle PDFs from storage without re-uploading. Deletes existing returns and re-parses the stored bundle PDFs. Useful after detection improvements or to fix processing issues.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReprocessPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingResultDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReprocessPost(requestParameters.binderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request unified e-signatures for all signature-required BundleDocuments. Creates a single DocuSeal submission with extracted PDFs as separate documents. Replaces the separate 8879 and DD report signature flows.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentSignatureResponseDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(requestParameters.binderId, requestParameters.requestBundleSignatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Convert a return to paper copy signing. Cancels any active DocuSeal e-signature session and switches to wet-ink paper workflow. The return status is reset to ReadyForReview and all signers are marked as manual-sign required.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(requestParameters.binderId, requestParameters.returnId, requestParameters.convertToPaperDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete a return. Cancels any active DocuSeal e-signature sessions before deleting.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdDelete(requestParameters.binderId, requestParameters.returnId, requestParameters.deleteReturnDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get filing instructions for a return.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(requestParameters.binderId, requestParameters.returnId, requestParameters.instructionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update filing instructions for a return. Only provided fields will be updated.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.instructionType, requestParameters.updateFilingInstructionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific return by ID.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdGet(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a return as accepted by the taxing authority.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a return as filed.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(requestParameters.binderId, requestParameters.returnId, requestParameters.markTaxReturnFiledDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a paper-copy return as signed by the client. Optionally upload the scanned signed form (PDF). The return status advances to Signed.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(requestParameters.binderId, requestParameters.returnId, requestParameters.signedAt, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a return as rejected by the taxing authority.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(requestParameters.binderId, requestParameters.returnId, requestParameters.markTaxReturnRejectedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a return\'s status and notes.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.updateJurisdictionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a signature requirement (reassign user, toggle manual sign).
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleSignatureRequirementDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(requestParameters.binderId, requestParameters.returnId, requestParameters.requirementId, requestParameters.updateBundleSignatureRequirementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment vouchers for a return.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoListApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersGet(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manually create a payment voucher for a return.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersPost(requestParameters.binderId, requestParameters.returnId, requestParameters.createPaymentVoucherDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete a payment voucher.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a voucher as paid, edit the amount actually paid, or un-mark it (IsPaid = false).
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.markPaymentVoucherPaidDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable or disable reminder for a voucher.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.paymentVoucherReminderOptInDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing payment voucher.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.updatePaymentVoucherDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload tax return bundle PDFs (Client Copy and Government Copy). Processes the PDFs to extract individual returns based on bookmark structure.
         * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTaxBindersBinderIdReturnsUploadBundlePost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingResultDtoApiResponse> {
            return localVarFp.apiTaxBindersBinderIdReturnsUploadBundlePost(requestParameters.binderId, requestParameters.clientCopyPdf, requestParameters.governmentCopyPdf, requestParameters.k1Pdf, requestParameters.invoiceLink, requestParameters.forceReprocess, requestParameters.isAmendment, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaxReturnBundleApi - interface
 */
export interface TaxReturnBundleApiInterface {
    /**
     * 
     * @summary Get all BundleDocument records for this binder\'s tax return bundle. Returns the structured list of extracted and tracked documents within the bundle.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsBundleDocumentsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoListApiResponse>;

    /**
     * 
     * @summary Delete a preparer-added document from the bundle. Cannot delete documents that are awaiting signature or already signed.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Update metadata on a preparer-added document. Cannot update documents that are awaiting signature or already signed.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoApiResponse>;

    /**
     * 
     * @summary Add a preparer-uploaded PDF document to the bundle. Supports custom documents like POA, custom letters, and state-specific forms. Documents with RequiresSignature=true automatically join the unified signing session.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsBundleDocumentsPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentDtoApiResponse>;

    /**
     * 
     * @summary Get the current status of a bundle signature request. Returns status for all jurisdictions and signers included in the bundle signature.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleSignatureStatusDtoApiResponse>;

    /**
     * 
     * @summary Record that the calling user reviewed and accepted the client copy, unlocking signing for them. Idempotent: a repeat call returns the original acceptance.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyAcknowledgePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyAcknowledgePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientCopyReviewDtoApiResponse>;

    /**
     * 
     * @summary Get the client copy a signer must review, with the calling user\'s acceptance state. The PDF itself is fetched through the standard document download endpoint.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsClientCopyGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientCopyReviewDtoApiResponse>;

    /**
     * 
     * @summary Get all returns for a binder.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoListApiResponse>;

    /**
     * 
     * @summary Get the processing status of bundle returns for a binder.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsProcessingStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingStatusDtoApiResponse>;

    /**
     * 
     * @summary Reprocess bundle PDFs from storage without re-uploading. Deletes existing returns and re-parses the stored bundle PDFs. Useful after detection improvements or to fix processing issues.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReprocessPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingResultDtoApiResponse>;

    /**
     * 
     * @summary Request unified e-signatures for all signature-required BundleDocuments. Creates a single DocuSeal submission with extracted PDFs as separate documents. Replaces the separate 8879 and DD report signature flows.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleDocumentSignatureResponseDtoApiResponse>;

    /**
     * 
     * @summary Convert a return to paper copy signing. Cancels any active DocuSeal e-signature session and switches to wet-ink paper workflow. The return status is reset to ReadyForReview and all signers are marked as manual-sign required.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @summary Soft-delete a return. Cancels any active DocuSeal e-signature sessions before deleting.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Get filing instructions for a return.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse>;

    /**
     * 
     * @summary Update filing instructions for a return. Only provided fields will be updated.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleFilingInstructionDtoApiResponse>;

    /**
     * 
     * @summary Get a specific return by ID.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @summary Mark a return as accepted by the taxing authority.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @summary Mark a return as filed.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @summary Mark a paper-copy return as signed by the client. Optionally upload the scanned signed form (PDF). The return status advances to Signed.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @summary Mark a return as rejected by the taxing authority.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @summary Update a return\'s status and notes.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundleJurisdictionDtoApiResponse>;

    /**
     * 
     * @summary Update a signature requirement (reassign user, toggle manual sign).
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleSignatureRequirementDtoApiResponse>;

    /**
     * 
     * @summary Get payment vouchers for a return.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoListApiResponse>;

    /**
     * 
     * @summary Manually create a payment voucher for a return.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>;

    /**
     * 
     * @summary Soft-delete a payment voucher.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Mark a voucher as paid, edit the amount actually paid, or un-mark it (IsPaid = false).
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>;

    /**
     * 
     * @summary Enable or disable reminder for a voucher.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>;

    /**
     * 
     * @summary Update an existing payment voucher.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaxReturnBundlePaymentVoucherDtoApiResponse>;

    /**
     * 
     * @summary Upload tax return bundle PDFs (Client Copy and Government Copy). Processes the PDFs to extract individual returns based on bookmark structure.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTaxBindersBinderIdReturnsUploadBundlePost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BundleProcessingResultDtoApiResponse>;

}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsBundleDocumentsGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly id: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsBundleDocumentsIdPut operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly id: string

    readonly updatePreparerDocumentDto?: UpdatePreparerDocumentDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsBundleDocumentsPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    /**
     * Display name shown to clients and preparers.
     */
    readonly displayName: string

    readonly category: BundleDocumentCategory

    /**
     * The PDF file to upload.
     */
    readonly file: File

    /**
     * Optional jurisdiction association. Must belong to the same bundle if provided.
     */
    readonly jurisdictionId?: string

    /**
     * Whether this document requires an e-signature from the client.
     */
    readonly requiresSignature?: boolean

    /**
     * JSON string containing signature field placements for custom positioning. Uses JSON string because multipart form data cannot bind nested objects cleanly. Expected format: { \\\&quot;signatureFieldPlacements\\\&quot;: [{ \\\&quot;page\\\&quot;: 1, \\\&quot;x\\\&quot;: 0.33, \\\&quot;y\\\&quot;: 0.82, \\\&quot;w\\\&quot;: 0.33, \\\&quot;h\\\&quot;: 0.05 }] }
     */
    readonly signatureFieldPlacementsJson?: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsBundleSignatureStatusGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyAcknowledgePostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsClientCopyGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsProcessingStatusGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReprocessPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly requestBundleSignatureDto?: RequestBundleSignatureDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly convertToPaperDto?: ConvertToPaperDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdDelete operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly deleteReturnDto?: DeleteReturnDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly instructionType?: FilingInstructionType
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly instructionType?: FilingInstructionType

    readonly updateFilingInstructionDto?: UpdateFilingInstructionDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly markTaxReturnFiledDto?: MarkTaxReturnFiledDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    /**
     * The date the physical signature was obtained.
     */
    readonly signedAt: string

    /**
     * Reserved for future use. File uploads are not yet supported on this endpoint. Upload the scanned signed copy via the document upload endpoint first, then call mark-paper-signed to record the signature date. Submitting a file will return FILE_UPLOAD_NOT_SUPPORTED.
     */
    readonly file?: File
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly markTaxReturnRejectedDto?: MarkTaxReturnRejectedDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdPatch operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly updateJurisdictionDto?: UpdateJurisdictionDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly requirementId: string

    readonly updateBundleSignatureRequirementDto?: UpdateBundleSignatureRequirementDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersGet operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly createPaymentVoucherDto?: CreatePaymentVoucherDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly voucherId: string
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly voucherId: string

    readonly markPaymentVoucherPaidDto?: MarkPaymentVoucherPaidDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly voucherId: string

    readonly paymentVoucherReminderOptInDto?: PaymentVoucherReminderOptInDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    readonly returnId: string

    readonly voucherId: string

    readonly updatePaymentVoucherDto?: UpdatePaymentVoucherDto
}

/**
 * Request parameters for apiTaxBindersBinderIdReturnsUploadBundlePost operation in TaxReturnBundleApi.
 */
export interface TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest {
    /**
     * Copy this from the Create Tax Binder response or Get Tax Binders list
     */
    readonly binderId: string

    /**
     * Client Copy PDF file (required)
     */
    readonly clientCopyPdf: File

    /**
     * Government Copy PDF file (required)
     */
    readonly governmentCopyPdf: File

    /**
     * K-1 PDF file (optional) - contains Schedule K-1 forms for pass-through entities
     */
    readonly k1Pdf?: File

    /**
     * URL link to the invoice for this binder (optional, stored at binder level)
     */
    readonly invoiceLink?: string

    /**
     * If true, delete existing returns and reprocess from scratch
     */
    readonly forceReprocess?: boolean

    /**
     * If true, this bundle amends a completed return: the amended round is opened server-side once the bundle parses, so a rejected PDF leaves the filed return untouched. Cannot be combined with ForceReprocess. The server re-applies the amendment preconditions regardless of this flag.
     */
    readonly isAmendment?: boolean
}

/**
 * TaxReturnBundleApi - object-oriented interface
 */
export class TaxReturnBundleApi extends BaseAPI implements TaxReturnBundleApiInterface {
    /**
     * 
     * @summary Get all BundleDocument records for this binder\'s tax return bundle. Returns the structured list of extracted and tracked documents within the bundle.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsBundleDocumentsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsBundleDocumentsGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a preparer-added document from the bundle. Cannot delete documents that are awaiting signature or already signed.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsBundleDocumentsIdDelete(requestParameters.binderId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update metadata on a preparer-added document. Cannot update documents that are awaiting signature or already signed.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsIdPutRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsBundleDocumentsIdPut(requestParameters.binderId, requestParameters.id, requestParameters.updatePreparerDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a preparer-uploaded PDF document to the bundle. Supports custom documents like POA, custom letters, and state-specific forms. Documents with RequiresSignature=true automatically join the unified signing session.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsBundleDocumentsPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsBundleDocumentsPost(requestParameters.binderId, requestParameters.displayName, requestParameters.category, requestParameters.file, requestParameters.jurisdictionId, requestParameters.requiresSignature, requestParameters.signatureFieldPlacementsJson, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the current status of a bundle signature request. Returns status for all jurisdictions and signers included in the bundle signature.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsBundleSignatureStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsBundleSignatureStatusGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record that the calling user reviewed and accepted the client copy, unlocking signing for them. Idempotent: a repeat call returns the original acceptance.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyAcknowledgePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyAcknowledgePostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsClientCopyAcknowledgePost(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the client copy a signer must review, with the calling user\'s acceptance state. The PDF itself is fetched through the standard document download endpoint.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsClientCopyGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsClientCopyGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsClientCopyGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all returns for a binder.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the processing status of bundle returns for a binder.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsProcessingStatusGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsProcessingStatusGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsProcessingStatusGet(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reprocess bundle PDFs from storage without re-uploading. Deletes existing returns and re-parses the stored bundle PDFs. Useful after detection improvements or to fix processing issues.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReprocessPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReprocessPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReprocessPost(requestParameters.binderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request unified e-signatures for all signature-required BundleDocuments. Creates a single DocuSeal submission with extracted PDFs as separate documents. Replaces the separate 8879 and DD report signature flows.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsRequestDocumentSignaturesPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsRequestDocumentSignaturesPost(requestParameters.binderId, requestParameters.requestBundleSignatureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Convert a return to paper copy signing. Cancels any active DocuSeal e-signature session and switches to wet-ink paper workflow. The return status is reset to ReadyForReview and all signers are marked as manual-sign required.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdConvertToPaperPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdConvertToPaperPost(requestParameters.binderId, requestParameters.returnId, requestParameters.convertToPaperDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete a return. Cancels any active DocuSeal e-signature sessions before deleting.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdDelete(requestParameters.binderId, requestParameters.returnId, requestParameters.deleteReturnDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get filing instructions for a return.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsGet(requestParameters.binderId, requestParameters.returnId, requestParameters.instructionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update filing instructions for a return. Only provided fields will be updated.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatchRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdFilingInstructionsPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.instructionType, requestParameters.updateFilingInstructionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific return by ID.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdGet(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a return as accepted by the taxing authority.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdMarkAcceptedPost(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a return as filed.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkFiledPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdMarkFiledPost(requestParameters.binderId, requestParameters.returnId, requestParameters.markTaxReturnFiledDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a paper-copy return as signed by the client. Optionally upload the scanned signed form (PDF). The return status advances to Signed.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdMarkPaperSignedPost(requestParameters.binderId, requestParameters.returnId, requestParameters.signedAt, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a return as rejected by the taxing authority.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdMarkRejectedPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdMarkRejectedPost(requestParameters.binderId, requestParameters.returnId, requestParameters.markTaxReturnRejectedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a return\'s status and notes.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdPatchRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.updateJurisdictionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a signature requirement (reassign user, toggle manual sign).
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPutRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdSignatureRequirementsRequirementIdPut(requestParameters.binderId, requestParameters.returnId, requestParameters.requirementId, requestParameters.updateBundleSignatureRequirementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment vouchers for a return.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersGet(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersGetRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersGet(requestParameters.binderId, requestParameters.returnId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manually create a payment voucher for a return.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersPost(requestParameters.binderId, requestParameters.returnId, requestParameters.createPaymentVoucherDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete a payment voucher.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdDelete(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a voucher as paid, edit the amount actually paid, or un-mark it (IsPaid = false).
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdMarkPaidPost(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.markPaymentVoucherPaidDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable or disable reminder for a voucher.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdOptInPost(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.paymentVoucherReminderOptInDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing payment voucher.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatchRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsReturnIdVouchersVoucherIdPatch(requestParameters.binderId, requestParameters.returnId, requestParameters.voucherId, requestParameters.updatePaymentVoucherDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload tax return bundle PDFs (Client Copy and Government Copy). Processes the PDFs to extract individual returns based on bookmark structure.
     * @param {TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTaxBindersBinderIdReturnsUploadBundlePost(requestParameters: TaxReturnBundleApiApiTaxBindersBinderIdReturnsUploadBundlePostRequest, options?: RawAxiosRequestConfig) {
        return TaxReturnBundleApiFp(this.configuration).apiTaxBindersBinderIdReturnsUploadBundlePost(requestParameters.binderId, requestParameters.clientCopyPdf, requestParameters.governmentCopyPdf, requestParameters.k1Pdf, requestParameters.invoiceLink, requestParameters.forceReprocess, requestParameters.isAmendment, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserSettingsApi - axios parameter creator
 */
export const UserSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets settings for the current user. Creates default settings if none exist.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates settings for the current user. Only provided fields are merged into existing settings.
         * @param {UpdateUserSettingDto} [updateUserSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsPut: async (updateUserSettingDto?: UpdateUserSettingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resets page defaults for the current user. If pageKey is provided, only that page\'s defaults are cleared. If omitted, all page defaults are reset.
         * @param {ResetUserSettingDto} [resetUserSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsResetPost: async (resetUserSettingDto?: ResetUserSettingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-settings/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetUserSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSettingsApi - functional programming interface
 */
export const UserSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets settings for the current user. Creates default settings if none exist.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSettingsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSettingsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSettingsApi.apiUserSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates settings for the current user. Only provided fields are merged into existing settings.
         * @param {UpdateUserSettingDto} [updateUserSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSettingsPut(updateUserSettingDto?: UpdateUserSettingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSettingsPut(updateUserSettingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSettingsApi.apiUserSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resets page defaults for the current user. If pageKey is provided, only that page\'s defaults are cleared. If omitted, all page defaults are reset.
         * @param {ResetUserSettingDto} [resetUserSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSettingsResetPost(resetUserSettingDto?: ResetUserSettingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettingDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSettingsResetPost(resetUserSettingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSettingsApi.apiUserSettingsResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserSettingsApi - factory interface
 */
export const UserSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets settings for the current user. Creates default settings if none exist.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsGet(options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse> {
            return localVarFp.apiUserSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates settings for the current user. Only provided fields are merged into existing settings.
         * @param {UserSettingsApiApiUserSettingsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsPut(requestParameters: UserSettingsApiApiUserSettingsPutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse> {
            return localVarFp.apiUserSettingsPut(requestParameters.updateUserSettingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resets page defaults for the current user. If pageKey is provided, only that page\'s defaults are cleared. If omitted, all page defaults are reset.
         * @param {UserSettingsApiApiUserSettingsResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSettingsResetPost(requestParameters: UserSettingsApiApiUserSettingsResetPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse> {
            return localVarFp.apiUserSettingsResetPost(requestParameters.resetUserSettingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserSettingsApi - interface
 */
export interface UserSettingsApiInterface {
    /**
     * 
     * @summary Gets settings for the current user. Creates default settings if none exist.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserSettingsGet(options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse>;

    /**
     * 
     * @summary Updates settings for the current user. Only provided fields are merged into existing settings.
     * @param {UserSettingsApiApiUserSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserSettingsPut(requestParameters?: UserSettingsApiApiUserSettingsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse>;

    /**
     * 
     * @summary Resets page defaults for the current user. If pageKey is provided, only that page\'s defaults are cleared. If omitted, all page defaults are reset.
     * @param {UserSettingsApiApiUserSettingsResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserSettingsResetPost(requestParameters?: UserSettingsApiApiUserSettingsResetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSettingDtoApiResponse>;

}

/**
 * Request parameters for apiUserSettingsPut operation in UserSettingsApi.
 */
export interface UserSettingsApiApiUserSettingsPutRequest {
    readonly updateUserSettingDto?: UpdateUserSettingDto
}

/**
 * Request parameters for apiUserSettingsResetPost operation in UserSettingsApi.
 */
export interface UserSettingsApiApiUserSettingsResetPostRequest {
    readonly resetUserSettingDto?: ResetUserSettingDto
}

/**
 * UserSettingsApi - object-oriented interface
 */
export class UserSettingsApi extends BaseAPI implements UserSettingsApiInterface {
    /**
     * 
     * @summary Gets settings for the current user. Creates default settings if none exist.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserSettingsGet(options?: RawAxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiUserSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates settings for the current user. Only provided fields are merged into existing settings.
     * @param {UserSettingsApiApiUserSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserSettingsPut(requestParameters: UserSettingsApiApiUserSettingsPutRequest = {}, options?: RawAxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiUserSettingsPut(requestParameters.updateUserSettingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resets page defaults for the current user. If pageKey is provided, only that page\'s defaults are cleared. If omitted, all page defaults are reset.
     * @param {UserSettingsApiApiUserSettingsResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserSettingsResetPost(requestParameters: UserSettingsApiApiUserSettingsResetPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UserSettingsApiFp(this.configuration).apiUserSettingsResetPost(requestParameters.resetUserSettingDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assigns a user to a client, granting them access to the client\'s documents and data. Requires Admin or Preparer role.
         * @param {AssignUserToClientDto} [assignUserToClientDto] Assignment data containing user ID, client ID, and permission settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAssignToClientPost: async (assignUserToClientDto?: AssignUserToClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/assign-to-client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignUserToClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a paginated list of users assigned to a specific client with their client-specific roles. Requires Admin or Preparer role.
         * @param {string} clientId The unique identifier of the client to get users for.
         * @param {number} [page] The page number (default: 1, minimum: 1).
         * @param {number} [limit] The number of items per page (default: 50, max: 200).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersClientClientIdGet: async (clientId: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiUsersClientClientIdGet', 'clientId', clientId)
            const localVarPath = `/api/Users/client/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a user\'s role for a specific client assignment. Requires Admin or Preparer role.
         * @param {UpdateClientUserRoleDto} [updateClientUserRoleDto] The update data including userId, clientId, and role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersClientRolePatch: async (updateClientUserRoleDto?: UpdateClientUserRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/client-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientUserRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new user account and immediately assigns them to a client with the specified role. Requires Preparer or Admin role.
         * @param {CreateUserWithClientDto} [createUserWithClientDto] User creation data including client assignment details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersCreateWithClientPost: async (createUserWithClientDto?: CreateUserWithClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/create-with-client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserWithClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a paginated list of users with optional filtering and sorting. Requires Admin or Preparer role.
         * @param {string} [search] 
         * @param {UserRole} [role] 
         * @param {boolean} [isActive] 
         * @param {string} [clientId] Use an existing client ID
         * @param {boolean} [isPartner] Filter by Partner status. Partners are users in the Partners Entra group who can be assigned to clients.
         * @param {string} [sortBy] 
         * @param {boolean} [sortDescending] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet: async (search?: string, role?: UserRole, isActive?: boolean, clientId?: string, isPartner?: boolean, sortBy?: string, sortDescending?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (role !== undefined) {
                localVarQueryParameter['Role'] = role;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }

            if (isPartner !== undefined) {
                localVarQueryParameter['IsPartner'] = isPartner;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDescending !== undefined) {
                localVarQueryParameter['SortDescending'] = sortDescending;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Activates a user account, allowing them to access the system. Preparers may activate Client accounts only; Preparer and Admin accounts require an Admin.
         * @param {string} id The unique identifier of the user to activate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdActivatePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdActivatePost', 'id', id)
            const localVarPath = `/api/Users/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a user\'s contact information (email and phone number only). Users can update their own contact info.
         * @param {string} id The unique identifier of the user to update.
         * @param {UpdateContactInfoDto} [updateContactInfoDto] The contact information to update (email and phone number).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdContactInfoPatch: async (id: string, updateContactInfoDto?: UpdateContactInfoDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdContactInfoPatch', 'id', id)
            const localVarPath = `/api/Users/{id}/contact-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContactInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivates a user account, preventing them from accessing the system. Preparers may deactivate Client accounts only; Preparer and Admin accounts require an Admin.
         * @param {string} id The unique identifier of the user to deactivate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDeactivatePost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdDeactivatePost', 'id', id)
            const localVarPath = `/api/Users/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a user from the system. Preparers may delete Client accounts only; Preparer and Admin accounts require an Admin.
         * @param {string} id The unique identifier of the user to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdDelete', 'id', id)
            const localVarPath = `/api/Users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific user by their unique identifier.
         * @param {string} id The unique identifier of the user to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdGet', 'id', id)
            const localVarPath = `/api/Users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finds possible duplicate users based on matching email or phone number. Only returns Client-role users as potential duplicates.
         * @param {string} id The user ID to find duplicates for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPossibleDuplicatesGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdPossibleDuplicatesGet', 'id', id)
            const localVarPath = `/api/Users/{id}/possible-duplicates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing user\'s information. Users can update their own profile, Admins can update any user.
         * @param {string} id The unique identifier of the user to update.
         * @param {UpdateUserDto} [updateUserDto] The user data to update with new information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut: async (id: string, updateUserDto?: UpdateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdPut', 'id', id)
            const localVarPath = `/api/Users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Merges two user accounts. All data from the merged user is transferred to the surviving user. The merged user is deactivated (not deleted) after the merge.
         * @param {MergeUsersDto} [mergeUsersDto] The merge request containing surviving and merged user IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMergePost: async (mergeUsersDto?: MergeUsersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeUsersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Previews the result of merging two user accounts. Shows what data will be transferred and any conflicts that need resolution.
         * @param {MergeUsersDto} [mergeUsersDto] The merge request containing surviving and merged user IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMergePreviewPost: async (mergeUsersDto?: MergeUsersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/merge/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeUsersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the current authenticated user\'s profile information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Performs a paginated search for users with advanced filtering for admin pages. Returns users with their client assignments and supports filtering by role, active status, and date ranges.
         * @param {UserAdminSearchQueryDto} [userAdminSearchQueryDto] Query parameters for filtering, pagination, and sorting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSearchAdminPost: async (userAdminSearchQueryDto?: UserAdminSearchQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/search/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAdminSearchQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for users by name, phone number, or email address and returns their client assignments. Requires Preparer or Admin role.
         * @param {string} [searchQuery] Search term to match against name, phone, or email
         * @param {string} [excludeClientId] Optional client ID to exclude from results (useful when adding users to a specific client)
         * @param {UserRole} [role] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSearchGet: async (searchQuery?: string, excludeClientId?: string, role?: UserRole, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (excludeClientId !== undefined) {
                localVarQueryParameter['excludeClientId'] = excludeClientId;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends a verification code to the user\'s email address. Use this when the user wants to verify their current email or change to a new one.
         * @param {SendEmailVerificationDto} [sendEmailVerificationDto] Optional email address to verify (defaults to user\&#39;s current email)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSendEmailVerificationPost: async (sendEmailVerificationDto?: SendEmailVerificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/send-email-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailVerificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends a verification code to the current user\'s phone number. Use this when the user needs to verify their phone number after updating it.
         * @param {SendPhoneVerificationDto} [sendPhoneVerificationDto] Optional phone number to verify (defaults to user\&#39;s current phone)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSendPhoneVerificationPost: async (sendPhoneVerificationDto?: SendPhoneVerificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/send-phone-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPhoneVerificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revokes SMS consent for the current user (A2P 10DLC opt-out). After opting out, the user will no longer receive SMS notifications.
         * @param {RevokeSmsConsentDto} [revokeSmsConsentDto] Optional reason for opting out.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentDelete: async (revokeSmsConsentDto?: RevokeSmsConsentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/sms-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokeSmsConsentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the current user\'s SMS consent status for A2P 10DLC compliance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/sms-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Grants SMS consent for the current user (A2P 10DLC opt-in). User must have a verified phone number before granting consent.
         * @param {GrantSmsConsentDto} [grantSmsConsentDto] The consent details including method and acknowledgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentPost: async (grantSmsConsentDto?: GrantSmsConsentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/sms-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grantSmsConsentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes a user\'s assignment from a client, revoking their access to the client\'s data. Admins and Preparers can remove any user. Clients can only remove themselves.
         * @param {string} userId The unique identifier of the user to remove from client.
         * @param {string} clientId The unique identifier of the client to remove user from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUserIdClientClientIdDelete: async (userId: string, clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiUsersUserIdClientClientIdDelete', 'userId', userId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiUsersUserIdClientClientIdDelete', 'clientId', clientId)
            const localVarPath = `/api/Users/{userId}/client/{clientId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validates that a phone number is a mobile number capable of receiving SMS. Uses Twilio Lookup API to check line type and carrier information.
         * @param {string} [phoneNumber] The phone number to validate in any standard format.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersValidatePhoneGet: async (phoneNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/validate-phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phoneNumber'] = phoneNumber;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verifies the email address with the provided 6-digit code. Call this after receiving the verification code via email.
         * @param {VerifyEmailDto} [verifyEmailDto] The verification code received via email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersVerifyEmailPost: async (verifyEmailDto?: VerifyEmailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/verify-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verifies the phone number with the provided 6-digit code. Call this after receiving the verification code via SMS.
         * @param {VerifyPhoneDto} [verifyPhoneDto] The verification code received via SMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersVerifyPhonePost: async (verifyPhoneDto?: VerifyPhoneDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Users/verify-phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPhoneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assigns a user to a client, granting them access to the client\'s documents and data. Requires Admin or Preparer role.
         * @param {AssignUserToClientDto} [assignUserToClientDto] Assignment data containing user ID, client ID, and permission settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersAssignToClientPost(assignUserToClientDto?: AssignUserToClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersAssignToClientPost(assignUserToClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersAssignToClientPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a paginated list of users assigned to a specific client with their client-specific roles. Requires Admin or Preparer role.
         * @param {string} clientId The unique identifier of the client to get users for.
         * @param {number} [page] The page number (default: 1, minimum: 1).
         * @param {number} [limit] The number of items per page (default: 50, max: 200).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersClientClientIdGet(clientId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientUserDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersClientClientIdGet(clientId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersClientClientIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a user\'s role for a specific client assignment. Requires Admin or Preparer role.
         * @param {UpdateClientUserRoleDto} [updateClientUserRoleDto] The update data including userId, clientId, and role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersClientRolePatch(updateClientUserRoleDto?: UpdateClientUserRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersClientRolePatch(updateClientUserRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersClientRolePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new user account and immediately assigns them to a client with the specified role. Requires Preparer or Admin role.
         * @param {CreateUserWithClientDto} [createUserWithClientDto] User creation data including client assignment details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersCreateWithClientPost(createUserWithClientDto?: CreateUserWithClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithClientsSearchResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersCreateWithClientPost(createUserWithClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersCreateWithClientPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a paginated list of users with optional filtering and sorting. Requires Admin or Preparer role.
         * @param {string} [search] 
         * @param {UserRole} [role] 
         * @param {boolean} [isActive] 
         * @param {string} [clientId] Use an existing client ID
         * @param {boolean} [isPartner] Filter by Partner status. Partners are users in the Partners Entra group who can be assigned to clients.
         * @param {string} [sortBy] 
         * @param {boolean} [sortDescending] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersGet(search?: string, role?: UserRole, isActive?: boolean, clientId?: string, isPartner?: boolean, sortBy?: string, sortDescending?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserListDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersGet(search, role, isActive, clientId, isPartner, sortBy, sortDescending, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Activates a user account, allowing them to access the system. Preparers may activate Client accounts only; Preparer and Admin accounts require an Admin.
         * @param {string} id The unique identifier of the user to activate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdActivatePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdActivatePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdActivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a user\'s contact information (email and phone number only). Users can update their own contact info.
         * @param {string} id The unique identifier of the user to update.
         * @param {UpdateContactInfoDto} [updateContactInfoDto] The contact information to update (email and phone number).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdContactInfoPatch(id: string, updateContactInfoDto?: UpdateContactInfoDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdContactInfoPatch(id, updateContactInfoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdContactInfoPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deactivates a user account, preventing them from accessing the system. Preparers may deactivate Client accounts only; Preparer and Admin accounts require an Admin.
         * @param {string} id The unique identifier of the user to deactivate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdDeactivatePost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdDeactivatePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdDeactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a user from the system. Preparers may delete Client accounts only; Preparer and Admin accounts require an Admin.
         * @param {string} id The unique identifier of the user to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific user by their unique identifier.
         * @param {string} id The unique identifier of the user to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Finds possible duplicate users based on matching email or phone number. Only returns Client-role users as potential duplicates.
         * @param {string} id The user ID to find duplicates for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdPossibleDuplicatesGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PossibleDuplicateDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdPossibleDuplicatesGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdPossibleDuplicatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing user\'s information. Users can update their own profile, Admins can update any user.
         * @param {string} id The unique identifier of the user to update.
         * @param {UpdateUserDto} [updateUserDto] The user data to update with new information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdPut(id: string, updateUserDto?: UpdateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdPut(id, updateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Merges two user accounts. All data from the merged user is transferred to the surviving user. The merged user is deactivated (not deleted) after the merge.
         * @param {MergeUsersDto} [mergeUsersDto] The merge request containing surviving and merged user IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersMergePost(mergeUsersDto?: MergeUsersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MergeResultDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersMergePost(mergeUsersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersMergePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Previews the result of merging two user accounts. Shows what data will be transferred and any conflicts that need resolution.
         * @param {MergeUsersDto} [mergeUsersDto] The merge request containing surviving and merged user IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersMergePreviewPost(mergeUsersDto?: MergeUsersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MergePreviewDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersMergePreviewPost(mergeUsersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersMergePreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves the current authenticated user\'s profile information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersProfileGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersProfileGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Performs a paginated search for users with advanced filtering for admin pages. Returns users with their client assignments and supports filtering by role, active status, and date ranges.
         * @param {UserAdminSearchQueryDto} [userAdminSearchQueryDto] Query parameters for filtering, pagination, and sorting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSearchAdminPost(userAdminSearchQueryDto?: UserAdminSearchQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAdminSearchResultDtoPaginatedResponseApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSearchAdminPost(userAdminSearchQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSearchAdminPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for users by name, phone number, or email address and returns their client assignments. Requires Preparer or Admin role.
         * @param {string} [searchQuery] Search term to match against name, phone, or email
         * @param {string} [excludeClientId] Optional client ID to exclude from results (useful when adding users to a specific client)
         * @param {UserRole} [role] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSearchGet(searchQuery?: string, excludeClientId?: string, role?: UserRole, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithClientsSearchResultDtoListApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSearchGet(searchQuery, excludeClientId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sends a verification code to the user\'s email address. Use this when the user wants to verify their current email or change to a new one.
         * @param {SendEmailVerificationDto} [sendEmailVerificationDto] Optional email address to verify (defaults to user\&#39;s current email)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSendEmailVerificationPost(sendEmailVerificationDto?: SendEmailVerificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailVerificationResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSendEmailVerificationPost(sendEmailVerificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSendEmailVerificationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sends a verification code to the current user\'s phone number. Use this when the user needs to verify their phone number after updating it.
         * @param {SendPhoneVerificationDto} [sendPhoneVerificationDto] Optional phone number to verify (defaults to user\&#39;s current phone)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSendPhoneVerificationPost(sendPhoneVerificationDto?: SendPhoneVerificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneVerificationResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSendPhoneVerificationPost(sendPhoneVerificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSendPhoneVerificationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revokes SMS consent for the current user (A2P 10DLC opt-out). After opting out, the user will no longer receive SMS notifications.
         * @param {RevokeSmsConsentDto} [revokeSmsConsentDto] Optional reason for opting out.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSmsConsentDelete(revokeSmsConsentDto?: RevokeSmsConsentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsConsentStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSmsConsentDelete(revokeSmsConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSmsConsentDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves the current user\'s SMS consent status for A2P 10DLC compliance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSmsConsentGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsConsentStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSmsConsentGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSmsConsentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Grants SMS consent for the current user (A2P 10DLC opt-in). User must have a verified phone number before granting consent.
         * @param {GrantSmsConsentDto} [grantSmsConsentDto] The consent details including method and acknowledgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSmsConsentPost(grantSmsConsentDto?: GrantSmsConsentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmsConsentStatusDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSmsConsentPost(grantSmsConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersSmsConsentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Removes a user\'s assignment from a client, revoking their access to the client\'s data. Admins and Preparers can remove any user. Clients can only remove themselves.
         * @param {string} userId The unique identifier of the user to remove from client.
         * @param {string} clientId The unique identifier of the client to remove user from.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersUserIdClientClientIdDelete(userId: string, clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersUserIdClientClientIdDelete(userId, clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersUserIdClientClientIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validates that a phone number is a mobile number capable of receiving SMS. Uses Twilio Lookup API to check line type and carrier information.
         * @param {string} [phoneNumber] The phone number to validate in any standard format.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersValidatePhoneGet(phoneNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneLookupResultApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersValidatePhoneGet(phoneNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersValidatePhoneGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verifies the email address with the provided 6-digit code. Call this after receiving the verification code via email.
         * @param {VerifyEmailDto} [verifyEmailDto] The verification code received via email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersVerifyEmailPost(verifyEmailDto?: VerifyEmailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailVerificationResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersVerifyEmailPost(verifyEmailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersVerifyEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verifies the phone number with the provided 6-digit code. Call this after receiving the verification code via SMS.
         * @param {VerifyPhoneDto} [verifyPhoneDto] The verification code received via SMS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersVerifyPhonePost(verifyPhoneDto?: VerifyPhoneDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneVerificationResponseDtoApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersVerifyPhonePost(verifyPhoneDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiUsersVerifyPhonePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Assigns a user to a client, granting them access to the client\'s documents and data. Requires Admin or Preparer role.
         * @param {UsersApiApiUsersAssignToClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAssignToClientPost(requestParameters: UsersApiApiUsersAssignToClientPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersAssignToClientPost(requestParameters.assignUserToClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a paginated list of users assigned to a specific client with their client-specific roles. Requires Admin or Preparer role.
         * @param {UsersApiApiUsersClientClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersClientClientIdGet(requestParameters: UsersApiApiUsersClientClientIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserDtoPaginatedResponseApiResponse> {
            return localVarFp.apiUsersClientClientIdGet(requestParameters.clientId, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a user\'s role for a specific client assignment. Requires Admin or Preparer role.
         * @param {UsersApiApiUsersClientRolePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersClientRolePatch(requestParameters: UsersApiApiUsersClientRolePatchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersClientRolePatch(requestParameters.updateClientUserRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new user account and immediately assigns them to a client with the specified role. Requires Preparer or Admin role.
         * @param {UsersApiApiUsersCreateWithClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersCreateWithClientPost(requestParameters: UsersApiApiUsersCreateWithClientPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoApiResponse> {
            return localVarFp.apiUsersCreateWithClientPost(requestParameters.createUserWithClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a paginated list of users with optional filtering and sorting. Requires Admin or Preparer role.
         * @param {UsersApiApiUsersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet(requestParameters: UsersApiApiUsersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserListDtoPaginatedResponseApiResponse> {
            return localVarFp.apiUsersGet(requestParameters.search, requestParameters.role, requestParameters.isActive, requestParameters.clientId, requestParameters.isPartner, requestParameters.sortBy, requestParameters.sortDescending, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Activates a user account, allowing them to access the system. Preparers may activate Client accounts only; Preparer and Admin accounts require an Admin.
         * @param {UsersApiApiUsersIdActivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdActivatePost(requestParameters: UsersApiApiUsersIdActivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersIdActivatePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a user\'s contact information (email and phone number only). Users can update their own contact info.
         * @param {UsersApiApiUsersIdContactInfoPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdContactInfoPatch(requestParameters: UsersApiApiUsersIdContactInfoPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse> {
            return localVarFp.apiUsersIdContactInfoPatch(requestParameters.id, requestParameters.updateContactInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivates a user account, preventing them from accessing the system. Preparers may deactivate Client accounts only; Preparer and Admin accounts require an Admin.
         * @param {UsersApiApiUsersIdDeactivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDeactivatePost(requestParameters: UsersApiApiUsersIdDeactivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersIdDeactivatePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a user from the system. Preparers may delete Client accounts only; Preparer and Admin accounts require an Admin.
         * @param {UsersApiApiUsersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete(requestParameters: UsersApiApiUsersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves detailed information about a specific user by their unique identifier.
         * @param {UsersApiApiUsersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet(requestParameters: UsersApiApiUsersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse> {
            return localVarFp.apiUsersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finds possible duplicate users based on matching email or phone number. Only returns Client-role users as potential duplicates.
         * @param {UsersApiApiUsersIdPossibleDuplicatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPossibleDuplicatesGet(requestParameters: UsersApiApiUsersIdPossibleDuplicatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PossibleDuplicateDtoListApiResponse> {
            return localVarFp.apiUsersIdPossibleDuplicatesGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing user\'s information. Users can update their own profile, Admins can update any user.
         * @param {UsersApiApiUsersIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut(requestParameters: UsersApiApiUsersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse> {
            return localVarFp.apiUsersIdPut(requestParameters.id, requestParameters.updateUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Merges two user accounts. All data from the merged user is transferred to the surviving user. The merged user is deactivated (not deleted) after the merge.
         * @param {UsersApiApiUsersMergePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMergePost(requestParameters: UsersApiApiUsersMergePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MergeResultDtoApiResponse> {
            return localVarFp.apiUsersMergePost(requestParameters.mergeUsersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Previews the result of merging two user accounts. Shows what data will be transferred and any conflicts that need resolution.
         * @param {UsersApiApiUsersMergePreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMergePreviewPost(requestParameters: UsersApiApiUsersMergePreviewPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MergePreviewDtoApiResponse> {
            return localVarFp.apiUsersMergePreviewPost(requestParameters.mergeUsersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the current authenticated user\'s profile information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileGet(options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse> {
            return localVarFp.apiUsersProfileGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Performs a paginated search for users with advanced filtering for admin pages. Returns users with their client assignments and supports filtering by role, active status, and date ranges.
         * @param {UsersApiApiUsersSearchAdminPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSearchAdminPost(requestParameters: UsersApiApiUsersSearchAdminPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserAdminSearchResultDtoPaginatedResponseApiResponse> {
            return localVarFp.apiUsersSearchAdminPost(requestParameters.userAdminSearchQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for users by name, phone number, or email address and returns their client assignments. Requires Preparer or Admin role.
         * @param {UsersApiApiUsersSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSearchGet(requestParameters: UsersApiApiUsersSearchGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoListApiResponse> {
            return localVarFp.apiUsersSearchGet(requestParameters.searchQuery, requestParameters.excludeClientId, requestParameters.role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends a verification code to the user\'s email address. Use this when the user wants to verify their current email or change to a new one.
         * @param {UsersApiApiUsersSendEmailVerificationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSendEmailVerificationPost(requestParameters: UsersApiApiUsersSendEmailVerificationPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerificationResponseDtoApiResponse> {
            return localVarFp.apiUsersSendEmailVerificationPost(requestParameters.sendEmailVerificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends a verification code to the current user\'s phone number. Use this when the user needs to verify their phone number after updating it.
         * @param {UsersApiApiUsersSendPhoneVerificationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSendPhoneVerificationPost(requestParameters: UsersApiApiUsersSendPhoneVerificationPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerificationResponseDtoApiResponse> {
            return localVarFp.apiUsersSendPhoneVerificationPost(requestParameters.sendPhoneVerificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revokes SMS consent for the current user (A2P 10DLC opt-out). After opting out, the user will no longer receive SMS notifications.
         * @param {UsersApiApiUsersSmsConsentDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentDelete(requestParameters: UsersApiApiUsersSmsConsentDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse> {
            return localVarFp.apiUsersSmsConsentDelete(requestParameters.revokeSmsConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the current user\'s SMS consent status for A2P 10DLC compliance.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentGet(options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse> {
            return localVarFp.apiUsersSmsConsentGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Grants SMS consent for the current user (A2P 10DLC opt-in). User must have a verified phone number before granting consent.
         * @param {UsersApiApiUsersSmsConsentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSmsConsentPost(requestParameters: UsersApiApiUsersSmsConsentPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse> {
            return localVarFp.apiUsersSmsConsentPost(requestParameters.grantSmsConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes a user\'s assignment from a client, revoking their access to the client\'s data. Admins and Preparers can remove any user. Clients can only remove themselves.
         * @param {UsersApiApiUsersUserIdClientClientIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUserIdClientClientIdDelete(requestParameters: UsersApiApiUsersUserIdClientClientIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse> {
            return localVarFp.apiUsersUserIdClientClientIdDelete(requestParameters.userId, requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validates that a phone number is a mobile number capable of receiving SMS. Uses Twilio Lookup API to check line type and carrier information.
         * @param {UsersApiApiUsersValidatePhoneGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersValidatePhoneGet(requestParameters: UsersApiApiUsersValidatePhoneGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PhoneLookupResultApiResponse> {
            return localVarFp.apiUsersValidatePhoneGet(requestParameters.phoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verifies the email address with the provided 6-digit code. Call this after receiving the verification code via email.
         * @param {UsersApiApiUsersVerifyEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersVerifyEmailPost(requestParameters: UsersApiApiUsersVerifyEmailPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerificationResponseDtoApiResponse> {
            return localVarFp.apiUsersVerifyEmailPost(requestParameters.verifyEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verifies the phone number with the provided 6-digit code. Call this after receiving the verification code via SMS.
         * @param {UsersApiApiUsersVerifyPhonePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersVerifyPhonePost(requestParameters: UsersApiApiUsersVerifyPhonePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerificationResponseDtoApiResponse> {
            return localVarFp.apiUsersVerifyPhonePost(requestParameters.verifyPhoneDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - interface
 */
export interface UsersApiInterface {
    /**
     * 
     * @summary Assigns a user to a client, granting them access to the client\'s documents and data. Requires Admin or Preparer role.
     * @param {UsersApiApiUsersAssignToClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersAssignToClientPost(requestParameters?: UsersApiApiUsersAssignToClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Retrieves a paginated list of users assigned to a specific client with their client-specific roles. Requires Admin or Preparer role.
     * @param {UsersApiApiUsersClientClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersClientClientIdGet(requestParameters: UsersApiApiUsersClientClientIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientUserDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Updates a user\'s role for a specific client assignment. Requires Admin or Preparer role.
     * @param {UsersApiApiUsersClientRolePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersClientRolePatch(requestParameters?: UsersApiApiUsersClientRolePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Creates a new user account and immediately assigns them to a client with the specified role. Requires Preparer or Admin role.
     * @param {UsersApiApiUsersCreateWithClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersCreateWithClientPost(requestParameters?: UsersApiApiUsersCreateWithClientPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoApiResponse>;

    /**
     * 
     * @summary Retrieves a paginated list of users with optional filtering and sorting. Requires Admin or Preparer role.
     * @param {UsersApiApiUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersGet(requestParameters?: UsersApiApiUsersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserListDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Activates a user account, allowing them to access the system. Preparers may activate Client accounts only; Preparer and Admin accounts require an Admin.
     * @param {UsersApiApiUsersIdActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdActivatePost(requestParameters: UsersApiApiUsersIdActivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Updates a user\'s contact information (email and phone number only). Users can update their own contact info.
     * @param {UsersApiApiUsersIdContactInfoPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdContactInfoPatch(requestParameters: UsersApiApiUsersIdContactInfoPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse>;

    /**
     * 
     * @summary Deactivates a user account, preventing them from accessing the system. Preparers may deactivate Client accounts only; Preparer and Admin accounts require an Admin.
     * @param {UsersApiApiUsersIdDeactivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdDeactivatePost(requestParameters: UsersApiApiUsersIdDeactivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Deletes a user from the system. Preparers may delete Client accounts only; Preparer and Admin accounts require an Admin.
     * @param {UsersApiApiUsersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdDelete(requestParameters: UsersApiApiUsersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Retrieves detailed information about a specific user by their unique identifier.
     * @param {UsersApiApiUsersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdGet(requestParameters: UsersApiApiUsersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse>;

    /**
     * 
     * @summary Finds possible duplicate users based on matching email or phone number. Only returns Client-role users as potential duplicates.
     * @param {UsersApiApiUsersIdPossibleDuplicatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdPossibleDuplicatesGet(requestParameters: UsersApiApiUsersIdPossibleDuplicatesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PossibleDuplicateDtoListApiResponse>;

    /**
     * 
     * @summary Updates an existing user\'s information. Users can update their own profile, Admins can update any user.
     * @param {UsersApiApiUsersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersIdPut(requestParameters: UsersApiApiUsersIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse>;

    /**
     * 
     * @summary Merges two user accounts. All data from the merged user is transferred to the surviving user. The merged user is deactivated (not deleted) after the merge.
     * @param {UsersApiApiUsersMergePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersMergePost(requestParameters?: UsersApiApiUsersMergePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<MergeResultDtoApiResponse>;

    /**
     * 
     * @summary Previews the result of merging two user accounts. Shows what data will be transferred and any conflicts that need resolution.
     * @param {UsersApiApiUsersMergePreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersMergePreviewPost(requestParameters?: UsersApiApiUsersMergePreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<MergePreviewDtoApiResponse>;

    /**
     * 
     * @summary Retrieves the current authenticated user\'s profile information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersProfileGet(options?: RawAxiosRequestConfig): AxiosPromise<UserDtoApiResponse>;

    /**
     * 
     * @summary Performs a paginated search for users with advanced filtering for admin pages. Returns users with their client assignments and supports filtering by role, active status, and date ranges.
     * @param {UsersApiApiUsersSearchAdminPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSearchAdminPost(requestParameters?: UsersApiApiUsersSearchAdminPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserAdminSearchResultDtoPaginatedResponseApiResponse>;

    /**
     * 
     * @summary Searches for users by name, phone number, or email address and returns their client assignments. Requires Preparer or Admin role.
     * @param {UsersApiApiUsersSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSearchGet(requestParameters?: UsersApiApiUsersSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserWithClientsSearchResultDtoListApiResponse>;

    /**
     * 
     * @summary Sends a verification code to the user\'s email address. Use this when the user wants to verify their current email or change to a new one.
     * @param {UsersApiApiUsersSendEmailVerificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSendEmailVerificationPost(requestParameters?: UsersApiApiUsersSendEmailVerificationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerificationResponseDtoApiResponse>;

    /**
     * 
     * @summary Sends a verification code to the current user\'s phone number. Use this when the user needs to verify their phone number after updating it.
     * @param {UsersApiApiUsersSendPhoneVerificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSendPhoneVerificationPost(requestParameters?: UsersApiApiUsersSendPhoneVerificationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerificationResponseDtoApiResponse>;

    /**
     * 
     * @summary Revokes SMS consent for the current user (A2P 10DLC opt-out). After opting out, the user will no longer receive SMS notifications.
     * @param {UsersApiApiUsersSmsConsentDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSmsConsentDelete(requestParameters?: UsersApiApiUsersSmsConsentDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse>;

    /**
     * 
     * @summary Retrieves the current user\'s SMS consent status for A2P 10DLC compliance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSmsConsentGet(options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse>;

    /**
     * 
     * @summary Grants SMS consent for the current user (A2P 10DLC opt-in). User must have a verified phone number before granting consent.
     * @param {UsersApiApiUsersSmsConsentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersSmsConsentPost(requestParameters?: UsersApiApiUsersSmsConsentPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SmsConsentStatusDtoApiResponse>;

    /**
     * 
     * @summary Removes a user\'s assignment from a client, revoking their access to the client\'s data. Admins and Preparers can remove any user. Clients can only remove themselves.
     * @param {UsersApiApiUsersUserIdClientClientIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersUserIdClientClientIdDelete(requestParameters: UsersApiApiUsersUserIdClientClientIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BooleanApiResponse>;

    /**
     * 
     * @summary Validates that a phone number is a mobile number capable of receiving SMS. Uses Twilio Lookup API to check line type and carrier information.
     * @param {UsersApiApiUsersValidatePhoneGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersValidatePhoneGet(requestParameters?: UsersApiApiUsersValidatePhoneGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PhoneLookupResultApiResponse>;

    /**
     * 
     * @summary Verifies the email address with the provided 6-digit code. Call this after receiving the verification code via email.
     * @param {UsersApiApiUsersVerifyEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersVerifyEmailPost(requestParameters?: UsersApiApiUsersVerifyEmailPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerificationResponseDtoApiResponse>;

    /**
     * 
     * @summary Verifies the phone number with the provided 6-digit code. Call this after receiving the verification code via SMS.
     * @param {UsersApiApiUsersVerifyPhonePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersVerifyPhonePost(requestParameters?: UsersApiApiUsersVerifyPhonePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PhoneVerificationResponseDtoApiResponse>;

}

/**
 * Request parameters for apiUsersAssignToClientPost operation in UsersApi.
 */
export interface UsersApiApiUsersAssignToClientPostRequest {
    /**
     * Assignment data containing user ID, client ID, and permission settings.
     */
    readonly assignUserToClientDto?: AssignUserToClientDto
}

/**
 * Request parameters for apiUsersClientClientIdGet operation in UsersApi.
 */
export interface UsersApiApiUsersClientClientIdGetRequest {
    /**
     * The unique identifier of the client to get users for.
     */
    readonly clientId: string

    /**
     * The page number (default: 1, minimum: 1).
     */
    readonly page?: number

    /**
     * The number of items per page (default: 50, max: 200).
     */
    readonly limit?: number
}

/**
 * Request parameters for apiUsersClientRolePatch operation in UsersApi.
 */
export interface UsersApiApiUsersClientRolePatchRequest {
    /**
     * The update data including userId, clientId, and role.
     */
    readonly updateClientUserRoleDto?: UpdateClientUserRoleDto
}

/**
 * Request parameters for apiUsersCreateWithClientPost operation in UsersApi.
 */
export interface UsersApiApiUsersCreateWithClientPostRequest {
    /**
     * User creation data including client assignment details
     */
    readonly createUserWithClientDto?: CreateUserWithClientDto
}

/**
 * Request parameters for apiUsersGet operation in UsersApi.
 */
export interface UsersApiApiUsersGetRequest {
    readonly search?: string

    readonly role?: UserRole

    readonly isActive?: boolean

    /**
     * Use an existing client ID
     */
    readonly clientId?: string

    /**
     * Filter by Partner status. Partners are users in the Partners Entra group who can be assigned to clients.
     */
    readonly isPartner?: boolean

    readonly sortBy?: string

    readonly sortDescending?: boolean

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for apiUsersIdActivatePost operation in UsersApi.
 */
export interface UsersApiApiUsersIdActivatePostRequest {
    /**
     * The unique identifier of the user to activate.
     */
    readonly id: string
}

/**
 * Request parameters for apiUsersIdContactInfoPatch operation in UsersApi.
 */
export interface UsersApiApiUsersIdContactInfoPatchRequest {
    /**
     * The unique identifier of the user to update.
     */
    readonly id: string

    /**
     * The contact information to update (email and phone number).
     */
    readonly updateContactInfoDto?: UpdateContactInfoDto
}

/**
 * Request parameters for apiUsersIdDeactivatePost operation in UsersApi.
 */
export interface UsersApiApiUsersIdDeactivatePostRequest {
    /**
     * The unique identifier of the user to deactivate.
     */
    readonly id: string
}

/**
 * Request parameters for apiUsersIdDelete operation in UsersApi.
 */
export interface UsersApiApiUsersIdDeleteRequest {
    /**
     * The unique identifier of the user to delete.
     */
    readonly id: string
}

/**
 * Request parameters for apiUsersIdGet operation in UsersApi.
 */
export interface UsersApiApiUsersIdGetRequest {
    /**
     * The unique identifier of the user to retrieve.
     */
    readonly id: string
}

/**
 * Request parameters for apiUsersIdPossibleDuplicatesGet operation in UsersApi.
 */
export interface UsersApiApiUsersIdPossibleDuplicatesGetRequest {
    /**
     * The user ID to find duplicates for
     */
    readonly id: string
}

/**
 * Request parameters for apiUsersIdPut operation in UsersApi.
 */
export interface UsersApiApiUsersIdPutRequest {
    /**
     * The unique identifier of the user to update.
     */
    readonly id: string

    /**
     * The user data to update with new information.
     */
    readonly updateUserDto?: UpdateUserDto
}

/**
 * Request parameters for apiUsersMergePost operation in UsersApi.
 */
export interface UsersApiApiUsersMergePostRequest {
    /**
     * The merge request containing surviving and merged user IDs
     */
    readonly mergeUsersDto?: MergeUsersDto
}

/**
 * Request parameters for apiUsersMergePreviewPost operation in UsersApi.
 */
export interface UsersApiApiUsersMergePreviewPostRequest {
    /**
     * The merge request containing surviving and merged user IDs
     */
    readonly mergeUsersDto?: MergeUsersDto
}

/**
 * Request parameters for apiUsersSearchAdminPost operation in UsersApi.
 */
export interface UsersApiApiUsersSearchAdminPostRequest {
    /**
     * Query parameters for filtering, pagination, and sorting
     */
    readonly userAdminSearchQueryDto?: UserAdminSearchQueryDto
}

/**
 * Request parameters for apiUsersSearchGet operation in UsersApi.
 */
export interface UsersApiApiUsersSearchGetRequest {
    /**
     * Search term to match against name, phone, or email
     */
    readonly searchQuery?: string

    /**
     * Optional client ID to exclude from results (useful when adding users to a specific client)
     */
    readonly excludeClientId?: string

    readonly role?: UserRole
}

/**
 * Request parameters for apiUsersSendEmailVerificationPost operation in UsersApi.
 */
export interface UsersApiApiUsersSendEmailVerificationPostRequest {
    /**
     * Optional email address to verify (defaults to user\&#39;s current email)
     */
    readonly sendEmailVerificationDto?: SendEmailVerificationDto
}

/**
 * Request parameters for apiUsersSendPhoneVerificationPost operation in UsersApi.
 */
export interface UsersApiApiUsersSendPhoneVerificationPostRequest {
    /**
     * Optional phone number to verify (defaults to user\&#39;s current phone)
     */
    readonly sendPhoneVerificationDto?: SendPhoneVerificationDto
}

/**
 * Request parameters for apiUsersSmsConsentDelete operation in UsersApi.
 */
export interface UsersApiApiUsersSmsConsentDeleteRequest {
    /**
     * Optional reason for opting out.
     */
    readonly revokeSmsConsentDto?: RevokeSmsConsentDto
}

/**
 * Request parameters for apiUsersSmsConsentPost operation in UsersApi.
 */
export interface UsersApiApiUsersSmsConsentPostRequest {
    /**
     * The consent details including method and acknowledgment.
     */
    readonly grantSmsConsentDto?: GrantSmsConsentDto
}

/**
 * Request parameters for apiUsersUserIdClientClientIdDelete operation in UsersApi.
 */
export interface UsersApiApiUsersUserIdClientClientIdDeleteRequest {
    /**
     * The unique identifier of the user to remove from client.
     */
    readonly userId: string

    /**
     * The unique identifier of the client to remove user from.
     */
    readonly clientId: string
}

/**
 * Request parameters for apiUsersValidatePhoneGet operation in UsersApi.
 */
export interface UsersApiApiUsersValidatePhoneGetRequest {
    /**
     * The phone number to validate in any standard format.
     */
    readonly phoneNumber?: string
}

/**
 * Request parameters for apiUsersVerifyEmailPost operation in UsersApi.
 */
export interface UsersApiApiUsersVerifyEmailPostRequest {
    /**
     * The verification code received via email
     */
    readonly verifyEmailDto?: VerifyEmailDto
}

/**
 * Request parameters for apiUsersVerifyPhonePost operation in UsersApi.
 */
export interface UsersApiApiUsersVerifyPhonePostRequest {
    /**
     * The verification code received via SMS
     */
    readonly verifyPhoneDto?: VerifyPhoneDto
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI implements UsersApiInterface {
    /**
     * 
     * @summary Assigns a user to a client, granting them access to the client\'s documents and data. Requires Admin or Preparer role.
     * @param {UsersApiApiUsersAssignToClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersAssignToClientPost(requestParameters: UsersApiApiUsersAssignToClientPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersAssignToClientPost(requestParameters.assignUserToClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a paginated list of users assigned to a specific client with their client-specific roles. Requires Admin or Preparer role.
     * @param {UsersApiApiUsersClientClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersClientClientIdGet(requestParameters: UsersApiApiUsersClientClientIdGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersClientClientIdGet(requestParameters.clientId, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a user\'s role for a specific client assignment. Requires Admin or Preparer role.
     * @param {UsersApiApiUsersClientRolePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersClientRolePatch(requestParameters: UsersApiApiUsersClientRolePatchRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersClientRolePatch(requestParameters.updateClientUserRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new user account and immediately assigns them to a client with the specified role. Requires Preparer or Admin role.
     * @param {UsersApiApiUsersCreateWithClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersCreateWithClientPost(requestParameters: UsersApiApiUsersCreateWithClientPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersCreateWithClientPost(requestParameters.createUserWithClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a paginated list of users with optional filtering and sorting. Requires Admin or Preparer role.
     * @param {UsersApiApiUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersGet(requestParameters: UsersApiApiUsersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersGet(requestParameters.search, requestParameters.role, requestParameters.isActive, requestParameters.clientId, requestParameters.isPartner, requestParameters.sortBy, requestParameters.sortDescending, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Activates a user account, allowing them to access the system. Preparers may activate Client accounts only; Preparer and Admin accounts require an Admin.
     * @param {UsersApiApiUsersIdActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdActivatePost(requestParameters: UsersApiApiUsersIdActivatePostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdActivatePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a user\'s contact information (email and phone number only). Users can update their own contact info.
     * @param {UsersApiApiUsersIdContactInfoPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdContactInfoPatch(requestParameters: UsersApiApiUsersIdContactInfoPatchRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdContactInfoPatch(requestParameters.id, requestParameters.updateContactInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivates a user account, preventing them from accessing the system. Preparers may deactivate Client accounts only; Preparer and Admin accounts require an Admin.
     * @param {UsersApiApiUsersIdDeactivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdDeactivatePost(requestParameters: UsersApiApiUsersIdDeactivatePostRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdDeactivatePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a user from the system. Preparers may delete Client accounts only; Preparer and Admin accounts require an Admin.
     * @param {UsersApiApiUsersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdDelete(requestParameters: UsersApiApiUsersIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves detailed information about a specific user by their unique identifier.
     * @param {UsersApiApiUsersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdGet(requestParameters: UsersApiApiUsersIdGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finds possible duplicate users based on matching email or phone number. Only returns Client-role users as potential duplicates.
     * @param {UsersApiApiUsersIdPossibleDuplicatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdPossibleDuplicatesGet(requestParameters: UsersApiApiUsersIdPossibleDuplicatesGetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdPossibleDuplicatesGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing user\'s information. Users can update their own profile, Admins can update any user.
     * @param {UsersApiApiUsersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersIdPut(requestParameters: UsersApiApiUsersIdPutRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdPut(requestParameters.id, requestParameters.updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Merges two user accounts. All data from the merged user is transferred to the surviving user. The merged user is deactivated (not deleted) after the merge.
     * @param {UsersApiApiUsersMergePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersMergePost(requestParameters: UsersApiApiUsersMergePostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersMergePost(requestParameters.mergeUsersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Previews the result of merging two user accounts. Shows what data will be transferred and any conflicts that need resolution.
     * @param {UsersApiApiUsersMergePreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersMergePreviewPost(requestParameters: UsersApiApiUsersMergePreviewPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersMergePreviewPost(requestParameters.mergeUsersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the current authenticated user\'s profile information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersProfileGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersProfileGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Performs a paginated search for users with advanced filtering for admin pages. Returns users with their client assignments and supports filtering by role, active status, and date ranges.
     * @param {UsersApiApiUsersSearchAdminPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSearchAdminPost(requestParameters: UsersApiApiUsersSearchAdminPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSearchAdminPost(requestParameters.userAdminSearchQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for users by name, phone number, or email address and returns their client assignments. Requires Preparer or Admin role.
     * @param {UsersApiApiUsersSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSearchGet(requestParameters: UsersApiApiUsersSearchGetRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSearchGet(requestParameters.searchQuery, requestParameters.excludeClientId, requestParameters.role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends a verification code to the user\'s email address. Use this when the user wants to verify their current email or change to a new one.
     * @param {UsersApiApiUsersSendEmailVerificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSendEmailVerificationPost(requestParameters: UsersApiApiUsersSendEmailVerificationPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSendEmailVerificationPost(requestParameters.sendEmailVerificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends a verification code to the current user\'s phone number. Use this when the user needs to verify their phone number after updating it.
     * @param {UsersApiApiUsersSendPhoneVerificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSendPhoneVerificationPost(requestParameters: UsersApiApiUsersSendPhoneVerificationPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSendPhoneVerificationPost(requestParameters.sendPhoneVerificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revokes SMS consent for the current user (A2P 10DLC opt-out). After opting out, the user will no longer receive SMS notifications.
     * @param {UsersApiApiUsersSmsConsentDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSmsConsentDelete(requestParameters: UsersApiApiUsersSmsConsentDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSmsConsentDelete(requestParameters.revokeSmsConsentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the current user\'s SMS consent status for A2P 10DLC compliance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSmsConsentGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSmsConsentGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Grants SMS consent for the current user (A2P 10DLC opt-in). User must have a verified phone number before granting consent.
     * @param {UsersApiApiUsersSmsConsentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersSmsConsentPost(requestParameters: UsersApiApiUsersSmsConsentPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersSmsConsentPost(requestParameters.grantSmsConsentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes a user\'s assignment from a client, revoking their access to the client\'s data. Admins and Preparers can remove any user. Clients can only remove themselves.
     * @param {UsersApiApiUsersUserIdClientClientIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersUserIdClientClientIdDelete(requestParameters: UsersApiApiUsersUserIdClientClientIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersUserIdClientClientIdDelete(requestParameters.userId, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validates that a phone number is a mobile number capable of receiving SMS. Uses Twilio Lookup API to check line type and carrier information.
     * @param {UsersApiApiUsersValidatePhoneGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersValidatePhoneGet(requestParameters: UsersApiApiUsersValidatePhoneGetRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersValidatePhoneGet(requestParameters.phoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verifies the email address with the provided 6-digit code. Call this after receiving the verification code via email.
     * @param {UsersApiApiUsersVerifyEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersVerifyEmailPost(requestParameters: UsersApiApiUsersVerifyEmailPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersVerifyEmailPost(requestParameters.verifyEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verifies the phone number with the provided 6-digit code. Call this after receiving the verification code via SMS.
     * @param {UsersApiApiUsersVerifyPhonePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUsersVerifyPhonePost(requestParameters: UsersApiApiUsersVerifyPhonePostRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersVerifyPhonePost(requestParameters.verifyPhoneDto, options).then((request) => request(this.axios, this.basePath));
    }
}



